/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 779);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(52);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)(module)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapField */
/* unused harmony export groupBy */
/* harmony export (immutable) */ __webpack_exports__["h"] = getSelectedValue;
/* harmony export (immutable) */ __webpack_exports__["x"] = setPaycodeInWorkPerformed;
/* unused harmony export setPaycodeInWorkPerformed2 */
/* harmony export (immutable) */ __webpack_exports__["w"] = setCCSubInWorkPerformed;
/* unused harmony export getSelectedValues */
/* harmony export (immutable) */ __webpack_exports__["B"] = handleWorkPerformed;
/* harmony export (immutable) */ __webpack_exports__["v"] = handleWorkPerformedEdit;
/* harmony export (immutable) */ __webpack_exports__["j"] = handleEquipmentNo;
/* unused harmony export validateEquipmentSelected */
/* harmony export (immutable) */ __webpack_exports__["z"] = totalHours;
/* harmony export (immutable) */ __webpack_exports__["y"] = totalCount;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return generateGUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return generateTSID; });
/* harmony export (immutable) */ __webpack_exports__["a"] = packageForm;
/* harmony export (immutable) */ __webpack_exports__["i"] = packageDashForm;
/* harmony export (immutable) */ __webpack_exports__["A"] = extractUsersFromForm;
/* harmony export (immutable) */ __webpack_exports__["k"] = clearForm;
/* harmony export (immutable) */ __webpack_exports__["p"] = handleFormChecking;
/* harmony export (immutable) */ __webpack_exports__["C"] = getCurrentDate;
/* harmony export (immutable) */ __webpack_exports__["s"] = fillEditForm;
/* harmony export (immutable) */ __webpack_exports__["q"] = fillIndividualWorkForm;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapEmployeeForAutoComplete;
/* harmony export (immutable) */ __webpack_exports__["t"] = mapEquipmentForAutoComplete;
/* unused harmony export errorToast */
/* harmony export (immutable) */ __webpack_exports__["b"] = findEmployeeByName;
/* unused harmony export combineSchedules */
/* unused harmony export disableDailyScheduleForm */
/* unused harmony export disableDailyEditScheduleForm */
/* harmony export (immutable) */ __webpack_exports__["d"] = onDummyComplete;
/* harmony export (immutable) */ __webpack_exports__["m"] = fillEdit;
/* harmony export (immutable) */ __webpack_exports__["o"] = fillEdit2;
/* unused harmony export getManagerName */
/* unused harmony export mapFields */
/* unused harmony export fillMultiSelect */
/* unused harmony export getDateString */
/* unused harmony export disableEnableForm */
/* harmony export (immutable) */ __webpack_exports__["l"] = determineReportOpts;
/* harmony export (immutable) */ __webpack_exports__["f"] = dynamicSort;
/* harmony export (immutable) */ __webpack_exports__["e"] = dynamicReverseSort;
/* harmony export (immutable) */ __webpack_exports__["g"] = generateGraphDataAndLabels;
/* harmony export (immutable) */ __webpack_exports__["u"] = generateRandomColors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_random_color__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_random_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_random_color__);
/***************************************************************
5/25/2017
Alexander Self
utils.js: Utility functions
- Misc. utility functions for use throughout the application
***************************************************************/var Materialize=window.Materialize;var $=window.$;function mapField(h){return h.field;}function groupBy(arr,fn){arr.map(typeof fn==='function'?fn:function(val){return val[fn];}).reduce(function(acc,val,i){acc[val]=(acc[val]||[]).concat(arr[i]);return acc;},{});}/**
* getSelectedValue(): Extracts the selected value from a drop down select field
* @param {String} id, id of form input
* @returns {String} form value selected
* @called-in: ['/components/timesheets/create/timesheet_form.js']
**/function getSelectedValue(id){var selectedVal='';[].forEach.call(document.querySelectorAll('#'+id+' :checked'),function(elm){selectedVal=elm.value;});return selectedVal;}/**
* setPaycodeInWorkPerformed(): Extracts the selected value from a drop down select field and sets to workperformed
* @param {String} inputId, id of text input
* @returns {String} selectId, id of select input
* @called-in: ['/components/timesheets/create/timesheet_form.js','/components/timesheets/edit/timesheet_edit_form.js']
**/function setPaycodeInWorkPerformed(inputId,selectId){var workPerformed=document.getElementById(inputId);[].forEach.call(document.querySelectorAll('#'+selectId+' :checked'),function(elm){workPerformed.value=elm.id;});return workPerformed;}function setPaycodeInWorkPerformed2(inputId,selectId){var workPerformed=document.getElementById(inputId);return workPerformed;}/**
* setCCSubInWorkPerformed(): Extracts the selected value from a drop down select field and sets to workPerformed
* @param {String} inputId, id of text input
* @returns {String} selectId, id of select input
* @called-in: ['/components/timesheets/create/timesheet_form.js']
**/function setCCSubInWorkPerformed(inputId,ccId,subId){var workPerformed=document.getElementById(inputId);var cc=void 0,sub=void 0;[].forEach.call(document.querySelectorAll('#'+ccId+' :checked'),function(elm){cc=elm.value;});[].forEach.call(document.querySelectorAll('#'+subId+' :checked'),function(elm){sub=elm.id;});var costCenter=cc.split('-')[1];var work=costCenter+', '+sub;workPerformed.value=work;return workPerformed;}/**
* getSelectedValues(): Extracts the selected values from a multi-select drop down
* @param {String} id, id of form input
* @returns {String} form values selected
* @called-in:
**/function getSelectedValues(id){var selectedVals=[];[].forEach.call(document.querySelectorAll('#'+id+' :checked'),function(elm){if(elm.value!=='')selectedVals.push(elm.value);});return selectedVals;}/**
* handleWorkPerformed(): Handles Work Performed form checks
* @returns {Object} hours, trainer values, True or False
* @called-in:
**/function handleWorkPerformed(){var hours=void 0,trainer=void 0;var paycode=getSelectedValue('paycode');var workPerformed=document.getElementById('workPerformed').value;workPerformed=$.trim(workPerformed);// Handle secondaryHours
if(document.getElementById('hours').value==='')hours=0.00;else hours=document.getElementById('hours').value;if(document.getElementById('trainer').checked)trainer=1;else trainer=0;// Handle Work Performed
if(workPerformed===''){Materialize.toast('Please input Work Performed',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// handle paycodes
if(parseInt(paycode,10)>13&&parseInt(paycode,10)<44&&hours>0.00){Materialize.toast('Only add hours for paycodes 1-13, 45, 50-65',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/*if (((parseInt(paycode, 10) >= 1 && parseInt(paycode, 10) <= 13) || (parseInt(paycode, 10) >= 43 && parseInt(paycode, 10) <= 44)) && hours <= 1.00) {
    Materialize.toast('Add hours greater than 1 for paycodes 1-13, 42-44', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*/// Handle costCenter & subAccount
if(getSelectedValue('subAccount')===''&&getSelectedValue('costCenterCode')!==''){Materialize.toast('Select a Sub-account with a Cost Center',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// handle costCenter, subAccount, workPerformed & hours
if(getSelectedValue('subAccount')!==''&&getSelectedValue('costCenterCode')!==''&&document.getElementById('workPerformed').value!==''&&hours<0.1){Materialize.toast('Enter hours for work with Cost Center and Sub-account',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/* Special Cases: Added 6/18/2018 on Finance department request
     Cost centers within 12-32 need a field
     If completing garage work; require an equipment number
  */if(isInRange(Number(getSelectedValue('costCenterCode').split('-')[0]))&&getSelectedValue('field')===''){Materialize.toast('Please select a field for cost centers 12 - 32',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// Added 6.20.24
// Values for equipment and trailer; should only be one equipment number due to mechanical work
if(getSelectedValue('costCenterCode').split('-')[0]==='62'&&document.getElementById('equipmentNo').value!==''&&getSelectedValue('equipmentTrailerNo')!==''){Materialize.toast('Please add only one equipment number with cost center 62',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}if(getSelectedValue('costCenterCode').split('-')[0]==='62'&&document.getElementById('equipmentNo').value===''&&getSelectedValue('equipmentTrailerNo')===''){Materialize.toast('Please add an equipment number with cost center 62',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/* Special case for bug: Added 4/6/20 on Finance department request
     Supervisors have discovered a way to submit subaccounts not contained in a cost center
     i.e. Submitting 31-Hand Harvest-71 and 71-18-131
  */var _sub=getSelectedValue('subAccount').split('-')[1];var _cc=getSelectedValue('costCenterCode').split('-')[0];if(getSelectedValue('subAccount')!==''&&getSelectedValue('costCenterCode')!==''&&_sub!==_cc){Materialize.toast('Please select a subaccount belonging to the correct cost center',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/* Special case for bug: Added 9.1.21 Users figured out how to add a subaccount without a cost center
     and the work performed = undefined, {subaccount}
     ex: subaccount: 72-32-130, workperformed: undefined, Time Travel Operator, costCenter: ''
  */if(getSelectedValue('subAccount')!==''&&getSelectedValue('costCenterCode')===''&&workPerformed.match(/undefined/)){Materialize.toast('Please select a cost center and subaccount',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}return{hours:hours,trainer:trainer,check:true};}function isInRange(number){return number>=12&&number<=32;}/* Handles workPerformed form checks */function handleWorkPerformedEdit(){var hours=void 0,trainer=void 0;var paycode=getSelectedValue('edit-ts-paycode');// Handle secondaryHours
if(document.getElementById('edit-ts-hours').value==='')hours=0.00;else hours=document.getElementById('edit-ts-hours').value;if(document.getElementById('edit-ts-trainer').checked)trainer=1;else trainer=0;// Handle Work Performed
if(document.getElementById('edit-ts-workPerformed').value===''){Materialize.toast('Please input Work Performed',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// Handle paycodes
if(parseInt(paycode,10)>13&&parseInt(paycode,10)<42&&hours>0.00){Materialize.toast('Only add hours for paycodes 1-13, 45, 50-65',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/*if (((parseInt(paycode, 10) >= 1 && parseInt(paycode, 10) <= 13) || (parseInt(paycode, 10) >= 43 && parseInt(paycode, 10) <= 44)) && hours <= 0.00) {
    Materialize.toast('Add hours greater than 1 for paycodes 1-13, 42-44', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*/// Handle costCenter & subAccount
if(getSelectedValue('edit-ts-subAccount')===''&&getSelectedValue('edit-ts-costCenterCode')!==''){Materialize.toast('Select a Sub-account with a Cost Center',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// handle costCenter, subAccount, workPerformed & hours
if(getSelectedValue('edit-ts-subAccount')!==''&&getSelectedValue('edit-ts-costCenterCode')!==''&&document.getElementById('edit-ts-workPerformed').value!==''&&hours<0.1){Materialize.toast('Enter hours for work with Cost Center and Sub-account',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/* Special Cases: Added 6/18/2018 on Finance department request
     Cost centers within 12-32 need a field
     If completing garage work; require an equipment number
     */if(isInRange(Number(getSelectedValue('edit-ts-costCenterCode').split('-')[0]))&&getSelectedValue('edit-tsworkPerformed-field')===''){Materialize.toast('Please select a field for cost centers 12 - 32',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// Added 6.20.24
// Values for equipment and trailer; should only be one equipment number due to mechanical work
if(getSelectedValue('edit-ts-costCenterCode').split('-')[0]==='62'&&document.getElementById('edit-ts-equipmentNo').value!==''&&getSelectedValue('edit-ts-equipmentTrailerNo')!==''){Materialize.toast('Please add only one equipment number with cost center 62',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}// No value at all for equipment or trailer
if(getSelectedValue('edit-ts-costCenterCode').split('-')[0]==='62'&&document.getElementById('edit-ts-equipmentNo').value===''&&getSelectedValue('edit-ts-equipmentTrailerNo')===''){Materialize.toast('Please add an equipment number with cost center 62',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/*if ((getSelectedValue('edit-ts-costCenterCode').split('-')[0] === '62' && document.getElementById('edit-ts-equipmentNo').value === '') && getSelectedValue('equipmentTrailerNo') !== '') {
    Materialize.toast('Please add an equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*//* Special case for bug: Added 4/6/20 on Finance department request
     Supervisors have discovered a way to submit subaccounts not contained in a cost center
     i.e. Submitting 31-Hand Harvest-71 and 71-18-131
  */var _sub=getSelectedValue('edit-ts-subAccount').split('-')[1];var _cc=getSelectedValue('edit-ts-costCenterCode').split('-')[0];if(getSelectedValue('edit-ts-subAccount')!==''&&getSelectedValue('edit-ts-costCenterCode')!==''&&_sub!==_cc){Materialize.toast('Please select a subaccount belonging to the correct cost center',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}/* Special case for bug: Added 9.1.21 Users figured out how to add a subaccount without a cost center
     and the work performed = undefined, {subaccount}
     ex: subaccount: 72-32-130, workperformed: undefined, Time Travel Operator, costCenter: ''
  */if(getSelectedValue('edit-ts-subAccount')!==''&&getSelectedValue('edit-ts-costCenterCode')===''&&document.getElementById('edit-ts-workPerformed').value.match(/undefined/)){Materialize.toast('Please select a cost center and subaccount',3000,'red rounded');return{hours:hours,trainer:trainer,check:false};}return{hours:hours,trainer:trainer,check:true};}/**
* handleEquipmentNo(): Ensures users select the full equipment no and desc from autocomplete
* @param {String} id, id of form input
* @returns error if no equipmentNo is properly selected
* @called-in:
**/function handleEquipmentNo(id,equipmentNo){if(document.getElementById(id).value!==''){var equip=equipmentNo.find(function(e){return e.equipmentNo+' - '+e.description===document.getElementById(id).value;});if(!equip){Materialize.toast('Please select the equipment from the autocomplete list',4000,'rounded red');return false;}}return true;}/**
* validateEquipmentSelected(): Ensures users select the full equipment no and desc from autocomplete
* @param {String} id, id of form input
* @returns {Boolean} true or false depending on if the equipment exists
* @called-in: [actions/harvest_actions.js]
**/function validateEquipmentSelected(_ref){var equipment=_ref.equipment,equipmentList=_ref.equipmentList;if(equipment===''){Materialize.toast('Please select the equipment from the autocomplete list',4000,'rounded red');return false;}var equip=equipmentList.find(function(e){return e.equipmentNo+' - '+e.description===equipment;});if(!equip){Materialize.toast('Please select the equipment from the autocomplete list',4000,'rounded red');return false;}return true;}/* Computes the total hours worked */function totalHours(work){if(work.length===0)return 0;else if(work.length===1){return work[0].hours;}var sum=0;for(var i=0;i<work.length;i++){sum+=parseFloat(work[i].hours);}return sum.toFixed(2);}function totalCount(arr,type){if(arr.length===0)return 0;switch(type){case"hours":if(arr.length===1){return arr[0].hours;}var hours=arr.reduce(function(prev,cur){return prev+parseFloat(cur.hours);},0);if(hours==="")hours=0.00;return hours.toPrecision(3);case"trees":if(arr.length===1){return arr[0].trees;}var trees=arr.reduce(function(prev,cur){return prev+parseFloat(cur.trees);},0);if(trees==="")trees=0.00;return trees.toPrecision(3);case"bags":if(arr.length===1){return arr[0].bags;}var bags=arr.reduce(function(prev,cur){return prev+parseFloat(cur.bags);},0);if(bags==="")bags=0.00;return bags.toPrecision(3);case"incentive":if(arr.length===1){return arr[0].incentive;}var incentive=arr.reduce(function(prev,cur){return prev+parseFloat(cur.incentive);},0);if(incentive==="")incentive=0.00;return incentive.toPrecision(4);case"pIndex":if(arr.length===1){return arr[0].pIndex;}var pIndex=arr.reduce(function(prev,cur){return prev+parseFloat(cur.pIndex);},0);var avgIndex=pIndex/arr.length;return avgIndex.toPrecision(4);default:return 0;}}/* Generates a unique general purpose ID */var generateGUID=function generateGUID(){var d=new Date().getTime();if(window.performance&&typeof window.performance.now==="function"){d+=performance.now();//use high-precision timer if available
}var uuid='xxxxxxxx'.replace(/[xy]/g,function(c){var r=(d+Math.random()*16)%16|0;d=Math.floor(d/16);// eslint-disable-next-line
return(c=='x'?r:r&0x3|0x8).toString(16);});return uuid;};/* Generates a unique Timesheet ID */var generateTSID=function generateTSID(){var d=new Date().getTime();if(window.performance&&typeof window.performance.now==="function"){d+=performance.now();//use high-precision timer if available
}var uuid='xxxxxxxx-xxxxxxxx-xxxxxxxx-xxxxxxxx'.replace(/[xy]/g,function(c){var r=(d+Math.random()*16)%16|0;d=Math.floor(d/16);// eslint-disable-next-line
return(c=='x'?r:r&0x3|0x8).toString(16);});return uuid;};/* Creates an obj containing all form elements */function packageForm(id){var elements=document.getElementById(''+id).elements;var formObj={};// eslint-disable-next-line
for(var i=0,element;element=elements[i++];){if(element.id==="")continue;formObj[element.id]=element.value;if(element.checked===true)formObj[element.id]=1;}return formObj;}/**
* packageDashForm(): Packages form element values with dashes in ids
* @param {String} id, id of form
* @returns {Object} formObj, key value form object
* @called-in: ['/components/timesheets/create/gang_autofill_form.js]
**//* The absurdity: for form ids using a dash */function packageDashForm(id){var elements=document.getElementById(''+id).elements;var formObj={};// eslint-disable-next-line
for(var i=0,element;element=elements[i++];){if(element.id==="")continue;if(element.id.split('-').length===2)formObj[element.id.split('-')[1]]=element.value;if(element.id.split('-').length===3)formObj[element.id.split('-')[2]]=element.value;if(element.checked===true&&element.id.split('-').length===2){formObj[element.id.split('-')[1]]=1;}}return formObj;}/* For Gang Timesheets
  Parses form array of dynamically added form elements (users + bags, trees)
  and splits unique ids and groups them according to their ids
  array starts as [312x-trees: '', 312x-bags: '', eid: '' ]
  after: [{ eid: 312x, trees: '', bags: '' }] array of objs
*/// Work Performed is for employee meetings, travel, ot ,etc
function extractUsersFromForm(formObj,workPerformed){var empArr=[];var empObj={};var newFormObj={};var tempKey=void 0;var subTimesheet={};var subTimesheets=[];/* First filter to extract form elements into formatted objects */for(var key in formObj){if(tempKey!==key&&key.split('-')[1]==='eid'){empObj.eid=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='positionType'){empObj.positionType=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='subgrade'){empObj.subgrade=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='trees'){empObj.trees=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='bags'){empObj.bags=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='field'){empObj.field=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='hours'){empObj.hours=formObj[key];}else if(tempKey!==key&&key.split('-')[1]==='block'){empObj.block=formObj[key];empObj.id=generateGUID();tempKey=key;empArr.push(empObj);empObj={};}else if(tempKey!==key&&key.split('-').length===3){continue;}else{newFormObj[key]=formObj[key];}}/* Second filter to extract form elements into formatted objects */for(var _key in formObj){if(tempKey!==_key&&_key.split('-')[2]==='eid'){empObj.eid=formObj[_key];}else if(tempKey!==_key&&_key.split('-')[2]==='trees'){empObj.trees=formObj[_key];}else if(tempKey!==_key&&_key.split('-')[2]==='bags'){empObj.bags=formObj[_key];}else if(tempKey!==_key&&_key.split('-')[2]==='field'){empObj.field=formObj[_key];}else if(tempKey!==_key&&_key.split('-')[2]==='hours'){empObj.hours=formObj[_key];}else if(tempKey!==_key&&_key.split('-')[2]==='block'){empObj.block=formObj[_key];empObj.id=generateGUID();tempKey=_key;empArr.push(empObj);empObj={};}}for(var _key2 in formObj){if(tempKey!==_key2&&_key2.split('-')[1]==='eid'){subTimesheet.eid=formObj[_key2];}else if(tempKey!==_key2&&_key2.split('-')[1]==='paycode'){subTimesheet.paycode=formObj[_key2];}else if(tempKey!==_key2&&_key2.split('-')[1]==='paycodeDescription'){subTimesheet.workPerformed=formObj[_key2];}else if(tempKey!==_key2&&_key2.split('-')[1]==='paycodeHours'){subTimesheet.hours=formObj[_key2];if(subTimesheet.hours==='')subTimesheet.hours=0.00;tempKey=_key2;subTimesheet=Object.assign({},subTimesheet,{tempGrade:'',costCenterCode:'',subAccount:'',field:'',block:'',equipmentNo:'',equipmentTrailerNo:'',differential:''});subTimesheets.push(subTimesheet);subTimesheet={};}}newFormObj.employees=empArr;newFormObj.emps=[];var summaryOfHours,harvest,temp,subTS,work;var eObj={};// Create employee timesheet object: contains all form info per employee
var _loop=function _loop(e){if(e.eid!==temp){work=workPerformed.reduce(function(previous,current){return previous+parseFloat(current.hours,10);},0);summaryOfHours=newFormObj.employees.filter(function(item){return item.eid===e.eid;}).reduce(function(previous,current){return previous+parseFloat(current.hours,10);},0);harvest=newFormObj.employees.filter(function(item){return item.eid===e.eid;});subTS=subTimesheets.filter(function(item){return item.eid===e.eid;});temp=e.eid;summaryOfHours+=work;if(subTS.length>0){if(subTS[0].paycode===''){eObj.subTimesheet=[];}else eObj.subTimesheet=subTS;}if(harvest.length>0){/* Case: Employee is sick, excused, vacation ,etc */if(harvest[0].hours===''){harvest=[];}}eObj.startTime=newFormObj.gangStartTime;eObj.endTime=newFormObj.gangEndTime;eObj.gang=newFormObj.gangNo;eObj.shift=newFormObj.gangShift;eObj.location=newFormObj.gangLocation;eObj.date=newFormObj.gangWorkDate;eObj.eid=e.eid;eObj.positionType=e.positionType;eObj.subgrade=e.subgrade||'';eObj.harvest=harvest.map(function(h){return Object.assign({},h,{round:Number(formObj.round)});});eObj.summaryOfHours=summaryOfHours.toFixed(2);if(summaryOfHours>8){eObj.regHours=8;eObj.otHours=(summaryOfHours-8).toFixed(2);}else{eObj.otHours=0;eObj.regHours=summaryOfHours.toFixed(2);}if(Object.keys(eObj).length>0){newFormObj.emps=newFormObj.emps.concat(eObj);}if(isNaN(eObj.regHours)){eObj.regHours=0.00;eObj.otHours=0.00;eObj.summaryOfHours=0.00;}/* Case: Employee is getting paid and need to account for hours */if(subTS.length>0){if(parseFloat(subTS[0].hours)>0){eObj.regHours=parseFloat(eObj.regHours);eObj.summaryOfHours=parseFloat(eObj.summaryOfHours);eObj.regHours+=parseFloat(subTS[0].hours);eObj.otHours=0.00;eObj.summaryOfHours+=parseFloat(subTS[0].hours);}}// eslint-disable-next-line
workPerformed.map(function(w){return eObj.subTimesheet.push(w);});eObj={};}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=newFormObj.employees[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var e=_step.value;_loop(e);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}newFormObj.emps=uniq(newFormObj.emps);delete newFormObj.employees;delete newFormObj.gangStartTime;delete newFormObj.gangEndTime;delete newFormObj.gangNo;delete newFormObj.gangShift;delete newFormObj.gangLocation;delete newFormObj.gangWorkDate;for(var _key3 in newFormObj){if(_key3!==('emps'||'gangTravel'||'gangMeeting'))delete newFormObj[_key3];}return newFormObj;}function uniq(a){var seen={};return a.filter(function(item){return seen.hasOwnProperty(item.eid)?false:seen[item.eid]=true;});}/* Clears any form based on id */function clearForm(formID){return document.getElementById(''+formID).reset();}/* Alerts user about required fields */function handleFormChecking(form,cb){switch(true){case form.date==='':cb('Please enter a date before submitting');return 1;/*case (form.location === ''):
      cb('Please select a location before submitting');
      return 1;
    case (form.shift === ''):
      cb('Please select a shift before submitting');
      return 1;
    case (form.regHours === 0):
      cb('Please enter regular hours before submitting');
      return 1;
    case (form.startTime === ''):
      cb('Please enter a start time before submitting');
      return 1;
    case (form.endTime === ''):
      cb('Please enter a end time before submitting');
      return 1;*/default:return 0;}}/*
  Returns current date
*/function getCurrentDate(){var today=__WEBPACK_IMPORTED_MODULE_0_moment___default()();return today.format('YYYY-MM-DD');}/*
  Prefills timesheet edit forms when user pulls information
  Edit form have unique ids that match the database column names
*/function fillEditForm(ts){var editForm=document.getElementById("edit-ts-form").elements;var timesheet=ts.timesheet;timesheet.round=ts.round;// eslint-disable-next-line
for(var i=0,element;element=editForm[i++];){if(element.id==="")continue;var id=element.id.split('-')[2];for(var key in timesheet){if(key===id){if(key==='date'){element.value=timesheet[key].split('T')[0];}else{element.value=timesheet[key];}if(key==='dustPay'&&timesheet[key]===1){element.checked=true;}else continue;}}}}/*
  Prefills timesheet individual forms when user needs to edit before submitting
*/function fillIndividualWorkForm(work,id){// eslint-disable-next-line
switch(id){case'second-ts-form':var form=document.getElementById(id).elements;// eslint-disable-next-line
for(var i=0,element;element=form[i++];){var _id=element.id;for(var key in work){if(key===_id)element.value=work[key];if(key==='trainer'&&work[key]===1)element.checked=true;}}return;case'edit-second-ts-form':var _form=document.getElementById(id).elements;// eslint-disable-next-line
for(var _i=0,_element;_element=_form[_i++];){var _id2=_element.id.split('-')[2];for(var _key4 in work){if(_key4===_id2)_element.value=work[_key4];if(_key4==='trainer'&&work[_key4]===1)_element.checked=true;}}return;case'gang-work-form':document.getElementById('gangCostCenterCode').value=work.costCenterCode;document.getElementById('gangSubAccount').value=work.subAccount;document.getElementById('gangWorkPerformed').value=work.workPerformed;document.getElementById('gangField').value=work.field;document.getElementById('gangHours').value=work.hours;return;default:return;}}/* Takes an array of data and maps to an object
  where the keys are the values;
  Built for materializecss autocomplete
 */function mapEmployeeForAutoComplete(data){var dataObj={};for(var i=0;i<data.length;i++){dataObj[data[i].firstName+' '+data[i].lastName]=null;}return dataObj;}function mapEquipmentForAutoComplete(data){var dataObj={};for(var i=0;i<data.length;i++){dataObj[data[i].equipmentNo+' - '+data[i].description]=null;}return dataObj;}/* Display an error as a toast */function errorToast(msg){Materialize.toast(msg,4000,'red rounded');return;}/*
  Find a particular employee by first and last name
  returning only the find function will return duplicates every time.
  @called-in: ['/actions/harvest_actions.js','irrigation/irrigation_actions.js',
  'irrigation/components/irrigation_display.js']
*/function findEmployeeByName(name,employees){var emp=void 0;emp=employees.find(function(e){return e.firstName+' '+e.lastName===name;});if(emp===undefined||emp===null||emp==='')return{};return emp;}/*
  Combines the basic weekly schedule with any daily schedule additions.
  If there are no daily schedule additions, iterate through dates and create
  daily schedule array from basic weekly schedule form
*/function combineSchedules(main,daily){var fullSchedule={schedule:{},// scheduleID, totalExpectedHours, startDate, endDate
dailySchedule:[]// Individual work day objs
};var schedule=[],totalExpectedHours=0;// For daily schedule replace
if(daily.length>0){// Add one extra day because loop exits the day prior to endDate
for(var m=__WEBPACK_IMPORTED_MODULE_0_moment___default()(main.startDate);m.isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()(main.endDate).add(1,'days'));m.add(1,'days')){// Keep track of which days have been individually assigned so there is no redundancy in scheduling
var day;// Daily Schedule array
for(var i=0;i<daily.length;i++){//if there is a date that matches, create the individual schdule
if(daily[i].workdate===m.format('YYYY-MM-DD')){day=daily[i].workdate;totalExpectedHours+=parseInt(daily[i].hours,10);// Check for days off
if(daily[i].dayOff==='on'){schedule.push({workdate:daily[i].workdate,startTime:"",endTime:"",typeOfWork:daily[i].typeOfWork,hours:parseInt(daily[i].hours,10),location:"",field:"",description:daily[i].description});}else{schedule.push({workdate:daily[i].workdate,startTime:daily[i].startTime,endTime:daily[i].endTime,typeOfWork:daily[i].typeOfWork,hours:parseInt(daily[i].hours,10),location:daily[i].location,field:daily[i].field,description:daily[i].description});}}}if(day===m.format('YYYY-MM-DD'))continue;else{totalExpectedHours+=parseInt(main.hours,10);schedule.push({workdate:m.format('YYYY-MM-DD'),startTime:main.startTime,endTime:main.endTime,typeOfWork:main.typeOfWork,hours:parseInt(main.hours,10),location:main.location,field:main.field,description:main.description});}}}else{// There are no custom days
for(var _m=__WEBPACK_IMPORTED_MODULE_0_moment___default()(main.startDate);_m.isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()(main.endDate).add(1,'days'));_m.add(1,'days')){totalExpectedHours+=parseInt(main.hours,10);schedule.push({workdate:_m.format('YYYY-MM-DD'),startTime:main.startTime,endTime:main.endTime,typeOfWork:main.typeOfWork,hours:parseInt(main.hours,10),location:main.location,field:main.field,description:main.description});}}fullSchedule.dailySchedule=schedule;fullSchedule.schedule={scheduleID:generateTSID(),totalExpectedHours:totalExpectedHours,startDate:main.startDate,endDate:main.endDate};return fullSchedule;}/*
  If the day off checkbox is selected, disable all fields except work date
  For schedules
*/function disableDailyScheduleForm(){var dayOff=document.getElementById('schedule-dayOff');var dailyForm=document.getElementById('daily-schedule-form').elements;if(dayOff.checked===true){// eslint-disable-next-line
for(var i=0,element;element=dailyForm[i++];){if(element.id==='schedule-dayOff')continue;if(element.id==='schedule-daily-workdate')continue;if(element.id==='schedule-add-day')continue;element.disabled=true;}}else{// eslint-disable-next-line
for(var _i2=0,_element2;_element2=dailyForm[_i2++];){if(_element2.id==='schedule-dayOff')continue;if(_element2.id==='schedule-daily-workdate')continue;if(_element2.id==='schedule-add-day')continue;_element2.disabled=false;}}}function disableDailyEditScheduleForm(){var dayOff=document.getElementById('edit-schedule-dayOff');var dailyForm=document.getElementById('daily-edit-schedule-form').elements;if(dayOff.checked===true){// eslint-disable-next-line
for(var i=0,element;element=dailyForm[i++];){if(element.id==='edit-schedule-dayOff')continue;if(element.id==='edit-schedule-workdate')continue;if(element.id==='edit-schedule-add-day')continue;element.disabled=true;}}else{// eslint-disable-next-line
for(var _i3=0,_element3;_element3=dailyForm[_i3++];){if(_element3.id==='edit-schedule-dayOff')continue;if(_element3.id==='edit-schedule-workdate')continue;if(_element3.id==='edit-schedule-add-day')continue;_element3.disabled=false;}}}function onDummyComplete(){return;}/* Fills in an edit form */function fillEdit(formId,form){var editForm=document.getElementById(formId).elements;// eslint-disable-next-line
for(var i=0,element;element=editForm[i++];){if(element.id==="")continue;var id=element.id.split('-')[2];for(var key in form){if(key===id){if(key==='date'){element.value=form[key].split('T')[0];}else{element.value=form[key];}if(key==='partTime'&&form[key]===1){element.checked=true;}else element.checked=false;}}}}/* Fills in an edit form */function fillEdit2(_ref2){var formId=_ref2.formId,form=_ref2.form;var editForm=document.getElementById(formId).elements;// eslint-disable-next-line
for(var i=0,element;element=editForm[i++];){if(element.id==="")continue;var id=element.id.split('-')[1];for(var key in form){if(key===id){element.value=form[key];}}}}function getManagerName(eid,employees){var manager=employees.filter(function(e){return e.eid===eid;});console.log(manager);}/*
  Maps fields in summaries; account for multiple entries or a single one
  Called in: components/timesheets/view/timesheet_view_individual_summary, timesheet_view_summary
*/function mapFields(fields){try{var _fields=JSON.parse(fields);if(_fields.length===0)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'None'));if(_fields.length===1)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,_fields[0]);if(_fields.length>1){return _fields.map(function(f){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:f},f,' ');});}return fields;}catch(e){/* Catches a failed parse attempt;  */// Multiple values
try{var _fields2=JSON.parse(fields);if(_fields2.length>1){return _fields2.map(function(f){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:f},f,' ');});}// just return single field
}catch(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,fields,' ');}}}/* Prefills a multi select dropdown
   Called in:
*/function fillMultiSelect(vals){var id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var multi=document.getElementById(id);var options=[];try{var _vals=JSON.parse(vals);for(var i=0;i<multi.length;i++){for(var j=0;j<_vals.length;j++){if(multi[i].value===_vals[j]){multi[i].selected='selected';options.push(multi[i].value);}}}$('input.select-dropdown').val(options);}catch(e){// Single value
for(var _i4=0;_i4<multi.length;_i4++){if(multi[_i4].value===vals){multi[_i4].selected='selected';$('input.select-dropdown').val(multi[_i4].value);break;}}}}function getDateString(date){return JSON.stringify(date).replace(/["]+/g,'').split('T')[0];}/**
* disableEnableForm(): Disables and enables a form
* @param {String} id, id of form input
* @returns
* @called-in: ['/components/finance/finance_payrates.js']
**/function disableEnableForm(id,disable){if(disable){var _form2=document.getElementById(id).elements;// eslint-disable-next-line
for(var i=0,element;element=_form2[i++];){element.readOnly=true;element.disabled=true;}return;}var form=document.getElementById(id).elements;// eslint-disable-next-line
for(var _i5=0,_element4;_element4=form[_i5++];){_element4.readOnly=false;_element4.disabled=false;}return;}/**
* determineReportOpts(): Returns a object of form options a user specified
* @param {Object} opts: Report form options
* @returns {Object} formOptions: user selected form options
* @called-in: ['/actions/harvest_actions.js']
**/function determineReportOpts(opts){var obj={};for(var key in opts){if(opts[key]==='on'||key==='dateFrom'||key==='dateTo'||key==='employee')continue;else obj[key]=opts[key];}return obj;}/**
* dynamicSort(): Returns a sorted array by dynamic prop asc
* @param {String} property: Property to sort by
* @returns {Array} sorted array
* @called-in: [''/components/harvest/view/harvest_view.js'']
**/function dynamicSort(property){if(property==='date'){var _sortOrder=1;if(property[0]==="-"){_sortOrder=-1;property=property.substr(1);}return function(a,b){var result=new Date(a[property])<new Date(b[property])?1:new Date(a[property])>new Date(b[property])?-1:0;return result*_sortOrder;};}var sortOrder=1;if(property[0]==="-"){sortOrder=-1;property=property.substr(1);}return function(a,b){var result=a[property]<b[property]?1:a[property]>b[property]?-1:0;return result*sortOrder;};}/**
* dynamicReverseSort(): Returns a sorted array by dynamic prop desc
* @param {String} property: Property to sort by
* @returns {Array} sorted array
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function dynamicReverseSort(property){if(property==='date'){var _sortOrder2=1;if(property[0]==="-"){_sortOrder2=-1;property=property.substr(1);}return function(a,b){var result=new Date(a[property])<new Date(b[property])?-1:new Date(a[property])>new Date(b[property])?1:0;return result*_sortOrder2;};}var sortOrder=1;if(property[0]==="-"){sortOrder=-1;property=property.substr(1);}return function(a,b){var result=a[property]<b[property]?-1:a[property]>b[property]?1:0;return result*sortOrder;};}/**
* generateGraphLabelsAndData(): Accepts an array of data and returns a set of labels and selected datapoints
* @param {String} dataProp: Property to extract from array
* @param {String} labelProp: Label to map to data prop
* @param {Array} arr: the entire data array
* @returns {Array} data: the array which will be mapped to a single property
* @called-in: ['/components/harvest/view/harvest_report_view.js']
**/function generateGraphDataAndLabels(dataProp,labelProp,arr){if(!(dataProp&&labelProp&&arr))return{data:[],labels:[]};var data=arr.map(function(a){return a[dataProp];});var labels=arr.map(function(a){return a[labelProp];});return{data:data,labels:labels};}/**
* generateRandomColors(): Returns an array of hex colors; used for graph colors on unknown array sizes
* @param {Array} arr: the entire data array
* @returns {Array} colors: an array of hex colors
* @called-in: ['/components/harvest/view/harvest_report_view.js']
**/function generateRandomColors(arr){if(!arr)return[];var colors=arr.map(function(d){var color=__WEBPACK_IMPORTED_MODULE_2_random_color___default()();var r=color.hexString();return r;});return colors;}/* END */

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(639)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROOT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_NON_REG_GRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DAYS_FOR_ADMINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TIMESHEET_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PROFILE_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TEAM_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MECH_HARVEST_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IRRIGATION_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROFILE_LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TYPES; });
/* unused harmony export BU_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LEVELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DIFFERENTIAL_SLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GRADES; });
/* unused harmony export PAYRATE_GRADES */
/* unused harmony export PAYRATE_YEARS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SUBGRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SHIFTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SMS_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EMPLOYEE_STATUS; });
/* unused harmony export EMPLOYEE_ATTENDANCE */
/* unused harmony export LABORS_HOURS_BY_FIELD */
/* unused harmony export DENSITY_BY_FIELD */
/* unused harmony export DEPARTMENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTAINER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KAU_FIELD_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return KEAAU_FIELD_MAP; });
/* Constants used throughout the application *///export const ROOT_URL = 'http://localhost:3090';
var ROOT_URL='https://www.rhs.systems';// export const ROOT_URL = 'https://www.himn-api.systems'; // Staging
// Max grade for non-regular employees; if this changes, update this number
var MAX_NON_REG_GRADE=6.1;// If it is necessary to update timesheets past a pay period is closed; update DAYS_FOR_ADMINS; default is 5
// @imported actions/index.js/fetchTimesheetDatesToEdit() 
var DAYS_FOR_ADMINS=5;/* Master Navigation URL's */var URLS=[{name:'Dashboard',url:'/dashboard',_class:'purple',icon:'dashboard'},{name:'Timesheet',url:'/timesheet',_class:'black',icon:'query_builder'},{name:'Team Builder',url:'/teambuilder',_class:'cyan',icon:'extension'},{name:'Profile',url:'/profile',_class:'grey',icon:'account_circle'},{name:'Alert',url:'/alert',_class:'red',icon:'message'},{name:'Harvest',url:'/harvest',_class:'indigo',icon:'grid_on'},{name:'Cultivation',url:'/cultivation',_class:'green',icon:'brightness_7'},{name:'Irrigation',url:'/irrigation',_class:'blue',icon:'opacity'},{name:'Interval',url:'/interval',_class:'brown',icon:'event_note'}];/* Timesheet specific URL's */var TIMESHEET_URLS=[{name:'View Timesheet',url:'/timesheet',level:0},{name:'Create Timesheet',url:'/timesheet/create',level:1},{name:'Edit Timesheet',url:'/timesheet/edit',level:2},{name:'Delete Timesheet',url:'/timesheet/delete',level:3}];/* Profile specific URL's */var PROFILE_URLS=[{name:'View Profile',url:'/profile',level:0},{name:'Create Profile',url:'/profile/create',level:4},{name:'Edit Profile',url:'/profile/edit',level:4}];/* Gang specific URL's */var TEAM_URLS=[{name:'View Teams',url:'/teambuilder',level:0},{name:'Create Teams',url:'/teambuilder/create',level:2},{name:'Edit Teams',url:'/teambuilder/edit',level:2},{name:'Delete Teams',url:'/teambuilder/delete',level:2}];/* Mechanical harvest URL's */var MECH_HARVEST_URLS=[{name:'View Harvest',url:'/harvest',level:0},{name:'Create Mechanical Harvest',url:'/harvest/create',level:3},{name:'Manage Mechanical Harvest',url:'/harvest/manage',level:3}];/* Mechanical harvest URL's */var IRRIGATION_URLS=[{name:'View Irrigation',url:'/irrigation',level:0},{name:'Create Irrigation',url:'/irrigation/create',level:3},{name:'Manage Irrigation',url:'/irrigation/manage',level:3}];/* Locations URL's */var LOCATIONS=[{val:'71',label:'71 - Kau'},{val:'72',label:'72 - Keaau'},{val:'75',label:'75 - Naalehu'}];var PROFILE_LOCATIONS=[{val:'60',label:'60 - California'},{val:'70',label:'70 - Admin'},{val:'71',label:'71 - Kau'},{val:'72',label:'72 - Keaau'},{val:'75',label:'75 - Naalehu'}];/* Type of employee: Salary or Union */var TYPES=[{val:'BU',label:'BU'},{val:'SAL',label:'SAL'}];var BU_TYPES=[{val:'Covered Seasonal',label:'Covered Seasonal'},{val:'Non-Covered Seasonal',label:'Non-Covered Seasonal'},{val:'Intermittent',label:'Intermittent'},{val:'Regular',label:'Regular'}];/* The levels of authentication for each employee */var LEVELS=[{val:0,label:'0 - Union: Basic Employee'},{val:1,label:'1 - Union: Timesheet Employee'},{val:2,label:'2 - Supervisor'},{val:3,label:'3 - Manager'},{val:4,label:'4 - HR / Administrator'}];/* Harvest status of a field */var STATUS=[{val:1,label:'Complete'},{val:0,label:'Incomplete'}];/* For shift differential payments: Only happens in Kau */var DIFFERENTIAL_SLOT=[{val:'6-12',label:'6-12'},{val:'12-5',label:'12-5'}];/* Employee Grades */var GRADES=[{val:1,label:1},{val:2,label:2},{val:2.1,label:2.1},{val:3,label:3},{val:3.1,label:3.1},{val:4,label:4},{val:4.1,label:4.1},{val:5,label:5},{val:5.1,label:5.1},{val:6,label:6},{val:6.1,label:6.1},{val:7,label:7},{val:7.1,label:7.1},{val:8,label:8},{val:8.1,label:8.1},{val:9,label:9},{val:9.1,label:9.1},{val:10,label:10},{val:10.1,label:10.1},{val:11,label:11},{val:11.1,label:11.1}];/* Used in finance payrate edit */var PAYRATE_GRADES=[{val:1,label:1},{val:2,label:2},{val:3,label:3},{val:4,label:4},{val:5,label:5},{val:6,label:6},{val:7,label:7},{val:8,label:8},{val:9,label:9},{val:10,label:10},{val:11,label:11}];/* Used in finance payrate edit */var PAYRATE_YEARS=[{val:1,label:1},{val:2,label:2},{val:3,label:3},{val:4,label:4}];var SUBGRADES=[{val:'A',label:'A'},{val:'B',label:'B'},{val:'C',label:'C'},{val:'D',label:'D'},{val:'E',label:'E'},{val:'F',label:'F'},{val:'G',label:'G'}];/* Employee Shifts */var SHIFTS=[{val:1,label:1},{val:2,label:2},{val:3,label:3}];var SMS_MESSAGES=[{value:'Test',msg:'ALERT: This is a test alert'},{value:'Rain',msg:'ALERT: Work has been cancelled today due to heavy rainfall in the orchards.'},{value:'Vog',msg:'ALERT: Work has been cancelled today due to excessive vog/ash in the orchards.'},{value:'Lightning',msg:'ALERT: Work has been cancelled today due to lightning close to the orchards.'},{value:'Disaster',msg:'ALERT: Work has been cancelled today due to a natural disaster near the orchards.'},{value:'Threat',msg:'ALERT: There is an ongoing threat in the orchards.'}];/*
export const FAULT_TYPES = [
  { header: 'Irrigation', icon: 'opacity', desc: 'Irrigation Required', color: '#2196f3', borderColor: '#90caf9', headerColor: '#e3f2fd', onclick: () => console.log('Clicked!') },
  { header: 'Fallen Branches', icon: 'nature', desc: 'Clear Fallen Branches', color: '#4caf50', borderColor: '#a5d6a7', headerColor: '#e8f5e9', onclick: () => console.log('Clicked!') },
  { header: 'Harvest Machines', icon: 'healing', desc: 'Repair Harvest Machines', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Husking Station', icon: 'toys', desc: 'Husking Station Repairs', color: '#009688', borderColor: '#80cbc4', headerColor: '#e0f2f1', onclick: () => console.log('Clicked!') },
  { header: 'Broken Water Lines', icon: 'warning', desc: 'Repair Broken Water Lines', color: '#3f51b5 ', borderColor: '#9fa8da', headerColor: '#e8eaf6', onclick: () => console.log('Clicked!') },
  { header: 'Rock Clearing', icon: 'landscape', desc: 'Clear Problematic Rocks', color: '#f44336', borderColor: '#ef9a9a', headerColor: '#ffebee', onclick: () => console.log('Clicked!') },
  { header: 'Machine Repair', icon: 'build', desc: 'Repair a Machine', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Tractor Clearing', icon: 'grid_on', desc: 'Clearing with Tractor', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Tree Replants', icon: 'nature_people', desc: 'Replant Trees', color: '#8bc34a', borderColor: '#c5e1a5', headerColor: '#f1f8e9', onclick: () => console.log('Clicked!') },
  { header: 'Other', icon: 'priority_high', desc: 'Other Fault', color: '#9e9e9e', borderColor: '#eeeeee', headerColor: '#fafafa', onclick: () => console.log('Clicked!') }
]
*//*
export const SP_PAY_CODE = [
  { val: '01', label: '01 - Vacation Non-Option' },
  { val: '02', label: '02 - Sick' },
  { val: '03', label: '03 - Sick, Supplemental' },
  { val: '05', label: '05 - Holiday' },
  { val: '06', label: '06 - Ind. Accident' },
  { val: '07', label: '07 - State TDI' },
  { val: '08', label: '08 - Jury Duty' },
  { val: '09', label: '09 - Boards & Comm.' },
  { val: '10', label: '10 - Funeral Leave' },
  { val: '11', label: '11 - Vacation In Lieu of Sick' },
  { val: '12', label: '12 - Vacation Option' },
  { val: '13', label: '13 - Vacation, Scheduled Carryover' },
  { val: '30', label: '30 - Stop Work Meeting' },
  { val: '31', label: '31 - Suspension' },
  { val: '32', label: '32 - Excused Absence' },
  { val: '33', label: '33 - Unexcused Absence' },
  { val: '34', label: '34 - Military Leave' },
  { val: '36', label: '36 - Ind. Accident Workers Comp.' },
  { val: '38', label: '38 - No Work Available' },
  { val: '39', label: '39 - Sick Without Pay' },
  { val: '40', label: '40 - Absence Without Pay' },
  { val: '41', label: '41 - Day of Rest' },
  { val: '42', label: '42 - 1FE (Employee Pay)' },
  { val: '43', label: '43 - 1FF (Family Care Pay)' },
  { val: '44', label: '44 - 1FA (FMLA Expansion)' },
  { val: '45', label: '45 - COV (COVID Pay-ETS)' },
  { val: '50', label: '50 - Meal Penalty' },
  { val: '51', label: '51 - Report Call Out S.T.' },
  { val: '52', label: '52 - Report Call Out O.T.' },
  { val: '53', label: '53 - Report Call Out D.T.' },
  { val: '54', label: '54 - Vacation - Pay in Lieu' },
  { val: '55', label: '55 - Vacation - Pro Rata' },
  { val: '56', label: '56 - Holiday Pay on Sick Day' },
  { val: '61', label: '61 - Severance - Lay off' },
  { val: '62', label: '62 - Severance - Interim Retirement' },
  { val: '65', label: '65 - Severance - Interim Disability' },
  { val: '69', label: '69 - Other Pay' }
];
*/var EMPLOYEE_STATUS=[{val:'Active',label:'Active'},{val:'Inactive',label:'Inactive'},{val:'LOA',label:'LOA'},{val:'Terminated',label:'Terminated'}];var EMPLOYEE_ATTENDANCE=[{name:'dashboard-attendance-location',id:'attendance-both-loc',label:'Both'},{name:'dashboard-attendance-location',id:'attendance-kau-loc',label:'Ka\'u'},{name:'dashboard-attendance-location',id:'attendance-keaau-loc',label:'Kea\'au'}];var LABORS_HOURS_BY_FIELD=[{name:'dashboard-field-location',id:'field-both-loc',label:'Both'},{name:'dashboard-field-location',id:'field-kau-loc',label:'Ka\'u'},{name:'dashboard-field-location',id:'field-keaau-loc',label:'Kea\'au'}];var DENSITY_BY_FIELD=[{name:'dashboard-density-location',id:'density-both-loc',label:'Both'},{name:'dashboard-density-location',id:'density-kau-loc',label:'Ka\'u'},{name:'dashboard-density-location',id:'density-keaau-loc',label:'Kea\'au'}];/* For dashboard departments */var DEPARTMENTS={'Harvesting':'red','Hand Harvest':'blue-grey','Garage Direct':'indigo','Field General':'purple','Drying':'cyan','Maintenance Shop':'teal','Mechanical Harvest':'grey','Other Field Operations':'red lighten-3','Agri Development':'green darken-2','Palima Engine':'cyan accent-2','Palima Well':'teal accent-4','Pest Control':'lime darken-4','QA Lab/Husk disposal':'orange lighten-1','Weed Control':'brown lighten-2','Irrigation':'blue','Husking':'deep-purple','Total':'black'};/* Mech. harvest container types */var CONTAINER_TYPES=[{val:'Bin',label:'Bin'},{val:'Trailer',label:'Trailer'}];/* Coodinates created from GIMP ImageMap; each set of coordinates maps to a field in Kau */var KAU_FIELD_MAP=[{shape:'poly',coords:'871,684,995,691,1012,726,1055,757,1047,806,1001,812,985,832,932,816,886,823,853,814,844,779,867,730,870,717,871,684',alt:'E410',id:'E410'},{shape:'poly',coords:'1009,690,1019,711,1054,744,1076,757,1074,810,1090,832,1111,829,1123,806,1119,788,1169,711,1171,686,1165,675,1165,661,1077,690,1010,691',alt:'E415',id:'E415'},{shape:'poly',coords:'1137,794,1130,831,1121,830,1121,855,1142,851,1172,850,1207,781,1258,770,1287,752,1331,752,1346,726,1303,727,1286,751,1256,771,1204,782,1136,795',alt:'W510',id:'W510'},{shape:'poly',coords:'1196,653,1308,621,1305,701,1362,703,1348,724,1301,724,1281,751,1253,768,1137,791,1169,732,1191,708,1194,653',alt:'W515',id:'W515'},{shape:'poly',coords:'1311,623,1594,539,1633,532,1620,601,1535,641,1477,682,1427,688,1390,715,1368,711,1372,699,1310,698,1313,621',alt:'T610',id:'T610'},{shape:'poly',coords:'1572,537,1635,524,1647,430,1640,408,1631,402,1623,407,1620,415,1616,439,1604,446,1600,430,1590,415,1581,412,1575,425,1568,487,1563,499,1576,521,1574,538',alt:'H650',id:'H650'},{shape:'poly',coords:'1733,377,1736,339,1757,332,1781,300,1799,327,1732,375',alt:'A730',id:'A730'},{shape:'poly',coords:'1795,336,1790,368,1723,416,1722,385,1797,335',alt:'B725',id:'B725'},{shape:'poly',coords:'1725,420,1748,435,1839,363,1853,271,1842,250,1822,255,1822,289,1812,334,1818,350,1727,419',alt:'C720',id:'C720'},{shape:'poly',coords:'1842,368,1811,389,1809,425,1802,449,1783,468,1822,469,1829,432,1843,370',alt:'D716',id:'D716'},{shape:'poly',coords:'1808,394,1752,440,1751,454,1775,461,1787,460,1802,447,1808,418,1807,395',alt:'D715',id:'D715'},{shape:'poly',coords:'1543,548,1570,540,1574,522,1561,505,1564,488,1570,431,1570,414,1563,417,1557,428,1557,437,1552,452,1544,475,1538,488,1534,492,1526,491,1503,507,1504,522,1525,518,1534,521,1539,520',alt:'Y655',id:'Y655'},{shape:'poly',coords:'1303,494,1322,520,1311,614,1541,547,1530,522,1515,521,1500,527,1496,504,1523,486,1536,487,1544,462,1529,448,1495,473,1461,464,1365,439,1332,468,1315,469,1304,493',alt:'H615',id:'H615'},{shape:'poly',coords:'1360,378,1423,417,1437,414,1471,363,1433,329,1362,378',alt:'K552',id:'K552'},{shape:'poly',coords:'1476,268,1487,280,1492,303,1471,358,1431,324,1475,269',alt:'K553',id:'K553'},{shape:'poly',coords:'1472,368,1522,377,1544,386,1518,416,1495,435,1521,445,1495,469,1372,438,1410,417,1436,420,1471,371',alt:'H620',id:'H620'},{shape:'poly',coords:'1649,421,1673,292,1660,286,1679,248,1615,293,1593,335,1568,374,1549,385,1503,434,1532,443,1552,420,1564,397,1591,412,1602,422,1606,438,1615,435,1618,404,1631,397,1641,399,1648,418',alt:'Y660',id:'Y660'},{shape:'poly',coords:'1088,406,1087,452,1114,448,1153,457,1186,470,1202,487,1231,485,1216,412,1189,415,1158,414,1146,403,1103,402,1090,405',alt:'F450',id:'F450'},{shape:'poly',coords:'1089,359,1087,406,1101,399,1149,400,1160,411,1214,411,1240,377,1253,350,1224,343,1213,337,1191,344,1143,344,1089,358',alt:'G455',id:'G455'},{shape:'poly',coords:'1021,358,1073,362,1080,364,1083,449,1067,477,1057,523,1029,518,1018,545,984,564,981,562,1005,531,1023,453,1029,434,1005,393,1021,357,1020,356,1019,357',alt:'G430',id:'G430'},{shape:'poly',coords:'829,428,849,439,885,439,962,449,1019,457,1026,434,1003,398,958,396,920,396,906,391,897,381,885,383,872,398,853,394,831,424',alt:'G320',id:'G320'},{shape:'poly',coords:'825,427,794,417,773,401,758,425,768,453,795,463,798,496,771,507,777,519,804,527,843,525,872,524,890,540,950,568,993,527,1008,460,882,442,850,443,823,427',alt:'G315',id:'G315'},{shape:'poly',coords:'801,529,788,549,803,603,814,625,831,650,867,668,883,641,915,608,944,569,878,538,866,527,800,531',alt:'F310',id:'F310'},{shape:'poly',coords:'958,571,1011,583,1041,586,1061,619,1008,684,883,673,887,646,920,642,942,582,958,573',alt:'F420',id:'F420'},{shape:'poly',coords:'668,445,655,514,636,514,635,499,614,500,609,525,592,528,580,542,510,594,537,613,542,617,645,606,650,553,743,521,682,439,669,444',alt:'M250',id:'M250'},{shape:'poly',coords:'478,416,405,574,394,636,452,634,509,624,518,606,503,595,579,539,587,525,569,519,573,509,607,519,610,499,621,471,618,435,572,423,559,430,543,444,539,425,522,410,480,416',alt:'M210',id:'M210'},{shape:'poly',coords:'621,436,623,477,611,499,609,523,576,511,573,519,596,524,607,523,613,496,624,475,640,476,643,438,622,436',alt:'N275',id:'N275'},{shape:'poly',coords:'481,414,523,404,542,389,576,380,618,389,644,394,669,397,670,389,657,375,653,360,642,325,631,325,615,306,599,294,592,295,604,335,614,351,567,317,543,317,516,297,511,321,510,333,482,413',alt:'M215',id:'M215'},{shape:'poly',coords:'600,288,584,242,577,219,540,226,545,250,505,257,485,243,466,246,476,265,495,277,517,291,541,311,567,312,604,339,585,293,599,291',alt:'G220',id:'G220'},{shape:'poly',coords:'431,225,452,230,458,244,471,267,513,292,505,336,473,416,381,417,389,361,405,334,434,282,431,226,430,225,431,226',alt:'L160',id:'L160'},{shape:'poly',coords:'241,415,376,419,472,419,436,492,376,493,262,497,239,415',alt:'L150',id:'L150'},{shape:'poly',coords:'230,162,305,210,383,245,430,284,386,358,377,416,238,412,173,220,200,217,229,165',alt:'L155',id:'L155'},{shape:'poly',coords:'40,198,38,170,74,158,108,164,110,200,40,199',alt:'G110',id:'G110'},{shape:'poly',coords:'96,207,128,228,148,306,199,306,213,357,143,352,115,355,95,377,83,335,102,300,97,207',alt:'F105',id:'F105'}];/* Coodinates created from GIMP ImageMap; each set of coordinates maps to a field in Keaau */var KEAAU_FIELD_MAP=[{shape:'poly',coords:'235,75,320,89,371,90,369,128,239,123,233,74',alt:'H016',id:'H016'},{shape:'poly',coords:'376,91,438,82,511,57,510,127,374,125,376,90',alt:'H015',id:'H015'},{shape:'poly',coords:'517,56,554,40,595,35,649,126,514,126,517,58',alt:'H005',id:'H005'},{shape:'poly',coords:'239,127,246,215,367,214,368,130,239,126',alt:'H017',id:'H017'},{shape:'poly',coords:'373,128,511,130,509,211,372,213,374,129',alt:'H014',id:'H014'},{shape:'poly',coords:'516,130,515,213,648,212,647,129,516,131',alt:'H006',id:'H006'},{shape:'poly',coords:'653,132,654,212,700,213,653,135',alt:'H004',id:'H004'},{shape:'poly',coords:'247,219,254,300,366,302,367,217,247,220',alt:'H018',id:'H018'},{shape:'poly',coords:'373,218,372,302,508,302,509,219,374,219',alt:'H013',id:'H013'},{shape:'poly',coords:'514,219,515,302,647,304,648,217,515,217',alt:'H007',id:'H007'},{shape:'poly',coords:'652,217,700,217,752,304,654,304',alt:'H003',id:'H003'},{shape:'poly',coords:'255,304,263,390,369,390,369,306',alt:'H019',id:'H019'},{shape:'poly',coords:'373,308,509,309,510,394,374,392',alt:'H012',id:'H012'},{shape:'poly',coords:'374,395,375,476,508,477,508,396',alt:'H011',id:'H011'},{shape:'poly',coords:'514,307,647,309,648,392,515,391',alt:'H008',id:'H008'},{shape:'poly',coords:'653,308,753,308,811,393,655,394',alt:'H0002',id:'H002'},{shape:'poly',coords:'265,395,368,395,370,478,255,478',alt:'H020',id:'H020'},{shape:'poly',coords:'514,397,517,477,646,479,647,397',alt:'H009',id:'H009'},{shape:'poly',coords:'656,399,815,398,815,478,654,479',alt:'H001',id:'H001'},{shape:'poly',coords:'35,476,258,393,172,477',alt:'H025',id:'H025'},{shape:'poly',coords:'30,482,56,566,237,567,238,483',alt:'H024',id:'H024'},{shape:'poly',coords:'241,484,242,569,370,570,370,481',alt:'H021',id:'H021'},{shape:'poly',coords:'373,510,375,576,503,511',alt:'H078',id:'H078'},{shape:'poly',coords:'375,481,565,481,512,507,374,507',alt:'H010',id:'H010'},{shape:'poly',coords:'376,581,376,604,461,604,462,535',alt:'H054',id:'H054'},{shape:'poly',coords:'466,535,568,486,560,552,542,564,539,603,466,606',alt:'H055',id:'H055'},{shape:'poly',coords:'571,485,572,510,744,507,745,482,571,482',alt:'W113',id:'W113'},{shape:'poly',coords:'570,511,754,513,756,553,749,554,749,592,573,593,565,558',alt:'W111',id:'W111'},{shape:'poly',coords:'748,484,816,485,813,566,754,565,754,558,759,552,759,510,750,508',alt:'H056',id:'H056'},{shape:'poly',coords:'753,569,817,571,813,656,751,655',alt:'H057',id:'H057'},{shape:'poly',coords:'750,658,813,660,811,777,751,779',alt:'H058',id:'H058'},{shape:'poly',coords:'574,598,596,673,746,674,746,595',alt:'W110',id:'W110'},{shape:'poly',coords:'591,677,516,725,518,757,746,755,745,677',alt:'Q109',id:'Q109'},{shape:'poly',coords:'517,761,506,832,747,836,745,761',alt:'Q108',id:'Q108'},{shape:'poly',coords:'373,609,372,691,459,692,461,609',alt:'H053',id:'H053'},{shape:'poly',coords:'375,694,372,776,459,778,457,696',alt:'H052',id:'H052'},{shape:'poly',coords:'466,610,542,609,525,676,464,675,465,674',alt:'H051',id:'H051'},{shape:'poly',coords:'463,678,464,746,505,747,522,680,521,680,522,678',alt:'H114',id:'H114'},{shape:'poly',coords:'156,572,170,605,193,635,239,637,238,571',alt:'H023',id:'H023'},{shape:'poly',coords:'241,572,370,574,367,640,242,637,243,637,241,636',alt:'H022',id:'H022'},{shape:'poly',coords:'241,640,370,644,369,750,179,750,181,732,219,698,220,673,241,671',alt:'T104',id:'T104'},{shape:'poly',coords:'179,755,368,756,368,775,343,776,345,835,74,834,77,816',alt:'Z103',id:'Z103'},{shape:'poly',coords:'75,838,367,841,367,962,119,964,57,887,76,840',alt:'S102',id:'S102'},{shape:'poly',coords:'320,967,370,967,368,1013,320,1013',alt:'P112',id:'P112'},{shape:'poly',coords:'317,968,117,969,57,995,12,1057,315,1059',alt:'P101',id:'P101'},{shape:'poly',coords:'375,839,556,841,558,966,375,964',alt:'D107',id:'D107'},{shape:'poly',coords:'562,842,747,843,746,967,565,966',alt:'C107',id:'C107'},{shape:'poly',coords:'375,969,373,1017,438,1022,457,1030,456,1044,746,1049,745,972',alt:'B106',id:'B106'},{shape:'poly',coords:'459,1047,672,1053,712,1081,710,1094,694,1096,683,1110,661,1108,639,1131,460,1129',alt:'A105',id:'A105'}];/* END */

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = DatePicker;
/* harmony export (immutable) */ __webpack_exports__["d"] = DatePicker2;
/* unused harmony export ClockPicker */
/* harmony export (immutable) */ __webpack_exports__["o"] = TimePicker2;
/* harmony export (immutable) */ __webpack_exports__["f"] = TextInput;
/* harmony export (immutable) */ __webpack_exports__["m"] = PasswordInput;
/* harmony export (immutable) */ __webpack_exports__["g"] = NumberInput;
/* harmony export (immutable) */ __webpack_exports__["a"] = Select;
/* harmony export (immutable) */ __webpack_exports__["i"] = SelectField;
/* harmony export (immutable) */ __webpack_exports__["j"] = SelectBlock;
/* unused harmony export SelectMultipleField */
/* harmony export (immutable) */ __webpack_exports__["p"] = SelectCostCenter;
/* harmony export (immutable) */ __webpack_exports__["q"] = SelectSubAccount;
/* harmony export (immutable) */ __webpack_exports__["r"] = SelectEquipment;
/* unused harmony export SelectPayPeriod */
/* harmony export (immutable) */ __webpack_exports__["n"] = FloatingButton;
/* harmony export (immutable) */ __webpack_exports__["k"] = Textarea;
/* harmony export (immutable) */ __webpack_exports__["e"] = AutoComplete;
/* unused harmony export FileButton */
/* harmony export (immutable) */ __webpack_exports__["c"] = RadioButton;
/* harmony export (immutable) */ __webpack_exports__["b"] = CheckBox;
/* harmony export (immutable) */ __webpack_exports__["h"] = HiddenInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/***************************************************************
5/22/2017
Alexander Self
Inputs
- Different form inputs
***************************************************************/var $=window.$;/* Must call document.ready to invoke Datepicker */function DatePicker(_ref){var id=_ref.id,label=_ref.label,min=_ref.min,max=_ref.max,disabled=_ref.disabled;$(document).ready(function(){$('#'+id).pickadate({selectMonths:true,// Creates a dropdown to control month
selectYears:2,// Creates a dropdown of 15 years to control year
format:'yyyy-mm-dd',min:min,max:max});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,type:'text',className:'datepicker',disabled:disabled}));}function DatePicker2(_ref2){var id=_ref2.id,label=_ref2.label,min=_ref2.min,max=_ref2.max,disabled=_ref2.disabled,defaultValue=_ref2.defaultValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',id:id,disabled:disabled,min:min,max:max,defaultValue:defaultValue}));}function ClockPicker(_ref3){var id=_ref3.id,label=_ref3.label;$(document).ready(function(){$('#'+id).pickatime({autoclose:false,twelvehour:true});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,className:'timepicker',type:'time'}));}function TimePicker2(_ref4){var id=_ref4.id,label=_ref4.label,defaultValue=_ref4.defaultValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,type:'time',defaultValue:defaultValue}));}function TextInput(_ref5){var id=_ref5.id,label=_ref5.label,defaultValue=_ref5.defaultValue,placeholder=_ref5.placeholder,onChange=_ref5.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,type:'text',defaultValue:defaultValue,placeholder:placeholder,onChange:onChange}));}function PasswordInput(_ref6){var id=_ref6.id,label=_ref6.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,type:'password'}));}function NumberInput(_ref7){var id=_ref7.id,label=_ref7.label,min=_ref7.min,max=_ref7.max,step=_ref7.step,value=_ref7.value,onChange=_ref7.onChange,defaultValue=_ref7.defaultValue,placeholder=_ref7.placeholder,disabled=_ref7.disabled,_class=_ref7._class,_inputClass=_ref7._inputClass,name=_ref7.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:_class},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:_inputClass,id:id,type:'number',min:min,max:max,step:step,value:value,onChange:onChange,defaultValue:defaultValue,placeholder:placeholder,disabled:disabled,name:name}));}function Select(_ref8){var id=_ref8.id,opts=_ref8.opts,label=_ref8.label,onChange=_ref8.onChange,defaultValue=_ref8.defaultValue;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default',defaultValue:defaultValue,onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{id:opt.label,key:opt.label,value:opt.val},opt.label);})));}/* Specifically for the fields
  Set selected as true for default value
*/function SelectField(_ref9){var id=_ref9.id,opts=_ref9.opts,label=_ref9.label,onChange=_ref9.onChange,selected=_ref9.selected,defaultValue=_ref9.defaultValue;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default',onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),opts.map(function(opt){if(selected&&opt.field===defaultValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.field,value:opt.field,selected:true},opt.field);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.field,value:opt.field},opt.field);})));}/* Specifically for the fields */function SelectBlock(_ref10){var id=_ref10.id,opts=_ref10.opts,label=_ref10.label;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.block,value:opt.block},opt.block);})));}/* Specifically for multiple fields */function SelectMultipleField(_ref11){var id=_ref11.id,opts=_ref11.opts,label=_ref11.label;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,multiple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.field,value:opt.field},opt.field);})));}/* Specifically for the cost centers */function SelectCostCenter(_ref12){var id=_ref12.id,opts=_ref12.opts,label=_ref12.label,onChange=_ref12.onChange;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default',onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.id,value:opt.costNo+'-'+opt.department+'-'+opt.location},opt.costNo,' - ',opt.department,' (',opt.location,')');})));}/* Specifically for the subaccounts */function SelectSubAccount(_ref13){var id=_ref13.id,opts=_ref13.opts,label=_ref13.label,onChange=_ref13.onChange;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default',onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.accountNo,id:opt.accountDesc,value:opt.accountNo},'(',opt.costCenter,') ',opt.subAccountNo,' - ',opt.accountDesc);})));}/* Specifically for the equipment */function SelectEquipment(_ref14){var id=_ref14.id,opts=_ref14.opts,label=_ref14.label;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.id,value:opt.equipmentNo},opt.equipmentNo,' - ',opt.description,' (',opt.companyCode,')');})));}/* Specifically for the payperiods */function SelectPayPeriod(_ref15){var id=_ref15.id,opts=_ref15.opts,label=_ref15.label,onChange=_ref15.onChange;$(document).ready(function(){$('#'+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'browser-default',onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:''}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:opt.id,value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(opt.startDate).format('YYYY-MM-DD')+'/'+__WEBPACK_IMPORTED_MODULE_1_moment___default()(opt.endDate).format('YYYY-MM-DD')},__WEBPACK_IMPORTED_MODULE_1_moment___default()(opt.startDate).format('YYYY-MM-DD')+' -> '+__WEBPACK_IMPORTED_MODULE_1_moment___default()(opt.endDate).format('YYYY-MM-DD'));})));}function FloatingButton(_ref16){var color=_ref16.color,icon=_ref16.icon,onclick=_ref16.onclick,disabled=_ref16.disabled,id=_ref16.id;if(disabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'btn-floating waves-effect waves-light '+color,onClick:onclick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},icon));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:id,className:'btn-floating waves-effect waves-light '+color,onClick:onclick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},icon));}function Textarea(_ref17){var id=_ref17.id,label=_ref17.label;$(document).ready(function(){$('textarea#'+id).characterCounter();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:id,className:'materialize-textarea','data-length':'350'}));}/* Materialze autocomplete: pass in onComplete callback to get value + id */function AutoComplete(_ref18){var id=_ref18.id,label=_ref18.label,data=_ref18.data,onComplete=_ref18.onComplete,disabled=_ref18.disabled;$(document).ready(function(){$('#'+id).autocomplete({data:data,limit:10,minLength:1,onAutocomplete:function onAutocomplete(val){onComplete(val,id);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:id,className:'autocomplete',disabled:disabled}));}/* Basic file button */function FileButton(_ref19){var id=_ref19.id,name=_ref19.name,label=_ref19.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-field input-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn btn-flat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,name:name,type:'file'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-path-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'file-path',className:'file-path validate',type:'text'})));}function RadioButton(_ref20){var id=_ref20.id,name=_ref20.name,label=_ref20.label,disabled=_ref20.disabled,onClick=_ref20.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,name:name,type:'radio',disabled:disabled,onClick:onClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label));}function CheckBox(_ref21){var id=_ref21.id,name=_ref21.name,label=_ref21.label,disabled=_ref21.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,name:name,type:'checkbox',disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},label));}function HiddenInput(_ref22){var id=_ref22.id,value=_ref22.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,type:'hidden',value:value}));}/* END */

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(29);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = packageForm;
/* harmony export (immutable) */ __webpack_exports__["f"] = fillForm;
/* harmony export (immutable) */ __webpack_exports__["h"] = handleRecommendedDosage;
/* harmony export (immutable) */ __webpack_exports__["i"] = handleMaxQuantity;
/* harmony export (immutable) */ __webpack_exports__["g"] = resetForm;
/* harmony export (immutable) */ __webpack_exports__["y"] = determineIcon;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapEmployeeForAutoComplete;
/* harmony export (immutable) */ __webpack_exports__["v"] = mapPropForAutoComplete;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateID; });
/* harmony export (immutable) */ __webpack_exports__["d"] = checkApplicationForm;
/* harmony export (immutable) */ __webpack_exports__["x"] = parseDosage;
/* harmony export (immutable) */ __webpack_exports__["l"] = findEmployeeByName;
/* harmony export (immutable) */ __webpack_exports__["w"] = setDosage;
/* harmony export (immutable) */ __webpack_exports__["s"] = calculateHoursFromTime;
/* harmony export (immutable) */ __webpack_exports__["t"] = calculatePercentage;
/* harmony export (immutable) */ __webpack_exports__["u"] = convertToGalAndSum;
/* unused harmony export percentComplete */
/* unused harmony export handleBalance */
/* harmony export (immutable) */ __webpack_exports__["m"] = acresBalance;
/* harmony export (immutable) */ __webpack_exports__["n"] = acresPerHour;
/* harmony export (immutable) */ __webpack_exports__["r"] = tonsPerHour;
/* harmony export (immutable) */ __webpack_exports__["q"] = tonsPerAcre;
/* harmony export (immutable) */ __webpack_exports__["j"] = sumProp;
/* unused harmony export avgProp */
/* harmony export (immutable) */ __webpack_exports__["o"] = onDummyComplete;
/* harmony export (immutable) */ __webpack_exports__["k"] = filterOldRecords;
/* harmony export (immutable) */ __webpack_exports__["a"] = filterArrayByPropAndValue;
/* harmony export (immutable) */ __webpack_exports__["p"] = uniqueElementsByRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_convert_units__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_convert_units___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_convert_units__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_constants__ = __webpack_require__(21);
/**
* packageForm(): Packages form element values with dashes in ids
* @param {String} id, id of form
* @returns {Object} formObj, key value form object
* @called-in: ['/components/chemical/chemical_form.js]
**/function packageForm(id){var elements=document.getElementById(''+id).elements;var formObj={};// eslint-disable-next-line
for(var i=0,element;element=elements[i++];){if(element.id==="")continue;if(element.id.split('-').length===2){if(element.checked)formObj[element.name.split('-')[1]]=element.value;else if(element.type==='radio'&&!element.checked)continue;else if(element.type==='checkbox'&&!element.checked)continue;else formObj[element.id.split('-')[1]]=element.value;}}return formObj;}/**
* fillForm(): Pre-fills form
* @param {String} formId, id of form
* @param {Object} formData, data to prefill into form
* @returns
* @called-in: ['/components/chemical/chemical_form.js]
**/function fillForm(formId,formData){var editForm=document.getElementById(formId).elements;// eslint-disable-next-line
for(var i=0,element;element=editForm[i++];){if(element.id==="")continue;var id=element.id.split('-')[1];for(var key in formData){if(key===id){if(element.type==='file')continue;if(element.type==='date')element.value=formData[key].split('T')[0];else element.value=formData[key];}// Chemical Application
if(element.id==='chemApp-kau'&&formData[key]===71)element.checked=true;if(element.id==='chemApp-keaau'&&formData[key]===72)element.checked=true;if(element.id==='chemApp-isCompleteYes'&&key==='isComplete'){if(formData[key]===1)element.checked=true;}if(element.id==='chemApp-isCompleteNo'&&key==='isComplete'){if(formData[key]===0)element.checked=true;}if(element.id==='chemApp-methodAirblast'&&formData[key]==='Airblast')element.checked=true;if(element.id==='chemApp-methodBroadcast'&&formData[key]==='Broadcast')element.checked=true;if(element.id==='chemApp-methodSpot'&&formData[key]==='Spot')element.checked=true;// Fertilizer
if(element.id==='fert-kau'&&Number(formData[key])===71)element.checked=true;if(element.id==='fert-keaau'&&Number(formData[key])===72)element.checked=true;if(element.id==='fert-isCompleteYes'&&key==='isComplete'){if(formData[key]===1)element.checked=true;}if(element.id==='fert-isCompleteNo'&&key==='isComplete'){if(formData[key]===0)element.checked=true;}// Mowing
if(element.id==='mow-kau'&&Number(formData[key])===71)element.checked=true;if(element.id==='mow-keaau'&&Number(formData[key])===72)element.checked=true;if(element.id==='mow-isCompleteYes'&&key==='isComplete'){if(formData[key]===1)element.checked=true;}if(element.id==='mow-isCompleteNo'&&key==='isComplete'){if(formData[key]===0)element.checked=true;}// Tree Inventory
if(element.id==='treeInvEdit-kau'&&Number(formData[key])===71)element.checked=true;if(element.id==='treeInvEdit-keaau'&&Number(formData[key])===72)element.checked=true;if(element.name==='treeInvEdit-approver'&&key==='approver'){if(formData[key]===element.value)element.checked=true;}if(element.id.match(/treeReplant[0-9]-kau/)&&Number(formData[key])===71)element.checked=true;if(element.id.match(/treeReplant[0-9]-keaau/)&&Number(formData[key])===72)element.checked=true;}}return;}/**
* handleRecommendedDosage(): Pre-fills form
* @param {r} recommended dosage
* @returns
* @called-in: ['cult_utils']
**/function handleRecommendedDosage(r){if(r===null||r==='')return;var rec1=document.getElementById('chemical-recoDosage1');var rec2=document.getElementById('chemical-recoDosage2');var rec3=document.getElementById('chemical-recoDosage3');var rec4=document.getElementById('chemical-recoDosage4');var rec=r.split(' ');rec1.value=rec[0];rec2.value=rec[1];rec3.value=rec[3];rec4.value=rec[4];return;}/**
* handleMaxQuantity(): Pre-fills form
* @param {r} maxQuantity
* @returns
* @called-in: ['cult_utils']
**/function handleMaxQuantity(r){if(r===null||r==='')return;var rec1=document.getElementById('chemical-maxQuantity');var rec2=document.getElementById('chemical-maxQuantityUnit');var rec=r.split(' ');rec1.value=rec[0];rec2.value=rec[1];return;}/**
* resetForm(): Resets a form
* @param {String} formId, id of form
* @returns
* @called-in: ['/components/chemical/chemical_form.js]
**/function resetForm(id){document.getElementById(id).reset();return;}/**
* determineIcon(): Determines the icon and color based on type
* @param {String} type, type of product
* @returns {Object} color, type
* @called-in: ['/components/chemical/product_view.js]
**/function determineIcon(type){switch(type){case'Herbicide':return{color:'green',icon:'filter_vintage'};case'Pesticide':return{color:'red',icon:'bug_report'};case'Fertilizer':return{color:'purple',icon:'local_florist'};case'Fungicide':return{color:'grey',icon:'colorize'};case'Nutrient':return{color:'cyan',icon:'healing'};case'Miticide':return{color:'teal',icon:'bug_report'};case'Bactericide':return{color:'light-green',icon:'leak_add'};case'Adjuvent':return{color:'lime',icon:'gradient'};default:return{color:'light-blue',icon:'folder'};}}/**
* mapEmployeeForAutoComplete(): Autocomplete function
* @param {Array} data, array of employees
* @returns {Object} object of names
* @called-in: ['/components/chemical/product_view.js]
**/function mapEmployeeForAutoComplete(data){var dataObj={};for(var i=0;i<data.length;i++){dataObj[data[i].firstName+' '+data[i].lastName]=null;}return dataObj;}/**
* mapPropForAutoComplete(): Autocomplete function
* @param {Array} data, array of employees
* @returns {Object} object of names
* @called-in: ['/components/chemical/product_view.js]
**/function mapPropForAutoComplete(data,prop){var dataObj={};for(var i=0;i<data.length;i++){dataObj[data[i][prop]]=null;}return dataObj;}/**
* generateID(): Generates a unique general purpose ID
* @returns {String} uuid: unique id
* @called-in: ['/actions/chem_app_actions.js]
**/var generateID=function generateID(){var d=new Date().getTime();if(window.performance&&typeof window.performance.now==="function"){d+=performance.now();//use high-precision timer if available
}var uuid='xxxxxxxxx'.replace(/[xy]/g,function(c){var r=(d+Math.random()*16)%16|0;d=Math.floor(d/16);// eslint-disable-next-line
return(c=='x'?r:r&0x3|0x8).toString(16);});return uuid;};function checkApplicationForm(form){for(var key in form){if(key==='notes'||key==='comments')continue;if(form[key]==='')return true;}return false;}/**
* parseDosage(): Parses the recommended dosage: [number] [unit] / [number] [unit]
* @param {Object} chemicalList item
* @returns {Object} parsed values and units
* @called-in: ['/components/chem_app/chem_app_form.js]
**/function parseDosage(c){if(c===undefined||c===null)return{num1:'',unit1:'',num2:'',unit2:''};if(Object.keys(c).length===0)return{num1:'',unit1:'',num2:'',unit2:''};var r=c.recoDosage.split(' ');return{num1:r[0],unit1:r[1],num2:r[3],unit2:r[4]};}/*
  Find a particular employee by first and last name
  returning only the find function will return duplicates every time.
  @called-in: ['/actions/harvest_actions.js']
*/function findEmployeeByName(name,employees){if(!name)return{eid:''};var emp=void 0;emp=employees.find(function(e){return e.firstName+' '+e.lastName===name;});return emp;}/**
* setDosage(): Sets the recommended dosage: [number] [unit] / [number] [unit] in a form
* @param {Object} chemicalList item
* @param {String} quantId: dom id of quantity
* @param {String} unitId: dom id of unit
* @param {String} totalId: dom id of total solution
* @returns
* @called-in: ['/components/chem_app/chem_app_form.js]
**/function setDosage(_ref){var dosage=_ref.dosage,quantId=_ref.quantId,unitId=_ref.unitId;document.getElementById(quantId).value=dosage.num1;document.getElementById(unitId).value=dosage.unit1;return;}/* Calculates the difference between two timestamps */function calculateHoursFromTime(_ref2){var date=_ref2.date,startTime=_ref2.startTime,endTime=_ref2.endTime;if(!(startTime&&endTime))return 0.00;var s=__WEBPACK_IMPORTED_MODULE_1_moment___default()(date+' '+startTime);var e=__WEBPACK_IMPORTED_MODULE_1_moment___default()(date+' '+endTime);return Math.abs(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(e.diff(s)).as('hours')).toFixed(2);}/* Calculates the percentage of a chemical used in a gallon based tanker */function calculatePercentage(_ref3){var quantity=_ref3.quantity,unit=_ref3.unit,totalGallons=_ref3.totalGallons;if(!(quantity&&unit)||totalGallons===0)return 0.00;if(__WEBPACK_IMPORTED_MODULE_2__cult_constants__["a" /* UNITS_OF_MEASURE */].find(function(u){return u.value===unit&&u.type==='mass';})){return(Number(quantity)/Number(totalGallons)*100).toFixed(5);}return(Number(__WEBPACK_IMPORTED_MODULE_0_convert_units___default()(quantity).from(unit).to('gal'))/Number(totalGallons)*100).toFixed(5);}/* Sums any measurement unit type to gallons */function convertToGalAndSum(arr){if(!arr)return 0.00;if(arr[0].hasOwnProperty('chemDosage')){var _total=arr.reduce(function(acc,cur){var n=cur.chemDosage.split(' ')[0];return acc+Number(n);},0);return _total;}var total=arr.reduce(function(acc,cur){if(__WEBPACK_IMPORTED_MODULE_2__cult_constants__["a" /* UNITS_OF_MEASURE */].find(function(u){return u.value===cur.chemDosage2&&u.type==='mass';}))return acc+0;return acc+Number(__WEBPACK_IMPORTED_MODULE_0_convert_units___default()(cur.chemDosage1).from(cur.chemDosage2).to('gal'));},0);return total;}/* Calculates the percentage of acres completed */function percentComplete(acresCompleted,totalAcres){if(!(acresCompleted&&totalAcres))return 0.00;return(acresCompleted/totalAcres).toFixed(2);}/* Displays the balance of remaining acres */function handleBalance(previousHarvest,selectedField){if(!(previousHarvest&&selectedField))return 0.0;var existingAcres=previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);return(selectedField.mechHarvest-existingAcres).toFixed(2);}/* Calculates the acres completed based on tree count input */function acresBalance(acresCompleted,acresRemaining){if(!(acresCompleted&&acresRemaining))return 0.00;return(Number(acresRemaining)-Number(acresCompleted)).toFixed(2);}/* Calculates acres per hour */function acresPerHour(hours,acres){if(!(acres&&hours))return 0.00;return(Number(acres)/Number(hours)).toFixed(2);}/* Calculates tons per hour: Fertilizer */function tonsPerHour(tons,hours){if(!(tons&&hours))return 0.00;return(Number(tons)/Number(hours)).toFixed(2);}/* Calculates tons per acre: Fertilizer */function tonsPerAcre(tons,acres){if(!(tons&&acres))return 0.00;return(Number(tons)/Number(acres)).toFixed(2);}/* Sums a selected property of an array */function sumProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return total.toFixed(2);}/* Averages a selected property of an array */function avgProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return(total/arr.length).toFixed(2);}/* Dummy function */function onDummyComplete(){return;}/**
* filterOldRecords(): Filters records that are older than two weeks. Uses date property
* @param {Object} r: record with date prop
* @returns {Bool} filtered condition
* @called-in: ['/components/chem_app/chem_app_create.js]
**/function filterOldRecords(r){return Math.abs(__WEBPACK_IMPORTED_MODULE_1_moment___default()(r.date).week()-__WEBPACK_IMPORTED_MODULE_1_moment___default()().week())<=1;}/**
* filterArrayByPropAndValue(): Filters records by property and value
* @param {Object} r: record with date prop
* @returns {Bool} filtered condition
* @called-in: ['/components/tree_replant/tree_replant.js]
**/function filterArrayByPropAndValue(arr,prop,value){return arr.filter(function(item){return item[prop]===value;});}/**
* uniqueElementsByRight(): Returns all unique values of an array, based on a provided comparator function, starting from the right.
* @param {Array} arr: array
* @param {Function} fn: function for comparison
* @returns {Bool} filtered condition
* @called-in: ['actions/fertilizer_actions.js'];
**/function uniqueElementsByRight(arr,fn){return arr.reduceRight(function(acc,v){if(!acc.some(function(x){return fn(v,x);}))acc.push(v);return acc;},[]);}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMProperty = __webpack_require__(49);
var ReactDOMComponentFlags = __webpack_require__(216);

var invariant = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SIGNIN_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AUTH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return UNAUTH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_PAY_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return SET_MAP_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return SET_FIELD_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return SET_MAP_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return FETCH_FIELD_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return FETCH_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_TIMESHEET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCH_SUBACCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_FIELDS_BY_LOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCH_BLOCKS_BY_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_TIMESHEETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_MY_TIMESHEETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_EMPLOYEE_TIMESHEETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return FETCH_TIMESHEET_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_TIMESHEETS_TO_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ADD_EMPLOYEE_TO_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return REMOVE_EMPLOYEE_FROM_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ADD_WORK_TO_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return REMOVE_WORK_FROM_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ADD_EMPLOYEE_TO_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return PREPARE_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return PREPARE_REG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SUBMIT_REG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SUBMIT_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_TIMESHEET_DATES_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return ADD_WORK_TO_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return ADD_HARVEST_TO_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return REMOVE_WORK_FROM_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return REMOVE_HARVEST_FROM_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return PREPARE_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SUBMIT_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DELETE_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return EMPLOYEE_AUTOCOMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DOWNLOAD_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SELECT_GANG_FOR_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SELECT_GANG_FOR_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return FETCH_MY_EMPLOYEES_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return ADD_NEW_GANG_INFO_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SELECT_COST_CENTER_BY_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return EDIT_WORK_IN_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return EDIT_WORK_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return EDIT_WORK_IN_EDIT_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return EDIT_WORK_RECORD_EDIT_TS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ADD_WORK_TO_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return EDIT_WORK_IN_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EDIT_GANG_WORK_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DELETE_WORK_IN_GANG_TIMESHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SELECT_HARVEST_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return EDIT_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return AUTOFILL_GANG_TIMESHEET; });
/* unused harmony export CREATE_SCHEDULE */
/* unused harmony export ADD_EMPLOYEE_TO_SCHEDULE */
/* unused harmony export REMOVE_EMPLOYEE_FROM_SCHEDULE */
/* unused harmony export ADD_DAILY_WORK_TO_SCHEDULE */
/* unused harmony export REMOVE_DAILY_WORK_FROM_SCHEDULE */
/* unused harmony export PREPARE_SCHEDULE */
/* unused harmony export SUBMIT_SCHEDULE */
/* unused harmony export FETCH_SCHEDULE */
/* unused harmony export SET_EMPLOYEE_PRESENCE */
/* unused harmony export RESET_EMPLOYEE_PRESENCE */
/* unused harmony export SUBMIT_EMPLOYEE_PRESENCE */
/* unused harmony export FETCH_SCHEDULES_TO_EDIT */
/* unused harmony export FETCH_SCHEDULE_TO_EDIT */
/* unused harmony export FETCH_EMPLOYEES_FOR_SCHEDULE */
/* unused harmony export ADD_EMPLOYEE_TO_EDIT_SCHEDULE */
/* unused harmony export REMOVE_EMPLOYEE_FROM_EDIT_SCHEDULE */
/* unused harmony export ADD_DAILY_WORK_TO_EDIT_SCHEDULE */
/* unused harmony export REMOVE_DAILY_WORK_FROM_EDIT_SCHEDULE */
/* unused harmony export PREPARE_EDIT_SCHEDULE */
/* unused harmony export SUBMIT_EDITED_SCHEDULE */
/* unused harmony export DELETE_SCHEDULE */
/* unused harmony export ADD_GANG_TO_SCHEDULE */
/* unused harmony export ADD_GANG_TO_EDIT_SCHEDULE */
/* unused harmony export FETCH_MY_EMPLOYEES_SCHEDULE */
/* unused harmony export VIEW_MY_SCHEDULED_EMPLOYEES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return ADD_GANG_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return REMOVE_GANG_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return GANG_AUTOCOMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CREATE_GANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return FETCH_GANGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SELECT_GANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SELECT_GANG_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return ADD_GANG_MEMBER_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return REMOVE_GANG_MEMBER_FROM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return EDIT_GANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return GANG_EDIT_AUTOCOMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return DELETE_GANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return FETCH_EMPLOYEE_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return FETCH_LEVEL_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return FETCH_EMPLOYEE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SUBMIT_EDIT_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CREATE_EMPLOYEE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return FETCH_POSITION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CREATE_LOGIN_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SUBMIT_EDIT_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return DOWNLOAD_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return FETCH_DASHBOARD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return FETCH_INFO_BY_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return ENLARGE_GRAPHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return FETCH_HEADCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return SORT_BY_OPERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return FETCH_HOURS_BY_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return FETCH_MISSING_TIMESHEETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return FETCH_EQUIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return SELECT_EQUIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SELECT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_MECH_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_MECH_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_MY_MECH_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PREPARE_MECH_HARVEST_TO_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PREPARE_MECH_HARVEST_TO_CREATE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PREPARE_MECH_HARVEST_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PREPARE_MECH_HARVEST_TO_EDIT_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SELECT_REPORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_REPORT_OPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SELECT_NEW_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SELECT_HARVEST_TO_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_MANAGE_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_HARVEST_BY_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_MECH_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_MECH_HARVEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ADD_HARVEST_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_MECH_HARVEST_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EDIT_MECH_HARVEST_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DELETE_MECH_HARVEST_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return UPDATE_SELECTED_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return UPDATE_PREFILL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return UPDATE_OPTIONAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return NOTIFICATION_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return UPDATE_SELECTED_GANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return TOAST_DISPLAYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return UPDATE_MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return UPDATE_CHIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return REMOVE_CHIP; });
/* unused harmony export NOTIFY_SELECTED_EMPLOYEES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return FETCH_GANGS_FOR_SMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return FETCH_LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SEARCH_MESSAGES_DATABASE; });
/******************************************************************
  Alexander Self
  Redux Actions
  - Any action that takes place throughout the application should be created here
*******************************************************************//* Auth Actions */var SIGNIN_USER='SIGNIN_USER',AUTH_USER='AUTH_USER',UNAUTH_USER='UNAUTH_USER',AUTH_ERROR='AUTH_ERROR',FETCH_USER_PROFILE='FETCH_USER_PROFILE';/* Misc Actions */var FETCH_PAY_PERIOD='FETCH_PAY_PERIOD',NULL='NULL';/* Map Actions */var SET_MAP_VIEW='SET_MAP_VIEW',SET_FIELD_VIEW='SET_FIELD_VIEW',SET_MAP_LOCATION='SET_MAP_LOCATION',FETCH_FIELD_INFORMATION='FETCH_FIELD_INFORMATION';/* Timesheet Actions */var ERROR='ERROR',FETCH_MESSAGE='FETCH_MESSAGE',FETCH_TIMESHEET_DATA='FETCH_TIMESHEET_DATA',FETCH_SUBACCOUNTS='FETCH_SUBACCOUNTS',FETCH_FIELDS_BY_LOC='FETCH_FIELDS_BY_LOC',FETCH_BLOCKS_BY_FIELD='FETCH_BLOCKS_BY_FIELD',FETCH_TIMESHEETS='FETCH_TIMESHEETS',FETCH_MY_TIMESHEETS='FETCH_MY_TIMESHEETS',FETCH_EMPLOYEE_TIMESHEETS='FETCH_EMPLOYEE_TIMESHEETS',FETCH_TIMESHEET_TO_EDIT='FETCH_TIMESHEETS_TO_EDIT',FETCH_TIMESHEETS_TO_DELETE='FETCH_TIMESHEETS_TO_DELETE',ADD_EMPLOYEE_TO_TIMESHEET='ADD_EMPLOYEE_TO_TIMESHEET',REMOVE_EMPLOYEE_FROM_TIMESHEET='REMOVE_EMPLOYEE_FROM_TIMESHEET',ADD_WORK_TO_TIMESHEET='ADD_WORK_TO_TIMESHEET',REMOVE_WORK_FROM_TIMESHEET='REMOVE_WORK_FROM_TIMESHEET',ADD_EMPLOYEE_TO_GANG_TIMESHEET='ADD_EMPLOYEE_TO_GANG_TIMESHEET',REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET='REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET',PREPARE_GANG_TIMESHEET='PREPARE_GANG_TIMESHEET',PREPARE_REG_TIMESHEET='PREPARE_REG_TIMESHEET',SUBMIT_REG_TIMESHEET='SUBMIT_REG_TIMESHEET',SUBMIT_GANG_TIMESHEET='SUBMIT_GANG_TIMESHEET',GET_TIMESHEET_DATES_TO_EDIT='GET_TIMESHEET_DATES_TO_EDIT',ADD_WORK_TO_EDIT_TIMESHEET='ADD_WORK_TO_EDIT_TIMESHEET',ADD_HARVEST_TO_EDIT_TIMESHEET='ADD_HARVEST_TO_EDIT_TIMESHEET',REMOVE_WORK_FROM_EDIT_TIMESHEET='REMOVE_WORK_FROM_EDIT_TIMESHEET',REMOVE_HARVEST_FROM_EDIT_TIMESHEET='REMOVE_HARVEST_FROM_EDIT_TIMESHEET',PREPARE_EDIT_TIMESHEET='PREPARE_EDIT_TIMESHEET',SUBMIT_EDIT_TIMESHEET='SUBMIT_EDIT_TIMESHEET',DELETE_TIMESHEET='DELETE_TIMESHEET',EMPLOYEE_AUTOCOMPLETE='EMPLOYEE_AUTOCOMPLETE',DOWNLOAD_TIMESHEET='DOWNLOAD_TIMESHEET',SELECT_GANG_FOR_TIMESHEET='SELECT_GANG_FOR_TIMESHEET',SELECT_GANG_FOR_GANG_TIMESHEET='SELECT_GANG_FOR_GANG_TIMESHEET',FETCH_MY_EMPLOYEES_TIMESHEET='FETCH_MY_EMPLOYEES_TIMESHEET',ADD_NEW_GANG_INFO_ROW='ADD_NEW_GANG_INFO_ROW',SELECT_COST_CENTER_BY_LOCATION='SELECT_COST_CENTER_BY_LOCATION',EDIT_WORK_IN_TIMESHEET='EDIT_WORK_IN_TIMESHEET',EDIT_WORK_RECORD='EDIT_WORK_RECORD',EDIT_WORK_IN_EDIT_TIMESHEET='EDIT_WORK_IN_EDIT_TIMESHEET',EDIT_WORK_RECORD_EDIT_TS='EDIT_WORK_RECORD_EDIT_TS',ADD_WORK_TO_GANG_TIMESHEET='ADD_WORK_TO_GANG_TIMESHEET',EDIT_WORK_IN_GANG_TIMESHEET='EDIT_WORK_IN_GANG_TIMESHEET',EDIT_GANG_WORK_RECORD='EDIT_GANG_WORK_RECORD',DELETE_WORK_IN_GANG_TIMESHEET='DELETE_WORK_IN_GANG_TIMESHEET',SELECT_HARVEST_TO_EDIT='SELECT_HARVEST_TO_EDIT',EDIT_HARVEST='EDIT_HARVEST',AUTOFILL_GANG_TIMESHEET='AUTOFILL_GANG_TIMESHEET';/* Schedule Actions */var CREATE_SCHEDULE='CREATE_SCHEDULE',ADD_EMPLOYEE_TO_SCHEDULE='ADD_EMPLOYEE_TO_SCHEDULE',REMOVE_EMPLOYEE_FROM_SCHEDULE='REMOVE_EMPLOYEE_FROM_SCHEDULE',ADD_DAILY_WORK_TO_SCHEDULE='ADD_DAILY_WORK_TO_SCHEDULE',REMOVE_DAILY_WORK_FROM_SCHEDULE='REMOVE_DAILY_WORK_FROM_SCHEDULE',PREPARE_SCHEDULE='PREPARE_SCHEDULE',SUBMIT_SCHEDULE='SUBMIT_SCHEDULE',FETCH_SCHEDULE='FETCH_SCHEDULE',SET_EMPLOYEE_PRESENCE='SET_EMPLOYEE_PRESENCE',RESET_EMPLOYEE_PRESENCE='RESET_EMPLOYEE_PRESENCE',SUBMIT_EMPLOYEE_PRESENCE='SUBMIT_EMPLOYEE_PRESENCE',FETCH_SCHEDULES_TO_EDIT='FETCH_SCHEDULES_TO_EDIT',FETCH_SCHEDULE_TO_EDIT='FETCH_SCHEDULE_TO_EDIT',FETCH_EMPLOYEES_FOR_SCHEDULE='FETCH_EMPLOYEES_FOR_SCHEDULE',ADD_EMPLOYEE_TO_EDIT_SCHEDULE='ADD_EMPLOYEE_TO_EDIT_SCHEDULE',REMOVE_EMPLOYEE_FROM_EDIT_SCHEDULE='REMOVE_EMPLOYEE_FROM_EDIT_SCHEDULE',ADD_DAILY_WORK_TO_EDIT_SCHEDULE='ADD_DAILY_WORK_TO_EDIT_SCHEDULE',REMOVE_DAILY_WORK_FROM_EDIT_SCHEDULE='REMOVE_DAILY_WORK_FROM_EDIT_SCHEDULE',PREPARE_EDIT_SCHEDULE='PREPARE_EDIT_SCHEDULE',SUBMIT_EDITED_SCHEDULE='SUBMIT_EDITED_SCHEDULE',DELETE_SCHEDULE='DELETE_SCHEDULE',ADD_GANG_TO_SCHEDULE='ADD_GANG_TO_SCHEDULE',ADD_GANG_TO_EDIT_SCHEDULE='ADD_GANG_TO_EDIT_SCHEDULE',FETCH_MY_EMPLOYEES_SCHEDULE='FETCH_MY_EMPLOYEES_SCHEDULE',VIEW_MY_SCHEDULED_EMPLOYEES='VIEW_MY_SCHEDULED_EMPLOYEES';/* Gang Builder Actions */var ADD_GANG_MEMBER='ADD_GANG_MEMBER',REMOVE_GANG_MEMBER='REMOVE_GANG_MEMBER',GANG_AUTOCOMPLETE='GANG_AUTOCOMPLETE',CREATE_GANG='CREATE_GANG',FETCH_GANGS='FETCH_GANGS',SELECT_GANG='SELECT_GANG',SELECT_GANG_TO_EDIT='SELECT_GANG_TO_EDIT',ADD_GANG_MEMBER_TO_EDIT='ADD_GANG_MEMBER_TO_EDIT',REMOVE_GANG_MEMBER_FROM_EDIT='REMOVE_GANG_MEMBER_FROM_EDIT',EDIT_GANG='EDIT_GANG',GANG_EDIT_AUTOCOMPLETE='GANG_EDIT_AUTOCOMPLETE',DELETE_GANG='DELETE_GANG';/* Profile Actions */var FETCH_EMPLOYEE_TO_EDIT='FETCH_EMPLOYEE_TO_EDIT',FETCH_LEVEL_EMPLOYEES='FETCH_LEVEL_EMPLOYEES',FETCH_EMPLOYEE_PROFILE='FETCH_EMPLOYEE_PROFILE',SUBMIT_EDIT_PROFILE='SUBMIT_EDIT_PROFILE',CREATE_EMPLOYEE_PROFILE='CREATE_EMPLOYEE_PROFILE',FETCH_POSITION_TYPE='FETCH_POSITION_TYPE',CREATE_LOGIN_PROFILE='CREATE_LOGIN_PROFILE',SUBMIT_EDIT_LOGIN='SUBMIT_EDIT_LOGIN',DOWNLOAD_EMPLOYEES='DOWNLOAD_EMPLOYEES';/* Dashboard Actions */var FETCH_DASHBOARD_DATA='FETCH_DASHBOARD_DATA',FETCH_INFO_BY_LOCATION='FETCH_INFO_BY_LOCATION',ENLARGE_GRAPHS='ENLARGE_GRAPHS',FETCH_HEADCOUNT='FETCH_HEADCOUNT',SORT_BY_OPERATION='SORT_BY_OPERATION',FETCH_HOURS_BY_FIELD='FETCH_HOURS_BY_FIELD',FETCH_MISSING_TIMESHEETS='FETCH_MISSING_TIMESHEETS';/* Equipment Actions */var FETCH_EQUIPMENT='FETCH_EQUIPMENT',SELECT_EQUIPMENT='SELECT_EQUIPMENT';/* Harvest Actions */var SELECT_FIELD='SELECT_FIELD',CREATE_MECH_HARVEST='CREATE_MECH_HARVEST',FETCH_MECH_HARVEST='FETCH_MECH_HARVEST',FETCH_MY_MECH_HARVEST='FETCH_MY_MECH_HARVEST',PREPARE_MECH_HARVEST_TO_CREATE='PREPARE_MECH_HARVEST_TO_CREATE',PREPARE_MECH_HARVEST_TO_CREATE_2='PREPARE_MECH_HARVEST_TO_CREATE_2',PREPARE_MECH_HARVEST_TO_EDIT='PREPARE_MECH_HARVEST_TO_EDIT',PREPARE_MECH_HARVEST_TO_EDIT_2='PREPARE_MECH_HARVEST_TO_EDIT_2',SELECT_REPORT_TYPE='SELECT_REPORT_TYPE',SET_REPORT_OPTS='SET_REPORT_OPTS',FETCH_REPORT='FETCH_REPORT',SELECT_NEW_REPORT='SELECT_NEW_REPORT',SELECT_HARVEST_TO_MANAGE='SELECT_HARVEST_TO_MANAGE',RESET_MANAGE_HARVEST='RESET_MANAGE_HARVEST',FETCH_HARVEST_BY_DATE='FETCH_HARVEST_BY_DATE',EDIT_MECH_HARVEST='EDIT_MECH_HARVEST',DELETE_MECH_HARVEST='DELETE_MECH_HARVEST',ADD_HARVEST_RECORD='ADD_HARVEST_RECORD',SET_MECH_HARVEST_TO_EDIT='SET_MECH_HARVEST_TO_EDIT',// In create/edit form
EDIT_MECH_HARVEST_RECORD='EDIT_MECH_HARVEST_RECORD',// In create/edit form
DELETE_MECH_HARVEST_RECORD='DELETE_MECH_HARVEST_RECORD';// In create/edit form
/* Alert Actions */var UPDATE_SELECTED_LOCATION='UPDATE_SELECTED_LOCATION',UPDATE_PREFILL_MESSAGE='UPDATE_PREFILL_MESSAGE',UPDATE_OPTIONAL_MESSAGE='UPDATE_OPTIONAL_MESSAGE',NOTIFICATION_SENT='NOTIFICATION_SENT',UPDATE_SELECTED_GANG='UPDATE_SELECTED_GANG',TOAST_DISPLAYED='TOAST_DISPLAYED',UPDATE_MESSAGE_LIST='UPDATE_MESSAGE_LIST',UPDATE_CHIPS='UPDATE_CHIPS',REMOVE_CHIP='REMOVE_CHIP',NOTIFY_SELECTED_EMPLOYEES='NOTIFY_SELECTED_EMPLOYEES',FETCH_GANGS_FOR_SMS='FETCH_GANGS_FOR_SMS',FETCH_LOCATIONS='FETCH_LOCATIONS',SEARCH_MESSAGES_DATABASE='SEARCH_MESSAGES_DATABASE';/* END */

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(261);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["signinUser"] = signinUser;
/* harmony export (immutable) */ __webpack_exports__["fetchPayPeriod"] = fetchPayPeriod;
/* harmony export (immutable) */ __webpack_exports__["fetchUserProfile"] = fetchUserProfile;
/* harmony export (immutable) */ __webpack_exports__["fetchUser"] = fetchUser;
/* harmony export (immutable) */ __webpack_exports__["fetchTimesheetData"] = fetchTimesheetData;
/* harmony export (immutable) */ __webpack_exports__["submitRegTimesheet"] = submitRegTimesheet;
/* harmony export (immutable) */ __webpack_exports__["submitGangTimesheet"] = submitGangTimesheet;
/* harmony export (immutable) */ __webpack_exports__["fetchTimesheets"] = fetchTimesheets;
/* harmony export (immutable) */ __webpack_exports__["fetchEmployeeTimesheets"] = fetchEmployeeTimesheets;
/* harmony export (immutable) */ __webpack_exports__["fetchMyTimesheets"] = fetchMyTimesheets;
/* harmony export (immutable) */ __webpack_exports__["fetchTimesheetDatesToEdit"] = fetchTimesheetDatesToEdit;
/* harmony export (immutable) */ __webpack_exports__["fetchTimesheetToEdit"] = fetchTimesheetToEdit;
/* harmony export (immutable) */ __webpack_exports__["submitEditTimesheet"] = submitEditTimesheet;
/* harmony export (immutable) */ __webpack_exports__["fetchTimesheetsToDelete"] = fetchTimesheetsToDelete;
/* harmony export (immutable) */ __webpack_exports__["deleteTimesheet"] = deleteTimesheet;
/* harmony export (immutable) */ __webpack_exports__["downloadTimesheets"] = downloadTimesheets;
/* harmony export (immutable) */ __webpack_exports__["downloadIndividualTimesheets"] = downloadIndividualTimesheets;
/* harmony export (immutable) */ __webpack_exports__["fetchSubAccounts"] = fetchSubAccounts;
/* harmony export (immutable) */ __webpack_exports__["fetchFieldsByLoc"] = fetchFieldsByLoc;
/* harmony export (immutable) */ __webpack_exports__["fetchBlocksByField"] = fetchBlocksByField;
/* harmony export (immutable) */ __webpack_exports__["signoutUser"] = signoutUser;
/* harmony export (immutable) */ __webpack_exports__["authUser"] = authUser;
/* harmony export (immutable) */ __webpack_exports__["addEmployeeToTimesheet"] = addEmployeeToTimesheet;
/* harmony export (immutable) */ __webpack_exports__["addWorkToTimesheet"] = addWorkToTimesheet;
/* harmony export (immutable) */ __webpack_exports__["addWorkToGangTimesheet"] = addWorkToGangTimesheet;
/* harmony export (immutable) */ __webpack_exports__["editWorkInTimesheet"] = editWorkInTimesheet;
/* harmony export (immutable) */ __webpack_exports__["editWorkRecord"] = editWorkRecord;
/* harmony export (immutable) */ __webpack_exports__["editGangWorkRecord"] = editGangWorkRecord;
/* harmony export (immutable) */ __webpack_exports__["editGangWorkInTimesheet"] = editGangWorkInTimesheet;
/* harmony export (immutable) */ __webpack_exports__["editWorkInEditTimesheet"] = editWorkInEditTimesheet;
/* harmony export (immutable) */ __webpack_exports__["editWorkRecordInEditTimesheet"] = editWorkRecordInEditTimesheet;
/* harmony export (immutable) */ __webpack_exports__["deleteWorkInGangTimesheet"] = deleteWorkInGangTimesheet;
/* harmony export (immutable) */ __webpack_exports__["removeEmployeeFromTimesheet"] = removeEmployeeFromTimesheet;
/* harmony export (immutable) */ __webpack_exports__["removeWorkFromTimesheet"] = removeWorkFromTimesheet;
/* harmony export (immutable) */ __webpack_exports__["addEmployeeToGangTS"] = addEmployeeToGangTS;
/* harmony export (immutable) */ __webpack_exports__["removeEmployeeFromGangTS"] = removeEmployeeFromGangTS;
/* harmony export (immutable) */ __webpack_exports__["prepareGangTS"] = prepareGangTS;
/* harmony export (immutable) */ __webpack_exports__["prepareRegTS"] = prepareRegTS;
/* harmony export (immutable) */ __webpack_exports__["addWorkToEditTimesheet"] = addWorkToEditTimesheet;
/* harmony export (immutable) */ __webpack_exports__["removeWorkFromEditTimesheet"] = removeWorkFromEditTimesheet;
/* harmony export (immutable) */ __webpack_exports__["prepareEditTS"] = prepareEditTS;
/* harmony export (immutable) */ __webpack_exports__["employeeAutocomplete"] = employeeAutocomplete;
/* harmony export (immutable) */ __webpack_exports__["selectGangForTimesheet"] = selectGangForTimesheet;
/* harmony export (immutable) */ __webpack_exports__["selectGangForGangTimesheet"] = selectGangForGangTimesheet;
/* harmony export (immutable) */ __webpack_exports__["authError"] = authError;
/* harmony export (immutable) */ __webpack_exports__["error"] = error;
/* harmony export (immutable) */ __webpack_exports__["formError"] = formError;
/* harmony export (immutable) */ __webpack_exports__["fetchMyEmployees"] = fetchMyEmployees;
/* harmony export (immutable) */ __webpack_exports__["addNewGangInfoRow"] = addNewGangInfoRow;
/* harmony export (immutable) */ __webpack_exports__["removeHarvest"] = removeHarvest;
/* harmony export (immutable) */ __webpack_exports__["addHarvest"] = addHarvest;
/* harmony export (immutable) */ __webpack_exports__["selectHarvestToEdit"] = selectHarvestToEdit;
/* harmony export (immutable) */ __webpack_exports__["editHarvest"] = editHarvest;
/* harmony export (immutable) */ __webpack_exports__["selectCostCenterByLocation"] = selectCostCenterByLocation;
/* harmony export (immutable) */ __webpack_exports__["autoFillGangTimesheet"] = autoFillGangTimesheet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
6/19/17
All Actions for timesheet, auth interactions
************************************************************************/var $=window.$;var Materialize=window.Materialize;/*****************************************************
  Asynchronous Functions
*****************************************************//**
* signinUser(): Signs in a user
* @param {Object} email, password
* @returns {Object} JWT(Token)
* @called-in: ['/containers/auth/signin.js]
**/function signinUser(_ref){var email=_ref.email,password=_ref.password;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/signin',{email:email,password:password}).then(function(res){$('#preloader').css('display','none');// Save JSON Web Token to localStorage
localStorage.setItem('token',res.data.token);localStorage.setItem('email',email);// Authenticate user on redux front end
dispatch(authUser(res.data.user));// Send user to protected component
__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/dashboard');}).catch(function(){$('#preloader').css('display','none');dispatch(authError('Bad login Info'));});};}/**
* fetchPayPeriod(): Fetches the current pay period to limit date selections
* @returns {Object} current pay period dates; previous pay period dates(for last edits)
* @called-in: ['/containers/timesheet.js]
**/function fetchPayPeriod(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchPayPeriod',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){var startDate=__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.payPeriod.startDate).format('YYYY-MM-DD');var endDate=__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.payPeriod.endDate).format('YYYY-MM-DD');var prevPPStartDate=__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.prevPP.startDate).format('YYYY-MM-DD');var prevPPEndDate=__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.prevPP.endDate).format('YYYY-MM-DD');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["w" /* FETCH_PAY_PERIOD */],payload:{startDate:startDate,endDate:endDate},prevPP:{startDate:prevPPStartDate,endDate:prevPPEndDate}});}).catch(function(err){return dispatch(error('There was an error fetching pay periods'));});};}/**
* fetchUserProfile(): Fetches the logged users profile
* @param {String} eid: employee id number
* @returns {Object} User profile
* @called-in: ['/containers/dashboard.js]
**/function fetchUserProfile(eid){return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchUserProfile',{params:{eid:eid},headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["x" /* FETCH_USER_PROFILE */],payload:res.data.profile});}).catch(function(err){return dispatch(error('There was an error fetching the users profile'));});};}/**
* fetchUser(): Fetches the logged user and runs a check on if they exist in the store
* @param {Object} store: redux store
* @returns {Object} User profile
* @called-in: ['index.js]
**/function fetchUser(store){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchUser',{params:{token:localStorage.getItem('token')},headers:{authorization:localStorage.getItem('token')}}).then(function(res){store.dispatch(authUser(res.data.user));localStorage.setItem('token',res.data.token);__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/dashboard');}).catch(function(err){return store.dispatch(error('There was an error fetching the user'));});}/**
* fetchEmployeesServer(): Fetches all employees, fields, costcenters, equipment
* @param {Object} user: Logged user
* @returns {Object} Active employees, fields, cost centers, equipment lists
* @called-in: ['/containers/timesheet.js','/containers/gang_builder.js']
**/function fetchTimesheetData(user){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchTimesheetData',{params:{eid:user.eid},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["y" /* FETCH_TIMESHEET_DATA */],payload:res.data,user:user});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching employees'));});};}/**
* submitRegTimesheet(): Submits a regular timesheet for one or many employees
* @param {Array} employees: List of employees
* @param {Object} timesheet: All timesheet information to be applied to each employee
* @returns {Object} Employees, gangs who timesheet was submitted for
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_individual_modal.js']
**/function submitRegTimesheet(employees,timesheet,dates,user){// Ensure user selects at least 1 employee
if(employees.length===0)return error('Please select one or more employees to submit a timesheet');if(timesheet.location==='')return error('Please select a location to submit a timesheet');if(timesheet.secondaryTS.workPerformed.length===0)return error('Please add a work record before submitting a timesheet');if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["p" /* handleFormChecking */])(timesheet,error)===1)return{type:__WEBPACK_IMPORTED_MODULE_1__types__["z" /* NULL */]};var regHours=timesheet.secondaryTS.workPerformed.filter(function(w){return w.subAccount!==''&&w.subAccount.split('-')[2]!=='111'&&w.subAccount.split('-')[2]!=='129'&&w.subAccount.split('-')[2]!=='150';}).reduce(function(acc,_ref2){var hours=_ref2.hours;return acc+parseFloat(hours);},0);if(regHours>8)return error('Work is over 8 hours. Please add the correct overtime or doubletime subaccount to one or more records.');// Ensure supervisors cannot submit timesheets with temp. grades that do not exist
// Added 10.25.21
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=employees[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var e=_step.value;var positionType=e.positionType,firstName=e.firstName,lastName=e.lastName;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=timesheet.secondaryTS.workPerformed[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var w=_step2.value;if(w.tempGrade){if(!positionType.match(/Regular/)&&Number(w.tempGrade)>__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* MAX_NON_REG_GRADE */]){return error(firstName+' '+lastName+', '+positionType+' requires temporary grade <= '+__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* MAX_NON_REG_GRADE */]+'.');}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}document.getElementById('reg-ts-btn').disabled=true;$('#preloader').css('display','block');// If a user is a supervisor, 10am of new pay period is cutoff for editing
var lastDay=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');var prevPPStartDate=dates.prevPPStartDate,prevPPEndDate=dates.prevPPEndDate,payPeriodStartDate=dates.payPeriodStartDate;if(lastDay===__WEBPACK_IMPORTED_MODULE_5_moment___default()(payPeriodStartDate).format('YYYY-MM-DD')&&__WEBPACK_IMPORTED_MODULE_5_moment___default()().hour()>=10&&user.level<4){for(var m=__WEBPACK_IMPORTED_MODULE_5_moment___default()(prevPPStartDate);m.isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(prevPPEndDate).add(1,'days'));m.add(1,'days')){if(m.format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_5_moment___default()(timesheet.date).format('YYYY-MM-DD')){$('#preloader').css('display','none');document.getElementById('reg-ts-btn').disabled=false;return error('Cannot submit timesheets for a previous pay period past 10am');}}}return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/submitRegTimesheet',{employees:employees,timesheet:timesheet},{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');document.getElementById('reg-ts-btn').disabled=false;// If timesheet exists for one or more individuals
if(res.data.exists)return error(res.data.msg);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])('basic-ts-form');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["A" /* SUBMIT_REG_TIMESHEET */],payload:res.data.employees,gangs:res.data.gangs});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error submitting a timesheet'));});};}/**
* submitGangTimesheet(): Submits a gang timesheet(hand harvest) for one or many employees
* @param {Object} timesheet: All employees and timesheet information
* @returns {Object} Employees, gangs: Timesheets that were just submitted
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_modal.js']
**/function submitGangTimesheet(timesheet,dates,user){if(timesheet.emps.length===0)return error('Please select one or more employees to submit a timesheet');if(timesheet.location==='')return error('Please select a location to submit a timesheet');if(timesheet.date==='')return error('Please select a date to submit a timesheet');if(timesheet.round===''||Number(timesheet.round)<1)return error('Please enter a round to submit a timesheet');document.getElementById('gang-ts-btn').disabled=true;$('#preloader').css('display','block');// If a user is a supervisor, 10am of new pay period is cutoff for editing
var lastDay=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');var prevPPStartDate=dates.prevPPStartDate,prevPPEndDate=dates.prevPPEndDate,payPeriodStartDate=dates.payPeriodStartDate;if(lastDay===__WEBPACK_IMPORTED_MODULE_5_moment___default()(payPeriodStartDate).format('YYYY-MM-DD')&&__WEBPACK_IMPORTED_MODULE_5_moment___default()().hour()>=10&&user.level<4){for(var m=__WEBPACK_IMPORTED_MODULE_5_moment___default()(prevPPStartDate);m.isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()(prevPPEndDate).add(1,'days'));m.add(1,'days')){if(m.format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_5_moment___default()(timesheet.date).format('YYYY-MM-DD')){$('#preloader').css('display','none');document.getElementById('reg-ts-btn').disabled=false;return error('Cannot submit timesheets for a previous pay period past 10am');}}}return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/submitGangTimesheet',{timesheet:timesheet},{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');document.getElementById('gang-ts-btn').disabled=false;if(res.data.exists)return error(res.data.msg);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])('gang-ts-form');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["B" /* SUBMIT_GANG_TIMESHEET */],payload:res.data.employees,gangs:res.data.gangs});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error submitting a gang timesheet'));});};}/**
* fetchTimesheets(): Fetches all timesheets by date
* @param {Object} date: Date string
* @returns {Array} Timesheets: all timesheets for a selected date
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/function fetchTimesheets(date){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchTimesheets',{params:{date:date},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');$('#timesheet-view').fadeIn({duration:300});//console.log(res.data.timesheets)
dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["C" /* FETCH_TIMESHEETS */],payload:res.data.timesheets});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching timesheets'));});};}/**
* fetchEmployeeTimesheets(): Fetches all timesheets by employee
* @param {Object} employee: employee object
* @returns {Array} Timesheets: All timesheets for a selected employee
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/function fetchEmployeeTimesheets(employee){var eid=employee.eid;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchEmployeeTimesheets',{params:{eid:eid},headers:{authorization:localStorage.getItem('token')}}).then(function(res){document.getElementById('employee-search-ts').value='';$('#preloader').css('display','none');$('#timesheet-view').fadeIn({duration:300});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["D" /* FETCH_EMPLOYEE_TIMESHEETS */],payload:res.data});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching timesheets'));});};}/**
* fetchMyTimesheets(): Fetches all timesheets submitted by a user
* @param {String} eid: Employee ID of the user
* @returns {Array} Timesheets: All timesheets for a given user on a present date
* @called-in: ['/components/timesheets/view/timesheet_view.js']
**/function fetchMyTimesheets(eid,date){if(!date)date=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchMyTimesheets',{params:{eid:eid,date:date},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');$('#timesheet-view').fadeIn({duration:300});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["E" /* FETCH_MY_TIMESHEETS */],payload:res.data.timesheets,date:date});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching timesheets'));});};}/**
* fetchTimesheetDatesToEdit(): Fetches all timesheet dates available for editing
* @param {Object} employee: employee object
* @param {Object} dates: pay period dates
* @param {Object} user: logged in user object
* @returns {Array} Timesheet dates: All timesheets for the current pay period
* @called-in: ['/components/timesheets/edit/timesheet_edit.js']
**/function fetchTimesheetDatesToEdit(employee,dates,user){if(!employee)return error('Please select an employee');$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-ts-form");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-second-ts-form");// If a user is a supervisor, 10am of new pay period is cutoff for editing
var lastDay=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');// See constants.js to update DAYS_FOR_ADMINS
var lastDayForAdmins=__WEBPACK_IMPORTED_MODULE_5_moment___default()(dates.prevPPEndDate).add(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DAYS_FOR_ADMINS */],'days').format('YYYY-MM-DD');if(lastDay===__WEBPACK_IMPORTED_MODULE_5_moment___default()(dates.payPeriodStartDate).format('YYYY-MM-DD')&&__WEBPACK_IMPORTED_MODULE_5_moment___default()().hour()<10){dates.payPeriodStartDate=dates.prevPPStartDate;}// If a user is an admin, the first Friday of new pay period is cutoff for editing the previous pay periods timesheets
// This is access is available for the accounting team to resolve lingering cost center, sub account issues with TM and GP
if(lastDayForAdmins>=lastDay&&user.level===4){dates.payPeriodStartDate=dates.prevPPStartDate;//moment(dates.prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD') //dates.prevPPStartDate; // moment(dates.prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD')
}return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchTimesheetDatesToEdit',{params:{eid:employee.eid,dates:dates},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["F" /* GET_TIMESHEET_DATES_TO_EDIT */],payload:res.data.timesheetDates,employee:employee});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching timesheets dates to edit'));});};}/**
* fetchTimesheetToEdit(): Fetches timesheet information of a particular date for editing
* @param {String} tsID: Timesheet id
* @param {String} eid: Employee id
* @returns {Object} Timesheet: All timesheet information; fields, subaccounts
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_list.js']
**/function fetchTimesheetToEdit(tsID,eid){$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-ts-form");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-second-ts-form");return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchTimesheetToEdit',{params:{tsID:tsID,eid:eid},headers:{authorization:localStorage.getItem('token')}}).then(function(res){var tsObj={timesheet:res.data.timesheet[0],subTimesheets:res.data.subTimesheet,harvestTimesheet:res.data.harvestTimesheet,subAccounts:res.data.subAccounts,fields:res.data.fields};$('#preloader').css('display','none');dispatch(getTimesheetToEdit(tsObj));}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching timesheets to edit'));});};}/**
* submitEditTimesheet(): Submits an editing timesheet
* @param {String} ts: timesheet object
* @returns {Object} Redux dispatch
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_modal.js']
**/function submitEditTimesheet(ts){console.log(ts);if(Object.keys(ts.employee).length===0){return error('Please select an employee to edit a timesheet');}if(ts.timesheet.reasonForEdit===''){return error('Please enter a reason for editing the timesheet');}if(ts.harvestTimesheet.length>0&&(Number(ts.timesheet.round)<1||ts.timesheet.round==='')){return error('Please enter a round for hand harvest timesheets');}var regHours=ts.subTimesheets.filter(function(w){return w.subAccount!==''&&w.subAccount.split('-')[2]!=='111'&&w.subAccount.split('-')[2]!=='129'&&w.subAccount.split('-')[2]!=='150';}).reduce(function(acc,_ref3){var hours=_ref3.hours;return acc+parseFloat(hours);},0);var harvestHours=ts.harvestTimesheet.reduce(function(acc,_ref4){var hours=_ref4.hours;return acc+parseFloat(hours);},0);if(regHours+harvestHours>8)return error('Work is over 8 hours. Please add the correct overtime or doubletime subaccount to one or more records.');var dateTimeEdited=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD hh:mm:ss');ts.timesheet.dateTimeEdited=dateTimeEdited;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/submitEditTimesheet',{ts:ts},{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.data.msg,4000,'rounded green');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-ts-form");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])("edit-second-ts-form");return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["G" /* SUBMIT_EDIT_TIMESHEET */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error submitting a timesheet to edit'));});};}/**
* fetchTimesheetsToDelete(): Fetches timesheet information of a particular date for deleting
* @param {Object} employee: employee object
* @param {Object} dates: dates object
* @returns {Array} Timesheets to delete
* @called-in: ['/components/timesheets/delete/timesheet_delete.js']
**/function fetchTimesheetsToDelete(employee,dates){if(!employee)return error('Please select an employee');$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchTimesheetsToDelete',{params:{employee:employee,dates:dates},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["H" /* FETCH_TIMESHEETS_TO_DELETE */],payload:res.data.timesheets,employee:employee});}).catch(function(err){return dispatch(error('There was an error fetching timesheets to delete.'));});};}/**
* deleteTimesheet(): Deletes a selected timesheet
* @param {Object} ts: Timesheet object
* @param {Object} employee: Employee object
* @returns {Object} Redux dispatch
* @called-in: ['/components/timesheets/delete/timesheet_delete.js->timesheet_delete_modal.js']
**/function deleteTimesheet(ts,employee){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/deleteTimesheet',{ts:ts,employee:employee},{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["I" /* DELETE_TIMESHEET */]});}).catch(function(err){return dispatch(error('There was an error deleting a timesheet'));});};}/**
* downloadTimesheets(): Downloads timesheets for a particular date or range of dates
* @param {Object} dates: Dates object
* @param {String} email: Employee email(where downloaded timesheets will be sent to)
* @returns {String} Download message
* @called-in: ['/components/timesheets/view/timesheet_view.js->timesheet_download.js']
**/function downloadTimesheets(dates,email){if(dates.dateFrom===''||dates.dateTo===''){return error('Please select a date range');}$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])('ts-download-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/downloadTimesheets',{params:{dateFrom:dates.dateFrom,dateTo:dates.dateTo,email:email},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["J" /* DOWNLOAD_TIMESHEET */],payload:res.data});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error emailing the timesheets'));});};}/**
* downloadIndividualTimesheets(): Downloads timesheets for a date or range of dates of an individual employee
* @param {Object} dates: Dates object
* @param {String} email: Employee email(where downloaded timesheets will be sent to)
* @param {Object} emp: Employee object
* @returns {String} Download message
* @called-in: ['/components/timesheets/view/timesheet_view.js->timesheet_download.js']
**/function downloadIndividualTimesheets(dates,email,emp){if(dates.dateFrom===''||dates.dateTo===''){return error('Please select a date range');}if(!emp)return error('Please select an employee');$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* clearForm */])('ts-download-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/downloadIndividualTimesheets',{params:{dateFrom:dates.dateFrom,dateTo:dates.dateTo,email:email,emp:emp},headers:{authorization:localStorage.getItem('token')}}).then(function(res){document.getElementById('employee-search-ts-download').value='';document.getElementById('ts-download-3').value='';document.getElementById('ts-download-4').value='';$('#preloader').css('display','none');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["J" /* DOWNLOAD_TIMESHEET */],payload:res.data});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error emailing the timesheets'));});};}/**
* fetchSubAccounts(): Fetches subaccounts based on a selected cost center
* @param {String} costCenter: Cost center selected
* @returns {Array} All subaccounts listed under a cost center
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function fetchSubAccounts(costCenter){var arr=costCenter.split('-');var cc=arr[0];var loc=arr[arr.length-1];$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchSubAccounts',{params:{cc:cc,loc:loc},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["K" /* FETCH_SUBACCOUNTS */],payload:res.data});}).catch(function(err){return dispatch(error('There was an error fetching subAccounts'));});};}/**
* fetchFieldsByLoc(): Fetches fields based on selected location
* @param {String} loc: Location(71,72)
* @returns {Array} All fields based on location
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function fetchFieldsByLoc(loc){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchFieldsByLoc',{params:{loc:loc},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["L" /* FETCH_FIELDS_BY_LOC */],payload:res.data.fields});}).catch(function(err){return dispatch(error('There was an error fetching fields by location'));});};}/**
* fetchBlocksByField(): Fetches blocks based on selected field
* @param {String} field: Field number
* @returns {Array} All blocks based on field
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js',
               '/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js',
               '/components/timesheets/create/timesheet_create.js->gang_autofill_form.js',
               '/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function fetchBlocksByField(field){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchBlocksByField',{params:{field:field},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["M" /* FETCH_BLOCKS_BY_FIELD */],payload:res.data.blocks});}).catch(function(err){return dispatch(error('There was an error fetching blocks by field'));});};}/*****************************************************
  Synchronous Functions
*****************************************************//**
* signoutUser(): Signs a user out of the applciation
* @returns {Object} Unauthorize user
* @notes Make sure to remove token for JWT signout
* @called-in: ['/containers/auth/signout.js']
**/function signoutUser(){// Destroy JWT token
localStorage.removeItem('token');localStorage.removeItem('email');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["N" /* UNAUTH_USER */]};}/**
* authUser(): Authenticates a user
* @returns {Object} Authorized user
* @notes
* @called-in: ['/actions/index.js->signinUser(),fetchUser()']
**/function authUser(user){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["O" /* AUTH_USER */],payload:user};}/****************************** CREATE & VIEW **********************************//**
* addEmployeeToTimesheet(): Adds an employee for timesheet submission
* @param {Object} emp: Employee for timesheet submission
* @returns {Object} Employee
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/function addEmployeeToTimesheet(emp){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["P" /* ADD_EMPLOYEE_TO_TIMESHEET */],payload:emp};}/**
* addWorkToTimesheet(): Adds specific work for employees for timesheet submission
* @param {Object} work: Work record for timesheet submission
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/function addWorkToTimesheet(work){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["Q" /* ADD_WORK_TO_TIMESHEET */],payload:work};}/**
* addWorkToTimesheet(): Adds specific work for employees for gang timesheet submission
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/function addWorkToGangTimesheet(work){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["R" /* ADD_WORK_TO_GANG_TIMESHEET */],payload:work};}/**
* editWorkInTimesheet(): Sets a specific work record and prefills the form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/function editWorkInTimesheet(work){$('#ind-work-edit-btn').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* fillIndividualWorkForm */])(work,'second-ts-form');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["S" /* EDIT_WORK_IN_TIMESHEET */],payload:work};}/**
* editWorkRecord(): Edits a specific work record on a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/function editWorkRecord(work){$('#ind-work-edit-btn').css('display','none');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["T" /* EDIT_WORK_RECORD */],payload:work};}/**
* editGangWorkRecord(): Edits a work record in a gang timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js']
**/function editGangWorkRecord(work){$('#gang-work-edit-btn').css('display','none');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["U" /* EDIT_GANG_WORK_RECORD */],payload:work};}/**
* editGangWorkInTimesheet(): Sets a specific work record and prefills the gang form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/function editGangWorkInTimesheet(work){$('#gang-work-edit-btn').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* fillIndividualWorkForm */])(work,'gang-work-form');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["V" /* EDIT_WORK_IN_GANG_TIMESHEET */],payload:work};}/**
* editWorkInEditTimesheet(): Sets a specific work record and prefills the edit form to edit in a timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function editWorkInEditTimesheet(work){$('#ind-work-edit-ts-btn').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* fillIndividualWorkForm */])(work,'edit-second-ts-form');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["W" /* EDIT_WORK_IN_EDIT_TIMESHEET */],payload:work};}/**
* editWorkInEditTimesheet(): Edits a work record in a edit timesheet
* @param {Object} work: Work record in timesheet
* @returns {Object} work
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function editWorkRecordInEditTimesheet(work){$('#ind-work-edit-ts-btn').css('display','none');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["X" /* EDIT_WORK_RECORD_EDIT_TS */],payload:work};}/**
* deleteWorkInGangTimesheet(): Deletes a work record in a gang timesheet
* @param {String} workId: Work id record in timesheet
* @returns {Object} workId
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js->gang_work_table.js']
**/function deleteWorkInGangTimesheet(workId){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["Y" /* DELETE_WORK_IN_GANG_TIMESHEET */],payload:workId};}/**
* removeEmployeeFromTimesheet(): Removes an employee from timesheet submission list
* @param {Object} emp: employee object
* @returns {Object} emp
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/function removeEmployeeFromTimesheet(emp){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["Z" /* REMOVE_EMPLOYEE_FROM_TIMESHEET */],payload:emp};}/**
* removeWorkFromTimesheet(): Removes specific work from a timesheet
* @param {String} workId: Work id record in timesheet
* @returns {Object} workId
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_form.js->add_work_table.js']
**/function removeWorkFromTimesheet(workId){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_0" /* REMOVE_WORK_FROM_TIMESHEET */],payload:workId};}/**
* addEmployeeToGangTS(): Adds employees to gang timesheets
* @param {String} emp: employee object
* @returns {Object} emp
* @called-in: ['/components/timesheets/create/timesheet_create.js->employee_list.js']
**/function addEmployeeToGangTS(emp){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_1" /* ADD_EMPLOYEE_TO_GANG_TIMESHEET */],payload:emp};}/**
* removeEmployeeFromGangTS(): Removes employees from gang timesheets
* @param {String} eid: employee id
* @returns {Object} eid
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/function removeEmployeeFromGangTS(eid){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_2" /* REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET */],payload:eid};}/**
* prepareGangTS(): Prepares the gang timesheet that is to be submitted for review
* @param {Array} gangTS: array of employee timesheet objects
* @param {String} submitter: employee id of supervisor
* @param {String} location: location of work
* @param {String} date: date string
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/create/timesheet_create.js->timesheet_gang_form.js']
**/function prepareGangTS(gangTS,submitter,location,date,round){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_3" /* PREPARE_GANG_TIMESHEET */],payload:Object.assign({timesheetID:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* generateTSID */])(),submitter:submitter,location:location,date:date,round:round},gangTS)};}/**
* prepareRegTS(): Prepares the individual timesheet that is to be submitted for review
* @param {Object} formObj: Timesheet form object
* @param {Array} addedWork: array of work records
* @param {String} submitter: employee id of supervisor
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/create/timesheet_create.js']
**/function prepareRegTS(formObj,addedWork,submitter){var regHours=8;var dustPay=void 0;var totalHours=addedWork.reduce(function(acc,_ref5){var hours=_ref5.hours;return acc+parseFloat(hours);},0);var overTime=addedWork.filter(function(w){return w.subAccount!==''&&(w.subAccount.split('-')[2]==='111'||w.subAccount.split('-')[2]==='150');}).reduce(function(acc,_ref6){var hours=_ref6.hours;return acc+parseFloat(hours);},0);var doubleTime=addedWork.filter(function(w){return w.subAccount!==''&&w.subAccount.split('-')[2]==='129';}).reduce(function(acc,_ref7){var hours=_ref7.hours;return acc+parseFloat(hours);},0);if(totalHours<=8)regHours=totalHours;// Handle dust pay: Added 1/18/18
if(document.getElementById('dustPay').checked)dustPay=1;else dustPay=0;formObj.dustPay=dustPay;return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_4" /* PREPARE_REG_TIMESHEET */],payload:Object.assign({timesheetID:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* generateTSID */])(),submitter:submitter,regHours:regHours.toFixed(2),otHours:overTime.toFixed(2),doubleTime:doubleTime.toFixed(2),summaryOfHours:totalHours.toFixed(2),gang:formObj.regGangNo},formObj,{secondaryTS:{workPerformed:addedWork}})};}/************************************ EDIT *************************************//**
* getTimesheetToEdit(): Prefill edit form and pull employees timesheet
* @param {Object} tsObj: Timesheet form object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/actions/index.js']
**/function getTimesheetToEdit(tsObj){var round=1;if(tsObj.harvestTimesheet.length>0)round=tsObj.harvestTimesheet[0].round;setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* fillEditForm */])(Object.assign({},tsObj,{round:round}));document.getElementById('edit-ts-date').disabled=true;},100);return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_5" /* FETCH_TIMESHEET_TO_EDIT */],payload:{timesheet:tsObj.timesheet,subTimesheets:tsObj.subTimesheets,removedWork:[],subAccounts:tsObj.subAccounts,harvestTimesheet:tsObj.harvestTimesheet,removedHarvest:[],block:tsObj.timesheet.block// Pass in block and concat to state; helps with prefilling timesheet for edit
},fields:tsObj.fields};}/**
* addWorkToEditTimesheet(): Add work to a timesheet being edited
* @param {Object} work: work object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function addWorkToEditTimesheet(work){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_6" /* ADD_WORK_TO_EDIT_TIMESHEET */],payload:work};}/**
* removeWorkFromEditTimesheet(): Remove work from a timesheet being edited
* @param {Number} id: id of work object
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function removeWorkFromEditTimesheet(id){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_7" /* REMOVE_WORK_FROM_EDIT_TIMESHEET */],payload:id};}/**
* prepareEditTS(): Prepares a timesheet for submission. Any calculations, groupings, etc
* @param {Object} timesheet: timesheet object
* @param {Array} addedWork: array of work objects
* @param {String} submitter: employee id of submitter
* @param {Array} removedWork: array of work objects
* @param {Array} harvestTimesheet: array of harvest objects
* @param {Array} removedHarvest: array of harvest objects to delete
* @returns {Object} payload: prepared timesheet
* @called-in: ['/components/timesheets/edit/timesheet_edit.js->timesheet_edit_form.js']
**/function prepareEditTS(timesheet,addedWork,submitter,removedWork,harvestTimesheet,removedHarvest){var ts=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('edit-ts-form');var regHours=0,totalRegWorkHours=0,totalHarvestHours=0,overTime=0,doubleTime=0,workHours=0,harvestHours=0,totalHours=0;var dustPay=void 0;/* Account for subtimesheets */if(addedWork.length>0){workHours=addedWork.filter(function(w){return w.subAccount!==''&&w.subAccount.split('-')[2]!=='111'&&w.subAccount.split('-')[2]!=='150'&&w.subAccount.split('-')[2]!=='129';}).reduce(function(acc,_ref8){var hours=_ref8.hours;return acc+parseFloat(hours);},0);overTime=addedWork.filter(function(w){return w.subAccount!==''&&(w.subAccount.split('-')[2]==='111'||w.subAccount.split('-')[2]==='150');}).reduce(function(acc,_ref9){var hours=_ref9.hours;return acc+parseFloat(hours);},0);doubleTime=addedWork.filter(function(w){return w.subAccount!==''&&w.subAccount.split('-')[2]==='129';}).reduce(function(acc,_ref10){var hours=_ref10.hours;return acc+parseFloat(hours);},0);totalRegWorkHours+=workHours;}/* Account for harvest */if(harvestTimesheet.length>0){harvestHours=harvestTimesheet.reduce(function(acc,_ref11){var hours=_ref11.hours;return acc+parseFloat(hours);},0);totalHarvestHours+=harvestHours;// Catch hours > 8
if(harvestHours>8)overTime+=harvestHours-8;if(Number(ts.round)>0){harvestTimesheet=harvestTimesheet.map(function(h){return Object.assign({},h,{round:Number(ts.round)});});}}// Total Work hours calculated
totalHours+=totalRegWorkHours;// Total Harvest hours calculated
totalHours+=totalHarvestHours;// If total hours is less than 8 hours, reg hours is totalHours
if(totalHours>8){regHours=8;//if (!(doubleTime > 0)) overTime = (totalHours - 8).toFixed(2);
}else{regHours=totalHours;}if(isNaN(regHours)){regHours=0.00;totalHours=0.00;}var paycodeHours=addedWork.filter(function(w){return w.paycode!=='';}).reduce(function(acc,cur){return acc+Number(cur.hours);},0);regHours+=paycodeHours;if(document.getElementById('edit-ts-dustPay').checked)dustPay=1;else dustPay=0;ts.dustPay=dustPay;return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_8" /* PREPARE_EDIT_TIMESHEET */],payload:{timesheet:Object.assign({},ts,{date:ts.date,timesheetID:timesheet.timesheetID,submitter:submitter,eid:timesheet.eid,regHours:regHours.toFixed(2),otHours:parseFloat(overTime).toFixed(2),doubleTime:parseFloat(doubleTime).toFixed(2),summaryOfHours:Number(workHours)+Number(harvestHours)+Number(overTime)+Number(doubleTime)+Number(paycodeHours)//.toFixed(2)
}),subTimesheets:addedWork,removedWork:removedWork,harvestTimesheet:harvestTimesheet,removedHarvest:removedHarvest}};}/**
* employeeAutocomplete(): Selects an employee based on autocomplete input
* @param {Object} val: employee object
* @param {Object} id: input id-> document.getElementById(id)
* @returns {Object} payload: employee name
* @called-in: ['/components/timesheets/create/timesheet_create.js']
**/function employeeAutocomplete(val,id){document.getElementById(id).value='';return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_9" /* EMPLOYEE_AUTOCOMPLETE */],payload:val,id:id};}/* Selects a gang and populates the employee timesheet list */function selectGangForTimesheet(gang){document.getElementById('regGangNo').value=gang.gangId;return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_10" /* SELECT_GANG_FOR_TIMESHEET */],payload:gang};}/* Selects a gang and populates the gang timesheet list */function selectGangForGangTimesheet(gang){document.getElementById('gangNo').value=gang.gangId;document.getElementById('gangShift').value=1;return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_11" /* SELECT_GANG_FOR_GANG_TIMESHEET */],payload:gang};}/*****************************************************
  Error Functions
*****************************************************/function authError(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_12" /* AUTH_ERROR */],payload:err};}function error(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["k" /* ERROR */],err:err};}function formError(err){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["k" /* ERROR */],err:err};}/* Fetches the users employees if they have any */function fetchMyEmployees(eid){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_13" /* FETCH_MY_EMPLOYEES_TIMESHEET */],payload:eid};}/* Adds a new row for employees to add different hours, trees, bags, per field */function addNewGangInfoRow(eid){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_14" /* ADD_NEW_GANG_INFO_ROW */],payload:eid};}/* Removes a harvest record from timesheet */function removeHarvest(id){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_15" /* REMOVE_HARVEST_FROM_EDIT_TIMESHEET */],payload:id};}/* Adds a harvest record to timesheet */function addHarvest(harvest){if(harvest.hours===''||harvest.bags===''||harvest.trees===''||harvest.field==='')return error('Please enter hours, bags, trees and a field');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_16" /* ADD_HARVEST_TO_EDIT_TIMESHEET */],payload:Object.assign({},harvest,{id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* generateGUID */])()})};}/* Selects a harvest record to edit */function selectHarvestToEdit(formId,harvest){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["m" /* fillEdit */])(formId,harvest);$('#edit-harvest-btn').css('display','block');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_17" /* SELECT_HARVEST_TO_EDIT */],payload:harvest};}/* Edits a selected harvest record */function editHarvest(formId,harvestToEdit){var harvest=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('edit-harvest-ts-form');harvestToEdit=Object.assign({},harvestToEdit,{bags:harvest.bags,trees:harvest.trees,block:harvest.block,field:harvest.field,hours:harvest.hours,incentive:0.00,pIndex:0.00});$('#edit-harvest-btn').css('display','none');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_18" /* EDIT_HARVEST */],payload:harvestToEdit};}/**
* selectCostCenterByLocation(): Displays cost centers by location only; once a location is selected
* @param {String} val: selected location
* @returns {Object}
* @called-in: ['/components/timesheets/create/.js]
**/function selectCostCenterByLocation(val){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_19" /* SELECT_COST_CENTER_BY_LOCATION */],payload:val};}/**
* autoFillGangTimesheet(): Autofills gang timesheet inputs; up to 3 inputs per employee
* @param {Object} formObj: autofill form object
* @returns {Object}
* @called-in: ['/components/timesheets/create/gang_autofill_form.js]
**/function autoFillGangTimesheet(formObj){$('#emp-list-gang input').each(function(){var id=this.id.split('-');if(formObj.count==="1"&&id.length===2){if(id[1]==='bags')this.value=formObj.bags;if(id[1]==='trees')this.value=formObj.trees;if(id[1]==='hours')this.value=formObj.hours;}if(formObj.count==="2"&&id.length===3&&id[1]==="0"){if(id[2]==='bags')this.value=formObj.bags;if(id[2]==='trees')this.value=formObj.trees;if(id[2]==='hours')this.value=formObj.hours;}if(formObj.count==="3"&&id.length===3&&id[1]==="1"){if(id[2]==='bags')this.value=formObj.bags;if(id[2]==='trees')this.value=formObj.trees;if(id[2]==='hours')this.value=formObj.hours;}if(formObj.count==="4"&&id.length===3&&id[1]==="2"){if(id[2]==='bags')this.value=formObj.bags;if(id[2]==='trees')this.value=formObj.trees;if(id[2]==='hours')this.value=formObj.hours;}if(formObj.count==="5"&&id.length===3&&id[1]==="3"){if(id[2]==='bags')this.value=formObj.bags;if(id[2]==='trees')this.value=formObj.trees;if(id[2]==='hours')this.value=formObj.hours;}});$('#emp-list-gang select').each(function(){var id=this.id.split('-');if(formObj.count==="1"&&id.length===2){if(id[1]==='field')this.value=formObj.field;if(id[1]==='block')this.value=formObj.block;}if(formObj.count==="2"&&id.length===3&&id[1]==="0"){if(id[2]==='field')this.value=formObj.field;if(id[2]==='block')this.value=formObj.block;}if(formObj.count==="3"&&id.length===3&&id[1]==="1"){if(id[2]==='field')this.value=formObj.field;if(id[2]==='block')this.value=formObj.block;}if(formObj.count==="4"&&id.length===3&&id[1]==="2"){if(id[2]==='field')this.value=formObj.field;if(id[2]==='block')this.value=formObj.block;}if(formObj.count==="5"&&id.length===3&&id[1]==="3"){if(id[2]==='field')this.value=formObj.field;if(id[2]==='block')this.value=formObj.block;}});return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_20" /* AUTOFILL_GANG_TIMESHEET */]};}/* END */

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EMAIL_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_MANAGERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SET_DOCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_CULT_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_CERTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLEAR_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CREATE_CHEMICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_CHEMICALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SELECT_CHEMICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SELECT_CHEMICAL_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return EDIT_CHEMICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return FETCH_CULTIVATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return ADD_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return EDIT_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DELETE_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SELECT_SOLUTION_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_TOTAL_GALLONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PREPARE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CREATE_CHEMICAL_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return EDIT_CHEMICAL_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return FETCH_CHEMICAL_APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SELECT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DELETE_CHEMICAL_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SELECT_CHEMICAL_APPLICATION_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SELECT_FIELD_FOR_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SELECT_APPLICATION_TO_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CREATE_FERTILIZER_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ADD_FERTILIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EDIT_FERTILIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SELECT_FERTILIZER_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DELETE_FERTILIZER; });
/* unused harmony export PREPARE_FERTILIZER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_FERTILIZER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FETCH_FERTILIZER_APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SELECT_FERTILIZER_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DELETE_FERTILIZER_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SELECT_FERT_APP_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return EDIT_FERTILIZER_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ADD_MOWING_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EDIT_MOWING_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SELECT_MOW_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DELETE_MOWING_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PREPARE_MOWING_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CREATE_MOWING_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_MOWING_APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SELECT_MOWING_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DELETE_MOWING_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SELECT_MOW_APP_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return EDIT_MOWING_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_FORM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PREPARE_TREE_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CREATE_INVENTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ISSUE_OR_RECEIVE_INVENTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return APPROVE_INVENTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DOWNLOAD_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_INVENTORY_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_INVENTORY_TO_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DELETE_INVENTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMOVE_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PREPARE_REPLANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_REPLANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_REPLANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_REPLANT_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_EMPLOYEE_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_EMPLOYEE_FROM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDIT_REPLANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_REPLANT_TO_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_REPLANT; });
/* General Actions */var ERROR='ERROR',EMAIL_FILE='EMAIL_FILE',FETCH_MANAGERS='FETCH_MANAGERS',SET_DOCS='SET_DOCS',FETCH_CULT_EMPLOYEES='FETCH_CULT_EMPLOYEES',FETCH_CERTIFICATION='FETCH_CERTIFICATION',CLEAR_FORM=' CLEAR_FORM';/* Chemical Actions */var CREATE_CHEMICAL='CREATE_CHEMICAL',FETCH_CHEMICALS='FETCH_CHEMICALS',SELECT_CHEMICAL='SELECT_CHEMICAL',SELECT_CHEMICAL_TO_EDIT='SELECT_CHEMICAL_TO_EDIT',EDIT_CHEMICAL='EDIT_CHEMICAL';/* Report Actions */var FETCH_FIELDS='FETCH_FIELDS',FETCH_CULTIVATION_REPORT='FETCH_CULTIVATION_REPORT';/* Chemical Application Actions */var ADD_SOLUTION='ADD_SOLUTION',EDIT_SOLUTION='EDIT_SOLUTION',DELETE_SOLUTION='DELETE_SOLUTION',SELECT_SOLUTION_TO_EDIT='SELECT_SOLUTION_TO_EDIT',SET_TOTAL_GALLONS='SET_TOTAL_GALLONS',PREPARE_DATA='PREPARE_DATA',CREATE_CHEMICAL_APPLICATION='CREATE_CHEMICAL_APPLICATION',EDIT_CHEMICAL_APPLICATION='EDIT_CHEMICAL_APPLICATION',FETCH_CHEMICAL_APPLICATIONS='FETCH_CHEMICAL_APPLICATIONS',SELECT_FIELD='SELECT_FIELD',DELETE_CHEMICAL_APPLICATION='DELETE_CHEMICAL_APPLICATION',SELECT_CHEMICAL_APPLICATION_TO_EDIT='SELECT_CHEMICAL_APPLICATION_TO_EDIT',SELECT_FIELD_FOR_EDIT='SELECT_FIELD_FOR_EDIT',SELECT_APPLICATION_TO_VIEW='SELECT_APPLICATION_TO_VIEW';/* Fertilizer Actions */var CREATE_FERTILIZER_APPLICATION='CREATE_FERTILIZER_APPLICATION',ADD_FERTILIZER='ADD_FERTILIZER',EDIT_FERTILIZER='EDIT_FERTILIZER',SELECT_FERTILIZER_TO_EDIT='SELECT_FERTILIZER_TO_EDIT',DELETE_FERTILIZER='DELETE_FERTILIZER',PREPARE_FERTILIZER='PREPARE_FERTILIZER',SET_FERTILIZER_FORM='SET_FERTILIZER_FORM',FETCH_FERTILIZER_APPLICATIONS='FETCH_FERTILIZER_APPLICATIONS',SELECT_FERTILIZER_APPLICATION='SELECT_FERTILIZER_APPLICATION',DELETE_FERTILIZER_APPLICATION='DELETE_FERTILIZER_APPLICATION',SELECT_FERT_APP_TO_EDIT='SELECT_FERT_APP_TO_EDIT',EDIT_FERTILIZER_APPLICATION='EDIT_FERTILIZER_APPLICATION';/* Mowing Actions */var ADD_MOWING_RECORD='ADD_MOWING_RECORD',EDIT_MOWING_RECORD='EDIT_MOWING_RECORD',SELECT_MOW_TO_EDIT='SELECT_MOW_TO_EDIT',DELETE_MOWING_RECORD='DELETE_MOWING_RECORD',PREPARE_MOWING_APPLICATION='PREPARE_MOWING_APPLICATION',CREATE_MOWING_APPLICATION='CREATE_MOWING_APPLICATION',FETCH_MOWING_APPLICATIONS='FETCH_MOWING_APPLICATIONS',SELECT_MOWING_APPLICATION='SELECT_MOWING_APPLICATION',DELETE_MOWING_APPLICATION='DELETE_MOWING_APPLICATION',SELECT_MOW_APP_TO_EDIT='SELECT_MOW_APP_TO_EDIT',EDIT_MOWING_APPLICATION='EDIT_MOWING_APPLICATION';/* Tree Inventory Actions */var SET_FORM_TYPE='SET_FORM_TYPE',PREPARE_TREE_INVENTORY='PREPARE_TREE_INVENTORY',CREATE_INVENTORY_REQUEST='CREATE_INVENTORY_REQUEST',FETCH_INVENTORY='FETCH_INVENTORY',ISSUE_OR_RECEIVE_INVENTORY_REQUEST='ISSUE_OR_RECEIVE_INVENTORY_REQUEST',APPROVE_INVENTORY_REQUEST='APPROVE_INVENTORY_REQUEST',DOWNLOAD_INVENTORY='DOWNLOAD_INVENTORY',SET_INVENTORY_TO_EDIT='SET_INVENTORY_TO_EDIT',EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST='EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST',SET_INVENTORY_TO_DELETE='SET_INVENTORY_TO_DELETE',DELETE_INVENTORY_REQUEST='DELETE_INVENTORY_REQUEST';var ADD_EMPLOYEE='ADD_EMPLOYEE',REMOVE_EMPLOYEE='REMOVE_EMPLOYEE',PREPARE_REPLANT='PREPARE_REPLANT',FETCH_REPLANTS='FETCH_REPLANTS',CREATE_REPLANT='CREATE_REPLANT',SET_REPLANT_TO_EDIT='SET_REPLANT_TO_EDIT',ADD_EMPLOYEE_TO_EDIT='ADD_EMPLOYEE_TO_EDIT',REMOVE_EMPLOYEE_FROM_EDIT='REMOVE_EMPLOYEE_FROM_EDIT',EDIT_REPLANT='EDIT_REPLANT',SET_REPLANT_TO_DELETE='SET_REPLANT_TO_DELETE',DELETE_REPLANT='DELETE_REPLANT';/* END */

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(775);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchFields;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchManagers;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchEmployees;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchCertification;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/*******************************************************************************
Chemical Actions: All interactions in the chemical component

*******************************************************************************//**
* fetchFields(): Fetches fields based on selected location
* @param {String} loc: Location(71,72)
* @returns {Array} All fields based on location
* @called-in: ['/components/reports/reports.js->report_form.js']
* @notes: Added setTimeout as the location dropdown would reset on async fetch; possible rerender
**/function fetchFields(loc){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchFields',{params:{loc:loc},headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["r" /* FETCH_FIELDS */],payload:res.data.fields});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('There was an error fetching fields by location'));});};}/**
* fetchManagers(): Fetches all cultivation managers
* @returns {Array} managers
* @called-in: ['/components/documentation/introduction.js']
**/function fetchManagers(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchManagers',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["s" /* FETCH_MANAGERS */],payload:res.data.managers});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('There was an error fetching managers.'));});};}/**
* fetchEmployees(): Fetches employees
* @returns {Array} employees
* @called-in: ['/components/chem_app/chem_app_create.js']
**/function fetchEmployees(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchEmployees',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["t" /* FETCH_CULT_EMPLOYEES */],payload:res.data.employees});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('There was an error fetching employees. '+err));});};}/**
* fetchCertification(): Fetches employees
* @returns {Array} employees
* @called-in: ['/components/chem_app/chem_app_create.js']
**/function fetchCertification(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchCertification',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["u" /* FETCH_CERTIFICATION */],payload:res.data.cert});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('There was an error fetching employees. '+err));});};}/**
* clearForm(): Clears a form
* @param {String} formId: form id to clear
* @called-in: ['/components/chem_app/chem_app_create.js; fertilizer/fertilizer_create.js']
**/function clearForm(formId){if(document.getElementById(formId)===null||document.getElementById(formId)===undefined||document.getElementById(formId)==='')return{type:__WEBPACK_IMPORTED_MODULE_0__types__["p" /* CLEAR_FORM */]};document.getElementById(formId).reset();return{type:__WEBPACK_IMPORTED_MODULE_0__types__["p" /* CLEAR_FORM */]};}/* END */

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CULTIVATION_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PRODUCT_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TREE_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHEMICAL_APP_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FERTILIZER_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MOWING_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHEMICAL_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return YES_OR_NO; });
/* unused harmony export STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ISSUE_OR_RECEIVE; });
/* unused harmony export APPLICATION_METHODS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNITS_OF_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FAQS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPORT_TYPES; });
/* Mechanical harvest URL's */var CULTIVATION_URLS=[{name:'Products & Reports',url:'/cultivation/products',level:2,iconColor:'amber-text'},{name:'Chemical Application',url:'/cultivation/chemicalApplication',level:2,iconColor:'teal-text'},{name:'Fertilizer',url:'/cultivation/fertilizer',level:2,iconColor:'purple-text'},{name:'Mowing',url:'/cultivation/mowing',level:2,iconColor:'cyan-text'},{name:'Tree & Replant',url:'/cultivation/trees',level:2,iconColor:'green-text'}];var PRODUCT_URLS=[{name:'Products',url:'/cultivation/products',level:1},{name:'Reports',url:'/cultivation/reports',level:1}];var TREE_URLS=[{name:'Tree Inventory',url:'/cultivation/trees',level:1},{name:'Replants',url:'/cultivation/replants',level:1}];var CHEMICAL_APP_URLS=[{name:'Current Chemical Applications',url:'/cultivation/chemicalApplication',level:1},{name:'Create & Edit Chemical Applications',url:'/cultivation/chemicalApplication/create',level:1}];var FERTILIZER_URLS=[{name:'Current Fertilizer Applications',url:'/cultivation/fertilizer',level:1},{name:'Create & Edit Fertilizer Applications',url:'/cultivation/fertilizer/create',level:3}];var MOWING_URLS=[{name:'Current Mowing Work',url:'/cultivation/mowing',level:1},{name:'Create & Edit Mowing Work',url:'/cultivation/mowing/create',level:3}];var CHEMICAL_TYPES=[{label:'Herbicide',val:'Herbicide'},{label:'Pesticide',val:'Pesticide'},{label:'Fungicide',val:'Fungicide'},{label:'Fertilizer',val:'Fertilizer'},{label:'Nutrient',val:'Nutrient'},{label:'Miticide',val:'Miticide'},{label:'Bactericide',val:'Bactericide'},{label:'Adjuvant',val:'Adjuvant'}].sort(function(a,b){return a.label<b.label?1:-1;});var YES_OR_NO=[{label:'Yes',val:1},{label:'No',val:0}];var STATUS=[{label:'Complete',val:1},{label:'Incomplete',val:0}];var ISSUE_OR_RECEIVE=[{label:'Issue',val:'I'},{label:'Receive',val:'R'}];var APPLICATION_METHODS=[{label:'Airblast',val:'Airblast'},{label:'Broadcast',val:'Broadcast'},{label:'Spot',val:'Spot'}];var UNITS_OF_MEASURE=[// length
{label:'ft',value:'ft',type:'length'},{label:'sq.ft',value:'sq.ft',type:'length'},{label:'yard',value:'yard',type:'length'},{label:'m',value:'m',type:'length'},{label:'km',value:'km',type:'length'},{label:'mi',value:'mi',type:'length'},{label:'acre',value:'acre',type:'length'},{label:'hectare',value:'hectare',type:'length'},// mass
{label:'mg',value:'mg',type:'mass'},{label:'g',value:'g',type:'mass'},{label:'oz',value:'oz',type:'mass'},{label:'kg',value:'kg',type:'mass'},{label:'lb',value:'lb',type:'mass'},{label:'ton',value:'ton',type:'mass'},// volume
{label:'ml',value:'ml',type:'volume'},{label:'l',value:'l',type:'volume'},{label:'kl',value:'kl',type:'volume'},{label:'tsp',value:'tsp',type:'volume'},{label:'Tbs',value:'Tbs',type:'volume'},{label:'fl-oz',value:'fl-oz',type:'volume'},{label:'cup',value:'cup',type:'volume'},{label:'pnt',value:'pnt',type:'volume'},{label:'qt',value:'qt',type:'volume'},{label:'gal',value:'gal',type:'volume'}];var LOCATIONS=[{val:'71',label:'71 - Kau'},{val:'72',label:'72 - Keaau'}];/*
  For FAQ cards. Use [color]-text for iconColor
*/var FAQS=[{title:'Products & Reports FAQ',extra:'Click for more information',icon:'folder',iconColor:'orange-text',cardColor:'grey lighten-3',url:'/cultivation/products'},{title:'Chemical Application FAQ',extra:'Click for more information',icon:'bug_report',iconColor:'red-text',cardColor:'grey lighten-3',url:'/cultivation'},{title:'Fertilizer & Mowing FAQ',extra:'Click for more information',icon:'filter_vintage',iconColor:'blue-text',cardColor:'grey lighten-3',url:'/cultivation'},{title:'Tree & Replant FAQ',extra:'Click for more information',icon:'local_florist',iconColor:'green-text',cardColor:'grey lighten-3',url:'/cultivation'}];var REPORT_TYPES=[{label:'Chemical Application',val:'Chemical Application'},{label:'Fertilizer',val:'Fertilizer'},{label:'Mowing',val:'Mowing'},{label:'Tree Replant',val:'Tree Replant'},{label:'Products',val:'Products'},{label:'Full Data Set',val:'Full Data Set'}];/* END */

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(143);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(40);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes2 = __webpack_require__(132);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.routerShape;
  }
});

var _PatternUtils = __webpack_require__(51);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(725);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(238);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(719);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(738);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(720);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(721);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(239);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(723);

var _Route3 = _interopRequireDefault(_Route2);

var _History2 = __webpack_require__(718);

var _History3 = _interopRequireDefault(_History2);

var _Lifecycle2 = __webpack_require__(722);

var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);

var _RouteContext2 = __webpack_require__(724);

var _RouteContext3 = _interopRequireDefault(_RouteContext2);

var _useRoutes2 = __webpack_require__(737);

var _useRoutes3 = _interopRequireDefault(_useRoutes2);

var _RouterContext2 = __webpack_require__(86);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _RoutingContext2 = __webpack_require__(726);

var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);

var _PropTypes3 = _interopRequireDefault(_PropTypes2);

var _match2 = __webpack_require__(735);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(244);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(728);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(729);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(733);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(241);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* mixins */

exports.History = _History3.default;
exports.Lifecycle = _Lifecycle3.default;
exports.RouteContext = _RouteContext3.default;

/* utils */

exports.useRoutes = _useRoutes3.default;
exports.RouterContext = _RouterContext3.default;
exports.RoutingContext = _RoutingContext3.default;
exports.PropTypes = _PropTypes3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return generateID; });
/* harmony export (immutable) */ __webpack_exports__["d"] = packageForm;
/* harmony export (immutable) */ __webpack_exports__["k"] = handleLog;
/* harmony export (immutable) */ __webpack_exports__["i"] = calculateTotalFuelGallons;
/* harmony export (immutable) */ __webpack_exports__["h"] = calculateTotalGallons;
/* harmony export (immutable) */ __webpack_exports__["g"] = sumProp;
/* harmony export (immutable) */ __webpack_exports__["j"] = avgProp;
/* harmony export (immutable) */ __webpack_exports__["a"] = preFillForm;
/* harmony export (immutable) */ __webpack_exports__["b"] = preFillMeterForm;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearForm;
/* harmony export (immutable) */ __webpack_exports__["c"] = filterOldRecords;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Irrigation utils: misc utility functions used through the module
**********************************************************//**
* generateID(): Generates a unique general purpose ID of any length
* @param {Number} len: length of unqiue string
* @returns {String} uuid: unique id
* @called-in: ['irrigation_actions.js]
**/var generateID=function generateID(len){if(len===0)return;var xString='';for(var i=0;i<len;i++){xString+='x';}var d=new Date().getTime();if(window.performance&&typeof window.performance.now==="function"){d+=performance.now();//use high-precision timer if available
}var uuid=xString.replace(/[xy]/g,function(c){var r=(d+Math.random()*16)%16|0;d=Math.floor(d/16);// eslint-disable-next-line
return(c=='x'?r:r&0x3|0x8).toString(16);});return uuid;};/**
* packageForm(): Packages form element values with dashes in ids
* @param {String} id, id of form
* @returns {Object} formObj, key value form object
* @called-in: ['irrigation_create.js']
**/function packageForm(id){var elements=document.getElementById(''+id).elements;var formObj={};// eslint-disable-next-line
for(var i=0,element;element=elements[i++];){formObj[element.id.split('-')[1]]=element.value;}return formObj;}/**
* handleLog(): Handles valve, meter, engine log updates
* @param {Object} payload, log object(engine, meter, valve)
* @param {Array} log, state log array
* @param {String} prop, property for to measure against diff cases
* @param {String} id, id of engine, meter or valve object
* @returns {Array} newLog, new state log array
* @called-in: ['reducer.js']
**/function handleLog(_ref){var payload=_ref.payload,log=_ref.log,prop=_ref.prop,id=_ref.id;var newLog=[].concat(_toConsumableArray(log));// Case 1: Does the log have hours > 0 and does it exist in the newLog array
if(Number(payload[prop])>0&&!newLog.find(function(v){return v[id]===payload[id];}))newLog=newLog.concat(payload);// Case 2: Does the log have a value === 0 and exists in the newLog array
if(Number(payload[prop])===0&&newLog.find(function(v){return v[id]===payload[id];})){newLog=newLog.filter(function(v){return v[id]!==payload[id];});}// Case 3: Does the obj exist in newLog array and was the value changed
if(Number(payload[prop])>0&&newLog.find(function(v){return v[id]===payload[id];})){var _v=newLog.find(function(v){return v[id]===payload[id];});if(Number(_v[prop])!==Number(payload[prop])){newLog=newLog.filter(function(v){return v[id]!==payload[id];}).concat(Object.assign({},_v,payload));}}return newLog;}/**************** Calculations ****************//**
* calculateTotalFuelGallons()
* @param {Number} hours: engine hours run
* @param {Number} galPerHour: fuel gallons consumed per hour
* @returns {Number} total gallons consumed
* @called-in: ['irrigation_engine_hours.js']
**/function calculateTotalFuelGallons(_ref2){var hours=_ref2.hours,galPerHour=_ref2.galPerHour;if(!(hours,galPerHour))return 0.00;return Number(hours*galPerHour);}/**
* calculateTotalGallons()
* @param {Number} hours: valve hours run
* @param {Number} galPerMinute: gallons of water per minute
* @returns {Number} total gallons released
* @called-in: ['irrigation_valve_hours.js']
**/function calculateTotalGallons(_ref3){var hours=_ref3.hours,galPerMinute=_ref3.galPerMinute;if(!(hours,galPerMinute))return 0.00;return Number(hours*galPerMinute*60);}/* Sums a selected property of an array */function sumProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return total.toFixed(2);}function avgProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return(total/arr.length).toFixed(2);}/**
* preFillForm(): Prefills a form in the irrigation module
* @param {Number} data: form data
* @param {String} formId: id of the form to prefill
* @param {String} prop: custom prop to set element value to
* @returns
* @called-in: ['irrigation_actions.js']
**/function preFillForm(_ref4){var data=_ref4.data,formId=_ref4.formId,prop=_ref4.prop,style=_ref4.style;var form=document.getElementById(formId).elements;// eslint-disable-next-line
var _loop=function _loop(i,element){if(element.name==="")return'continue';var id=element.name.split('-')[1];var _d=data.find(function(d){return Number(d.id)===Number(id);});if(_d)element.value=_d[prop];if(_d&&style){element.style.backgroundColor='#bbdefb';element.style.fontWeight='bold';element.style.textAlign='center';element.style.color='#424242';}};for(var i=0,element;element=form[i++];){var _ret=_loop(i,element);if(_ret==='continue')continue;}return;}/**
* preFillMeterForm(): Prefills the meter form in the irrigation module. Special case for multiple inputs
* @param {Number} data: form data
* @param {String} formId: id of the form to prefill
* @returns
* @called-in: ['irrigation_actions.js']
**/function preFillMeterForm(_ref5){var data=_ref5.data,formId=_ref5.formId;var form=document.getElementById(formId).elements;// eslint-disable-next-line
var _loop2=function _loop2(i,element){var id=element.name.split('-')[1];if(!id){var _id=element.id.split('-')[0];var newId=_id.replace('meter','');id=newId;}var _d=data.find(function(d){return Number(d.meterId)===Number(id);});if(_d){for(var key in _d){var inputKey=element.id.split('-')[1];if(inputKey===key)element.value=_d[key];if(inputKey===key&&key==='totalGal'){element.style.backgroundColor='#bbdefb';element.style.fontWeight='bold';element.style.textAlign='center';element.style.color='#424242';}}}};for(var i=0,element;element=form[i++];){_loop2(i,element);}return;}/**
* clearForm(): Clears a form based on form id; resets any css on inputs
* @param {String} formId: id of the form to prefill
* @returns
* @called-in: ['irrigation_actions.js']
**/function clearForm(formId){var form=document.getElementById(formId).elements;// eslint-disable-next-line
for(var i=0,element;element=form[i++];){var dom=document.getElementById(element.id);dom.style.backgroundColor='#ffffff';dom.style.textAlign='initial';dom.style.fontWeight='normal';}return document.getElementById(formId).reset();}/**
* filterOldRecords(): Filters records that are older than two weeks. Uses date property
* @param {Object} r: record with date prop
* @returns {Bool} filtered condition
* @called-in: ['/components/chem_app/chem_app_create.js]
**/function filterOldRecords(r){return Math.abs(__WEBPACK_IMPORTED_MODULE_0_moment___default()(r.date).week()-__WEBPACK_IMPORTED_MODULE_0_moment___default()().week())<=1;}/* END */

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchChemicals;
/* harmony export (immutable) */ __webpack_exports__["e"] = createOrEditChemical;
/* harmony export (immutable) */ __webpack_exports__["f"] = sendFile;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectChemical;
/* harmony export (immutable) */ __webpack_exports__["h"] = selectChemicalToEdit;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearForm;
/* harmony export (immutable) */ __webpack_exports__["a"] = error;
/* harmony export (immutable) */ __webpack_exports__["b"] = success;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/*******************************************************************************
Chemical Actions: All interactions in the chemical component

*******************************************************************************/var $=window.$;var Materialize=window.Materialize;/**
* fetchChemicals(): Fetches all chemicals
* @returns {Array} chemicals
* @called-in: ['/components/chemical/chemical_view.js']
**/function fetchChemicals(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchChemicals',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["l" /* FETCH_CHEMICALS */],payload:res.data.chemicals});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error fetching chemicals.'));});};}/**
* createChemical(): Submits a new chemical
* @param {Array} formData: All form data
* @returns {Object} Newly created chemical
* @called-in: ['/components/chemical/chemical_view']
**/function createOrEditChemical(data,eid,type,path){var editedChemical=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};// Form validation check
for(var key in data){if(key==='name'&&data[key]==='')return error('Product Name is Required');if(key==='ingredients'&&data[key]==='')return error('Ingredients are Required');if(key==='type'&&data[key]==='')return error('Product Type is Required');if(key==='epaNo'&&data[key]==='')return error('EPA# is Required. If none exists, enter N/A');if(key==='rei'&&data[key]==='')return error('REI is Required. If none exists, enter 0');if(key==='preHarvestInterval'&&data[key]==='')return error('Pre-Harvest Interval is Required. If none exists, enter 0');}var formData=new FormData();if(document.getElementById('chemical-sds').files.length>0){var sds=document.getElementById('chemical-sds').files[0];formData.append('chemical-sds',sds,sds.name);}if(document.getElementById('chemical-label').files.length>0){var label=document.getElementById('chemical-label').files[0];formData.append('chemical-label',label,label.name);}if(document.getElementById('chemical-supplementalLabel').files.length>0){var suppLabel=document.getElementById('chemical-supplementalLabel').files[0];formData.append('chemical-supplementalLabel',suppLabel,suppLabel.name);}if(document.getElementById('chemical-specialLocalNeedsLabel').files.length>0){var slnLabel=document.getElementById('chemical-specialLocalNeedsLabel').files[0];formData.append('chemical-specialLocalNeedsLabel',slnLabel,slnLabel.name);}formData.append('editedBy',eid);for(var _key in data){formData.append(_key,data[_key]);}$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/'+path,formData,{params:{editedChemical:editedChemical},headers:{'content-type':'multipart/form-data'}}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])('chemical-form');success(res.data.msg);dispatch({type:type,payload:res.data.c});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* emailFile(): Emails a file
* @param {String} filename: Name of the file to download
* @returns {Object} blob: Actual file
* @called-in: ['/components/chemical/chemical_view->product_view.js']
**/function sendFile(filename,email){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/sendFile',{params:{filename:filename,email:email},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');success(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["m" /* EMAIL_FILE */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(error('There was an error emailing a file.'));});};}/**
* selectChemical(): Selects a chemical to view
* @param {Number} id: id of chemical
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
**/function selectChemical(c){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["n" /* SELECT_CHEMICAL */],payload:c.id};}/**
* selectChemicalToEdit(): Selects a chemical to edit
* @param {Number} id: id of chemical
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
* @notes: Select form value will not set without setTimeout
**/function selectChemicalToEdit(c){setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])('chemical-form',c);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["h" /* handleRecommendedDosage */])(c.recoDosage);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["i" /* handleMaxQuantity */])(c.maxQuantity);},200);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["o" /* SELECT_CHEMICAL_TO_EDIT */],payload:c.id};}/**
* clearForm(): Clears a form; resets state
* @param {Number} id: id of form
* @returns {Object} type, payload
* @called-in: ['/components/chemical/chemical_view']
**/function clearForm(formid){document.getElementById(formid).reset();return{type:__WEBPACK_IMPORTED_MODULE_0__types__["p" /* CLEAR_FORM */]};}function error(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_0__types__["q" /* ERROR */],err:err};}function success(msg){Materialize.toast(msg,4000,'rounded green');}/* END */

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**********************************************************
Cultivation Modal
**********************************************************/var $=window.$;var CultivationModal=function CultivationModal(WrappedComponent){return function(props){var id=props.id,onClick=props.onClick,footer=props.footer,view=props.view;$(document).ready(function(){$("#"+id).modal();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:""+id,className:"modal bottom-sheet modal-fixed-footer chem-app-display"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,props))),footer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-footer"},view?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#!",className:"modal-action modal-close waves-effect waves-green btn-flat",onClick:onClick},"Submit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#!",className:"modal-action modal-close waves-effect btn-flat"},"Close")):''));};};/* harmony default export */ __webpack_exports__["a"] = (CultivationModal);/* END */

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var CallbackQueue = __webpack_require__(214);
var PooledClass = __webpack_require__(44);
var ReactFeatureFlags = __webpack_require__(219);
var ReactReconciler = __webpack_require__(50);
var Transaction = __webpack_require__(83);

var invariant = __webpack_require__(6);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
5/22/2017
Alexander Self
Timesheet View
- Displays a list of employees
***************************************************************/var EmployeeList=function EmployeeList(_ref){var employees=_ref.employees,onclick=_ref.onclick,icon=_ref.icon,_class=_ref._class,header=_ref.header,isEditOrDelete=_ref.isEditOrDelete,_onClick=_ref.onClick;/* Check if this is the edit or delete module */if(isEditOrDelete){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection with-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-header"},header),employees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item",key:e.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"emp-name"},e.firstName," ",e.lastName)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn-floating waves-effect waves-light "+_class,onClick:function onClick(){return _onClick(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},icon)));}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection with-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-header"},header),employees.map(function(e){if(e.status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item",key:e.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"emp-name"},e.firstName," ",e.lastName)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn-floating waves-effect waves-light "+_class+" grey",onClick:function onClick(){return _onClick(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},icon)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item",key:e.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"emp-name"},e.firstName," ",e.lastName)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn-floating waves-effect waves-light "+_class,onClick:function onClick(){return _onClick(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},icon)));}));};/* harmony default export */ __webpack_exports__["a"] = (EmployeeList);/* END */

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = DatePicker;
/* harmony export (immutable) */ __webpack_exports__["i"] = TimePicker;
/* harmony export (immutable) */ __webpack_exports__["g"] = TextInput;
/* harmony export (immutable) */ __webpack_exports__["f"] = NumberInput;
/* harmony export (immutable) */ __webpack_exports__["e"] = Select;
/* harmony export (immutable) */ __webpack_exports__["d"] = SelectField;
/* unused harmony export SelectBlock */
/* unused harmony export SelectChemical */
/* unused harmony export SelectEquipment */
/* unused harmony export MultiSelect */
/* unused harmony export Textarea */
/* harmony export (immutable) */ __webpack_exports__["a"] = AutoComplete;
/* harmony export (immutable) */ __webpack_exports__["k"] = FileButton;
/* harmony export (immutable) */ __webpack_exports__["c"] = RadioButton;
/* harmony export (immutable) */ __webpack_exports__["j"] = CheckBox;
/* harmony export (immutable) */ __webpack_exports__["h"] = Switch;
/* unused harmony export HiddenInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
5/22/2017
Alexander Self
Inputs
- Different form inputs
***************************************************************/var $=window.$;function DatePicker(_ref){var id=_ref.id,label=_ref.label,min=_ref.min,max=_ref.max,disabled=_ref.disabled,required=_ref.required;if(required){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date",id:id,disabled:disabled,min:min,max:max,required:true}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date",id:id,disabled:disabled,min:min,max:max}));}function TimePicker(_ref2){var id=_ref2.id,label=_ref2.label,required=_ref2.required,onChange=_ref2.onChange;if(required){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"time",required:true,onChange:onChange}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"time",onChange:onChange}));}function TextInput(_ref3){var id=_ref3.id,label=_ref3.label,defaultValue=_ref3.defaultValue,placeholder=_ref3.placeholder,onChange=_ref3.onChange,required=_ref3.required;if(required){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"text",defaultValue:defaultValue,placeholder:placeholder,onChange:onChange,required:true}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"text",defaultValue:defaultValue,placeholder:placeholder,onChange:onChange}));}function NumberInput(_ref4){var id=_ref4.id,label=_ref4.label,min=_ref4.min,max=_ref4.max,step=_ref4.step,value=_ref4.value,onChange=_ref4.onChange,onBlur=_ref4.onBlur,defaultValue=_ref4.defaultValue,placeholder=_ref4.placeholder,disabled=_ref4.disabled,required=_ref4.required;if(required){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"number",min:min,max:max,step:step,value:value,onChange:onChange,onBlur:onBlur,defaultValue:defaultValue,placeholder:placeholder,disabled:disabled,required:true}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"number",min:min,max:max,step:step,value:value,onChange:onChange,onBlur:onBlur,defaultValue:defaultValue,placeholder:placeholder,disabled:disabled}));}function Select(_ref5){var id=_ref5.id,opts=_ref5.opts,label=_ref5.label,onChange=_ref5.onChange,required=_ref5.required,disabled=_ref5.disabled;if(required){$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default",onChange:onChange,required:true,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{id:opt.label,key:opt.val,value:opt.val},opt.label);})));}$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default",onChange:onChange,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{id:opt.label,key:opt.val,value:opt.val},opt.label);})));}/* Specifically for the fields
  Set selected as true for default value
*/function SelectField(_ref6){var id=_ref6.id,opts=_ref6.opts,label=_ref6.label,onChange=_ref6.onChange,selected=_ref6.selected,defaultValue=_ref6.defaultValue;$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default",onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){if(selected&&opt.field===defaultValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.field,value:opt.field,selected:true},opt.field);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.field,value:opt.field},opt.field);})));}/* Specifically for the fields */function SelectBlock(_ref7){var id=_ref7.id,opts=_ref7.opts,label=_ref7.label;$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.block,value:opt.block},opt.block);})));}/* Specifically for the fields
  Set selected as true for default value
*/function SelectChemical(_ref8){var id=_ref8.id,opts=_ref8.opts,label=_ref8.label,onChange=_ref8.onChange,selected=_ref8.selected,defaultValue=_ref8.defaultValue;$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default",onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){if(selected&&opt.name===defaultValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.name,value:opt.id,selected:true},opt.name);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.name,value:opt.id},opt.name);})));}/* Specifically for the equipment */function SelectEquipment(_ref9){var id=_ref9.id,opts=_ref9.opts,label=_ref9.label;$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:id,className:"browser-default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:opt.equipmentNo,value:opt.equipmentNo},opt.equipmentNo," - ",opt.description," (",opt.companyCode,")");})));}function MultiSelect(_ref10){var id=_ref10.id,opts=_ref10.opts,label=_ref10.label,onChange=_ref10.onChange,required=_ref10.required,disabled=_ref10.disabled;if(required){$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"input-field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{multiple:true,id:id,onChange:onChange,required:true,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{id:opt.label,key:opt.val,value:opt.val},opt.label);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label));}$(document).ready(function(){$("#"+id).material_select();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"input-field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{multiple:true,id:id,onChange:onChange,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}),opts.map(function(opt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{id:opt.label,key:opt.val,value:opt.val},opt.label);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,label));}function Textarea(_ref11){var id=_ref11.id,label=_ref11.label;$(document).ready(function(){$("textarea#"+id).characterCounter();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{id:id,className:"materialize-textarea","data-length":"350"}));}/* Materialze autocomplete: pass in onComplete callback to get value + id */function AutoComplete(_ref12){var id=_ref12.id,label=_ref12.label,data=_ref12.data,onComplete=_ref12.onComplete,onBlur=_ref12.onBlur,disabled=_ref12.disabled;$(document).ready(function(){$("#"+id).autocomplete({data:data,limit:10,minLength:1,onAutocomplete:function onAutocomplete(val){onComplete(val,id);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:id,className:"autocomplete",onBlur:onBlur,disabled:disabled}));}/* Basic file button */function FileButton(_ref13){var id=_ref13.id,name=_ref13.name,label=_ref13.label,_class=_ref13._class;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"file-field input-field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"btn btn-flat"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:_class},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"file"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"file-path-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"file-path-"+id,className:"file-path validate",type:"text"})));}function RadioButton(_ref14){var id=_ref14.id,name=_ref14.name,label=_ref14.label,value=_ref14.value,disabled=_ref14.disabled,onClick=_ref14.onClick,checked=_ref14.checked;if(checked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"radio",disabled:disabled,onClick:onClick,value:value,defaultChecked:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"radio",disabled:disabled,onClick:onClick,value:value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label));}function CheckBox(_ref15){var id=_ref15.id,name=_ref15.name,label=_ref15.label,disabled=_ref15.disabled,value=_ref15.value,onChange=_ref15.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"checkbox",value:value,disabled:disabled,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label));}function Switch(_ref16){var id=_ref16.id,name=_ref16.name,label=_ref16.label,disabled=_ref16.disabled,onClick=_ref16.onClick,onChange=_ref16.onChange,switchLabel1=_ref16.switchLabel1,switchLabel2=_ref16.switchLabel2,value=_ref16.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"switch"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,switchLabel1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",onClick:onClick,onChange:onChange,value:value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"lever"}),switchLabel2));}function HiddenInput(_ref17){var id=_ref17.id,value=_ref17.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,type:"hidden",value:value}));}/* END */

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = acresPerHour;
/* harmony export (immutable) */ __webpack_exports__["g"] = density;
/* harmony export (immutable) */ __webpack_exports__["e"] = estimatedLbs;
/* harmony export (immutable) */ __webpack_exports__["j"] = percentComplete;
/* harmony export (immutable) */ __webpack_exports__["c"] = sumProp;
/* harmony export (immutable) */ __webpack_exports__["l"] = avgProp;
/* harmony export (immutable) */ __webpack_exports__["i"] = handleInterval;
/* harmony export (immutable) */ __webpack_exports__["k"] = handleBalance;
/* harmony export (immutable) */ __webpack_exports__["b"] = initLineChart;
/* harmony export (immutable) */ __webpack_exports__["o"] = initBubbleChart;
/* harmony export (immutable) */ __webpack_exports__["a"] = initBarChart;
/* unused harmony export initPolarChart */
/* unused harmony export initPieChart */
/* harmony export (immutable) */ __webpack_exports__["n"] = initDoughnutChart;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateMechHarvestForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mech_harvest_calc__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__mech_harvest_calc__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__mech_harvest_calc__["d"]; });
/*******************************************************************************
Hawaiian Macadamia Nut Services
12.31.18
Harvest Utilities
Calculation functions used in the mechHarvest module
*******************************************************************************/var Materialize=window.Materialize;/* Calculates acres per hour */function acresPerHour(hours,acres){if(!(acres&&hours))return 0.00;return(Number(acres)/Number(hours)).toFixed(2);}/* Calculates lbs/tree or density */function density(weight,treeCount){if(!(weight&&treeCount))return 0.00;return(Number(weight)/Number(treeCount)).toFixed(2);}/* Calculates Estimated total lbs*/function estimatedLbs(lbs,containerCount){if(!(lbs&&containerCount))return 0.00;return(Number(lbs)*Number(containerCount)).toFixed(2);}/* Moved to mech_harvest_calc.js (testable without a browser); re-exported for existing callers *//* Calculates the percentage of acres completed */function percentComplete(acresCompleted,totalAcres){if(!(acresCompleted&&totalAcres))return 0.00;return(acresCompleted/totalAcres).toFixed(2);}/* Sums a selected property of an array */function sumProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return total.toFixed(2);}/* Averages a selected property of an array */function avgProp(prop,arr){if(!(prop&&arr))return 0.00;var total=arr.reduce(function(acc,cur){return acc+Number(cur[prop]);},0);return(total/arr.length).toFixed(2);}/* Handles the start of an interval: Time between field harvests after completion */function handleInterval(previousHarvests){// If no other harvest exist for the round and season of the selected field, start interval on 1(in days)
if(previousHarvests.length===0)return 1.0;// The intervals get updated daily in another script; if other harvests exist and the intervals have been updated
// Set the new harvest record to the existing intervals for a given field
return previousHarvests[0].intervals;}/* Displays the balance of remaining acres */function handleBalance(previousHarvest,selectedField){if(!(previousHarvest&&selectedField))return 0.0;var existingAcres=previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);return(selectedField.mechHarvest-existingAcres).toFixed(2);}function initLineChart(_ref){var label=_ref.label,labels=_ref.labels,data=_ref.data,backgroundColor=_ref.backgroundColor,_ref$fill=_ref.fill,fill=_ref$fill===undefined?false:_ref$fill;return{labels:labels,datasets:[{data:data,backgroundColor:backgroundColor,pointBorderColor:backgroundColor,borderColor:backgroundColor,pointBackgroundColor:'#000',label:label,fill:fill}]};}function initBubbleChart(_ref2){var label=_ref2.label,labels=_ref2.labels,data=_ref2.data,_ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?false:_ref2$fill;return{labels:labels,datasets:[{label:label,fill:fill,lineTension:0.1,backgroundColor:'rgba(75,192,192,0.4)',borderColor:'rgba(75,192,192,1)',borderCapStyle:'butt',borderDash:[],borderDashOffset:0.0,borderJoinStyle:'miter',pointBorderColor:'rgba(75,192,192,1)',pointBackgroundColor:'#fff',pointBorderWidth:1,pointHoverRadius:1,pointHoverBackgroundColor:'rgba(75,192,192,1)',pointHoverBorderColor:'rgba(220,220,220,1)',pointHoverBorderWidth:1,pointRadius:1,pointHitRadius:1,data:data}]};}function initBarChart(_ref3){var label=_ref3.label,labels=_ref3.labels,data=_ref3.data,backgroundColor=_ref3.backgroundColor,borderColor=_ref3.borderColor,borderWidth=_ref3.borderWidth,hoverBackgroundColor=_ref3.hoverBackgroundColor,hoverBorderColor=_ref3.hoverBorderColor,_ref3$fill=_ref3.fill,fill=_ref3$fill===undefined?false:_ref3$fill;return{labels:labels,datasets:[{data:data,backgroundColor:backgroundColor,label:label,fill:fill,borderColor:borderColor,borderWidth:borderWidth,hoverBackgroundColor:hoverBackgroundColor,hoverBorderColor:hoverBorderColor}]};}function initPolarChart(_ref4){var label=_ref4.label,labels=_ref4.labels,data=_ref4.data,backgroundColor=_ref4.backgroundColor;return{labels:labels,datasets:[{data:data,backgroundColor:backgroundColor,label:label}]};}function initPieChart(_ref5){var label=_ref5.label,labels=_ref5.labels,data=_ref5.data,backgroundColor=_ref5.backgroundColor;return{labels:labels,datasets:[{data:data,backgroundColor:backgroundColor,label:label}]};}function initDoughnutChart(_ref6){var label=_ref6.label,labels=_ref6.labels,data=_ref6.data,backgroundColor=_ref6.backgroundColor;return{labels:labels,datasets:[{data:data,backgroundColor:backgroundColor,label:label}]};}/**
* formatMechHarvestKey(): Returns the mech harvest input label from individual harvest form
* @param {String} key: object key for mech harvest records 
* @returns {String} 
* @called-in: [right below]
**/function formatMechHarvestKey(key){if(!key)return'';var values={"field":"Field","block":"Block","treesCovered":"Trees Covered","hours":"Total Hours","containerType":"Container Type","containerCount":"Total Containers","estLbsPerContainer":"Est. Lbs/Container","status":"Status","equipmentNo":"Equipment No.","eid":"Equipment Operator"};return values[key];}/**
* validateMechHarvestForm(): Name says it all; verifies information is correct and 
  returns empty or full objects depending on the error; used in both create/edit
* @param {String} season: current season id(used for previous mech harvest fetches)  
* @param {Array} employees: the entire dataset of active employees
* @returns {Object} {} harvest data set or empty set
* @called-in: ['/components/harvest/create/mechHarvest_create']
**/function validateMechHarvestForm(_ref7){var seasons=_ref7.seasons,employees=_ref7.employees,equipmentList=_ref7.equipmentList;var date=document.getElementById('mech-date').value;var location=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* getSelectedValue */])('mech-location');var round=document.getElementById('mech-round').value;var notes=document.getElementById('mech-notes').value;var equipment=document.getElementById('mech-equipmentNo').value;var season=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mech_harvest_calc__["a" /* seasonForLocation */])(seasons,location);if(!season){Materialize.toast('No current harvest season for location '+location+'. Contact an administrator.',4000,'rounded red');return{};}if(!(date&&location&&round)){Materialize.toast('A date, location and round are required to add harvest records.',4000,'rounded red');return{};}var harvest=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* packageDashForm */])('mechHarvest-individual-form');if(location==='71'){if(harvest.field==="F525"||harvest.field==="F520"){// Added 9.11.25 on req from P.Salmo(Harvesting Olsen orchards)
for(var key in harvest){if(harvest[key]===''&&key!=='block'){if(key!=='notes'||key!=='eid'){Materialize.toast('Entire form must be filled. Missing: '+formatMechHarvestKey(key),4000,'rounded red');return{};}}}}else{for(var _key in harvest){if(harvest[_key]===''){if(_key!=='notes'||_key!=='eid'){Materialize.toast('Entire form must be filled. Missing: '+formatMechHarvestKey(_key),4000,'rounded red');return{};}}}}}else if(location==='72'){for(var _key2 in harvest){if(_key2==='block'||_key2==='notes'||_key2!=='eid')continue;else{if(harvest[_key2]===''){Materialize.toast('Entire form must be filled. Missing: '+formatMechHarvestKey(_key2),4000,'rounded red');return{};}}}}var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* findEmployeeByName */])(harvest.eid,employees);if(Object.keys(emp).length===0){Materialize.toast('The following employee does not exist: '+harvest.eid+'. Please check spelling and try again.',4000,'rounded red');return{};}if(equipment===''){Materialize.toast('Please select the equipment from the autocomplete list',4000,'rounded red');return{};}var equip=equipmentList.find(function(e){return e.equipmentNo+' - '+e.description===equipment;});if(!equip){Materialize.toast('Please select the equipment from the autocomplete list',4000,'rounded red');return{};}return Object.assign({},harvest,{date:date,location:location,round:round,notes:notes,intervals:1.0,seasonId:season.id,eid:emp.eid});}/* END */

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(195);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(44);

var emptyFunction = __webpack_require__(29);
var warning = __webpack_require__(10);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = updateSelectedLocation;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateSelectedGang;
/* harmony export (immutable) */ __webpack_exports__["k"] = notifyEmployees;
/* harmony export (immutable) */ __webpack_exports__["h"] = notifySelectedEmployees;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMessages;
/* unused harmony export fetchGangs */
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchLocations;
/* harmony export (immutable) */ __webpack_exports__["b"] = searchMessagesDatabase;
/* harmony export (immutable) */ __webpack_exports__["d"] = updatePrefillMessage;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateOptionalMessage;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateChips;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeChip;
/* harmony export (immutable) */ __webpack_exports__["a"] = toastDisplayed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
;var Materialize=window.Materialize;/**
* updateSelectedLocation(): update list of employees to only include those at specified location
* @params {String}: location: location of employees to select
**/function updateSelectedLocation(loc){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchEmployeeData',{headers:{authorization:localStorage.getItem('token')},params:{location:loc}}).then(function(res){dispatch(fetchGangs(loc));dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_21" /* UPDATE_SELECTED_LOCATION */],payload:{location:loc,employees:res.data}});}).catch(function(e){return Materialize.toast('There was an error fetching employees by location',4000,'rounded red');});};}/**
* updateSelectedDepartment(): update display of employees to account for department
* @params {String}: location: location of employees
* @params {String}: dept: department to get employees from
**/function updateSelectedGang(location,gang){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchEmployeeData',{headers:{authorization:localStorage.getItem('token')},params:{location:location,gang:gang}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_22" /* UPDATE_SELECTED_GANG */],payload:{gang:gang,employees:res.data}});}).catch(function(e){return Materialize.toast('There was an error updating the selected gang',4000,'rounded red');});};}/**
* notifyEmployees(): send information to server to send out message
* @params {String}: location: location of employees
* @params {String}: department: department to be notified
* @params {String}: message: message to be sent to employees
**/function notifyEmployees(location,department,message,eid){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/notifyEmployees',{headers:{authorization:localStorage.getItem('token')},params:{location:location,dept:department,message:message,eid:eid}}).then(function(res){dispatch(getMessages());dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_23" /* NOTIFICATION_SENT */],payload:res.data});}).catch(function(e){return Materialize.toast('There was an error notifying employees by SMS or call',4000,'rounded red');});};}/**
* notifySelectedEmployees(): send information to server to send out message
* @params {Object}: employees: list of custom selected employees
* @params {String}: message: message to be sent to employees
**/function notifySelectedEmployees(employees,message,eid){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/notifySelectedEmployees',{headers:{authorization:localStorage.getItem('token')},params:{employees:employees,message:message,eid:eid}}).then(function(res){dispatch(getMessages());dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_23" /* NOTIFICATION_SENT */],payload:res.data});}).catch(function(e){return Materialize.toast('There was an error notifying employees by SMS or call',4000,'rounded red');});};}/**
* getMessages(): get previously sent messages from database
**/function getMessages(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchSMSMessages',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_24" /* UPDATE_MESSAGE_LIST */],payload:res.data});}).catch(function(e){return Materialize.toast('There was an error fetching sent messages',4000,'rounded red');});};}/**
* fetchGangs(): update list of gangs in gang dropdown when location is selected from location dropdown
* @params {String}: location: location of gangs to fetch
**/function fetchGangs(loc){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchGangsForSMS',{headers:{authorization:localStorage.getItem('token')},params:{location:loc}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_25" /* FETCH_GANGS_FOR_SMS */],payload:res.data.gangs});}).catch(function(e){return Materialize.toast('There was an error fetching gangs',4000,'rounded red');});};}/**
* fetchLocations(): get all locations with employees from db to populate location dropdown
**/function fetchLocations(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchLocations',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_26" /* FETCH_LOCATIONS */],payload:res.data});}).catch(function(e){return Materialize.toast('There was an error fetching locations',4000,'rounded red');});};}/**
* searchMessagesDatabase(): search for messages in db between specified dates
* @params {String}: start: first date to search for
* @params {String}: last: last date to search for
**/function searchMessagesDatabase(start,end){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/searchMessagesDatabase',{headers:{authorization:localStorage.getItem('token')},params:{start:start,end:end}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_27" /* SEARCH_MESSAGES_DATABASE */],payload:res.data});}).catch(function(e){return Materialize.toast('There was an error searching for sent messages',4000,'rounded red');});};}/**
* updatePrefillMessage(): update message selected from list
* @params {String}: message: the message selected
**/function updatePrefillMessage(message){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_28" /* UPDATE_PREFILL_MESSAGE */],payload:message});};}/**
* updateOptionalMessage(): update custom message typed by user
* @params {String}: message: the message typed by the user
**/function updateOptionalMessage(message){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_29" /* UPDATE_OPTIONAL_MESSAGE */],payload:message});};}/**
* updateChips(): add an employee to list of custom employee selection
* @params {String}: firstName: first name of employee to add
* @params {String}: lastName: last name of employee to add
* @params {String}: mobile: mobile phone number of employee to add
* @params {String}: number: landline number of employee to add
* @params {String}: id: id of employee to add
**/function updateChips(firstName,lastName,mobile,number,id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_30" /* UPDATE_CHIPS */],payload:{first:firstName,last:lastName,mobilePhone:mobile,phone:number,id:id}});};}/**
* removeChip(): update list of selected employees by removing a person
* @params {String}: id: id (not eid) of employee to remove
**/function removeChip(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_31" /* REMOVE_CHIP */],payload:id});};}/**
* toastDisplayed(): record that a toast with the success/error message was posted after a message attempt
**/function toastDisplayed(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_32" /* TOAST_DISPLAYED */],payload:true});};}/* END */

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(566),
    getValue = __webpack_require__(590);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var arrayOf = _react.PropTypes.arrayOf;
var oneOfType = _react.PropTypes.oneOfType;
var element = _react.PropTypes.element;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/***************************************************************
12/07/2018
Alexander Self
Mech harvest table
- Table summary of mech harvest
***************************************************************/var MechHarvestTable=function MechHarvestTable(_ref){var harvest=_ref.harvest,totals=_ref.totals,field=_ref.field,_onClick=_ref.onClick;if(!harvest)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'harvest-headers'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-date',onClick:function onClick(e){return _onClick(e.target.id);}},'Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-round',onClick:function onClick(e){return _onClick(e.target.id);}},'Round'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-field',onClick:function onClick(e){return _onClick(e.target.id);}},'Field'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-block',onClick:function onClick(e){return _onClick(e.target.id);}},'Block'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-status',onClick:function onClick(e){return _onClick(e.target.id);}},'Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-hours',onClick:function onClick(e){return _onClick(e.target.id);}},'Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-treesCovered',onClick:function onClick(e){return _onClick(e.target.id);}},'Trees'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-acresCompleted',onClick:function onClick(e){return _onClick(e.target.id);}},'Acres Complete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-acresBalance',onClick:function onClick(e){return _onClick(e.target.id);}},'Acres Balance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-percentComplete',onClick:function onClick(e){return _onClick(e.target.id);}},'% Complete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-containerCount',onClick:function onClick(e){return _onClick(e.target.id);}},'Container #'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-estimatedLbs',onClick:function onClick(e){return _onClick(e.target.id);}},'Est. lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-density',onClick:function onClick(e){return _onClick(e.target.id);}},'Density'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{id:'h-acresPerHour',onClick:function onClick(e){return _onClick(e.target.id);}},'Acres/Hr'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:h.id?h.id:h.guid?h.guid:Math.random()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(h.date).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.round),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.field),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.block),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.status===0||h.status==='0'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.hours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.treesCovered),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.acresCompleted),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.acresBalance),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,(h.percentComplete*100).toFixed(2),'%'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.containerCount),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.estimatedLbs),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.density,' lbs/tree'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.acresPerHour));})),totals?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('hours',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('treesCovered',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('acresCompleted',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["k" /* handleBalance */])(harvest,field)<0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'day-off'},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["k" /* handleBalance */])(harvest,field)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["k" /* handleBalance */])(harvest,field))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('percentComplete',harvest)*100).toFixed(2),'%'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('containerCount',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('estimatedLbs',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('density',harvest),' lbs/tree'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('acresPerHour',harvest)))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null));};/* harmony default export */ __webpack_exports__["a"] = (MechHarvestTable);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Indicates that navigation was caused by a call to history.push.
 */


exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(114);
var setInnerHTML = __webpack_require__(85);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);
var setTextContent = __webpack_require__(232);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(680);
var ReactInstrumentation = __webpack_require__(26);

var warning = __webpack_require__(10);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = {};

function compilePattern(pattern) {
  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern);

  var regexpSource = _compilePattern2.regexpSource;
  var paramNames = _compilePattern2.paramNames;
  var tokens = _compilePattern2.tokens;


  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames;
  var paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern);

  var tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var ReactBaseClasses = __webpack_require__(246);
var ReactChildren = __webpack_require__(745);
var ReactDOMFactories = __webpack_require__(746);
var ReactElement = __webpack_require__(53);
var ReactPropTypes = __webpack_require__(747);
var ReactVersion = __webpack_require__(748);

var createReactClass = __webpack_require__(749);
var onlyChild = __webpack_require__(753);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var ReactCurrentOwner = __webpack_require__(38);

var warning = __webpack_require__(10);
var canDefineProperty = __webpack_require__(250);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(248);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = createGang;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchGangs;
/* harmony export (immutable) */ __webpack_exports__["h"] = editGang;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteGang;
/* harmony export (immutable) */ __webpack_exports__["i"] = addGangMember;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeGangMember;
/* harmony export (immutable) */ __webpack_exports__["k"] = gangAutocomplete;
/* harmony export (immutable) */ __webpack_exports__["g"] = gangEditAutocomplete;
/* harmony export (immutable) */ __webpack_exports__["b"] = selectGang;
/* harmony export (immutable) */ __webpack_exports__["d"] = selectGangToEdit;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeGangMemberFromEdit;
/* harmony export (immutable) */ __webpack_exports__["f"] = addGangMemberToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/**************************************************************
Alexander Self
Team Actions
8/22/17
**************************************************************/var Materialize=window.Materialize;var $=window.$;/********************** Asynchronous Function *********************************//* Creates a new gang
   Called in components/gangs/create/gang_create.js
*/function createGang(emps,gangs){var gangId=document.getElementById('gang-builder-No').value;var gangLoc=document.getElementById('gang-builder-location').value;var gangCount=emps.length;if(!(gangId&&gangLoc))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please add a Gang No. and Gang Location');if(gangCount===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please add at least one employee to create a gang.');var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=gangs[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var g=_step.value;if(g.gangId===gangId)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Gang No. is taken. Please try again.');}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}document.getElementById('gang-builder-No').value='';document.getElementById('gang-builder-location').value='';$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/createGang',{gangId:gangId,gangLoc:gangLoc,gangCount:gangCount,emps:emps}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_42" /* CREATE_GANG */],payload:res.gangs,selectedEmps:emps});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error creating a new gang. Please try another Gang No.'));});};}/* Fetches gangs from the server */function fetchGangs(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchGangs',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_43" /* FETCH_GANGS */],payload:res.gangs});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching gangs'));});};}/* Submits a gang for editing */function editGang(gang){var tempGangId=document.getElementById('edit-gang-builder-gangId').value;var tempGangLoc=document.getElementById('edit-gang-builder-gangLoc').value;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/editGang',{gang:gang,tempGangId:tempGangId,tempGangLoc:tempGangLoc}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_44" /* EDIT_GANG */],payload:res.gangs});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error editing a gang'));});};}function deleteGang(gang){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/deleteGang',{gang:gang}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_45" /* DELETE_GANG */],payload:res.gangs,oldGang:gang});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error deleting a gang'));});};}/********************** Synchronous Function **********************************//* Adds a gang member to the viewing table during create */function addGangMember(emp){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_46" /* ADD_GANG_MEMBER */],payload:emp};}/* Removes a gang member from the table during create */function removeGangMember(emp){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_47" /* REMOVE_GANG_MEMBER */],payload:emp};}/* Adds a member to a gang using the autocomplete */function gangAutocomplete(e,id){document.getElementById(id).value='';return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_48" /* GANG_AUTOCOMPLETE */],payload:e};}/* Adds a member to a gang using the autocomplete */function gangEditAutocomplete(e,id){document.getElementById(id).value='';return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_49" /* GANG_EDIT_AUTOCOMPLETE */],payload:e};}/* Selects a gang for viewing */function selectGang(gangId){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_50" /* SELECT_GANG */],payload:gangId};}/* Selects a gang to edit */function selectGangToEdit(gangId){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_51" /* SELECT_GANG_TO_EDIT */],payload:gangId};}/* Removes a gang member from table and adds to employee list */function removeGangMemberFromEdit(emp){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_52" /* REMOVE_GANG_MEMBER_FROM_EDIT */],payload:emp};}/* Adds an employee to a gang during editing */function addGangMemberToEdit(emp,selectedGang){// Make sure a gang is selected prior to adding an employee
if(Object.keys(selectedGang).length<=1)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please select a gang before adding an employee');return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_53" /* ADD_GANG_MEMBER_TO_EDIT */],payload:emp};}/* END */

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
var Tabs=function Tabs(_ref){var tabs=_ref.tabs,id=_ref.id,level=_ref.level;// Set Level for each iterated item to enforce authorization
function authmap(tab,i){if(level>=tab.level){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:''+tab.url+i,className:'tab col s3',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push(tab.url);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'tab-text',to:''+tab.url},tab.name));}return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:id,className:'tabs tabs-fixed-width'},tabs.map(authmap)));};/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Work Table Summary of timesheet to be submitted for review;
***************************************************************/var TimesheetWorkTable=function TimesheetWorkTable(_ref){var workPerformed=_ref.workPerformed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Work'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Temp Grade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pay Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cost Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Subaccount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Equip No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Equip Trailer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Detail'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Differential'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trainer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,workPerformed.map(function(w){if(w.field==='Select')w.field='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.workPerformed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.tempGrade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.block),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.paycode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.costCenterCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.subAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.equipmentNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.equipmentTrailerNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.detail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.differential),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Number(w.trainer)===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'done'):''));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Total Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* totalHours */])(workPerformed)))))));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetWorkTable);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(208);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used for native method references */
var objectProto = Object.prototype;

/** Used to resolve the internal [[Class]] of values */
var toString = objectProto.toString;

/** Used to detect if a method is native */
var reNative = RegExp('^' +
  String(toString)
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/toString| for [^\]]+/g, '.*?') + '$'
);

module.exports = reNative;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(75),
    getRawTag = __webpack_require__(587),
    objectToString = __webpack_require__(614);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(115);
var EventPluginUtils = __webpack_require__(116);
var ReactErrorUtils = __webpack_require__(120);

var accumulateInto = __webpack_require__(225);
var forEachAccumulated = __webpack_require__(226);
var invariant = __webpack_require__(6);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(61);
var EventPluginUtils = __webpack_require__(116);

var accumulateInto = __webpack_require__(225);
var forEachAccumulated = __webpack_require__(226);
var warning = __webpack_require__(10);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

var getEventTarget = __webpack_require__(125);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchAllEmployees;
/* harmony export (immutable) */ __webpack_exports__["e"] = submitProfileToCreate;
/* harmony export (immutable) */ __webpack_exports__["f"] = submitProfileForLogin;
/* harmony export (immutable) */ __webpack_exports__["b"] = submitProfileToEdit;
/* harmony export (immutable) */ __webpack_exports__["c"] = submitLoginToEdit;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchEmployeeProfile;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchEmployeeProfileByName;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchPostionType;
/* harmony export (immutable) */ __webpack_exports__["j"] = downloadEmployees;
/* harmony export (immutable) */ __webpack_exports__["i"] = uploadProfileImage;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchProfileToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/************************************************************************
6/19/17
All Actions for timesheet, auth interactions
************************************************************************/var Materialize=window.Materialize;var $=window.$;var FileSaver=__webpack_require__(176);/****************************  ASYNCHRONOUS Actions ***************************//*
  Fetch all employees based on level and email;
  If the level is 1, only fetch the employee
  If level is 2; fetch only their employees
  If level is 3 or greater, fetch all employees
*/function fetchAllEmployees(level,email,eid){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchAllEmployees',{params:{level:level,email:email,eid:eid},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_33" /* FETCH_LEVEL_EMPLOYEES */],payload:res.employees});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching all employees'));});};}/* Submits a profile to create a new employee */function submitProfileToCreate(profile,employees){if(!(profile.firstName&&profile.lastName))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please enter a first name and last name.');$('#preloader').css('display','block');if(document.getElementById('create-profile-partTime').checked)profile.partTime=1;else profile.partTime=0;// Check if they selected a manager to fill in
if(profile.managerId){var manager=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* findEmployeeByName */])(profile.managerId,employees);profile.managerId=manager.eid;}// Make sure unique eid
if(employees.find(function(e){return e.eid===profile.eid;}))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Employee ID already exists');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* clearForm */])('profile-create-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/submitProfileToCreate',{profile:profile}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'green rounded');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_34" /* CREATE_EMPLOYEE_PROFILE */],payload:res.employees});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error creating a user profile'));});};}/* Submits a profile to create a new employee login */function submitProfileForLogin(profile,employees){if(profile.password!==profile.passwordVerify)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Passwords must match');if(!(profile.email&&profile.eid&&profile.level))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Email, Employee ID and Access Level required');$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* clearForm */])('profile-createAuth-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/submitProfileForLogin',{profile:profile}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');if(res.error)__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])(res.error);Materialize.toast(res.msg,4000,'green rounded');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_35" /* CREATE_LOGIN_PROFILE */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])(err));});};}/* Submits a profile for editing */function submitProfileToEdit(profile,employees,employee){if(!(profile.firstName&&profile.lastName&&profile.eid))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please enter a first name, last name, employee id.');$('#preloader').css('display','block');if(document.getElementById('edit-profile-partTime').checked)profile.partTime=1;else profile.partTime=0;var manager=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* findEmployeeByName */])(profile.managerId,employees);if(manager)profile.managerId=manager.eid;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* clearForm */])('profile-edit-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/submitProfileToEdit',{profile:profile,employee:employee}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'green rounded');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_36" /* SUBMIT_EDIT_PROFILE */],payload:res.employees});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error editing the profile '+err));});};}/* Submits a profile for editing */function submitLoginToEdit(profile,employee){if(!(profile.email&&profile.eid&&profile.level))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Email, Employee ID and Access Level required');if(profile.password!==profile.passwordVerify)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Passwords must match');$('#preloader').css('display','block');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* clearForm */])('profile-editAuth-form');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/submitLoginToEdit',{profile:profile,employee:employee}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.msg,4000,'green rounded');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_37" /* SUBMIT_EDIT_LOGIN */],payload:res.employees});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error editing the profile '+err));});};}/* Fetches an employee profile from button clicks */function fetchEmployeeProfile(employee){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchEmployeeProfile',{params:{employee:employee},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_38" /* FETCH_EMPLOYEE_PROFILE */],payload:res.profile});}).catch(function(err){$('#preloader').css('display','none');console.error(err);dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching employee information'));});};}/* Fetches an employee profile from autocomplete name selection */function fetchEmployeeProfileByName(emp){if(!emp)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please enter an employees name');document.getElementById('employee-profile-list').value='';$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchEmployeeProfile',{params:{employee:emp},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_38" /* FETCH_EMPLOYEE_PROFILE */],payload:res.profile});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching employee information'));});};}/* Fetches position types */function fetchPostionType(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchPostionType',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){//console.log(res);
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_39" /* FETCH_POSITION_TYPE */],payload:res.positionTypes});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching position types'));});};}/* Fetches position types */function downloadEmployees(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/downloadEmployees',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){var blob=new Blob([res.csv],{type:"text/plain;charset=utf-8"});FileSaver.saveAs(blob,'Current Employee List '+__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD')+'.csv');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_40" /* DOWNLOAD_EMPLOYEES */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching position types'));});};}/*******************************************************************
Specific for Image uploads
********************************************************************/function uploadProfileImage(eid){if(!eid)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('Please select an employee prior to uploading a picture');$('#preloader').css('display','block');var data=new FormData();var file=document.getElementById('employee-profile-img').files[0];data.append('imgUploader',file,file.name);return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/uploadProfileImage',data,{params:{eid:eid},headers:{'content-type':'multipart/form-data'}}).then(function(res){$('#preloader').css('display','none');Materialize.toast('Successfully uploaded an image',4000,'rounded green');document.getElementById('file-path').value='';dispatch({type:'DUMMY'});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error uploading a profile image'));});};}/****************************  SYNCHRONOUS Actions ***************************//* Fetches an employee profile locally as all profiles are stored in memory */function fetchProfileToEdit(e,employees){var manager=void 0;if((typeof e==='undefined'?'undefined':_typeof(e))==='object'){// User clicked on employee button
// Get manager name
manager=employees.find(function(emp){return emp.eid===e.managerId;});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["m" /* fillEdit */])('profile-edit-form',e);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["m" /* fillEdit */])('profile-editAuth-form',e);if(manager!==undefined){document.getElementById('edit-profile-managerId').value=manager.firstName+' '+manager.lastName;}document.getElementById('employee-profile-list').value='';return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_41" /* FETCH_EMPLOYEE_TO_EDIT */],payload:e};}else{// User is searching for employees by AutoComplete
document.getElementById('employee-profile-list').value='';manager=employees.find(function(emp){return emp.eid===e.managerId;});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["m" /* fillEdit */])('profile-edit-form',e);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["m" /* fillEdit */])('profile-editAuth-form',e);if(manager!==undefined){document.getElementById('edit-profile-managerId').value=manager.firstName+' '+manager.lastName;}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_41" /* FETCH_EMPLOYEE_TO_EDIT */],payload:e};}}/* *//* END */

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_user_jpg__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_user_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_user_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs__ = __webpack_require__(8);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Table Summary of e to be submitted for review;
***************************************************************/var EmployeeTable=function EmployeeTable(_ref){var employees=_ref.employees,onClick=_ref.onClick,noClick=_ref.noClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Position'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Position Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Department'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'EID'),noClick?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Remove'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,employees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'responsive-img circle',height:'30',width:'30',alt:'',src:__WEBPACK_IMPORTED_MODULE_1__img_user_jpg___default.a,onError:function onError(e){return e.target.src='img/user.jpg';}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.firstName===null?'':e.firstName,' ',e.lastName===null?'':e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.positionTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.positionType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.department),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.eid===null?'':e.eid),noClick?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["n" /* FloatingButton */],{color:'red',icon:'clear',onclick:function onclick(){return onClick(e);}})));})));};/* harmony default export */ __webpack_exports__["a"] = (EmployeeTable);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
/******************************************************************************
Tabs
******************************************************************************/var Tabs=function Tabs(_ref){var tabs=_ref.tabs,id=_ref.id,level=_ref.level;// Set Level for each iterated item to enforce authorization
if(!tabs)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);function authmap(tab,i){if(level>=tab.level){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:''+tab.url+i,className:'tab col s3',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push(tab.url);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'tab-text cult-tabs',to:''+tab.url},tab.name));}return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:id,className:'tabs-fixed-width tabs'},tabs.map(authmap)));};/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PASCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEATHER_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_airQualityIndex_svg__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_airQualityIndex_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_airQualityIndex_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_radiation_svg__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_radiation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_radiation_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_so2_jpg__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_so2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_so2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_co_jpg__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_co_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_co_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_no2_v2_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_no2_v2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_no2_v2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_pm2_5_v2_svg__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_pm2_5_v2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_pm2_5_v2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_pm10_v2_svg__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_pm10_v2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_pm10_v2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_ozone_svg__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_ozone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_ozone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_primaryPollutant_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_primaryPollutant_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_primaryPollutant_png__);
// Convert from inHg to Pascals. 1 inHg = 33.86 pascals
var PASCAL=33.86;/*
  Used in Time Slider: Maps integer values to time on a 6am - 12a slider
*/var TIME={1:'06',2:'07',3:'08',4:'09',5:'10',6:'11',7:'12',8:'13',9:'14',10:'15',11:'16',12:'17',13:'18',14:'19',15:'20',16:'21',17:'22',18:'23',19:'00'};var WEATHER_CODES={'freezing_rain_heavy':'wi-day-sleet-storm','Heavy Freezing Rain':'wi-day-sleet-storm','freezing_rain':'wi-day-sleet','Freezing Rain':'wi-day-sleet','freezing_rain_light':'wi-day-sleet','Light Freezing Rain':'wi-day-sleet','freezing_drizzle':'wi-day-sleet','Freezing Drizzle':'wi-day-sleet','ice_pellets_heavy':'wi-day-snow-thunderstorm','Heavy Ice Pellets':'wi-day-snow-thunderstorm','ice_pellets':'wi-day-snow','ice_pellets_light':'wi-day-snow','Light Ice Pellets':'wi-day-snow','snow_heavy':'wi-day-snow-thunderstorm','Heavy Snow':'wi-day-snow-thunderstorm','snow':'wi-day-snow','Snow':'wi-day-snow','snow_light':'wi-day-snow','Light Snow':'wi-day-snow','flurries':'wi-day-storm-showers','Flurries':'wi-day-storm-showers','tstorm':'wi-day-thunderstorm','Thunderstorm':'wi-day-thunderstorm','rain_heavy':'wi-day-rain','Heavy Rain':'wi-day-rain','rain':'wi-day-showers','Rain':'wi-day-showers','rain_light':'wi-day-sprinkle','Light Rain':'wi-day-sprinkle','drizzle':'wi-day-rain-mix','Drizzle':'wi-day-rain-mix','fog_light':'wi-fog','Light Fog':'wi-fog','fog':'wi-day-fog','Fog':'wi-day-fog','cloudy':'wi-cloudy','Cloudy':'wi-cloudy','mostly_cloudy':'wi-day-cloudy','Mostly Cloudy':'wi-day-cloudy','partly_cloudy':'wi-day-cloudy-high','Partly Cloudy':'wi-day-cloudy-high','mostly_clear':'wi-day-haze','Mostly Clear':'wi-day-haze','clear':'wi-day-sunny','Clear':'wi-day-sunny','Light Wind':'wi-windy'};var SVG={'surface_shortwave_radiation':__WEBPACK_IMPORTED_MODULE_1__svg_radiation_svg___default.a,'epa_aqi':__WEBPACK_IMPORTED_MODULE_0__svg_airQualityIndex_svg___default.a,'pm25':__WEBPACK_IMPORTED_MODULE_5__svg_pm2_5_v2_svg___default.a,'pm10':__WEBPACK_IMPORTED_MODULE_6__svg_pm10_v2_svg___default.a,'o3':__WEBPACK_IMPORTED_MODULE_7__svg_ozone_svg___default.a,'no2':__WEBPACK_IMPORTED_MODULE_4__svg_no2_v2_png___default.a,'co':__WEBPACK_IMPORTED_MODULE_3__svg_co_jpg___default.a,'so2':__WEBPACK_IMPORTED_MODULE_2__svg_so2_jpg___default.a,'epa_primary_pollutant':__WEBPACK_IMPORTED_MODULE_8__svg_primaryPollutant_png___default.a/* END */};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(641);

var _runTransitionHook = __webpack_require__(102);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(42);

var _deprecate = __webpack_require__(101);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(103);

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes[typeof value]);
}

module.exports = isObject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(600),
    listCacheDelete = __webpack_require__(601),
    listCacheGet = __webpack_require__(602),
    listCacheHas = __webpack_require__(603),
    listCacheSet = __webpack_require__(604);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(35);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(200);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(597);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(111);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var EventPluginRegistry = __webpack_require__(115);
var ReactEventEmitterMixin = __webpack_require__(672);
var ViewportMetrics = __webpack_require__(224);

var getVendorPrefixedEventName = __webpack_require__(704);
var isEventSupported = __webpack_require__(126);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);
var ViewportMetrics = __webpack_require__(224);

var getEventModifierState = __webpack_require__(124);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);
var DOMNamespaces = __webpack_require__(114);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deprecateObjectProperties = __webpack_require__(87);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _getRouteParams = __webpack_require__(732);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _RouteUtils = __webpack_require__(40);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var array = _React$PropTypes.array;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  propTypes: {
    history: object,
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    history: object,
    location: object.isRequired,
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var router = _props.router;
    var history = _props.history;
    var location = _props.location;

    if (!router) {
       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props;
    var history = _props2.history;
    var location = _props2.location;
    var routes = _props2.routes;
    var params = _props2.params;
    var components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseMembrane = undefined;

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseMembrane = exports.canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      exports.canUseMembrane = canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

exports.default = deprecateObjectProperties;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["p"] = fetchAllMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["j"] = createMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["k"] = createMechHarvest2;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["n"] = prepareMechHarvest2;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["q"] = fetchReport;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectHarvestToManage;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchHarvestByDate;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectField;
/* harmony export (immutable) */ __webpack_exports__["t"] = setReportOptions;
/* harmony export (immutable) */ __webpack_exports__["s"] = selectReportType;
/* harmony export (immutable) */ __webpack_exports__["r"] = selectNewReport;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchMyMechHarvest;
/* harmony export (immutable) */ __webpack_exports__["e"] = resetManageHarvest;
/* harmony export (immutable) */ __webpack_exports__["i"] = addHarvestRecord;
/* harmony export (immutable) */ __webpack_exports__["o"] = setMechHarvestToEdit;
/* harmony export (immutable) */ __webpack_exports__["m"] = editHarvestRecord;
/* harmony export (immutable) */ __webpack_exports__["l"] = deleteHarvestRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mech_harvest_calc__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**************************************************************
Hawaiian Macadamia Nut Services
12.18.18
Mechanical Harvest & Report actions
11.17.22: Updating mech harvest form for multiple entries with
one submission
**************************************************************///const FileSaver = require('file-saver');
var Materialize=window.Materialize;var $=window.$;/********************** Asynchronous Function *********************************//**
* fetchAllMechHarvest(): Fetches mechanical harvest, equipment, season and employees
* @returns {Object} harvest, equipment, season, employee
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function fetchAllMechHarvest(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/fetchMechHarvest',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_MECH_HARVEST */],mechHarvest:res.mechHarvest,equipmentNo:res.equipmentNo,seasons:res.seasons,employees:res.employees,fields:res.fields});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error creating a mechanical harvest. Please try again.'));});};}/**
* createMechHarvest(): Creates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/function createMechHarvest(harvest,previousHarvest,selectedField,equipmentNo){for(var key in harvest){switch(true){case key==='block':break;case key!=='block'&&harvest[key]==='':return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Please complete the entire form.');default:}}var equipCheck=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* handleEquipmentNo */])('mech-equipmentNo',equipmentNo);if(!equipCheck)return{type:'DUMMY'};var preparedAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,selectedField.treePerAcre);var existingAcres=previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);var totalAcresComplete=Number(preparedAcres)+existingAcres;if(totalAcresComplete>selectedField.mechHarvest)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Cannot exceed the total acres in a field.<br /> Max Acres: '+selectedField.mechHarvest+' <br /> You have: '+totalAcresComplete.toFixed(2));$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/createMechHarvest',{harvest:harvest}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-form');Materialize.toast(res.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["b" /* CREATE_MECH_HARVEST */],payload:res.harvest,submitter:harvest.submitter});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error creating a mechanical harvest. Please try again: '+err));});};}/**
* createMechHarvest2(): Creates a Mech harvest record
* @param {Array} harvest: harvest records to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/function createMechHarvest2(_ref){var harvest=_ref.harvest;if(harvest.length===0||!harvest)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('No harvest records exist. Add one and try again.');var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=harvest[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var h=_step.value;if(Number(h.acresBalance)<0){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Cannot exceed the total acres in a field.<br /> Acres balance: '+h.acresBalance+' for Field: '+h.field+'.');}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/createMechHarvest2',{harvest:harvest}).then(function(res){return res.data;}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-form');Materialize.toast(res.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["b" /* CREATE_MECH_HARVEST */]});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error creating a mechanical harvest. Please try again: '+err));});};}/**
* prepareMechHarvest(): Prepares the mechanical harvest to review before submitting; fetches previous records for viewing & calculating
* @param {Object} harvest: Harvest record to be submitted
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} seasons: The harvest season: start date, end date, location
* @param {Object} employees: All employees who can harvest(Currently all of them)
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js','/components/harvest/manage/mechHarvest_manage.js']
**/function prepareMechHarvest(harvest,selectedField,seasons,employees,type){var season=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mech_harvest_calc__["a" /* seasonForLocation */])(seasons,harvest.location);if(!season)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('No current harvest season for location '+harvest.location+'.');// Verify the type of action so only one function is needed
var _type=__WEBPACK_IMPORTED_MODULE_0__types__["c" /* PREPARE_MECH_HARVEST_TO_CREATE */];if(type==='edit')_type=__WEBPACK_IMPORTED_MODULE_0__types__["d" /* PREPARE_MECH_HARVEST_TO_EDIT */];// Fetch employee object to get id
var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* findEmployeeByName */])(harvest.employee,employees);if(!emp)emp={eid:''};$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/fetchPreviousMechHarvest',{params:{field:harvest.field,round:harvest.round,seasonId:season.id},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');var previousHarvest=res.previousHarvest;// If editing, filter out the record that will be updated for new calculations
if(type==='edit')previousHarvest=previousHarvest.filter(function(h){return Number(h.id)!==Number(harvest.id);});var preparedAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,selectedField.treePerAcre);var existingAcres=previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);var totalAcresComplete=Number(preparedAcres)+existingAcres;var newHarvest=Object.assign({},harvest,{estimatedLbs:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["e" /* estimatedLbs */])(harvest.estLbsPerContainer,harvest.containerCount),acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["f" /* acresPerHour */])(harvest.hours,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,selectedField.treePerAcre)),density:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["g" /* density */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["e" /* estimatedLbs */])(harvest.estLbsPerContainer,harvest.containerCount),harvest.treesCovered),acresBalance:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["h" /* acresBalance */])(totalAcresComplete,selectedField.mechHarvest),acresCompleted:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,selectedField.treePerAcre),seasonId:season.id,eid:emp.eid,intervals:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["i" /* handleInterval */])(previousHarvest),percentComplete:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["j" /* percentComplete */])(preparedAcres,selectedField.mechHarvest)});dispatch({type:_type,payload:newHarvest,selectedField:selectedField,previousHarvest:previousHarvest});}).catch(function(e){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error fetching mechanical harvest.'));console.error(e);});};}/**
* prepareMechHarvest2(): Prepares the mechanical harvest to review before submitting; fetches previous records for viewing & calculating
* @param {Object} harvest: Harvest record to be submitted
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} seasons: The harvest season: start date, end date, location
* @param {Object} employees: All employees who can harvest(Currently all of them)
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js','/components/harvest/manage/mechHarvest_manage.js']
**/function prepareMechHarvest2(_ref2){var harvest=_ref2.harvest,fields=_ref2.fields,employees=_ref2.employees,type=_ref2.type;// Verify the type of action so only one function is needed
var _type=__WEBPACK_IMPORTED_MODULE_0__types__["e" /* PREPARE_MECH_HARVEST_TO_CREATE_2 */];if(type==='edit')_type=__WEBPACK_IMPORTED_MODULE_0__types__["f" /* PREPARE_MECH_HARVEST_TO_EDIT_2 */];// Clicked prepare, nothing to be fetched without a record
if(harvest.length===0){return{type:'DUMMY'};}//$('#preloader').css('display','block');
return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/fetchPreviousMechHarvest2',{params:{fields:harvest.map(function(h){return h.field;}),round:harvest[0].round,seasonId:harvest[0].seasonId},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return res.data;}).then(function(res){console.log('\n ** Response ** \n');var pHarvest=res.pHarvest;console.log(pHarvest);//$('#preloader').css('display','none');
var balances=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mech_harvest_calc__["b" /* batchAcresBalances */])(harvest,fields,pHarvest);var updatedHarvest=[].concat(_toConsumableArray(harvest)).map(function(h,i){var field=fields.find(function(f){return f.field===h.field;});var preparedAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(h.treesCovered,field.treePerAcre);return Object.assign({},h,{estimatedLbs:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["e" /* estimatedLbs */])(h.estLbsPerContainer,h.containerCount),acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["f" /* acresPerHour */])(h.hours,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(h.treesCovered,field.treePerAcre)),density:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["g" /* density */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["e" /* estimatedLbs */])(h.estLbsPerContainer,h.containerCount),h.treesCovered),acresBalance:balances[i],acresCompleted:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(h.treesCovered,field.treePerAcre),percentComplete:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["j" /* percentComplete */])(preparedAcres,field.mechHarvest)});});/*
        // If editing, filter out the record that will be updated for new calculations
        if (type === 'edit') previousHarvest = previousHarvest.filter((h) => Number(h.id) !== Number(harvest.id));
        */dispatch({type:_type,payload:updatedHarvest,previousHarvest:pHarvest});}).catch(function(e){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error fetching mechanical harvest.'));console.error(e);});};}/**
* updateMechHarvest(): Updates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @param {Array} previousHarvest: previous harvest records for the field, round, season
* @param {Object} selectedField: Field where harvest is taking place
* @param {Object} equipmentNo: List of available equipment
* @returns {Object} harvest: New harvest record sent back to add to existing records
* @called-in: ['/components/harvest/manage/mechHarvest_manage.js']
**/function updateMechHarvest(harvest,previousHarvest,selectedField,equipmentNo,selectedHarvest){if(harvest.field==="F525"||harvest.field==="F520"){}// Added 9.11.25 on req from P.Salmo(Harvesting Olsen orchards)
else{for(var key in harvest){switch(true){case key==='block':break;case key!=='block'&&key!=='notes'&&harvest[key]==='':return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Please complete the entire form.');default:}}}var equipCheck=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* handleEquipmentNo */])('mech-edit-equipmentNo',equipmentNo);if(!equipCheck)return{type:'DUMMY'};var preparedAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,selectedField.treePerAcre);var existingAcres=previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);var totalAcresComplete=Number(preparedAcres)+existingAcres;if(totalAcresComplete>selectedField.mechHarvest)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Cannot exceed the total acres in a field.<br /> Max Acres: '+selectedField.mechHarvest+' <br /> You have: '+totalAcresComplete.toFixed(2));$('#preloader').css('display','block');harvest.id=selectedHarvest.id;return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/updateMechHarvest',{harvest:harvest}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-edit-form');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["g" /* EDIT_MECH_HARVEST */],payload:harvest,submitter:harvest.submitter});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error editing a mechanical harvest. Please try again '+err));});};}/**
* deleteMechHarvest(): Creates a Mech harvest record
* @param {Object} harvest: harvest record to be created
* @returns {Object} msg: Success of failure
* @called-in: ['/components/harvest/manage/mechHarvest_manage.js']
**/function deleteMechHarvest(harvest){return function(dispatch){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/deleteMechHarvest',{params:{harvest:harvest}}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-edit-form');Materialize.toast(res.data.msg,4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["h" /* DELETE_MECH_HARVEST */],payload:res.data.id,submitter:harvest.submitter});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error editing a mechanical harvest. Please try again '+err));});};}/**
* fetchReport(): Fetches a report based on form selections
* @param {Object} opts:
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function fetchReport(opts,employees,email){// Must select a report type
if(opts.hand==='on'&&opts.mech==='on')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Please select a report type - Hand or Mech.');if(opts.dateFrom===''||opts.dateTo==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Please select dates for the report.');if(opts.location==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Please select a location for the report.');opts.eid='';$('#preloader').css('display','block');if(opts.employee){var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* findEmployeeByName */])(opts.employee,employees);opts.eid=emp.eid;}return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["i" /* SET_REPORT_OPTS */],payload:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* determineReportOpts */])(opts)});__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/fetchReport',{headers:{authorization:localStorage.getItem('token')},params:{opts:opts,email:email}}).then(function(res){$('#preloader').css('display','none');Materialize.toast(res.data.msg,4000,'rounded green');//console.log(res.data)
/*if (res.data.csv.status) {
          var blob = new Blob([res.data.csv.file], {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(blob, `Harvest Data Dump(${res.data.query.type}) ${opts.dateFrom}-${opts.dateTo}_${opts.location}.csv`);
        }*/dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["j" /* FETCH_REPORT */],payload:res.data.query,options:opts});}).catch(function(e){$('#preloader').css('display','none');console.error(e);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error fetching a report.');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["k" /* ERROR */]});});};}/**
* selectHarvestToManage(): Selects a harvest record to edit or delete; also fetches fields and field information
* @param {Object} h: harvest record to edit or delete
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/function selectHarvestToManage(h){//return { type: SELECT_HARVEST_TO_MANAGE, payload: h };
return function(dispatch,getState){// Quick check to see if harvest is still selected
var _getState=getState(),harvest=_getState.harvest;var employees=harvest.employees;if(harvest.manage.selectedHarvest.id===h.id)return{type:'DUMMY'};var emp=employees.all.find(function(e){return e.eid===h.eid;});if(Object.keys(emp).length>0)h.employee=emp.firstName+' '+emp.lastName;$('#preloader').css('display','block');__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/selectHarvestToManage',{params:{field:h.field},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');// Dispatch data
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["l" /* SELECT_HARVEST_TO_MANAGE */],payload:h,selectedField:res.data.selectedField,blocks:res.data.blocks});// Fill Form
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* fillEdit */])('mechHarvest-edit-form',h);}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There was an error creating a mechanical harvest. Please try again. '+err));});};}/**
* fetchHarvestByDate(): Fetches harvest records by date to edit or delete
* @param {String} date: date of harvest records
* @returns {Object} res.harvest: Harvest records
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/function fetchHarvestByDate(date){var twoWeeksPrior=__WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(14,'days').format('YYYY-MM-DD');if(new Date(date)<new Date(twoWeeksPrior))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('Records past two weeks are locked and final.');return function(dispatch){$('#preloader').css('display','block');__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ROOT_URL */]+'/fetchHarvestByDate',{params:{date:date},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["m" /* FETCH_HARVEST_BY_DATE */],payload:res.data.harvest});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__index__["error"])('There are no available mechanical harvest records for this date'));});};}/**
* selectField(): Selects a field from field list
* @param {String} field: the selected field
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/create/mechHarvest_create.js']
**/function selectField(field){if(field==='')return{type:'DUMMY'};return{type:__WEBPACK_IMPORTED_MODULE_0__types__["n" /* SELECT_FIELD */],payload:field};}/**
* setReportOptions(): Sets the report options to query the database; Hand, Mech choice determines different components
* @param {Object} opts: report options
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function setReportOptions(opts){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["i" /* SET_REPORT_OPTS */],payload:opts};}/**
* selectReportType(): Sets the report type; disables the
* @param {Object} opts: report options
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function selectReportType(type){var _type='';if(type==='rep-hand'){_type='disabled';// Clean up round value
document.getElementById('rep-round').value='';}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["o" /* SELECT_REPORT_TYPE */],payload:_type};}/**
* selectNewReport(): Selects a new report option; reinstating the form
* @param {Boolean} reportRunning: true or false on whether a current report was run
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/view/harvest_view.js']
**/function selectNewReport(){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["p" /* SELECT_NEW_REPORT */]};}/**
* fetchMyMechHarvest(): Selects all mech harvest that was submitted by a user
* @param {String} eid: Employee id
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/function fetchMyMechHarvest(eid){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["q" /* FETCH_MY_MECH_HARVEST */],payload:eid};}/**
* resetManageHarvest(): Resets or clears the state for managing harvest
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/harvest/manage/harvest_manage.js']
**/function resetManageHarvest(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-edit-form');return{type:__WEBPACK_IMPORTED_MODULE_0__types__["r" /* RESET_MANAGE_HARVEST */]};}/**
* addHarvestRecord(): Adds an individual harvest record in the mechanical harvest form
* @param {Object} harvest: individual harvest records for a single submission 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_2']
**/function addHarvestRecord(harvest){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-individual-form');return{type:__WEBPACK_IMPORTED_MODULE_0__types__["s" /* ADD_HARVEST_RECORD */],payload:Object.assign({},harvest,{guid:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* generateGUID */])()})};}function setMechHarvestToEdit(harvest){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["o" /* fillEdit2 */])({formId:'mechHarvest-individual-form',form:harvest});return{type:__WEBPACK_IMPORTED_MODULE_0__types__["t" /* SET_MECH_HARVEST_TO_EDIT */],payload:harvest};}/**
* editHarvestRecord(): Edits an individual harvest record in the mechanical harvest form
* @param {Object} harvest: individual harvest records for a single submission 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_2']
**/function editHarvestRecord(harvest){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* clearForm */])('mechHarvest-individual-form');return{type:__WEBPACK_IMPORTED_MODULE_0__types__["u" /* EDIT_MECH_HARVEST_RECORD */],payload:harvest};}/**
* deleteHarvestRecord(): Deletes an individual harvest record in the mechanical harvest form
* @param {String} guid: individual harvest record unique temp id 
* @returns {Object} 
* @called-in: ['/components/harvest/create/mechHarvest_create.js->mechHarvest_form_table']
**/function deleteHarvestRecord(guid){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["v" /* DELETE_MECH_HARVEST_RECORD */],payload:guid};}/* END */

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/****************************************************************
Alexander Self
8/23/17
Gang list:Displyas a list of gangs
****************************************************************/var TeamList=function TeamList(_ref){var gangs=_ref.gangs,_onClick=_ref.onClick,id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection",id:id},gangs.map(function(g){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:g.gangId,className:"collection-item avatar gang-list",onClick:function onClick(){return _onClick(g.gangId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons circle"},"group"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"title"},"Team No: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,g.gangId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Team Location: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,g.gangLoc===71?g.gangLoc+" - Ka'u":g.gangLoc+" - Kea'au")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Team Count: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,g.gangCount)));}));};/* harmony default export */ __webpack_exports__["a"] = (TeamList);/* END */

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchChemicalApplications;
/* harmony export (immutable) */ __webpack_exports__["k"] = selectApplicationToView;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOrEditChemicalApplication;
/* harmony export (immutable) */ __webpack_exports__["l"] = deleteChemicalApplication;
/* harmony export (immutable) */ __webpack_exports__["e"] = prepareData;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSolution;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectSolutionToEdit;
/* harmony export (immutable) */ __webpack_exports__["d"] = editSolution;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteSolution;
/* harmony export (immutable) */ __webpack_exports__["i"] = setTotalGallons;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectField;
/* harmony export (immutable) */ __webpack_exports__["h"] = selectChemAppToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*******************************************************************************
Chemical Application Actions: All interactions in the chemical component

*******************************************************************************/var $=window.$;/**
* fetchChemicalApplications(): Fetches all chemical applications
* @returns {Array} chemicals
* @called-in: ['/components/chemical/chemical_app_view.js']
**/function fetchChemicalApplications(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchChemicalApplications',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["Z" /* FETCH_CHEMICAL_APPLICATIONS */],payload:res.data.chemApps});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('There was an error fetching chemicals.'));});};}/**
* selectApplicationToView(): Sets the application to view
* @param {Object} app: app to view
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_view.js->chem_app_table.js->fab_modal.js->chem_app_display.js']
**/function selectApplicationToView(app){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchPreviousApplication',{params:{date:app.date,field:app.fieldId,round:app.round},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_0" /* SELECT_APPLICATION_TO_VIEW */],payload:app,previousApplications:res.data.records.filter(function(s){return s.id!==app.id;})});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* createChemicalApplication(): Submits a new chemical
* @param {Array} formData: All form data
* @returns {Object} Newly created chemical
* @called-in: ['/components/chemical/chemical_app_create']
**/function createOrEditChemicalApplication(_ref){var data=_ref.data,type=_ref.type,path=_ref.path;// Form validation check
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["d" /* checkApplicationForm */])(data))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Entire form must be filled.');if(data.solutions.length===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('At least one chemical is required.');if(Number(data.measurement)===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Gallons used must be greater than 0.');if(Number(data.acresBalance)<0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Cannot exceed total acres in a field. Re-enter Acres Completed.');$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/'+path,{data:data}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])('chemical-application-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:type,payload:res.data.record});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* deleteChemicalApplication(): Delete an existing chemical
* @param {Array} data: id of application; ids of chemicals applied
* @returns {Object} Newly created chemical
* @called-in: ['/components/chem_app/chem_app_view.js->chem_app_table.js->fab_modal.js->chem_app_display.js']
**/function deleteChemicalApplication(data){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/deleteChemicalApplication',{data:{id:data.id,solutions:data.solutions.map(function(s){return s.id;})}}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_1" /* DELETE_CHEMICAL_APPLICATION */],payload:res.data.id});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* prepareData(): Prepares form data for submission
* @param {Object} form: all form data
* @param {Array} fields: all fields from a location
* @param {Array} employees: list of cultivation employees
* @param {Array} solutions: chemical cocktail array
* @param {String} submitter: submitter eid of form
* @param {String} certId: cert# to use regulated chemicals
* @returns {Object} type, payload
* @called-in: ['/components/chemApp/chem_app_create.js']
**/function prepareData(_ref2){var user=_ref2.user,form=_ref2.form,selectedField=_ref2.selectedField,employees=_ref2.employees,solutions=_ref2.solutions,deletedSolutions=_ref2.deletedSolutions,submitter=_ref2.submitter,certId=_ref2.certId,chemAppId=_ref2.chemAppId,editingApplication=_ref2.editingApplication;var e=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["l" /* findEmployeeByName */])(form.employee,employees);// If EID is filled in form
if(!e&&form.employee!=='')e=employees.find(function(emp){return emp.eid===form.employee;});$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchPreviousApplication',{params:{date:form.date,field:form.fieldId,round:form.round},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');// Determine remaining balance of acres
var previousAcresWorked=res.data.records.filter(function(d){return d.chemAppId!==chemAppId;}).reduce(function(acc,cur){return acc+Number(cur.acresCompleted);},0);//if (editingApplication) previousAcresWorked = 0;
var totalAcresWorked=Number(form.acresCompleted)+previousAcresWorked;var balance=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["m" /* acresBalance */])(totalAcresWorked,selectedField.totalAcre);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["R" /* PREPARE_DATA */],payload:Object.assign({},form,{hours:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["s" /* calculateHoursFromTime */])({date:form.date,startTime:form.startTime,endTime:form.endTime}),employee:e.eid,chemAppId:chemAppId?chemAppId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),certId:certId,submitter:submitter,acresBalance:balance,reiDaysRemaining:Math.max.apply(Math,_toConsumableArray(solutions.map(function(s){return s.rei;}))),preHarvestDaysRemaining:Math.max.apply(Math,_toConsumableArray(solutions.map(function(s){return s.preHarvest;}))),canEdit:1,isComplete:form.isComplete==='Incomplete'?0:1,solutions:solutions,deletedSolutions:deletedSolutions,editedBy:editingApplication?user.firstName+' '+user.lastName:null}),previousApplications:res.data.records});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* addSolution(): Adds a solution in the create application form
* @param {Object} solution: chemical used form info
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_create.js']
**/function addSolution(_ref3){var solution=_ref3.solution,totalGallons=_ref3.totalGallons,formId=_ref3.formId,chemicals=_ref3.chemicals;var chemId=solution.chemId,chemDosage1=solution.chemDosage1,chemDosage2=solution.chemDosage2;if(chemId==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('All fields must be filled.');if(chemDosage1===''||Number(chemDosage1)<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Must be greater than 0.');if(chemDosage2==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Select a unit of measure');var chem=chemicals.find(function(c){return c.id===Number(chemId);});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_2" /* ADD_SOLUTION */],payload:Object.assign({id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),percentageUsed:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["t" /* calculatePercentage */])({quantity:solution.chemDosage1,unit:solution.chemDosage2,totalGallons:totalGallons})},solution,{rei:chem.rei,preHarvest:chem.preHarvestInterval})};}/**
* selectSolutionToEdit(): Selects a solution to edit in the create application form
* @param {Object} solution: chemical used form info
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_create.js']
**/function selectSolutionToEdit(solution){var formId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,solution);},200);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_3" /* SELECT_SOLUTION_TO_EDIT */],payload:solution};}/**
* editSolution(): Edits a solution added in the create application form
* @param {Object} solution: chemical used form info
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_create.js']
**/function editSolution(_ref4){var solution=_ref4.solution,editSolution=_ref4.editSolution,totalGallons=_ref4.totalGallons,formId=_ref4.formId,chemicals=_ref4.chemicals;var chemId=solution.chemId,chemDosage1=solution.chemDosage1,chemDosage2=solution.chemDosage2;if(chemId==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('All fields must be filled.');if(chemDosage1===''||Number(chemDosage1)<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Must be greater than 0.');if(chemDosage2==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('Select a unit of measure');var chem=chemicals.find(function(c){return c.id===Number(chemId);});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_4" /* EDIT_SOLUTION */],payload:Object.assign({id:editSolution.id?editSolution.id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),percentageUsed:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["t" /* calculatePercentage */])({quantity:solution.chemDosage1,unit:solution.chemDosage2,totalGallons:totalGallons})},solution,{rei:chem.rei,preHarvest:chem.preHarvestInterval})};}/**
* deleteSolution(): Deletes a solution added in the create application form
* @param {Object} solution: chemical used form info
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_create.js']
**/function deleteSolution(solution){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_5" /* DELETE_SOLUTION */],payload:solution};}/**
* setTotalGallons(): Sets the total gallons of solution
* @param {Object} val: total gallons
* @returns {Array} type, payload
* @called-in: ['/components/chem-app/chem_app_create.js->chem_app_form.js']
**/function setTotalGallons(val){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_6" /* SET_TOTAL_GALLONS */],payload:Number(val)};}/**
* selectField(): Selects a field from field list
* @param {String} field: the selected field
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/chem_app/chem_app_create.js->chem_app_form.js']
* @notes: Call in onComplete and onBlur; make sure users cannot select a field outside of a correct location
**/function selectField(fields,val,id){var editChem=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(fields.length===0)return{type:'DUMMY'};var field=fields.find(function(f){return f.field===val;});if(field===undefined){document.getElementById(id).value='';return{type:'DUMMY'};}if(editChem){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_7" /* SELECT_FIELD_FOR_EDIT */],payload:field};}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_8" /* SELECT_FIELD */],payload:field};}/**
* selectChemAppToEdit(): Selects a application to edit
* @param {String} formId: the id of the form
* @param {String} chem: the id of the form
* @param {String} formId: the id of the form
* @param {String} formId: the id of the form
* @returns {Object} type, payload: action and the field string
* @called-in: ['/components/chem_app/chem_app_create.js->chem_app_form.js']
* onEdit: mutate solutions to reflect initial state with chemDosage split into number and unit of measure
**/function selectChemAppToEdit(_ref5){var formId=_ref5.formId,chem=_ref5.chem,chemicalList=_ref5.chemicalList,employees=_ref5.employees;var solutions=chem.solutions;var employee=employees.find(function(e){return e.eid===chem.employee;});var _solutions=solutions.map(function(s){if(s.hasOwnProperty('chemDosage')){var _chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});var c=s.chemDosage.split(' ');s.chemDosage1=c[0];s.chemDosage2=c[1];s.rei=_chem.rei;s.preHarvest=_chem.preHarvestInterval;delete s.chemDosage;return s;}return s;});chem.solutions=_solutions;// Display employee name in Employee Autocomplete rather than employee ID
if(employee)chem.employee=employee.firstName+' '+employee.lastName;// Fill form
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,chem);// After form is filled, set employee back to employee id
chem.employee=employee.eid;return function(dispatch){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchField',{params:{field:chem.fieldId},headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_9" /* SELECT_CHEMICAL_APPLICATION_TO_EDIT */],payload:chem,field:res.data.field});}).catch(function(err){console.log(err);dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chem_actions__["a" /* error */])('There was an error fetching the field for the application.'));});};}/* END */

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_inventory_edit_form__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tree_inventory_display__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_utils__ = __webpack_require__(11);
/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Transaction Table: For transactions only
************************************************************************/var TreeInventoryTransactionTable=function TreeInventoryTransactionTable(_ref){var inventory=_ref.inventory,_inventory=_ref._inventory,user=_ref.user,fields=_ref.fields,approvers=_ref.approvers,formType=_ref.formType,readOnly=_ref.readOnly,formId=_ref.formId,setFormType=_ref.setFormType,setInventoryToEdit=_ref.setInventoryToEdit,editInventoryRequest=_ref.editInventoryRequest,deleteInventoryRequest=_ref.deleteInventoryRequest,setInventoryToDelete=_ref.setInventoryToDelete,fetchFields=_ref.fetchFields,_onClick=_ref.onClick;if(readOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered centered responsive-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Transaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Approved'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Approved Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Comments'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,inventory.map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.date).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.location===71?"71 - Ka'u":"72 - Kea'au"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.issuedOrReceived==='I'?'Issued':'Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.isApproved===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-text'},'Awaiting Approval'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green-text'},'Approved')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.approvedDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.approvedDate).format('MM/DD/YYYY')):'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.comments));})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered centered responsive-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Issued or Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Approved'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Approved Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Approve'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,inventory.map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.date).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.location===71?"71 - Ka'u":"72 - Kea'au"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.issuedOrReceived==='I'?'Issued':'Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.isApproved===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-text'},'Awaiting Approval'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green-text'},'Approved')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.approvedDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.approvedDate).format('MM/DD/YYYY')):'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.isApproved?'':i.approver===user.eid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn white-text green waves-effect',onClick:function onClick(){return _onClick({user:user,inventoryTransaction:i});}},'Approve'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn white-text green',disabled:true},'Approve')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.isApproved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating green pointer modal-trigger tooltipped btn-squared',href:'#'+i.id+'-view',onClick:function onClick(){return console.log(i);},'data-position':'left','data-tooltip':'View'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'info')))):i.submitter===user.eid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating blue pointer modal-trigger tooltipped btn-squared',href:'#'+i.id+'-edit',onClick:function onClick(){return setInventoryToEdit({inventory:i,formId:'edit-form-'+i.id});},'data-position':'left','data-tooltip':'Edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating red pointer modal-trigger tooltipped btn-squared',href:'#'+i.id+'-delete',onClick:function onClick(){return setInventoryToDelete(i);},'data-position':'top','data-tooltip':'Delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),i.isApproved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__tree_inventory_display__["a" /* default */])// eslint-disable-next-line
({id:i.id+'-view',approvers:approvers,data:i,footer:true,toView:true,createOrEdit:false,previousInventoryTransactions:[],approver:{},view:true,onClick:function onClick(){return console.log(i);}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__tree_inventory_edit_form__["a" /* default */])// eslint-disable-next-line
({id:i.id+'-edit',approvers:approvers,inventory:i,fields:fields,footer:true,formType:formType,formId:'edit-form-'+i.id,createOrEdit:true,view:false,onClick:function onClick(){return editInventoryRequest({data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cult_utils__["c" /* packageForm */])('edit-form-'+i.id),formId:'edit-form-'+i.id,inventory:_inventory,oldInventoryRecord:i,user:user});},setFormType:setFormType,fetchFields:fetchFields}),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__tree_inventory_display__["a" /* default */])// eslint-disable-next-line
({id:i.id+'-delete',approvers:approvers,data:i,footer:true,formType:formType,formId:'edit-form-'+i.id,createOrEdit:true,toDelete:true,previousInventoryTransactions:[],approver:{},view:false,onClick:function onClick(){return deleteInventoryRequest(i);}}))));})));};/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryTransactionTable);/* END */

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**********************************************************
Footer Modal
**********************************************************/var $=window.$;var FooterModal=function FooterModal(WrappedComponent){return function(props){var id=props.id,onClick=props.onClick,footer=props.footer,view=props.view;$(document).ready(function(){$("#"+id).modal();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:""+id,className:"modal bottom-sheet modal-fixed-footer modal-app-display"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,props))),footer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-footer"},view?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#!",className:"modal-action modal-close waves-effect waves-green btn-flat",onClick:onClick},"Submit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#!",className:"modal-action modal-close waves-effect btn-flat"},"Close")):''));};};/* harmony default export */ __webpack_exports__["a"] = (FooterModal);/* END */

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__engine_table__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meter_table__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__valve_table__ = __webpack_require__(426);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Display: Display for a single irriation record
**********************************************************/var propTypes={employees:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,app:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};var IrrigationDisplay=function IrrigationDisplay(_ref){var employees=_ref.employees,engines=_ref.engines,meters=_ref.meters,valves=_ref.valves,app=_ref.app,view=_ref.view,toDelete=_ref.toDelete;var employee=app.data.employee;if(!isNaN(app.data.employee)&&employees.length>0){var emp=employees.find(function(e){return Number(e.id)===Number(app.data.employee);});if(emp)employee=emp.firstName+' '+emp.lastName;}if(!app.engineLog)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'red-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Are you sure you want to delete the following log?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'blue-text'},view?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Irrigation Log')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Review and Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons medium'},'opacity')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_moment___default()(app.data.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Employee'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,employee)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Notes'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,app.data.notes)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Engine Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,app.data.totalEngineHours)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Meter Gallons'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Number(app.data.totalMeterGal)*1000000)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Valve Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,app.data.totalValveHours)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Valve Gallons'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,app.data.totalValveGal))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'irr-hr'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Engines')),app.engineLog.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__engine_table__["a" /* default */],{engines:engines,engineLog:app.engineLog}):'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'irr-hr'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Meters')),app.meterLog.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meter_table__["a" /* default */],{meters:meters,meterLog:app.meterLog}):'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'irr-hr'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Valves')),app.valveLog.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__valve_table__["a" /* default */],{valves:valves,valveLog:app.valveLog}):'');};IrrigationDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (IrrigationDisplay);/* END */

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["m"] = fetchIrrigation;
/* harmony export (immutable) */ __webpack_exports__["n"] = fetchIrrigationReport;
/* harmony export (immutable) */ __webpack_exports__["l"] = fetchEmployees;
/* harmony export (immutable) */ __webpack_exports__["h"] = createIrrigation;
/* harmony export (immutable) */ __webpack_exports__["b"] = editIrrigation;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteIrrigation;
/* harmony export (immutable) */ __webpack_exports__["j"] = prepareData;
/* harmony export (immutable) */ __webpack_exports__["f"] = prepareEditData;
/* harmony export (immutable) */ __webpack_exports__["e"] = handleValveHours;
/* harmony export (immutable) */ __webpack_exports__["c"] = handleEngineHours;
/* harmony export (immutable) */ __webpack_exports__["d"] = handleMeterGallons;
/* harmony export (immutable) */ __webpack_exports__["i"] = preloadMeterForm;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectIrrigationLogToEdit;
/* harmony export (immutable) */ __webpack_exports__["o"] = resetDashboard;
/* harmony export (immutable) */ __webpack_exports__["k"] = _error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Actions
**********************************************************/var Materialize=window.Materialize;var $=window.$;/**
* fetchIrrigation(): Fetches irrigation records
* @returns {Object} {Array} engines, meters, valves:
* @called-in: ['/irrigation/irrigation_view.js']
**/function fetchIrrigation(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/irrigation',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["a" /* FETCH_IRRIGATION */],payload:res.data});}).catch(function(err){console.error(err);});};}/**
* fetchIrrigationReport(): Fetches an irrigation report bassd on startDate, endDate
* @returns {Object} {Array} engines, meters, valves:
* @called-in: ['/irrigation/irrigation_view.js']
**/function fetchIrrigationReport(_ref){var startDate=_ref.startDate,endDate=_ref.endDate,email=_ref.email;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/irrigationReport',{params:{startDate:startDate,endDate:endDate,email:email},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');//console.log(res.data)
success('Success fetching irrigation report for '+startDate+' to '+endDate);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["b" /* FETCH_IRRIGATION_REPORT */],payload:res.data,startDate:startDate,endDate:endDate});}).catch(function(err){$('#preloader').css('display','none');console.error(err);});};}/**
* fetchEmployees(): Fetches all active BU employees
* @returns {Array} employees
* @called-in: ['/components/chem_app/chem_app_create.js']
**/function fetchEmployees(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/fetchEmployees',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["c" /* FETCH_IRRIGATION_EMPLOYEES */],payload:res.data.employees});}).catch(function(err){return console.error(err);});};}/**
* createIrrigation(): Creates a new irrigation record
* @param {Object} app: data, engineLog, meterLog, valveLog
* @param {Array} employees: list of all BU employees
* @param {String} formId
* @returns {Object} app: data, engineLog, meterLog, valveLog
* @called-in: ['/irrigation/irrigation_create.js']
**/function createIrrigation(_ref2){var app=_ref2.app,employees=_ref2.employees,formId=_ref2.formId;// Validations
// Case 1 Date, Employee required
var _app$data=app.data,date=_app$data.date,employee=_app$data.employee;if(!(date&&employee))return error('Please select a Date and Employee.');// Case 2 If valve or meter, engine hours must be added and vise versa
var engineLog=app.engineLog,meterLog=app.meterLog,valveLog=app.valveLog;if(valveLog.length===0&&engineLog.length===0&&meterLog.length===0)return error('Please add at least one meter, valve and engine.');if(valveLog.length>0&&(engineLog.length===0||meterLog.length===0))return error('Please add engines and meters with valves.');if(meterLog.length>0&&(engineLog.length===0||valveLog.length===0))return error('Please add engines and valves with meters.');if(engineLog.length>0&&(meterLog.length===0||valveLog.length===0))return error('Please add meters and valves with engines.');var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* findEmployeeByName */])(employee,employees);app.data.employee=emp.id;return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/createIrrigation',{app:app}).then(function(res){success('Success creating a new irrigation record');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])(formId);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('engine-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('meter-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('valve-form');setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["a" /* preFillForm */])({data:res.data.prevMeters,formId:'meter-form',prop:'endGal'});},200);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" /* CREATE_IRRIGATION */],payload:res.data});}).catch(function(err){error(err.response.statusText);});};}/**
* editIrrigation(): Edits an existing irrigation record
* @param {Object} app: data, engineLog, meterLog, valveLog
* @param {Array} employees: list of all BU employees
* @param {String} formId
* @returns {Object} app: data, engineLog, meterLog, valveLog
* @called-in: ['/irrigation/irrigation_create.js']
**/function editIrrigation(_ref3){var app=_ref3.app,deleted=_ref3.deleted,employees=_ref3.employees,formId=_ref3.formId;// Validations
// Case 1 Date, Employee required
var _app$data2=app.data,date=_app$data2.date,employee=_app$data2.employee;if(!(date&&employee))return error('Please select a Date and Employee.');// Case 2 If valve or meter, engine hours must be added and vise versa
var engineLog=app.engineLog,meterLog=app.meterLog,valveLog=app.valveLog;if(valveLog.length===0&&engineLog.length===0&&meterLog.length===0)return error('Please add at least one meter, valve and engine.');if(valveLog.length>0&&(engineLog.length===0||meterLog.length===0))return error('Please add engines and meters with valves.');if(meterLog.length>0&&(engineLog.length===0||valveLog.length===0))return error('Please add engines and valves with meters.');if(engineLog.length>0&&(meterLog.length===0||valveLog.length===0))return error('Please add meters and valves with engines.');var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* findEmployeeByName */])(employee,employees);app.data.employee=emp.id;var _deleted={engineLog:deleted.engineLog.map(function(e){return e.id;}),meterLog:deleted.meterLog.map(function(e){return e.id;}),valveLog:deleted.valveLog.map(function(e){return e.id;})};return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/editIrrigation',{app:app,deleted:_deleted}).then(function(res){success('Success editing an irrigation record');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])(formId);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('engine-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('meter-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('valve-form');dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["e" /* EDIT_IRRIGATION */],payload:res.data});}).catch(function(err){error(err.response.statusText);});};}/**
* deleteIrrigation(): Deletes an existing irrigation record
* @param {String} irrigationId: unique id to the irrigation log
* @returns {Array} prevMeters: updated previous meter readings
* @called-in: ['/irrigation/irrigation_create.js']
**/function deleteIrrigation(irrigationId){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/deleteIrrigation',{irrigationId:irrigationId}).then(function(res){var _res$data=res.data,irrigationId=_res$data.irrigationId,prevMeters=_res$data.prevMeters;success('Success deleting an irrigation record');dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["f" /* DELETE_IRRIGATION */],payload:irrigationId,prevMeters:prevMeters});}).catch(function(err){error(err);});};}/**
* prepareData(): Gathers data into a submitable object; computes any remaining calculations
* @param {Object} formData: Date, employee, notes fields
* @param {Object} engineLog: Engine log: hours, engineId, irrigationId, totalFuelGal
* @param {Object} meterLog: engineId, irrigationId, meterId, endGal, startGal, totalGal
* @param {Object} valveLog: engineId, irrigationId, meterId, valveId, totalGal, hours
* @param {Object} user: user object
* @returns {Object} irrigation log object
* @called-in: ['/irrigation/irrigation_create.js']
**/function prepareData(_ref4){var formData=_ref4.formData,engineLog=_ref4.engineLog,meterLog=_ref4.meterLog,valveLog=_ref4.valveLog,user=_ref4.user;var irrigationId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["f" /* generateID */])(15);return{type:__WEBPACK_IMPORTED_MODULE_2__types__["g" /* PREPARE_IRRIGATION_DATA */],payload:{data:Object.assign({},formData,{irrigationId:irrigationId,submitter:user.id,totalEngineHours:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('hours',engineLog),totalMeterGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalGal',meterLog),totalValveHours:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('hours',valveLog),totalValveGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalGal',valveLog)}),engineLog:engineLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});}),meterLog:meterLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});}),valveLog:valveLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});})}};}/**
* prepareEditData(): Gathers edited form data into a submitable object; computes any remaining calculations
* @param {Object} formData: Date, employee, notes fields
* @param {Object} engineLog: Engine log: hours, engineId, irrigationId, totalFuelGal
* @param {Object} meterLog: engineId, irrigationId, meterId, endGal, startGal, totalGal
* @param {Object} valveLog: engineId, irrigationId, meterId, valveId, totalGal, hours
* @param {Object} user: user object
* @returns {Object} irrigation log object
* @called-in: ['/irrigation/irrigation_create.js']
**/function prepareEditData(_ref5){var formData=_ref5.formData,irrigationId=_ref5.irrigationId,engineLog=_ref5.engineLog,meterLog=_ref5.meterLog,valveLog=_ref5.valveLog,user=_ref5.user;return{type:__WEBPACK_IMPORTED_MODULE_2__types__["h" /* PREPARE_EDIT_IRRIGATION_DATA */],payload:{data:Object.assign({},formData,{irrigationId:irrigationId,submitter:user.id,totalEngineHours:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('hours',engineLog),totalMeterGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalGal',meterLog),totalValveHours:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('hours',valveLog),totalValveGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalGal',valveLog),editedBy:user.id,dateEdited:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')}),engineLog:engineLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});}).sort(function(a,b){return a.engineId<b.engineId?-1:1;}),meterLog:meterLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});}).sort(function(a,b){return a.meterId<b.meterId?-1:1;}),valveLog:valveLog.map(function(e){return Object.assign({},e,{irrigationId:irrigationId});}).sort(function(a,b){return a.valveId<b.valveId?-1:1;})}};}/**
* handleValveHours(): onChange/onBlur function which adds/removes valve hours when inputted.
  If blank, filter; if value concat/modify
* @param {Object} valveRecord: engineId, irrigationId, meterId, endGal, startGal, totalGal
* @param {Boolean} edit: is a record being edited
* @returns {Object}
* @called-in: ['/irrigation/irrigation_create.js->irrigation_form.js->irrigation_valve_hours.js']
**/function handleValveHours(_ref6){var v=_ref6.v,edit=_ref6.edit;if(edit){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["i" /* HANDLE_EDIT_VALVE_HOURS */],payload:v};}return{type:__WEBPACK_IMPORTED_MODULE_2__types__["j" /* HANDLE_VALVE_HOURS */],payload:v};}/**
* handleEngineHours(): onChange/onBlur function which adds/removes engine hours when inputted.
  If blank, filter; if value concat/modify
* @returns {Object}
* @called-in: ['/irrigation/irrigation_create.js->irrigation_form.js->irrigation_engine_hours.js']
**/function handleEngineHours(_ref7){var e=_ref7.e,edit=_ref7.edit;if(edit){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["k" /* HANDLE_EDIT_ENGINE_HOURS */],payload:e};}return{type:__WEBPACK_IMPORTED_MODULE_2__types__["l" /* HANDLE_ENGINE_HOURS */],payload:e};}/**
* handleMeterGallons(): onChange/onBlur function which adds/removes meter gallons when inputted.
  If blank, filter; if value concat/modify
* @returns {Object}
* @called-in: ['/irrigation/irrigation_create.js->irrigation_form.js->irrigation_meter_gallons.js']
**/function handleMeterGallons(_ref8){var m=_ref8.m,edit=_ref8.edit;if(edit){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["m" /* HANDLE_EDIT_METER_GALLONS */],payload:m};}return{type:__WEBPACK_IMPORTED_MODULE_2__types__["n" /* HANDLE_METER_GALLONS */],payload:m};}/**
* preloadMeterForm(): Preloads the meters form with the last submitted irrigation meter log
  If blank, filter; if value concat/modify
* @param {Array} prevMeters: Last submitted meter values
* @param {String} formId: id of the form to be filled
* @returns {Object}
* @called-in: ['/irrigation/irrigation_create.js']
**/function preloadMeterForm(_ref9){var prevMeters=_ref9.prevMeters,formId=_ref9.formId;setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["a" /* preFillForm */])({data:prevMeters,formId:formId,prop:'endGal'});},200);return{type:__WEBPACK_IMPORTED_MODULE_2__types__["o" /* PRELOAD_METER_FORM */]};}/**
* selectIrrigationLogToEdit(): Selects a log to edit and prefills edit form
* @param {Object} i: irrigation log
* @returns {Object}
* @called-in: ['/irrigation/irrigation_manage.js']
**/function selectIrrigationLogToEdit(_ref10){var i=_ref10.i,employees=_ref10.employees;var engineLog=i.engineLog,meterLog=i.meterLog,valveLog=i.valveLog;// Need new copy of log; otherwise delete will mutate state
var irr=Object.assign({},i);delete irr.engineLog;delete irr.meterLog;delete irr.valveLog;var emp=employees.find(function(e){return Number(e.id)===Number(irr.employee);});var name=emp.firstName+' '+emp.lastName||'N/A';setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('engine-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('meter-form');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["e" /* clearForm */])('valve-form');document.getElementById('irrigation-date').value=__WEBPACK_IMPORTED_MODULE_1_moment___default()(irr.date).format('YYYY-MM-DD');document.getElementById('irrigation-notes').value=irr.notes;document.getElementById('irrigation-employee').value=name;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["a" /* preFillForm */])({data:engineLog.map(function(e){return Object.assign({},e,{id:e.engineId});}),formId:'engine-form',prop:'hours'});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["a" /* preFillForm */])({data:valveLog.map(function(e){return Object.assign({},e,{id:e.valveId});}),formId:'valve-form',prop:'hours',style:true});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["b" /* preFillMeterForm */])({data:meterLog,formId:'meter-form'});},500);return{type:__WEBPACK_IMPORTED_MODULE_2__types__["p" /* SELECT_IRRIGATION_LOG_TO_EDIT */],payload:{data:Object.assign({},irr),engineLog:engineLog,meterLog:meterLog,valveLog:valveLog}};}/**
* resetDashboard(): Clears data for dashboard, returns to table view
* @returns {Object}
* @called-in: ['/irrigation/irrigation_view.js']
**/function resetDashboard(){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["q" /* RESET_DASHBOARD */]};}function error(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_2__types__["r" /* ERROR */],err:err};}function success(msg){Materialize.toast(msg,4000,'rounded green');}function _error(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_2__types__["r" /* ERROR */],err:err};}/* END */

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = acresCompleted;
/* harmony export (immutable) */ __webpack_exports__["d"] = acresBalance;
/* harmony export (immutable) */ __webpack_exports__["b"] = batchAcresBalances;
/* unused harmony export SEASON_LOCATION */
/* harmony export (immutable) */ __webpack_exports__["a"] = seasonForLocation;
/*******************************************************************************
Mechanical harvest acreage calculations — pure, no imports.

Kept free of browser globals (harvest_utils.js reads window.Materialize at load)
so these can be tested under plain Node: `node --test test/*.test.mjs` from Client/.
harvest_utils.js re-exports acresCompleted/acresBalance for existing callers.
*******************************************************************************//* Calculates the acres completed based on tree count input */function acresCompleted(trees,treesPerAcre){if(!(trees&&treesPerAcre))return 0.00;return(Number(trees)/Number(treesPerAcre)).toFixed(2);}/* Remaining acres in a field after acresCompleted (cumulative) is subtracted */function acresBalance(acresCompleted,acresRemaining){if(!(acresCompleted&&acresRemaining))return 0.00;return(Number(acresRemaining)-Number(acresCompleted)).toFixed(2);}/**
* batchAcresBalances(): acres balance for each record of one submission
* @param {Array} harvest: records being submitted together, in entry order
* @param {Array} fields: field rows (field, treePerAcre, mechHarvest)
* @param {Array} pHarvest: [{ field, previousHarvest: [saved records] }] per field
* @returns {Array} acresBalance per record, same order as harvest
*
* Each record's balance is a running balance in entry order: saved acres for the
* field, plus every EARLIER record in this batch on the same field, plus its own.
* Before 2026-10-09 the batch siblings were omitted, so every record after the
* first on a field was over-stated by their acres (ticket: balance only right
* after re-opening the record in Manage > Edit), and siblings could jointly
* exceed the field's acres without tripping the < 0 check in createMechHarvest2.
**/function batchAcresBalances(harvest,fields,pHarvest){var batchAcres={};// field -> acres from earlier records in this batch
return harvest.map(function(h){var field=fields.find(function(f){return f.field===h.field;});var prevHarvest=pHarvest.find(function(p){return p.field===h.field;});var preparedAcres=acresCompleted(h.treesCovered,field.treePerAcre);var existingAcres=prevHarvest.previousHarvest.reduce(function(acc,cur){return acc+cur.acresCompleted;},0);var priorInBatch=batchAcres[h.field]||0;batchAcres[h.field]=priorInBatch+Number(preparedAcres);var totalAcresComplete=Number(preparedAcres)+existingAcres+priorInBatch;return acresBalance(totalAcresComplete,field.mechHarvest);});}/* Locations without a season row of their own harvest under another's.
   75 (Naalehu) -> 71 (Kau): owner decision 2026-10-09. Mirrored server-side in
   Server/services/mech_harvest_season.js — change both together. */var SEASON_LOCATION={'75':'71'};/**
* seasonForLocation(): the current harvest season for a location
* @param {Array} seasons: current seasons as served by /fetchAllMechHarvest (selectCurrentSeasons)
* @param {String} location: '71' | '72' | '75'
* @returns {Object|undefined} season row; undefined when none matches
*
* Matches on season.location (varchar(3)). Until 2026-10-09 the create path was
* positional — seasons[0] for 71, seasons[1] for 72 — but the server lists newest
* first and the 71 row is created before the 72 row each year, so the list
* arrives [72, 71] and every Kau record was filed under the Keaau season and vice
* versa (5,542 of 5,703 rows in seasons 13..18). Editing re-filed a record under
* the correct season, so one field/round's records ended up split across two
* seasonIds. No match now returns undefined so the caller refuses, instead of
* guessing another location's season.
**/function seasonForLocation(seasons,location){var seasonLocation=SEASON_LOCATION[String(location)]||String(location);return seasons.find(function(s){return String(s.location)===seasonLocation;});}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.3
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(1); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge({}, [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(Math.max.apply(null, widths));
	highest = heights.indexOf(Math.max.apply(null, heights));

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used to determine if values are of the language type Object */
var objectTypes = {
  'boolean': false,
  'function': true,
  'object': true,
  'number': false,
  'string': false,
  'undefined': false
};

module.exports = objectTypes;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var noop = __webpack_require__(190),
    reNative = __webpack_require__(58);

/** Used as the property descriptor for `__bindData__` */
var descriptor = {
  'configurable': false,
  'enumerable': false,
  'value': null,
  'writable': false
};

/** Used to set meta data on functions */
var defineProperty = (function() {
  // IE 8 only accepts DOM elements
  try {
    var o = {},
        func = reNative.test(func = Object.defineProperty) && func,
        result = func(o, o, o) && func;
  } catch(e) { }
  return result;
}());

/**
 * Sets `this` binding data on a given function.
 *
 * @private
 * @param {Function} func The function to set data on.
 * @param {Array} value The data array to set.
 */
var setBindData = !defineProperty ? noop : function(func, value) {
  descriptor.value = value;
  defineProperty(func, '__bindData__', descriptor);
};

module.exports = setBindData;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(35);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(605),
    mapCacheDelete = __webpack_require__(606),
    mapCacheGet = __webpack_require__(607),
    mapCacheHas = __webpack_require__(608),
    mapCacheSet = __webpack_require__(609);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(564),
    isObjectLike = __webpack_require__(60);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(36),
    isSymbol = __webpack_require__(111);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(552),
    baseKeys = __webpack_require__(569),
    isArrayLike = __webpack_require__(202);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(48);
var Danger = __webpack_require__(649);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstrumentation = __webpack_require__(26);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);
var setInnerHTML = __webpack_require__(85);
var setTextContent = __webpack_require__(232);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactErrorUtils = __webpack_require__(120);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(678);
var propTypesFactory = __webpack_require__(210);

var React = __webpack_require__(52);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(38);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(26);
var ReactUpdates = __webpack_require__(31);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var emptyFunction = __webpack_require__(29);
var warning = __webpack_require__(10);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(707);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;

var _react = __webpack_require__(0);

var _deprecateObjectProperties = __webpack_require__(87);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _InternalPropTypes = __webpack_require__(45);

var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = exports.falsy = InternalPropTypes.falsy;
var history = exports.history = InternalPropTypes.history;
var location = exports.location = locationShape;
var component = exports.component = InternalPropTypes.component;
var components = exports.components = InternalPropTypes.components;
var route = exports.route = InternalPropTypes.route;
var routes = exports.routes = InternalPropTypes.routes;
var router = exports.router = routerShape;

if (false) {
  (function () {
    var deprecatePropType = function deprecatePropType(propType, message) {
      return function () {
        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
        return propType.apply(undefined, arguments);
      };
    };

    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
    };

    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
    };

    exports.falsy = falsy = deprecateInternalPropType(falsy);
    exports.history = history = deprecateInternalPropType(history);
    exports.component = component = deprecateInternalPropType(component);
    exports.components = components = deprecateInternalPropType(components);
    exports.route = route = deprecateInternalPropType(route);
    exports.routes = routes = deprecateInternalPropType(routes);

    exports.location = location = deprecateRenamedPropType(location, 'location');
    exports.router = router = deprecateRenamedPropType(router, 'router');
  })();
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

exports.default = defaultExport;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _Actions = __webpack_require__(47);

var _computeChangedRoutes2 = __webpack_require__(730);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(727);

var _isActive2 = __webpack_require__(734);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(731);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(736);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  function createLocationFromRedirectInfo(location) {
    return history.createLocation(location, _Actions.REPLACE);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);

    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
    var changeRoutes = _computeChangedRoutes.changeRoutes;
    var enterRoutes = _computeChangedRoutes.enterRoutes;


    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.transitionTo(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes
module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactSparklines"] = factory(require("react"));
	else
		root["ReactSparklines"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(16)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {
    return data.reduce(function (a, b) {
        return a + b;
    }) / data.length;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {
    return Math.min.apply(Math, data);
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(4);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {
    return Math.max.apply(Math, data);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mean = __webpack_require__(3);

var _mean2 = _interopRequireDefault(_mean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (data) {
    var dataMean = (0, _mean2.default)(data);
    var sqDiff = data.map(function (n) {
        return Math.pow(n - dataMean, 2);
    });
    var avgSqDiff = (0, _mean2.default)(sqDiff);
    return Math.sqrt(avgSqDiff);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(13);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SparklinesText = exports.SparklinesNormalBand = exports.SparklinesReferenceLine = exports.SparklinesSpots = exports.SparklinesBars = exports.SparklinesCurve = exports.SparklinesLine = exports.Sparklines = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SparklinesText = __webpack_require__(17);

var _SparklinesText2 = _interopRequireDefault(_SparklinesText);

var _SparklinesLine = __webpack_require__(18);

var _SparklinesLine2 = _interopRequireDefault(_SparklinesLine);

var _SparklinesCurve = __webpack_require__(19);

var _SparklinesCurve2 = _interopRequireDefault(_SparklinesCurve);

var _SparklinesBars = __webpack_require__(20);

var _SparklinesBars2 = _interopRequireDefault(_SparklinesBars);

var _SparklinesSpots = __webpack_require__(21);

var _SparklinesSpots2 = _interopRequireDefault(_SparklinesSpots);

var _SparklinesReferenceLine = __webpack_require__(22);

var _SparklinesReferenceLine2 = _interopRequireDefault(_SparklinesReferenceLine);

var _SparklinesNormalBand = __webpack_require__(27);

var _SparklinesNormalBand2 = _interopRequireDefault(_SparklinesNormalBand);

var _dataToPoints = __webpack_require__(28);

var _dataToPoints2 = _interopRequireDefault(_dataToPoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sparklines = function (_PureComponent) {
    _inherits(Sparklines, _PureComponent);

    function Sparklines(props) {
        _classCallCheck(this, Sparklines);

        return _possibleConstructorReturn(this, (Sparklines.__proto__ || Object.getPrototypeOf(Sparklines)).call(this, props));
    }

    _createClass(Sparklines, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                limit = _props.limit,
                width = _props.width,
                height = _props.height,
                svgWidth = _props.svgWidth,
                svgHeight = _props.svgHeight,
                preserveAspectRatio = _props.preserveAspectRatio,
                margin = _props.margin,
                style = _props.style,
                max = _props.max,
                min = _props.min;


            if (data.length === 0) return null;

            var points = (0, _dataToPoints2.default)({ data: data, limit: limit, width: width, height: height, margin: margin, max: max, min: min });

            var svgOpts = { style: style, viewBox: '0 0 ' + width + ' ' + height, preserveAspectRatio: preserveAspectRatio };
            if (svgWidth > 0) svgOpts.width = svgWidth;
            if (svgHeight > 0) svgOpts.height = svgHeight;

            return _react2.default.createElement(
                'svg',
                svgOpts,
                _react2.default.Children.map(this.props.children, function (child) {
                    return _react2.default.cloneElement(child, { data: data, points: points, width: width, height: height, margin: margin });
                })
            );
        }
    }]);

    return Sparklines;
}(_react.PureComponent);

Sparklines.propTypes = {
    data: _propTypes2.default.array,
    limit: _propTypes2.default.number,
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    svgWidth: _propTypes2.default.number,
    svgHeight: _propTypes2.default.number,
    preserveAspectRatio: _propTypes2.default.string,
    margin: _propTypes2.default.number,
    style: _propTypes2.default.object,
    min: _propTypes2.default.number,
    max: _propTypes2.default.number,
    onMouseMove: _propTypes2.default.func
};
Sparklines.defaultProps = {
    data: [],
    width: 240,
    height: 60,
    //Scale the graphic content of the given element non-uniformly if necessary such that the element's bounding box exactly matches the viewport rectangle.
    preserveAspectRatio: 'none', //https://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
    margin: 2
};
exports.Sparklines = Sparklines;
exports.SparklinesLine = _SparklinesLine2.default;
exports.SparklinesCurve = _SparklinesCurve2.default;
exports.SparklinesBars = _SparklinesBars2.default;
exports.SparklinesSpots = _SparklinesSpots2.default;
exports.SparklinesReferenceLine = _SparklinesReferenceLine2.default;
exports.SparklinesNormalBand = _SparklinesNormalBand2.default;
exports.SparklinesText = _SparklinesText2.default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(8);

var ReactPropTypesSecret = __webpack_require__(6);
var checkPropTypes = __webpack_require__(15);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(5);
  var warning = __webpack_require__(8);
  var ReactPropTypesSecret = __webpack_require__(6);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(5);
var ReactPropTypesSecret = __webpack_require__(6);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesText = function (_React$Component) {
    _inherits(SparklinesText, _React$Component);

    function SparklinesText() {
        _classCallCheck(this, SparklinesText);

        return _possibleConstructorReturn(this, (SparklinesText.__proto__ || Object.getPrototypeOf(SparklinesText)).apply(this, arguments));
    }

    _createClass(SparklinesText, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                point = _props.point,
                text = _props.text,
                fontSize = _props.fontSize,
                fontFamily = _props.fontFamily;
            var x = point.x,
                y = point.y;

            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'text',
                    { x: x, y: y, fontFamily: fontFamily || "Verdana", fontSize: fontSize || 10 },
                    text
                )
            );
        }
    }]);

    return SparklinesText;
}(_react2.default.Component);

SparklinesText.propTypes = {
    text: _propTypes2.default.string,
    point: _propTypes2.default.object,
    fontSize: _propTypes2.default.number,
    fontFamily: _propTypes2.default.string
};
SparklinesText.defaultProps = {
    text: '',
    point: { x: 0, y: 0 }
};
exports.default = SparklinesText;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesLine = function (_React$Component) {
  _inherits(SparklinesLine, _React$Component);

  function SparklinesLine() {
    _classCallCheck(this, SparklinesLine);

    return _possibleConstructorReturn(this, (SparklinesLine.__proto__ || Object.getPrototypeOf(SparklinesLine)).apply(this, arguments));
  }

  _createClass(SparklinesLine, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          points = _props.points,
          width = _props.width,
          height = _props.height,
          margin = _props.margin,
          color = _props.color,
          style = _props.style,
          onMouseMove = _props.onMouseMove;


      var linePoints = points.map(function (p) {
        return [p.x, p.y];
      }).reduce(function (a, b) {
        return a.concat(b);
      });

      var closePolyPoints = [points[points.length - 1].x, height - margin, margin, height - margin, margin, points[0].y];

      var fillPoints = linePoints.concat(closePolyPoints);

      var lineStyle = {
        stroke: color || style.stroke || 'slategray',
        strokeWidth: style.strokeWidth || '1',
        strokeLinejoin: style.strokeLinejoin || 'round',
        strokeLinecap: style.strokeLinecap || 'round',
        fill: 'none'
      };
      var fillStyle = {
        stroke: style.stroke || 'none',
        strokeWidth: '0',
        fillOpacity: style.fillOpacity || '.1',
        fill: style.fill || color || 'slategray',
        pointerEvents: 'auto'
      };

      var tooltips = points.map(function (p, i) {
        return _react2.default.createElement('circle', {
          key: i,
          cx: p.x,
          cy: p.y,
          r: 2,
          style: fillStyle,
          onMouseEnter: function onMouseEnter(e) {
            return onMouseMove('enter', data[i], p);
          },
          onClick: function onClick(e) {
            return onMouseMove('click', data[i], p);
          }
        });
      });

      return _react2.default.createElement(
        'g',
        null,
        tooltips,
        _react2.default.createElement('polyline', { points: fillPoints.join(' '), style: fillStyle }),
        _react2.default.createElement('polyline', { points: linePoints.join(' '), style: lineStyle })
      );
    }
  }]);

  return SparklinesLine;
}(_react2.default.Component);

SparklinesLine.propTypes = {
  color: _propTypes2.default.string,
  style: _propTypes2.default.object
};
SparklinesLine.defaultProps = {
  style: {},
  onMouseMove: function onMouseMove() {}
};
exports.default = SparklinesLine;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesCurve = function (_React$Component) {
    _inherits(SparklinesCurve, _React$Component);

    function SparklinesCurve() {
        _classCallCheck(this, SparklinesCurve);

        return _possibleConstructorReturn(this, (SparklinesCurve.__proto__ || Object.getPrototypeOf(SparklinesCurve)).apply(this, arguments));
    }

    _createClass(SparklinesCurve, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                points = _props.points,
                width = _props.width,
                height = _props.height,
                margin = _props.margin,
                color = _props.color,
                style = _props.style,
                _props$divisor = _props.divisor,
                divisor = _props$divisor === undefined ? 0.25 : _props$divisor;

            var prev = void 0;
            var curve = function curve(p) {
                var res = void 0;
                if (!prev) {
                    res = [p.x, p.y];
                } else {
                    var len = (p.x - prev.x) * divisor;
                    res = ["C",
                    //x1
                    prev.x + len,
                    //y1
                    prev.y,
                    //x2,
                    p.x - len,
                    //y2,
                    p.y,
                    //x,
                    p.x,
                    //y
                    p.y];
                }
                prev = p;
                return res;
            };
            var linePoints = points.map(function (p) {
                return curve(p);
            }).reduce(function (a, b) {
                return a.concat(b);
            });
            var closePolyPoints = ["L" + points[points.length - 1].x, height - margin, margin, height - margin, margin, points[0].y];
            var fillPoints = linePoints.concat(closePolyPoints);

            var lineStyle = {
                stroke: color || style.stroke || 'slategray',
                strokeWidth: style.strokeWidth || '1',
                strokeLinejoin: style.strokeLinejoin || 'round',
                strokeLinecap: style.strokeLinecap || 'round',
                fill: 'none'
            };
            var fillStyle = {
                stroke: style.stroke || 'none',
                strokeWidth: '0',
                fillOpacity: style.fillOpacity || '.1',
                fill: style.fill || color || 'slategray'
            };

            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { d: "M" + fillPoints.join(' '), style: fillStyle }),
                _react2.default.createElement('path', { d: "M" + linePoints.join(' '), style: lineStyle })
            );
        }
    }]);

    return SparklinesCurve;
}(_react2.default.Component);

SparklinesCurve.propTypes = {
    color: _propTypes2.default.string,
    style: _propTypes2.default.object
};
SparklinesCurve.defaultProps = {
    style: {}
};
exports.default = SparklinesCurve;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesBars = function (_React$Component) {
  _inherits(SparklinesBars, _React$Component);

  function SparklinesBars() {
    _classCallCheck(this, SparklinesBars);

    return _possibleConstructorReturn(this, (SparklinesBars.__proto__ || Object.getPrototypeOf(SparklinesBars)).apply(this, arguments));
  }

  _createClass(SparklinesBars, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          points = _props.points,
          height = _props.height,
          style = _props.style,
          barWidth = _props.barWidth,
          margin = _props.margin,
          onMouseMove = _props.onMouseMove;

      var strokeWidth = 1 * (style && style.strokeWidth || 0);
      var marginWidth = margin ? 2 * margin : 0;
      var width = barWidth || (points && points.length >= 2 ? Math.max(0, points[1].x - points[0].x - strokeWidth - marginWidth) : 0);

      return _react2.default.createElement(
        'g',
        { transform: 'scale(1,-1)' },
        points.map(function (p, i) {
          return _react2.default.createElement('rect', {
            key: i,
            x: p.x - (width + strokeWidth) / 2,
            y: -height,
            width: width,
            height: Math.max(0, height - p.y),
            style: style,
            onMouseMove: onMouseMove && onMouseMove.bind(_this2, p)
          });
        })
      );
    }
  }]);

  return SparklinesBars;
}(_react2.default.Component);

SparklinesBars.propTypes = {
  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
  height: _propTypes2.default.number,
  style: _propTypes2.default.object,
  barWidth: _propTypes2.default.number,
  margin: _propTypes2.default.number,
  onMouseMove: _propTypes2.default.func
};
SparklinesBars.defaultProps = {
  style: { fill: 'slategray' }
};
exports.default = SparklinesBars;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesSpots = function (_React$Component) {
    _inherits(SparklinesSpots, _React$Component);

    function SparklinesSpots() {
        _classCallCheck(this, SparklinesSpots);

        return _possibleConstructorReturn(this, (SparklinesSpots.__proto__ || Object.getPrototypeOf(SparklinesSpots)).apply(this, arguments));
    }

    _createClass(SparklinesSpots, [{
        key: 'lastDirection',
        value: function lastDirection(points) {

            Math.sign = Math.sign || function (x) {
                return x > 0 ? 1 : -1;
            };

            return points.length < 2 ? 0 : Math.sign(points[points.length - 2].y - points[points.length - 1].y);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                points = _props.points,
                width = _props.width,
                height = _props.height,
                size = _props.size,
                style = _props.style,
                spotColors = _props.spotColors;


            var startSpot = _react2.default.createElement('circle', {
                cx: points[0].x,
                cy: points[0].y,
                r: size,
                style: style });

            var endSpot = _react2.default.createElement('circle', {
                cx: points[points.length - 1].x,
                cy: points[points.length - 1].y,
                r: size,
                style: style || { fill: spotColors[this.lastDirection(points)] } });

            return _react2.default.createElement(
                'g',
                null,
                style && startSpot,
                endSpot
            );
        }
    }]);

    return SparklinesSpots;
}(_react2.default.Component);

SparklinesSpots.propTypes = {
    size: _propTypes2.default.number,
    style: _propTypes2.default.object,
    spotColors: _propTypes2.default.object
};
SparklinesSpots.defaultProps = {
    size: 2,
    spotColors: {
        '-1': 'red',
        '0': 'black',
        '1': 'green'
    }
};
exports.default = SparklinesSpots;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dataProcessing = __webpack_require__(23);

var dataProcessing = _interopRequireWildcard(_dataProcessing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesReferenceLine = function (_React$Component) {
    _inherits(SparklinesReferenceLine, _React$Component);

    function SparklinesReferenceLine() {
        _classCallCheck(this, SparklinesReferenceLine);

        return _possibleConstructorReturn(this, (SparklinesReferenceLine.__proto__ || Object.getPrototypeOf(SparklinesReferenceLine)).apply(this, arguments));
    }

    _createClass(SparklinesReferenceLine, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                points = _props.points,
                margin = _props.margin,
                type = _props.type,
                style = _props.style,
                value = _props.value;


            var ypoints = points.map(function (p) {
                return p.y;
            });
            var y = type == 'custom' ? value : dataProcessing[type](ypoints);

            return _react2.default.createElement('line', {
                x1: points[0].x, y1: y + margin,
                x2: points[points.length - 1].x, y2: y + margin,
                style: style });
        }
    }]);

    return SparklinesReferenceLine;
}(_react2.default.Component);

SparklinesReferenceLine.propTypes = {
    type: _propTypes2.default.oneOf(['max', 'min', 'mean', 'avg', 'median', 'custom']),
    value: _propTypes2.default.number,
    style: _propTypes2.default.object
};
SparklinesReferenceLine.defaultProps = {
    type: 'mean',
    style: { stroke: 'red', strokeOpacity: .75, strokeDasharray: '2, 2' }
};
exports.default = SparklinesReferenceLine;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variance = exports.stdev = exports.median = exports.midRange = exports.avg = exports.mean = exports.max = exports.min = undefined;

var _min2 = __webpack_require__(7);

var _min3 = _interopRequireDefault(_min2);

var _mean2 = __webpack_require__(3);

var _mean3 = _interopRequireDefault(_mean2);

var _midRange2 = __webpack_require__(24);

var _midRange3 = _interopRequireDefault(_midRange2);

var _median2 = __webpack_require__(25);

var _median3 = _interopRequireDefault(_median2);

var _stdev2 = __webpack_require__(10);

var _stdev3 = _interopRequireDefault(_stdev2);

var _variance2 = __webpack_require__(26);

var _variance3 = _interopRequireDefault(_variance2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.min = _min3.default;
exports.max = _min3.default;
exports.mean = _mean3.default;
exports.avg = _mean3.default;
exports.midRange = _midRange3.default;
exports.median = _median3.default;
exports.stdev = _stdev3.default;
exports.variance = _variance3.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _min = __webpack_require__(7);

var _min2 = _interopRequireDefault(_min);

var _max = __webpack_require__(9);

var _max2 = _interopRequireDefault(_max);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (data) {
    return (0, _max2.default)(data) - (0, _min2.default)(data) / 2;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {
    return data.sort(function (a, b) {
        return a - b;
    })[Math.floor(data.length / 2)];
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mean = __webpack_require__(3);

var _mean2 = _interopRequireDefault(_mean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (data) {
    var dataMean = (0, _mean2.default)(data);
    var sq = data.map(function (n) {
        return Math.pow(n - dataMean, 2);
    });
    return (0, _mean2.default)(sq);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _mean = __webpack_require__(3);

var _mean2 = _interopRequireDefault(_mean);

var _stdev = __webpack_require__(10);

var _stdev2 = _interopRequireDefault(_stdev);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SparklinesNormalBand = function (_React$Component) {
    _inherits(SparklinesNormalBand, _React$Component);

    function SparklinesNormalBand() {
        _classCallCheck(this, SparklinesNormalBand);

        return _possibleConstructorReturn(this, (SparklinesNormalBand.__proto__ || Object.getPrototypeOf(SparklinesNormalBand)).apply(this, arguments));
    }

    _createClass(SparklinesNormalBand, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                points = _props.points,
                margin = _props.margin,
                style = _props.style;


            var ypoints = points.map(function (p) {
                return p.y;
            });
            var dataMean = (0, _mean2.default)(ypoints);
            var dataStdev = (0, _stdev2.default)(ypoints);

            return _react2.default.createElement('rect', { x: points[0].x, y: dataMean - dataStdev + margin,
                width: points[points.length - 1].x - points[0].x, height: _stdev2.default * 2,
                style: style });
        }
    }]);

    return SparklinesNormalBand;
}(_react2.default.Component);

SparklinesNormalBand.propTypes = {
    style: _propTypes2.default.object
};
SparklinesNormalBand.defaultProps = {
    style: { fill: 'red', fillOpacity: .1 }
};
exports.default = SparklinesNormalBand;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _min = __webpack_require__(7);

var _min2 = _interopRequireDefault(_min);

var _max = __webpack_require__(9);

var _max2 = _interopRequireDefault(_max);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var data = _ref.data,
        limit = _ref.limit,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 1 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 1 : _ref$height,
        _ref$margin = _ref.margin,
        margin = _ref$margin === undefined ? 0 : _ref$margin,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? (0, _max2.default)(data) : _ref$max,
        _ref$min = _ref.min,
        min = _ref$min === undefined ? (0, _min2.default)(data) : _ref$min;


    var len = data.length;

    if (limit && limit < len) {
        data = data.slice(len - limit);
    }

    var vfactor = (height - margin * 2) / (max - min || 2);
    var hfactor = (width - margin * 2) / ((limit || len) - (len > 1 ? 1 : 0));

    return data.map(function (d, i) {
        return {
            x: i * hfactor + margin,
            y: (max === min ? 1 : max - d) * vfactor + margin
        };
    });
};

/***/ })
/******/ ]);
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var settle = __webpack_require__(268);
var buildURL = __webpack_require__(144);
var buildFullPath = __webpack_require__(265);
var parseHeaders = __webpack_require__(275);
var isURLSameOrigin = __webpack_require__(273);
var createError = __webpack_require__(140);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(271);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(267);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(23);
var normalizeHeaderName = __webpack_require__(274);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(137);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(137);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchFieldInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = setMapView;
/* harmony export (immutable) */ __webpack_exports__["a"] = setFieldView;
/* harmony export (immutable) */ __webpack_exports__["d"] = setMapLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/************************************************************************
10/25/17
All Actions for map interactions
************************************************************************/var $=window.$;/* Fetch field information: called in containers/main.js  */function fetchFieldInfo(field){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchFieldInfo',{params:{field:field},headers:{authorization:localStorage.getItem('token')}}).then(function(response){return JSON.parse(response.request.response);}).then(function(res){$('#preloader').css('display','none');//console.log(res);
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_61" /* FETCH_FIELD_INFORMATION */],payload:res});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["error"])('There was an error fetching field information: '+err));});};}/* Sets the application interface as viewing map, or main app: called in containers/navbar.js */function setMapView(){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_62" /* SET_MAP_VIEW */]};}/* Sets the field the user is hovering over: Called in containers/main.js */function setFieldView(field){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_63" /* SET_FIELD_VIEW */],payload:field};}/* Switches between locations: Kau & Keaau: Called in containers/navbar.js */function setMapLocation(loc){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_64" /* SET_MAP_LOCATION */],payload:loc};}/* END */

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*******************************************************************************
10/19/17
Alexander Self
Royal Hawaiian Services
Preloader.js: Displays a loader to let users know there is processing occuring
*******************************************************************************/var Preloader=function Preloader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"preloader-wrapper big active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner-layer spinner-blue-only"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"circle-clipper left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"circle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gap-patch"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"circle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"circle-clipper right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"circle"}))));};/* harmony default export */ __webpack_exports__["a"] = (Preloader);/* END */

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
5/27/2017
Alexander Self
Timesheet harvest table
- Displays an employees harvested trees, bags, hours, field
***************************************************************/var TimesheetHarvestTable=function TimesheetHarvestTable(_ref){var harvest=_ref.harvest;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Round'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:h.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.trees),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.bags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.block),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.round));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'hours')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'trees')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'bags')))))));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetHarvestTable);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Table Summary of timesheet to be submitted for review;
***************************************************************/var TimesheetEmployeeTable=function TimesheetEmployeeTable(_ref){var timesheet=_ref.timesheet,employees=_ref.employees;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"highlight bordered responsive-table centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Grade"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Regular Hours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Overtime"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Doubletime"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Summary of Hours"),timesheet.dustPay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"error"},"Dust Pay"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,employees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:e.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.firstName," ",e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.grade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,timesheet.regHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,timesheet.otHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,timesheet.doubleTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,timesheet.summaryOfHours),timesheet.dustPay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"done")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null));})));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetEmployeeTable);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
5/27/2017
Alexander Self
Timesheet harvest table
- Displays an employees harvested trees, bags, hours, field
***************************************************************/var TimesheetHarvestViewTable=function TimesheetHarvestViewTable(_ref){var harvest=_ref.harvest;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Inc. Bonus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'P. Index'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cost Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Subaccount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Round'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:h.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.trees),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.bags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'$',h.incentive.toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.pIndex),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.block),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.costCenter?h.costCenter:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.subAccount?h.subAccount:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,h.round));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'hours')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'trees')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'bags')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'incentive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* totalCount */])(harvest,'pIndex')))))));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetHarvestViewTable);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_map_actions__ = __webpack_require__(145);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*************************************************************************
Alexander Self
10/24/2017
Navbar
*************************************************************************/var Navbar=function(_Component){_inherits(Navbar,_Component);function Navbar(props){_classCallCheck(this,Navbar);var _this=_possibleConstructorReturn(this,(Navbar.__proto__||Object.getPrototypeOf(Navbar)).call(this,props));_this.renderLinks=_this.renderLinks.bind(_this);_this.renderNavLinks=_this.renderNavLinks.bind(_this);return _this;}_createClass(Navbar,[{key:'renderLinks',value:function renderLinks(){var _this2=this;if(this.props.authenticated){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'9F'},this.props.mapView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'kau',className:'btn-flat',onClick:function onClick(e){return _this2.props.setMapLocation(e.target.id);}},'Ka\'u'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'keaau',className:'btn-flat',onClick:function onClick(e){return _this2.props.setMapLocation(e.target.id);}},'Kea\'au')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'8F',className:'map-check'},this.props.mapView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn blue',onClick:this.props.setMapView},'App View'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn blue',onClick:this.props.setMapView},'Map View')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'6F'},this.props.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'7F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/signout'},'Sign Out'))];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/'},'Sign In'));}}/* Only want these showing up on hamburger menu */},{key:'renderNavLinks',value:function renderNavLinks(){if(this.props.authenticated){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'1F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/dashboard'},'Dashboard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'2F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/timesheet'},'Timesheet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'3F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/schedule'},'Schedule')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'4F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/faultlog'},'Fault Log')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'5F'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{className:'nav-link',to:'/profile'},'Profile'))];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{id:'main-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{to:'/',className:'brand-logo left himn-logo'},'Hawaiian Macadamia Nut Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],{'data-activates':'slide-out',className:'nav-link button-collapse right',to:'/signout'},'Sign Out'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'right hide-on-med-and-down'},this.renderLinks())));}}]);return Navbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;function mapStateToProps(state){return{authenticated:state.auth.authenticated,user:state.auth.user,email:state.auth.user.email,field:state.misc.field,mapView:state.misc.mapView};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({setMapView:__WEBPACK_IMPORTED_MODULE_4__actions_map_actions__["c" /* setMapView */],setMapLocation:__WEBPACK_IMPORTED_MODULE_4__actions_map_actions__["d" /* setMapLocation */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Navbar));

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchFertilizerApplications;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOrEditFertilizerApplication;
/* harmony export (immutable) */ __webpack_exports__["i"] = deleteFertilizerApplication;
/* harmony export (immutable) */ __webpack_exports__["e"] = prepareData;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectFertAppToEdit;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFertilizer;
/* harmony export (immutable) */ __webpack_exports__["d"] = editFertilizer;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteFertilizer;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectFertilizerToEdit;
/* harmony export (immutable) */ __webpack_exports__["h"] = setFertilizerForm;
/* harmony export (immutable) */ __webpack_exports__["k"] = selectFertilizerApplication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var $=window.$;/**
* fetchFertilizerApplications(): Fetches all recent fertilizer applications
* @returns {Array} fertilizerApps
* @called-in: ['/components/chemical/fertilizer_app_view.js']
**/function fetchFertilizerApplications(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchFertilizerApplications',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["P" /* FETCH_FERTILIZER_APPLICATIONS */],payload:res.data.fertApps});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('There was an error fetching fertilizer applications.'));});};}/**
* createOrEditFertilizerApplication(): Creates a fertilzier record
* @param {Object} data: fert application
* @param {String} type: Create or edit. Redux type
* @param {String} path: Routing path to server
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/function createOrEditFertilizerApplication(_ref){var data=_ref.data,type=_ref.type,path=_ref.path;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["d" /* checkApplicationForm */])(data))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Entire form must be filled.');if(data.fertilizerApplied.length===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('At least one fertilizer is required.');var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=data.fertilizerApplied[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var f=_step.value;if(Number(f.acresBalance)<-5.0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Cannot exceed total acres in a field. Re-enter Acres Completed.');}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=data.fertilizerApplied[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _f2=_step2.value;if(_f2.appType==='L'&&Number(data.measurement)===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Total Gallons must be greater than 0 for foliar applications.');}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/'+path,{data:data}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])('fertilizer-application-form');var _res$data=res.data,msg=_res$data.msg,record=_res$data.record;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["b" /* success */])(msg);dispatch({type:type,payload:record});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* deleteFertilizerApplication(): Deletes a fertilzier record
* @param {String} fertAppId: id of fertilizer application
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_view.js->fab_modal_v2.js']
**/function deleteFertilizerApplication(_ref2){var fertAppId=_ref2.fertAppId;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/deleteFertilizerApplication',{fertAppId:fertAppId}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["Q" /* DELETE_FERTILIZER_APPLICATION */],payload:res.data.fertAppId});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* prepareData(): Prepares a fert application for submission
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/function prepareData(_ref3){var user=_ref3.user,form=_ref3.form,fields=_ref3.fields,employees=_ref3.employees,fertilizerApplied=_ref3.fertilizerApplied,fertAppId=_ref3.fertAppId,editingApplication=_ref3.editingApplication;var e=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["l" /* findEmployeeByName */])(form.employee,employees);var isComplete=form.isComplete==='Incomplete'?0:1;// If EID is filled in form
if(!e&&form.employee!=='')e=employees.find(function(emp){return emp.eid===form.employee;});var _loop=function _loop(fert){var field=fields.find(function(f){return f.field===fert.field;});fert.acresBalance=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["m" /* acresBalance */])(fert.acresCompleted,field.totalAcre);};var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=fertilizerApplied[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var fert=_step3.value;_loop(fert);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}delete form.solidOrLiquid;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchPreviousFertApplications',{params:{date:form.date,fertilizerApplied:JSON.stringify(fertilizerApplied),round:form.round,isComplete:isComplete},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');var prevApps=res.data.prevApps;// If editing application, do not fetch any of the records that are potentially being edited
if(editingApplication){prevApps=prevApps.map(function(p){// eslint-disable-next-line
if(fertilizerApplied.find(function(f){return f.id===p.id;}))return;return p;}).filter(function(p){return p!==undefined;});}// Update the balance if previous submissions exist for round, field, year
var _loop2=function _loop2(f){var selectedField=fields.find(function(_f){return _f.field===f.field;});var previousAcresWorked=prevApps.filter(function(p){return p.field===f.field&&p.id!==f.id;}).reduce(function(acc,cur){return acc+Number(cur.acresCompleted);},0);if(editingApplication)previousAcresWorked=0;var totalAcresWorked=Number(f.acresCompleted);if(f.appType==='S')totalAcresWorked+=previousAcresWorked;if(f.appType==='L'){var uniqueAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["p" /* uniqueElementsByRight */])(prevApps,function(a,b){return a.fertAppId===b.fertAppId;});totalAcresWorked+=uniqueAcres.reduce(function(acc,cur){return acc+Number(cur.acresCompleted);},0);//Math.max(...prevApps.map((_f) => _f.acresCompleted));
}var balance=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["m" /* acresBalance */])(totalAcresWorked,selectedField.totalAcre);f.acresBalance=balance;};var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=fertilizerApplied[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var f=_step4.value;_loop2(f);}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["R" /* PREPARE_DATA */],payload:Object.assign({},form,{fertAppId:fertAppId?fertAppId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),employee:e.eid,isComplete:isComplete,canEdit:1,submitter:user.eid,fertilizerApplied:fertilizerApplied,editedBy:editingApplication?user.eid:null}),previousApplications:prevApps});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* selectFertAppToEdit(): Sets the application to edit
* @param {Object} app: app to edit
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/function selectFertAppToEdit(_ref4){var formId=_ref4.formId,app=_ref4.app,employees=_ref4.employees;var employee=employees.find(function(e){return e.eid===app.employee;});if(employee)app.employee=employee.firstName+' '+employee.lastName;// Fill form
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,app);// After form is filled, set employee back to eid
app.employee=employee.eid;return function(dispatch){dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_actions__["c" /* fetchFields */])(app.location));dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["S" /* SELECT_FERT_APP_TO_EDIT */],payload:app});};}/**
* addFertilizer(): Adds a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/function addFertilizer(_ref5){var fertilizer=_ref5.fertilizer,formId=_ref5.formId,chemicals=_ref5.chemicals;var chemId=fertilizer.chemId;for(var key in fertilizer){if(fertilizer[key]==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('All fields must be filled.');if(!isNaN(fertilizer[key])&&Number(fertilizer[key])<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Value must be greater than 0.');}var chem=chemicals.find(function(c){return c.id===Number(chemId);});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["T" /* ADD_FERTILIZER */],payload:Object.assign({id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),chemId:chem.id,acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["n" /* acresPerHour */])(fertilizer.hours,fertilizer.acresCompleted),quantityPerAcre:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["q" /* tonsPerAcre */])(fertilizer.quantityApplied,fertilizer.acresCompleted),quantityPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["r" /* tonsPerHour */])(fertilizer.quantityApplied,fertilizer.hours)},fertilizer,{formId:formId})};}/**
* editFertilizer(): Edits a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/function editFertilizer(_ref6){var fertilizer=_ref6.fertilizer,fertAppId=_ref6.fertAppId,editFertilizerApplied=_ref6.editFertilizerApplied,formId=_ref6.formId,chemicals=_ref6.chemicals;var chemId=fertilizer.chemId;for(var key in fertilizer){if(fertilizer[key]==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('All fields must be filled.');if(!isNaN(fertilizer[key])&&Number(fertilizer[key])<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Value must be greater than 0.');}var chem=chemicals.find(function(c){return c.id===Number(chemId);});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);// ON EDIT APPLICATION ONLY: Check if a fertAppId exists, if so, add it to object
if(Object.keys(editFertilizerApplied).length>0){fertilizer.fertAppId=editFertilizerApplied.fertAppId;fertilizer.id=editFertilizerApplied.id;}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["U" /* EDIT_FERTILIZER */],payload:Object.assign({chemId:chem.id,acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["n" /* acresPerHour */])(fertilizer.hours,fertilizer.acresCompleted),quantityPerAcre:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["q" /* tonsPerAcre */])(fertilizer.quantityApplied,fertilizer.acresCompleted),quantityPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["r" /* tonsPerHour */])(fertilizer.quantityApplied,fertilizer.hours)},fertilizer,{formId:formId})};}/**
* deleteFertilizer(): Deletes a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/function deleteFertilizer(_ref7){var fertilizer=_ref7.fertilizer;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["V" /* DELETE_FERTILIZER */],payload:fertilizer};}/**
* selectFertilizerToEdit(): Selects a fertilzier record to edit
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/function selectFertilizerToEdit(_ref8){var fertilizer=_ref8.fertilizer,formId=_ref8.formId;var solOrLiq='S';if(fertilizer.unitOfMeasure==='tons'){document.getElementById('fert-solid').checked=true;setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,fertilizer);},500);}else{document.getElementById('fert-liquid').checked=true;solOrLiq='L';setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,fertilizer);},500);}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["W" /* SELECT_FERTILIZER_TO_EDIT */],payload:fertilizer,solOrLiq:solOrLiq};}/**
* setFertilizerForm(): Sets the type of form used for fertilizer submissions(Ganular or foliar app)
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/function setFertilizerForm(_ref9){var val=_ref9.val;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["X" /* SET_FERTILIZER_FORM */],payload:val};}/**
* selectFertilizerApplication(): Sets the application to view or delete
* @param {Object} app: app to view/delete
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_view.js']
**/function selectFertilizerApplication(app){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["Y" /* SELECT_FERTILIZER_APPLICATION */],payload:app};}/* END */

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchMowingApplications;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteMowingApplication;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOrEditMowingApplication;
/* harmony export (immutable) */ __webpack_exports__["e"] = prepareMow;
/* harmony export (immutable) */ __webpack_exports__["a"] = addMow;
/* harmony export (immutable) */ __webpack_exports__["d"] = editMow;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteMow;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectMowToEdit;
/* harmony export (immutable) */ __webpack_exports__["j"] = selectMowingApplication;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectMowAppToEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var $=window.$;/**
* fetchMowingApplications(): Fetches all recent fertilizer applications
* @returns {Array} mowingRecords
* @called-in: ['/components/mowing/mowing_view.js']
**/function fetchMowingApplications(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchMowingApplications',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["G" /* FETCH_MOWING_APPLICATIONS */],payload:res.data.mowingRecords});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('There was an error fetching fertilizer applications.'));});};}/**
* deleteMowingApplication(): Deletes a mowing record
* @param {String} mowAppId: id of mowing application
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_view.js->fab_modal_v2.js']
**/function deleteMowingApplication(_ref){var mowAppId=_ref.mowAppId;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/deleteMowingApplication',{mowAppId:mowAppId}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["H" /* DELETE_MOWING_APPLICATION */],payload:res.data.mowAppId});}).catch(function(err){$('#preloader').css('display','none');dispatch({type:'ERROR',payload:err});});};}/**
* createOrEditMowingApplication(): Creates or edits a mowing application
* @param {Object} data: mowing application data
* @param {String} type: Type of action: Create or Edit
* @param {String} path: Path to submit: Create or edit
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/function createOrEditMowingApplication(_ref2){var data=_ref2.data,type=_ref2.type,path=_ref2.path;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["d" /* checkApplicationForm */])(data))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Entire form must be filled.');if(data.mowJobs.length===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('At least one mow record is required.');var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=data.mowJobs[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var f=_step.value;if(Number(f.acresBalance)<0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Cannot exceed total acres in a field. Off by '+f.acresBalance);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/'+path,{data:data}).then(function(res){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])('mowing-form');var _res$data=res.data,record=_res$data.record,msg=_res$data.msg;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["b" /* success */])(msg);dispatch({type:type,payload:record});}).catch(function(err){dispatch({type:'ERROR',payload:err});});};}/**
* prepareMow(): Prepares a mowing application for submission
* @param {Object} mow: mow record
* @param {String} formId: id of mowing form
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/function prepareMow(_ref3){var user=_ref3.user,form=_ref3.form,fields=_ref3.fields,employees=_ref3.employees,mowJobs=_ref3.mowJobs,mowAppId=_ref3.mowAppId,editingApplication=_ref3.editingApplication;var e=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["l" /* findEmployeeByName */])(form.employee,employees);var isComplete=form.isComplete==='Incomplete'?0:1;// If EID is filled in form
if(!e&&form.employee!=='')e=employees.find(function(emp){return emp.eid===form.employee;});return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchPreviousMowApplications',{params:{date:form.date,mowJobs:JSON.stringify(mowJobs),round:form.round,isComplete:isComplete},headers:{authorization:localStorage.getItem('token')}}).then(function(res){var prevApps=res.data.prevApps;if(editingApplication){prevApps=prevApps.map(function(p){// eslint-disable-next-line
if(mowJobs.find(function(m){return m.id===p.id;}))return;return p;}).filter(function(p){return p!==undefined;});}var _loop=function _loop(mow){var field=fields.find(function(f){return f.field===mow.field;});var previousAcresWorked=prevApps.filter(function(p){return p.field===mow.field&&p.id!==mow.id;}).reduce(function(acc,cur){return acc+Number(cur.acresCompleted);},0);//if (editingApplication) previousAcresWorked = 0;
var totalAcresWorked=Number(mow.acresCompleted)+previousAcresWorked;var balance=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["m" /* acresBalance */])(totalAcresWorked,field.totalAcre);mow.acresBalance=balance;};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=mowJobs[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var mow=_step2.value;_loop(mow);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["I" /* PREPARE_MOWING_APPLICATION */],payload:Object.assign({},form,{employee:e.eid,mowAppId:mowAppId?mowAppId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),isComplete:isComplete,submitter:user.eid,mowJobs:mowJobs}),prevApps:prevApps});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('There was an error fetcing previous mows. '+err));});};}/**
* addMow(): Adds a mowing record in the create mow form
* @param {Object} mow: mow record
* @param {String} formId: id of mowing record form
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/function addMow(_ref4){var mow=_ref4.mow,formId=_ref4.formId;if(Number(mow.hours)<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Mowing records require hours.');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["J" /* ADD_MOWING_RECORD */],payload:Object.assign({id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["n" /* acresPerHour */])(mow.hours,mow.acresCompleted)},mow)};}/**
* editMow(): Edits a mowing record
* @param {Object} mow: mow job
* @param {String} formId: id of form
* @param {String} mowAppId: id of mow application
* @param {Object} editMow: the mowjob object being edited
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/function editMow(_ref5){var mow=_ref5.mow,mowAppId=_ref5.mowAppId,editingMow=_ref5.editingMow,formId=_ref5.formId;if(Number(mow.hours)<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chem_actions__["a" /* error */])('Mowing records require hours.');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["g" /* resetForm */])(formId);if(Object.keys(editingMow).length>0){mow.mowAppId=editingMow.mowAppId;mow.id=editingMow.id;}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["K" /* EDIT_MOWING_RECORD */],payload:Object.assign({id:mow.id?mow.id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["e" /* generateID */])(),acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["n" /* acresPerHour */])(mow.hours,mow.acresCompleted)},mow)};}/**
* deleteMow(): Deletes a mowing record
* @param {Number} mowId: mowjob id
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/function deleteMow(_ref6){var mow=_ref6.mow;return{type:__WEBPACK_IMPORTED_MODULE_0__types__["L" /* DELETE_MOWING_RECORD */],payload:mow};}/**
* selectMowToEdit(): Selects a mow record to edit
* @param {Object} mow: mow job
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/function selectMowToEdit(_ref7){var mow=_ref7.mow,formId=_ref7.formId;setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,mow);},500);return{type:__WEBPACK_IMPORTED_MODULE_0__types__["M" /* SELECT_MOW_TO_EDIT */],payload:mow};}/**
* selectMowingApplication(): Sets the application to view or delete
* @param {Object} app: app to view/delete
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_view.js']
**/function selectMowingApplication(app){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["N" /* SELECT_MOWING_APPLICATION */],payload:app};}/**
* selectMowAppToEdit(): Sets the application to edit
* @param {Object} app: app to edit
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/function selectMowAppToEdit(_ref8){var formId=_ref8.formId,app=_ref8.app,employees=_ref8.employees;var employee=employees.find(function(e){return e.eid===app.employee;});if(employee)app.employee=employee.firstName+' '+employee.lastName;// Fill form
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["f" /* fillForm */])(formId,app);// After form is filled, set employee back to eid
app.employee=employee.eid;return function(dispatch){dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_actions__["c" /* fetchFields */])(app.location));dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["O" /* SELECT_MOW_APP_TO_EDIT */],payload:app});};}/* END */

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chem_app_solution_table__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chem_app_sol_table__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/**********************************************************
Chemical Application Display: Displays data for viewing & prior to submission

**********************************************************/var propTypes={application:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,chemicalList:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,solutions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,view:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};var ChemicalApplicationDisplay=function ChemicalApplicationDisplay(_ref){var chemicalList=_ref.chemicalList,solutions=_ref.solutions,application=_ref.application,employees=_ref.employees,selectedApp=_ref.selectedApp,view=_ref.view,createOrEdit=_ref.createOrEdit,toDelete=_ref.toDelete;var certId=application.certId,fieldId=application.fieldId,round=application.round,employee=application.employee;var previousApplications=[];if(selectedApp)previousApplications=selectedApp.previousApplications;var emp={};var name='N/A';if(employees.length>0&&employee!==undefined){emp=employees.find(function(e){return e.eid===employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',{className:'red-text chem-app-flex'},'Are you sure you want to delete the following log?'):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons red-text medium'},'bug_report')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'app-log-header'},'Application Log')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),previousApplications.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Previous Applications - ',fieldId,', Round ',round),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered chem-app-table'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',{className:'chem-app-table-headers'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Employee'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Start Time'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'End Time'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Products'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Round'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'REI'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Pre-Harvest'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,previousApplications.map(function(s,i){var chems=s.solutions.map(function(sols){return sols.chemId;});var c=[];c=chems.map(function(chemId){return chemId===''?'':chemicalList.find(function(cl){return cl.id===Number(chemId);});});if(c===undefined||c[0]===undefined)c=[];var name='N/A';var emp={};if(employees.length>0&&s.employee!==undefined){emp=employees.find(function(e){return e.eid===s.employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',{className:'chem-app-table-row',key:s.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default()(s.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.fieldId),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.startTime),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.endTime),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.acresBalance<0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'red-text'},s.acresBalance):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,s.acresBalance)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.isComplete===0||s.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,c.length>0?c.map(function(chem){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'chem-app-table-name',key:chem.id},chem.name,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br',null));}):''),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.round),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.reiDaysRemaining,' days'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,s.preHarvestDaysRemaining,' days'));})))):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Application'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'certId'},'#',certId)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_4_moment___default()(application.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Employee'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,employees.length>0&&employee!==undefined?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,name):'N/A')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Field'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,application.fieldId)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Method'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,application.method)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Start Time'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'End Time'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Round'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'REI'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Pre-Harvest'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',{className:'chem-app-time'},application.startTime),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.endTime),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.hours),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.acresCompleted),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.acresBalance<0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'red-text'},application.acresBalance):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,application.acresBalance)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.isComplete===0||application.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.round),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.reiDaysRemaining,' days'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,application.preHarvestDaysRemaining,' days')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'Total Gallons: '),application.measurement),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'Notes: '),application.notes)),solutions.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Products'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s1'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s10'},/* SolutionsTable uses different array of object */createOrEdit?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__chem_app_solution_table__["a" /* default */],{solutions:solutions,chemicalList:chemicalList,readOnly:true}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__chem_app_sol_table__["a" /* default */],{solutions:solutions,chemicalList:chemicalList})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s1'})):'')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'divider'}));};ChemicalApplicationDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ChemicalApplicationDisplay);/* END */

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/var propTypes={chemicalList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,formId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,solutions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,edit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,_delete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var SolutionsTable=function SolutionsTable(_ref){var solutions=_ref.solutions,chemicalList=_ref.chemicalList,formId=_ref.formId,edit=_ref.edit,_delete=_ref._delete,readOnly=_ref.readOnly;if(!solutions)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);if(readOnly){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Chemical'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Quantity / Unit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Chemical %'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'REI'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Pre-Harvest'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,solutions.map(function(s,i){var chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:s.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,chem.name,' - ',chem.type),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.chemDosage1,' ',s.chemDosage2),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,isNaN(s.percentageUsed)?0:s.percentageUsed,'%'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.rei,' days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.preHarvest,' days'));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,'Total Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_utils__["u" /* convertToGalAndSum */])(solutions),' gal'))))));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Chemical'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Quantity / Unit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Chemical %'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'REI'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Pre-Harvest'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,solutions.map(function(s,i){var chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:s.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,chem.name,' - ',chem.type),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.chemDosage1,' ',s.chemDosage2),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,isNaN(s.percentageUsed)?0:s.percentageUsed,'%'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.rei,' days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.preHarvest,' days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return edit(s,formId);},className:'btn-floating waves-effect waves-light blue table-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _delete(s);},className:'btn-floating waves-effect waves-light red table-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,'Total Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_utils__["u" /* convertToGalAndSum */])(solutions),' gal'))))));};SolutionsTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (SolutionsTable);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/**********************************************************
Fab button Modal: Button actions for view, edit and deleting
**********************************************************/// It's Fabulous!
var FabModalV2=function FabModalV2(WrappedComponent){return function(props){var user=props.user,application=props.application,_select=props._select,auth=props.auth;if(auth){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,Object.keys(user).length===0?'':user.level>=3||user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'btn-floating red pointer modal-trigger tooltipped btn-squared '+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cult_utils__["k" /* filterOldRecords */])(application)?'':'disabled'),href:'#'+application.id+'-delete','data-position':'top','data-tooltip':'Delete',onClick:function onClick(){return _select(application);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'clear'))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_modal__["a" /* default */])(WrappedComponent)(Object.assign({},props))):'');}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'btn-floating green pointer modal-trigger tooltipped btn-squared',href:'#'+application.id+'-view',onClick:function onClick(){return _select(application);},'data-position':'left','data-tooltip':'View'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'subject'))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_modal__["a" /* default */])(WrappedComponent)(Object.assign({},props)));};};/* harmony default export */ __webpack_exports__["a"] = (FabModalV2);/* END */

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fert_applied_table__ = __webpack_require__(157);
/**********************************************************
Chemical Application Display: Displays data for viewing & prior to submission

**********************************************************/var propTypes={application:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,chemicalList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,solutions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,view:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var FertilizerApplicationDisplay=function FertilizerApplicationDisplay(_ref){var chemicalList=_ref.chemicalList,application=_ref.application,employees=_ref.employees,editingApplication=_ref.editingApplication,previousApplications=_ref.previousApplications,toDelete=_ref.toDelete;var employee=application.employee;var emp={};var name='N/A';if(employees.length>0&&employee!==undefined){emp=employees.find(function(e){return e.eid===employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'red-text chem-app-flex'},'Are you sure you want to delete the following log?'):'',editingApplication?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header blue-text'},'Editing Fertilizer Application Log'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons blue-text medium'},'filter_vintage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header'},'Fertilizer Application Log')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),previousApplications.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Previous Applications - ',application.location,', Round ',application.round),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fert_applied_table__["a" /* default */],{fertilizers:previousApplications,chemicalList:chemicalList,readOnly:true,editChem:false})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Application'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-prev-header'},application.isComplete===0||application.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(application.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Employee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,employees.length>0&&employee!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,name):'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,application.location==='71'?'71 - Kau':'72 - Keaau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Round'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,application.round)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total Gallons: '),application.measurement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Comments: '),application.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},application.fertilizerApplied?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fert_applied_table__["a" /* default */],{fertilizers:application.fertilizerApplied,chemicalList:chemicalList,readOnly:true,editChem:false}):'')));};FertilizerApplicationDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (FertilizerApplicationDisplay);/* END */

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__harvest_utils__ = __webpack_require__(34);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/***************************************************************
2/5/2020
Alexander Self
fert_applied_table.js
- Displays a list of fertilizers applied
***************************************************************/var propTypes={chemicalList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,solutions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,_delete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var FertAppliedTable=function FertAppliedTable(_ref){var fertilizers=_ref.fertilizers,chemicalList=_ref.chemicalList,_edit=_ref._edit,_delete=_ref._delete,readOnly=_ref.readOnly;if(!fertilizers)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);if(readOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,fertilizers.length>0?fertilizers[0].hasOwnProperty('date')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Id'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Id'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fertilizer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Acre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Hour'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,fertilizers.map(function(s,i){var chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:''+s.id+Math.random()},fertilizers.length>0?fertilizers[0].hasOwnProperty('date')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(s.date).format('YYYY-MM-DD')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.id):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,chem.name?chem.name:'',' - ',chem.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresBalance<0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-text'},s.acresBalance):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,s.acresBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityApplied,' ',s.unitOfMeasure),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityPerAcre),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityPerHour));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,fertilizers.find(function(f){return f.appType==='L';})?Math.max.apply(Math,_toConsumableArray(fertilizers.map(function(f){return f.hours;}))):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["c" /* sumProp */])('hours',fertilizers)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,fertilizers.find(function(f){return f.appType==='L';})?Math.max.apply(Math,_toConsumableArray(fertilizers.map(function(f){return f.acresCompleted;}))):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["c" /* sumProp */])('acresCompleted',fertilizers)))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'fert-th'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fertilizer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Acre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,fertilizers.map(function(s,i){var chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'fert-td',key:s.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,chem.name,' - ',chem.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityApplied,' ',s.unitOfMeasure),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityPerAcre),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.quantityPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _edit({fertilizer:s,formId:s.formId});},className:'btn-floating waves-effect waves-light blue table-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _delete({fertilizer:s});},className:'btn-floating waves-effect waves-light red table-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,fertilizers.find(function(f){return f.appType==='L';})?Math.max.apply(Math,_toConsumableArray(fertilizers.map(function(f){return f.hours;}))):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["c" /* sumProp */])('hours',fertilizers)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,fertilizers.find(function(f){return f.appType==='L';})?Math.max.apply(Math,_toConsumableArray(fertilizers.map(function(f){return f.acresCompleted;}))):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["c" /* sumProp */])('acresCompleted',fertilizers)))))));};FertAppliedTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (FertAppliedTable);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mowing_table__ = __webpack_require__(159);
/**********************************************************
Chemical Application Display: Displays data for viewing & prior to submission

**********************************************************/var propTypes={application:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,editingApplication:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,previousApplications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,toDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var MowingApplicationDisplay=function MowingApplicationDisplay(_ref){var application=_ref.application,employees=_ref.employees,editingApplication=_ref.editingApplication,previousApplications=_ref.previousApplications,toDelete=_ref.toDelete;var employee=application.employee;var emp={};var name='N/A';if(employees.length>0&&employee!==undefined){emp=employees.find(function(e){return e.eid===employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'red-text chem-app-flex'},'Are you sure you want to delete the following log?'):'',editingApplication?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header blue-text'},'Editing Mowing Log'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons brown-text lighten-4 medium'},'view_comfy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header'},'Mowing Log')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),previousApplications.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Previous Applications - ',application.location,', Round ',application.round),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__mowing_table__["a" /* default */],{mowJobs:previousApplications,readOnly:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Application'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-prev-header'},application.isComplete===0||application.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(application.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Employee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,employees.length>0&&employee!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,name):'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,application.location==='71'?'71 - Kau':'72 - Keaau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Round'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,application.round)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Comments: '),application.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},application.mowJobs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__mowing_table__["a" /* default */],{mowJobs:application.mowJobs,readOnly:true}):'')));};MowingApplicationDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MowingApplicationDisplay);/* END */

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__harvest_utils__ = __webpack_require__(34);
/***************************************************************
2/5/2020
Alexander Self
fert_applied_table.js
- Displays a list of fertilizers applied
***************************************************************/var propTypes={mowRecords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,formId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,edit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,_delete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var MowTable=function MowTable(_ref){var mowJobs=_ref.mowJobs,formId=_ref.formId,_edit=_ref._edit,_delete=_ref._delete,readOnly=_ref.readOnly;if(!mowJobs)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);if(readOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres / Hour'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mowJobs.map(function(s,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:''+s.id+Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresBalance),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresPerHour));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harvest_utils__["c" /* sumProp */])('hours',mowJobs)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harvest_utils__["c" /* sumProp */])('acresCompleted',mowJobs)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harvest_utils__["c" /* sumProp */])('acresBalance',mowJobs)))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mowJobs.map(function(s,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:''+s.id+Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.acresPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _edit({mow:s,formId:'mow-used-form'});},className:'btn-floating waves-effect waves-light blue table-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _delete({mow:s});},className:'btn-floating waves-effect waves-light red table-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harvest_utils__["c" /* sumProp */])('hours',mowJobs)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harvest_utils__["c" /* sumProp */])('acresCompleted',mowJobs)))))));};MowTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MowTable);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_inventory_transaction_table__ = __webpack_require__(93);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Display: Displays data for viewing & prior to submission
**********************************************************/var propTypes={user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,formType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,previousInventoryTransactions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,approver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,editingApplication:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,toDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var TreeInventoryDisplay=function TreeInventoryDisplay(_ref){var user=_ref.user,data=_ref.data,toView=_ref.toView,formType=_ref.formType,previousInventoryTransactions=_ref.previousInventoryTransactions,approver=_ref.approver,employees=_ref.employees,toDelete=_ref.toDelete,editingApplication=_ref.editingApplication;var _approver='N/A';if(approver.eid)_approver=approver.firstName+' '+approver.lastName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'red-text chem-app-flex'},'Are you sure you want to delete the following transaction?'):'',editingApplication?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header blue-text'},'Editing Inventory Transaction'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons indigo-text lighten-2 medium'},'assignment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header'},'Inventory Transaction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),previousInventoryTransactions.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Previous Transactions - ',data.location==='71'?'71 - Kau':'72 - Keaau',', ',data.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tree_inventory_transaction_table__["a" /* default */],{inventory:previousInventoryTransactions,readOnly:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},toView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):formType==='issueOrReceiveInventory'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Inventory Request'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Create New Inventory Batch')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'left'},data.issuedOrReceived==='I'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Issue'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Receive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(data.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.location==='71'?'71 - Kau':'72 - Keaau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Physical Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.field)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Approver: '),_approver),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Comments: '),data.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'}))));};TreeInventoryDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryDisplay);/* END */

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_replant_table__ = __webpack_require__(163);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.21.20
Tree Replant Display: Displays data for viewing & prior to submission
**********************************************************/var propTypes={user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,approver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,editingApplication:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,prevReplants:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,toDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var TreeReplantDisplay=function TreeReplantDisplay(_ref){var data=_ref.data,prevReplants=_ref.prevReplants,toDelete=_ref.toDelete,editingApplication=_ref.editingApplication;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,toDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'red-text chem-app-flex'},'Are you sure you want to delete the following replant?'):'',editingApplication?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header blue-text'},'Editing Tree Replant'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons green-text medium'},'local_florist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header'},'Tree Replant Log')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),prevReplants.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Previous Replants - ',data.location,', Field ',data.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tree_replant_table__["a" /* default */],{replants:prevReplants,readOnly:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'Replant Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(data.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.location==='71'?'71 - Kau':'72 - Keaau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.field)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total Trees to Plant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.totalTrees)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.hours)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Trees Planted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.treesPlanted)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Trees Remaining'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.treesRemaining)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Trees per hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.treesPerHour)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Employees')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),data.addedEmployees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:e.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,e.name),', ',e.position,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Comments: '),data.comments)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'})))));};TreeReplantDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeReplantDisplay);/* END */

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_employee_list__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Tree Replant Form
**********************************************************/var propTypes={fields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,fetchFields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var TreeReplantForm=function(_Component){_inherits(TreeReplantForm,_Component);function TreeReplantForm(props){_classCallCheck(this,TreeReplantForm);var _this=_possibleConstructorReturn(this,(TreeReplantForm.__proto__||Object.getPrototypeOf(TreeReplantForm)).call(this,props));_this.state={inventoryTransactionId:''};return _this;}_createClass(TreeReplantForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},this.props.editing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'blue-text'},'Edit Replant Log'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)):'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'treeReplant'+this.props.inputId+'-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeReplant'+this.props.inputId+'-kau',name:'treeReplant-location',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeReplant'+this.props.inputId+'-keaau',name:'treeReplant-location',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'treeReplant'+this.props.inputId+'-field',label:'Field',opts:this.props.fields})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},this.props.editing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'treeReplant'+this.props.inputId+'-inventoryTransactionId',label:'Inventory Transaction',disabled:'disabled',opts:this.props.inventoryTransactions.filter(function(i){return i.isApproved===1&&i.issuedOrReceived==='I';}).map(function(i){return{val:i.id,label:__WEBPACK_IMPORTED_MODULE_3_moment___default()(i.date).format('MM/DD/YYYY')+', '+i.field+', '+i.quantity+' trees'};})}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'treeReplant'+this.props.inputId+'-inventoryTransactionId',label:'Inventory Transaction',opts:this.props.inventoryTransactions.filter(function(i){return i.isApproved===1&&i.issuedOrReceived==='I';}).map(function(i){return{val:i.id,label:__WEBPACK_IMPORTED_MODULE_3_moment___default()(i.date).format('MM/DD/YYYY')+', '+i.field+', '+i.quantity+' trees'};})}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'treeReplant'+this.props.inputId+'-hours',label:'Hours',step:"1.0",min:"0"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'treeReplant'+this.props.inputId+'-treesPlanted',label:'Trees Planted',step:"1.0",min:"0"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'treeReplant'+this.props.inputId+'-comments',label:'Comments',defaultValue:'N/A'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},this.props.editing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* AutoComplete */],{id:'treeReplant'+this.props.inputId+'-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cult_utils__["b" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:function onComplete(val,id){return _this2.props.addEmployee(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* findEmployeeByName */])(val,_this2.props.employees),id);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'emp-list-replant hide-on-small-only'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_employee_list__["a" /* default */],{employees:this.props.employees,icon:'person_add',header:'Add Employees',onClick:this.props.addEmployee,_class:'green'})))):'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m10 l10 xl10'},this.props.addedEmployees.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'centered bordered responsive-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Employee'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Remove'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,this.props.addedEmployees.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:e.eid},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,e.name,', ',e.position),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.removeEmployee(e);},className:'btn-floating waves-effect waves-light red table-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'clear'))));}))):'')));}}]);return TreeReplantForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);TreeReplantForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeReplantForm);/* END */

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_replant_display__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tree_replant_form__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_utils__ = __webpack_require__(11);
/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Table: Master inventory records
************************************************************************/var TreeReplantTable=function TreeReplantTable(_ref){var replants=_ref.replants,fields=_ref.fields,employees=_ref.employees,inventoryTransactions=_ref.inventoryTransactions,addedEmployees=_ref.addedEmployees,user=_ref.user,addEmployeeToEdit=_ref.addEmployeeToEdit,removeEmployeeFromEdit=_ref.removeEmployeeFromEdit,fetchFields=_ref.fetchFields,editing=_ref.editing,setReplantToEdit=_ref.setReplantToEdit,setReplantToDelete=_ref.setReplantToDelete,editReplant=_ref.editReplant,deleteReplant=_ref.deleteReplant,readOnly=_ref.readOnly,onClick=_ref.onClick;if(replants.length===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);if(readOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered centered responsive-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Trees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees Planted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees Remaining'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,replants.map(function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:r.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(r.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.totalTrees),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesPlanted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesRemaining),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.employees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:e.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,e.name),', ',e.position,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Number(r.isComplete)===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete')));})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered centered responsive-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Trees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees Planted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees Remaining'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,replants.map(function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:r.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(r.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.totalTrees),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesPlanted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesRemaining),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.treesPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,r.employees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:e.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,e.name),', ',e.position,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Number(r.isComplete)===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating blue pointer modal-trigger tooltipped btn-squared',href:'#'+r.id+'-edit',onClick:function onClick(){return setReplantToEdit({replant:r,formId:'tree-replant-editForm-'+r.id});},'data-position':'left','data-tooltip':'Edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating red pointer modal-trigger tooltipped btn-squared',href:'#'+r.id+'-delete',onClick:function onClick(){return setReplantToDelete(r);},'data-position':'top','data-tooltip':'Delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear')))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__tree_replant_form__["a" /* default */])// eslint-disable-next-line
({id:r.id+'-edit',formId:'tree-replant-editForm-'+r.id,fields:fields,employees:employees,inputId:r.id,inventoryTransactions:inventoryTransactions,addedEmployees:addedEmployees,addEmployee:addEmployeeToEdit,removeEmployee:removeEmployeeFromEdit,fetchFields:fetchFields,toDelete:false,editing:editing,footer:true,createOrEdit:true,onClick:function onClick(){return editReplant({data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cult_utils__["c" /* packageForm */])('tree-replant-editForm-'+r.id),user:user,oldReplantRecord:r,addedEmployees:addedEmployees,formId:'tree-replant-editForm-'+r.id});}}),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__tree_replant_display__["a" /* default */])// eslint-disable-next-line
({id:r.id+'-delete',data:Object.assign({},r,{addedEmployees:r.employees}),inventoryTransactions:inventoryTransactions,prevReplants:[],toDelete:true,editingApplication:false,footer:true,createOrEdit:true,onClick:function onClick(){return deleteReplant(r);}})));})));};/* harmony default export */ __webpack_exports__["a"] = (TreeReplantTable);/* END */

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
6/9/2017
Alexander Self
List of urls for side nav
***************************************************************/var $=window.$;var UrlList=function UrlList(_ref){var listItems=_ref.listItems,id=_ref.id,_class=_ref._class;$(document).ready(function(){$('.tooltipped').tooltip({delay:50});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{id:id,className:'collection product-report-ul z-depth-4'},listItems.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:''+item+i,className:'collection-item tooltipped product-report-tab',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push(''+item.url);},'data-position':'right','data-delay':'50','data-tooltip':item.name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product-tab-display-desktop-tablet'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'product-report-text'},item.name));})));};/* harmony default export */ __webpack_exports__["a"] = (UrlList);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_INTERVALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SEASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTERVAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECT_INTERVAL; });
var FETCH_INTERVALS='FETCH_INTERVALS';var FETCH_SEASONS=' FETCH_SEASONS';var INTERVAL_ERROR='INTERVAL_ERROR';var SELECT_INTERVAL='SELECT_INTERVAL';

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__irrigation_engine_hours__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__irrigation_meter_gallons__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__irrigation_valve_hours__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Create
**********************************************************/var $=window.$;var propTypes={employees:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};var IrrigationForm=function(_Component){_inherits(IrrigationForm,_Component);function IrrigationForm(props){_classCallCheck(this,IrrigationForm);var _this=_possibleConstructorReturn(this,(IrrigationForm.__proto__||Object.getPrototypeOf(IrrigationForm)).call(this));_this.calculateTotalMeterGallons=_this.calculateTotalMeterGallons.bind(_this);return _this;}_createClass(IrrigationForm,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('#irr-tabs').tabs();});}},{key:'calculateTotalMeterGallons',value:function calculateTotalMeterGallons(_ref){var startGal=_ref.startGal,endGal=_ref.endGal,totalGalDOM=_ref.totalGalDOM;if(!(startGal&&endGal))return 0;if(Number(endGal)<Number(startGal))return 0;totalGalDOM.value=Number((endGal-startGal).toFixed(2));if(Number(totalGalDOM.value)===0)totalGalDOM.style.backgroundColor='#ffffff';if(Number(totalGalDOM.value)>0){totalGalDOM.style.backgroundColor='#bbdefb';totalGalDOM.style.fontWeight='bold';totalGalDOM.style.textAlign='center';totalGalDOM.style.color='#424242';}return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_inputs__["d" /* DatePicker2 */],{id:'irrigation-date',label:'Date',max:__WEBPACK_IMPORTED_MODULE_7_moment___default()().add(1,'days').format('YYYY-MM-DD')})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_inputs__["e" /* AutoComplete */],{id:'irrigation-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_inputs__["f" /* TextInput */],{id:'irrigation-notes',label:'Notes'}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('ul',{id:'irr-tabs',className:'tabs'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'irr-tabs',href:'#irr-engines-meters'},'Engines & Meters')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'irr-tabs',href:'#irr-valves'},'Valves'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{id:'irr-engines-meters'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l12 xl3'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('form',{id:'engine-form'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__irrigation_engine_hours__["a" /* default */],{engines:this.props.engines,handleEngineHours:this.props.handleEngineHours,edit:this.props.edit}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l12 xl9'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('form',{id:'meter-form'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__irrigation_meter_gallons__["a" /* default */],{meters:this.props.meters,calculateTotalMeterGallons:this.calculateTotalMeterGallons,handleMeterGallons:this.props.handleMeterGallons,edit:this.props.edit}))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{id:'irr-valves'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('form',{id:'valve-form'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__irrigation_valve_hours__["a" /* default */],{valves:this.props.valves,handleValveHours:this.props.handleValveHours,edit:this.props.edit}))))));}}]);return IrrigationForm;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux__["c" /* bindActionCreators */])({},dispatch);}IrrigationForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IrrigationForm));/* END */

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_IRRIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_IRRIGATION_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PREPARE_IRRIGATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HANDLE_VALVE_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return HANDLE_METER_GALLONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HANDLE_ENGINE_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_IRRIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PRELOAD_METER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SELECT_IRRIGATION_LOG_TO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_IRRIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HANDLE_EDIT_VALVE_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HANDLE_EDIT_METER_GALLONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HANDLE_EDIT_ENGINE_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PREPARE_EDIT_IRRIGATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDIT_IRRIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_IRRIGATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ERROR; });
var FETCH_IRRIGATION='FETCH_IRRIGATION',FETCH_IRRIGATION_EMPLOYEES='FETCH_IRRIGATION_EMPLOYEES',PREPARE_IRRIGATION_DATA='PREPARE_IRRIGATION_DATA',HANDLE_VALVE_HOURS='HANDLE_VALVE_HOURS',HANDLE_METER_GALLONS='HANDLE_METER_GALLONS',HANDLE_ENGINE_HOURS='HANDLE_ENGINE_HOURS',CREATE_IRRIGATION='CREATE_IRRIGATION',PRELOAD_METER_FORM='PRELOAD_METER_FORM',SELECT_IRRIGATION_LOG_TO_EDIT='SELECT_IRRIGATION_LOG_TO_EDIT',DELETE_IRRIGATION='DELETE_IRRIGATION',HANDLE_EDIT_VALVE_HOURS='HANDLE_EDIT_VALVE_HOURS',HANDLE_EDIT_METER_GALLONS='HANDLE_EDIT_METER_GALLONS',HANDLE_EDIT_ENGINE_HOURS='HANDLE_EDIT_ENGINE_HOURS',PREPARE_EDIT_IRRIGATION_DATA='PREPARE_EDIT_IRRIGATION_DATA',EDIT_IRRIGATION='EDIT_IRRIGATION',FETCH_IRRIGATION_REPORT='FETCH_IRRIGATION_REPORT',RESET_DASHBOARD='RESET_DASHBOARD',ERROR='ERROR';

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_WEATHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_WEATHER_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_LOCAL_WEATHER_SITE; });
/* unused harmony export SET_WEATHER_SITE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_WEATHER_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOWNLOAD_DATA; });
// Actions
var FETCH_WEATHER='FETCH_WEATHER',SET_WEATHER_TIME='SET_WEATHER_TIME',SET_LOCAL_WEATHER_SITE='SET_LOCAL_WEATHER_SITE',SET_WEATHER_SITE='SET_WEATHER_SITE',SET_WEATHER_LOCATION='SET_WEATHER_LOCATION',DOWNLOAD_DATA='DOWNLOAD_DATA';

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = swapKeyWithValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalizeWeatherCode;
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/* Swaps obj keys for vals */function swapKeyWithValue(json){var ret={};for(var key in json){ret[json[key]]=key;}return ret;}function capitalizeFirstLetter(string){return string.charAt(0).toUpperCase()+string.slice(1);}/* Splits weather description string; capitalizes */function capitalizeWeatherCode(wcode){if(!wcode)return'N/A';var code=wcode.split('_');if(code.length===1){var _code=_slicedToArray(code,1),c=_code[0];return capitalizeFirstLetter(c);}else if(code.length===2){return capitalizeFirstLetter(code[0])+' '+capitalizeFirstLetter(code[1]);}else if(code.length===3){return capitalizeFirstLetter(code[0])+' '+capitalizeFirstLetter(code[1])+' '+capitalizeFirstLetter(code[2]);}return wcode;}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(460);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var convert
  , keys = __webpack_require__(189)
  , each = __webpack_require__(538)
  , measures = {
      length: __webpack_require__(475)
    , area: __webpack_require__(468)
    , mass: __webpack_require__(476)
    , volume: __webpack_require__(487)
    , each: __webpack_require__(471)
    , temperature: __webpack_require__(484)
    , time: __webpack_require__(485)
    , digital: __webpack_require__(470)
    , partsPer: __webpack_require__(478)
    , speed: __webpack_require__(483)
    , pace: __webpack_require__(477)
    , pressure: __webpack_require__(480)
    , current: __webpack_require__(469)
    , voltage: __webpack_require__(486)
    , power: __webpack_require__(479)
    , reactivePower: __webpack_require__(482)
    , apparentPower: __webpack_require__(467)
    , energy: __webpack_require__(472)
    , reactiveEnergy: __webpack_require__(481)
    , volumeFlowRate: __webpack_require__(488)
    , illuminance: __webpack_require__(474)
    , frequency: __webpack_require__(473)
    , angle : __webpack_require__(466)
    }
  , Converter;

Converter = function (numerator, denominator) {
  if(denominator)
    this.val = numerator / denominator;
  else
    this.val = numerator;
};

/**
* Lets the converter know the source unit abbreviation
*/
Converter.prototype.from = function (from) {
  if(this.destination)
    throw new Error('.from must be called before .to');

  this.origin = this.getUnit(from);

  if(!this.origin) {
    this.throwUnsupportedUnitError(from);
  }

  return this;
};

/**
* Converts the unit and returns the value
*/
Converter.prototype.to = function (to) {
  if(!this.origin)
    throw new Error('.to must be called after .from');

  this.destination = this.getUnit(to);

  var result
    , transform;

  if(!this.destination) {
    this.throwUnsupportedUnitError(to);
  }

  // Don't change the value if origin and destination are the same
  if (this.origin.abbr === this.destination.abbr) {
    return this.val;
  }

  // You can't go from liquid to mass, for example
  if(this.destination.measure != this.origin.measure) {
    throw new Error('Cannot convert incompatible measures of '
      + this.destination.measure + ' and ' + this.origin.measure);
  }

  /**
  * Convert from the source value to its anchor inside the system
  */
  result = this.val * this.origin.unit.to_anchor;

  /**
  * For some changes it's a simple shift (C to K)
  * So we'll add it when convering into the unit (later)
  * and subtract it when converting from the unit
  */
  if (this.origin.unit.anchor_shift) {
    result -= this.origin.unit.anchor_shift
  }

  /**
  * Convert from one system to another through the anchor ratio. Some conversions
  * aren't ratio based or require more than a simple shift. We can provide a custom
  * transform here to provide the direct result
  */
  if(this.origin.system != this.destination.system) {
    transform = measures[this.origin.measure]._anchors[this.origin.system].transform;
    if (typeof transform === 'function') {
      result = transform(result)
    }
    else {
      result *= measures[this.origin.measure]._anchors[this.origin.system].ratio;
    }
  }

  /**
  * This shift has to be done after the system conversion business
  */
  if (this.destination.unit.anchor_shift) {
    result += this.destination.unit.anchor_shift;
  }

  /**
  * Convert to another unit inside the destination system
  */
  return result / this.destination.unit.to_anchor;
};

/**
* Converts the unit to the best available unit.
*/
Converter.prototype.toBest = function(options) {
  if(!this.origin)
    throw new Error('.toBest must be called after .from');

  var options = Object.assign({
    exclude: [],
    cutOffNumber: 1,
  }, options)

  var best;
  /**
    Looks through every possibility for the 'best' available unit.
    i.e. Where the value has the fewest numbers before the decimal point,
    but is still higher than 1.
  */
  each(this.possibilities(), function(possibility) {
    var unit = this.describe(possibility);
    var isIncluded = options.exclude.indexOf(possibility) === -1;

    if (isIncluded && unit.system === this.origin.system) {
      var result = this.to(possibility);
      if (!best || (result >= options.cutOffNumber && result < best.val)) {
        best = {
          val: result,
          unit: possibility,
          singular: unit.singular,
          plural: unit.plural
        };
      }
    }
  }.bind(this));

  return best;
}

/**
* Finds the unit
*/
Converter.prototype.getUnit = function (abbr) {
  var found;

  each(measures, function (systems, measure) {
    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      each(units, function (unit, testAbbr) {
        if(testAbbr == abbr) {
          found = {
            abbr: abbr
          , measure: measure
          , system: system
          , unit: unit
          };
          return false;
        }
      });

      if(found)
        return false;
    });

    if(found)
      return false;
  });

  return found;
};

var describe = function(resp) {
  return {
    abbr: resp.abbr
  , measure: resp.measure
  , system: resp.system
  , singular: resp.unit.name.singular
  , plural: resp.unit.name.plural
  };
}

/**
* An alias for getUnit
*/
Converter.prototype.describe = function (abbr) {
  var resp = Converter.prototype.getUnit(abbr);
  var desc = null;

  try {
    desc = describe(resp);
  } catch(err) {
    this.throwUnsupportedUnitError(abbr);
  }

  return desc;
};

/**
* Detailed list of all supported units
*/
Converter.prototype.list = function (measure) {
  var list = [];

  each(measures, function (systems, testMeasure) {
    if(measure && measure !== testMeasure)
      return;

    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      each(units, function (unit, abbr) {
        list = list.concat(describe({
          abbr: abbr,
          measure: testMeasure
        , system: system
        , unit: unit
        }));
      });
    });
  });

  return list;
};

Converter.prototype.throwUnsupportedUnitError = function (what) {
  var validUnits = [];

  each(measures, function (systems, measure) {
    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      validUnits = validUnits.concat(keys(units));
    });
  });

  throw new Error('Unsupported unit ' + what + ', use one of: ' + validUnits.join(', '));
}

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.possibilities = function (measure) {
  var possibilities = [];
  if(!this.origin && !measure) {
	  each(keys(measures), function (measure){
		  each(measures[measure], function (units, system) {
		    if(system == '_anchors')
		      return false;

		    possibilities = possibilities.concat(keys(units));
		  });
	  });
  } else {
	  measure = measure || this.origin.measure;
	  each(measures[measure], function (units, system) {
	    if(system == '_anchors')
	      return false;

	    possibilities = possibilities.concat(keys(units));
	  });
  }

  return possibilities;
};

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.measures = function () {
  return keys(measures);
};

convert = function (value) {
  return new Converter(value);
};

module.exports = convert;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(177);

var GetIntrinsic = __webpack_require__(491);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

module.exports = function callBind() {
	return $reflectApply(bind, $call, arguments);
};

module.exports.apply = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(29);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(776) !== null) && (__webpack_require__(777) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
    return saveAs;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(513);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(514);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable no-empty */


exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(71);

var _DOMUtils = __webpack_require__(100);

var _createHistory = __webpack_require__(182);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(47);

var _PathUtils = __webpack_require__(42);

var _ExecutionEnvironment = __webpack_require__(71);

var _DOMUtils = __webpack_require__(100);

var _DOMStateStorage = __webpack_require__(179);

var _createDOMHistory = __webpack_require__(180);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(490);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(42);

var _AsyncUtils = __webpack_require__(515);

var _Actions = __webpack_require__(47);

var _createLocation2 = __webpack_require__(517);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(102);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(101);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(71);

var _PathUtils = __webpack_require__(42);

var _runTransitionHook = __webpack_require__(102);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(101);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(531);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(532);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isObject = __webpack_require__(73),
    noop = __webpack_require__(190),
    reNative = __webpack_require__(58);

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeCreate = reNative.test(nativeCreate = Object.create) && nativeCreate;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(prototype, properties) {
  return isObject(prototype) ? nativeCreate(prototype) : {};
}
// fallback for browsers without `Object.create`
if (!nativeCreate) {
  baseCreate = (function() {
    function Object() {}
    return function(prototype) {
      if (isObject(prototype)) {
        Object.prototype = prototype;
        var result = new Object;
        Object.prototype = null;
      }
      return result || global.Object();
    };
  }());
}

module.exports = baseCreate;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var bind = __webpack_require__(537),
    identity = __webpack_require__(540),
    setBindData = __webpack_require__(104),
    support = __webpack_require__(542);

/** Used to detected named functions */
var reFuncName = /^\s*function[ \n\r\t]+\w/;

/** Used to detect functions containing a `this` reference */
var reThis = /\bthis\b/;

/** Native method shortcuts */
var fnToString = Function.prototype.toString;

/**
 * The base implementation of `_.createCallback` without support for creating
 * "_.pluck" or "_.where" style callbacks.
 *
 * @private
 * @param {*} [func=identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of the created callback.
 * @param {number} [argCount] The number of arguments the callback accepts.
 * @returns {Function} Returns a callback function.
 */
function baseCreateCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  // exit early for no `thisArg` or already bound by `Function#bind`
  if (typeof thisArg == 'undefined' || !('prototype' in func)) {
    return func;
  }
  var bindData = func.__bindData__;
  if (typeof bindData == 'undefined') {
    if (support.funcNames) {
      bindData = !func.name;
    }
    bindData = bindData || !support.funcDecomp;
    if (!bindData) {
      var source = fnToString.call(func);
      if (!support.funcNames) {
        bindData = !reFuncName.test(source);
      }
      if (!bindData) {
        // checks if `func` references the `this` keyword and stores the result
        bindData = reThis.test(source);
        setBindData(func, bindData);
      }
    }
  }
  // exit early if there are no `this` references or `func` is bound
  if (bindData === false || (bindData !== true && bindData[1] & 1)) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 2: return function(a, b) {
      return func.call(thisArg, a, b);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
  }
  return bind(func, thisArg);
}

module.exports = baseCreateCallback;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Slices the `collection` from the `start` index up to, but not including,
 * the `end` index.
 *
 * Note: This function is used instead of `Array#slice` to support node lists
 * in IE < 9 and to ensure dense arrays are returned.
 *
 * @private
 * @param {Array|Object|string} collection The collection to slice.
 * @param {number} start The start index.
 * @param {number} end The end index.
 * @returns {Array} Returns the new array.
 */
function slice(array, start, end) {
  start || (start = 0);
  if (typeof end == 'undefined') {
    end = array ? array.length : 0;
  }
  var index = -1,
      length = end - start || 0,
      result = Array(length < 0 ? 0 : length);

  while (++index < length) {
    result[index] = array[start + index];
  }
  return result;
}

module.exports = slice;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isObject = __webpack_require__(73),
    reNative = __webpack_require__(58),
    shimKeys = __webpack_require__(536);

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeKeys = reNative.test(nativeKeys = Object.keys) && nativeKeys;

/**
 * Creates an array composed of the own enumerable property names of an object.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 * @example
 *
 * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
 * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  if (!isObject(object)) {
    return [];
  }
  return nativeKeys(object);
};

module.exports = keys;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * A no-operation function.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.noop(object) === undefined;
 * // => true
 */
function noop() {
  // no operation performed
}

module.exports = noop;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(74),
    stackClear = __webpack_require__(619),
    stackDelete = __webpack_require__(620),
    stackGet = __webpack_require__(621),
    stackHas = __webpack_require__(622),
    stackSet = __webpack_require__(623);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(193),
    toKey = __webpack_require__(79);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(36),
    isKey = __webpack_require__(108),
    stringToPath = __webpack_require__(624),
    toString = __webpack_require__(634);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(547),
    arraySome = __webpack_require__(555),
    cacheHas = __webpack_require__(577);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 196 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(110);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(563),
    isObjectLike = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(204),
    isLength = __webpack_require__(109);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(35),
    stubFalse = __webpack_require__(633);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)(module)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObject = __webpack_require__(110);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(567),
    baseUnary = __webpack_require__(576),
    nodeUtil = __webpack_require__(613);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(206);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(209);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(637);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(640);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function get() {
    return _chart["default"];
  }
});
exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(5));

var _chart = _interopRequireDefault(__webpack_require__(98));

var _isEqual = _interopRequireDefault(__webpack_require__(628));

var _keyBy = _interopRequireDefault(__webpack_require__(629));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NODE_ENV = typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production";

var ChartComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  var _super = _createSuper(ChartComponent);

  function ChartComponent() {
    var _this;

    _classCallCheck(this, ChartComponent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      var instance = _this.chartInstance;
      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
      _this.element = element;
    });

    _this.chartInstance = undefined;
    return _this;
  }

  _createClass(ChartComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.redraw) {
        this.destroyChart();
        this.renderChart();
        return;
      }

      this.updateChart();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          redraw = _this$props2.redraw,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;

      if (nextProps.redraw === true) {
        return true;
      }

      if (height !== nextProps.height || width !== nextProps.width) {
        return true;
      }

      if (type !== nextProps.type) {
        return true;
      }

      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
        return true;
      }

      if (!(0, _isEqual["default"])(options, nextProps.options)) {
        return true;
      }

      var nextData = this.transformDataProp(nextProps);

      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
        return true;
      }

      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "transformDataProp",
    value: function transformDataProp(props) {
      var data = props.data;

      if (typeof data == 'function') {
        var node = this.element;
        return data(node);
      } else {
        return data;
      }
    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
    // this makes impossible to compare the current and next data changes
    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617

  }, {
    key: "memoizeDataProps",
    value: function memoizeDataProps() {
      if (!this.props.data) {
        return;
      }

      var data = this.transformDataProp(this.props);
      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
        datasets: data.datasets && data.datasets.map(function (set) {
          return _objectSpread({}, set);
        })
      });
      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

      return data;
    }
  }, {
    key: "checkDatasets",
    value: function checkDatasets(datasets) {
      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
      var multipleDatasets = datasets.length > 1;

      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
        var shouldWarn = false;
        datasets.forEach(function (dataset) {
          if (!dataset.label) {
            shouldWarn = true;
          }
        });

        if (shouldWarn) {
          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
        }
      }
    }
  }, {
    key: "getCurrentDatasets",
    value: function getCurrentDatasets() {
      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    }
  }, {
    key: "saveCurrentDatasets",
    value: function saveCurrentDatasets() {
      var _this2 = this;

      this.datasets = this.datasets || {};
      var currentDatasets = this.getCurrentDatasets();
      currentDatasets.forEach(function (d) {
        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
      });
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      var _this3 = this;

      var options = this.props.options;
      var data = this.memoizeDataProps(this.props);
      if (!this.chartInstance) return;

      if (options) {
        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
      } // Pipe datasets to chart instance datasets enabling
      // seamless transitions


      var currentDatasets = this.getCurrentDatasets();
      var nextDatasets = data.datasets || [];
      this.checkDatasets(currentDatasets);
      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
      // on each dataset.

      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

        if (current && current.type === next.type && next.data) {
          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
          // The data array must be edited in place. As chart.js adds listeners to it.
          current.data.splice(next.data.length);
          next.data.forEach(function (point, pid) {
            current.data[pid] = next.data[pid];
          });

          var _data = next.data,
              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
          // from next, it will be retained by current and never disappears.
          // Workaround is to set value to null or undefined in next.


          return _objectSpread(_objectSpread({}, current), otherProps);
        } else {
          return next;
        }
      });

      var datasets = data.datasets,
          rest = _objectWithoutProperties(data, ["datasets"]);

      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
      this.chartInstance.update();
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
      var node = this.element;
      var data = this.memoizeDataProps();

      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
        options.legend = legend;
      }

      this.chartInstance = new _chart["default"](node, {
        type: type,
        data: data,
        options: options,
        plugins: plugins
      });
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (!this.chartInstance) {
        return;
      } // Put all of the datasets that have existed in the chart back on the chart
      // so that the metadata associated with this chart get destroyed.
      // This allows the datasets to be used in another chart. This can happen,
      // for example, in a tabbed UI where the chart gets created each time the
      // tab gets switched to the chart and uses the same data).


      this.saveCurrentDatasets();
      var datasets = Object.values(this.datasets);
      this.chartInstance.config.data.datasets = datasets;
      this.chartInstance.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        ref: this.ref,
        height: height,
        width: width,
        id: id,
        onClick: this.handleOnClick
      });
    }
  }]);

  return ChartComponent;
}(_react["default"].Component);

_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
  return d.label;
});

_defineProperty(ChartComponent, "propTypes", {
  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
  getDatasetAtEvent: _propTypes["default"].func,
  getElementAtEvent: _propTypes["default"].func,
  getElementsAtEvent: _propTypes["default"].func,
  height: _propTypes["default"].number,
  legend: _propTypes["default"].object,
  onElementsClick: _propTypes["default"].func,
  options: _propTypes["default"].object,
  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
  redraw: _propTypes["default"].bool,
  type: function type(props, propName, componentName) {
    if (!_chart["default"].controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: _propTypes["default"].number,
  datasetKeyProvider: _propTypes["default"].func
});

_defineProperty(ChartComponent, "defaultProps", {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
});

var _default = ChartComponent;
exports["default"] = _default;

var Doughnut = /*#__PURE__*/function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  var _super2 = _createSuper(Doughnut);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _super2.apply(this, arguments);
  }

  _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref) {
          return _this4.chartInstance = _ref && _ref.chartInstance;
        },
        type: "doughnut"
      }));
    }
  }]);

  return Doughnut;
}(_react["default"].Component);

exports.Doughnut = Doughnut;

var Pie = /*#__PURE__*/function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  var _super3 = _createSuper(Pie);

  function Pie() {
    _classCallCheck(this, Pie);

    return _super3.apply(this, arguments);
  }

  _createClass(Pie, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref2) {
          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
        },
        type: "pie"
      }));
    }
  }]);

  return Pie;
}(_react["default"].Component);

exports.Pie = Pie;

var Line = /*#__PURE__*/function (_React$Component4) {
  _inherits(Line, _React$Component4);

  var _super4 = _createSuper(Line);

  function Line() {
    _classCallCheck(this, Line);

    return _super4.apply(this, arguments);
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref3) {
          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
        },
        type: "line"
      }));
    }
  }]);

  return Line;
}(_react["default"].Component);

exports.Line = Line;

var Bar = /*#__PURE__*/function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  var _super5 = _createSuper(Bar);

  function Bar() {
    _classCallCheck(this, Bar);

    return _super5.apply(this, arguments);
  }

  _createClass(Bar, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref4) {
          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
        },
        type: "bar"
      }));
    }
  }]);

  return Bar;
}(_react["default"].Component);

exports.Bar = Bar;

var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  var _super6 = _createSuper(HorizontalBar);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _super6.apply(this, arguments);
  }

  _createClass(HorizontalBar, [{
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref5) {
          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
        },
        type: "horizontalBar"
      }));
    }
  }]);

  return HorizontalBar;
}(_react["default"].Component);

exports.HorizontalBar = HorizontalBar;

var Radar = /*#__PURE__*/function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  var _super7 = _createSuper(Radar);

  function Radar() {
    _classCallCheck(this, Radar);

    return _super7.apply(this, arguments);
  }

  _createClass(Radar, [{
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref6) {
          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
        },
        type: "radar"
      }));
    }
  }]);

  return Radar;
}(_react["default"].Component);

exports.Radar = Radar;

var Polar = /*#__PURE__*/function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  var _super8 = _createSuper(Polar);

  function Polar() {
    _classCallCheck(this, Polar);

    return _super8.apply(this, arguments);
  }

  _createClass(Polar, [{
    key: "render",
    value: function render() {
      var _this10 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref7) {
          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
        },
        type: "polarArea"
      }));
    }
  }]);

  return Polar;
}(_react["default"].Component);

exports.Polar = Polar;

var Bubble = /*#__PURE__*/function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  var _super9 = _createSuper(Bubble);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _super9.apply(this, arguments);
  }

  _createClass(Bubble, [{
    key: "render",
    value: function render() {
      var _this11 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref8) {
          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
        },
        type: "bubble"
      }));
    }
  }]);

  return Bubble;
}(_react["default"].Component);

exports.Bubble = Bubble;

var Scatter = /*#__PURE__*/function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  var _super10 = _createSuper(Scatter);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _super10.apply(this, arguments);
  }

  _createClass(Scatter, [{
    key: "render",
    value: function render() {
      var _this12 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref9) {
          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
        },
        type: "scatter"
      }));
    }
  }]);

  return Scatter;
}(_react["default"].Component);

exports.Scatter = Scatter;
var defaults = _chart["default"].defaults;
exports.defaults = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(44);

var invariant = __webpack_require__(6);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(49);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstrumentation = __webpack_require__(26);

var quoteAttributeValueForBrowser = __webpack_require__(705);
var warning = __webpack_require__(10);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var LinkedValueUtils = __webpack_require__(118);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(31);

var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(665);

var containsNode = __webpack_require__(498);
var focusNode = __webpack_require__(174);
var getActiveElement = __webpack_require__(175);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(48);
var DOMProperty = __webpack_require__(49);
var React = __webpack_require__(52);
var ReactBrowserEventEmitter = __webpack_require__(81);
var ReactCurrentOwner = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMContainerInfo = __webpack_require__(659);
var ReactDOMFeatureFlags = __webpack_require__(661);
var ReactFeatureFlags = __webpack_require__(219);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(26);
var ReactMarkupChecksum = __webpack_require__(675);
var ReactReconciler = __webpack_require__(50);
var ReactUpdateQueue = __webpack_require__(121);
var ReactUpdates = __webpack_require__(31);

var emptyObject = __webpack_require__(70);
var instantiateReactComponent = __webpack_require__(230);
var invariant = __webpack_require__(6);
var setInnerHTML = __webpack_require__(85);
var shouldUpdateReactComponent = __webpack_require__(127);
var warning = __webpack_require__(10);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(52);

var invariant = __webpack_require__(6);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(223);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(13);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var ReactCompositeComponent = __webpack_require__(656);
var ReactEmptyComponent = __webpack_require__(218);
var ReactHostComponent = __webpack_require__(220);

var getNextDebugID = __webpack_require__(751);
var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);
var escapeTextContentForBrowser = __webpack_require__(84);
var setInnerHTML = __webpack_require__(85);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(38);
var REACT_ELEMENT_TYPE = __webpack_require__(671);

var getIteratorFn = __webpack_require__(702);
var invariant = __webpack_require__(6);
var KeyEscapeUtils = __webpack_require__(117);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(236);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(237);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(130);


function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes;
var bool = _React$PropTypes.bool;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query;
  var hash = _ref.hash;
  var state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object]).isRequired,
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    var _props = this.props;
    var to = _props.to;
    var query = _props.query;
    var hash = _props.hash;
    var state = _props.state;

    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

    this.context.router.push(location);
  },
  render: function render() {
    var _props2 = this.props;
    var to = _props2.to;
    var query = _props2.query;
    var hash = _props2.hash;
    var state = _props2.state;
    var activeClassName = _props2.activeClassName;
    var activeStyle = _props2.activeStyle;
    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(40);

var _PatternUtils = __webpack_require__(51);

var _InternalPropTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = _react2.default.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location;
        var params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.createRoutingHistory = createRoutingHistory;

var _deprecateObjectProperties = __webpack_require__(87);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(72);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(183);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(518);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(244);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeStateWithLocation;

var _deprecateObjectProperties = __webpack_require__(87);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}
module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(72);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(183);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(260);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(65),
    _assign = __webpack_require__(12);

var ReactNoopUpdateQueue = __webpack_require__(249);

var canDefineProperty = __webpack_require__(250);
var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(6);
var lowPriorityWarning = __webpack_require__(752);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(65);

var ReactCurrentOwner = __webpack_require__(38);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(762);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(254);

var supportsDescriptors = __webpack_require__(57).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/user.38d31b12.jpg";

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registerServiceWorker__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_css__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cult_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_thunk__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_router__);
var createStoreWithMiddleware=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_10_redux_thunk__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* createStore */]);var store=createStoreWithMiddleware(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */],window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());//const store = createStoreWithMiddleware(reducers);
var token=localStorage.getItem('token');// If a token exists, consider the user signed in
(function(){if(token){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["fetchUser"])(store);}__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["Router"],{history:__WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"],routes:__WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]})),document.getElementById('root'));__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__registerServiceWorker__["a" /* default */])();})();

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(741).enable();
  window.Promise = __webpack_require__(740);
}

// fetch() polyfill for making API calls.
__webpack_require__(742);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(12);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var bind = __webpack_require__(143);
var Axios = __webpack_require__(263);
var mergeConfig = __webpack_require__(141);
var defaults = __webpack_require__(142);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(138);
axios.CancelToken = __webpack_require__(262);
axios.isCancel = __webpack_require__(139);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(276);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(138);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var buildURL = __webpack_require__(144);
var InterceptorManager = __webpack_require__(264);
var dispatchRequest = __webpack_require__(266);
var mergeConfig = __webpack_require__(141);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(272);
var combineURLs = __webpack_require__(270);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var transformData = __webpack_require__(269);
var isCancel = __webpack_require__(139);
var defaults = __webpack_require__(142);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(140);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchData;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchHeadCount;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchHoursByDepartment;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchHoursByField;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchMissingTimesheets;
/* harmony export (immutable) */ __webpack_exports__["b"] = switchLocation;
/* harmony export (immutable) */ __webpack_exports__["c"] = enlargeGraphs;
/* harmony export (immutable) */ __webpack_exports__["e"] = sortByOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/************************************************************************
8/14/17
All Actions for dashboard interactions
************************************************************************/var $=window.$;var Materialize=window.Materialize;/*****************************************************
  Asynchronous Functions
*****************************************************/function fetchData(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchData',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');//console.log(res)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_54" /* FETCH_DASHBOARD_DATA */],payload:res});}).catch(function(err){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('There was an error fetching data for dashboard'));});};}/**
* fetchHeadCount(): Fetches headcounts based on submitted timesheets
* @returns {Array} Headcounts
* @called-in: ['/containers/dashboard.js]
**/function fetchHeadCount(){$('#preloader').css('display','block');var date=__WEBPACK_IMPORTED_MODULE_4_moment___default()(document.getElementById('headcount-date').value).format('YYYY-MM-DD');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchHeadCount',{params:{date:date},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_55" /* FETCH_HEADCOUNT */],payload:res.headCount,date:date});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('There was an error fetching data for dashboard'));});};}/**
* fetchHoursByDepartment(): Fetches the hours by each department(broken up by cost centers)
* @returns {Array} Hours by department
* @called-in: ['/containers/dashboard.js]
**/function fetchHoursByDepartment(){//$('#preloader').css('display','block');
if(document.getElementById('department-date-1').value===''||document.getElementById('department-date-2').value===''){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('Two dates are required');}var dateFrom=__WEBPACK_IMPORTED_MODULE_4_moment___default()(document.getElementById('department-date-1').value).format('YYYY-MM-DD');var dateTo=__WEBPACK_IMPORTED_MODULE_4_moment___default()(document.getElementById('department-date-2').value).format('YYYY-MM-DD');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchHoursByDepartment',{params:{dateFrom:dateFrom,dateTo:dateTo},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){//console.log(res);
$('#preloader').css('display','none');//dispatch({type: FETCH_HOURS_BY_DEPARTMENT, payload: res.fieldHours });
dispatch({type:'DUMMY'});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('There was an error fetching data for dashboard'));});};}/**
* fetchHoursByField(): Fetches the hours in each field
* @returns {Array} Calculated field hours
* @called-in: ['/containers/dashboard.js]
**/function fetchHoursByField(){if(document.getElementById('field-date-1').value===''||document.getElementById('field-date-2').value===''){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('Two dates are required');}$('#preloader').css('display','block');var dateFrom=__WEBPACK_IMPORTED_MODULE_4_moment___default()(document.getElementById('field-date-1').value).format('YYYY-MM-DD');var dateTo=__WEBPACK_IMPORTED_MODULE_4_moment___default()(document.getElementById('field-date-2').value).format('YYYY-MM-DD');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchHoursByField',{params:{dateFrom:dateFrom,dateTo:dateTo},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_56" /* FETCH_HOURS_BY_FIELD */],payload:res.fieldHours});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('There was an error fetching data for dashboard'));});};}/**
* fetchMissingTimesheets(): Fetches the employees who have missed timesheets(grouped by supervisors)
* @returns {Array} Missing timesheets
* @called-in: ['/containers/dashboard.js]
**/function fetchMissingTimesheets(date){if(date===''){date=__WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1,'days').format('YYYY-MM-DD');}// Weekends should not be displayed. Most employees do not work Weekends and should not have timesheets
if(__WEBPACK_IMPORTED_MODULE_4_moment___default()(date).day()===0||__WEBPACK_IMPORTED_MODULE_4_moment___default()(date).day()===6){Materialize.toast('Weekends do not have required timesheet submissions.',3000,'rounded');return{type:'DUMMY'};}$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROOT_URL */]+'/fetchMissingTimesheets',{params:{date:date},headers:{authorization:localStorage.getItem('token')}}).then(function(res){return JSON.parse(res.request.response);}).then(function(res){$('#preloader').css('display','none');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_57" /* FETCH_MISSING_TIMESHEETS */],payload:res});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["error"])('There was an error fetching data for dashboard'));});};}/*****************************************************
  Synchronous Functions
*****************************************************/function switchLocation(id){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_58" /* FETCH_INFO_BY_LOCATION */],payload:id};}function enlargeGraphs(){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_59" /* ENLARGE_GRAPHS */]};}function sortByOperation(id){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_60" /* SORT_BY_OPERATION */],payload:id};}/* END */

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
6/9/2017
Alexander Self
Floating action button for navigation
***************************************************************/var $=window.$;var ActionMenuButton=function ActionMenuButton(_ref){var urls=_ref.urls;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fixed-action-btn click-to-toggle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn-floating btn-large red',onMouseOver:function onMouseOver(){return $('.fixed-action-btn').openFAB();},onMouseLeave:function onMouseLeave(){setTimeout(function(){$('.fixed-action-btn').closeFAB();},4000);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'large material-icons'},'more_vert')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,urls.map(function(url){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:url.url,onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push(''+url.url);$('.fixed-action-btn').closeFAB();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],{className:'btn-floating '+url._class,to:''+url.url},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},url.icon)));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:'weather8',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/weather');$('.fixed-action-btn').closeFAB();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["Link"],{className:'btn-floating',to:'/weather'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'wi wi-day-rain orange lighten-2 circle'})))));};/* harmony default export */ __webpack_exports__["a"] = (ActionMenuButton);/* END */

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_modal__ = __webpack_require__(280);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomForm=function(_React$Component){_inherits(CustomForm,_React$Component);function CustomForm(){_classCallCheck(this,CustomForm);return _possibleConstructorReturn(this,(CustomForm.__proto__||Object.getPrototypeOf(CustomForm)).apply(this,arguments));}_createClass(CustomForm,[{key:'componentDidMount',value:function componentDidMount(){//remove ability to send message when first loaded (means no data has been entered)
document.getElementById('customBtn').disabled=true;}},{key:'componentDidUpdate',value:function componentDidUpdate(){//check if any employees have been selected and if a message has been selected or an optional message filled in
//if both, allow user to send message, otherwise disable send button
if(this.props.chips[0]&&(this.props.prefillMessage||this.props.optionalMessage)){document.getElementById('customBtn').disabled=false;}else{document.getElementById('customBtn').disabled=true;}}},{key:'renderChips',value:function renderChips(){var _this2=this;//render list of chips to be displayed
return this.props.chips.map(function(chip){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:chip.id,id:chip.id,className:'chip',onClick:function onClick(e){_this2.props.removeChip(e.currentTarget.id);}},chip.first,' ',chip.last,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons x'},'close'));});}},{key:'render',value:function render(){var _this3=this;var messages={test:'ALERT: This is a test alert',rain:'ALERT: Work has been cancelled today due to heavy rainfall in the orchards.',vog:'ALERT: Work has been cancelled today due to excessive vog/ash in the orchards.',lightning:'ALERT: Work has been cancelled today due to lightning close to the orchards.',disaster:'ALERT: Work has been cancelled today due to a natural disaster near the orchards.',threat:'ALERT: There is an ongoing threat in the orchards.'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'messageForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:this.props.chips.length>0?'hidden':'',id:'defaultMessage'},'Select employees from the list to add recipients.'),this.renderChips()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'browser-default',defaultValue:'',id:'messages',onChange:function onChange(e){_this3.props.updatePrefillMessage(e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Select Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:messages.test},'Test'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:messages.rain},'Rain Out'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:messages.vog},'Vog/Ash'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:messages.lightning},'Lightning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:messages.threat},'Threat')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'selectedMessageText'},this.props.prefillMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'messageInput'},'Optional additional information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(e){_this3.props.updateOptionalMessage(e.target.value);},className:'validate',id:'messageInput',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'customBtn','data-target':'CustomModal',className:'btn modal-trigger modalBtn'},'Send Message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__custom_modal__["a" /* default */],{id:'CustomModal'}));}}]);return CustomForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{prefillMessage:state.form.prefillMessage,optionalMessage:state.form.optionalMessage,chips:state.form.chips};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({updatePrefillMessage:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["d" /* updatePrefillMessage */],updateOptionalMessage:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["e" /* updateOptionalMessage */],updateSelectedLocation:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["f" /* updateSelectedLocation */],removeChip:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["g" /* removeChip */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CustomForm));

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_alert_actions__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Materialize=window.Materialize;var $=window.$;var CustomModal=function(_React$Component){_inherits(CustomModal,_React$Component);function CustomModal(){_classCallCheck(this,CustomModal);return _possibleConstructorReturn(this,(CustomModal.__proto__||Object.getPrototypeOf(CustomModal)).apply(this,arguments));}_createClass(CustomModal,[{key:'componentDidMount',value:function componentDidMount(){$('#'+this.props.id).modal();}},{key:'getMobileEmployees',value:function getMobileEmployees(){//get list of employees with mobile phone
var mobile=this.props.employees.filter(function(emp){return emp.mobilePhone;});return mobile.map(function(emp,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i.toString(),className:'collection-item'},emp.first,' ',emp.last);});}},{key:'getLandlineEmployees',value:function getLandlineEmployees(){//get list of employees with landline phone
var mobile=this.props.employees.filter(function(emp){return emp.phone;});return mobile.map(function(emp,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i.toString(),className:'collection-item'},emp.first,' ',emp.last);});}},{key:'render',value:function render(){var _this2=this;var d=new Date().toLocaleDateString("en-US");var combinedMessage=this.props.prefillMessage+" "+this.props.optionalMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:this.props.id,className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Confirm Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'modalTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,d)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,combinedMessage)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m6 s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Employees To Be Texted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection modal-list'},this.getMobileEmployees())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m6 s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Employees To Be Called'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection modal-list'},this.getLandlineEmployees())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'modal-close btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){if(_this2.props.employees.length===0){Materialize.toast('No Employees Match This Criteria',4000,'rounded red');}else{_this2.props.notifySelectedEmployees(_this2.props.employees,combinedMessage,_this2.props.eid);}},className:'btn modal-close'},'Confirm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return CustomModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{employees:state.form.chips,prefillMessage:state.form.prefillMessage,optionalMessage:state.form.optionalMessage,eid:state.auth.user.guid};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({notifySelectedEmployees:__WEBPACK_IMPORTED_MODULE_3__actions_alert_actions__["h" /* notifySelectedEmployees */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CustomModal));

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__custom_form__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location_form__ = __webpack_require__(283);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var FormTabs=function(_React$Component){_inherits(FormTabs,_React$Component);function FormTabs(){_classCallCheck(this,FormTabs);return _possibleConstructorReturn(this,(FormTabs.__proto__||Object.getPrototypeOf(FormTabs)).apply(this,arguments));}_createClass(FormTabs,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('#alert-tabs').tabs();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Message & Call'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m12 s12 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'alert-tabs',className:'tabs tabs-fixed-width '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab1',className:'tab-text'},'Location Based')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab2',className:'tab-text'},'Custom')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab1',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__location_form__["a" /* default */],{className:'center form-card'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab2',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__custom_form__["a" /* default */],{className:'center form-card'})));}}]);return FormTabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FormTabs);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import '../App.css';
var Materialize=window.Materialize;var List=function(_React$Component){_inherits(List,_React$Component);function List(){var _ref;var _temp,_this,_ret;_classCallCheck(this,List);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=List.__proto__||Object.getPrototypeOf(List)).call.apply(_ref,[this].concat(args))),_this),_this.updateCustomList=function(e){//get employee selected from list
var employee=_this.props.list.find(function(person){return person.id===Number(e.currentTarget.id);});//if employee has a number listed, check if employee has already been added
if(employee.mobilePhone||employee.phone){if(_this.props.chips.find(function(chip){return chip.phone&&chip.phone===employee.phone;})||_this.props.chips.find(function(chip){return chip.mobilePhone&&chip.mobilePhone===employee.mobilePhone;})){//if already added, toast a message
Materialize.toast('An employee with the same phone number has already been added.',4000,'rounded red');}else{//if not added, add employee to list
_this.props.updateChips(employee.FirstName,employee.LastName,employee.mobilePhone,employee.phone,employee.id);}}else{//if no number listed, toast message
Materialize.toast('Employee does not have a phone number.',4000,'rounded red');}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(List,[{key:'renderList',value:function renderList(){var _this2=this;//render list of employees based on selected location and gang
return this.props.list.map(function(emp,i){var phone="";if(emp.mobilePhone){phone=emp.mobilePhone;}else{phone=emp.phone;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:emp.id,id:emp.id.toString(),className:'collection-item avatar',onClick:function onClick(e){return _this2.updateCustomList(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons circle green'},'person'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title'},emp.FirstName,' ',emp.LastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,phone,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),emp.location,' - ',Number(emp.location)===71?"Kau":"Keaau"));});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collapsible'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons '},'group'),'Employees (',this.props.list.length,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collapsible-body collection emp-list-alert'},this.renderList()))));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{list:state.list.employees,chips:state.form.chips};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({updateChips:__WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__["l" /* updateChips */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(List));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Form=function(_React$Component){_inherits(Form,_React$Component);function Form(){_classCallCheck(this,Form);return _possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).apply(this,arguments));}_createClass(Form,[{key:'componentDidMount',value:function componentDidMount(){//display all employees by default and get possible locations to select
this.props.updateSelectedLocation("All");this.props.fetchLocations();}},{key:'componentDidUpdate',value:function componentDidUpdate(){//if gang, location, and a prefill or option message are all filled in, allow message to be sent
if(this.props.gang&&this.props.location&&(this.props.prefillMessage||this.props.optionalMessage)){document.getElementById('modalBtn').disabled=false;}else{document.getElementById('modalBtn').disabled=true;}}},{key:'renderGangOptions',value:function renderGangOptions(){//render list of gang options from state
return this.props.gangOptions.map(function(opt,i){if(opt.gangCount){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i.toString(),value:opt.gangId},opt.gangId);}return null;});}},{key:'renderLocationOptions',value:function renderLocationOptions(){//render list of location options from state
return this.props.locationOptions.map(function(opt,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i.toString(),value:opt.location},opt.location,' - ',Number(opt.location)===71?"Kau":"Keaau");});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'messageForm',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col s12 m6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'active'},'Location:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'browser-default',defaultValue:'',id:'location',onChange:function onChange(e){_this2.props.updateSelectedLocation(e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Select Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'All'},'All Locations'),this.renderLocationOptions())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col s12 m6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'active'},'Gang:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'browser-default',defaultValue:'',id:'department',onChange:function onChange(e){_this2.props.updateSelectedGang(_this2.props.location,e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Select Gang'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'All'},'All Gangs'),this.renderGangOptions())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'browser-default',defaultValue:'',id:'messages',onChange:function onChange(e){_this2.props.updatePrefillMessage(e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Select Message'),__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SMS_MESSAGES */].map(function(m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:m.msg,value:m.msg},m.value);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'selectedMessageText'},this.props.prefillMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'messageInput'},'Optional additional information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(e){_this2.props.updateOptionalMessage(e.target.value);},className:'validate',id:'messageInput',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'modalBtn','data-target':'finalModal',className:'btn modal-trigger modalBtn'},'Send Message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__modal__["a" /* default */],{id:'finalModal'}));}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{location:state.form.location,prefillMessage:state.form.prefillMessage,optionalMessage:state.form.optionalMessage,gangOptions:state.form.gangOptions,locationOptions:state.form.locationOptions,gang:state.form.gang};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({updateSelectedLocation:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["f" /* updateSelectedLocation */],updatePrefillMessage:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["d" /* updatePrefillMessage */],updateOptionalMessage:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["e" /* updateOptionalMessage */],updateSelectedGang:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["i" /* updateSelectedGang */],fetchLocations:__WEBPACK_IMPORTED_MODULE_1__actions_alert_actions__["j" /* fetchLocations */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Form));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recent_messages__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_messages__ = __webpack_require__(287);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var MessagesTabs=function(_React$Component){_inherits(MessagesTabs,_React$Component);function MessagesTabs(){_classCallCheck(this,MessagesTabs);return _possibleConstructorReturn(this,(MessagesTabs.__proto__||Object.getPrototypeOf(MessagesTabs)).apply(this,arguments));}_createClass(MessagesTabs,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('#alert-search-tabs').tabs();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Notification History'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m12 s12 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'alert-search-tabs',className:'tabs tabs-fixed-width '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#recent',className:'tab-text'},'Recent')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#search',className:'tab-text'},'Search')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'recent',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__recent_messages__["a" /* default */],{className:'center'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'search',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__search_messages__["a" /* default */],{className:'center'})));}}]);return MessagesTabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MessagesTabs);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_alert_actions__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'componentDidMount',value:function componentDidMount(){$('#'+this.props.id).modal();}},{key:'getMobileEmployees',value:function getMobileEmployees(){//get employees with mobile phone
var mobile=this.props.employees.filter(function(emp){return emp.mobilePhone;});return mobile.map(function(emp,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i.toString(),className:'collection-item'},emp.FirstName,' ',emp.LastName);});}},{key:'getLandlineEmployees',value:function getLandlineEmployees(){//get employees with landline phone
var mobile=this.props.employees.filter(function(emp){return emp.phone;});return mobile.map(function(emp,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i.toString(),className:'collection-item'},emp.FirstName,' ',emp.LastName);});}},{key:'render',value:function render(){var _this2=this;var d=new Date().toLocaleDateString("en-US");var combinedMessage=this.props.prefillMessage+" "+this.props.optionalMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:this.props.id,className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Confirm Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{className:'modalTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,d)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Location: ',this.props.location,' - Gang No. ',this.props.gang)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,combinedMessage)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m6 s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Employees To Be Texted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection modal-list'},this.getMobileEmployees())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m6 s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Employees To Be Called'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection modal-list'},this.getLandlineEmployees())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'modal-close btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){_this2.props.notifyEmployees(_this2.props.location,_this2.props.gang,combinedMessage,_this2.props.eid);},className:'btn modal-close'},'Confirm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{location:state.form.location,gang:state.form.gang,employees:state.list.employees,prefillMessage:state.form.prefillMessage,optionalMessage:state.form.optionalMessage,eid:state.auth.user.guid};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({notifyEmployees:__WEBPACK_IMPORTED_MODULE_3__actions_alert_actions__["k" /* notifyEmployees */],getMessages:__WEBPACK_IMPORTED_MODULE_3__actions_alert_actions__["c" /* getMessages */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Modal));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecentMessages=function(_React$Component){_inherits(RecentMessages,_React$Component);function RecentMessages(){_classCallCheck(this,RecentMessages);return _possibleConstructorReturn(this,(RecentMessages.__proto__||Object.getPrototypeOf(RecentMessages)).apply(this,arguments));}_createClass(RecentMessages,[{key:'componentDidMount',value:function componentDidMount(){this.props.getMessages();}},{key:'renderList',value:function renderList(){//render list of previously sent messages
return this.props.list.map(function(message,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.dateSent.substring(0,10)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.location));});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderList()))));}}]);return RecentMessages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{list:state.messages.messages};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({getMessages:__WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__["c" /* getMessages */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(RecentMessages));

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inputs__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Materialize=window.Materialize;var SearchMessages=function(_React$Component){_inherits(SearchMessages,_React$Component);function SearchMessages(){_classCallCheck(this,SearchMessages);return _possibleConstructorReturn(this,(SearchMessages.__proto__||Object.getPrototypeOf(SearchMessages)).apply(this,arguments));}_createClass(SearchMessages,[{key:'componentDidUpdate',value:function componentDidUpdate(){var start=document.getElementById('dateStart').value;var end=document.getElementById('dateEnd').value;//allow query to be sent only if a start and end date have been specified
if(start&&end&&!this.props.list[0]){Materialize.toast('No messages were found.',4000,'rounded red');}}},{key:'renderList',value:function renderList(){//render list of messages fetched by database
return this.props.list.map(function(message,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.dateSent.substring(0,10)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,message.location));});}},{key:'searchForMessages',value:function searchForMessages(){//searcg for messages using start and end dates
var start=document.getElementById('dateStart').value;var end=document.getElementById('dateEnd').value;if(start&&end){this.props.searchMessagesDatabase(start,end);}else{Materialize.toast('Select a beginning and last date for your search.',4000,'rounded red');}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__inputs__["l" /* DatePicker */],{id:'dateStart',label:'Beginning Date',min:'2018-07-19'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__inputs__["l" /* DatePicker */],{id:'dateEnd',label:'Last Date',min:'2018-07-19'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field col m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn ',onClick:function onClick(){_this2.searchForMessages();}},'Search',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons right'},'search')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderList()))));}}]);return SearchMessages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{list:state.messages.searchedMessages};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({searchMessagesDatabase:__WEBPACK_IMPORTED_MODULE_2__actions_alert_actions__["b" /* searchMessagesDatabase */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchMessages));

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*********************************************************************
Alexander Self
Card Component
Original Author: Brandon Morelli
https://codeburst.io/build-a-minimalist-html-card-in-just-53-lines-of-code-with-flexbox-b40801927eb5
*********************************************************************/var Card=function Card(_ref){var header=_ref.header,width=_ref.width,icon=_ref.icon,desc=_ref.desc,color=_ref.color,borderColor=_ref.borderColor,headerColor=_ref.headerColor,onclick=_ref.onclick,_class=_ref._class,id=_ref.id,child=_ref.child;var card={width:width,border:"1px solid "+borderColor,borderRadius:"4px",/* Slightly Curve edges */overflow:"hidden",/* Fixes the corners */display:"flex",flexDirection:"column"};var cardHeader={color:""+color,textAlign:"center",fontSize:"11px",fontWeight:600,borderBottom:"1px solid "+borderColor,backgroundColor:""+headerColor,padding:"5px 10px"};var cardMain={display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",padding:"15px 0"};var cardIcon={fontSize:"36px",color:""+color,marginBottom:"5px"};var cardDescription={color:""+color,fontSize:"12px",textAlign:"center"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:card,onClick:onclick,className:"waves-effect","data-target":id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:cardHeader},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:cardMain},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{style:cardIcon,className:"material-icons"},icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:cardDescription},desc,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:_class},child))));};/* harmony default export */ __webpack_exports__["a"] = (Card);/* END */

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = LineChart;
/* unused harmony export StackedChart */
/* harmony export (immutable) */ __webpack_exports__["d"] = StackedBarChartWithLine;
/* harmony export (immutable) */ __webpack_exports__["a"] = StackedBarChart;
/* harmony export (immutable) */ __webpack_exports__["b"] = BarChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/***************************************************************
8/7/2017
Alexander Self
Line chart
- Creates linechart for a set of data
***************************************************************/function LineChart(ctx,labels,data){var opts=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'line',data:{labels:labels,datasets:[{label:'',//label,
data:data,backgroundColor:['rgba(255, 99, 132, 0.2)','rgba(54, 162, 235, 0.2)','rgba(255, 206, 86, 0.2)','rgba(75, 192, 192, 0.2)','rgba(153, 102, 255, 0.2)','rgba(255, 159, 64, 0.2)'],borderColor:['rgba(255,99,132,1)','rgba(54, 162, 235, 1)','rgba(255, 206, 86, 1)','rgba(75, 192, 192, 1)','rgba(153, 102, 255, 1)','rgba(255, 159, 64, 1)'],borderWidth:1}]},options:opts});}function StackedChart(ctx,labels,data1,data2,yLength,title){var opts={responsive:true,hoverMode:'index',stacked:false,title:{display:true,text:title},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Dates'}}],yAxes:[{type:"linear",// only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
display:true,position:"left",id:"y-axis-1",ticks:{beginAtZero:true,suggestedMax:yLength},scaleLabel:{display:true,labelString:'Total Employees'}},{type:"linear",// only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
display:false,position:"right",id:"y-axis-2",// grid line settings
ticks:{beginAtZero:true,suggestedMax:yLength},gridLines:{color:"rgba(0, 0, 0, 0)"}}]}};return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.Line(ctx,{data:{labels:labels,datasets:[{label:'Present',//label,
backgroundColor:['rgba(255, 99, 132, 0.2)'],borderColor:['rgba(255,99,132,1)'],borderWidth:1,fill:true,data:data1,yAxisID:"y-axis-1"},{label:'Absent',//label,
backgroundColor:['rgba(54, 162, 235, 0.2)'],borderColor:['rgba(54, 162, 235, 1)'],borderWidth:1,data:data2,yAxisID:"y-axis-2"}]},options:opts});}function StackedBarChartWithLine(ctx,labels,data1,data2,data3,label1,label2,label3){return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{labels:labels,datasets:[{type:'line',label:label1,backgroundColor:'rgba(54, 162, 235, 1)',borderColor:'rgba(54, 162, 235, 1)',borderWidth:2,fill:false,data:data1,yAxisID:"y-axis-2"},{type:'bar',label:label2,backgroundColor:'rgba(75, 192, 192, 1)',borderColor:'rgba(75, 192, 192, 1)',borderWidth:2,data:data2},{type:'bar',label:label3,backgroundColor:'rgba(255, 206, 86, 1)',borderColor:'rgba(255, 206, 86, 1)',borderWidth:2,data:data3,yAxisID:"y-axis-1"}]},options:{responsive:true,title:{text:''},tooltips:{mode:'index'},hover:{mode:'index'},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Field'}}],yAxes:[{stacked:false,position:"left",scaleLabel:{display:true,labelString:'Count'},id:"y-axis-1",ticks:{beginAtZero:true}},{stacked:false,position:"left",scaleLabel:{display:true,labelString:'Bag & Tree Count'},id:"y-axis-1"},{type:"linear",display:true,position:"right",scaleLabel:{display:true,labelString:'Density'},gridLines:{color:"rgba(0, 0, 0, 0)"},ticks:{beginAtZero:true},id:"y-axis-2"}]}}});}function StackedBarChart(ctx,labels,data1,data2,label1,label2){return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{labels:labels,datasets:[{type:'bar',label:label1,backgroundColor:'rgba(75, 192, 192, 1)',borderColor:'rgba(75, 192, 192, 1)',borderWidth:2,data:data1},{type:'bar',label:label2,backgroundColor:'rgba(255, 206, 86, 1)',borderColor:'rgba(255, 206, 86, 1)',borderWidth:2,data:data2,yAxisID:"y-axis-1"}]},options:{responsive:true,title:{text:''},tooltips:{mode:'index'},hover:{mode:'index'},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Department'}}],yAxes:[{stacked:false,position:"left",scaleLabel:{display:true,labelString:'Hours'},id:"y-axis-1",ticks:{beginAtZero:true}}]}}});}function BarChart(ctx,labels,data,title,label){return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{labels:labels,datasets:[{label:label,data:data,backgroundColor:data.map(function(d){return'rgba('+Math.floor(Math.random()*300)+', '+Math.floor(Math.random()*100)+', '+Math.floor(Math.random()*200)+', 0.2)';}),borderColor:data.map(function(d){return'rgba('+Math.floor(Math.random()*300)+', '+Math.floor(Math.random()*100)+', '+Math.floor(Math.random()*200)+', 1';}),borderWidth:1}]},options:{responsive:true,legend:{position:'top'},title:{display:true,text:title},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Fields'}}],yAxes:[{stacked:true,scaleLabel:{display:true,labelString:'Hours'}}]}}});}/* END */

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_map_modal__ = __webpack_require__(292);
/********************************************************************
Alexander Self
Image Map
10/24/17
- Clickable and interactive image map
********************************************************************/var GeneralMap=function GeneralMap(_ref){var onclick=_ref.onclick,onmouseover=_ref.onmouseover,_map=_ref._map,fields=_ref.fields,mapId=_ref.mapId,id=_ref.id,selectedField=_ref.selectedField,fieldHours=_ref.fieldHours,lastVisited=_ref.lastVisited,harvest=_ref.harvest,work=_ref.work;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,fields.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__dashboard_map_modal__["a" /* default */],{key:f.coords,field:f,selectedField:selectedField,fieldHours:fieldHours,lastVisited:lastVisited,harvest:harvest,work:work});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:_map,useMap:'#'+mapId,id:id,alt:'Map'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('map',{name:mapId},fields.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:f.id,className:'modal-trigger',href:'#'+f.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('area',{shape:f.shape,coords:f.coords,alt:f.alt,id:f.id,onClick:function onClick(e){return onclick(e.target.id);},onMouseOver:function onMouseOver(e){return onmouseover(e.target.id);}}));})));};/* harmony default export */ __webpack_exports__["a"] = (GeneralMap);/* END */

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_tractor_icon_png__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_tractor_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_tractor_icon_png__);
/*****************************************************
Alexander Self
1/12/18
EquipmentHours: Displays hours of use by equipment
*****************************************************/var EquipmentHours=function EquipmentHours(_ref){var equipmentHours=_ref.equipmentHours,sortBy=_ref.sortBy;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection with-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__img_tractor_icon_png___default.a,height:'40',width:'40',alt:'Tractor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'\xA0','Equipment Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'secondary-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'grade')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'dashboard-equipmenthours',type:'radio',id:'dashboard-operating-equipment',onClick:function onClick(e){return sortBy(e.target.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'dashboard-operating-equipment'},'Sort by Operating Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'dashboard-equipmenthours',type:'radio',id:'dashboard-garage-equipment',onClick:function onClick(e){return sortBy(e.target.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'dashboard-garage-equipment'},'Sort by Garage Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderBoard'},equipmentHours.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item',key:e.equipmentNo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s10 m10 l10 xl10 leaderInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text dash-readable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,e.equipmentNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'equipmentHours flow-text dash-readable'},'Operating Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'employee-active'},e.operatingHours))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'equipmentHours flow-text dash-readable'},'Garage Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'employee-inactive'},e.garageHours))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'secondary-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'#',i+1)))));})));};/* harmony default export */ __webpack_exports__["a"] = (EquipmentHours);/* END */

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_field_content_header__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_macOrchard_jpg__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_macOrchard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_macOrchard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_HIMN_logo_jpg__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_HIMN_logo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_HIMN_logo_jpg__);
/********************************************************************
Alexander Self
10/25/17
Map modal: Users recieve reports based onthe fields the select
********************************************************************///import FieldHoursList from './field/field_hours_list';
//import FieldTable from './field/field_custom_table';
var $=window.$;var MapModal=function MapModal(_ref){var field=_ref.field,selectedField=_ref.selectedField,fieldHours=_ref.fieldHours,lastVisited=_ref.lastVisited,harvest=_ref.harvest,hours=_ref.hours;$(document).ready(function(){$('#'+field.id).modal({//startingTop: '60%'//, // Starting top style attribute
endingTop:'20%'});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:field.id,className:'modal field-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__field_field_content_header__["a" /* default */],{field:field,selectedField:selectedField,logo:__WEBPACK_IMPORTED_MODULE_6__img_HIMN_logo_jpg___default.a,background:__WEBPACK_IMPORTED_MODULE_5__img_macOrchard_jpg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card light-blue',id:'lastVisited'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content white-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text left-align'},'Last Harvest Visit:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right-align'},lastVisited===undefined?'N/A':Object.keys(lastVisited).length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,lastVisited.lastHarvestVisit.date==='N/A'?lastVisited.lastHarvestVisit.date:__WEBPACK_IMPORTED_MODULE_1_moment___default()(lastVisited.lastHarvestVisit.date).format('YYYY-MM-DD')):'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text left-align'},'Last General Visit:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right-align'},lastVisited===undefined?'N/A':Object.keys(lastVisited).length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,lastVisited.lastWorkVisit.date==='N/A'?lastVisited.lastWorkVisit.date:__WEBPACK_IMPORTED_MODULE_1_moment___default()(lastVisited.lastWorkVisit.date).format('YYYY-MM-DD')):'N/A')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m8 l8 xl8'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'modal-action modal-close waves-effect waves-green btn-flat'},'Close')));};function mapStateToProps(state){return{user:state.auth.user,location:state.misc.location,selectedField:state.misc.fieldInfo.basicInfo,fieldHours:state.misc.fieldInfo.hours,lastVisited:state.misc.fieldInfo.lastVisited,harvest:state.misc.fieldInfo.harvest,work:state.misc.fieldInfo.work};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MapModal));/* END */

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*****************************************************
Alexander Self
12/17/17
HeadCount: Displays a headcount by department by date
*****************************************************/var MissingTimesheet=function MissingTimesheet(_ref){var empsWOTS=_ref.empsWOTS,fetchMissingTimesheets=_ref.fetchMissingTimesheets;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection with-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item avatar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons circle red"},"assignment_late"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title grey-text text-darken-4"},"Missing Timesheets ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,empsWOTS.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{onSubmit:function onSubmit(e){return e.preventDefault();},id:"headcount-search"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"missingTimesheet-date",type:"date",pattern:"[0-9]{4}-[0-9]{2}-[0-9]{2}"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{id:"missingTimesheet-date-btn",className:"btn btn-flat",onClick:function onClick(){return fetchMissingTimesheets(document.getElementById('missingTimesheet-date').value);}},"Fetch")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"leaderInfo"},"Total Missing Timesheets: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,empsWOTS.total," people")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"leaderBoard"},empsWOTS.data.map(function(h,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item avatar",key:h.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s10 m10 l10 xl10 leaderInfo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"flow-text"},h.data?h.data[0].manager.firstName+" "+h.data[0].manager.lastName:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"flow-text"},"Count: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,h.data.length),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("details",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("summary",null,"Employees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"highlight bordered responsive-table centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"EID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Location"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Department"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Position Type"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,h.data.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:e.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.eid===null?'':e.eid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.firstName===null?'':e.firstName," ",e.lastName===null?'':e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.department),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.positionType));}))))))));})));};/* harmony default export */ __webpack_exports__["a"] = (MissingTimesheet);/* END */

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/****************************************************************
Alexander Self
10/25/17

****************************************************************/var ContentHeader=function ContentHeader(_ref){var field=_ref.field,selectedField=_ref.selectedField,logo=_ref.logo,background=_ref.background;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"field-page-header",className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-image waves-effect waves-block waves-light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"activator",src:background,alt:"background"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("figure",{className:"card-profile-image"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:logo,className:"circle z-depth-2 responsive-img activator",alt:"keaau orchards"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s2 offset-s2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"card-title grey-text text-darken-4"},field.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-small grey-text"},"Field")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s2 center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"card-title grey-text text-darken-4"},selectedField.totalAcre),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-small grey-text"},"Total Acres")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s2 center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"card-title grey-text text-darken-4"},selectedField.mechHarvest===null?0:selectedField.mechHarvest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-small grey-text"},"Mechanical Harvest")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s2 center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"card-title grey-text text-darken-4"},selectedField.handHarvest===null?0:selectedField.handHarvest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-small grey-text"},"Hand Harvest")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s1 center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"card-title grey-text text-darken-4"},selectedField.owner),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-small grey-text"},"Group")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s1 right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"btn-floating activator waves-effect waves-light darken-2 right field-clickview"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"assessment"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-reveal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title grey-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"left"},field.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"close")))));};/* harmony default export */ __webpack_exports__["a"] = (ContentHeader);/* END */

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col l6 s12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"white-text"},"Hawaiian Macadamia Nut Services"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"grey-text text-lighten-4"},"Time Management")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col l4 offset-l2 s12"}))));};/* harmony default export */ __webpack_exports__["a"] = (Footer);/* END */

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/****************************************************************
Alexander Self
8/23/17
Team list:Displyas a list of gangs
****************************************************************/var $=window.$;var GeneralGangList=function GeneralGangList(_ref){var gangs=_ref.gangs,_onClick=_ref.onClick,id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection',id:id},gangs.map(function(g){$(document).ready(function(){$('#'+g.gangId).collapsible();});if(g.status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:g.gangId,className:'collection-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},'Team: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),'Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangLoc===72?'Kea\'au':'Ka\'u'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-floating waves-effect waves-light grey',onClick:function onClick(){return _onClick(g);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'person_add'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:g.gangId,className:'collection-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},'Team: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),'Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,g.gangLoc===72?'Kea\'au':'Ka\'u'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["n" /* FloatingButton */],{color:'green',icon:'person_add',onclick:function onclick(){return _onClick(g);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('details',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('summary',null,'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,g.emps.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:Math.random(),className:'gang-employees'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'gang-employees-font'},e.firstName===null?'':e.firstName,' ',e.lastName===null?'':e.lastName));})))));}));};/* harmony default export */ __webpack_exports__["a"] = (GeneralGangList);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mechHarvest_form_2__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mechHarvest_modal_2__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mechHarvest_form_table__ = __webpack_require__(305);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
12.14.22: Update on primary form; allows user to submit multiple
harvest records in a single submission
Mech harvest create: Handles the creation of new records
***********************************************************//* Libraries *//* Actions *//* Components */var MechanicalHarvestCreate=function(_Component){_inherits(MechanicalHarvestCreate,_Component);function MechanicalHarvestCreate(props){_classCallCheck(this,MechanicalHarvestCreate);var _this=_possibleConstructorReturn(this,(MechanicalHarvestCreate.__proto__||Object.getPrototypeOf(MechanicalHarvestCreate)).call(this,props));_this.handleHarvestRecord=_this.handleHarvestRecord.bind(_this);return _this;}_createClass(MechanicalHarvestCreate,[{key:'handleHarvestRecord',value:function handleHarvestRecord(callback){var harvest=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["m" /* validateMechHarvestForm */])({seasons:this.props.seasons,employees:this.props.employees,equipmentList:this.props.equipmentNo});if(Object.keys(harvest).length===0)return;var preparedAcres=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,this.props.selectedField.treePerAcre);return callback(Object.assign({},harvest,{submitter:this.props.eid,estimatedLbs:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["e" /* estimatedLbs */])(harvest.estLbsPerContainer,harvest.containerCount),acresPerHour:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["f" /* acresPerHour */])(harvest.hours,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,this.props.selectedField.treePerAcre)),density:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["g" /* density */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["e" /* estimatedLbs */])(harvest.estLbsPerContainer,harvest.containerCount),harvest.treesCovered),acresCompleted:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["d" /* acresCompleted */])(harvest.treesCovered,this.props.selectedField.treePerAcre),percentComplete:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["j" /* percentComplete */])(preparedAcres,this.props.selectedField.mechHarvest)}));}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Create Mechanical Harvest')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__mechHarvest_form_2__["a" /* default */],{fields:this.props.fields,blocks:this.props.blocks,selectedField:this.props.selectedField,submitter:this.props.eid,equipmentNo:this.props.equipmentNo,employees:this.props.employees,toEdit:this.props.toEdit,fetchFieldsByLoc:this.props.fetchFieldsByLoc,fetchBlocksByField:this.props.fetchBlocksByField,selectField:this.props.selectField,addHarvestRecord:function addHarvestRecord(){return _this2.handleHarvestRecord(_this2.props.addHarvestRecord);},editHarvestRecord:function editHarvestRecord(){return _this2.handleHarvestRecord(_this2.props.editHarvestRecord);}})),this.props.harvestRecords.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__mechHarvest_form_table__["a" /* default */],{harvest:this.props.harvestRecords,employees:this.props.employees,editHarvest:function editHarvest(h){return _this2.props.setMechHarvestToEdit(h);},deleteHarvest:this.props.deleteHarvestRecord})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__mechHarvest_modal_2__["a" /* default */],{id:'mechHarvest-modal',harvest:this.props.harvestRecords,previousHarvest:this.props.previousHarvest,fields:this.props.fields,employees:this.props.employees,onClick:function onClick(){return _this2.props.createMechHarvest2({harvest:_this2.props.harvestRecords});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-target':'mechHarvest-modal',className:'btn waves-light waves-effect',onClick:function onClick(){return _this2.props.prepareMechHarvest2({harvest:_this2.props.harvestRecords,fields:_this2.props.fields,employees:_this2.props.employees,type:'create'});}},'Prepare')));}}]);return MechanicalHarvestCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{blocks:state.harvest.blocks,eid:state.auth.user.guid,employees:state.harvest.employees.displaying,equipmentNo:state.harvest.equipmentNo,fields:state.harvest.fields,harvest:state.harvest.create.harvest,harvestRecords:state.harvest.create.harvestRecords,previousHarvest:state.harvest.create.previousHarvest,seasons:state.harvest.seasons,selectedField:state.harvest.create.selectedField,toEdit:state.harvest.create.toEdit};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({addHarvestRecord:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["i" /* addHarvestRecord */],createMechHarvest:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["j" /* createMechHarvest */],createMechHarvest2:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["k" /* createMechHarvest2 */],deleteHarvestRecord:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["l" /* deleteHarvestRecord */],editHarvestRecord:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["m" /* editHarvestRecord */],fetchFieldsByLoc:__WEBPACK_IMPORTED_MODULE_4__actions__["fetchFieldsByLoc"],fetchBlocksByField:__WEBPACK_IMPORTED_MODULE_4__actions__["fetchBlocksByField"],prepareMechHarvest:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["d" /* prepareMechHarvest */],prepareMechHarvest2:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["n" /* prepareMechHarvest2 */],selectField:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["f" /* selectField */],setMechHarvestToEdit:__WEBPACK_IMPORTED_MODULE_5__actions_harvest_actions__["o" /* setMechHarvestToEdit */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MechanicalHarvestCreate));/* END */

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
11.15.22: Update; create multiple input dynamic harvest form
Mech. harvest form: Handles form interactions
***********************************************************/var MechanicalHarvestForm2=function(_Component){_inherits(MechanicalHarvestForm2,_Component);function MechanicalHarvestForm2(){_classCallCheck(this,MechanicalHarvestForm2);return _possibleConstructorReturn(this,(MechanicalHarvestForm2.__proto__||Object.getPrototypeOf(MechanicalHarvestForm2)).apply(this,arguments));}_createClass(MechanicalHarvestForm2,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pl-2 pr-2 pt-2 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'mechHarvest-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["d" /* DatePicker2 */],{id:'mech-date',label:'Date',defaultValue:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),max:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-location',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){return _this2.props.fetchFieldsByLoc(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-round',label:'Round',min:1,max:5})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:'mech-notes',label:'Notes'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ml-1 flow-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Individual Harvest')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'mechHarvest-individual-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:'mech-field',opts:this.props.fields,label:'Field',onChange:function onChange(event){_this2.props.fetchBlocksByField(event.target.value,'mech-field');_this2.props.selectField(event.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["j" /* SelectBlock */],{id:'mech-block',label:'Block No.',opts:this.props.blocks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-treesCovered',label:'Trees Covered'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-hours',label:'Total Hours',step:"0.1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-containerType',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CONTAINER_TYPES */],label:'Container Type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-containerCount',label:'Total Containers'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-estLbsPerContainer',label:'Est. Lbs/Container'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-status',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* STATUS */],label:'Status'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["e" /* AutoComplete */],{id:'mech-equipmentNo',label:'Equipment No.',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* mapEquipmentForAutoComplete */])(this.props.equipmentNo),onComplete:__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["e" /* AutoComplete */],{id:'mech-eid',label:'Equipment Operator',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l4 xl4 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-2'},this.props.toEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect waves-light blue',onClick:this.props.editHarvestRecord},'Edit Harvest'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect waves-light',onClick:this.props.addHarvestRecord},'Add Harvest')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'mech-time',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("hh:mm:ss a")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'mech-submitter',value:this.props.submitter})));}}]);return MechanicalHarvestForm2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MechanicalHarvestForm2);/*

*//* END */

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/****************************************************************
Alexander Self
8/23/17
Gang list:Displyas a list of gangs
****************************************************************/var HarvestList=function HarvestList(_ref){var harvest=_ref.harvest,_onClick=_ref.onClick,id=_ref.id;if(!harvest)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Harvest Available for Edit');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection',id:id},harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:h.id,className:'collection-item harvest-list-item waves-light',onClick:function onClick(){return _onClick(h);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(h.date).format('YYYY-MM-DD')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Rd. ',h.round)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,h.field),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,h.estimatedLbs,' lbs'))));}));};/* harmony default export */ __webpack_exports__["a"] = (HarvestList);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mechHarvest_table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
Hawaiian Macadamia Nut Services
12/05/2018
Alexander Self
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with recently submitted logs
***************************************************************/var $=window.$;var MechHarvestDeleteModal=function MechHarvestDeleteModal(_ref){var id=_ref.id,selectedField=_ref.selectedField,selectedHarvest=_ref.selectedHarvest,_onClick=_ref.onClick;$(document).ready(function(){$('#'+id).modal();});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Delete Mechanical Harvest Log'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',{className:'day-off'},'Do you wish to delete the following log?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__mechHarvest_table__["a" /* default */],{harvest:[selectedHarvest],field:selectedField,totals:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'modal-action modal-close waves-effect waves-red btn red',id:'mech-harvest-delete-btn',onClick:function onClick(){return _onClick(selectedHarvest);}},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (MechHarvestDeleteModal);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech. harvest form: Handles form interactions
***********************************************************/var MechanicalHarvestEditForm=function(_Component){_inherits(MechanicalHarvestEditForm,_Component);function MechanicalHarvestEditForm(props){_classCallCheck(this,MechanicalHarvestEditForm);var _this=_possibleConstructorReturn(this,(MechanicalHarvestEditForm.__proto__||Object.getPrototypeOf(MechanicalHarvestEditForm)).call(this,props));_this.state={id:_this.props.id};return _this;}_createClass(MechanicalHarvestEditForm,[{key:'render',value:function render(){var _this2=this;var max=__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'mechHarvest-edit-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["d" /* DatePicker2 */],{id:'mech-edit-date',label:'Date',max:max})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-edit-location',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){return _this2.props.fetchFieldsByLoc(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:'mech-edit-field',opts:this.props.fields,label:'Field',onChange:function onChange(event){_this2.props.fetchBlocksByField(event.target.value,'mech-field');_this2.props.selectField(event.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["j" /* SelectBlock */],{id:'mech-edit-block',label:'Block No.',opts:this.props.blocks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-edit-treesCovered',label:'Trees Covered'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-edit-hours',label:'Total Hours',step:"0.1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-edit-containerType',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CONTAINER_TYPES */],label:'Container Type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-edit-containerCount',label:'Total Containers'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-edit-estLbsPerContainer',label:'Est. Lbs/Container'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["e" /* AutoComplete */],{id:'mech-edit-equipmentNo',label:'Equipment No.',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* mapEquipmentForAutoComplete */])(this.props.equipmentNo),onComplete:__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["e" /* AutoComplete */],{id:'mech-edit-employee',label:'Equipment Operator',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'mech-edit-round',label:'Round'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m8 l8 xl8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["k" /* Textarea */],{id:'mech-edit-notes',label:'Notes'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'mech-edit-status',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* STATUS */],label:'Status'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'mech-edit-time',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("hh:mm:ss a")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'mech-edit-submitter',value:this.props.submitter}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'mech-edit-id',value:this.state.id})));}}]);return MechanicalHarvestEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MechanicalHarvestEditForm);/*

*//* END */

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__harvest_list__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mechHarvest_edit_form__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mechHarvest_modal__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mechHarvest_delete_modal__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Gang View: View user created gangs(teams of employees)
***********************************************************/var MechanicalHarvestManage=function(_Component){_inherits(MechanicalHarvestManage,_Component);function MechanicalHarvestManage(props){_classCallCheck(this,MechanicalHarvestManage);var _this=_possibleConstructorReturn(this,(MechanicalHarvestManage.__proto__||Object.getPrototypeOf(MechanicalHarvestManage)).call(this,props));_this.fetchHarvest=_this.fetchHarvest.bind(_this);return _this;}_createClass(MechanicalHarvestManage,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchMyMechHarvest(this.props.eid);}},{key:'fetchHarvest',value:function fetchHarvest(){var date=document.getElementById('mechHarvest-manage-date').value;if(date===''||date===undefined||date===null)return;return this.props.fetchHarvestByDate(date);}},{key:'render',value:function render(){var _this2=this;var max=__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');//let min = moment().subtract(10, 'days').format('YYYY-MM-DD');
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Manage Mechanical Harvest')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__harvest_list__["a" /* default */],{harvest:this.props.myHarvest,onClick:this.props.selectHarvestToManage,id:'mechHarvest-manage-list'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__inputs__["d" /* DatePicker2 */],{id:'mechHarvest-manage-date',label:'Select a Date',max:max}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect waves-light',onClick:this.fetchHarvest},'Fetch'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},this.props.isEditOrDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-edit-or-delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-target':'mechHarvest-edit-modal',className:'btn blue',onClick:function onClick(){return _this2.props.prepareMechHarvest(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["i" /* packageDashForm */])('mechHarvest-edit-form'),_this2.props.selectedField,_this2.props.seasons,_this2.props.employees,'edit');}},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-target':'mechHarvest-delete-modal',className:'btn red'},'Delete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn white clear-btn',onClick:this.props.resetManageHarvest},'Clear'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__mechHarvest_modal__["a" /* default */],{id:'mechHarvest-edit-modal',selectedField:this.props.selectedField,harvest:this.props.editedHarvest,previousHarvest:this.props.previousHarvest,equipmentNo:this.props.equipmentNo,onClick:this.props.updateMechHarvest,selectedHarvest:this.props.selectedHarvest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__mechHarvest_delete_modal__["a" /* default */],{id:'mechHarvest-delete-modal',selectedField:this.props.selectedField,onClick:this.props.deleteMechHarvest,selectedHarvest:this.props.selectedHarvest})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__mechHarvest_edit_form__["a" /* default */],{fetchFieldsByLoc:this.props.fetchFieldsByLoc,fetchBlocksByField:this.props.fetchBlocksByField,fields:this.props.fields,blocks:this.props.blocks,selectField:this.props.selectField,selectedField:this.props.selectedField,submitter:this.props.eid,equipmentNo:this.props.equipmentNo,employees:this.props.employees,id:this.props.selectedHarvest.id})));}}]);return MechanicalHarvestManage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{blocks:state.harvest.blocks,eid:state.auth.user.eid,editedHarvest:state.harvest.manage.editedHarvest,employees:state.harvest.employees.displaying,equipmentNo:state.harvest.equipmentNo,fields:state.harvest.fields,isEditOrDelete:state.harvest.manage.isEditOrDelete,myHarvest:state.harvest.manage.myHarvest,previousHarvest:state.harvest.manage.previousHarvest,seasons:state.harvest.seasons,selectedField:state.harvest.manage.selectedField,selectedHarvest:state.harvest.manage.selectedHarvest};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({deleteMechHarvest:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["a" /* deleteMechHarvest */],fetchFieldsByLoc:__WEBPACK_IMPORTED_MODULE_10__actions__["fetchFieldsByLoc"],fetchBlocksByField:__WEBPACK_IMPORTED_MODULE_10__actions__["fetchBlocksByField"],fetchHarvestByDate:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["b" /* fetchHarvestByDate */],fetchMyMechHarvest:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["c" /* fetchMyMechHarvest */],prepareMechHarvest:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["d" /* prepareMechHarvest */],resetManageHarvest:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["e" /* resetManageHarvest */],selectField:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["f" /* selectField */],selectHarvestToManage:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["g" /* selectHarvestToManage */],updateMechHarvest:__WEBPACK_IMPORTED_MODULE_11__actions_harvest_actions__["h" /* updateMechHarvest */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MechanicalHarvestManage));/* END */

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech harvest create: Handles the creation of new records
***********************************************************/var MechanicalHarvestDisplay=function(_Component){_inherits(MechanicalHarvestDisplay,_Component);function MechanicalHarvestDisplay(){_classCallCheck(this,MechanicalHarvestDisplay);return _possibleConstructorReturn(this,(MechanicalHarvestDisplay.__proto__||Object.getPrototypeOf(MechanicalHarvestDisplay)).apply(this,arguments));}_createClass(MechanicalHarvestDisplay,[{key:'render',value:function render(){if(!this.props.harvest)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);var _props$harvest=this.props.harvest,containerType=_props$harvest.containerType,employee=_props$harvest.employee,equipmentNo=_props$harvest.equipmentNo,estLbsPerContainer=_props$harvest.estLbsPerContainer,notes=_props$harvest.notes;//this.props.harvest.id = 0;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Operator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,employee)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Equipment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,equipmentNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Container Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,containerType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Est Lbs/Container'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,estLbsPerContainer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'p-b'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,notes)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__["a" /* default */],{harvest:[this.props.harvest],field:{},totals:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return MechanicalHarvestDisplay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MechanicalHarvestDisplay);/* END */

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech harvest create: Handles the creation of new records
***********************************************************/var MechanicalHarvestDisplay2=function(_Component){_inherits(MechanicalHarvestDisplay2,_Component);function MechanicalHarvestDisplay2(){_classCallCheck(this,MechanicalHarvestDisplay2);return _possibleConstructorReturn(this,(MechanicalHarvestDisplay2.__proto__||Object.getPrototypeOf(MechanicalHarvestDisplay2)).apply(this,arguments));}_createClass(MechanicalHarvestDisplay2,[{key:'render',value:function render(){var _this2=this;if(!this.props.harvest)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.harvest&&this.props.harvest.map(function(h){var containerType=h.containerType,eid=h.eid,equipmentNo=h.equipmentNo,estLbsPerContainer=h.estLbsPerContainer,notes=h.notes;var emp=_this2.props.employees.find(function(e){return e.eid===eid;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:h.id?h.id:h.guid,className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Operator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,emp&&emp.firstName[0]+'. '+emp.lastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Equipment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,equipmentNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Container Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,containerType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Est Lbs/Container'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,estLbsPerContainer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,notes)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__["a" /* default */],{harvest:[h],field:{},totals:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}));}}]);return MechanicalHarvestDisplay2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MechanicalHarvestDisplay2);/* END */

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
Hawaiian Macadamia Nut Services
11/17/22
Alexander Self
Mech harvest form table
- Table that displays, updates and deletes new or edited harvest records
***************************************************************/function MechHarvestFormTable(_ref){var harvest=_ref.harvest,employees=_ref.employees,editHarvest=_ref.editHarvest,deleteHarvest=_ref.deleteHarvest;if(!harvest)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"highlight bordered responsive-table centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"harvest-headers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Field"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Block"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Trees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Hours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Container Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Container #"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Est Lbs/Container"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Equipment"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Employee"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Edit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Delete"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,harvest&&harvest.map(function(h){var emp=employees.find(function(e){return e.eid===h.eid;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:h.id?h.id:h.guid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.block),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.treesCovered),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.containerType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.containerCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.estLbsPerContainer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.status===0||h.status==='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label label-incomplete"},"Incomplete"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"label label-complete"},"Complete")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,h.equipmentNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,emp&&emp.firstName[0]+". "+emp.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return editHarvest(h);},className:"btn-floating waves-effect waves-light blue"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"mode_edit"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return deleteHarvest(h.id?h.id:h.guid);},className:"btn-floating waves-effect waves-light red"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"clear"))));})));}/* harmony default export */ __webpack_exports__["a"] = (MechHarvestFormTable);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mechHarvest_display__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/***************************************************************
Hawaiian Macadamia Nut Services
12/05/2018
Alexander Self
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with recently submitted logs
***************************************************************/var $=window.$;var MechHarvestModal=function MechHarvestModal(_ref){var id=_ref.id,selectedField=_ref.selectedField,harvest=_ref.harvest,previousHarvest=_ref.previousHarvest,equipmentNo=_ref.equipmentNo,selectedHarvest=_ref.selectedHarvest,_onClick=_ref.onClick;$(document).ready(function(){$('#'+id).modal();});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Mechanical Harvest Log'),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},previousHarvest.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text'},'Recent Records for: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,selectedField.field,' | Round ',harvest.round)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__["a" /* default */],{harvest:previousHarvest,field:selectedField,currentHarvest:harvest,totals:true})):''),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text blue-text'},'Review & Submit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__mechHarvest_display__["a" /* default */],{selectedField:selectedField,harvest:harvest}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'modal-action modal-close waves-effect waves-green btn-flat',id:'mech-harvest-create-btn',onClick:function onClick(){return _onClick(harvest,previousHarvest,selectedField,equipmentNo,selectedHarvest);}},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (MechHarvestModal);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mechHarvest_display_2__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/***************************************************************
Hawaiian Macadamia Nut Services
12/08/2022
Alexander Self
** Large update from prior form: Allows user to submit multiple 
fields in one submission
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with 
recently submitted logs
***************************************************************/var $=window.$;var MechHarvestModal2=function MechHarvestModal2(_ref){var id=_ref.id,harvest=_ref.harvest,previousHarvest=_ref.previousHarvest,fields=_ref.fields,employees=_ref.employees,_onClick=_ref.onClick;$(document).ready(function(){$('#'+id).modal();});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Mechanical Harvest Log'),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},previousHarvest.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text pt-2'},'Recent Records for: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,harvest&&harvest.map(function(h){return'| '+h.field+' ';}),' --- Round ',harvest.length>0&&harvest[0].round)),previousHarvest.map(function(h){var field=fields.find(function(f){return f.field===h.field;});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:h.field},h.previousHarvest.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,h.field),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mechHarvest_table__["a" /* default */],{harvest:h.previousHarvest,field:field,totals:true,onClick:function onClick(){return console.log('Clicked!');}})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'There are no previous records for ',h.field,' during round ',harvest.length>0&&harvest[0].round));})):''),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text blue-text'},'Review & Submit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__mechHarvest_display_2__["a" /* default */],{harvest:harvest,employees:employees}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'modal-action modal-close waves-effect waves-green btn-flat',id:'mech-harvest-create-btn',onClick:function onClick(){return _onClick(harvest,previousHarvest);}},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (MechHarvestModal2);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
01/18/2019
Alexander Self
Harvest Info Card
- Small info cards of different colors which provide important information
***************************************************************/var IrrigationInfoCard=function IrrigationInfoCard(_ref){var header=_ref.header,label=_ref.label,icon=_ref.icon,child=_ref.child,data=_ref.data,color=_ref.color,avg1=_ref.avg1,avg2=_ref.avg2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-stats"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content "+color+" white-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("center",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons icon-shift"},icon),header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,data),avg1,avg2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-action "+color+" darken-4"},child)));};/* harmony default export */ __webpack_exports__["a"] = (IrrigationInfoCard);/* END */

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech. harvest form: Handles form interactions
***********************************************************/var HarvestReportForm=function(_Component){_inherits(HarvestReportForm,_Component);function HarvestReportForm(){_classCallCheck(this,HarvestReportForm);return _possibleConstructorReturn(this,(HarvestReportForm.__proto__||Object.getPrototypeOf(HarvestReportForm)).apply(this,arguments));}_createClass(HarvestReportForm,[{key:'render',value:function render(){var _this2=this;if(!(this.props.employees&&this.props.equipmentNo))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Report Form')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'rep-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["c" /* RadioButton */],{id:'rep-hand',name:'rep-type',label:'Hand',onClick:function onClick(e){return _this2.props.selectReportType(e.target.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["c" /* RadioButton */],{id:'rep-mech',name:'rep-type',label:'Mech',onClick:function onClick(e){return _this2.props.selectReportType(e.target.id);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["d" /* DatePicker2 */],{id:'rep-dateFrom',label:'Date From'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["d" /* DatePicker2 */],{id:'rep-dateTo',label:'Date To'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["a" /* Select */],{id:'rep-location',opts:__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){return _this2.props.fetchFieldsByLoc(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["g" /* NumberInput */],{id:'rep-round',label:'Round',disabled:this.props.disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["i" /* SelectField */],{id:'rep-field',opts:this.props.fields,label:'Field',onChange:function onChange(event){_this2.props.fetchBlocksByField(event.target.value,'mech-rep-field');_this2.props.selectField(event.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["j" /* SelectBlock */],{id:'rep-block',label:'Block No.',opts:this.props.blocks}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["e" /* AutoComplete */],{id:'rep-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* onDummyComplete */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["e" /* AutoComplete */],{id:'rep-equipmentNo',label:'Equipment No.',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["t" /* mapEquipmentForAutoComplete */])(this.props.equipmentNo),onComplete:__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* onDummyComplete */],disabled:this.props.disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["b" /* CheckBox */],{id:'rep-csv',name:'rep-docType',label:'Excel'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-large waves-effect waves-light',type:'button',onClick:function onClick(){return _this2.props.fetchReport(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["i" /* packageDashForm */])('rep-form'),_this2.props.employees,_this2.props.email);}},'Run Report')))));}}]);return HarvestReportForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestReportForm);/*

*//* END */

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__report_harvest_intro_summary__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__report_harvest_metrics_summary__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_harvest_averages_summary__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__report_harvest_field_summary__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
Hawaiian Macadamia Nut Services
01/18/2019
Alexander Self
Harvest Report View
- View various graphs, data sets regarding harvest
***************************************************************/var HarvestReportView=function(_Component){_inherits(HarvestReportView,_Component);function HarvestReportView(props){_classCallCheck(this,HarvestReportView);var _this=_possibleConstructorReturn(this,(HarvestReportView.__proto__||Object.getPrototypeOf(HarvestReportView)).call(this,props));_this.state={dataExists:true};return _this;}_createClass(HarvestReportView,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){var data=newProps.query.data;if(data.length===0){this.setState({dataExists:!this.state.dataExists});return;}}},{key:'render',value:function render(){if(this.props.query.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.dataExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Loading...',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No data exists for this query',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect',onClick:this.props.selectNewReport},'Select New Report')));}var _props$options=this.props.options,dateFrom=_props$options.dateFrom,dateTo=_props$options.dateTo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect',onClick:this.props.selectNewReport},'Select New Report')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right flow-text'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(dateFrom).format('MM-DD-YYYY'),' to ',__WEBPACK_IMPORTED_MODULE_5_moment___default()(dateTo).format('MM-DD-YYYY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__report_harvest_intro_summary__["a" /* default */],{query:this.props.query})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__report_harvest_metrics_summary__["a" /* default */],{query:this.props.query,options:this.props.options})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__report_harvest_averages_summary__["a" /* default */],{query:this.props.query})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__report_harvest_field_summary__["a" /* default */],{query:this.props.query}))));}}]);return HarvestReportView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestReportView);/* END */

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__harvest_report_form__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mechHarvest_table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__harvest_report_view__ = __webpack_require__(310);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/6/18
Updated: 7.6.22
Harvest View: Table and report view for harvest module
***********************************************************/var HarvestView=function(_Component){_inherits(HarvestView,_Component);function HarvestView(props){_classCallCheck(this,HarvestView);var _this=_possibleConstructorReturn(this,(HarvestView.__proto__||Object.getPrototypeOf(HarvestView)).call(this,props));_this.state={harvest:_this.props.mechHarvest,reverseSort:false};_this.sortBy=_this.sortBy.bind(_this);return _this;}_createClass(HarvestView,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchAllMechHarvest();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){if(newProps.mechHarvest)this.setState({harvest:newProps.mechHarvest});}},{key:'sortBy',value:function sortBy(id){var _this2=this;if(!id)return;var _id=id.split('-');if(this.state.reverseSort)this.setState({reverseSort:!this.state.reverseSort},function(){_this2.setState({harvest:_this2.state.harvest.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* dynamicReverseSort */])(_id[1]))});});this.setState({harvest:this.state.harvest.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* dynamicSort */])(_id[1])),reverseSort:!this.state.reverseSort});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},!this.props.reportOpts.reportRunning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col s12 m4 l3 xl3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__harvest_report_form__["a" /* default */],{equipmentNo:this.props.equipmentNo,employees:this.props.employees,email:this.props.email,fields:this.props.fields,blocks:this.props.blocks,fetchFieldsByLoc:this.props.fetchFieldsByLoc,fetchBlocksByField:this.props.fetchBlocksByField,selectField:this.props.selectField,disabled:this.props.disabled,setReportOptions:this.props.setReportOptions,selectReportType:this.props.selectReportType,fetchReport:this.props.fetchReport})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col s12 m8 l9 xl9"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card harvest-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__mechHarvest_table__["a" /* default */],{harvest:this.state.harvest,totals:false,onClick:this.sortBy}))))):/* Report is running */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__harvest_report_view__["a" /* default */],{query:this.props.query,selectNewReport:this.props.selectNewReport,options:this.props.options}));}}]);return HarvestView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{blocks:state.harvest.blocks,disabled:state.harvest.report.disabled,eid:state.auth.user.guid,email:state.auth.user.email,employees:state.harvest.employees.all,equipmentNo:state.harvest.equipmentNo,fields:state.harvest.fields,mechHarvest:state.harvest.harvest.mech.displaying,query:state.harvest.report.query,reportOpts:state.harvest.report.reportOpts,options:state.harvest.report.options,seasons:state.harvest.seasons};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchAllMechHarvest:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["p" /* fetchAllMechHarvest */],fetchFieldsByLoc:__WEBPACK_IMPORTED_MODULE_3__actions__["fetchFieldsByLoc"],fetchBlocksByField:__WEBPACK_IMPORTED_MODULE_3__actions__["fetchBlocksByField"],fetchReport:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["q" /* fetchReport */],selectField:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["f" /* selectField */],selectNewReport:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["r" /* selectNewReport */],selectReportType:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["s" /* selectReportType */],setReportOptions:__WEBPACK_IMPORTED_MODULE_4__actions_harvest_actions__["t" /* setReportOptions */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HarvestView));/* END */

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestAveragesSummary: Harvest averages for harvest dashboard
***********************************************************/var HarvestAveragesSummary=function(_Component){_inherits(HarvestAveragesSummary,_Component);function HarvestAveragesSummary(){_classCallCheck(this,HarvestAveragesSummary);return _possibleConstructorReturn(this,(HarvestAveragesSummary.__proto__||Object.getPrototypeOf(HarvestAveragesSummary)).apply(this,arguments));}_createClass(HarvestAveragesSummary,[{key:'render',value:function render(){var summary=this.props.query.summary;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection z-depth-1 with-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan circle'},'insert_chart'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'flow-text'},'Average Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:true},'Employee Averages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Cost per Acre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},'$',summary.avgCostPerAcre,'/acre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge cyan white-text'},'Cost')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgCostPerAcre;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Density'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},summary.avgDensity,' lbs/tree')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge red white-text'},'Density')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgDensity;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Lbs per Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},summary.avgLbsPerHour,' lbs/hr')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge green white-text'},'Lbs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgLbsPerHour;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Trees per Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},summary.avgTreesPerHour,' tree/acre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge orange white-text'},'Trees')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgTreesPerHour;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Lbs per Acre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},summary.avgLbsPerAcre,' lbs/acre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge green white-text'},'Lbs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgLbsPerAcre;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))),summary.avgPerformanceIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item harvest-collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row harvest-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 harvest-col-s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-title'},'Average Performance Index'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'harvest-collections-content'},summary.avgPerformanceIndex)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge blue white-text'},'Performance')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s4 harvest-col-s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:summary.employee.map(function(e){return e.avgPerformanceIndex;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"blue",strokeWidth:"1",fill:"#00acc1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))))):'');}}]);return HarvestAveragesSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestAveragesSummary);/* END */

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
12/07/2018
Alexander Self
Mech harvest table
- Table summary of harvest: mech or hand
***************************************************************/var HarvestEmployeeTable=function HarvestEmployeeTable(_ref){var harvest=_ref.harvest,totals=_ref.totals,type=_ref.type;if(!harvest)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);if(type==='hand'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Key'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Trees'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Cost'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Performance Index'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Lbs / Hr'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Cost / Lb'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Density'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Acres/Hr'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:h.key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.key),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.firstName+' '+h.lastName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalLbs,' lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalTrees),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalHours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.totalCost),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgPerformanceIndex),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgLbsPerHour),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.avgCostPerLb),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgDensity,' lbs/tree'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgAcresPerHour));})),totals?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalLbs',harvest),' lbs'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalTrees',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalHours',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalCost',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgPerformanceIndex',harvest),' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgLbsPerHour',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgCostPerLb',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgDensity',harvest),' lbs/tree'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgAcresPerHour',harvest)))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Key'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Trees'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Cost'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Lbs / Hr'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Cost / Lb'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Density'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Acres/Hr'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:h.key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.key),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.firstName+' '+h.lastName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalLbs,' lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalTrees),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalHours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.totalCost),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgLbsPerHour),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.avgCostPerLb),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgDensity,' lbs/tree'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgAcresPerHour));})),totals?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalLbs',harvest),' lbs'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalTrees',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalHours',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalCost',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgLbsPerHour',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgCostPerLb',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgDensity',harvest),' lbs/tree'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgAcresPerHour',harvest)))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null));};/* harmony default export */ __webpack_exports__["a"] = (HarvestEmployeeTable);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
12/07/2018
Alexander Self
Mech harvest table
- Table summary of harvest: mech or hand
***************************************************************/var HarvestEquipmentTable=function HarvestEquipmentTable(_ref){var harvest=_ref.harvest,totals=_ref.totals;if(!harvest)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Key'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Containers'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Trees'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Cost'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Lbs / Hr'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Cost / Lb'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Density'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Acres/Hr'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,harvest.map(function(h){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:h.key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.key),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalContainers),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalLbs,' lbs'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalTrees),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.totalHours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.totalCost),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgLbsPerHour),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'$',h.avgCostPerLb),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgDensity,' lbs/tree'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,h.avgAcresPerHour));})),totals?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalContainers',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalLbs',harvest),' lbs'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalTrees',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalHours',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["c" /* sumProp */])('totalCost',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgLbsPerHour',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgCostPerLb',harvest)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgDensity',harvest),' lbs/tree'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__harvest_utils__["l" /* avgProp */])('avgAcresPerHour',harvest)))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',null));};/* harmony default export */ __webpack_exports__["a"] = (HarvestEquipmentTable);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestFieldSummary: Harvest metrics for field
***********************************************************/var HarvestFieldSummary=function(_Component){_inherits(HarvestFieldSummary,_Component);function HarvestFieldSummary(){_classCallCheck(this,HarvestFieldSummary);return _possibleConstructorReturn(this,(HarvestFieldSummary.__proto__||Object.getPrototypeOf(HarvestFieldSummary)).apply(this,arguments));}_createClass(HarvestFieldSummary,[{key:"render",value:function render(){var summary=this.props.query.summary;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection z-depth-1 with-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item avatar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons cyan circle"},"insert_chart"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"flow-text"},"Field Metrics"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:true},"By Field")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item harvest-collection field-metrics"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"highlight bordered responsive-table centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Field"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"$Cost per Lb"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"$Cost per Acre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Density"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Lbs per Hour"),summary.avgPerformanceIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Performance Index"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,summary.field.map(function(b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:b.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,b.key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"$",b.avgCostPerLb),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"$",b.avgCostPerAcre),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,b.avgDensity," lbs/tree"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,b.avgLbsPerHour),summary.avgPerformanceIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,b.avgPerformanceIndex):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null));})))));}}]);return HarvestFieldSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestFieldSummary);/* END */

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__harvest_info_card__ = __webpack_require__(308);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Gang View: View user created gangs(teams of employees)
***********************************************************/var HarvestIntroSummary=function(_Component){_inherits(HarvestIntroSummary,_Component);function HarvestIntroSummary(){_classCallCheck(this,HarvestIntroSummary);return _possibleConstructorReturn(this,(HarvestIntroSummary.__proto__||Object.getPrototypeOf(HarvestIntroSummary)).apply(this,arguments));}_createClass(HarvestIntroSummary,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__harvest_info_card__["a" /* default */],{header:'Total WIS Lbs',icon:'trending_up',data:this.props.query.summary.totalLbs,color:'blue-grey',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg WIS lbs/person: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.query.summary.avgTotalLbs)),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.query.summary.employee.map(function(e){return e.totalLbs;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#eceff1",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__harvest_info_card__["a" /* default */],{header:'Total Hours',icon:'hourglass_empty',data:this.props.query.summary.totalHours,color:'red',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg hours/person: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.query.summary.avgHours)),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.query.summary.employee.map(function(e){return e.totalHours;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#ffebee",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__harvest_info_card__["a" /* default */],{header:'Total Acres',icon:'terrain',data:this.props.query.summary.totalAcresCompleted,color:'green',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Acres/Hour: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.query.summary.avgAcresPerHour)),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.query.summary.employee.map(function(e){return e.avgAcresPerHour;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#e8f5e9",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__harvest_info_card__["a" /* default */],{header:'Total Cost',icon:'monetization_on',data:'$'+this.props.query.summary.totalCost,color:'blue',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Cost/lb: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'$',this.props.query.summary.avgCostPerLb)),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.query.summary.employee.map(function(e){return e.avgCostPerLb;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#e1f5fe",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})));}}]);return HarvestIntroSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestIntroSummary);/* END */

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__harvest_employee_table__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__harvest_equipment_table__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_chartjs_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestMetricsSummary: Graphs and data displayed in harvest dashboard
***********************************************************/var HarvestMetricsSummary=function(_Component){_inherits(HarvestMetricsSummary,_Component);function HarvestMetricsSummary(){_classCallCheck(this,HarvestMetricsSummary);return _possibleConstructorReturn(this,(HarvestMetricsSummary.__proto__||Object.getPrototypeOf(HarvestMetricsSummary)).apply(this,arguments));}_createClass(HarvestMetricsSummary,[{key:'render',value:function render(){var _props$query=this.props.query,summary=_props$query.summary,type=_props$query.type;var field=summary.field,block=summary.block,employee=summary.employee,equipment=summary.equipment;/* Line Chart: Lbs by field */var line_1=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* generateGraphDataAndLabels */])('totalLbs','key',field);/* Line Chart: By Block */var line_2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* generateGraphDataAndLabels */])('totalLbs','key',block);/* Doughnut Chart: Cost per field */var doughnut_1=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* generateGraphDataAndLabels */])('totalCost','key',field);var doughnut_colors=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* generateRandomColors */])(field);/* Bar Chart: Lbs by employee */var bar_1=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* generateGraphDataAndLabels */])('totalLbs','lastName',employee);/* Bubble Chart: Cost by block */var bubble_labels_1=employee.map(function(d){return d.key;});var bubble_data_1=employee.map(function(d){return{x:d.totalLbs,y:d.totalCost,r:Number(d.avgPerformanceIndex)*10};});var bubble_title='WIS Lbs, Cost, & Performance Index (Scaled)';if(type==='mech'){bubble_data_1=employee.map(function(d){return{x:d.totalLbs,y:d.totalCost,r:d.avgDensity};});bubble_title='WIS Lbs, Cost, & Density';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m8 l8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Harvest Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Bar"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["a" /* initBarChart */])({label:'WIS Lbs by Employee',labels:bar_1.labels,data:bar_1.data,backgroundColor:'#3949ab',borderColor:'#5c6bc0 ',borderWidth:1,hoverBackgroundColor:'#c5cae9',hoverBorderColor:'#303f9f'}),height:300,options:{maintainAspectRatio:false}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating btn-move-up waves-effect waves-light red accent-2 z-depth-4 right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons activator'},'filter_list')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'linechart3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Line"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["b" /* initLineChart */])({label:'WIS Lbs by Block',labels:line_2.labels,data:line_2.data,backgroundColor:'#00897b'}),height:250,options:{maintainAspectRatio:false}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Line"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["b" /* initLineChart */])({label:'WIS Lbs by Field',labels:line_1.labels,data:line_1.data,backgroundColor:'#e53935'}),height:250,options:{maintainAspectRatio:false}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-reveal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Employee Metrics',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons right'},'close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},type==='hand'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__harvest_employee_table__["a" /* default */],{harvest:employee.sort(function(a,b){return a.avgPerformanceIndex>b.avgPerformanceIndex?-1:1;}),totals:true,type:type}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__harvest_employee_table__["a" /* default */],{harvest:employee.sort(function(a,b){return Number(a.totalLbs)>Number(b.totalLbs)?-1:1;}),totals:true})),type==='mech'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Equipment Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__harvest_equipment_table__["a" /* default */],{harvest:equipment.sort(function(a,b){return Number(a.totalLbs)>Number(b.totalLbs)?-1:1;}),totals:true}))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Cost by Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Doughnut"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["n" /* initDoughnutChart */])({label:'Lbs by Field',labels:doughnut_1.labels,data:doughnut_1.data,backgroundColor:doughnut_colors})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Cost by Employee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["Bubble"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__harvest_utils__["o" /* initBubbleChart */])({label:bubble_title,labels:bubble_labels_1,data:bubble_data_1}),options:{scales:{yAxes:[{scaleLabel:{display:true,labelString:'$ Cost'}}],xAxes:[{scaleLabel:{display:true,labelString:'WIS Lbs'}}]}}})))));}}]);return HarvestMetricsSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HarvestMetricsSummary);/* END */

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_profile_actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Displays user profiles
***************************************************************/var ProfileCreate=function(_Component){_inherits(ProfileCreate,_Component);function ProfileCreate(){_classCallCheck(this,ProfileCreate);return _possibleConstructorReturn(this,(ProfileCreate.__proto__||Object.getPrototypeOf(ProfileCreate)).apply(this,arguments));}_createClass(ProfileCreate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.positionTypes.length===0)this.props.fetchPostionType();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'flow-text'},'Profile Create: ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'If an employee will be logging into the application please create a profile, then create a login.'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'profile-create-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-firstName',label:'First Name'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-lastName',label:'Last Name'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-middleInit',label:'Middle Initial'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-eid',label:'Employee ID'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Position Type'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('select',{id:'create-profile-positionType',className:'browser-default'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option',{value:''}),this.props.positionTypes.map(function(p){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('option',{key:p.positionType,value:p.positionType},p.positionType);})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-positionTitle',label:'Position Title'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'create-profile-location',label:'Location',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* PROFILE_LOCATIONS */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'trainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'checkbox',id:'create-profile-partTime'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',{htmlFor:'create-profile-partTime'},'Part-time')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'create-profile-type',label:'Type',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* TYPES */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-department',label:'Department'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-email',label:'Email'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-profile-phone',label:'Phone'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'create-profile-grade',label:'Employee Grade',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* GRADES */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'create-profile-subgrade',label:'Employee Subgrade',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SUBGRADES */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* AutoComplete */],{id:'create-profile-managerId',label:'Manager',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* onDummyComplete */]}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large waves-effect waves-light blue',type:'submit',onClick:function onClick(){return _this2.props.submitProfileToCreate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('profile-create-form'),_this2.props.employees);}},'Submit')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'flow-text'},'Login Form'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'profile-createAuth-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-login-email',label:'Email'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'create-login-eid',label:'Employee ID'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'create-login-level',label:'Employee Access Level',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* LEVELS */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["m" /* PasswordInput */],{id:'create-login-password',label:'Password'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["m" /* PasswordInput */],{id:'create-login-passwordVerify',label:'Password Verify'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large waves-effect waves-light blue',type:'submit',onClick:function onClick(){return _this2.props.submitProfileForLogin(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('profile-createAuth-form'),_this2.props.employees);}},'Submit')))));}}]);return ProfileCreate;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated,employees:state.profile.employees,positionTypes:state.misc.positionTypes};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["c" /* bindActionCreators */])({submitProfileToCreate:__WEBPACK_IMPORTED_MODULE_3__actions_profile_actions__["e" /* submitProfileToCreate */],submitProfileForLogin:__WEBPACK_IMPORTED_MODULE_3__actions_profile_actions__["f" /* submitProfileForLogin */],fetchPostionType:__WEBPACK_IMPORTED_MODULE_3__actions_profile_actions__["d" /* fetchPostionType */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ProfileCreate));/* END */

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_edit_form__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_profile_actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Edits user profiles
***************************************************************/var ProfileEdit=function(_Component){_inherits(ProfileEdit,_Component);function ProfileEdit(){_classCallCheck(this,ProfileEdit);return _possibleConstructorReturn(this,(ProfileEdit.__proto__||Object.getPrototypeOf(ProfileEdit)).apply(this,arguments));}_createClass(ProfileEdit,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.positionTypes.length===0)this.props.fetchPostionType();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'flow-text'},'Profile Edit')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["e" /* AutoComplete */],{id:'employee-profile-list',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:function onComplete(val){return _this2.props.fetchProfileToEdit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* findEmployeeByName */])(val,_this2.props.employees),_this2.props.employees);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__employee_list__["a" /* default */],{employees:this.props.employees,icon:'mode_edit',header:'View Employee',_class:'blue',onClick:function onClick(e){return _this2.props.fetchProfileToEdit(e,_this2.props.employees);},isEditOrDelete:true})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l10'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__profile_edit_form__["a" /* default */],{employees:this.props.employees,submitProfileToEdit:this.props.submitProfileToEdit,submitLoginToEdit:this.props.submitLoginToEdit,positionTypes:this.props.positionTypes,employee:this.props.employee})));}}]);return ProfileEdit;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated,user:state.auth.user,employees:state.profile.employees,positionTypes:state.misc.positionTypes,employee:state.profile.edit.employee};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux__["c" /* bindActionCreators */])({fetchProfileToEdit:__WEBPACK_IMPORTED_MODULE_4__actions_profile_actions__["a" /* fetchProfileToEdit */],submitProfileToEdit:__WEBPACK_IMPORTED_MODULE_4__actions_profile_actions__["b" /* submitProfileToEdit */],submitLoginToEdit:__WEBPACK_IMPORTED_MODULE_4__actions_profile_actions__["c" /* submitLoginToEdit */],fetchPostionType:__WEBPACK_IMPORTED_MODULE_4__actions_profile_actions__["d" /* fetchPostionType */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ProfileEdit));/* END */

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
7/19/2017
Alexander Self
Profile Edit form
- Edits user profiles
***************************************************************/var ProfileEditForm=function(_Component){_inherits(ProfileEditForm,_Component);function ProfileEditForm(){_classCallCheck(this,ProfileEditForm);return _possibleConstructorReturn(this,(ProfileEditForm.__proto__||Object.getPrototypeOf(ProfileEditForm)).apply(this,arguments));}_createClass(ProfileEditForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('form',{id:'profile-edit-form',onSubmit:function onSubmit(e){return e.preventDefault();},encType:'multipart/form-data'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-firstName',label:'First Name'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-lastName',label:'Last Name'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-middleInit',label:'Middle Initial'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-eid',label:'Employee ID'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',null,'Position Type'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('select',{id:'edit-profile-positionType',className:'browser-default'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('option',{value:''}),this.props.positionTypes.map(function(p){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('option',{key:p.positionType,value:p.positionType},p.positionType);})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-positionTitle',label:'Position Title'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-profile-location',label:'Location',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* PROFILE_LOCATIONS */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',{className:'trainer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input',{type:'checkbox',id:'edit-profile-partTime'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',{htmlFor:'edit-profile-partTime'},'Part-time')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-profile-type',label:'Type',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* TYPES */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-department',label:'Department'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-email',label:'Email'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-profile-phone',label:'Phone'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-profile-grade',label:'Employee Grade',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* GRADES */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-profile-subgrade',label:'Employee Subgrade',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SUBGRADES */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-profile-employeeStatus',label:'Employee Status',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* EMPLOYEE_STATUS */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* AutoComplete */],{id:'edit-profile-managerId',label:'Manager',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* onDummyComplete */]}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btn btn-large waves-effect waves-light blue',type:'submit',onClick:function onClick(){return _this2.props.submitProfileToEdit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('profile-edit-form'),_this2.props.employees,_this2.props.employee);}},'Submit')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',{className:'flow-text'},'Login Form'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('form',{id:'profile-editAuth-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-login-email',label:'Email'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-login-eid',label:'Employee ID'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-login-level',label:'Employee Access Level',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* LEVELS */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["m" /* PasswordInput */],{id:'edit-login-password',label:'Password'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["m" /* PasswordInput */],{id:'edit-login-passwordVerify',label:'Password Verify'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btn btn-large waves-effect waves-light blue',type:'submit',onClick:function onClick(){return _this2.props.submitLoginToEdit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('profile-editAuth-form'),_this2.props.employee);}},'Submit')))));}}]);return ProfileEditForm;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProfileEditForm);/* END */

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
8/10/2017
Alexander Self
EmployeeInfoCard: Information about an employee in a card

***************************************************************/var EmployeeInfoCard=function EmployeeInfoCard(_ref){var employee=_ref.employee;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card z-depth-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12 l12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Location: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.location==='60'?employee.location+" - California":employee.location==='70'?employee.location+" - Admin":employee.location==='71'?employee.location+" - Ka'u":employee.location==='72'?employee.location+" - Kea'au":employee.location==='92'?employee.location+" - Hilo":''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Type: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.type))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Position Type: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.positionType," ",employee.partTime?'- Part-time':''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Status: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.employeeStatus==='Active'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"employee-active right-align"},employee.employeeStatus):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"employee-inactive right-align"},employee.employeeStatus)))),employee.grade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Grade: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.grade))):'',employee.subgrade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Subgrade: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.subgrade))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Phone: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,employee.phone?employee.phone:employee.mobilePhone?employee.mobilePhone:'N/A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item"},"Email: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:"+employee.email},employee.email)))))))));};/* harmony default export */ __webpack_exports__["a"] = (EmployeeInfoCard);/* END */

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_user_profile_bg_jpg__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_user_profile_bg_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_user_profile_bg_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_user_fa_png__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_user_fa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_user_fa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/****************************************************************
Alexander Self
3/30/20

****************************************************************/var ContentHeader=function ContentHeader(_ref){var employee=_ref.employee,employees=_ref.employees,fetchEmployeeProfileByName=_ref.fetchEmployeeProfileByName;var hireDate=__WEBPACK_IMPORTED_MODULE_1_moment___default()(employee.hireDate).toNow().split(' ');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'field-page-header',className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image waves-effect waves-block waves-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'activator',src:__WEBPACK_IMPORTED_MODULE_2__img_user_profile_bg_jpg___default.a,alt:'background'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'hide-on-small-only card-profile-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__img_user_fa_png___default.a,className:'circle z-depth-2 responsive-img activator',alt:'profile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,employee.eid))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide-on-small-only card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s3 offset-s2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},employee.firstName,' ',employee.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},employee.positionTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},hireDate?hireDate[1]+'+ '+hireDate[2]:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Work Experience')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},employee.department),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Department')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4 hoverable pointer',onClick:function onClick(){return fetchEmployeeProfileByName(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* findEmployeeByName */])(employee.manager.firstName+' '+employee.manager.lastName,employees));}},employee.manager?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,employee.manager.firstName,' ',employee.manager.lastName):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Manager')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s1 right-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating activator waves-effect waves-light amber darken-2 right field-clickview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'assessment'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'show-on-small hide-on-med-and-up'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},employee.firstName,' ',employee.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},employee.positionTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},hireDate?hireDate[1]+'+ '+hireDate[2]:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Work Experience')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},employee.department),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Department')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 center-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title grey-text text-darken-4'},employee.manager?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,employee.manager.firstName,' ',employee.manager.lastName):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-small grey-text'},'Manager')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s11 right-align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating activator waves-effect waves-light pink darken-2 right field-clickview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'assessment'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-reveal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},employee.firstName,' ',employee.lastName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons right'},'close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan-text'},'perm_identity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-1'},employee.positionTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan-text'},'description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-1'},employee.positionType,', ',employee.grade?'Grade '+employee.grade:'',' ',employee.subgrade?employee.subgrade:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan-text'},'perm_phone_msg'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-1'},employee.phone?employee.phone:employee.mobilePhone?employee.mobilePhone:'N/A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan-text'},'email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-1'},employee.email?employee.email:'N/A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan-text'},'location_on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-1'},employee.location==='60'?employee.location+' - California':employee.location==='70'?employee.location+' - Admin':employee.location==='71'?employee.location+' - Ka\'u':employee.location==='72'?employee.location+' - Kea\'au':employee.location==='92'?employee.location+' - Hilo':'N/A')))));};/* harmony default export */ __webpack_exports__["a"] = (ContentHeader);/* END */

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/***************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/31/20
Profile Card
- Displays simple information about a user
***************************************************************/var ProfileCard=function ProfileCard(_ref){var employee=_ref.employee;if(!employee.eid)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card light-blue',id:'lastVisited'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content white-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title'},'About Me!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I started with the company on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(employee.hireDate).format("dddd, MMMM Do YYYY")),'. I am a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,employee.type==='SAL'?'salaried':'hourly',' ',employee.positionType),' employee','\xA0','and work in the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,employee.department),' department.')));};/* harmony default export */ __webpack_exports__["a"] = (ProfileCard);/* END */

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_user_jpg__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_user_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_user_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/***************************************************************
Hawaiian Macadamia Nut Services
4/1/20
Alexander Self
Profile Tabs
***************************************************************/var $=window.$;var List=function List(_ref){var stats=_ref.stats,prop1=_ref.prop1,prop2=_ref.prop2,header=_ref.header,color=_ref.color,borderColor=_ref.borderColor,headerColor=_ref.headerColor;var cardHeader={color:''+color,textAlign:"center",fontSize:"14px",fontWeight:600,borderBottom:'1px solid '+borderColor,backgroundColor:''+headerColor,padding:"5px 10px"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection with-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:cardHeader,className:'collection-header'},header),stats.map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item',key:Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,s[prop1]),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right-align'},s[prop2],' hours'));})));};var ProfileTabs=function ProfileTabs(_ref2){var employee=_ref2.employee,employees=_ref2.employees,fetchEmployeeProfileByName=_ref2.fetchEmployeeProfileByName,stats=_ref2.stats;$(document).ready(function(){$('.tabs').tabs();$('#stats-bio-collapsible').collapsible();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tabs light-blue z-depth-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'white-text',href:'#statsBio'},'Stats Bio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'white-text',href:'#trainingAndSkills'},'Training and Skills')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'white-text',href:'#managedEmployees'},'Managed Employees')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'statsBio',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'stats-bio-collapsible',className:'collapsible'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:'green'},className:'material-icons'},'eco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{color:'green'}},'Harvest')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,{stats:stats.harvest.harvestHours,prop1:'field',prop2:'totalHours',header:'Harvest Hours Per Field',color:'green',borderColor:'green',headerColor:'#e8f5e9'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:'blue'},className:'material-icons'},'local_shipping'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{color:'blue'}},'Equipment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,{stats:stats.equipment.equipmentHours,prop1:'equipmentNo',prop2:'totalHours',header:'Equipment Hours Per Machine',color:'blue',borderColor:'blue',headerColor:'#e1f5fe'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:'red'},className:'material-icons'},'insert_chart'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{color:'red'}},'Cost Centers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,{stats:stats.costCenter.costCenterHours,prop1:'costCenterCode',prop2:'totalHours',header:'Cost Center Hours',color:'red',borderColor:'red',headerColor:'#ffebee'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'trainingAndSkills',className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 user-list'},employee.monchiero?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card__["a" /* default */],{header:'Monchiero',icon:'eco',desc:'Qualified',color:'green',borderColor:'green',headerColor:'#e8f5e9',id:'monchiero-profile',width:"250px"}):'',employee.cdl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card__["a" /* default */],{header:"Commercial Driver's License (CDL)",icon:'local_shipping',desc:'Qualified',color:'blue',borderColor:'blue',headerColor:'#e1f5fe',id:'cdl-profile',width:"250px"}):'',employee.equipMastery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card__["a" /* default */],{header:"Equipment Mastery",icon:'transform',desc:'Qualified',color:'amber',borderColor:'amber',headerColor:'#fff8e1',id:'cdl-equipMastery',width:"250px"}):'',employee.equipSpecial>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card__["a" /* default */],{header:"Equipment Specialization",icon:'memory',desc:'Qualified: '+employee.equipSpecial+' types',color:'red',borderColor:'red',headerColor:'#ffebee',id:'cdl-equipSpecial',width:"250px"}):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'managedEmployees',className:'col s12'},employee.managedEmployees.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection z-depth-1 hoverable managed-list'},employee.managedEmployees.filter(function(e){return e.employeeStatus==='Active';}).map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:e.eid,className:'collection-item avatar pointer',onClick:function onClick(){return fetchEmployeeProfileByName(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* findEmployeeByName */])(e.firstName+' '+e.lastName,employees));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__img_user_jpg___default.a,className:'circle',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title'},e.firstName,' ',e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'grey-text text-darken-2'},e.positionTitle,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),e.department));})):'No Managed Employees'));};/* harmony default export */ __webpack_exports__["a"] = (ProfileTabs);/* END */

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__employeeInfoCard__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_card__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__employee_content_header__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profile_tabs__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
5/22/2017
Alexander Self
Profile View
- Displays user profiles
***************************************************************/var ProfileView=function(_Component){_inherits(ProfileView,_Component);function ProfileView(){_classCallCheck(this,ProfileView);return _possibleConstructorReturn(this,(ProfileView.__proto__||Object.getPrototypeOf(ProfileView)).apply(this,arguments));}_createClass(ProfileView,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["e" /* AutoComplete */],{id:'employee-profile-list',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* onDummyComplete */]}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.fetchEmployeeProfileByName(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* findEmployeeByName */])(document.getElementById('employee-profile-list').value,_this2.props.employees));},className:'btn waves-light waves-effect'},'Fetch'),'\xA0','\xA0','\xA0','\xA0','\xA0',__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('button',{className:'btn-flat small',onClick:this.props.downloadEmployees},'Download'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__employee_list__["a" /* default */],{employees:this.props.employees.filter(function(e){return e.employeeStatus==='Active';}),icon:'person',header:'View Employee',_class:'green',onClick:function onClick(e){return _this2.props.fetchEmployeeProfile(e);},isEditOrDelete:true}))),' ',__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'col s12 m12 l10'},this.props.selectedEmployee.eid?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__employee_content_header__["a" /* default */],{employee:this.props.selectedEmployee,employees:this.props.employees,fetchEmployeeProfileByName:this.props.fetchEmployeeProfileByName}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__profile_card__["a" /* default */],{employee:this.props.selectedEmployee}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__employeeInfoCard__["a" /* default */],{employee:this.props.selectedEmployee})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'col s12 m8 l8 xl8'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__profile_tabs__["a" /* default */],{employee:this.props.selectedEmployee,employees:this.props.employees,fetchEmployeeProfileByName:this.props.fetchEmployeeProfileByName,stats:this.props.stats}))):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null))));}}]);return ProfileView;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user,employees:state.profile.employees,selectedEmployee:state.profile.view.selectedEmployee,stats:state.profile.view.selectedEmployee.stats};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux__["c" /* bindActionCreators */])({fetchEmployeeProfile:__WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__["g" /* fetchEmployeeProfile */],fetchEmployeeProfileByName:__WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__["h" /* fetchEmployeeProfileByName */],uploadProfileImage:__WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__["i" /* uploadProfileImage */],downloadEmployees:__WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__["j" /* downloadEmployees */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ProfileView));/* END */

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/***********************************************************************
Alexander Self
8/23/17
Gang Create form: Basic inline form that describes a form
***********************************************************************/var TeamBuilderForm=function TeamBuilderForm(_ref){var onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["g" /* NumberInput */],{id:'gang-builder-No',label:'Team No.',step:"1.0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["a" /* Select */],{id:'gang-builder-location',opts:__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* LOCATIONS */],label:'Team Location'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gang-create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-light waves-effect',onClick:onClick},'Create'))));};/* harmony default export */ __webpack_exports__["a"] = (TeamBuilderForm);/* END */

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_team_actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__employee_table__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_builder_form__ = __webpack_require__(326);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Alexander Self
8/22/17
Gang Create: Create gangs(teams of employees)
***********************************************************/var GangCreate=function(_Component){_inherits(GangCreate,_Component);function GangCreate(){_classCallCheck(this,GangCreate);return _possibleConstructorReturn(this,(GangCreate.__proto__||Object.getPrototypeOf(GangCreate)).apply(this,arguments));}_createClass(GangCreate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Team Create')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs__["e" /* AutoComplete */],{id:'employee-gang-builder',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:function onComplete(val,id){return _this2.props.gangAutocomplete(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* findEmployeeByName */])(val,_this2.props.employees),id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__employee_list__["a" /* default */],{employees:this.props.employees,icon:'person_add',header:'Add Employees',onClick:function onClick(e){return _this2.props.addGangMember(e);},_class:'green',isEditOrDelete:true}))),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l10 xl10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__team_builder_form__["a" /* default */],{onClick:function onClick(){return _this2.props.createGang(_this2.props.gangMembers,_this2.props.gangs);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row scrollable'},'Team Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.count),this.props.gangMembers.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__employee_table__["a" /* default */],{employees:this.props.gangMembers,onClick:this.props.removeGangMember}):'')));}}]);return GangCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{employees:state.gang.employees,gangMembers:state.gang.create.gangMembers,count:state.gang.create.count,gangs:state.gang.gangs};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({addGangMember:__WEBPACK_IMPORTED_MODULE_4__actions_team_actions__["i" /* addGangMember */],removeGangMember:__WEBPACK_IMPORTED_MODULE_4__actions_team_actions__["j" /* removeGangMember */],gangAutocomplete:__WEBPACK_IMPORTED_MODULE_4__actions_team_actions__["k" /* gangAutocomplete */],createGang:__WEBPACK_IMPORTED_MODULE_4__actions_team_actions__["l" /* createGang */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GangCreate));/* END */

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_team_actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_team_list__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__employee_table__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Alexander Self
8/22/17
Gang View: View user created gangs(teams of employees)
***********************************************************/var TeamDelete=function(_Component){_inherits(TeamDelete,_Component);function TeamDelete(){_classCallCheck(this,TeamDelete);return _possibleConstructorReturn(this,(TeamDelete.__proto__||Object.getPrototypeOf(TeamDelete)).apply(this,arguments));}_createClass(TeamDelete,[{key:'componentDidMount',value:function componentDidMount(){return this.props.fetchGangs();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Team Delete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__view_team_list__["a" /* default */],{gangs:this.props.gangs,onClick:this.props.selectGang})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l9 xl9'},this.props.selectedGang.emps.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},'Team No: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},'Team Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangLoc===71?this.props.selectedGang.gangLoc+' - Ka\'u':this.props.selectedGang.gangLoc+' - Kea\'au')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},'Team Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.deleteGang(_this2.props.selectedGang);},className:'btn waves-effect waves-light red'},'Delete'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollable'},this.props.selectedGang.emps.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__employee_table__["a" /* default */],{employees:this.props.selectedGang.emps,noClick:true}):''))));}}]);return TeamDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{gangs:state.gang.gangs,selectedGang:state.gang.selectedGang};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchGangs:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["a" /* fetchGangs */],selectGang:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["b" /* selectGang */],deleteGang:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["c" /* deleteGang */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TeamDelete));/* END */

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_team_actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_team_list__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__employee_table__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Alexander Self
8/22/17
Gang Edit: Edit user created gangs(teams of employees)
***********************************************************/var $=window.$;var TeamEdit=function(_Component){_inherits(TeamEdit,_Component);function TeamEdit(props){_classCallCheck(this,TeamEdit);var _this=_possibleConstructorReturn(this,(TeamEdit.__proto__||Object.getPrototypeOf(TeamEdit)).call(this,props));_this.state={gangId:0,gangLoc:71};return _this;}_createClass(TeamEdit,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('.gang-edit-collapsible').collapsible();});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){var _this2=this;var gangId=parseInt(newProps.selectedGang.gangId,10);var gangLoc=newProps.selectedGang.gangLoc;if(gangId&&gangLoc){this.setState({gangId:gangId,gangLoc:gangLoc},function(){document.getElementById('edit-gang-builder-gangId').value=_this2.state.gangId;document.getElementById('edit-gang-builder-gangLoc').value=_this2.state.gangLoc;});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Team Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collapsible gang-edit-collapsible','data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'group'),'Teams'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__view_team_list__["a" /* default */],{gangs:this.props.gangs,onClick:this.props.selectGangToEdit}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'person'),'Employees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["e" /* AutoComplete */],{id:'employee-gang-edit',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:function onComplete(val,id){return _this3.props.gangEditAutocomplete(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* findEmployeeByName */])(val,_this3.props.employees),id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__employee_list__["a" /* default */],{employees:this.props.employees,icon:'person_add',header:'Add Employees',onClick:function onClick(e){return _this3.props.addGangMemberToEdit(e,_this3.props.selectedGang);},_class:'green'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l9 xl9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["g" /* NumberInput */],{id:'edit-gang-builder-gangId',label:'Team No.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["a" /* Select */],{id:'edit-gang-builder-gangLoc',opts:__WEBPACK_IMPORTED_MODULE_9__constants__["e" /* LOCATIONS */],label:'Team Location'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gang-create'},'Team Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangCount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect waves-light blue',onClick:function onClick(){return _this3.props.editGang(_this3.props.editedGang);}},'Edit Team')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollable-edit'},this.props.selectedGang.emps.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__employee_table__["a" /* default */],{employees:this.props.selectedGang.emps,onClick:this.props.removeGangMemberFromEdit}):''))));}}]);return TeamEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{employees:state.gang.employees,gangs:state.gang.gangs,selectedGang:state.gang.edit.selectedGang,editedGang:state.gang.edit};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({selectGangToEdit:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["d" /* selectGangToEdit */],removeGangMemberFromEdit:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["e" /* removeGangMemberFromEdit */],addGangMemberToEdit:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["f" /* addGangMemberToEdit */],gangEditAutocomplete:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["g" /* gangEditAutocomplete */],editGang:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["h" /* editGang */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TeamEdit));/* END */

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_team_actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_list__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__employee_table__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Alexander Self
8/22/17
Gang View: View user created gangs(teams of employees)
***********************************************************/var GangView=function(_Component){_inherits(GangView,_Component);function GangView(){_classCallCheck(this,GangView);return _possibleConstructorReturn(this,(GangView.__proto__||Object.getPrototypeOf(GangView)).apply(this,arguments));}_createClass(GangView,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchGangs();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Team View')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__team_list__["a" /* default */],{gangs:this.props.gangs,onClick:this.props.selectGang})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l9 xl9'},this.props.selectedGang.emps.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},'Team No: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},'Team Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangLoc===71?this.props.selectedGang.gangLoc+' - Ka\'u':this.props.selectedGang.gangLoc+' - Kea\'au')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},'Team Count: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.selectedGang.gangCount))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollable'},this.props.selectedGang.emps.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__employee_table__["a" /* default */],{employees:this.props.selectedGang.emps,noClick:true}):''))));}}]);return GangView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{gangs:state.gang.gangs,selectedGang:state.gang.selectedGang};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchGangs:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["a" /* fetchGangs */],selectGang:__WEBPACK_IMPORTED_MODULE_3__actions_team_actions__["b" /* selectGang */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GangView));/* END */

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
5/23/2017
Alexander Self
add_work_table.js
- Table that maintains a list of work performed;
  work added from secontaryTS
***************************************************************/var WorkTable=function WorkTable(_ref){var work=_ref.work,removeWork=_ref.removeWork,editWork=_ref.editWork;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Grade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Work'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cost Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub Account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Equip No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Paycode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,work.map(function(w,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:''+w.workPerformed+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.tempGrade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.workPerformed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.costCenterCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.subAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.equipmentNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.paycode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return editWork(w);},className:'btn-floating waves-effect waves-light blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return removeWork(w.workId);},className:'btn-floating waves-effect waves-light red'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Total Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* totalHours */])(work)))))));};/* harmony default export */ __webpack_exports__["a"] = (WorkTable);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of gang timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/var GangFormAutoFill=function GangFormAutoFill(_ref){var id=_ref.id,fields=_ref.fields,blocks=_ref.blocks,autoFillGangTimesheet=_ref.autoFillGangTimesheet,fetchBlocksByField=_ref.fetchBlocksByField;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'autofill-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["a" /* Select */],{id:'autofill-count',label:'Input Count',opts:[{val:1,label:1},{val:2,label:2},{val:3,label:3},{val:4,label:4},{val:5,label:5}]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["g" /* NumberInput */],{id:'autofill-hours',min:"0",max:"8",step:'0.1',label:'Hours'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["g" /* NumberInput */],{id:'autofill-trees',min:"0",max:"75",step:'0.1',label:'Trees'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["g" /* NumberInput */],{id:'autofill-bags',min:"0",max:"25",step:'0.1',label:'Bags'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["i" /* SelectField */],{id:'autofill-field',label:'Field',opts:fields,onChange:function onChange(event){return fetchBlocksByField(event.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["j" /* SelectBlock */],{id:'autofill-block',label:'Block',opts:blocks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-light waves-effect',onClick:function onClick(){return autoFillGangTimesheet(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('autofill-form'));}},'Auto-Fill')))));};/* harmony default export */ __webpack_exports__["a"] = (GangFormAutoFill);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
5/23/2017
Alexander Self
add_work_table.js
- Table that maintains a list of work performed;
  work added from secontaryTS
***************************************************************/var GangWorkTable=function GangWorkTable(_ref){var work=_ref.work,removeWork=_ref.removeWork,editWork=_ref.editWork;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Work'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cost Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub Account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,work.map(function(w,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:''+w.workPerformed+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.workPerformed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.costCenterCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.subAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return editWork(w);},className:'btn-floating waves-effect waves-light blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return removeWork(w.workId);},className:'btn-floating waves-effect waves-light red'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Total Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* totalHours */])(work)))))));};/* harmony default export */ __webpack_exports__["a"] = (GangWorkTable);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timesheet_form__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timesheet_individual_modal__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__timesheet_gang_form__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_gang_list__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gang_autofill_form__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Creates timesheets for employees; includes individual timesheet
  and gang timesheet
***************************************************************/var $=window.$;/* Pass all state and actions to this component */var TimesheetCreate=function TimesheetCreate(_ref){var user=_ref.user,employees=_ref.employees,myEmployees=_ref.myEmployees,addedEmployees=_ref.addedEmployees,fields=_ref.fields,blocks=_ref.blocks,costCenters=_ref.costCenters,details=_ref.details,equipmentNo=_ref.equipmentNo,equipmentTrailerNo=_ref.equipmentTrailerNo,subAccounts=_ref.subAccounts,paycodes=_ref.paycodes,submitter=_ref.submitter,workPerformed=_ref.workPerformed,addedGangEmployees=_ref.addedGangEmployees,empTimesheet=_ref.empTimesheet,gangTS=_ref.gangTS,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,prevPPStartDate=_ref.prevPPStartDate,prevPPEndDate=_ref.prevPPEndDate,gangWorkPerformed=_ref.gangWorkPerformed,addEmployee=_ref.addEmployee,removeEmployee=_ref.removeEmployee,addWork=_ref.addWork,editWork=_ref.editWork,removeWork=_ref.removeWork,addEmployeeToGang=_ref.addEmployeeToGang,removeEmployeeFromGang=_ref.removeEmployeeFromGang,prepareRegTS=_ref.prepareRegTS,prepareGangTS=_ref.prepareGangTS,submitRegTimesheet=_ref.submitRegTimesheet,submitGangTimesheet=_ref.submitGangTimesheet,employeeAutocomplete=_ref.employeeAutocomplete,fetchSubAccounts=_ref.fetchSubAccounts,fetchFieldsByLoc=_ref.fetchFieldsByLoc,gangs=_ref.gangs,selectGangForTimesheet=_ref.selectGangForTimesheet,selectGangForGangTimesheet=_ref.selectGangForGangTimesheet,fetchBlocksByField=_ref.fetchBlocksByField,addNewGangInfoRow=_ref.addNewGangInfoRow,addedGangInfoRow=_ref.addedGangInfoRow,selectCostCenterByLocation=_ref.selectCostCenterByLocation,editWorkRecord=_ref.editWorkRecord,addWorkToGangTimesheet=_ref.addWorkToGangTimesheet,editGangWorkRecord=_ref.editGangWorkRecord,editGangWorkInTimesheet=_ref.editGangWorkInTimesheet,deleteWorkInGangTimesheet=_ref.deleteWorkInGangTimesheet,autoFillGangTimesheet=_ref.autoFillGangTimesheet;$(document).ready(function(){$('#ts-choice').tabs();$('.timesheet-collapsible').collapsible();});return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span',{className:'flow-text'},'Create Timesheet')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('ul',{id:'ts-choice',className:'tabs tabs-fixed-width'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('a',{href:'#individual-ts'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'person'),'  Individual Timesheet')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('a',{href:'#gang-ts'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'group'),'  Team Timesheet'))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{id:'individual-ts'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12 m12 l2 xl2'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('ul',{className:'collapsible timesheet-collapsible','data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'person'),'Employee'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["e" /* AutoComplete */],{id:'employee-reg-ts-list',label:'Employee Timesheets',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapEmployeeForAutoComplete */])(employees),onComplete:function onComplete(val,id){return employeeAutocomplete(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* findEmployeeByName */])(val,employees),id);}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__employee_list__["a" /* default */],{employees:myEmployees,icon:'person_add',header:'Add Employees',onClick:addEmployee,_class:'green'}))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'group'),'Teams'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__general_gang_list__["a" /* default */],{gangs:gangs,id:'timesheet-gang-list',onClick:selectGangForTimesheet}))))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12 m12 l8 xl8'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__timesheet_form__["a" /* default */],{fields:fields,blocks:blocks,details:details,workPerformed:workPerformed,payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate,user:user,paycodes:paycodes,addWork:addWork,editWork:editWork,removeWork:removeWork,costCenters:costCenters,equipmentNo:equipmentNo,equipmentTrailerNo:equipmentTrailerNo,subAccounts:subAccounts,fetchSubAccounts:fetchSubAccounts,fetchFieldsByLoc:fetchFieldsByLoc,fetchBlocksByField:fetchBlocksByField,selectCostCenterByLocation:selectCostCenterByLocation,editWorkRecord:editWorkRecord})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'emp-list-2'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__employee_list__["a" /* default */],{employees:addedEmployees,icon:'clear',_class:'red',header:'Employees Timesheet',onClick:removeEmployee,isEditOrDelete:true}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__timesheet_individual_modal__["a" /* default */],{id:'individual-ts-modal',timesheet:empTimesheet,employees:addedEmployees,workPerformed:workPerformed,submitRegTimesheet:submitRegTimesheet,payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate,user:user}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('button',{'data-target':'individual-ts-modal',className:'btn waves-light waves-effect',onClick:function onClick(){return prepareRegTS(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* packageForm */])('basic-ts-form'),workPerformed,submitter);}},'Prepare'))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12',id:'gang-ts'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('ul',{className:'collapsible timesheet-collapsible','data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'person'),'Employee'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["e" /* AutoComplete */],{id:'employee-gang-ts-list',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapEmployeeForAutoComplete */])(employees),onComplete:function onComplete(val,id){return employeeAutocomplete(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* findEmployeeByName */])(val,employees),id);}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__employee_list__["a" /* default */],{employees:myEmployees,icon:'person_add',header:'Add Employees',onClick:addEmployeeToGang,_class:'green'}))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'group'),'Teams'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__general_gang_list__["a" /* default */],{gangs:gangs,id:'timesheet-gang-list2',onClick:selectGangForGangTimesheet}))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i',{className:'material-icons'},'cached'),'Form Auto-Fill'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__gang_autofill_form__["a" /* default */],{fields:fields,blocks:blocks,autoFillGangTimesheet:autoFillGangTimesheet,fetchBlocksByField:fetchBlocksByField}))))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'col s12 m12 l10'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__timesheet_gang_form__["a" /* default */],{addedGangEmployees:addedGangEmployees,addEmployeeToGang:addEmployeeToGang,removeEmployeeFromGang:removeEmployeeFromGang,prepareGangTS:prepareGangTS,submitter:submitter,gangTS:gangTS,submitGangTimesheet:submitGangTimesheet,payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate,fields:fields,blocks:blocks,paycodes:paycodes,fetchFieldsByLoc:fetchFieldsByLoc,fetchBlocksByField:fetchBlocksByField,addNewGangInfoRow:addNewGangInfoRow,addedGangInfoRow:addedGangInfoRow,fetchSubAccounts:fetchSubAccounts,costCenters:costCenters,subAccounts:subAccounts,addWorkToGangTimesheet:addWorkToGangTimesheet,gangWorkPerformed:gangWorkPerformed,editGangWorkRecord:editGangWorkRecord,editGangWorkInTimesheet:editGangWorkInTimesheet,deleteWorkInGangTimesheet:deleteWorkInGangTimesheet,selectCostCenterByLocation:selectCostCenterByLocation,user:user})))));};function mapStateToProps(state){return{addedEmployees:state.timesheet.addedEmployees,addedGangEmployees:state.timesheet.gangTS.addedGangEmployees,addedGangInfoRow:state.timesheet.gangTS.addedGangInfoRow,blocks:state.timesheet.blocks,costCenters:state.timesheet.costCenters.displaying,details:state.timesheet.details.displaying,employees:state.timesheet.employees,empTimesheet:state.timesheet.employeeTS,equipmentNo:state.equipment.equipmentNo,equipmentTrailerNo:state.equipment.equipmentTrailerNo,fields:state.timesheet.fields,gangs:state.gang.gangs,gangTS:state.timesheet.gangTS.timesheet,gangWorkPerformed:state.timesheet.gangTS.gangWorkPerformed,myEmployees:state.timesheet.myEmployees,paycodes:state.timesheet.paycodes,payPeriodStartDate:state.misc.payPeriod.startDate,payPeriodEndDate:state.misc.payPeriod.endDate,prevPPStartDate:state.misc.prevPP.startDate,prevPPEndDate:state.misc.prevPP.endDate,subAccounts:state.timesheet.subAccounts,submitter:state.auth.user.guid,user:state.auth.user,workPerformed:state.timesheet.employeeTS.secondaryTS.workPerformed};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* bindActionCreators */])({addEmployee:__WEBPACK_IMPORTED_MODULE_2__actions__["addEmployeeToTimesheet"],removeEmployee:__WEBPACK_IMPORTED_MODULE_2__actions__["removeEmployeeFromTimesheet"],addWork:__WEBPACK_IMPORTED_MODULE_2__actions__["addWorkToTimesheet"],editWork:__WEBPACK_IMPORTED_MODULE_2__actions__["editWorkInTimesheet"],removeWork:__WEBPACK_IMPORTED_MODULE_2__actions__["removeWorkFromTimesheet"],addEmployeeToGang:__WEBPACK_IMPORTED_MODULE_2__actions__["addEmployeeToGangTS"],removeEmployeeFromGang:__WEBPACK_IMPORTED_MODULE_2__actions__["removeEmployeeFromGangTS"],submitRegTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["submitRegTimesheet"],submitGangTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["submitGangTimesheet"],employeeAutocomplete:__WEBPACK_IMPORTED_MODULE_2__actions__["employeeAutocomplete"],editWorkRecord:__WEBPACK_IMPORTED_MODULE_2__actions__["editWorkRecord"],fetchFieldsByLoc:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchFieldsByLoc"],fetchSubAccounts:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchSubAccounts"],fetchBlocksByField:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchBlocksByField"],selectGangForTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["selectGangForTimesheet"],selectGangForGangTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["selectGangForGangTimesheet"],addNewGangInfoRow:__WEBPACK_IMPORTED_MODULE_2__actions__["addNewGangInfoRow"],selectCostCenterByLocation:__WEBPACK_IMPORTED_MODULE_2__actions__["selectCostCenterByLocation"],addWorkToGangTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["addWorkToGangTimesheet"],editGangWorkRecord:__WEBPACK_IMPORTED_MODULE_2__actions__["editGangWorkRecord"],editGangWorkInTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["editGangWorkInTimesheet"],deleteWorkInGangTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["deleteWorkInGangTimesheet"],autoFillGangTimesheet:__WEBPACK_IMPORTED_MODULE_2__actions__["autoFillGangTimesheet"],prepareRegTS:__WEBPACK_IMPORTED_MODULE_2__actions__["prepareRegTS"],prepareGangTS:__WEBPACK_IMPORTED_MODULE_2__actions__["prepareGangTS"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TimesheetCreate));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add_work_table__ = __webpack_require__(331);
/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Timesheet form
12.6.21: Added paycodes
***************************************************************/var $=window.$;var TimesheetForm=function TimesheetForm(_ref){var fields=_ref.fields,blocks=_ref.blocks,costCenters=_ref.costCenters,details=_ref.details,equipmentNo=_ref.equipmentNo,equipmentTrailerNo=_ref.equipmentTrailerNo,subAccounts=_ref.subAccounts,paycodes=_ref.paycodes,user=_ref.user,workPerformed=_ref.workPerformed,addWork=_ref.addWork,editWork=_ref.editWork,removeWork=_ref.removeWork,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,fetchSubAccounts=_ref.fetchSubAccounts,fetchFieldsByLoc=_ref.fetchFieldsByLoc,fetchBlocksByField=_ref.fetchBlocksByField,selectCostCenterByLocation=_ref.selectCostCenterByLocation,editWorkRecord=_ref.editWorkRecord,prevPPStartDate=_ref.prevPPStartDate,prevPPEndDate=_ref.prevPPEndDate;function packageWorkPerformed(callback){// handles form checks: hours=0.00, workPerformed != '', paycode > 13 no hours, etc
var _handleWorkPerformed=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* handleWorkPerformed */])(),hours=_handleWorkPerformed.hours,trainer=_handleWorkPerformed.trainer,check=_handleWorkPerformed.check;if(!check)return;// Make sure employees select the full equipment no with description
var equipCheck=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* handleEquipmentNo */])('equipmentNo',equipmentNo);if(!equipCheck)return;callback({workId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* generateGUID */])(),tempGrade:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('tempGrade'),costCenterCode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('costCenterCode'),subAccount:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('subAccount'),paycode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('paycode'),field:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('field'),block:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('block'),equipmentNo:document.getElementById('equipmentNo').value,equipmentTrailerNo:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('equipmentTrailerNo'),differential:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('differential'),workPerformed:$.trim(document.getElementById('workPerformed').value),detail:document.getElementById('detail').value,hours:hours,trainer:trainer});document.getElementById("second-ts-form").reset();}/* Cap dates after 10am for new PP */var startDate=void 0;var lastDay=__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');// Proposed 9.3.21 to change to 5 days instead of 3 for retroactive submission
var lastDayForAdmins=__WEBPACK_IMPORTED_MODULE_1_moment___default()(prevPPEndDate).add(5,'days').format('YYYY-MM-DD');if(lastDay===payPeriodStartDate&&__WEBPACK_IMPORTED_MODULE_1_moment___default()().hour()<10)startDate=prevPPStartDate;else startDate=payPeriodStartDate;if(lastDayForAdmins>=lastDay&&user.level===4)startDate=prevPPStartDate;// If nec. to create timesheets beyond end of pp
//startDate = moment(prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'basic-ts-form',className:'form-rerender'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["d" /* DatePicker2 */],{id:'date',label:'Date',min:startDate,max:payPeriodEndDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'location',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){fetchFieldsByLoc(e.target.value);selectCostCenterByLocation(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:'regGangNo',label:'Team No.'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["o" /* TimePicker2 */],{id:'startTime',label:'Start Time',defaultValue:'07:00'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["o" /* TimePicker2 */],{id:'endTime',label:'End Time',defaultValue:'15:30'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4 xl4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'shift',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* SHIFTS */],label:'Shift'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'dustPay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'dustPay'},'Dust Pay')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'flow-text'},'Individual Work Form')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'second-ts-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'tempGrade',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["l" /* GRADES */],label:'Temp Grade'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["p" /* SelectCostCenter */],{id:'costCenterCode',opts:costCenters,label:'Cost Center',onChange:function onChange(e){return fetchSubAccounts(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["q" /* SelectSubAccount */],{id:'subAccount',opts:subAccounts,label:'Sub Account',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["w" /* setCCSubInWorkPerformed */])('workPerformed','costCenterCode',e.target.id);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'paycode',opts:paycodes.map(function(p){return{val:p.code,label:p.label};}),label:'Special Pay Code',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["x" /* setPaycodeInWorkPerformed */])('workPerformed',e.target.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:'field',label:'Field No.',opts:fields,onChange:function onChange(e){return fetchBlocksByField(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["j" /* SelectBlock */],{id:'block',label:'Block No.',opts:blocks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'detail',opts:details.map(function(d){return{val:d.detail,label:d.detail+' - '+d.description};}),label:'Detail'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["e" /* AutoComplete */],{id:'equipmentNo',label:'Equipment No.',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* mapEquipmentForAutoComplete */])(equipmentNo),onComplete:__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["r" /* SelectEquipment */],{id:'equipmentTrailerNo',opts:equipmentTrailerNo,label:'Equipment Trailer No.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'differential',label:'Differential',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["s" /* DIFFERENTIAL_SLOT */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'trainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'trainer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'trainer'},'Trainer')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:'workPerformed',label:'Work Performed',placeholder:'Ex: Blow/sweep, Hauling, Vacation, Sick'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'hours',min:"0",max:"16",label:'Hours',step:"0.1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return packageWorkPerformed(addWork);},className:'btn waves-effect waves-light'},'Add Work')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'ind-work-edit-btn',onClick:function onClick(){return packageWorkPerformed(editWorkRecord);},className:'btn waves-effect waves-light blue'},'Edit Work'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__add_work_table__["a" /* default */],{work:workPerformed,removeWork:removeWork,editWork:editWork})))));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetForm);/* END */

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gang_work_table__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timesheet_gang_modal__ = __webpack_require__(337);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
5/30/2017
Alexander Self
Timesheet Gang Form
- Timesheet form for gangs; allows a user to add multiple
  employees and allocate individual trees, bags to each employee
***************************************************************/var $=window.$;var Materialize=window.Materialize;var GangTimesheetForm=function(_Component){_inherits(GangTimesheetForm,_Component);function GangTimesheetForm(props){_classCallCheck(this,GangTimesheetForm);var _this=_possibleConstructorReturn(this,(GangTimesheetForm.__proto__||Object.getPrototypeOf(GangTimesheetForm)).call(this,props));_this.prepareGangForm=_this.prepareGangForm.bind(_this);_this.packageWorkPerformed=_this.packageWorkPerformed.bind(_this);return _this;}_createClass(GangTimesheetForm,[{key:'prepareGangForm',value:function prepareGangForm(){var location=document.getElementById('gangLocation').value;var date=document.getElementById('gangWorkDate').value;var round=document.getElementById('round').value;return this.props.prepareGangTS(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["A" /* extractUsersFromForm */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* packageForm */])('gang-ts-form'),this.props.gangWorkPerformed),this.props.submitter,location,date,round);}},{key:'packageWorkPerformed',value:function packageWorkPerformed(callback){if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangCostCenterCode')===''){Materialize.toast('Please input a cost center',4000,'rounded red');return;}else if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangSubAccount')===''){Materialize.toast('Please input a subaccount',4000,'rounded red');return;}else if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangField')===''&&!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangCostCenterCode').match(/06|07|08/)){Materialize.toast('Please input a field',4000,'rounded red');return;}else if(document.getElementById('gangWorkPerformed').value===''){Materialize.toast('Please input work performed',4000,'rounded red');return;}else if(document.getElementById('gangHours').value===''){Materialize.toast('Please input hours',4000,'rounded red');return;}callback({workId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* generateGUID */])(),costCenterCode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangCostCenterCode'),subAccount:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangSubAccount'),workPerformed:$.trim(document.getElementById('gangWorkPerformed').value),hours:document.getElementById('gangHours').value,trainer:0,differential:'',detail:'',tempGrade:'',equipmentNo:'',equipmentTrailerNo:'',field:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getSelectedValue */])('gangField'),block:'',paycode:''});document.getElementById('gangCostCenterCode').value='';document.getElementById('gangSubAccount').value='';document.getElementById('gangField').value='';document.getElementById('gangWorkPerformed').value='';document.getElementById('gangHours').value='';return;}},{key:'render',value:function render(){var _this2=this;// If this is the day after the pay period ends, give one day to allow supervisors to enter in remaining timesheets
var startDate=void 0;var lastDay=__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');if(lastDay===this.props.payPeriodStartDate&&__WEBPACK_IMPORTED_MODULE_1_moment___default()().hour()<10)startDate=this.props.prevPPStartDate;else startDate=this.props.payPeriodStartDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'gang-ts-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["d" /* DatePicker2 */],{id:'gangWorkDate',label:'Date',min:startDate,max:this.props.payPeriodEndDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'gangLocation',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){_this2.props.fetchFieldsByLoc(e.target.value);_this2.props.selectCostCenterByLocation(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:'gangNo',label:'Team No.'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["o" /* TimePicker2 */],{id:'gangStartTime',label:'Start Time'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["o" /* TimePicker2 */],{id:'gangEndTime',label:'End Time'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:'gangShift',opts:__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* SHIFTS */],label:'Shift'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'round',label:'Round',min:1,max:6,step:1,defaultValue:1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["p" /* SelectCostCenter */],{id:'gangCostCenterCode',opts:this.props.costCenters,label:'Cost Center',onChange:function onChange(e){return _this2.props.fetchSubAccounts(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["q" /* SelectSubAccount */],{id:'gangSubAccount',opts:this.props.subAccounts,label:'Sub Account',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["w" /* setCCSubInWorkPerformed */])('gangWorkPerformed','gangCostCenterCode',e.target.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:'gangField',label:'Field',opts:this.props.fields})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:'gangWorkPerformed',label:'Work Performed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:'gangHours',min:"0",max:"16",label:'Hours',step:"0.1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2 trainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.packageWorkPerformed(_this2.props.addWorkToGangTimesheet);},className:'btn waves-effect waves-light'},'Add Work')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2 trainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'gang-work-edit-btn',onClick:function onClick(){return _this2.packageWorkPerformed(_this2.props.editGangWorkRecord);},className:'btn waves-effect waves-light blue'},'Edit Work'))),this.props.gangWorkPerformed.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__gang_work_table__["a" /* default */],{work:this.props.gangWorkPerformed,editWork:this.props.editGangWorkInTimesheet,removeWork:this.props.deleteWorkInGangTimesheet})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'emp-list-gang'},this.props.addedGangEmployees.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:e.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'emp-name-gang',className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text empname-gangts'},e.firstName,' ',e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:e.eid+'-eid',value:e.eid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:e.eid+'-positionType',value:e.positionType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:e.eid+'-subgrade',value:e.subgrade}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:e.eid+'-hours',min:"0",max:"8",step:'0.1',label:'Hours'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:e.eid+'-trees',min:"0",max:"75",step:'1',label:'Trees'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:e.eid+'-bags',min:"0",max:"25",step:'0.25',label:'Bags'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:e.eid+'-field',label:'Field',opts:_this2.props.fields,onChange:function onChange(event){return _this2.props.fetchBlocksByField(event.target.value,e.eid+'-field');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["j" /* SelectBlock */],{id:e.eid+'-block',label:'Block',opts:_this2.props.blocks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'co2 s2 m2 l2 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-floating waves-effect waves-light red',onClick:function onClick(){return _this2.props.removeEmployeeFromGang(e.eid);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'co2 s2 m2 l2 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-floating waves-effect waves-light green',onClick:function onClick(){return _this2.props.addNewGangInfoRow(e.eid);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'add')))),_this2.props.addedGangInfoRow.length>0?_this2.props.addedGangInfoRow.map(function(field){if(field.eid===e.eid){if(field.count.length>0){return field.count.map(function(f,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:f.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Next Input ',i+2,': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text empname-gangts'},e.firstName,' ',e.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:field.eid+'-'+i+'-eid',value:field.eid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:field.eid+'-'+i+'-hours',min:"0",max:"8",step:"0.05",label:'Hours'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:field.eid+'-'+i+'-trees',min:"0",max:"75",step:"0.05",label:'Trees'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:field.eid+'-'+i+'-bags',min:"0",max:"25",step:"0.05",label:'Bags'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["i" /* SelectField */],{id:field.eid+'-'+i+'-field',label:'Field',opts:_this2.props.fields,onChange:function onChange(event){return _this2.props.fetchBlocksByField(event.target.value,field.eid+'-'+i+'-field');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["j" /* SelectBlock */],{id:field.eid+'-'+i+'-block',label:'Block',opts:_this2.props.blocks}))));});}}return'';}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["a" /* Select */],{id:e.eid+'-paycode',opts:_this2.props.paycodes.map(function(p){return{val:p.code,label:p.label};}),label:'Special Pay Code'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["f" /* TextInput */],{id:e.eid+'-paycodeDescription',label:'Description'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__inputs__["g" /* NumberInput */],{id:e.eid+'-paycodeHours',min:"0",max:"12",step:'0.1',label:'Hours'}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__timesheet_gang_modal__["a" /* default */],{id:'gang-ts-modal',timesheet:this.props.gangTS,submitGangTimesheet:this.props.submitGangTimesheet,payPeriodStartDate:this.props.payPeriodStartDate,payPeriodEndDate:this.props.payPeriodEndDate,prevPPStartDate:this.props.prevPPStartDate,prevPPEndDate:this.props.prevPPEndDate,user:this.props.user}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-target':'gang-ts-modal',onClick:function onClick(){return _this2.prepareGangForm();},className:'btn waves-light waves-effect'},'Prepare')))));}}]);return GangTimesheetForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (GangTimesheetForm);/* END */

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timesheet_gang_harvest_table__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timesheet_modal_work_table__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of gang timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/var $=window.$;var TimesheetGangModal=function TimesheetGangModal(_ref){var id=_ref.id,timesheet=_ref.timesheet,submitGangTimesheet=_ref.submitGangTimesheet,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,prevPPStartDate=_ref.prevPPStartDate,prevPPEndDate=_ref.prevPPEndDate,user=_ref.user;var tsCheck='',empsWOHours=[],empsLessThan7=[];if(!timesheet.emps)tsCheck='No employees selected';if(timesheet.emps.length>0){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=timesheet.emps[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var e=_step.value;if(e.harvest.length===0)empsWOHours.push(e);if(Number(e.summaryOfHours)<8)empsLessThan7.push(e);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}$(document).ready(function(){$('#'+id).modal();});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Timesheet Summary'),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),tsCheck,empsWOHours.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'day-off'},'The follow employees do not have harvest records entered. Please verify this is correct.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,empsWOHours.map(function(e){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'day-off',key:e.eid},e.firstName,' ',e.lastName);}))):'',empsLessThan7.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{className:'day-off'},'The follow employees have less than 8 hours. Please verify this is correct.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',null,empsLessThan7.map(function(e){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'day-off',key:e.eid},e.firstName,' ',e.lastName);}))):'',timesheet.emps.map(function(e){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:e.eid,className:'card horizontal z-depth-4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-stacked'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,e.date)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row ind-summary'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Name: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.firstName,' ',e.lastName))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Location: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.location))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Reg. Hours: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.regHours))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'OT Hours: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.otHours>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'day-off'},e.otHours):e.otHours))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Double Time Hours: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.doubleTime))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text '},'Total Hours: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('u',null,e.summaryOfHours)))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'EID: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.eid))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Start Time: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.startTime))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'End Time: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.endTime))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Gang: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.gang))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Grade: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.grade))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item flow-text'},'Shift: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},e.shift)))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-action'},e.subTimesheet.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__timesheet_modal_work_table__["a" /* default */],{workPerformed:e.subTimesheet}):'',e.harvest.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__timesheet_gang_harvest_table__["a" /* default */],{harvest:e.harvest}):'')));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return submitGangTimesheet(timesheet,{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate},user);},id:'gang-ts-btn',className:'modal-action modal-close waves-effect waves-green btn-flat'},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetGangModal);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timesheet_modal_emp_table__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timesheet_modal_work_table__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of individual timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/var $=window.$;var TimesheetIndividualModal=function TimesheetIndividualModal(_ref){var id=_ref.id,timesheet=_ref.timesheet,employees=_ref.employees,workPerformed=_ref.workPerformed,submitRegTimesheet=_ref.submitRegTimesheet,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,prevPPStartDate=_ref.prevPPStartDate,prevPPEndDate=_ref.prevPPEndDate,user=_ref.user;if(!timesheet.startTime||!timesheet.endTime){timesheet.startTime='';timesheet.endTime='';}var tsCheck='';var work=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["z" /* totalHours */])(workPerformed);/* Let users know they have not selected any employees */if(employees.length===0)tsCheck='No employees selected';$(document).ready(function(){$('#'+id).modal();});return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',null,'Timesheet Summary'),' ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),work>12?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'day-off'},'Total hours are: ',work,'. Is this correct?'):'',work<8?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'day-off'},'Total working hours are: ',work,'. Is this correct?'):'',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',null,tsCheck),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'collection flow-text'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Date: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.date))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Location: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.location))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Start Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.startTime?timesheet.startTime:''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'End Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.endTime?timesheet.endTime:''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Gang No: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.gang?timesheet.gang:''))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__timesheet_modal_emp_table__["a" /* default */],{timesheet:timesheet,employees:employees})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},workPerformed.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__timesheet_modal_work_table__["a" /* default */],{workPerformed:workPerformed}):'')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return submitRegTimesheet(employees,timesheet,{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate},user);},id:'reg-ts-btn',className:'modal-action modal-close waves-effect waves-green btn-flat'},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetIndividualModal);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timesheet_delete_modal__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit
- Allows supervisors and managers to edit exisiting timesheets
***************************************************************/var TimesheetDelete=function TimesheetDelete(_ref){var selectedEmployee=_ref.selectedEmployee,employees=_ref.employees,myEmployees=_ref.myEmployees,submitter=_ref.submitter,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,timesheets=_ref.timesheets,fetchTimesheetsToDelete=_ref.fetchTimesheetsToDelete,deleteTimesheet=_ref.deleteTimesheet;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Delete Timesheet: ','\xA0',' ',selectedEmployee.firstName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,selectedEmployee.firstName,' ',selectedEmployee.lastName):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__inputs__["e" /* AutoComplete */],{id:'employee-delete-ts-list',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* mapEmployeeForAutoComplete */])(employees),onComplete:function onComplete(val,id){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* onDummyComplete */])(val,id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-light waves-effect',onClick:function onClick(val,id){fetchTimesheetsToDelete(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* findEmployeeByName */])(document.getElementById('employee-delete-ts-list').value,employees),{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate});document.getElementById('employee-delete-ts-list').value='';}},'Fetch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__employee_list__["a" /* default */],{employees:myEmployees,onClick:function onClick(e){return fetchTimesheetsToDelete(e,{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate});},icon:'add',header:'Select Employee',_class:'green',isEditOrDelete:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'delete-list'},timesheets.length>0?timesheets.map(function(ts){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:ts.timesheetID,className:'delete-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-target':ts.timesheetID,className:'btn waves-light waves-effect red rounded'},ts.date.split('T')[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__timesheet_delete_modal__["a" /* default */],{id:ts.timesheetID,employee:selectedEmployee,timesheet:ts,deleteTimesheet:deleteTimesheet}));}):'No Timesheets Available')))));};function mapStateToProps(state){return{submitter:state.auth.user.guid,employees:state.timesheet.employees,myEmployees:state.timesheet.myEmployees,selectedEmployee:state.timesheet.delete.employee,timesheets:state.timesheet.delete.timesheets,payPeriodStartDate:state.misc.payPeriod.startDate,payPeriodEndDate:state.misc.payPeriod.endDate};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchTimesheetsToDelete:__WEBPACK_IMPORTED_MODULE_6__actions__["fetchTimesheetsToDelete"],deleteTimesheet:__WEBPACK_IMPORTED_MODULE_6__actions__["deleteTimesheet"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TimesheetDelete));/* END */

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
5/27/2017
Alexander Self
Timesheet edit modal
- Summary of edited timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/var $=window.$;var TimesheetDeleteModal=function TimesheetDeleteModal(_ref){var id=_ref.id,timesheet=_ref.timesheet,employee=_ref.employee,deleteTimesheet=_ref.deleteTimesheet;$(document).ready(function(){$("#"+id).modal();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:id,className:"modal modal-fixed-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Delete Timesheet")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Please note that the timesheet will be deleted permanently."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote",{className:"alert-red"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row delete-summary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Employee ID: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},employee.eid))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Name: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},employee.firstName," ",employee.lastName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Date: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.date?timesheet.date.split('T')[0]:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Location: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.location))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Gang: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.gang))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Start Time: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.startTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"End Time: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.endTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Grade: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.grade))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Shift: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.shift))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Regular Hours: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.regHours))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Overtime: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.otHours))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"collection-item flow-text"},"Total Hours: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"right"},timesheet.summaryOfHours))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"modal-action modal-close waves-effect btn-flat"},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return deleteTimesheet({timesheet:timesheet,employee:employee});},className:"modal-action modal-close waves-effect btn-flat"},"Delete")));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetDeleteModal);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/***************************************************************
6/13/2017
Alexander Self
edit_work_table.js
- Table that maintains a list of work performed;
***************************************************************/var EditWorkTable=function EditWorkTable(_ref){var work=_ref.work,removeWork=_ref.removeWork,editWork=_ref.editWork;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Grade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Work'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cost Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub Account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Equip No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Paycode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,work.map(function(w,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:w.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.tempGrade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.workPerformed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.costCenterCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.subAccount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.equipmentNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,w.paycode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return editWork(w);},className:'btn-floating waves-effect waves-light blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mode_edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return removeWork(w.id);},className:'btn-floating waves-effect waves-light red'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'clear'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Total Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* totalHours */])(work)))))));};/* harmony default export */ __webpack_exports__["a"] = (EditWorkTable);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timesheet_edit_form__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timesheet_edit_list__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timesheet_edit_modal__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(4);
/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit
- Allows supervisors and managers to edit exisiting timesheets
***************************************************************/var TimesheetEdit=function TimesheetEdit(_ref){var user=_ref.user,employees=_ref.employees,myEmployees=_ref.myEmployees,fields=_ref.fields,blocks=_ref.blocks,costCenters=_ref.costCenters,details=_ref.details,equipmentNo=_ref.equipmentNo,equipmentTrailerNo=_ref.equipmentTrailerNo,subAccounts=_ref.subAccounts,timesheet=_ref.timesheet,subTimesheets=_ref.subTimesheets,paycodes=_ref.paycodes,timesheetDates=_ref.timesheetDates,employeeSelected=_ref.employeeSelected,submitter=_ref.submitter,removedWork=_ref.removedWork,payPeriodStartDate=_ref.payPeriodStartDate,payPeriodEndDate=_ref.payPeriodEndDate,prevPPStartDate=_ref.prevPPStartDate,prevPPEndDate=_ref.prevPPEndDate,harvestTimesheet=_ref.harvestTimesheet,removedHarvest=_ref.removedHarvest,fetchTimesheetDatesToEdit=_ref.fetchTimesheetDatesToEdit,fetchTimesheetToEdit=_ref.fetchTimesheetToEdit,removeWorkFromEditTimesheet=_ref.removeWorkFromEditTimesheet,addWorkToEditTimesheet=_ref.addWorkToEditTimesheet,prepareEditTS=_ref.prepareEditTS,submitEditTimesheet=_ref.submitEditTimesheet,fetchSubAccounts=_ref.fetchSubAccounts,fetchFieldsByLoc=_ref.fetchFieldsByLoc,fetchBlocksByField=_ref.fetchBlocksByField,removeHarvest=_ref.removeHarvest,addHarvest=_ref.addHarvest,selectCostCenterByLocation=_ref.selectCostCenterByLocation,editWork=_ref.editWork,editWorkRecord=_ref.editWorkRecord,selectHarvestToEdit=_ref.selectHarvestToEdit,editHarvest=_ref.editHarvest,harvestToEdit=_ref.harvestToEdit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text'},'Edit Timesheet ','\xA0',employeeSelected.firstName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,employeeSelected.firstName,' ',employeeSelected.lastName):'Select an Employee')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inputs__["e" /* AutoComplete */],{id:'employee-edit-ts-list',label:'Find Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* mapEmployeeForAutoComplete */])(employees),onComplete:function onComplete(val,id){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* onDummyComplete */])(val,id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-light waves-effect',onClick:function onClick(){return fetchTimesheetDatesToEdit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* findEmployeeByName */])(document.getElementById('employee-edit-ts-list').value,employees),{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,prevPPStartDate:prevPPStartDate,prevPPEndDate:prevPPEndDate},user);}},'Fetch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__employee_list__["a" /* default */],{employees:myEmployees,onClick:function onClick(e){return fetchTimesheetDatesToEdit(e,{payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate},user);},icon:'add',header:'Select Employee',_class:'green',isEditOrDelete:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#edit-ts-modal',onClick:function onClick(){return prepareEditTS(timesheet,subTimesheets,submitter,removedWork,harvestTimesheet,removedHarvest);},className:'btn waves-light waves-effect blue'},'Prepare')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__timesheet_edit_modal__["a" /* default */],{id:'edit-ts-modal',subTimesheets:subTimesheets,timesheet:timesheet,employee:employeeSelected,submitTimesheet:submitEditTimesheet,removedWork:removedWork,harvestTimesheet:harvestTimesheet,removedHarvest:removedHarvest})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l10 xl10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row edit-timesheet-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},timesheetDates.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__timesheet_edit_list__["a" /* default */],{timesheets:timesheetDates,employee:employeeSelected,fetchTimesheetToEdit:fetchTimesheetToEdit}):'No Timesheets Available')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__timesheet_edit_form__["a" /* default */],{fields:fields,blocks:blocks,details:details,work:subTimesheets,costCenters:costCenters,paycodes:paycodes,removeWork:removeWorkFromEditTimesheet,addWork:addWorkToEditTimesheet,equipmentNo:equipmentNo,equipmentTrailerNo:equipmentTrailerNo,subAccounts:subAccounts,fetchSubAccounts:fetchSubAccounts,payPeriodStartDate:payPeriodStartDate,payPeriodEndDate:payPeriodEndDate,fetchFieldsByLoc:fetchFieldsByLoc,fetchBlocksByField:fetchBlocksByField,harvestTimesheet:harvestTimesheet,removeHarvest:removeHarvest,addHarvest:addHarvest,selectCostCenterByLocation:selectCostCenterByLocation,editWork:editWork,editWorkRecord:editWorkRecord,selectHarvestToEdit:selectHarvestToEdit,editHarvest:editHarvest,harvestToEdit:harvestToEdit}))));};function mapStateToProps(state){return{user:state.auth.user,employees:state.timesheet.employees,myEmployees:state.timesheet.myEmployees,fields:state.timesheet.fields,blocks:state.timesheet.blocks,details:state.timesheet.details.displaying,costCenters:state.timesheet.costCenters.displaying,equipmentNo:state.equipment.equipmentNo,equipmentTrailerNo:state.equipment.equipmentTrailerNo,paycodes:state.timesheet.paycodes,subAccounts:state.timesheet.subAccounts,submitter:state.auth.user.guid,timesheetDates:state.timesheet.edit.timesheetDates,employeeSelected:state.timesheet.edit.employee,subTimesheets:state.timesheet.edit.ts.subTimesheets,timesheet:state.timesheet.edit.ts.timesheet,removedWork:state.timesheet.edit.ts.removedWork,harvestTimesheet:state.timesheet.edit.ts.harvestTimesheet,removedHarvest:state.timesheet.edit.ts.removedHarvest,payPeriodStartDate:state.misc.payPeriod.startDate,payPeriodEndDate:state.misc.payPeriod.endDate,prevPPStartDate:state.misc.prevPP.startDate,prevPPEndDate:state.misc.prevPP.endDate,harvestToEdit:state.timesheet.edit.ts.editHarvest};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchTimesheetDatesToEdit:__WEBPACK_IMPORTED_MODULE_7__actions__["fetchTimesheetDatesToEdit"],fetchTimesheetToEdit:__WEBPACK_IMPORTED_MODULE_7__actions__["fetchTimesheetToEdit"],removeWorkFromEditTimesheet:__WEBPACK_IMPORTED_MODULE_7__actions__["removeWorkFromEditTimesheet"],addWorkToEditTimesheet:__WEBPACK_IMPORTED_MODULE_7__actions__["addWorkToEditTimesheet"],prepareEditTS:__WEBPACK_IMPORTED_MODULE_7__actions__["prepareEditTS"],submitEditTimesheet:__WEBPACK_IMPORTED_MODULE_7__actions__["submitEditTimesheet"],fetchSubAccounts:__WEBPACK_IMPORTED_MODULE_7__actions__["fetchSubAccounts"],fetchFieldsByLoc:__WEBPACK_IMPORTED_MODULE_7__actions__["fetchFieldsByLoc"],fetchBlocksByField:__WEBPACK_IMPORTED_MODULE_7__actions__["fetchBlocksByField"],removeHarvest:__WEBPACK_IMPORTED_MODULE_7__actions__["removeHarvest"],addHarvest:__WEBPACK_IMPORTED_MODULE_7__actions__["addHarvest"],selectCostCenterByLocation:__WEBPACK_IMPORTED_MODULE_7__actions__["selectCostCenterByLocation"],editWorkRecord:__WEBPACK_IMPORTED_MODULE_7__actions__["editWorkRecordInEditTimesheet"],editWork:__WEBPACK_IMPORTED_MODULE_7__actions__["editWorkInEditTimesheet"],selectHarvestToEdit:__WEBPACK_IMPORTED_MODULE_7__actions__["selectHarvestToEdit"],editHarvest:__WEBPACK_IMPORTED_MODULE_7__actions__["editHarvest"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TimesheetEdit));/* END */

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_work_table__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Timesheet form
***************************************************************/var $=window.$;var TimesheetEditForm=function(_Component){_inherits(TimesheetEditForm,_Component);function TimesheetEditForm(props){_classCallCheck(this,TimesheetEditForm);var _this=_possibleConstructorReturn(this,(TimesheetEditForm.__proto__||Object.getPrototypeOf(TimesheetEditForm)).call(this,props));_this.packageWorkPerformed=_this.packageWorkPerformed.bind(_this);_this.onForceUpdate=_this.onForceUpdate.bind(_this);$(document).ready(function(){$('.scrollspy').scrollSpy();});return _this;}_createClass(TimesheetEditForm,[{key:'onForceUpdate',value:function onForceUpdate(){this.forceUpdate();}},{key:'packageWorkPerformed',value:function packageWorkPerformed(callback){var _handleWorkPerformedE=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* handleWorkPerformedEdit */])(),hours=_handleWorkPerformedE.hours,trainer=_handleWorkPerformedE.trainer,check=_handleWorkPerformedE.check;if(!check)return;var equipCheck=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["j" /* handleEquipmentNo */])('edit-ts-equipmentNo',this.props.equipmentNo);if(!equipCheck)return;callback({id:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* generateGUID */])(),tempGrade:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-tempGrade'),costCenterCode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-costCenterCode'),subAccount:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-subAccount'),paycode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-paycode'),field:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-tsworkPerformed-field'),block:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-tsworkPerformed-block'),equipmentNo:document.getElementById('edit-ts-equipmentNo').value,equipmentTrailerNo:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-equipmentTrailerNo'),differential:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* getSelectedValue */])('edit-ts-differential'),workPerformed:$.trim(document.getElementById('edit-ts-workPerformed').value),detail:document.getElementById('edit-ts-detail').value,hours:hours,trainer:trainer});document.getElementById("edit-second-ts-form").reset();return;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m9 l10 xl10'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{id:'edit-ts-mtimesheet',className:'section scrollspy'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'edit-ts-form',className:'form-rerender'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["k" /* Textarea */],{id:'edit-ts-reasonForEdit',label:'Reason for Edit'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* DatePicker2 */],{id:'edit-ts-date',label:'Date',min:this.props.payPeriodStartDate,max:this.props.payPeriodEndDate})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-location',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* LOCATIONS */],label:'Location',onChange:function onChange(e){_this2.props.fetchFieldsByLoc(e.target.value);_this2.props.selectCostCenterByLocation(e.target.value);_this2.onForceUpdate();}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-ts-gang',label:'Team No.'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["o" /* TimePicker2 */],{id:'edit-ts-startTime',label:'Start Time'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["o" /* TimePicker2 */],{id:'edit-ts-endTime',label:'End Time'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-shift',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SHIFTS */],label:'Shift'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* NumberInput */],{id:'edit-ts-round',label:'Round',min:1,max:6,step:1,defaultValue:1}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'checkbox',id:'edit-ts-dustPay'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',{htmlFor:'edit-ts-dustPay'},'Dust Pay')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{id:'edit-ts-stimesheet',className:'section scrollspy'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'flow-text'},'Individual Work Form')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'edit-second-ts-form'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-tempGrade',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* GRADES */],label:'Temp Grade'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["p" /* SelectCostCenter */],{id:'edit-ts-costCenterCode',opts:this.props.costCenters,label:'Cost Center',onChange:function onChange(e){_this2.props.fetchSubAccounts(e.target.value);_this2.onForceUpdate();}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["q" /* SelectSubAccount */],{id:'edit-ts-subAccount',opts:this.props.subAccounts,label:'Sub Account',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["w" /* setCCSubInWorkPerformed */])('edit-ts-workPerformed','edit-ts-costCenterCode',e.target.id);}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-paycode',opts:this.props.paycodes.map(function(p){return{val:p.code,label:p.label};}),label:'Special Pay Code',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["x" /* setPaycodeInWorkPerformed */])('edit-ts-workPerformed',e.target.id);}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["i" /* SelectField */],{id:'edit-tsworkPerformed-field',label:'Field No.',opts:this.props.fields,onChange:function onChange(e){_this2.props.fetchBlocksByField(e.target.value);_this2.onForceUpdate();}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["j" /* SelectBlock */],{id:'edit-tsworkPerformed-block',label:'Block No.',opts:this.props.blocks})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-detail',opts:this.props.details.map(function(d){return{val:d.detail,label:d.detail+' - '+d.description};}),label:'Detail'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* AutoComplete */],{id:'edit-ts-equipmentNo',label:'Equipment No.',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["t" /* mapEquipmentForAutoComplete */])(this.props.equipmentNo),onComplete:__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["r" /* SelectEquipment */],{id:'edit-ts-equipmentTrailerNo',opts:this.props.equipmentTrailerNo,label:'Equipment Trailer No.'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* Select */],{id:'edit-ts-differential',label:'Differential',opts:__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* DIFFERENTIAL_SLOT */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'trainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'checkbox',id:'edit-ts-trainer'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',{htmlFor:'edit-ts-trainer'},'Trainer')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l8'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* TextInput */],{id:'edit-ts-workPerformed',label:'Work Performed'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* NumberInput */],{id:'edit-ts-hours',min:"0",max:"16",label:'Hours',step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this2.packageWorkPerformed(_this2.props.addWork);},className:'btn waves-effect waves-light'},'Add Work')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{id:'ind-work-edit-ts-btn',onClick:function onClick(){return _this2.packageWorkPerformed(_this2.props.editWorkRecord);},className:'btn waves-effect waves-light blue'},'Edit Work'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__edit_work_table__["a" /* default */],{work:this.props.work,removeWork:this.props.removeWork,editWork:this.props.editWork}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{id:'edit-ts-htimesheet',className:'section scrollspy'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'flow-text'},'Harvest')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return e.preventDefault();},id:'edit-harvest-ts-form'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* NumberInput */],{id:'edit-ts-hours',min:"0",max:"8",step:"0.05",label:'Hours'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* NumberInput */],{id:'edit-ts-trees',min:"0",max:"75",step:"0.05",label:'Trees'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* NumberInput */],{id:'edit-ts-bags',min:"0",max:"25",step:"0.05",label:'Bags'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["i" /* SelectField */],{id:'edit-ts-field',label:'Field',opts:this.props.fields,onChange:function onChange(event){return _this2.props.fetchBlocksByField(event.target.value,'edit-ts-field');}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["j" /* SelectBlock */],{id:'edit-ts-block',label:'Block',opts:this.props.blocks})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2 mt-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["n" /* FloatingButton */],{color:'green',icon:'add',onclick:function onclick(){_this2.props.addHarvest(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* packageDashForm */])('edit-harvest-ts-form'));document.getElementById('edit-harvest-ts-form').reset();}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["n" /* FloatingButton */],{id:'edit-harvest-btn',color:'blue',icon:'mode_edit',onclick:function onclick(){_this2.props.editHarvest('edit-harvest-ts-form',_this2.props.harvestToEdit);document.getElementById('edit-harvest-ts-form').reset();}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,this.props.harvestTimesheet.length>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('table',{className:'responsive-table centered highlight bordered'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Trees'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Bags'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Block'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'Remove'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tbody',null,this.props.harvestTimesheet.map(function(h){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',{key:h.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,h.hours),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,h.trees),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,h.bags),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,h.field),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,h.block),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["n" /* FloatingButton */],{color:'blue',icon:'mode_edit',onclick:function onclick(){return _this2.props.selectHarvestToEdit('edit-harvest-ts-form',h);}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["n" /* FloatingButton */],{color:'red',icon:'clear',onclick:function onclick(){return _this2.props.removeHarvest(h.id);}})));})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* totalCount */])(this.props.harvestTimesheet,'hours')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* totalCount */])(this.props.harvestTimesheet,'trees')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* totalCount */])(this.props.harvestTimesheet,'bags'))))))):'')))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col hide-on-small-only m3 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{id:'edit-table-of-contents',className:'section table-of-contents'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'#edit-ts-mtimesheet'},'Main')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'#edit-ts-stimesheet'},'Individual Work')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'#edit-ts-htimesheet'},'Harvest')))));}}]);return TimesheetEditForm;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (TimesheetEditForm);/* END */

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs__ = __webpack_require__(8);
/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit list
- List of timesheets for each employee
***************************************************************/var TimesheetEditList=function TimesheetEditList(_ref){var timesheets=_ref.timesheets,employee=_ref.employee,fetchTimesheetToEdit=_ref.fetchTimesheetToEdit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'edit-timesheets'},timesheets.map(function(ts){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:ts.timesheetID,className:'edit-timesheets-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,ts.date.split('T')[0]),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__inputs__["n" /* FloatingButton */],{color:'blue',icon:'mode_edit',onclick:function onclick(){return fetchTimesheetToEdit(ts.timesheetID,employee.eid);}}))));}));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetEditList);/* END */

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_timesheet_modal_emp_table__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_timesheet_modal_work_table__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_timesheet_gang_harvest_table__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/***************************************************************
5/27/2017
Alexander Self
Timesheet edit modal
- Summary of edited timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/var $=window.$;var TimesheetEditModal=function TimesheetEditModal(_ref){var id=_ref.id,employee=_ref.employee,timesheet=_ref.timesheet,removedWork=_ref.removedWork,subTimesheets=_ref.subTimesheets,submitTimesheet=_ref.submitTimesheet,harvestTimesheet=_ref.harvestTimesheet,removedHarvest=_ref.removedHarvest;$(document).ready(function(){$('#'+id).modal();});var _sub=subTimesheets.reduce(function(acc,cur){return acc+Number(cur.hours);},0);var harv=harvestTimesheet.reduce(function(acc,cur){return acc+Number(cur.hours);},0);var work=_sub+harv;if(timesheet===undefined||Object.keys(timesheet).length===0){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',null,'Edit Timesheet Summary'),' ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',null,'No employee selected')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel')));}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{id:id,className:'modal modal-fixed-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',null,'Edit Timesheet Summary'),' ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),work>12?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'day-off'},'Total hours are: ',work,'. Is this correct?'):'',work<8?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'day-off'},'Total working hours are: ',work,'. Is this correct?'):'',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h5',null,'Reason for Edit: ',timesheet.reasonForEdit?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',{className:'blue-text'},timesheet.reasonForEdit):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,'...'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'collection flow-text'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Date: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.date?timesheet.date.split('T')[0]:''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Location: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.location))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Start Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.startTime?timesheet.startTime:''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'End Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.endTime?timesheet.endTime:''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item'},'Gang No: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},timesheet.gang?timesheet.gang:''))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},Object.keys(employee).length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__create_timesheet_modal_emp_table__["a" /* default */],{timesheet:timesheet,employees:[employee]}):''),subTimesheets.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'flow-text'},'Individual Work'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__create_timesheet_modal_work_table__["a" /* default */],{workPerformed:subTimesheets})):'',harvestTimesheet.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'flow-text'},'Harvest'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__create_timesheet_gang_harvest_table__["a" /* default */],{harvest:harvestTimesheet})):''),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',className:'modal-action modal-close waves-effect waves-red btn-flat'},'Cancel'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return submitTimesheet({timesheet:timesheet,subTimesheets:subTimesheets,removedWork:removedWork,employee:employee,harvestTimesheet:harvestTimesheet,removedHarvest:removedHarvest});},className:'modal-action modal-close waves-effect waves-green btn-flat'},'Submit')));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetEditModal);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timesheet_view_summary__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timesheet_view_individual_summary__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/***************************************************************
6/6/2017
Alexander Self
Accordion
- Displays timesheets and daily summaries as accordions
***************************************************************/var $=window.$;var Accordion=function Accordion(_ref){var id=_ref.id,timesheets=_ref.timesheets,date=_ref.date;if(timesheets.length===0)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);$(document).ready(function(){// Materialize Initialization
$('#'+id).collapsible();});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{id:id,className:'collapsible popout','data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'insert_chart'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'Summary'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right-align'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,date))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__timesheet_view_summary__["a" /* default */],{timesheets:timesheets}))),timesheets.map(function(ts){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:ts.eid},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'perm_identity'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'left-align'},ts.firstName,' ',ts.lastName),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right-align'},ts.eid)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__timesheet_view_individual_summary__["a" /* default */],{ts:ts})));}));};/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/***************************************************************
5/22/2017
Alexander Self
Timesheet Download
- Component to allow a user to download a timesheet daily summary
   or a set of timesheets in a date range
***************************************************************/var $=window.$;var TimesheetDownload=function TimesheetDownload(_ref){var id=_ref.id,_class=_ref._class,downloadTimesheets=_ref.downloadTimesheets,email=_ref.email,label=_ref.label,byEmployee=_ref.byEmployee,employees=_ref.employees,date1=_ref.date1,date2=_ref.date2;$(document).ready(function(){$('#'+id).collapsible();});function packageDates(callback){var dateFrom=document.getElementById(date1).value;var dateTo=document.getElementById(date2).value;if(byEmployee){var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* findEmployeeByName */])(document.getElementById('employee-search-ts-download').value,employees);return callback({dateFrom:dateFrom,dateTo:dateTo},email,emp);}return callback({dateFrom:dateFrom,dateTo:dateTo},email);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{id:id,className:'collapsible '+_class,'data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'get_app'),label),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'Select a date range'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{id:'ts-download-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* DatePicker2 */],{id:date1,label:'From'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* DatePicker2 */],{id:date2,label:'To'}),byEmployee?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* AutoComplete */],{id:'employee-search-ts-download',label:'Select an Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* mapEmployeeForAutoComplete */])(employees),onComplete:function onComplete(val,id){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* onDummyComplete */])(val,id);}}),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br',null)):'',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn waves-light waves-effect',onClick:function onClick(){return packageDates(downloadTimesheets);}},'Email'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Send to: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,email)))))));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetDownload);/* END */

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_timesheet_modal_work_table__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timesheet_harvest_view_table__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/***************************************************************
6/6/2017
Alexander Self
Accordion
- Displays timesheets and daily summaries as accordions
***************************************************************/var $=window.$;var TimesheetIndividualAccordion=function TimesheetIndividualAccordion(_ref){var id=_ref.id,timesheets=_ref.timesheets,employee=_ref.employee;if(timesheets.length===0)return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null);$(document).ready(function(){// Materialize Initialization
$('#'+id).collapsible();});return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{id:id,className:'collapsible popout','data-collapsible':'accordion'},timesheets.map(function(ts){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{key:ts.timesheetID},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('i',{className:'material-icons'},'perm_identity'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'left-align'},ts.location),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right-align'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(ts.date).format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'card horizontal z-depth-4'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'card-stacked'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row ind-summary'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Name: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},employee.firstName,' ',employee.lastName))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'EID ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.eid))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Reg. Hours: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.regHours))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'OT Hours: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.otHours))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Doubletime Hours: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.doubleTime))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text '},'Non-work Hours: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('u',null,ts.miscHours)))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text '},'Total Hours: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('u',null,ts.summaryOfHours)))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Start Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.startTime))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'End Time: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.endTime))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Grade: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.grade))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Shift: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.shift))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Location: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.location))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li',{className:'collection-item flow-text'},'Team ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'right'},ts.gang))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h5',null,ts.reasonForEdit?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,'Timesheet Edited: ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(ts.dateTimeEdited).format('YYYY-MM-DD hh:mm:ss a'),', ',ts.reasonForEdit)):'')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'card-action'},ts.subTimesheets.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__create_timesheet_modal_work_table__["a" /* default */],{workPerformed:ts.subTimesheets}):'',ts.harvest.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__timesheet_harvest_view_table__["a" /* default */],{harvest:ts.harvest}):'')))));}));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetIndividualAccordion);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timesheet_accordion__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timesheet_individual_timesheet_accordion__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timesheet_download__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
5/22/2017
Alexander Self
Timesheet View
- Displays timesheets and daily summaries
***************************************************************///import TimesheetFilters from './timesheet_filters';
var $=window.$;var Materialize=window.Materialize;var TimesheetView=function(_Component){_inherits(TimesheetView,_Component);function TimesheetView(props){_classCallCheck(this,TimesheetView);var _this=_possibleConstructorReturn(this,(TimesheetView.__proto__||Object.getPrototypeOf(TimesheetView)).call(this,props));_this.fetchTSDate=_this.fetchTSDate.bind(_this);_this.fetchTSEmployee=_this.fetchTSEmployee.bind(_this);_this.fetchMyTimesheetsByDate=_this.fetchMyTimesheetsByDate.bind(_this);_this.state={date:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["C" /* getCurrentDate */])()};return _this;}_createClass(TimesheetView,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('#ts-view').tabs();});if(this.props.timesheets.length>0)return;this.props.fetchTimesheets(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["C" /* getCurrentDate */])());if(this.props.myEmployees.length>0)return;this.props.fetchMyEmployees(this.props.user.guid);if(this.props.myTimesheets.length>0)return;}},{key:'fetchTSDate',value:function fetchTSDate(){/* Fetches a set of timesheets based on user selected date */var date=document.getElementById('view-timesheet-date').value;if(date==='')return;$('#timesheet-view').fadeOut({duration:300});this.props.fetchTimesheets(date);this.setState({date:date});// Only local state
document.getElementById('view-timesheet-date').value='';}},{key:'fetchMyTimesheetsByDate',value:function fetchMyTimesheetsByDate(){/* Fetches a set of timesheets based on user selected date */var date=document.getElementById('my-timesheet-date').value;if(date==='')return;this.props.fetchMyTimesheets(this.props.user.eid,date);document.getElementById('my-timesheet-date').value='';}},{key:'fetchTSEmployee',value:function fetchTSEmployee(){if(document.getElementById('employee-search-ts').value===''){Materialize.toast('Please select an employee',4000,'rounded red');return;};var emp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* findEmployeeByName */])(document.getElementById('employee-search-ts').value,this.props.employees);if(!emp)return;this.props.fetchEmployeeTimesheets(emp);document.getElementById('employee-search-ts').value='';}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span',{className:'flow-text'},'View Timesheets')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('ul',{id:'ts-view',className:'tabs'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('a',{href:'#all-ts'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i',{className:'material-icons'},'list'),'  All Timesheets')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('a',{href:'#my-ts',onClick:function onClick(){return _this2.props.fetchMyTimesheets(_this2.props.user.eid);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i',{className:'material-icons'},'view_list'),'  My Timesheets'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{id:'all-ts'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs__["d" /* DatePicker2 */],{id:'view-timesheet-date',label:'Select a Date'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button',{className:'btn waves-effect waves-light',onClick:function onClick(){return _this2.fetchTSDate();}},'Search')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs__["e" /* AutoComplete */],{id:'employee-search-ts',label:'Select an Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:function onComplete(val,id){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* onDummyComplete */])(val,id);}}),' ',__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button',{className:'btn waves-effect waves-light',onClick:function onClick(){return _this2.fetchTSEmployee();}},'Search')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__timesheet_download__["a" /* default */],{id:'ts-download',_class:'timesheet-download',label:'Timesheets by Date Range',downloadTimesheets:this.props.downloadTimesheets,email:this.props.user.email,byEmployee:false,date1:'ts-download-1',date2:'ts-download-2'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__timesheet_download__["a" /* default */],{id:'ts-ind-download',_class:'timesheet-download',label:'Timesheets by Employee',downloadTimesheets:this.props.downloadIndividualTimesheets,email:this.props.user.email,byEmployee:true,employees:this.props.employees,date1:'ts-download-3',date2:'ts-download-4'}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m12 l10 emp-list-ts'},this.props.timesheets.length<1&&this.props.employeeTimesheets.timesheets<1?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('b',null,'No Timesheets Available')):'',this.props.timesheets.length<1?'':__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__timesheet_accordion__["a" /* default */],{id:'timesheet-view',timesheets:this.props.timesheets,date:this.state.date})),this.props.employeeTimesheets.timesheets<1?'':__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p',{className:'flow-text'},this.props.employee.firstName,' ',this.props.employee.lastName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__timesheet_individual_timesheet_accordion__["a" /* default */],{id:'timesheet-individual-view',employee:this.props.employee,timesheets:this.props.employeeTimesheets.timesheets})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{id:'my-ts'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5',null,this.props.myTimesheetsDate)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m12 l2'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs__["d" /* DatePicker2 */],{id:'my-timesheet-date',label:'Select a Date'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button',{className:'btn waves-effect waves-light',onClick:function onClick(){return _this2.fetchMyTimesheetsByDate();}},'Search'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m12 l10 emp-list-ts'},this.props.myTimesheets?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__timesheet_accordion__["a" /* default */],{id:'my-timesheet-view',timesheets:this.props.myTimesheets,date:this.props.myTimesheetDate})):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('b',null,'No Timesheets Available')))));}}]);return TimesheetView;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);;function mapStateToProps(state){return{user:state.auth.user,employees:state.timesheet.employees,myEmployees:state.timesheet.myEmployees,timesheets:state.timesheet.timesheets,myTimesheets:state.timesheet.myTimesheets.timesheets,myTimesheetsDate:state.timesheet.myTimesheets.date,download:state.timesheet.download,employeeTimesheets:state.timesheet.employeeTimesheets,employee:state.timesheet.employeeTimesheets.employee};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* bindActionCreators */])({downloadIndividualTimesheets:__WEBPACK_IMPORTED_MODULE_2__actions__["downloadIndividualTimesheets"],downloadTimesheets:__WEBPACK_IMPORTED_MODULE_2__actions__["downloadTimesheets"],fetchEmployeeTimesheets:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchEmployeeTimesheets"],fetchMyEmployees:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchMyEmployees"],fetchMyTimesheets:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchMyTimesheets"],fetchTimesheets:__WEBPACK_IMPORTED_MODULE_2__actions__["fetchTimesheets"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TimesheetView));

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_timesheet_modal_work_table__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timesheet_harvest_view_table__ = __webpack_require__(149);
/***************************************************************
5/22/2017
Alexander Self
Timesheet View individual
- Displays individual timesheet summaries
Anyone who has a subtimesheet len > 0 is displayed with a work table
***************************************************************/var TimesheetIndividualSummaryView=function TimesheetIndividualSummaryView(_ref){var ts=_ref.ts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card horizontal z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-stacked'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ind-summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Name: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.firstName,' ',ts.lastName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'EID ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.eid))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Reg. Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.regHours))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'OT Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.otHours))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Doubletime Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.doubleTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text '},'Non-work Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,ts.miscHours)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text '},'Total Hours: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,ts.summaryOfHours)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Start Time: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.startTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'End Time: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.endTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Grade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.grade))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Shift: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.shift))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.location))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Team ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},ts.gang))),ts.dustPay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item flow-text'},'Dust Pay ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right error'},'Active'))):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,ts.reasonForEdit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Timesheet Edited: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(ts.dateTimeEdited).format('YYYY-MM-DD hh:mm:ss a'),', ',ts.reasonForEdit)):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-action'},ts.subTimesheet.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__create_timesheet_modal_work_table__["a" /* default */],{workPerformed:ts.subTimesheet}):'',ts.harvest.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__timesheet_harvest_view_table__["a" /* default */],{harvest:ts.harvest}):'')));};/* harmony default export */ __webpack_exports__["a"] = (TimesheetIndividualSummaryView);/* END */

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
5/22/2017
Alexander Self
Timesheet Summary View
- Displays daily timesheet summaries
***************************************************************/var TimesheetSummaryView=function TimesheetSummaryView(_ref){var timesheets=_ref.timesheets;function mapGangTimesheets(timesheets){return timesheets.map(function(ts){if(ts.harvest.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:ts.eid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.firstName,' ',ts.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.eid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.grade),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.shift),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.regHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.otHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.doubleTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.summaryOfHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.gang),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.harvest.length>0?ts.harvest.reduce(function(acc,cur){return acc+cur.trees;},0):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ts.harvest.length>0?ts.harvest.reduce(function(acc,cur){return acc+cur.bags;},0):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'$',ts.harvest.length>0?ts.harvest.reduce(function(acc,cur){return acc+cur.incentive;},0.00):''));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:Math.random()});});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,timesheets.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Team Submitted Timesheets'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered responsive-table highlight centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'EID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Grade'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Shift'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reg. Hrs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'OT Hrs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DT Hrs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Hrs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Trees'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bonus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mapGangTimesheets(timesheets))))):'');};/* harmony default export */ __webpack_exports__["a"] = (TimesheetSummaryView);/* END */

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/***************************************************************
6/9/2017
Alexander Self
List of urls for side nav
***************************************************************/var $=window.$;var UrlList=function UrlList(_ref){var listItems=_ref.listItems,id=_ref.id,_class=_ref._class;$(document).ready(function(){$('.tooltipped').tooltip({delay:50});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{id:id,className:'collection'},listItems.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:''+item+i,className:'collection-item avatar '+_class+' nav-icon tooltipped',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push(''+item.url);},'data-position':'right','data-delay':'50','data-tooltip':item.name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:item._class+' material-icons circle'},item.icon));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:'weather8',className:'collection-item side-navigation avatar nav-icon tooltipped',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/weather');},'data-position':'right','data-delay':'50','data-tooltip':'Weather'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'wi wi-day-rain orange lighten-2 circle'}))));};/* harmony default export */ __webpack_exports__["a"] = (UrlList);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_alert_list__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_alert_formTabs__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alert_messagesTabs__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_alert_actions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Materialize=window.Materialize;var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){document.title='Alert';}},{key:'componentDidUpdate',value:function componentDidUpdate(){//check if an attempt to send a notification has been made
if(this.props.messageAttempt){//check if the notification sent was successful or unsuccessful
if(this.props.messageSuccess){// if unsuccessful, display error
Materialize.toast(this.props.messageSuccess,4000,'rounded red');}else{Materialize.toast('Success!',4000,'rounded green');}//notify state that the toast was displayed so that it does not display again
this.props.toastDisplayed();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Alert ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m4 l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_alert_list__["a" /* default */],{className:'list-card'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m8 l9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_alert_formTabs__["a" /* default */],{className:'card-panel row col m12 s12 center'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_alert_messagesTabs__["a" /* default */],{className:'card-panel col m12 s12 center'}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{messageAttempt:state.toast.messageAttempt,messageSuccess:state.toast.messageSuccess};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux__["c" /* bindActionCreators */])({toastDisplayed:__WEBPACK_IMPORTED_MODULE_5__actions_alert_actions__["a" /* toastDisplayed */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(ComposedComponent){var Authentication=function(_Component){_inherits(Authentication,_Component);function Authentication(){_classCallCheck(this,Authentication);return _possibleConstructorReturn(this,(Authentication.__proto__||Object.getPrototypeOf(Authentication)).apply(this,arguments));}_createClass(Authentication,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.authenticated){__WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/');}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!nextProps.authenticated){__WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/');}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent,this.props);}}]);return Authentication;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated};}return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Authentication);});/* END */

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_preloader__ = __webpack_require__(146);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
6/19/2017
Alexander Self
Signin component
- Simple form for users to signin
***************************************************************/var SignIn=function(_Component){_inherits(SignIn,_Component);function SignIn(props){_classCallCheck(this,SignIn);var _this=_possibleConstructorReturn(this,(SignIn.__proto__||Object.getPrototypeOf(SignIn)).call(this,props));_this.handleFormSubmit=_this.handleFormSubmit.bind(_this);return _this;}_createClass(SignIn,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.authenticated){__WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push('/dashboard');}}},{key:'handleFormSubmit',value:function handleFormSubmit(e){e.preventDefault();var email=document.getElementById('signin-email').value;var password=document.getElementById('signin-password').value;this.props.signinUser({email:email,password:password});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container signin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m8 l6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'preloader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_preloader__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card signin z-depth-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title'},'Signin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this2.handleFormSubmit(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'signin-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'signin-email'},'Email:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'signin-email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'signin-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'signin-password'},'Password:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'signin-password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{action:'submit',className:'btn btn-large'},'Sign In')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l3'})));}}]);return SignIn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;function mapStateToProps(state){return{errorMessage:state.auth.error,authenticated:state.auth.authenticated};}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_3__actions__)(SignIn));/* END */

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignOut=function(_Component){_inherits(SignOut,_Component);function SignOut(){_classCallCheck(this,SignOut);return _possibleConstructorReturn(this,(SignOut.__proto__||Object.getPrototypeOf(SignOut)).apply(this,arguments));}_createClass(SignOut,[{key:'componentWillMount',value:function componentWillMount(){this.props.signoutUser();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sign-out'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'You have been signed out!')));}}]);return SignOut;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null,__WEBPACK_IMPORTED_MODULE_2__actions__)(SignOut));

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(295);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthApp=function(_Component){_inherits(AuthApp,_Component);function AuthApp(){_classCallCheck(this,AuthApp);return _possibleConstructorReturn(this,(AuthApp.__proto__||Object.getPrototypeOf(AuthApp)).apply(this,arguments));}_createClass(AuthApp,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__navbar__["a" /* default */],null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',id:'push'},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */],null));}}]);return AuthApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AuthApp);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_misc_chart__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboard_equipmenthours__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_dashboard_missingTimesheet__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
8/7/2017
Alexander Self
Dashboard container
- Main dashboard container
***************************************************************///import { sortByDate } from '../reducers/dashboard_reducer';
//import { LABORS_HOURS_BY_FIELD, DENSITY_BY_FIELD } from '../constants';
//import DashboardCard from '../components/dashboard/dashboard_card';
//import DensityTable from '../components/dashboard/dashboard_table_density';
//import FieldHoursTable from '../components/dashboard/dashboard_table_fieldHours';
//import AttendanceTable from '../components/dashboard/dashboard_table_attendance';
//import HeadCount from '../components/dashboard/dashboard_headcount';
//import DepartmentTable from '../components/dashboard/dashboard_table_departmentHours';
//import Leaderboard from '../components/dashboard/dashboard_leaderBoard';
//import HoursInfoCard from '../components/dashboard/dashboard_info_card';
//import DateRange from '../components/date_range';
//import { Sparklines, SparklinesLine } from 'react-sparklines';
var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(props){_classCallCheck(this,Dashboard);var _this=_possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call(this,props));_this.state={stackedChart:null,barChart:null,curChart:null,linechart:null,barLineChart:null,field:null};_this.drawStackedChart=_this.drawStackedChart.bind(_this);_this.drawHoursByFieldBarChart=_this.drawHoursByFieldBarChart.bind(_this);_this.drawBagTreeDensities=_this.drawBagTreeDensities.bind(_this);return _this;}_createClass(Dashboard,[{key:'componentDidMount',value:function componentDidMount(){// Need to make sure data is not fetched twice
if(this.props.eid){this.props.fetchData();if(!this.props.user.firstName)this.props.fetchUserProfile(this.props.eid);}document.title='Time Management';}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){// Draw charts here
//this.drawStackedChart(newProps.hoursByDepartment);
//this.drawHoursByFieldBarChart(newProps.fieldHours);
//this.drawBagTreeDensities(newProps.bagDensities);
}},{key:'drawStackedChart',value:function drawStackedChart(props){if(!props)return;if(this.state.stackedChart)this.state.stackedChart.update();var ctx=document.getElementById("stackedChart");var labels=props.map(function(val){return val.department;});var regHours=props.map(function(val){return val.regHours;});var otHours=props.map(function(val){return val.otHours;});var myChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_charts_misc_chart__["a" /* StackedBarChart */])(ctx,labels,regHours,otHours,'Regular Hours','Overtime');this.setState({stackedChart:myChart});}},{key:'drawHoursByFieldBarChart',value:function drawHoursByFieldBarChart(props){if(!props)return;if(this.state.barChart)this.state.barChart.destroy();var ctx=document.getElementById("barChart");var labels=props.map(function(val){return val.field;});var hours=props.map(function(val){return val.totalHours;});var barChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_charts_misc_chart__["b" /* BarChart */])(ctx,labels,hours,'','Total Hours');this.setState({barChart:barChart});}},{key:'drawnLineChart',value:function drawnLineChart(props){if(!props)return;if(this.state.lineChart)this.state.lineChart.update();var ctx=document.getElementById("lineChart");var labels=props.map(function(val){return val.field;});var hours=props.map(function(val){return val.totalHours;});var lineChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_charts_misc_chart__["c" /* LineChart */])(ctx,labels,hours,'Hours By Field','Total Hours');this.setState({lineChart:lineChart});}},{key:'drawBagTreeDensities',value:function drawBagTreeDensities(props){if(!props)return;if(this.state.barLineChart)this.state.barLineChart.destroy();var ctx=document.getElementById("barLineChart").getContext("2d");var labels=props.map(function(val){return val.field;});var trees=props.map(function(val){return val.treesCovered;});var bags=props.map(function(val){return val.bagsCount;});var densities=props.map(function(val){return val.density;});// Params: ctx, labels, data1, data2, data3, label1, label2, label3
var barLineChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_charts_misc_chart__["d" /* StackedBarChartWithLine */])(ctx,labels,densities,trees,bags,'Density','Trees','Bags');this.setState({barLineChart:barLineChart});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// Do nothing dates={<DateRange dateID1={'department-date-1'} dateID2={'department-date-2'} onClick={() => Materialize.toast('Available soon!', 'green rounded' ,3000)} />}
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h5',null,'Dashboard ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('button',{onClick:this.props.enlargeGraphs,className:'btn waves-effect graph-resize'},this.props.graphSize==='6'?'Enlarge Graphs':'Shrink Graphs'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_6_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l'+this.props.graphSize+' xl'+this.props.graphSize},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_dashboard_dashboard_missingTimesheet__["a" /* default */],{empsWOTS:this.props.empsWOTS,fetchMissingTimesheets:this.props.fetchMissingTimesheets}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'col s12 m12 l'+this.props.graphSize+' xl'+this.props.graphSize},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboard_equipmenthours__["a" /* default */],{equipmentHours:this.props.equipmentHours,sortBy:this.props.sortByOperation})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',null,this.state.field))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated,bagDensities:state.dashboard.bagDensities.displaying,eid:state.auth.user.guid,employeeAttendance:state.dashboard.employeeAttendance.displaying,empsWOTS:state.dashboard.empsWOTS,equipmentHours:state.dashboard.equipmentHours,fieldHours:state.dashboard.fieldHours.displaying,graphSize:state.dashboard.graphSize,headCount:state.dashboard.headCount,headCountDate:state.dashboard.headCountDate,hoursByDepartment:state.dashboard.hoursByDepartment,laborHours:state.dashboard.laborHours,leaderBoard:state.dashboard.leaderBoard.displaying,totalLbs:state.dashboard.leaderBoard.totalLbs,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux__["c" /* bindActionCreators */])({fetchData:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["a" /* fetchData */],switchLocation:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["b" /* switchLocation */],fetchUserProfile:__WEBPACK_IMPORTED_MODULE_2__actions_index__["fetchUserProfile"],enlargeGraphs:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["c" /* enlargeGraphs */],fetchHeadCount:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["d" /* fetchHeadCount */],sortByOperation:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["e" /* sortByOperation */],fetchHoursByField:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["f" /* fetchHoursByField */],fetchHoursByDepartment:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["g" /* fetchHoursByDepartment */],fetchMissingTimesheets:__WEBPACK_IMPORTED_MODULE_1__actions_dashboard_actions__["h" /* fetchMissingTimesheets */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Dashboard));/*if ('caches' in window) {
  caches.open('test-cache').then((cache) => {
    cache.addAll(['/', '/img/geo.png'])
      .then(() => {
        console.log('Geo.png is cached!');
      });
  });
}
['a','b','c','d','e','f','g','h','i','j','k'].map((v, i) => {
  localforage.setItem(v, i).then((val) => {
    console.log(val)
  }).catch((err) => {
    console.log(err);
  });
});
*//* END */

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabs__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/var Harvest=function(_Component){_inherits(Harvest,_Component);function Harvest(){_classCallCheck(this,Harvest);return _possibleConstructorReturn(this,(Harvest.__proto__||Object.getPrototypeOf(Harvest)).apply(this,arguments));}_createClass(Harvest,[{key:'componentDidMount',value:function componentDidMount(){document.title='Harvest';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Harvest ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_tabs__["a" /* default */],{id:"mechHarvest",tabs:__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* MECH_HARVEST_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children));}}]);return Harvest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Harvest));/* END */

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_url_list__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_action_button__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_preloader__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dashboard_GeneralMap__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_map_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_kauSatelliteMap_final_jpg__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_kauSatelliteMap_final_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_kauSatelliteMap_final_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_keaauMap_final_jpg__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_keaauMap_final_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_keaauMap_final_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Main=function(_Component){_inherits(Main,_Component);function Main(props){_classCallCheck(this,Main);var _this=_possibleConstructorReturn(this,(Main.__proto__||Object.getPrototypeOf(Main)).call(this,props));_this.state={field:null};return _this;}_createClass(Main,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){if(!this.props.user)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__navbar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main-body'},this.props.mapView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'map-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'preloader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_preloader__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'map-field-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.props.field?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Field: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.field)):''))),this.props.location==='kau'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_dashboard_GeneralMap__["a" /* default */],{onclick:this.props.fetchFieldInfo,onmouseover:this.props.setFieldView,_map:__WEBPACK_IMPORTED_MODULE_10__img_kauSatelliteMap_final_jpg___default.a,fields:__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* KAU_FIELD_MAP */],mapId:'kaumap',id:'kauMap',selectedField:this.props.selectedFieldInfo,fieldHours:this.props.fieldHours,fieldHoursByDate:this.props.fieldHoursByDate,lastVisited:this.props.lastVisited,harvest:this.props.harvest,work:this.props.work})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_dashboard_GeneralMap__["a" /* default */],{onclick:this.props.fetchFieldInfo,onmouseover:this.props.setFieldView,_map:__WEBPACK_IMPORTED_MODULE_11__img_keaauMap_final_jpg___default.a,fields:__WEBPACK_IMPORTED_MODULE_3__constants__["v" /* KEAAU_FIELD_MAP */],mapId:'keaaumap',id:'keaauMap',selectedField:this.props.selectedFieldInfo,fieldHours:this.props.fieldHours,fieldHoursByDate:this.props.fieldHoursByDate}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',id:'push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l1 xl1 nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_url_list__["a" /* default */],{listItems:__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* URLS */],_class:'side-navigation',id:'url-nav'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l11 xl11 content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'preloader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_preloader__["a" /* default */],null))),this.props.children))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide-on-large-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_action_button__["a" /* default */],{urls:__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* URLS */]})));}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated,message:state.auth.message,user:state.auth.user,payPeriod:state.misc.payPeriod,mapView:state.misc.mapView,field:state.misc.field,location:state.misc.location,selectedFieldInfo:state.misc.fieldInfo.basicInfo,fieldHours:state.misc.fieldInfo.hours,lastVisited:state.misc.fieldInfo.lastVisited,harvest:state.misc.fieldInfo.harvest,work:state.misc.fieldInfo.work};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({setFieldView:__WEBPACK_IMPORTED_MODULE_9__actions_map_actions__["a" /* setFieldView */],fetchFieldInfo:__WEBPACK_IMPORTED_MODULE_9__actions_map_actions__["b" /* fetchFieldInfo */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Main));/* END */

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tabs__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Displays user profiles
***************************************************************/var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){_classCallCheck(this,Profile);return _possibleConstructorReturn(this,(Profile.__proto__||Object.getPrototypeOf(Profile)).apply(this,arguments));}_createClass(Profile,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.employees.length===0)return this.props.fetchAllEmployees(this.props.user.level,this.props.user.email,this.props.user.guid);document.title='Profile';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h5',null,'Profile ',__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_6_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_tabs__["a" /* default */],{id:"profile",tabs:__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PROFILE_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,this.props.children));}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user,authenticated:state.auth.authenticated,employees:state.profile.employees};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["c" /* bindActionCreators */])({fetchAllEmployees:__WEBPACK_IMPORTED_MODULE_2__actions_profile_actions__["k" /* fetchAllEmployees */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Profile));/* END */

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabs__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/var GangBuilder=function(_Component){_inherits(GangBuilder,_Component);function GangBuilder(){_classCallCheck(this,GangBuilder);return _possibleConstructorReturn(this,(GangBuilder.__proto__||Object.getPrototypeOf(GangBuilder)).apply(this,arguments));}_createClass(GangBuilder,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.employees.length===0)return this.props.fetchTimesheetData(this.props.user);document.title='Team Builder';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Team Builder ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_0_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_tabs__["a" /* default */],{id:"gangs",tabs:__WEBPACK_IMPORTED_MODULE_5__constants__["q" /* TEAM_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.children));}}]);return GangBuilder;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user,authenticated:state.auth.authenticated,employees:state.timesheet.employees};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({fetchTimesheetData:__WEBPACK_IMPORTED_MODULE_4__actions_index__["fetchTimesheetData"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GangBuilder));/* END */

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_team_actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabs__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***************************************************************
5/22/2017
Alexander Self
Timesheet Container
- Displays all timesheet components; handles pre-fetching; routes, tabs
***************************************************************/var Timesheet=function(_Component){_inherits(Timesheet,_Component);function Timesheet(){_classCallCheck(this,Timesheet);return _possibleConstructorReturn(this,(Timesheet.__proto__||Object.getPrototypeOf(Timesheet)).apply(this,arguments));}_createClass(Timesheet,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.employees.length===0){this.props.fetchTimesheetData(this.props.user);this.props.fetchGangs();}if(Object.keys(this.props.payPeriod).length===0)this.props.fetchPayPeriod();document.title='Timesheets';return;}},{key:'render',value:function render(){if(!this.props.employees)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Timesheet ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_tabs__["a" /* default */],{id:"timesheet",tabs:__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* TIMESHEET_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children));}}]);return Timesheet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{authenticated:state.auth.authenticated,user:state.auth.user,employees:state.timesheet.employees,myEmployees:state.timesheet.myEmployees,payPeriod:state.misc.payPeriod};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({fetchTimesheetData:__WEBPACK_IMPORTED_MODULE_4__actions__["fetchTimesheetData"],fetchGangs:__WEBPACK_IMPORTED_MODULE_5__actions_team_actions__["a" /* fetchGangs */],fetchPayPeriod:__WEBPACK_IMPORTED_MODULE_4__actions__["fetchPayPeriod"],fetchMyEmployees:__WEBPACK_IMPORTED_MODULE_4__actions__["fetchMyEmployees"]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Timesheet));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setDocs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/*******************************************************************************
Documentation Actions

*******************************************************************************///import { ROOT_URL } from '../../constants';
//const Materialize = window.Materialize;
function setDocs(docType){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["_13" /* SET_DOCS */],payload:docType};}/*
function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: ERROR,
    err
  };
}*//* END */

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCultivationReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/*******************************************************************************
Reports Actions

*******************************************************************************/var $=window.$;/**
* fetchCultivationReport(): Fetches cultivation report
* @param {Object} opts: form options
* @param {Object} user: user object
* @returns {Array}
* @called-in: ['/components/reports/reports.js']
**/function fetchCultivationReport(_ref){var opts=_ref.opts,user=_ref.user;if(opts.dateFrom===''||opts.dateTo==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('Please select two dates.');if(opts.type==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('Please select a report type.');$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ROOT_URL */]+'/fetchCultivationReport',{headers:{authorization:localStorage.getItem('token')},params:{opts:opts,email:user.email}}).then(function(res){$('#preloader').css('display','none');var _res$data=res.data,msg=_res$data.msg,query=_res$data.query;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["b" /* success */])(msg);//console.log(res.data)
dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_10" /* FETCH_CULTIVATION_REPORT */],payload:query});}).catch(function(e){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chem_actions__["a" /* error */])('There was an issue fetching a report'));});};}/* END */

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchInventory;
/* harmony export (immutable) */ __webpack_exports__["b"] = createInventoryRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = editInventoryRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteInventoryRequest;
/* harmony export (immutable) */ __webpack_exports__["g"] = prepareInventory;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveInventoryRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = downloadInventory;
/* harmony export (immutable) */ __webpack_exports__["h"] = setFormType;
/* harmony export (immutable) */ __webpack_exports__["j"] = setInventoryToEdit;
/* harmony export (immutable) */ __webpack_exports__["i"] = setInventoryToDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/30/2020
Tree Inventory Actions
**********************************************************/var FileSaver=__webpack_require__(176);var $=window.$;/**
* fetchInventory(): Fetches all current inventory and the 30 most recent transactions
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
**/function fetchInventory(){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchInventory',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');var _res$data=res.data,inventory=_res$data.inventory,inventoryTransactions=_res$data.inventoryTransactions,approvers=_res$data.approvers;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["v" /* FETCH_INVENTORY */],inventory:inventory,inventoryTransactions:inventoryTransactions,approvers:approvers});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error fetching inventory. '+err));});};}/**
* createInventoryRequest(): Creates an inventory request
* @param {Object} data: form data + inventory batch(If new)
* @param {String} formType: type of form and path to server function
* @param {Array} inventory: Master inventory records
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
**/function createInventoryRequest(_ref){var data=_ref.data,formType=_ref.formType,inventory=_ref.inventory;/* Check whether this is a issuedOrReceived and if an existing inventory location exists
     If inventory does not exist in a location and a user is tryng to issue, throw an error
     to issue from a specific location
     If inventory does exist in a location and a new batch is being created for an existing master record
     throw an error
     Approver required
  */var issuedOrReceived=data.issuedOrReceived,field=data.field,date=data.date;if(date==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select a date.');if(issuedOrReceived==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select an option from the Issue or Receive field');if(formType==='issueOrReceiveInventory'&&!inventory.find(function(f){return f.physicalLocation===field;})){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select a field that contains inventory or create a new batch');}if(formType==='createInventoryBatch'&&inventory.find(function(f){return f.physicalLocation===field;})){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Inventory exists for the field. Select Issue or Receive Inventory to submit transaction.');}if(formType==='createInventoryBatch'&&issuedOrReceived==='I'){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Cannot issue inventory from a batch that does not exist.');}if(Object.keys(data.approver).length<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select an approver from the list.');$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/createInventoryRequest',{data:data,formType:formType}).then(function(res){$('#preloader').css('display','none');var _res$data2=res.data,inventory=_res$data2.inventory,inventoryTransaction=_res$data2.inventoryTransaction,msg=_res$data2.msg,createBatch=_res$data2.createBatch;if(!createBatch)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])(msg);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["a" /* clearForm */])('tree-inventory-form');document.getElementById('treeInv-issuedOrReceived').selectedIndex=0;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(msg);switch(formType){case'issueOrReceiveInventory':dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["w" /* ISSUE_OR_RECEIVE_INVENTORY_REQUEST */],inventoryTransaction:inventoryTransaction});break;case'createInventoryBatch':dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["x" /* CREATE_INVENTORY_REQUEST */],inventory:inventory,inventoryTransaction:inventoryTransaction});break;default:break;}}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error submitting an inventory request. '+err));});};}/**
* editInventoryRequest(): Edits an inventory request
* @param {Object} data: form data + inventory batch(If new)
* @param {String} formType: type of form and path to server function
* @param {Array} inventory: Master inventory records
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js->tree_inventory_transaction_table.js']
**/function editInventoryRequest(_ref2){var data=_ref2.data,user=_ref2.user,oldInventoryRecord=_ref2.oldInventoryRecord,formType=_ref2.formType,formId=_ref2.formId,inventory=_ref2.inventory;var issuedOrReceived=data.issuedOrReceived,field=data.field,date=data.date;if(date==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select a date.');if(issuedOrReceived==='')return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select an option from the Issue or Receive field');if(formType==='issueOrReceiveInventory'&&!inventory.find(function(f){return f.physicalLocation===field;})){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select a field that contains inventory or create a new batch');}if(formType==='createInventoryBatch'&&inventory.find(function(f){return f.physicalLocation===field;})){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Inventory exists for the field. Select Issue or Receive Inventory to submit transaction.');}if(formType==='createInventoryBatch'&&issuedOrReceived==='I'){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Cannot issue inventory from a batch that does not exist.');}if(Object.keys(data.approver).length<=0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Please select an approver from the list.');$('#preloader').css('display','block');/* Pre-fill missing properties that either need to be updated or referenced */data.submitter=user.eid;data.editedBy=user.eid;data.dateEdited=__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');data.id=oldInventoryRecord.id;data.inventoryId=oldInventoryRecord.inventoryId;data.masterRecord=0;// This is a master record; if the quantity is different, must update master record
if(inventory.find(function(i){return i.inventoryTotal===oldInventoryRecord.quantity&&i.physicalLocation===oldInventoryRecord.field&&__WEBPACK_IMPORTED_MODULE_6_moment___default()(i.lastDateReceived).format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_6_moment___default()(oldInventoryRecord.date).format('YYYY-MM-DD');})){data.masterRecord=1;}return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/editInventoryRequest',{data:data,formType:formType}).then(function(res){$('#preloader').css('display','none');var _res$data3=res.data,inventoryTransaction=_res$data3.inventoryTransaction,inventoryMaster=_res$data3.inventoryMaster,msg=_res$data3.msg;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["a" /* clearForm */])(formId);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["y" /* EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST */],payload:inventoryTransaction,inventoryMaster:inventoryMaster});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error submitting an inventory request. '+err));});};}/**
* deleteInventoryRequest(): Deletes an inventory request
* @param {Number} id: id of inventory
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js->tree_inventory_transaction_table.js']
**/function deleteInventoryRequest(inventory){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/deleteInventoryRequest',{inventory:inventory}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["z" /* DELETE_INVENTORY_REQUEST */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error submitting an inventory request. '+err));});};}/**
* prepareInventory(): Prepares a tree inventory request
* @param {Object} user: user record
* @param {Object} form: packaged form
* @param {String} formType: type of form
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
**/function prepareInventory(_ref3){var user=_ref3.user,form=_ref3.form,formType=_ref3.formType;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchPreviousInventory',{params:{field:form.field,approver:form.approver},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');var _res$data4=res.data,previousInventoryTransactions=_res$data4.previousInventoryTransactions,approver=_res$data4.approver;var inventoryId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["e" /* generateID */])();if(previousInventoryTransactions.length>0)inventoryId=previousInventoryTransactions[0].inventoryId;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["A" /* PREPARE_TREE_INVENTORY */],payload:Object.assign({},form,{submitter:user.eid,formType:formType,inventoryId:inventoryId,approver:approver.length>0?approver[0]:{},previousInventoryTransactions:previousInventoryTransactions})});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error fetching previous inventory. '+err));});};}/**
* approveInventoryRequest(): Approves of an inventory transaction
* @param {Object} user: Logged in user
* @param {Object} inventoryTransaction: Inventory request to be approved
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
* @notes only users who are approvers and logged in can approve of a inventory request
**/function approveInventoryRequest(_ref4){var user=_ref4.user,inventoryTransaction=_ref4.inventoryTransaction;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/approveInventoryRequest',{user:{eid:user.eid,email:user.email},inventoryTransaction:inventoryTransaction}).then(function(res){$('#preloader').css('display','none');var _res$data5=res.data,msg=_res$data5.msg,inventoryTransaction=_res$data5.inventoryTransaction,inventoryMaster=_res$data5.inventoryMaster;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(msg);console.log(res.data);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["B" /* APPROVE_INVENTORY_REQUEST */],inventoryTransaction:inventoryTransaction,inventoryMaster:inventoryMaster});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error approving an inventory request. '+err));});};}/**
* downloadInventory(): Downloads inventory record(s)
* @param {Object} i: inventory master object
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
**/function downloadInventory(i){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/downloadInventory',{params:{inventoryId:i.inventoryId},headers:{authorization:localStorage.getItem('token')}}).then(function(res){$('#preloader').css('display','none');var _res$data6=res.data,msg=_res$data6.msg,csv=_res$data6.csv;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(msg);var blob=new Blob([csv],{type:"text/plain;charset=utf-8"});FileSaver.saveAs(blob,'Inventory Transactions - '+i.physicalLocation+' - '+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')+'.csv');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["C" /* DOWNLOAD_INVENTORY */]});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error fetching inventory. '+err));});};}/**
* setFormType(): Sets the type of form: Creating a new inventory batch; or issuing or receiving
  inventory
* @param {String} formType: Create New Inventory Batch or Issue or Receive Inventory
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js']
**/function setFormType(formType){if(formType==='createInventoryBatch'){formType='issueOrReceiveInventory';document.getElementById('treeInv-issuedOrReceived').selectedIndex=0;document.getElementById('treeInv-issuedOrReceived').value='I';}else if(formType==='issueOrReceiveInventory'){formType='createInventoryBatch';document.getElementById('treeInv-issuedOrReceived').selectedIndex=1;document.getElementById('treeInv-issuedOrReceived').value='R';}return{type:__WEBPACK_IMPORTED_MODULE_0__types__["D" /* SET_FORM_TYPE */],payload:formType};}/**
* setInventoryToEdit(): Sets the inventory to be edited
* @param {Object} inventory: copy of inventory to be edited
* @param {String} formId: Id of form to be pre-filled
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js->tree_inventory_transaction_table.js']
**/function setInventoryToEdit(_ref5){var inventory=_ref5.inventory,formId=_ref5.formId;/* 
     Fill form
     Set  
  */return function(dispatch){dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["c" /* fetchFields */])(inventory.location));setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["f" /* fillForm */])(formId,inventory);},200);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["E" /* SET_INVENTORY_TO_EDIT */],payload:inventory});};}/**
* setInventoryToDelete(): Sets the inventory to be deleted
* @param {Object} inventory: copy of inventory to be edited
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_inventory.js->tree_inventory_transaction_table.js']
**/function setInventoryToDelete(inventory){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["F" /* SET_INVENTORY_TO_DELETE */],payload:inventory};}/* END */

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchReplants;
/* harmony export (immutable) */ __webpack_exports__["c"] = createReplant;
/* harmony export (immutable) */ __webpack_exports__["e"] = editReplant;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteReplant;
/* harmony export (immutable) */ __webpack_exports__["g"] = prepareReplant;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEmployee;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeEmployee;
/* harmony export (immutable) */ __webpack_exports__["k"] = setReplantToEdit;
/* harmony export (immutable) */ __webpack_exports__["b"] = addEmployeeToEdit;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeEmployeeFromEdit;
/* harmony export (immutable) */ __webpack_exports__["j"] = setReplantToDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4/20/2020
Tree Replant Actions
**********************************************************///const FileSaver = require('file-saver');
var $=window.$;/**
* fetchReplants(): Fetches replant logs
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js']
**/function fetchReplants(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchReplants',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){var replants=res.data.replants;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_REPLANTS */],payload:replants});}).catch(function(e){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error fetching replants '+e));});};}/**
* createReplant(): Creates a replant log 
* @param {Object} data: submission
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js']
**/function createReplant(_ref){var data=_ref.data,formId=_ref.formId;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["d" /* checkApplicationForm */])(data))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Entire form must be filled.');if(data.addedEmployees.length===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Must select at least one employee.');// Set isComplete based on treesRemaining
data.isComplete=data.treesRemaining===0?1:0;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/createReplant',{data:data}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["a" /* clearForm */])(formId);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(res.data.msg);var replant=res.data.replant;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["b" /* CREATE_REPLANT */],payload:replant});}).catch(function(e){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error creating a replant log'));});};}/**
* editReplant(): Edits a replant log
* @param {Object} data: form data + inventory batch(If new)
* @param {Object} user: logged in user
* @param {Object} oldReplantRecord: record being edited
* @param {Array} inventory: inventory records
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function editReplant(_ref2){var data=_ref2.data,user=_ref2.user,oldReplantRecord=_ref2.oldReplantRecord,formId=_ref2.formId,addedEmployees=_ref2.addedEmployees;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["d" /* checkApplicationForm */])(data))return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Entire form must be filled.');if(addedEmployees.length===0)return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('Must select at least one employee.');/* Pre-fill missing properties that either need to be updated or referenced */data.submitter=user.eid;data.editedBy=user.eid;data.dateEdited=__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');data.id=oldReplantRecord.id;data.replantId=oldReplantRecord.replantId;data.treesRemaining=Math.abs(Number(data.treesPlanted)-(Number(oldReplantRecord.treesPlanted)+Number(oldReplantRecord.treesRemaining)));data.treesPerHour=data.treesPlanted&&data.hours?Number((Number(data.treesPlanted)/Number(data.hours)).toFixed(2)):0;data.employees=JSON.stringify(addedEmployees);$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/editReplant',{data:data}).then(function(res){$('#preloader').css('display','none');var _res$data=res.data,replant=_res$data.replant,msg=_res$data.msg;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["a" /* clearForm */])(formId);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["c" /* EDIT_REPLANT */],payload:replant});}).catch(function(err){$('#preloader').css('display','none');dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error submitting an inventory request. '+err));});};}/**
* deleteReplant(): Deletes a replant log 
* @param {Object} replant: record to be deleted
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function deleteReplant(replant){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/deleteReplant',{id:replant.id,replantId:replant.replantId}).then(function(res){$('#preloader').css('display','none');__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["b" /* success */])(res.data.msg);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["d" /* DELETE_REPLANT */]});}).catch(function(e){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error deleting a replant log'));});};}/**
* prepareReplant(): Prepares an replant log for review prior to submission
* @param {Object} user: user data
* @param {Object} form: form data
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js']
**/function prepareReplant(_ref3){var user=_ref3.user,form=_ref3.form,inventoryTransactions=_ref3.inventoryTransactions;var inv=inventoryTransactions.find(function(i){return Number(i.id)===Number(form.inventoryTransactionId);});return function(dispatch){__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchPreviousReplants',{params:{field:form.field,inventoryId:form.inventoryTransactionId},headers:{authorization:localStorage.getItem('token')}}).then(function(res){var prevReplants=res.data.prevReplants;var treesRemaining=inv?Math.abs(Number(form.treesPlanted)-inv.quantity):0;var replantId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["e" /* generateID */])();// Keep same replantId: All replants that fall under a inventory transaction have the same unique grouping id
if(prevReplants.length>0){replantId=prevReplants[0].replantId;treesRemaining=Math.abs(Number(form.treesPlanted)-Math.min.apply(Math,_toConsumableArray(prevReplants.map(function(p){return p.treesRemaining;}))));}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["e" /* PREPARE_REPLANT */],payload:Object.assign({},form,{replantId:replantId,totalTrees:inv?inv.quantity:0,treesRemaining:treesRemaining,treesPerHour:form.treesPlanted&&form.hours?Number((Number(form.treesPlanted)/Number(form.hours)).toFixed(2)):0,submitter:user.eid,inventoryTransaction:inv,prevReplants:prevReplants})});}).catch(function(e){return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chem_actions__["a" /* error */])('There was an error fetching previous replants'));});};}/**
* addEmployee(): Adds an employee to a replant log
* @param {Object} val: employee data
* @param {String} id: id of autocomplete input to clear value
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js']
**/function addEmployee(val,id){if(id)document.getElementById(id).value='';return{type:__WEBPACK_IMPORTED_MODULE_0__types__["f" /* ADD_EMPLOYEE */],payload:{eid:val.eid,name:val.firstName+' '+val.lastName,position:val.positionTitle}};}/**
* removeEmployee(): Removes an employee from a replant log
* @param {Object} val: employee data
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js']
**/function removeEmployee(val){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["g" /* REMOVE_EMPLOYEE */],payload:val};}/**
* setReplantToEdit(): Sets the replant log to be edited
* @param {Object} replant: copy of replant to be edited
* @param {String} formId: Id of form to be pre-filled
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function setReplantToEdit(_ref4){var replant=_ref4.replant,formId=_ref4.formId;return function(dispatch){dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_actions__["c" /* fetchFields */])(replant.location));setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["f" /* fillForm */])(formId,replant);},200);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["h" /* SET_REPLANT_TO_EDIT */],payload:replant});};}/**
* addEmployee(): Adds an employee to a replant log
* @param {Object} val: employee data
* @param {String} id: id of autocomplete input to clear value
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function addEmployeeToEdit(val,id){if(id)document.getElementById(id).value='';return{type:__WEBPACK_IMPORTED_MODULE_0__types__["i" /* ADD_EMPLOYEE_TO_EDIT */],payload:{eid:val.eid,name:val.firstName+' '+val.lastName,position:val.positionTitle}};}/**
* removeEmployee(): Removes an employee from a replant log
* @param {Object} val: employee data
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function removeEmployeeFromEdit(val){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["j" /* REMOVE_EMPLOYEE_FROM_EDIT */],payload:val};}/**
* setReplantToDelete(): Sets the replant log to be deleted
* @param {Object} replant: copy of replant to be deleted
* @returns {Object} type, payload
* @called-in: ['/components/tree_replant/tree_replant.js->tree_replant_table.js']
**/function setReplantToDelete(replant){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["k" /* SET_REPLANT_TO_DELETE */],payload:replant};}/* END */

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var ChemicalApplicationContainer=function(_Component){_inherits(ChemicalApplicationContainer,_Component);function ChemicalApplicationContainer(){_classCallCheck(this,ChemicalApplicationContainer);return _possibleConstructorReturn(this,(ChemicalApplicationContainer.__proto__||Object.getPrototypeOf(ChemicalApplicationContainer)).apply(this,arguments));}_createClass(ChemicalApplicationContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* default */],{tabs:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["f" /* CHEMICAL_APP_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,this.props.children));}}]);return ChemicalApplicationContainer;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChemicalApplicationContainer));/* END */

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chem_app_form__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chem_app_list__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chem_app_display__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Create
**********************************************************/var ChemicalApplicationCreate=function(_Component){_inherits(ChemicalApplicationCreate,_Component);function ChemicalApplicationCreate(){_classCallCheck(this,ChemicalApplicationCreate);return _possibleConstructorReturn(this,(ChemicalApplicationCreate.__proto__||Object.getPrototypeOf(ChemicalApplicationCreate)).apply(this,arguments));}_createClass(ChemicalApplicationCreate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.chemicalList.length===0)this.props.fetchChemicals();if(this.props.employees.length===0)this.props.fetchEmployees();if(Object.keys(this.props.cert).length===0)this.props.fetchCertification();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},Object.keys(this.props.user).length===0?'':this.props.user.level>=3||this.props.user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'chem-container'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__chem_app_list__["a" /* default */],{chemAppList:this.props.chemicalApplications.filter(__WEBPACK_IMPORTED_MODULE_7__cult_utils__["k" /* filterOldRecords */]),chemicals:this.props.chemicalList.filter(function(c){return c.type!=='Fertilizer'&&c.type!=='Nutrient';}),onClick:function onClick(c){return _this2.props.selectChemAppToEdit({formId:'chemical-application-form',chem:c,chemicalList:_this2.props.chemicalList,employees:_this2.props.employees});}}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__chem_app_form__["a" /* default */],{formId:'chemical-application-form',chemicalList:this.props.chemicalList.filter(function(c){return c.type!=='Fertilizer'&&c.type!=='Nutrient';}),fields:this.props.fields,employees:this.props.employees,solutions:this.props.solutions,isEditing:this.props.isEditing,totalGallons:this.props.totalGallons,eid:this.props.eid,cert:this.props.cert,editingApplication:this.props.editingApplication,setTotalGallons:this.props.setTotalGallons,fetchFields:this.props.fetchFields,addSolution:this.props.addSolution,selectField:this.props.selectField,editSolution:this.props.editSolution,deleteSolution:this.props.deleteSolution,selectSolutionToEdit:this.props.selectSolutionToEdit,_editSolution:this.props._editSolution}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#chem-app-prepare',onClick:function onClick(){return _this2.props.prepareData({user:_this2.props.user,form:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cult_utils__["c" /* packageForm */])('chemical-application-form'),selectedField:_this2.props.selectedField,employees:_this2.props.employees,solutions:_this2.props.solutions,deletedSolutions:_this2.props.deletedSolutions,submitter:_this2.props.eid,certId:_this2.props.cert.certNo,chemAppId:_this2.props.chemAppId,editingApplication:_this2.props.editingApplication});}},'Prepare'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button',{className:'btn btn-flat',onClick:function onClick(){return _this2.props.clearForm('chemical-application-form');}},'Clear')),this.props.editingApplication?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__chem_app_display__["a" /* default */])// eslint-disable-next-line
({id:'chem-app-prepare',footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createOrEditChemicalApplication({data:_this2.props.application,type:'EDIT_CHEMICAL_APPLICATION',path:'editChemicalApplication'});},application:this.props.application,employees:this.props.employees,solutions:this.props.solutions,chemicalList:this.props.chemicalList,previousApplications:this.props.previousApplications}):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__chem_app_display__["a" /* default */])// eslint-disable-next-line
({id:'chem-app-prepare',footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createOrEditChemicalApplication({data:_this2.props.application,type:'CREATE_CHEMICAL_APPLICATION',path:'createChemicalApplication'});},application:this.props.application,employees:this.props.employees,solutions:this.props.solutions,chemicalList:this.props.chemicalList,previousApplications:this.props.previousApplications}))))):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5',null,'Unauthorized')));}}]);return ChemicalApplicationCreate;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);function mapStateToProps(state){return{application:state.cultivation.chemApp.app.application,cert:state.cultivation.utils.cert,chemicalApplications:state.cultivation.chemApp.chemicalApplications.displaying,chemAppId:state.cultivation.chemApp.app.chemAppId,chemicalList:state.cultivation.chemical.chemicalList,deletedSolutions:state.cultivation.chemApp.app.deletedSolutions,editingApplication:state.cultivation.chemApp.app.editingApplication,_editSolution:state.cultivation.chemApp.app.editSolution,eid:state.auth.user.guid,employees:state.cultivation.utils.employees,fields:state.cultivation.utils.fields,isEditing:state.cultivation.chemApp.app.isEditing,previousApplications:state.cultivation.chemApp.app.previousApplications,selectedField:state.cultivation.chemApp.app.selectedField,solutions:state.cultivation.chemApp.app.solutions,totalGallons:state.cultivation.chemApp.app.totalGallons,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_redux__["c" /* bindActionCreators */])({addSolution:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["a" /* addSolution */],clearForm:__WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__["a" /* clearForm */],createOrEditChemicalApplication:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["b" /* createOrEditChemicalApplication */],deleteSolution:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["c" /* deleteSolution */],editSolution:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["d" /* editSolution */],fetchCertification:__WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__["d" /* fetchCertification */],fetchChemicals:__WEBPACK_IMPORTED_MODULE_5__actions_chem_actions__["c" /* fetchChemicals */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__["b" /* fetchEmployees */],fetchFields:__WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__["c" /* fetchFields */],prepareData:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["e" /* prepareData */],selectField:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["f" /* selectField */],selectSolutionToEdit:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["g" /* selectSolutionToEdit */],selectChemAppToEdit:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["h" /* selectChemAppToEdit */],setTotalGallons:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["i" /* setTotalGallons */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChemicalApplicationCreate));/* END */

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chem_app_solution_table__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Form
**********************************************************/var propTypes={cert:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,chemicalList:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,eid:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,employees:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,isEditing:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,solutions:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,totalGallons:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,addSolution:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,editSolution:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,deleteSolution:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,fetchFields:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,selectSolutionToEdit:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,setTotalGallons:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func};var ChemicalApplicationForm=function(_Component){_inherits(ChemicalApplicationForm,_Component);function ChemicalApplicationForm(){_classCallCheck(this,ChemicalApplicationForm);return _possibleConstructorReturn(this,(ChemicalApplicationForm.__proto__||Object.getPrototypeOf(ChemicalApplicationForm)).apply(this,arguments));}_createClass(ChemicalApplicationForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'chemApp-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-kau',name:'chemApp-loc',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-keaau',name:'chemApp-loc',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* AutoComplete */],{id:'chemApp-fieldId',label:'Field',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["v" /* mapPropForAutoComplete */])(this.props.fields,'field'),onComplete:function onComplete(val,id){return _this2.props.selectField(_this2.props.fields,val,id,_this2.props.editChem);},onBlur:function onBlur(e){return _this2.props.selectField(_this2.props.fields,e.target.value,e.target.id,_this2.props.editChem);}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* AutoComplete */],{id:'chemApp-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["b" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_3__cult_utils__["o" /* onDummyComplete */]}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["i" /* TimePicker */],{id:'chemApp-startTime',label:'Start Time',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["i" /* TimePicker */],{id:'chemApp-endTime',label:'End Time',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemApp-acresCompleted',label:'Acres Completed',min:'0.00',max:'275',step:'0.01',defaultValue:0.00,required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemApp-round',label:'Round',min:'1',max:'10',step:'1.0',defaultValue:1,required:true}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Status'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-isCompleteYes',name:'chemApp-isComplete',label:'Complete',value:'Complete'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-isCompleteNo',name:'chemApp-isComplete',label:'Incomplete',value:'Incomplete'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Method'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-methodAirblast',name:'chemApp-method',label:'Airblast',value:'Airblast'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-methodBroadcast',name:'chemApp-method',label:'Broadcast',value:'Broadcast'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'chemApp-methodSpot',name:'chemApp-method',label:'Spot',value:'Spot'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemUsed-measurement',label:'Gallons Used',max:'50000',step:'0.01',defaultValue:0.00,onBlur:function onBlur(e){return _this2.props.setTotalGallons(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m8 l8 xl8'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemApp-notes',label:'Notes',defaultValue:'N/A'})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'chemicals-used-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemUsed-chemId',label:'Chemical',onChange:function onChange(e){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["w" /* setDosage */])({dosage:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["x" /* parseDosage */])(_this2.props.chemicalList.find(function(c){return c.id===Number(e.target.value);})),quantId:'chemUsed-chemDosage1',unitId:'chemUsed-chemDosage2'});},opts:this.props.chemicalList.map(function(c){return{label:c.name,val:c.id};})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemUsed-chemDosage1',label:'Quantity',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemUsed-chemDosage2',label:'Unit',opts:__WEBPACK_IMPORTED_MODULE_2__cult_constants__["a" /* UNITS_OF_MEASURE */].filter(function(c){return c.type==='volume'||c.type==='mass';})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},this.props.isEditing?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large blue chem-add',onClick:function onClick(){return _this2.props.editSolution({solution:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["c" /* packageForm */])('chemicals-used-form'),editSolution:_this2.props._editSolution,totalGallons:_this2.props.totalGallons,formId:'chemicals-used-form',chemicals:_this2.props.chemicalList});}},'Edit Solution')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large chem-add',onClick:function onClick(){return _this2.props.addSolution({solution:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["c" /* packageForm */])('chemicals-used-form'),totalGallons:_this2.props.totalGallons,formId:'chemicals-used-form',chemicals:_this2.props.chemicalList});}},'Add Solution'))))),this.props.solutions.length>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__chem_app_solution_table__["a" /* default */],{solutions:this.props.solutions,chemicalList:this.props.chemicalList,formId:'chemicals-used-form',edit:this.props.selectSolutionToEdit,_delete:this.props.deleteSolution,readOnly:false,editChem:false}))):'');}}]);return ChemicalApplicationForm;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);ChemicalApplicationForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ChemicalApplicationForm);/* END */

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/**********************************************************
Chemical App List: Lists all chemical products in the database
9/03/19
chemicalList: Array of chemical products
**********************************************************/var propTypes={chemAppList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,deleteChemicalApplication:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var ChemicalAppList=function ChemicalAppList(_ref){var chemAppList=_ref.chemAppList,chemicals=_ref.chemicals,_onClick=_ref.onClick;if(!chemAppList)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No Applications Available');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},chemAppList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:c.id,className:'collection-item chem-list-item',onClick:function onClick(){return _onClick(c);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(c.date).format('MM/DD/YYYY')),' - ',c.fieldId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fert-flex-list'},c.solutions.map(function(s){var chem=chemicals.find(function(_c){return _c.id===s.chemId;});var _determineIcon=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["y" /* determineIcon */])(chem.type),color=_determineIcon.color,icon=_determineIcon.icon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:s.id,className:'icon-shift'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons circle '+color+' darken-2'},icon));})));})));};ChemicalAppList.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ChemicalAppList);/* END */

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/var propTypes={chemicalList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,solutions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};var SolsTable=function SolsTable(_ref){var solutions=_ref.solutions,chemicalList=_ref.chemicalList;if(!solutions)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Chemical'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Chemical %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Dosage'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solutions.map(function(s,i){var chem=chemicalList.find(function(c){return c.id===Number(s.chemId);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:s.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,chem.name,' - ',chem.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,isNaN(s.percentageUsed)?0:s.percentageUsed,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.chemDosage));})));};SolsTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (SolsTable);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fab_modal__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/var propTypes={chemicalList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,chemicalApplications:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var ChemicalApplicationTable=function ChemicalApplicationTable(_ref){var chemicalApplications=_ref.chemicalApplications,chemicalList=_ref.chemicalList,employees=_ref.employees,readOnly=_ref.readOnly,centered=_ref.centered,selectedApp=_ref.selectedApp,selectApplicationToView=_ref.selectApplicationToView;if(!chemicalApplications)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);if(!employees)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered chem-app-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'chem-app-table-headers'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Employee'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Start Time'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'End Time'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Products'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Round'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'REI'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Pre-Harvest'),readOnly?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,chemicalApplications.map(function(s,i){var chems=s.solutions.map(function(sols){return sols.chemId;});var c=[];c=chems.map(function(chemId){return chemId===''?'':chemicalList.find(function(cl){return cl.id===Number(chemId);});});if(c===undefined||c[0]===undefined)c=[];var name='N/A';var emp={};if(employees.length>0&&s.employee!==undefined){emp=employees.find(function(e){return e.eid===s.employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'chem-app-table-row',key:s.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(s.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.fieldId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.startTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.endTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.hours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.acresCompleted),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.acresBalance<0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'red-text'},s.acresBalance):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,s.acresBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.isComplete===0||s.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,c.length>0?c.map(function(chem){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'chem-app-table-name',key:''+Math.random()+chem.id},chem.name,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null));}):''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.round),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.reiDaysRemaining,' days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,s.preHarvestDaysRemaining,' days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,readOnly?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__fab_modal__["a" /* default */],{key:s.id,chem:s,chemicalList:chemicalList,selectApplicationToView:selectApplicationToView,selectedApp:selectedApp})));})));};ChemicalApplicationTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ChemicalApplicationTable);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chem_app_table__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_utils_actions__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var ChemicalApplicationView=function(_Component){_inherits(ChemicalApplicationView,_Component);function ChemicalApplicationView(){_classCallCheck(this,ChemicalApplicationView);return _possibleConstructorReturn(this,(ChemicalApplicationView.__proto__||Object.getPrototypeOf(ChemicalApplicationView)).apply(this,arguments));}_createClass(ChemicalApplicationView,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchChemicalApplications();if(this.props.employees.length===0)this.props.fetchEmployees();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chem-app-table-view'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__chem_app_table__["a" /* default */],{chemicalApplications:this.props.chemicalApplications,chemicalList:this.props.chemicalList,employees:this.props.employees,selectApplicationToView:this.props.selectApplicationToView,selectedApp:this.props.selectedApp})));}}]);return ChemicalApplicationView;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{chemicalList:state.cultivation.chemical.chemicalList,chemicalApplications:state.cultivation.chemApp.chemicalApplications.displaying,employees:state.cultivation.utils.employees,selectedApp:state.cultivation.chemApp.view};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({fetchChemicalApplications:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["j" /* fetchChemicalApplications */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_5__actions_utils_actions__["b" /* fetchEmployees */],selectApplicationToView:__WEBPACK_IMPORTED_MODULE_4__actions_chem_app_actions__["k" /* selectApplicationToView */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChemicalApplicationView));/* END */

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chem_app_display__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_chem_app_actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/**********************************************************
Fab button Modal: Button actions for view, edit and deleting
**********************************************************/var $=window.$;var propTypes={chem:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,application:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,chemicalList:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,solutions:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,employees:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,deleteChemicalApplication:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func};// It's Fabulous!
var FabModal=function FabModal(_ref){var chem=_ref.chem,chemicalList=_ref.chemicalList,employees=_ref.employees,user=_ref.user,deleteChemicalApplication=_ref.deleteChemicalApplication,selectedApp=_ref.selectedApp,selectApplicationToView=_ref.selectApplicationToView;$(document).ready(function(){$('.tooltipped').tooltip();$('#'+chem.chemAppId+'-delete').modal();});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'btn-actions'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'btn-floating green pointer modal-trigger tooltipped btn-squared',href:'#'+chem.chemAppId+'-view',onClick:function onClick(){return selectApplicationToView(chem);},'data-position':'left','data-tooltip':'View'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'material-icons'},'subject'))),Object.keys(user).length===0?'':user.level>=3||user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'btn-floating red pointer modal-trigger tooltipped btn-squared '+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["k" /* filterOldRecords */])(chem)?'':'disabled'),href:'#'+chem.chemAppId+'-delete','data-position':'top','data-tooltip':'Delete'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'material-icons'},'clear'))):''),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,// eslint-disable-next-line
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__chem_app_display__["a" /* default */])// eslint-disable-next-line
({id:chem.chemAppId+'-view',footer:true,view:true,toDelete:false,chemicalList:chemicalList,employees:employees,solutions:chem.solutions,application:chem,selectApplicationToView:selectApplicationToView,selectedApp:selectedApp}),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__chem_app_display__["a" /* default */])// eslint-disable-next-line
({id:chem.chemAppId+'-delete',footer:true,view:false,toDelete:true,chemicalList:chemicalList,employees:employees,solutions:chem.solutions,application:chem,previousApplications:[],onClick:function onClick(){return deleteChemicalApplication(chem);}})));};function mapStateToProps(state){return{employees:state.cultivation.utils.employees,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["c" /* bindActionCreators */])({deleteChemicalApplication:__WEBPACK_IMPORTED_MODULE_2__actions_chem_app_actions__["l" /* deleteChemicalApplication */]},dispatch);}FabModal.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FabModal));/* END */

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_list__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cult_constants__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var ChemicalContainer=function(_Component){_inherits(ChemicalContainer,_Component);function ChemicalContainer(){_classCallCheck(this,ChemicalContainer);return _possibleConstructorReturn(this,(ChemicalContainer.__proto__||Object.getPrototypeOf(ChemicalContainer)).apply(this,arguments));}_createClass(ChemicalContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m1 l1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__url_list__["a" /* default */],{listItems:__WEBPACK_IMPORTED_MODULE_4__cult_constants__["k" /* PRODUCT_URLS */],id:'cult-url-nav'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m11 l11'},this.props.children));}}]);return ChemicalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChemicalContainer));/* END */

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Form
**********************************************************/var ChemicalForm=function(_Component){_inherits(ChemicalForm,_Component);function ChemicalForm(){_classCallCheck(this,ChemicalForm);return _possibleConstructorReturn(this,(ChemicalForm.__proto__||Object.getPrototypeOf(ChemicalForm)).apply(this,arguments));}_createClass(ChemicalForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{className:'chem-container',id:'chemical-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemical-name',label:'Brand Name',placeholder:'Goal XL, Herbimax, etc ',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemical-ingredients',label:'Ingredients',placeholder:'Glyphosate, etc',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemical-type',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["i" /* CHEMICAL_TYPES */],label:'Type',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemical-hawaiiRegistration',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["j" /* YES_OR_NO */],label:'Hawaii Registration'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemical-epaNo',label:'EPA#',placeholder:'56-1234-56',required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemical-manufacturer',label:'Manufacturer',placeholder:'DuPont Crop Protection'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemical-rei',label:'Restricted Entry Interval (REI)',min:"0",max:"120",step:"0.1",required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemical-preHarvestInterval',label:'Pre-Harvest Interval',min:"0",max:"120",step:"0.1",required:true}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'reco-dosage'},'Recommended Dosage'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemical-recoDosage1',label:'Quantity',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemical-recoDosage2',label:'Unit',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["a" /* UNITS_OF_MEASURE */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s1 m1 l1 xl1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',null,'/')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemical-recoDosage3',label:'Quantity',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemical-recoDosage4',label:'Unit',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["a" /* UNITS_OF_MEASURE */]}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s2 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'chemical-maxQuantity',label:'Max Quantity(Acre/Year)',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'chemical-maxQuantityUnit',label:'Unit',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["a" /* UNITS_OF_MEASURE */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'chemical-url',label:'Product URL',placeholder:'https://www.greenbook.net/syngenta-llc/aatrex-nine-o'})),this.props.isEditing?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'edit-file-list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'Current Files')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'Label:'),' ',this.props.editedChemical.label,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'SDS:'),' ',this.props.editedChemical.sds,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'Supp.Label:'),' ',this.props.editedChemical.supplementalLabel,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',null,'SLNL:'),' ',this.props.editedChemical.specialLocalNeedsLabel,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null))):'',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["k" /* FileButton */],{id:'chemical-label',name:'chemical-label',label:'Product Label',_class:'file-btn-label'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["k" /* FileButton */],{id:'chemical-sds',name:'chemical-sds',label:'Safety Data Sheet',_class:'file-btn-label'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["k" /* FileButton */],{id:'chemical-supplementalLabel',name:'chemical-supplementalLabel',label:'Supplemental Label',_class:'file-btn-label'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["k" /* FileButton */],{id:'chemical-specialLocalNeedsLabel',name:'chemical-specialLocalNeedsLabel',label:'Special Local Needs Label',_class:'file-btn-label'}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,this.props.isEditing?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn waves-effect blue',onClick:function onClick(){return _this2.props.createOrEditChemical(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["c" /* packageForm */])('chemical-form'),_this2.props.eid,__WEBPACK_IMPORTED_MODULE_2__actions_types__["_11" /* EDIT_CHEMICAL */],'editChemical',_this2.props.editedChemical);}},'Edit Product')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.clearForm('chemical-form');},className:'btn waves-effect flat'},'Clear Form'))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.createOrEditChemical(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cult_utils__["c" /* packageForm */])('chemical-form'),_this2.props.eid,__WEBPACK_IMPORTED_MODULE_2__actions_types__["_12" /* CREATE_CHEMICAL */],'createChemical');},className:'btn waves-effect'},'Create New Product')));}}]);return ChemicalForm;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChemicalForm);/* END */

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**********************************************************
Chemical List: Lists all chemical products in the database
7/22/19
chemicalList: Array of chemical products
**********************************************************/var ChemicalList=function ChemicalList(_ref){var chemicalList=_ref.chemicalList,_onClick=_ref.onClick;if(!chemicalList)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"No Products Available");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"collection"},chemicalList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:c.id,className:"collection-item chem-list-item",onClick:function onClick(){return _onClick(c);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,c.name)," - ",c.type));})));};/* harmony default export */ __webpack_exports__["a"] = (ChemicalList);/* END */

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chemical_form__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chemical_list__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_view__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var $=window.$;var ChemicalView=function(_Component){_inherits(ChemicalView,_Component);function ChemicalView(){_classCallCheck(this,ChemicalView);return _possibleConstructorReturn(this,(ChemicalView.__proto__||Object.getPrototypeOf(ChemicalView)).apply(this,arguments));}_createClass(ChemicalView,[{key:'componentDidMount',value:function componentDidMount(){$('#chemical-nav').tabs();if(this.props.chemicalList.length===0)this.props.fetchChemicals();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row chemical-reports-view'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{id:'chemical-nav',className:'tabs tabs-fixed-width'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'active chemical-tab-nav',href:'#products'},'Chemical Products')),Object.keys(this.props.user).length===0?'':this.props.user.level>=3||this.props.user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{className:'chemical-tab-nav',href:'#manage-products'},'Create & Edit Products')):''),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{id:'products'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'chem-container chem-list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__chemical_list__["a" /* default */],{chemicalList:this.props.chemicalList,onClick:this.props.selectChemical}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_view__["a" /* default */],{selectedChemical:this.props.selectedChemical,onClick:this.props.sendFile,email:this.props.user.email}))),Object.keys(this.props.user).length===0?'':this.props.user.level>=3||this.props.user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{id:'manage-products'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'chem-container chem-list'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__chemical_list__["a" /* default */],{chemicalList:this.props.chemicalList,onClick:this.props.selectChemicalToEdit}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__chemical_form__["a" /* default */],{createOrEditChemical:this.props.createOrEditChemical,editChemical:this.props.editChemical,clearForm:this.props.clearForm,editedChemical:this.props.editedChemical,isEditing:this.props.isEditing,eid:this.props.user.eid}))):'');}}]);return ChemicalView;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);function mapStateToProps(state){return{chemicalList:state.cultivation.chemical.chemicalList,isEditing:state.cultivation.chemical.edit.isEditing,editedChemical:state.cultivation.chemical.edit.editedChemical,selectedChemical:state.cultivation.chemical.selectedChemical,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["c" /* bindActionCreators */])({clearForm:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["d" /* clearForm */],createOrEditChemical:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["e" /* createOrEditChemical */],sendFile:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["f" /* sendFile */],fetchChemicals:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["c" /* fetchChemicals */],selectChemical:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["g" /* selectChemical */],selectChemicalToEdit:__WEBPACK_IMPORTED_MODULE_3__actions_chem_actions__["h" /* selectChemicalToEdit */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChemicalView));/* END */

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/**********************************************************
Product View: Displays information about the selected chemical
7/24/19
@params {Object} selectedChemical
**********************************************************/var $=window.$;var ProductView=function ProductView(_ref){var selectedChemical=_ref.selectedChemical,email=_ref.email,_onClick=_ref.onClick;if(Object.keys(selectedChemical).length===0)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);$(document).ready(function(){$('.tooltipped').tooltip({delay:50});});var _determineIcon=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_utils__["y" /* determineIcon */])(selectedChemical.type),color=_determineIcon.color,icon=_determineIcon.icon;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'product'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'chem-name'},selectedChemical.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:selectedChemical.url?selectedChemical.url:'https://www.greenbook.net',target:'_blank'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons product-info-icon tooltipped','data-position':'left','data-delay':'50','data-tooltip':'More Info'},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m12 l12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-display blue'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'product-title'},selectedChemical.type),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'product-recoDosage'},selectedChemical.recoDosage.split(' ')[0]===''?'N/A':__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,selectedChemical.recoDosage)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'product-reco-desc'},'Recommended Dosage')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-content product-card-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'collection product-collection'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons circle '+color+' darken-2'},icon),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'product-title-info'},'Product Information'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,selectedChemical.manufacturer),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'#!',className:'secondary-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'material-icons'},'grade'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Ingredients'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content'},selectedChemical.ingredients)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat purple'},'Components')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Restricted Entry Interval (REI)'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content red-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,selectedChemical.rei,' days'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat cyan'},'Interval')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Pre-harvest Interval'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content orange-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,selectedChemical.preHarvestInterval,' days'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat cyan'},'Interval')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Max Quantity Per Acre/Year'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content red-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,selectedChemical.maxQuantity))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat red'},'Max Amount')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'EPA #'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content'},selectedChemical.epaNo)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat amber'},'Certified')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Hawaii Registration'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content'},selectedChemical.hawaiiRegistration?'Yes':'No')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'task-cat '+(selectedChemical.hawaiiRegistration?'green':'red')+' '},'Availability')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'collection-item product-item'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s6 m6 l6'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Last Edit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(selectedChemical.dateEdited).format('YYYY-MM-DD hh:mm:ss a'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s3 m3 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-title'},'Edited by'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'collections-content'},selectedChemical.editedByName))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'flow-text'},'Email files'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-footer'},selectedChemical.label?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{onClick:function onClick(e){return _onClick(e.target.name,email);},name:selectedChemical.label,className:'btn waves-light waves-effect product-file-btn'},'Label'):'',selectedChemical.sds?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{onClick:function onClick(e){return _onClick(e.target.name,email);},name:selectedChemical.sds,className:'btn waves-light waves-effect product-file-btn'},'Safety Data Sheet'):'',selectedChemical.supplementalLabel?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{onClick:function onClick(e){return _onClick(e.target.name,email);},name:selectedChemical.supplementalLabel,className:'btn waves-light waves-effect product-file-btn'},'Supplemental Label'):'',selectedChemical.specialLocalNeedsLabel?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{onClick:function onClick(e){return _onClick(e.target.name,email);},name:selectedChemical.specialLocalNeedsLabel,className:'btn waves-light waves-effect product-file-btn'},'Special Local Needs'):''))))));};/* harmony default export */ __webpack_exports__["a"] = (ProductView);/* END */

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**********************************************************
FAQ Card
**********************************************************/var FAQCard=function FAQCard(_ref){var faq=_ref.faq,_class=_ref._class,_onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m6 l3 "+_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"black-text",onClick:function onClick(){return _onClick(faq);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card "+faq.cardColor+" hoverable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content center-align"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons "+faq.iconColor+" medium"},faq.icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,faq.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,faq.extra)))));};/* harmony default export */ __webpack_exports__["a"] = (FAQCard);/* END */

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__faq_card__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_chem_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_docs_actions__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var $=window.$;var CultivationIntro=function(_Component){_inherits(CultivationIntro,_Component);function CultivationIntro(){_classCallCheck(this,CultivationIntro);return _possibleConstructorReturn(this,(CultivationIntro.__proto__||Object.getPrototypeOf(CultivationIntro)).apply(this,arguments));}_createClass(CultivationIntro,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.managers.length===0)this.props.fetchManagers();if(this.props.chemicalList.length===0)this.props.fetchChemicals();document.title='Cultivation';$(document).ready(function(){$('#cult-faq-data').collapsible();});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){$(document).ready(function(){$('#cult-faq-data').collapsible();});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card z-depth-1 cult-intro-header'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Welcome to the Cultivation Module'))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4__cult_constants__["l" /* FAQS */].map(function(f){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__faq_card__["a" /* default */],{key:f.title,faq:f,_class:"pointer",onClick:_this2.props.setDocs});}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s12 m3 l3'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'card-title'},'Components'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'category-list'},__WEBPACK_IMPORTED_MODULE_4__cult_constants__["m" /* CULTIVATION_URLS */].map(function(c){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',{key:c.url,className:'mt-4 pointer',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"].push(c.url);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i',{className:'material-icons vertical-text-sub '+c.iconColor},'panorama_fish_eye'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'ml-2'},c.name));})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'card-title mt-10'},'Managers'),this.props.managers?this.props.managers.map(function(m){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:m.id,className:'row'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s3 m4 l3 xl3 pr-0'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i',{className:'material-icons medium manager-icon'},'face')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s9 m8 l9 xl9 pl-0'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:'mailto:'+m.email},m.firstName,' ',m.lastName),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',{className:'text-sm'},m.location==='71'?'Ka\'u':'Kea\'au',' - ',m.positionTitle)));}):'N/A'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},this.props.docs.selected?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card'}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'cult-about-services'},'About the Services'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'Product Management:'),' Manage information about the products used in cultivation operations'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'Flexible Reporting:'),' Create custom reports and data sets from all cultivation activities'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'Herbicide & Pesticide Tracking:'),' Manage chemical application activity'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'Fertilizer & Mowing Tracking:'),' Manage fertilizer application & mowing activity'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'Tree and Replanting Management:'),' Manage nursery inventory and replanting activities')))))))));}}]);return CultivationIntro;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);function mapStateToProps(state){return{chemicalList:state.cultivation.chemical.chemicalList,docs:state.cultivation.utils.docs,managers:state.cultivation.utils.managers};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux__["c" /* bindActionCreators */])({fetchChemicals:__WEBPACK_IMPORTED_MODULE_1__actions_chem_actions__["c" /* fetchChemicals */],fetchManagers:__WEBPACK_IMPORTED_MODULE_2__actions_utils_actions__["e" /* fetchManagers */],setDocs:__WEBPACK_IMPORTED_MODULE_3__actions_docs_actions__["a" /* setDocs */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CultivationIntro));/* END */

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Fertilizer
**********************************************************/var FertilizerContainer=function(_Component){_inherits(FertilizerContainer,_Component);function FertilizerContainer(){_classCallCheck(this,FertilizerContainer);return _possibleConstructorReturn(this,(FertilizerContainer.__proto__||Object.getPrototypeOf(FertilizerContainer)).apply(this,arguments));}_createClass(FertilizerContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* default */],{tabs:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["e" /* FERTILIZER_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,this.props.children));}}]);return FertilizerContainer;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FertilizerContainer));/* END */

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fertilizer_form__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fert_app_display__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fertilizer_list__ = __webpack_require__(386);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Create
**********************************************************/var FertilizerCreate=function(_Component){_inherits(FertilizerCreate,_Component);function FertilizerCreate(){_classCallCheck(this,FertilizerCreate);return _possibleConstructorReturn(this,(FertilizerCreate.__proto__||Object.getPrototypeOf(FertilizerCreate)).apply(this,arguments));}_createClass(FertilizerCreate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.employees.length===0)this.props.fetchEmployees();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object.keys(this.props.user).length===0?'':this.props.user.level>=3||this.props.user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chem-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__fertilizer_list__["a" /* default */],{fertAppList:this.props.fertilizerApplications.filter(__WEBPACK_IMPORTED_MODULE_5__cult_utils__["k" /* filterOldRecords */]),employees:this.props.employees,onClick:this.props.selectFertAppToEdit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},this.props.editingApplication?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header blue-text'},'Editing Fertilizer Application'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fertilizer_form__["a" /* default */],{employees:this.props.employees,fields:this.props.fields,formId:'fertilizer-application-form',chemicalList:this.props.chemicalList.filter(function(c){return c.type==='Fertilizer'||c.type==='Adjuvant';}),fertilizerApplied:this.props.fertilizerApplied,fertAppId:this.props.fertAppId,isEditing:this.props.isEditing,solidOrLiquid:this.props.solidOrLiquid,application:this.props.application,editFertilizerApplied:this.props.editFertilizerApplied,fetchFields:this.props.fetchFields,addFertilizer:this.props.addFertilizer,editFertilizer:this.props.editFertilizer,setFertilizerForm:this.props.setFertilizerForm,selectFertilizerToEdit:this.props.selectFertilizerToEdit,deleteFertilizer:this.props.deleteFertilizer,createOrEditFertilizerApplication:this.props.createOrEditFertilizerApplication}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#fertilzer-app-prepare',onClick:function onClick(){return _this2.props.prepareData({user:_this2.props.user,form:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cult_utils__["c" /* packageForm */])('fertilizer-application-form'),fields:_this2.props.fields,fertAppId:_this2.props.fertAppId,employees:_this2.props.employees,editingApplication:_this2.props.editingApplication,fertilizerApplied:_this2.props.fertilizerApplied,deletedFertilizers:_this2.props.deletedFertilizers});}},'Prepare'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat',onClick:function onClick(){_this2.props.clearForm('fertilizer-application-form');_this2.props.clearForm('fert-used-form-S');_this2.props.clearForm('fert-used-form-LD');}},'Clear'))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__fert_app_display__["a" /* default */])// eslint-disable-next-line
({id:'fertilzer-app-prepare',footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createOrEditFertilizerApplication({data:Object.assign({},_this2.props.application,{deletedFertilizerApplied:_this2.props.deletedFertilizerApplied}),type:_this2.props.type,path:_this2.props.path});},application:this.props.application,employees:this.props.employees,editingApplication:this.props.editingApplication,chemicalList:this.props.chemicalList,previousApplications:this.props.previousApplications})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Unauthorized')));}}]);return FertilizerCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{application:state.cultivation.fertilizer.app.application,chemicalList:state.cultivation.chemical.chemicalList,deletedFertilizerApplied:state.cultivation.fertilizer.app.deletedFertilizerApplied,eid:state.auth.user.guid,employees:state.cultivation.utils.employees,editingApplication:state.cultivation.fertilizer.app.editingApplication,editFertilizerApplied:state.cultivation.fertilizer.app.editFertilizerApplied,fields:state.cultivation.utils.fields,fertAppId:state.cultivation.fertilizer.app.fertAppId,fertilizerApplied:state.cultivation.fertilizer.app.fertilizerApplied,fertilizerApplications:state.cultivation.fertilizer.fertilizerApplications.displaying,isEditing:state.cultivation.fertilizer.app.isEditing,path:state.cultivation.fertilizer.app.path,previousApplications:state.cultivation.fertilizer.app.previousApplications,solidOrLiquid:state.cultivation.fertilizer.app.solidOrLiquid,type:state.cultivation.fertilizer.app.type,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({addFertilizer:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["a" /* addFertilizer */],createOrEditFertilizerApplication:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["b" /* createOrEditFertilizerApplication */],clearForm:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["a" /* clearForm */],deleteFertilizer:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["c" /* deleteFertilizer */],editFertilizer:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["d" /* editFertilizer */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["b" /* fetchEmployees */],fetchFields:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["c" /* fetchFields */],prepareData:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["e" /* prepareData */],selectFertilizerToEdit:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["f" /* selectFertilizerToEdit */],selectFertAppToEdit:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["g" /* selectFertAppToEdit */],setFertilizerForm:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["h" /* setFertilizerForm */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FertilizerCreate));/* END */

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fert_applied_table__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Form
**********************************************************/var propTypes={chemicalList:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,eid:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,employees:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,isEditing:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,solutions:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,totalGallons:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number};var FertilizerForm=function(_Component){_inherits(FertilizerForm,_Component);function FertilizerForm(){_classCallCheck(this,FertilizerForm);return _possibleConstructorReturn(this,(FertilizerForm.__proto__||Object.getPrototypeOf(FertilizerForm)).apply(this,arguments));}_createClass(FertilizerForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'fert-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-kau',name:'fert-location',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-keaau',name:'fert-location',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* AutoComplete */],{id:'fert-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["b" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_2__cult_utils__["o" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fert-round',label:'Round',min:'1',max:'10',step:'1.0',defaultValue:1,required:true}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Type of Application'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-solid',name:'fert-solidOrLiquid',label:'Granular (Solid)',value:'S',onClick:function onClick(e){return _this2.props.setFertilizerForm({val:e.target.value});},checked:true}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-liquid',name:'fert-solidOrLiquid',label:'Foliar Spray (Liquid)',value:'L',onClick:function onClick(e){return _this2.props.setFertilizerForm({val:e.target.value});}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('label',null,'Status'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-isCompleteYes',name:'fert-isComplete',label:'Complete',value:'Complete'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'fert-isCompleteNo',name:'fert-isComplete',label:'Incomplete',value:'Incomplete'}))),this.props.solidOrLiquid==='S'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'fert-comments',label:'Comments',defaultValue:'N/A'})):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fert-measurement',label:'Total Gallons',min:'1',max:'10000',step:'1.0'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'fert-comments',label:'Comments',defaultValue:'N/A'}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),this.props.solidOrLiquid==='S'?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'fert-used-form-S',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'fertUsed-chemId',label:'Fertilizer',opts:this.props.chemicalList.map(function(c){return{label:c.name,val:c.id};})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'fertUsed-field',label:'Field',opts:this.props.fields})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-hours',label:'Hours',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-acresCompleted',label:'Acres Completed',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-quantityApplied',label:'Quantity (In Tons)',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'fertUsed-unitOfMeasure',value:'tons'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'fertUsed-appType',value:'S'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m2 l2 xl2'},this.props.isEditing?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large blue chem-add',onClick:function onClick(){return _this2.props.editFertilizer({fertilizer:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-S'),fertAppId:_this2.props.fertAppId,editFertilizerApplied:_this2.props.editFertilizerApplied,formId:'fert-used-form-S',chemicals:_this2.props.chemicalList});}},'Edit Record')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large chem-add',onClick:function onClick(){return _this2.props.addFertilizer({fertilizer:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-S'),formId:'fert-used-form-S',chemicals:_this2.props.chemicalList});}},'Add Record'))))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'fert-used-form-L',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l4 xl4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'fertUsed-field',label:'Field',opts:this.props.fields})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l4 xl4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-hours',label:'Hours',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s6 m2 l4 xl4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-acresCompleted',label:'Acres Completed',min:"0",max:"5000",step:"0.1"})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form',{id:'fert-used-form-LD',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m2 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'fertUsed-chemId',label:'Fertilizer',opts:this.props.chemicalList.map(function(c){return{label:c.name,val:c.id};})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m2 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'fertUsed-quantityApplied',label:'Quantity',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m2 l3 xl3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'fertUsed-unitOfMeasure',label:'Unit',opts:__WEBPACK_IMPORTED_MODULE_3__cult_constants__["a" /* UNITS_OF_MEASURE */].filter(function(c){return c.type==='volume';})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('input',{type:'hidden',id:'fertUsed-appType',value:'L'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},this.props.isEditing?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large blue chem-add',onClick:function onClick(){return _this2.props.editFertilizer({fertilizer:Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-L'),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-LD')),fertAppId:_this2.props.fertAppId,editFertilizerApplied:_this2.props.editFertilizerApplied,formId:'fert-used-form-LD',chemicals:_this2.props.chemicalList});}},'Edit Record')):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-large chem-add',onClick:function onClick(){return _this2.props.addFertilizer({fertilizer:Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-L'),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('fert-used-form-LD')),formId:'fert-used-form-LD',chemicals:_this2.props.chemicalList});}},'Add Record'))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'})),this.props.fertilizerApplied.length>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fert_applied_table__["a" /* default */],{fertilizers:this.props.fertilizerApplied,chemicalList:this.props.chemicalList,formId:'chemicals-used-form',_edit:this.props.selectFertilizerToEdit,_delete:this.props.deleteFertilizer,readOnly:false,editChem:false}))):'');}}]);return FertilizerForm;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);FertilizerForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (FertilizerForm);/* END */

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Fertilizer List: Lists all fert apps
2/13/20
**********************************************************/var propTypes={FertilizerAppList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var FertilizerAppList=function FertilizerAppList(_ref){var fertAppList=_ref.fertAppList,employees=_ref.employees,_onClick=_ref.onClick;if(!fertAppList)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No Applications Available');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},fertAppList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:c.fertAppId,className:'collection-item chem-list-item',onClick:function onClick(){return _onClick({formId:'fertilizer-application-form',app:c,employees:employees});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(c.date).format('MM/DD/YYYY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fert-flex-list'},c.fertilizerApplied.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:''+f.id+Math.random()},f.field,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-shift'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},f.unitOfMeasure==='tons'?'grain':'invert_colors')));})));})));};FertilizerAppList.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (FertilizerAppList);/* END */

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fab_modal_v2__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fert_app_display__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Fertilizer View
**********************************************************/var FertilizerView=function(_Component){_inherits(FertilizerView,_Component);function FertilizerView(){_classCallCheck(this,FertilizerView);return _possibleConstructorReturn(this,(FertilizerView.__proto__||Object.getPrototypeOf(FertilizerView)).apply(this,arguments));}_createClass(FertilizerView,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchFertilizerApplications();if(this.props.employees.length===0)this.props.fetchEmployees();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chem-app-table-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Employee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Round'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.fertilizerApplications.map(function(f){var fertilizerApplied=f.fertilizerApplied;var name='N/A';var emp={};if(_this2.props.employees.length>0&&f.employee!==undefined){emp=_this2.props.employees.find(function(e){return e.eid===f.employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return fertilizerApplied.map(function(fert){var c=_this2.props.chemicalList.find(function(cl){return cl.id===Number(fert.chemId);});if(c===undefined)c={};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:fert.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_7_moment___default()(f.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fert.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fert.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fert.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fert.acresBalance),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,f.isComplete===0||f.isComplete==='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chem-app-table-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,c.name),': ',c.ingredients),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-shift'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},fert.unitOfMeasure==='tons'?'grain':'invert_colors'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,fert.quantityApplied,' ',fert.unitOfMeasure),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,f.round),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fab_modal_v2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__fert_app_display__["a" /* default */])// eslint-disable-next-line
({id:f.id+'-view',auth:false,user:_this2.props.user,employees:_this2.props.employees,chemicalList:_this2.props.chemicalList,previousApplications:[],toDelete:false,view:true,footer:true,application:f,_select:function _select(){return _this2.props.selectFertilizerApplication(f);}}),Object.keys(_this2.props.user).length===0?'':_this2.props.user.level>=3||_this2.props.user.positionTitle.match(/Cultivation/)?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fab_modal_v2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__fert_app_display__["a" /* default */])// eslint-disable-next-line
({id:f.id+'-delete',auth:true,user:_this2.props.user,employees:_this2.props.employees,chemicalList:_this2.props.chemicalList,previousApplications:[],toDelete:true,view:false,footer:true,application:f,_select:function _select(){return _this2.props.selectFertilizerApplication(f);},onClick:function onClick(){return _this2.props.deleteFertilizerApplication({fertAppId:_this2.props.selectedApp.fertAppId});}}):''))));});})))));}}]);return FertilizerView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{chemicalList:state.cultivation.chemical.chemicalList,employees:state.cultivation.utils.employees,fertilizerApplications:state.cultivation.fertilizer.fertilizerApplications.displaying,previousApplications:state.cultivation.fertilizer.app.previousApplications,selectedApp:state.cultivation.fertilizer.view.app,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({deleteFertilizerApplication:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["i" /* deleteFertilizerApplication */],fetchFertilizerApplications:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["j" /* fetchFertilizerApplications */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_6__actions_utils_actions__["b" /* fetchEmployees */],selectFertilizerApplication:__WEBPACK_IMPORTED_MODULE_3__actions_fertilizer_actions__["k" /* selectFertilizerApplication */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(FertilizerView));/* END */

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Mowing
**********************************************************/var MowingContainer=function(_Component){_inherits(MowingContainer,_Component);function MowingContainer(){_classCallCheck(this,MowingContainer);return _possibleConstructorReturn(this,(MowingContainer.__proto__||Object.getPrototypeOf(MowingContainer)).apply(this,arguments));}_createClass(MowingContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* default */],{tabs:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["d" /* MOWING_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,this.props.children));}}]);return MowingContainer;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MowingContainer));/* END */

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mowing_form__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mowing_app_display__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mowing_list__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Mowing Create
**********************************************************/var MowingCreate=function(_Component){_inherits(MowingCreate,_Component);function MowingCreate(){_classCallCheck(this,MowingCreate);return _possibleConstructorReturn(this,(MowingCreate.__proto__||Object.getPrototypeOf(MowingCreate)).apply(this,arguments));}_createClass(MowingCreate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},Object.keys(this.props.user).length===0?'':this.props.user.level>=3||this.props.user.positionTitle.match(/Cultivation/)?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'chem-container'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__mowing_list__["a" /* default */],{mowingRecords:this.props.mowingRecords.filter(__WEBPACK_IMPORTED_MODULE_6__cult_utils__["k" /* filterOldRecords */]),employees:this.props.employees,onClick:this.props.selectMowAppToEdit}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col s12 m9 l9 xl9'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mowing_form__["a" /* default */],{formId:'mowing-form',employees:this.props.employees,fields:this.props.fields,mowJobs:this.props.mowJobs,isEditing:this.props.isEditing,mowAppId:this.props.mowAppId,editingMow:this.props.editingMow,selectMowToEdit:this.props.selectMowToEdit,fetchFields:this.props.fetchFields,addMow:this.props.addMow,editMow:this.props.editMow,deleteMow:this.props.deleteMow}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#mowing-app-prepare',onClick:function onClick(){return _this2.props.prepareMow({user:_this2.props.user,form:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cult_utils__["c" /* packageForm */])('mowing-form'),fields:_this2.props.fields,employees:_this2.props.employees,mowJobs:_this2.props.mowJobs,mowAppId:_this2.props.mowAppId,editingApplication:_this2.props.editingApplication});}},'Prepare'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button',{className:'btn btn-flat',onClick:function onClick(){_this2.props.clearForm('mowing-form');_this2.props.clearForm('mow-used-form');}},'Clear'))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__mowing_app_display__["a" /* default */])// eslint-disable-next-line
({id:'mowing-app-prepare',employees:this.props.employees,footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createOrEditMowingApplication({data:Object.assign({},_this2.props.application,{deletedMowingRecords:_this2.props.deletedMowingRecords}),path:_this2.props.path,type:_this2.props.type});},application:this.props.application,previousApplications:this.props.previousApplications})))):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5',null,'Unauthorized')));}}]);return MowingCreate;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);function mapStateToProps(state){return{application:state.cultivation.mowing.app.application,deletedMowingRecords:state.cultivation.mowing.app.deletedMowingRecords,editingApplication:state.cultivation.mowing.app.editingApplication,editingMow:state.cultivation.mowing.app.editingMow,employees:state.cultivation.utils.employees,fields:state.cultivation.utils.fields,isEditing:state.cultivation.mowing.app.isEditing,mowAppId:state.cultivation.mowing.app.mowAppId,mowJobs:state.cultivation.mowing.app.mowJobs,mowingRecords:state.cultivation.mowing.mowingRecords.displaying,path:state.cultivation.mowing.app.path,previousApplications:state.cultivation.mowing.app.previousApplications,type:state.cultivation.mowing.app.type,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux__["c" /* bindActionCreators */])({addMow:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["a" /* addMow */],clearForm:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["a" /* clearForm */],createOrEditMowingApplication:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["b" /* createOrEditMowingApplication */],deleteMow:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["c" /* deleteMow */],editMow:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["d" /* editMow */],fetchFields:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["c" /* fetchFields */],prepareMow:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["e" /* prepareMow */],selectMowToEdit:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["f" /* selectMowToEdit */],selectMowAppToEdit:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["g" /* selectMowAppToEdit */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MowingCreate));/* END */

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mowing_table__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Form
**********************************************************/var propTypes={eid:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,employees:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,formId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,isEditing:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};var MowingForm=function(_Component){_inherits(MowingForm,_Component);function MowingForm(){_classCallCheck(this,MowingForm);return _possibleConstructorReturn(this,(MowingForm.__proto__||Object.getPrototypeOf(MowingForm)).apply(this,arguments));}_createClass(MowingForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'mow-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'mow-kau',name:'mow-location',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'mow-keaau',name:'mow-location',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m4 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["a" /* AutoComplete */],{id:'mow-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["b" /* mapEmployeeForAutoComplete */])(this.props.employees),onComplete:__WEBPACK_IMPORTED_MODULE_2__cult_utils__["o" /* onDummyComplete */]})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'mow-round',label:'Round',min:'1',max:'10',step:'1.0',defaultValue:1,required:true}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('label',null,'Status'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'mow-isCompleteYes',name:'mow-isComplete',label:'Complete',value:'Complete'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'mow-isCompleteNo',name:'mow-isComplete',label:'Incomplete',value:'Incomplete'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'mow-comments',label:'Comments',defaultValue:'N/A'})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('form',{id:'mow-used-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'mowing-field',label:'Field',opts:this.props.fields})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'mowing-hours',label:'Hours',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'mowing-acresCompleted',label:'Acres Completed',min:"0",max:"5000",step:"0.1"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m3 l3 xl3'},this.props.isEditing?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btn btn-large blue chem-add',onClick:function onClick(){return _this2.props.editMow({mow:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('mow-used-form'),formId:'mow-used-form',editingMow:_this2.props.editingMow,mowAppId:_this2.props.mowAppId});}},'Edit Record')):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btn btn-large chem-add',onClick:function onClick(){return _this2.props.addMow({mow:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('mow-used-form'),formId:'mow-used-form'});}},'Add Record'))))),this.props.mowJobs.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mowing_table__["a" /* default */],{mowJobs:this.props.mowJobs,_edit:this.props.selectMowToEdit,_delete:this.props.deleteMow}))):'');}}]);return MowingForm;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);MowingForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MowingForm);/* END */

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Mowing List: Lists all fert apps
3/24/20
**********************************************************/var propTypes={mowingRecords:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var MowingAppList=function MowingAppList(_ref){var mowingRecords=_ref.mowingRecords,employees=_ref.employees,_onClick=_ref.onClick;if(!mowingRecords)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No Applications Available');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},mowingRecords.map(function(m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:m.mowAppId,className:'collection-item chem-list-item',onClick:function onClick(){return _onClick({formId:'mowing-form',app:m,employees:employees});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(m.date).format('MM/DD/YYYY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fert-flex-list'},m.mowJobs.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:''+f.id+Math.random()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-shift'},f.field));})));})));};MowingAppList.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MowingAppList);/* END */

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fab_modal_v2__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mowing_app_display__ = __webpack_require__(158);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Mowing View
**********************************************************/var MowingView=function(_Component){_inherits(MowingView,_Component);function MowingView(){_classCallCheck(this,MowingView);return _possibleConstructorReturn(this,(MowingView.__proto__||Object.getPrototypeOf(MowingView)).apply(this,arguments));}_createClass(MowingView,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.employees.length===0)this.props.fetchEmployees();this.props.fetchMowingApplications();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chem-app-table-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Employee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acres / Hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Round'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.mowingRecords.map(function(m){var mowJobs=m.mowJobs;var name='N/A';var emp={};if(_this2.props.employees.length>0&&m.employee!==undefined){emp=_this2.props.employees.find(function(e){return e.eid===m.employee;});if(emp)name=emp.firstName[0]+'. '+emp.lastName;}return mowJobs.map(function(mow){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:mow.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(m.date).format('MM/DD/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mow.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mow.hours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mow.acresCompleted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mow.acresBalance),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mow.acresPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Number(m.isComplete)===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-incomplete'},'Incomplete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-complete'},'Complete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.round),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__fab_modal_v2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__mowing_app_display__["a" /* default */])// eslint-disable-next-line
({id:m.id+'-view',auth:false,user:_this2.props.user,employees:_this2.props.employees,previousApplications:[],toDelete:false,view:true,footer:true,application:m,_select:function _select(){return _this2.props.selectMowingApplication(m);}}),Object.keys(_this2.props.user).length===0?'':_this2.props.user.level>=3||_this2.props.user.positionTitle.match(/Cultivation/)?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__fab_modal_v2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__mowing_app_display__["a" /* default */])// eslint-disable-next-line
({id:m.id+'-delete',auth:true,user:_this2.props.user,employees:_this2.props.employees,previousApplications:[],toDelete:true,view:false,footer:true,application:m,_select:function _select(){return _this2.props.selectMowingApplication(m);},onClick:function onClick(){return _this2.props.deleteMowingApplication({mowAppId:_this2.props.selectedApp.mowAppId});}}):''))));});})))));}}]);return MowingView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{employees:state.cultivation.utils.employees,mowingRecords:state.cultivation.mowing.mowingRecords.displaying,selectedApp:state.cultivation.mowing.view.app,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({deleteMowingApplication:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["h" /* deleteMowingApplication */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["b" /* fetchEmployees */],fetchMowingApplications:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["i" /* fetchMowingApplications */],selectMowingApplication:__WEBPACK_IMPORTED_MODULE_5__actions_mowing_actions__["j" /* selectMowingApplication */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MowingView));/* END */

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/**********************************************************
Chemical Form

**********************************************************/var ReportForm=function ReportForm(_ref){var fields=_ref.fields,fetchFields=_ref.fetchFields,fetchCultivationReport=_ref.fetchCultivationReport,user=_ref.user;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('form',{id:'reports-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'reports-dateFrom',label:'Date From',min:'2018-01-01',required:true})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'reports-dateTo',label:'Date To',min:'2018-01-01',required:true})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'reports-loc',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["g" /* LOCATIONS */],label:'Location',onChange:function onChange(e){fetchFields(e.target.value,e.target.id);}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'reports-field',opts:fields,label:'Field'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'reports-type',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["h" /* REPORT_TYPES */],label:'Report Type',required:true}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["j" /* CheckBox */],{id:'reports-excel',name:'reports-excel',label:'Excel'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["j" /* CheckBox */],{id:'reports-pdf',name:'reports-pdf',label:'PDF',disabled:"disabled"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{onClick:function onClick(){return fetchCultivationReport({opts:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_utils__["c" /* packageForm */])('reports-form'),user:user});},className:'btn btn-large waves-effect'},'Fetch Report')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null));};/* harmony default export */ __webpack_exports__["a"] = (ReportForm);/* END */

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__report_form__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_report_actions__ = __webpack_require__(365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical View
**********************************************************/var Reports=function(_Component){_inherits(Reports,_Component);function Reports(){_classCallCheck(this,Reports);return _possibleConstructorReturn(this,(Reports.__proto__||Object.getPrototypeOf(Reports)).apply(this,arguments));}_createClass(Reports,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'reports-title'},'Reports Form'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__report_form__["a" /* default */],{fetchFields:this.props.fetchFields,fields:this.props.fields,user:this.props.user,fetchCultivationReport:this.props.fetchCultivationReport}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m8 l9'}));}}]);return Reports;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);function mapStateToProps(state){return{fields:state.cultivation.utils.fields,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({fetchCultivationReport:__WEBPACK_IMPORTED_MODULE_5__actions_report_actions__["a" /* fetchCultivationReport */],fetchFields:__WEBPACK_IMPORTED_MODULE_1__actions_utils_actions__["c" /* fetchFields */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Reports));/* END */

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tree_inventory_form__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tree_inventory_display__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_inventory_transaction_table__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tree_inventory_table__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cult_utils__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree Inventory View
**********************************************************/;var $=window.$;var propTypes={approvers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,approver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,formType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inventory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,inventoryMaster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,inventoryTransactions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,previousInventoryTransactions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,req:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,approveInventoryRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,clearForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,createInventoryRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,deleteInventoryRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchEmployees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchInventory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,prepareInventory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setFormType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,downloadInventory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setInventoryToEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setInventoryToDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,editInventoryRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var TreeInventory=function(_Component){_inherits(TreeInventory,_Component);function TreeInventory(){_classCallCheck(this,TreeInventory);return _possibleConstructorReturn(this,(TreeInventory.__proto__||Object.getPrototypeOf(TreeInventory)).apply(this,arguments));}_createClass(TreeInventory,[{key:'componentDidMount',value:function componentDidMount(){$('#tree-nav').tabs();this.props.fetchInventory();if(this.props.employees.length===0)this.props.fetchEmployees();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row chemical-reports-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'tree-nav',className:'tabs tabs-fixed-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'active chemical-tab-nav',href:'#treeInventory'},'Current Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'chemical-tab-nav',href:'#recentTransactions'},'Recent Transactions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'chemical-tab-nav',href:'#issueAndReceiveInv'},'Issue & Receive Inventory'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'treeInventory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card harvest-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__tree_inventory_table__["a" /* default */],{inventory:this.props.inventory,inventoryTransactions:this.props.inventoryTransactions,employees:this.props.employees,onClick:this.props.downloadInventory}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'recentTransactions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card harvest-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tree_inventory_transaction_table__["a" /* default */],{user:this.props.user,_inventory:this.props.inventory,inventory:this.props.inventoryTransactions,formType:this.props.formType,fields:this.props.fields,approvers:this.props.approvers,readOnly:false,formId:'tree-inventory-editform',setFormType:this.props.setFormType,fetchFields:this.props.fetchFields,setInventoryToEdit:this.props.setInventoryToEdit,onClick:this.props.approveInventoryRequest,editInventoryRequest:this.props.editInventoryRequest,setInventoryToDelete:this.props.setInventoryToDelete,deleteInventoryRequest:this.props.deleteInventoryRequest}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'issueAndReceiveInv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__tree_inventory_form__["a" /* default */],{formId:'tree-inventory-form',formType:this.props.formType,fields:this.props.fields,approvers:this.props.approvers,setFormType:this.props.setFormType,fetchFields:this.props.fetchFields})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#tree-inventory-prepare',onClick:function onClick(){return _this2.props.prepareInventory({user:_this2.props.user,form:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__cult_utils__["c" /* packageForm */])('tree-inventory-form'),formType:_this2.props.formType});}},'Prepare'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat',onClick:function onClick(){return _this2.props.clearForm('tree-inventory-form');}},'Clear'))),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__tree_inventory_display__["a" /* default */])// eslint-disable-next-line
({id:'tree-inventory-prepare',approver:this.props.approver,formType:this.props.formType,data:this.props.req,employees:this.props.employees,previousInventoryTransactions:this.props.previousInventoryTransactions,toDelete:false,// TODO: Add
editingApplication:false,// TODO: Add
footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createInventoryRequest({data:_this2.props.req,formType:_this2.props.formType,inventory:_this2.props.inventory});}})));}}]);return TreeInventory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{approvers:state.cultivation.treeInventory.approvers,approver:state.cultivation.treeInventory.req.approver,employees:state.cultivation.utils.employees,fields:state.cultivation.utils.fields,formType:state.cultivation.treeInventory.formType,inventory:state.cultivation.treeInventory.inventory,inventoryMaster:state.cultivation.treeInventory.req.inventoryMaster,inventoryTransactions:state.cultivation.treeInventory.inventoryTransactions,previousInventoryTransactions:state.cultivation.treeInventory.req.previousInventoryTransactions,req:state.cultivation.treeInventory.req,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({approveInventoryRequest:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["a" /* approveInventoryRequest */],clearForm:__WEBPACK_IMPORTED_MODULE_10__actions_utils_actions__["a" /* clearForm */],createInventoryRequest:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["b" /* createInventoryRequest */],deleteInventoryRequest:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["c" /* deleteInventoryRequest */],downloadInventory:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["d" /* downloadInventory */],editInventoryRequest:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["e" /* editInventoryRequest */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_10__actions_utils_actions__["b" /* fetchEmployees */],fetchFields:__WEBPACK_IMPORTED_MODULE_10__actions_utils_actions__["c" /* fetchFields */],fetchInventory:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["f" /* fetchInventory */],prepareInventory:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["g" /* prepareInventory */],setFormType:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["h" /* setFormType */],setInventoryToDelete:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["i" /* setInventoryToDelete */],setInventoryToEdit:__WEBPACK_IMPORTED_MODULE_9__actions_tree_inventory_actions__["j" /* setInventoryToEdit */]},dispatch);}TreeInventory.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TreeInventory));/* END */

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Chemical Application Form
**********************************************************/var propTypes={formType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,fields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,approvers:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,setFormType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,fetchFields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};var TreeInventoryEditForm=function(_Component){_inherits(TreeInventoryEditForm,_Component);function TreeInventoryEditForm(){_classCallCheck(this,TreeInventoryEditForm);return _possibleConstructorReturn(this,(TreeInventoryEditForm.__proto__||Object.getPrototypeOf(TreeInventoryEditForm)).apply(this,arguments));}_createClass(TreeInventoryEditForm,[{key:'render',value:function render(){var _this2=this;if(!this.props.formId)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'tree-inventory-editform'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',{className:'blue-text'},'Edit Inventory Transaction'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'treeInvEdit-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInvEdit-kau',name:'treeInvEdit-location',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInvEdit-keaau',name:'treeInvEdit-location',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'treeInvEdit-field',label:'Inventory Field',opts:this.props.fields.filter(function(f){return f.field.match(/NK29|N000|N001/);})}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'treeInvEdit-issuedOrReceived',label:'Issue or Receivable',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["b" /* ISSUE_OR_RECEIVE */]})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'treeInvEdit-quantity',label:'Quantity',step:"1.0",min:"0"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'treeInvEdit-comments',label:'Comments'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'Approver'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'check-flex'},this.props.approvers.map(function(a,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:a.id,className:'ml-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInvEdit-approver'+(i+1),name:'treeInvEdit-approver',label:a.name,value:a.eid}));}))))));}}]);return TreeInventoryEditForm;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TreeInventoryEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryEditForm);/* END */

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Tree Inventory Form
**********************************************************/var propTypes={formType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,fields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,approvers:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,setFormType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,fetchFields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};var TreeInventoryForm=function(_Component){_inherits(TreeInventoryForm,_Component);function TreeInventoryForm(){_classCallCheck(this,TreeInventoryForm);return _possibleConstructorReturn(this,(TreeInventoryForm.__proto__||Object.getPrototypeOf(TreeInventoryForm)).apply(this,arguments));}_createClass(TreeInventoryForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12 mt-1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["h" /* Switch */],{id:'treeInv-formType',label:'Initialize Inventory',value:this.props.formType,onChange:function onChange(e){return _this2.props.setFormType(e.target.value);},switchLabel2:'Create New Inventory Batch',switchLabel1:'Issue or Receive Inventory'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('form',{id:this.props.formId,onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["b" /* DatePicker */],{id:'treeInv-date',label:'Date',min:'2019-01-01',max:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),required:true})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'radio-flex'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInv-kau',name:'treeInv-location',value:'71',label:'Kau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInv-keaau',name:'treeInv-location',value:'72',label:'Keaau',onClick:function onClick(e){return _this2.props.fetchFields(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["d" /* SelectField */],{id:'treeInv-field',label:'Inventory Field',opts:this.props.fields.filter(function(f){return f.field.match(/NK/);})}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["e" /* Select */],{id:'treeInv-issuedOrReceived',label:'Issue or Receivable',opts:__WEBPACK_IMPORTED_MODULE_1__cult_constants__["b" /* ISSUE_OR_RECEIVE */]})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["f" /* NumberInput */],{id:'treeInv-quantity',label:'Quantity',step:"1.0",min:"0"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["g" /* TextInput */],{id:'treeInv-comments',label:'Comments'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'Approver'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'check-flex'},this.props.approvers.map(function(a,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:a.id,className:'ml-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__inputs__["c" /* RadioButton */],{id:'treeInv-approver'+(i+1),name:'treeInv-approver',label:a.name,value:a.eid}));}))))));}}]);return TreeInventoryForm;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TreeInventoryForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryForm);/* END */

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_inventory_transaction_table__ = __webpack_require__(93);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Display: Displays data for viewing & prior to submission
**********************************************************/var propTypes={inventory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,inventoryTransactions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};var TreeInventoryMasterDisplay=function TreeInventoryMasterDisplay(_ref){var inventory=_ref.inventory,inventoryTransactions=_ref.inventoryTransactions,employeeIssued=_ref.employeeIssued,employeeReceived=_ref.employeeReceived;if(!inventoryTransactions)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons indigo-text lighten-2 medium'},'assignment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Inventory Master')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-log-prev-header'},inventory.location==='71'?'71 - Kau':'72 - Keaau',', ',inventory.physicalLocation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),inventoryTransactions.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'blue-text app-log-prev-header'},'All Transactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tree_inventory_transaction_table__["a" /* default */],{inventory:inventoryTransactions,readOnly:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Inventory Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,inventory.inventoryTotal)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Inventory Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,inventory.inventoryReceived)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m4 l4 xl4 b-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Inventory Issued'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,inventory.inventoryIssued)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section chem-app-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Last Date Received: '),inventory.lastDateReceived?__WEBPACK_IMPORTED_MODULE_2_moment___default()(inventory.lastDateReceived).format('YYYY-MM-DD'):'N/A'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Last Date Issued: '),inventory.lastDateIssued?__WEBPACK_IMPORTED_MODULE_2_moment___default()(inventory.lastDateIssued).format('YYYY-MM-DD'):'N/A'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))));};TreeInventoryMasterDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryMasterDisplay);/* END */

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_inventory_master_display__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cult_utils__ = __webpack_require__(11);
/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Table: Master inventory records
************************************************************************/var TreeInventoryTable=function TreeInventoryTable(_ref){var inventory=_ref.inventory,inventoryTransactions=_ref.inventoryTransactions,employees=_ref.employees,_onClick=_ref.onClick;if(inventory.length===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered centered responsive-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nursery Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tree Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tree Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tree Issued'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date Issued'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Issue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Received'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,inventory.map(function(i){var empIssued='N/A';var empReceived='N/A';if(i.lastEIDIssued){empIssued=i.lastEIDIssued;}if(i.lastEIDReceived!==null){empReceived=i.lastEIDReceived;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.physicalLocation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.location==='71'?"71 - Ka'u":"72 - Kea'au"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.inventoryTotal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.inventoryReceived),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.inventoryIssued),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.lastDateIssued?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blue-text'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.lastDateIssued).format('MM/DD/YYYY')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.lastDateReceived?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green-text'},__WEBPACK_IMPORTED_MODULE_1_moment___default()(i.lastDateReceived).format('MM/DD/YYYY')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,empIssued),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,empReceived),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating green pointer modal-trigger tooltipped btn-squared',href:'#'+i.physicalLocation+'-view','data-position':'left','data-tooltip':'View'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'info'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'action-btn-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-floating grey pointer tooltipped btn-squared',href:'#'+i.physicalLocation+'-download',onClick:function onClick(){return _onClick(i);},'data-position':'top','data-tooltip':'Download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'cloud_download')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__tree_inventory_master_display__["a" /* default */])// eslint-disable-next-line
({id:i.physicalLocation+'-view',inventory:i,inventoryTransactions:inventoryTransactions.filter(function(item){return item.inventoryId===i.inventoryId;}),footer:true,createOrEdit:false,view:true}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cult_utils__["j" /* sumProp */])('inventoryTotal',inventory)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cult_utils__["j" /* sumProp */])('inventoryReceived',inventory)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cult_utils__["j" /* sumProp */])('inventoryIssued',inventory)))))));};/* harmony default export */ __webpack_exports__["a"] = (TreeInventoryTable);/* END */

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tree_replant_form__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_replant_display__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cult_modal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_employee_list__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tree_replant_table__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inputs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cult_utils__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree Inventory View
**********************************************************/var $=window.$;var propTypes={employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,fields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,inventoryTransactions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,prevReplants:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,replants:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,clearForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,addEmployee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,addEmployeeToEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,createReplant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,deleteReplant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,editReplant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchEmployees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchReplants:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,prepareReplant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeEmployee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeEmployeeFromEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setReplantToEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setReplantToDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var TreeReplant=function(_Component){_inherits(TreeReplant,_Component);function TreeReplant(){_classCallCheck(this,TreeReplant);return _possibleConstructorReturn(this,(TreeReplant.__proto__||Object.getPrototypeOf(TreeReplant)).apply(this,arguments));}_createClass(TreeReplant,[{key:'componentDidMount',value:function componentDidMount(){$('#tree-replant-nav').tabs();if(this.props.employees.length===0)this.props.fetchEmployees();if(this.props.replants.length===0)this.props.fetchReplants();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row chemical-reports-view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'tree-replant-nav',className:'tabs tabs-fixed-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'active chemical-tab-nav',href:'#recentReplants'},'Recent Replants')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'chemical-tab-nav',href:'#createReplant'},'Create Replant Log'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'recentReplants'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card harvest-scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'harvest-form-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__tree_replant_table__["a" /* default */],{replants:this.props.replants,fields:this.props.fields,employees:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__cult_utils__["a" /* filterArrayByPropAndValue */])(this.props.employees,'employeeStatus','Active'),inventoryTransactions:this.props.inventoryTransactions,addedEmployees:this.props.addedEditEmployees,user:this.props.user,editing:this.props.editing,addEmployeeToEdit:this.props.addEmployeeToEdit,removeEmployeeFromEdit:this.props.removeEmployeeFromEdit,fetchFields:this.props.fetchFields,setReplantToEdit:this.props.setReplantToEdit,editReplant:this.props.editReplant,setReplantToDelete:this.props.setReplantToDelete,deleteReplant:this.props.deleteReplant}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'createReplant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__inputs__["a" /* AutoComplete */],{id:'treeReplant-employee',label:'Employee',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__cult_utils__["b" /* mapEmployeeForAutoComplete */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__cult_utils__["a" /* filterArrayByPropAndValue */])(this.props.employees,'employeeStatus','Active')),onComplete:function onComplete(val,id){return _this2.props.addEmployee(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* findEmployeeByName */])(val,_this2.props.employees),id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emp-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_employee_list__["a" /* default */],{employees:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__cult_utils__["a" /* filterArrayByPropAndValue */])(this.props.employees,'employeeStatus','Active'),icon:'person_add',header:'Add Employees',onClick:this.props.addEmployee,_class:'green'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m10 l10 xl10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tree_replant_form__["a" /* default */],{formId:'tree-replant-form',fields:this.props.fields,employees:this.props.employees,inventoryTransactions:this.props.inventoryTransactions,addedEmployees:this.props.addedEmployees,inputId:0,removeEmployee:this.props.removeEmployee,fetchFields:this.props.fetchFields})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#tree-inventory-prepare',onClick:function onClick(){return _this2.props.prepareReplant({user:_this2.props.user,form:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__cult_utils__["c" /* packageForm */])('tree-replant-form'),inventoryTransactions:_this2.props.inventoryTransactions});}},'Prepare'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat',onClick:function onClick(){return _this2.props.clearForm('tree-replant-form');}},'Clear'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__cult_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__tree_replant_display__["a" /* default */])// eslint-disable-next-line
({id:'tree-inventory-prepare',data:this.props.app,employees:this.props.employees,inventoryTransactions:this.props.inventoryTransactions,prevReplants:this.props.prevReplants,toDelete:false,editingApplication:false,footer:true,createOrEdit:true,onClick:function onClick(){return _this2.props.createReplant({data:_this2.props.app,formId:'tree-replant-form'});}}))));}}]);return TreeReplant;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{app:state.cultivation.treeReplant.app,addedEmployees:state.cultivation.treeReplant.app.addedEmployees,addedEditEmployees:state.cultivation.treeReplant.edit.addedEmployees,editing:state.cultivation.treeReplant.editing,employees:state.cultivation.utils.employees,fields:state.cultivation.utils.fields,inventoryTransactions:state.cultivation.treeInventory.inventoryTransactions,prevReplants:state.cultivation.treeReplant.app.prevReplants,replants:state.cultivation.treeReplant.replants,user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({addEmployee:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["a" /* addEmployee */],addEmployeeToEdit:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["b" /* addEmployeeToEdit */],clearForm:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["a" /* clearForm */],createReplant:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["c" /* createReplant */],deleteReplant:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["d" /* deleteReplant */],editReplant:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["e" /* editReplant */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["b" /* fetchEmployees */],fetchFields:__WEBPACK_IMPORTED_MODULE_4__actions_utils_actions__["c" /* fetchFields */],fetchReplants:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["f" /* fetchReplants */],prepareReplant:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["g" /* prepareReplant */],removeEmployee:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["h" /* removeEmployee */],removeEmployeeFromEdit:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["i" /* removeEmployeeFromEdit */],setReplantToDelete:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["j" /* setReplantToDelete */],setReplantToEdit:__WEBPACK_IMPORTED_MODULE_5__actions_tree_replant_actions__["k" /* setReplantToEdit */]},dispatch);}TreeReplant.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TreeReplant));/* END */

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_list__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cult_constants__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree and Replanting Container
**********************************************************/var TreeReplantContainer=function(_Component){_inherits(TreeReplantContainer,_Component);function TreeReplantContainer(){_classCallCheck(this,TreeReplantContainer);return _possibleConstructorReturn(this,(TreeReplantContainer.__proto__||Object.getPrototypeOf(TreeReplantContainer)).apply(this,arguments));}_createClass(TreeReplantContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m1 l1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__url_list__["a" /* default */],{listItems:__WEBPACK_IMPORTED_MODULE_4__cult_constants__["c" /* TREE_URLS */],id:'cult-url-nav'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col m11 l11'},this.props.children));}}]);return TreeReplantContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TreeReplantContainer));/* END */

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cult_constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabs__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/var $=window.$;var Cultivation=function(_Component){_inherits(Cultivation,_Component);function Cultivation(){_classCallCheck(this,Cultivation);return _possibleConstructorReturn(this,(Cultivation.__proto__||Object.getPrototypeOf(Cultivation)).apply(this,arguments));}_createClass(Cultivation,[{key:'componentDidMount',value:function componentDidMount(){$(document).ready(function(){$('.mobile-nav-collapsible').collapsible();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row cult-tabs-display-lg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'pointer',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push('/cultivation');}},'Cultivation ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_2_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_tabs__["a" /* default */],{id:"cultivation",tabs:__WEBPACK_IMPORTED_MODULE_5__cult_constants__["m" /* CULTIVATION_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row cult-tabs-display-sm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'collapsible mobile-nav-collapsible','data-collapsible':'accordion'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'collapsible-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'apps'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Menu')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'collapsible-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_5__cult_constants__["m" /* CULTIVATION_URLS */].concat({name:'Introduction',url:'/cultivation',level:1}).map(function(c){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:c.name,className:'collection-item chem-list-item',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"].push(c.url);$('.mobile-nav-collapsible').collapsible('close',0);}},c.name);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cultivation-display'},this.props.children));}}]);return Cultivation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cultivation));/* END */

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChemicalApplicationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cult_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/******************************************************************************
Chemical Reducer: Handles all interactions & state changes with the chemical
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/23/19
*******************************************************************************/var initState={chemicalApplications:{all:[],displaying:[]},view:{app:{},previousApplications:[]},app:{editingApplication:false,solutions:[],// Solutions used
selectedField:{},chemAppId:null,// Application ID if editing
isEditing:false,editSolution:{},// Solution being edited
totalGallons:0,// Used to calculate percentage of chem used
application:{},// Application to submit
previousApplications:[],// Previous applications within the same field, round
deletedSolutions:[]// Solutions deleted during the app edit process(Need to delete serverside)
}};function ChemicalApplicationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_2" /* ADD_SOLUTION */]:return Object.assign({},state,{app:Object.assign({},state.app,{solutions:state.app.solutions.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_3" /* SELECT_SOLUTION_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{isEditing:true,editSolution:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_4" /* EDIT_SOLUTION */]:return Object.assign({},state,{app:Object.assign({},state.app,{solutions:state.app.solutions.filter(function(s){return s.id!==state.app.editSolution.id;}).concat(action.payload),isEditing:false,editSolution:{}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_5" /* DELETE_SOLUTION */]:return Object.assign({},state,{app:Object.assign({},state.app,{solutions:state.app.solutions.filter(function(s){return s.id!==action.payload.id;}),isEditing:false,editSolution:{},deletedSolutions:state.app.deletedSolutions.concat(action.payload.id)})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_8" /* SELECT_FIELD */]:return Object.assign({},state,{app:Object.assign({},state.app,{selectedField:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_7" /* SELECT_FIELD_FOR_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{selectedField:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_6" /* SET_TOTAL_GALLONS */]:// Yeah, don't do this. Fix this later 8.6.19
var solutions=state.app.solutions;if(state.app.solutions.length>0){solutions=state.app.solutions.map(function(s){return Object.assign({},s,{percentageUsed:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cult_utils__["t" /* calculatePercentage */])({quantity:s.chemDosage1,unit:s.chemDosage2,totalGallons:action.payload})});});}return Object.assign({},state,{app:Object.assign({},state.app,{totalGallons:action.payload,solutions:solutions})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["R" /* PREPARE_DATA */]:return Object.assign({},state,{app:Object.assign({},state.app,{application:action.payload,previousApplications:action.previousApplications})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_18" /* CREATE_CHEMICAL_APPLICATION */]:return Object.assign({},state,{chemicalApplications:{all:state.chemicalApplications.all.concat(action.payload),displaying:state.chemicalApplications.displaying.concat(action.payload).sort(sortByDateField)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_19" /* EDIT_CHEMICAL_APPLICATION */]:return Object.assign({},state,{chemicalApplications:{all:state.chemicalApplications.all.filter(function(c){return c.chemAppId!==action.payload.chemAppId;}).concat(action.payload).sort(sortByDateField),displaying:state.chemicalApplications.displaying.filter(function(c){return c.chemAppId!==action.payload.chemAppId;}).concat(action.payload).sort(sortByDateField)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Z" /* FETCH_CHEMICAL_APPLICATIONS */]:return Object.assign({},state,{chemicalApplications:{all:action.payload,displaying:action.payload.sort(sortByDateField)}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_1" /* DELETE_CHEMICAL_APPLICATION */]:return Object.assign({},state,{chemicalApplications:{all:state.chemicalApplications.all.filter(function(c){return c.id!==Number(action.payload);}),displaying:state.chemicalApplications.displaying.filter(function(c){return c.id!==Number(action.payload);}),previousApplications:[]}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_9" /* SELECT_CHEMICAL_APPLICATION_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{editingApplication:true,totalGallons:action.payload.measurement,solutions:action.payload.solutions,chemAppId:action.payload.chemAppId,selectedField:action.field,application:{},isEditing:false,editSolution:{},// Solution being edited
previousApplications:[],// Previous applications within the same field, round
deletedSolutions:[]// Solutions deleted during the app edit process(Need to delete serverside)
})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_0" /* SELECT_APPLICATION_TO_VIEW */]:return Object.assign({},state,{view:{app:action.payload,previousApplications:action.previousApplications}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["p" /* CLEAR_FORM */]:return Object.assign({},state,{app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["q" /* ERROR */]:return state;default:return state;}}function sortByDateField(a,b){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('YYYY-MM-DD')<__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.date).format('YYYY-MM-DD'))return 1;else if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('YYYY-MM-DD')>__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.date).format('YYYY-MM-DD'))return-1;else if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.date).format('YYYY-MM-DD')){if(a.fieldId<b.fieldId)return-1;else if(a.fieldId>b.fieldId)return 1;return 0;}return 0;}/* END */

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ChemicalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/******************************************************************************
Chemical Reducer: Handles all interactions & state changes with the chemical
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/23/19
*******************************************************************************/var initState={chemicalList:[],selectedChemical:{},edit:{isEditing:false,editedChemical:{}}};function ChemicalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["l" /* FETCH_CHEMICALS */]:return Object.assign({},state,{chemicalList:action.payload.sort(sortByTypeName)});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_12" /* CREATE_CHEMICAL */]:return Object.assign({},state,{chemicalList:state.chemicalList.concat(action.payload).sort(sortByTypeName)});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["n" /* SELECT_CHEMICAL */]:return Object.assign({},state,{selectedChemical:state.chemicalList.find(function(c){return c.id===action.payload;})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["o" /* SELECT_CHEMICAL_TO_EDIT */]:return Object.assign({},state,{edit:{isEditing:true,editedChemical:state.chemicalList.find(function(c){return c.id===action.payload;})}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* CLEAR_FORM */]:return Object.assign({},state,{edit:{isEditing:false,editedChemical:{}}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_11" /* EDIT_CHEMICAL */]:return Object.assign({},state,{chemicalList:state.chemicalList.filter(function(c){return c.id!==action.payload.id;}).concat(action.payload).sort(sortByTypeName),edit:{isEditing:false,editedChemical:{}}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["m" /* EMAIL_FILE */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* ERROR */]:return state;default:return state;}}function sortByTypeName(a,b){if(a.type<b.type)return-1;else if(a.type>b.type)return 1;else if(a.type===b.type){if(a.name<b.name)return-1;else if(a.name>b.name)return 1;return 0;}return 0;}/* END */

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FertilizerReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types__ = __webpack_require__(17);
/******************************************************************************
Fertilizer Reducer: Handles all interactions & state changes with the fertilizer
component.
Hawaiian Macadamia Nut Services
Alexander Self
2/06/20
*******************************************************************************/var initState={fertilizerApplications:{all:[],displaying:[]},view:{app:{}},app:{solidOrLiquid:'S',// Determines if the form is for solids or liquids (tons applied vs. gal applied) Ganular vs Foliar spray
type:__WEBPACK_IMPORTED_MODULE_1__actions_types__["_16" /* CREATE_FERTILIZER_APPLICATION */],// type of action
path:'createFertilizerApplication',editingApplication:false,fertilizerApplied:[],// Fertilizer records
selectedFields:[],fertAppId:null,// Application ID if editing
isEditing:false,editFertilizerApplied:{},// Fertilizer being edited
application:{},// Application to submit
previousApplications:[],// Previous applications within the same field, round
deletedFertilizerApplied:[]// Fertilizers applied deleted during the app edit process(deletes serverside)
}};function FertilizerReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_types__["P" /* FETCH_FERTILIZER_APPLICATIONS */]:return Object.assign({},state,{fertilizerApplications:{all:action.payload.sort(sortByDateField),displaying:action.payload.sort(sortByDateField)}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_16" /* CREATE_FERTILIZER_APPLICATION */]:return Object.assign({},state,{fertilizerApplications:{all:state.fertilizerApplications.all.concat(action.payload).sort(sortByDateField),displaying:state.fertilizerApplications.all.concat(action.payload).sort(sortByDateField)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["T" /* ADD_FERTILIZER */]:return Object.assign({},state,{app:Object.assign({},state.app,{fertilizerApplied:state.app.fertilizerApplied.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["U" /* EDIT_FERTILIZER */]:return Object.assign({},state,{app:Object.assign({},state.app,{isEditing:false,editFertilizerApplied:initState.app.editFertilizerApplied,fertilizerApplied:state.app.fertilizerApplied.filter(function(f){return f.id!==state.app.editFertilizerApplied.id;}).concat(Object.assign({id:state.app.editFertilizerApplied.id},action.payload))})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["W" /* SELECT_FERTILIZER_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{editFertilizerApplied:action.payload,solidOrLiquid:action.solOrLiq,isEditing:true})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["V" /* DELETE_FERTILIZER */]:return Object.assign({},state,{app:Object.assign({},state.app,{fertilizerApplied:state.app.fertilizerApplied.filter(function(f){return f.id!==action.payload.id;}),deletedFertilizerApplied:state.app.deletedFertilizerApplied.concat(action.payload.id)})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["X" /* SET_FERTILIZER_FORM */]:return Object.assign({},state,{app:Object.assign({},state.app,{solidOrLiquid:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["R" /* PREPARE_DATA */]:return Object.assign({},state,{app:Object.assign({},state.app,{application:action.payload,previousApplications:action.previousApplications})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Y" /* SELECT_FERTILIZER_APPLICATION */]:return Object.assign({},state,{view:{app:action.payload}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Q" /* DELETE_FERTILIZER_APPLICATION */]:return Object.assign({},state,{fertilizerApplications:{all:state.fertilizerApplications.all.filter(function(f){return f.fertAppId!==action.payload;}).sort(sortByDateField),displaying:state.fertilizerApplications.displaying.filter(function(f){return f.fertAppId!==action.payload;}).sort(sortByDateField)},view:initState.view});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["S" /* SELECT_FERT_APP_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{type:__WEBPACK_IMPORTED_MODULE_1__actions_types__["_17" /* EDIT_FERTILIZER_APPLICATION */],path:'editFertilizerApplication',editingApplication:true,fertAppId:action.payload.fertAppId,fertilizerApplied:action.payload.fertilizerApplied,deletedFertilizerApplied:initState.app.deletedFertilizerApplied,previousApplications:initState.app.previousApplications})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_17" /* EDIT_FERTILIZER_APPLICATION */]:return Object.assign({},state,{fertilizerApplications:{all:state.fertilizerApplications.all.filter(function(f){return f.fertAppId!==action.payload.fertAppId;}).concat(action.payload).sort(sortByDateField),displaying:state.fertilizerApplications.all.filter(function(f){return f.fertAppId!==action.payload.fertAppId;}).concat(action.payload).sort(sortByDateField)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["p" /* CLEAR_FORM */]:return Object.assign({},state,{app:initState.app});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["q" /* ERROR */]:return state;default:return state;}}function sortByDateField(a,b){if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')<__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD'))return 1;else if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')>__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD'))return-1;else if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD')){if(a.field<b.field)return-1;else if(a.field>b.field)return 1;return 0;}return 0;}/* END */

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chemical_reducer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__report_reducer__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_reducer__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chem_app_reducer__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fertilizer_reducer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mowing_reducer__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_inventory_reducer__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tree_replant_reducer__ = __webpack_require__(410);
/***************************************************
Alexander Self
7/22/19
Root reducer: Combines all cultivation reducers
****************************************************/var cultivationReducer=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({chemical:__WEBPACK_IMPORTED_MODULE_1__chemical_reducer__["a" /* default */],chemApp:__WEBPACK_IMPORTED_MODULE_4__chem_app_reducer__["a" /* default */],fertilizer:__WEBPACK_IMPORTED_MODULE_5__fertilizer_reducer__["a" /* default */],mowing:__WEBPACK_IMPORTED_MODULE_6__mowing_reducer__["a" /* default */],report:__WEBPACK_IMPORTED_MODULE_2__report_reducer__["a" /* default */],treeInventory:__WEBPACK_IMPORTED_MODULE_7__tree_inventory_reducer__["a" /* default */],treeReplant:__WEBPACK_IMPORTED_MODULE_8__tree_replant_reducer__["a" /* default */],utils:__WEBPACK_IMPORTED_MODULE_3__utils_reducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (cultivationReducer);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MowingReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/******************************************************************************
Mowing Reducer: Handles all interactions & state changes with the mowing component
Hawaiian Macadamia Nut Services
Alexander Self
03/18/20
*Note: Day 9 of quarantine.
*******************************************************************************/var initState={mowingRecords:{all:[],displaying:[]},view:{app:{}},app:{editingApplication:false,selectedFields:[],type:__WEBPACK_IMPORTED_MODULE_0__actions_types__["_14" /* CREATE_MOWING_APPLICATION */],// type of action
path:'createMowingApplication',mowJobs:[],mowAppId:null,// Application ID if editing
isEditing:false,editingMow:{},// Mow being edited
application:{},// Application to submit
previousApplications:[],// Previous applications within the same field, round
deletedMowingRecords:[]// Fertilizers applied deleted during the app edit process(deletes serverside)
}};function MowingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["G" /* FETCH_MOWING_APPLICATIONS */]:return Object.assign({},state,{mowingRecords:{all:action.payload,displaying:action.payload}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["J" /* ADD_MOWING_RECORD */]:return Object.assign({},state,{app:Object.assign({},state.app,{mowJobs:state.app.mowJobs.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["K" /* EDIT_MOWING_RECORD */]:return Object.assign({},state,{app:Object.assign({},state.app,{mowJobs:state.app.mowJobs.filter(function(m){return m.id!==state.app.editingMow.id;}).concat(action.payload),editingMow:initState.app.editingMow,isEditing:initState.app.isEditing})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["M" /* SELECT_MOW_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{isEditing:true,editingMow:action.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["L" /* DELETE_MOWING_RECORD */]:return Object.assign({},state,{app:Object.assign({},state.app,{mowJobs:state.app.mowJobs.filter(function(m){return m.id!==action.payload.id;}),deletedMowingRecords:state.app.deletedMowingRecords.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["I" /* PREPARE_MOWING_APPLICATION */]:return Object.assign({},state,{app:Object.assign({},state.app,{application:action.payload,previousApplications:action.prevApps})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_14" /* CREATE_MOWING_APPLICATION */]:return Object.assign({},state,{mowingRecords:{all:state.mowingRecords.all.concat(action.payload),displaying:state.mowingRecords.displaying.concat(action.payload)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["N" /* SELECT_MOWING_APPLICATION */]:return Object.assign({},state,{view:{app:action.payload}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["H" /* DELETE_MOWING_APPLICATION */]:return Object.assign({},state,{mowingRecords:{all:state.mowingRecords.all.filter(function(m){return m.mowAppId!==action.payload;}),displaying:state.mowingRecords.displaying.filter(function(m){return m.mowAppId!==action.payload;})}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["O" /* SELECT_MOW_APP_TO_EDIT */]:return Object.assign({},state,{app:Object.assign({},state.app,{type:__WEBPACK_IMPORTED_MODULE_0__actions_types__["_15" /* EDIT_MOWING_APPLICATION */],path:'editMowingApplication',editingApplication:true,mowAppId:action.payload.mowAppId,mowJobs:action.payload.mowJobs,deletedMowingRecords:initState.app.deletedMowingRecords,previousApplications:initState.app.previousApplications})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_15" /* EDIT_MOWING_APPLICATION */]:return Object.assign({},state,{mowingRecords:{all:state.mowingRecords.all.filter(function(m){return m.id!==action.payload.id;}).concat(action.payload),displaying:state.mowingRecords.displaying.filter(function(m){return m.id!==action.payload.id;}).concat(action.payload)},app:initState.app});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* CLEAR_FORM */]:return Object.assign({},state,{app:initState.app});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* ERROR */]:return state;default:return state;}}/* END */

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReportReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/******************************************************************************
Report Reducer: Handles all interactions & state changes with the reports
component.
Hawaiian Macadamia Nut Services
Alexander Self
7/29/19
*******************************************************************************/var initState={date:{},report:{}};function ReportReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_10" /* FETCH_CULTIVATION_REPORT */]:return Object.assign({},state,{report:action.payload});default:return state;}}/* END */

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TreeInventoryReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/******************************************************************************
Tree Inventory Reducer: Handles all interactions & state changes with the tree
inventory component.
Hawaiian Macadamia Nut Services
Alexander Self
03/27/20
*******************************************************************************/var initState={formType:'issueOrReceiveInventory',// Default Value of the switch
inventory:[],// Running master list of all inventory
inventoryTransactions:[],// Running list of all inventory transactions
approvers:[],view:{},// Inventory viewed
edit:{},// Inventory to edit
delete:{},// Inventory to delete
req:{// Inventory request
inventoryMaster:{},// The master inventory record that transactions are requested against
approver:{eid:null},// Approver of the request
previousInventoryTransactions:[]// Any inventory transactions against a particular field(nursery location)
}};function TreeInventoryReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["v" /* FETCH_INVENTORY */]:return Object.assign({},state,{inventory:action.inventory,inventoryTransactions:action.inventoryTransactions.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved')),approvers:action.approvers});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["D" /* SET_FORM_TYPE */]:return Object.assign({},state,{formType:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["A" /* PREPARE_TREE_INVENTORY */]:return Object.assign({},state,{req:Object.assign({},action.payload,{inventoryMaster:state.inventory.find(function(i){return i.physicalLocation===action.payload.field;})||{}})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["x" /* CREATE_INVENTORY_REQUEST */]:return Object.assign({},state,{formType:initState.formType,inventory:state.inventory.concat(action.inventory),inventoryTransactions:state.inventoryTransactions.concat(action.inventoryTransaction).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved'))});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["w" /* ISSUE_OR_RECEIVE_INVENTORY_REQUEST */]:return Object.assign({},state,{formType:initState.formType,inventoryTransactions:state.inventoryTransactions.concat(action.inventoryTransaction).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved'))});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["B" /* APPROVE_INVENTORY_REQUEST */]:return Object.assign({},state,{inventory:state.inventory.filter(function(i){return i.inventoryId!==action.inventoryMaster.inventoryId;}).concat(action.inventoryMaster),inventoryTransactions:state.inventoryTransactions.filter(function(i){return i.id!==action.inventoryTransaction.id;}).concat(action.inventoryTransaction).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved'))});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["E" /* SET_INVENTORY_TO_EDIT */]:return Object.assign({},state,{edit:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* DOWNLOAD_INVENTORY */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST */]:console.log(action.inventoryMaster);return Object.assign({},state,{formType:initState.formType,edit:initState.edit,inventoryTransactions:state.inventoryTransactions.filter(function(i){return i.id!==state.edit.id;}).concat(action.payload).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved')),inventory:state.inventory.filter(function(i){return i.id!==action.inventoryMaster.id;}).concat(action.inventoryMaster).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('physicalLocation'))});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["F" /* SET_INVENTORY_TO_DELETE */]:return Object.assign({},state,{delete:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["z" /* DELETE_INVENTORY_REQUEST */]:return Object.assign({},state,{inventoryTransactions:state.inventoryTransactions.filter(function(i){return i.id!==state.delete.id;}).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* dynamicReverseSort */])('isApproved')),delete:initState.delete});default:return state;}}/* END */

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TreeReplantReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/******************************************************************************
Tree Replant Reducer: Handles all interactions & state changes with the tree replant
component.
Hawaiian Macadamia Nut Services
Alexander Self
03/27/20
*******************************************************************************/var initState={replants:[],edit:{addedEmployees:[]},delete:{},app:{addedEmployees:[],employees:[],prevReplants:[],inventoryTransaction:{}},editing:false};function TreeReplantReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* FETCH_REPLANTS */]:return Object.assign({},state,{replants:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* CREATE_REPLANT */]:return Object.assign({},state,{replants:state.replants.concat(action.payload),app:initState.app});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* EDIT_REPLANT */]:return Object.assign({},state,{replants:state.replants.filter(function(r){return r.id!==state.edit.id;}).concat(action.payload),edit:initState.edit,editing:initState.editing});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* DELETE_REPLANT */]:return Object.assign({},state,{replants:state.replants.filter(function(r){return r.id!==state.delete.id;}),delete:initState.delete});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["f" /* ADD_EMPLOYEE */]:if(state.app.addedEmployees.find(function(e){return e.eid===action.payload.eid;}))return state;return Object.assign({},state,{app:Object.assign({},state.app,{addedEmployees:state.app.addedEmployees.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["g" /* REMOVE_EMPLOYEE */]:return Object.assign({},state,{app:Object.assign({},state.app,{addedEmployees:state.app.addedEmployees.filter(function(e){return e.eid!==action.payload.eid;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["e" /* PREPARE_REPLANT */]:return Object.assign({},state,{app:Object.assign({},state.app,action.payload)});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["h" /* SET_REPLANT_TO_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload,{addedEmployees:action.payload.employees}),editing:true});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["i" /* ADD_EMPLOYEE_TO_EDIT */]:if(state.edit.addedEmployees.find(function(e){return e.eid===action.payload.eid;}))return state;return Object.assign({},state,{edit:Object.assign({},state.edit,{addedEmployees:state.edit.addedEmployees.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* REMOVE_EMPLOYEE_FROM_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{addedEmployees:state.edit.addedEmployees.filter(function(e){return e.eid!==action.payload.eid;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["k" /* SET_REPLANT_TO_DELETE */]:return Object.assign({},state,{delete:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* CLEAR_FORM */]:return Object.assign({},state,{app:initState.app});default:return state;}}/* END */

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UtilsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(17);
/******************************************************************************
Utils reducer
Hawaiian Macadamia Nut Services
Alexander Self
7/29/19
*******************************************************************************/var initState={managers:[],employees:[],fields:[],cert:{},docs:{selected:false,selectedDocs:'',data:{}}};function UtilsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["t" /* FETCH_CULT_EMPLOYEES */]:return Object.assign({},state,{employees:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["s" /* FETCH_MANAGERS */]:return Object.assign({},state,{managers:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["r" /* FETCH_FIELDS */]:return Object.assign({},state,{fields:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_13" /* SET_DOCS */]:return Object.assign({},state,{docs:Object.assign({},state.docs,{selected:true,selectedDocs:action.payload.title})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["u" /* FETCH_CERTIFICATION */]:return Object.assign({},state,{cert:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* ERROR */]:return state;default:return state;}}/* END */

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var IntervalTable=function IntervalTable(_ref){var intervals=_ref.intervals,onClick=_ref.onClick;if(!intervals)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"responsive-table bordered highlight centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-field'},"Field"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r1Start'},"R1 Start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r1End'},"R1 End"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r1Acres'},"R1 Acres"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r1Percent'},"R1 %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r1Interval',className:"blue-text"},"Interval"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r2Start'},"R2 Start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r2End'},"R2 End"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r2Acres'},"R2 Acres"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r2Percent'},"R2 %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r2Interval',className:"blue-text"},"Interval"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r3Start'},"R3 Start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r3End'},"R3 End"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r3Acres'},"R3 Acres"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r3Percent'},"R3 %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{id:'i-r3Interval',className:"blue-text"},"Interval"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,intervals.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:e.field},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.field),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r1Start).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r1End).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r1Acres),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r1Percent+"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,e.r1Interval)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r2Start?__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r2Start).format('YYYY-MM-DD'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r2End?__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r2End).format('YYYY-MM-DD'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r2Acres),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r2Percent?e.r2Percent+"%":''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,e.r2Interval)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r3Start?__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r3Start).format('YYYY-MM-DD'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r3End?__WEBPACK_IMPORTED_MODULE_1_moment___default()(e.r3End).format('YYYY-MM-DD'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r3Acres),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,e.r3Percent?e.r3Percent+"%":''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,e.r3Interval)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tfoot",{className:"hide-on-med-and-down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null)));};/* harmony default export */ __webpack_exports__["a"] = (IntervalTable);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchIntervals;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchSeasons;
/* harmony export (immutable) */ __webpack_exports__["c"] = selectInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(7);
var Materialize=window.Materialize;var $=window.$;function error(err){Materialize.toast(err,4000,'rounded red');return{type:__WEBPACK_IMPORTED_MODULE_1__types__["a" /* INTERVAL_ERROR */],err:err};}/**
* fetchIntervals: fetches the harvest intervals for a given season
* @param {String} season, ex: 2021-22, 2022-23
* @param {String} email
* @param {Boolean} report
* @returns {Array} intervals
* @called-in: ['/interval/interval_view.js]
**/function fetchIntervals(_ref){var season=_ref.season,email=_ref.email,report=_ref.report;$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchIntervals',{headers:{authorization:localStorage.getItem('token')},params:{season:season,email:email,report:report}}).then(function(res){return res.data;}).then(function(res){$('#preloader').css('display','none');if(report===1)Materialize.toast('Report for Season: '+season+' fetched!',4000,'rounded green');dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["b" /* FETCH_INTERVALS */],payload:res.data});}).catch(function(err){return dispatch(error('There was an error fetching data for dashboard: '+err));});};}/**
* fetchSeasonss: fetches the seasons since 2019-20
* @returns {Array} seasons
* @called-in: ['/interval/interval_view.js]
**/function fetchSeasons(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ROOT_URL */]+'/fetchSeasons',{headers:{authorization:localStorage.getItem('token')}}).then(function(res){return res.data;}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["c" /* FETCH_SEASONS */],payload:res.seasons});}).catch(function(err){return dispatch(error('There was an error fetching seasons: '+err));});};}function selectInterval(_ref2){var interval=_ref2.interval,loc=_ref2.loc;return{type:__WEBPACK_IMPORTED_MODULE_1__types__["d" /* SELECT_INTERVAL */],payload:interval,loc:loc};}/* END */

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8/25/22
Interval Container
**********************************************************/var IntervalContainer=function(_Component){_inherits(IntervalContainer,_Component);function IntervalContainer(){_classCallCheck(this,IntervalContainer);return _possibleConstructorReturn(this,(IntervalContainer.__proto__||Object.getPrototypeOf(IntervalContainer)).apply(this,arguments));}_createClass(IntervalContainer,[{key:'componentDidMount',value:function componentDidMount(){document.title='Intervals';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Intervals ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children));}}]);return IntervalContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IntervalContainer));/* END */

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IntervalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(165);
var initState={intervals:[],seasons:[],selectedInterval:{loc:71,hand:[],mech:[]},selectedSeason:{}};function IntervalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_INTERVALS */]:return Object.assign({},state,{intervals:action.payload,selectedInterval:Object.assign({},state.selectedInterval,{hand:action.payload.kau.hand,mech:action.payload.kau.mech})});case __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_SEASONS */]:return Object.assign({},state,{seasons:action.payload});case __WEBPACK_IMPORTED_MODULE_0__types__["d" /* SELECT_INTERVAL */]:return Object.assign({},state,{selectedInterval:{hand:action.payload.hand,mech:action.payload.mech}});default:return state;}}/* END */

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interval_actions__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_interval_table__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8/25/22
Interval View
**********************************************************/var $=window.$;var IntervalView=function(_Component){_inherits(IntervalView,_Component);function IntervalView(props){_classCallCheck(this,IntervalView);var _this=_possibleConstructorReturn(this,(IntervalView.__proto__||Object.getPrototypeOf(IntervalView)).call(this,props));_this.onSubmit=_this.onSubmit.bind(_this);$(document).ready(function(){$('#interval-choice').tabs();});return _this;}_createClass(IntervalView,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.seasons.length===0)this.props.fetchSeasons();if(this.props.intervals.length===0){this.props.fetchIntervals({season:'',email:'',report:0});}}},{key:'onSubmit',value:function onSubmit(){var form=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* packageForm */])('intervalForm');if(!form.season)return;return this.props.fetchIntervals({season:form.season,email:this.props.user.email,report:form.report===1?form.report:0});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'intervalForm',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s5 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_inputs__["a" /* Select */],{id:'season',opts:this.props.seasons.map(function(s){return{val:s,label:'Season '+s};}),label:'Season',defaultValue:this.props.seasons&&this.props.seasons[0]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row trainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_inputs__["b" /* CheckBox */],{id:'report',name:'report',label:'Report'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect',onClick:this.onSubmit},'Fetch')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m4 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_inputs__["c" /* RadioButton */],{id:'kau-interval',name:'interval-opts',label:'Ka\'u',onClick:function onClick(e){return _this2.props.selectInterval({interval:_this2.props.intervals.kau,loc:71});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m4 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_inputs__["c" /* RadioButton */],{id:'keaau-interval',name:'interval-opts',label:'Kea\'au',onClick:function onClick(e){return _this2.props.selectInterval({interval:_this2.props.intervals.keaau,loc:72});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'interval-choice',className:'tabs tabs-fixed-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#hand-interval'},'Hand Intervals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tab col s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#mech-interval'},'Mech Intervals'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interval-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hand-interval'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_interval_table__["a" /* default */],{intervals:this.props.selectedInterval.hand})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mech-interval'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_interval_table__["a" /* default */],{intervals:this.props.selectedInterval.mech})))));}}]);return IntervalView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user,intervals:state.intervals.intervals,seasons:state.intervals.seasons,selectedSeason:state.intervals.selectedSeason,selectedInterval:state.intervals.selectedInterval};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* bindActionCreators */])({fetchSeasons:__WEBPACK_IMPORTED_MODULE_3__interval_actions__["a" /* fetchSeasons */],fetchIntervals:__WEBPACK_IMPORTED_MODULE_3__interval_actions__["b" /* fetchIntervals */],selectInterval:__WEBPACK_IMPORTED_MODULE_3__interval_actions__["c" /* selectInterval */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IntervalView));/* END */

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/***************************************************************
01/18/2019
Alexander Self
Harvest Info Card
- Small info cards of different colors which provide important information
***************************************************************/var HarvestInfoCard=function HarvestInfoCard(_ref){var header=_ref.header,label=_ref.label,icon=_ref.icon,child=_ref.child,data=_ref.data,color=_ref.color,avg1=_ref.avg1,avg2=_ref.avg2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-stats"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content "+color+" white-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("center",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons icon-shift"},icon),header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,data),avg1,avg2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-action "+color+" darken-4"},child)));};/* harmony default export */ __webpack_exports__["a"] = (HarvestInfoCard);/* END */

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_commafy_anything__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__irrigation_info_card__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__irrigation_utils__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8.19.20

***********************************************************/var IrrigationIntroSummary=function(_Component){_inherits(IrrigationIntroSummary,_Component);function IrrigationIntroSummary(){_classCallCheck(this,IrrigationIntroSummary);return _possibleConstructorReturn(this,(IrrigationIntroSummary.__proto__||Object.getPrototypeOf(IrrigationIntroSummary)).apply(this,arguments));}_createClass(IrrigationIntroSummary,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__irrigation_info_card__["a" /* default */],{header:'Total Gallons of Water',icon:'opacity',data:''+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalGal',this.props.valveTotals))),color:'blue',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Gallon/Valve: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["j" /* avgProp */])('totalGal',this.props.valveTotals))))),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.valveTotals.map(function(e){return e.totalGal;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#bbdefb",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__irrigation_info_card__["a" /* default */],{header:'Total Engine Hours',icon:'hourglass_empty',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalHours',this.props.engineTotals))),color:'teal',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Hours/Engine: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["j" /* avgProp */])('totalHours',this.props.engineTotals))))),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.engineTotals.map(function(e){return e.totalHours;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#b2dfdb",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__irrigation_info_card__["a" /* default */],{header:'Total Gallons of Fuel',icon:'waves',data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalFuelGal',this.props.engineTotals))),color:'indigo',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Fuel/Engine: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["j" /* avgProp */])('totalFuelGal',this.props.engineTotals))))),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.engineTotals.map(function(e){return e.totalFuelGal;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#c5cae9",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l3 xl3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__irrigation_info_card__["a" /* default */],{header:'Total Fuel Cost',icon:'monetization_on',data:'$'+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["g" /* sumProp */])('totalFuelCost',this.props.engineTotals))),color:'red',avg1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Avg Fuel Cost/Engine: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'$',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_commafy_anything__["a" /* default */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["j" /* avgProp */])('totalFuelCost',this.props.engineTotals))))),child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["Sparklines"],{data:this.props.engineTotals.map(function(e){return e.totalFuelCost;}),height:20},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesLine"],{style:{stroke:"white",strokeWidth:"1",fill:"#ffcdd2",fillOpacity:"0.5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_sparklines__["SparklinesReferenceLine"],{type:'mean'}))})));}}]);return IrrigationIntroSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IrrigationIntroSummary);/* END */

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irrigation_utils__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8.20.20
Meter Summary: Simple meter table or irrigation
***********************************************************/var MeterSummary=function(_Component){_inherits(MeterSummary,_Component);function MeterSummary(){_classCallCheck(this,MeterSummary);return _possibleConstructorReturn(this,(MeterSummary.__proto__||Object.getPrototypeOf(MeterSummary)).apply(this,arguments));}_createClass(MeterSummary,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection z-depth-1 with-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons cyan circle'},'insert_chart'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'flow-text'},'Meter Summary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:true},'By Meter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'highlight bordered responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Meter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Starting Gallons (M)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ending Gallons (M)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Totals Gallons (M)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Average Gallons (M)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.meterTotals.map(function(m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:m.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.startGal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.endGal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.totalGal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,m.avgGal));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__irrigation_utils__["g" /* sumProp */])('totalGal',this.props.meterTotals)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__irrigation_utils__["j" /* avgProp */])('avgGal',this.props.meterTotals)))))))));}}]);return MeterSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MeterSummary);/* END */

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Engine table component: called in irrigation_create
**********************************************************/var propTypes={engines:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,engineLog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};var EngineTable=function EngineTable(_ref){var engines=_ref.engines,engineLog=_ref.engineLog;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'irr-log-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'responsive-table bordered highlight centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Engine'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Fuel (gal)'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,engineLog.map(function(e){var engine=engines.find(function(_e){return _e.id===e.engineId;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:e.engineId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,engine===undefined?'':engine.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,e.hours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,e.totalFuelGal));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',{className:'hide-on-med-and-down'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,engineLog.length>0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__irrigation_utils__["g" /* sumProp */])('hours',engineLog):0))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,engineLog.length>0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__irrigation_utils__["g" /* sumProp */])('totalFuelGal',engineLog):0)))))));};EngineTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (EngineTable);/* END */

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Engine Hours component: called in irrigation_form
**********************************************************/var propTypes={engines:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,handleEngineHours:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};var EngineHours=function EngineHours(_ref){var engines=_ref.engines,handleEngineHours=_ref.handleEngineHours,edit=_ref.edit;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card z-depth-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'card-title blue-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('u',null,'Engine Hours')),engines.map(function(e){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:e.equipmentNo},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["g" /* NumberInput */],{id:'engine'+e.id+'-hours',name:'engine-'+e.id,label:e.name,min:0,max:1000,_class:'irr-label',onChange:function onChange(){return handleEngineHours({e:{engineId:e.id,hours:document.getElementById('engine'+e.id+'-hours').value,totalFuelGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__irrigation_utils__["i" /* calculateTotalFuelGallons */])({hours:document.getElementById('engine'+e.id+'-hours').value,galPerHour:e.galPerHour})},edit:edit});}}));}))));};EngineHours.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (EngineHours);/* END */

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Engine Hours component: called in irrigation_form
**********************************************************/var propTypes={meters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,calculateTotalMeterGallons:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleMeterGallons:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var MeterGallons=function MeterGallons(_ref){var meters=_ref.meters,calculateTotalMeterGallons=_ref.calculateTotalMeterGallons,handleMeterGallons=_ref.handleMeterGallons,edit=_ref.edit;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card z-depth-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'card-title blue-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,'Meter Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Meter')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Starting Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Ending Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Total'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6 hide-on-small-only'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Meter')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Starting Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Ending Gallons')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'meter-label'},'Total')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},meters.map(function(m){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:m.id,className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'irr-meter-label z-depth-3'},m.meterNo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["g" /* NumberInput */],{id:'meter'+m.id+'-startGal',name:'meter-'+m.id,min:0,max:1000000000})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["g" /* NumberInput */],{id:'meter'+m.id+'-endGal',name:'meter-'+m.id,min:0,max:1000000000,onChange:function onChange(e){calculateTotalMeterGallons({startGal:document.getElementById('meter'+m.id+'-startGal').value,endGal:e.target.value,totalGalDOM:document.getElementById('meter'+m.id+'-totalGal')});handleMeterGallons({m:{meterId:m.id,engineId:m.engineId,startGal:document.getElementById('meter'+m.id+'-startGal').value,endGal:e.target.value,totalGal:document.getElementById('meter'+m.id+'-totalGal').value},edit:edit});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s3 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["g" /* NumberInput */],{id:'meter'+m.id+'-totalGal',defaultValue:0,disabled:true})));})))));};MeterGallons.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MeterGallons);/* END */

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Valve Hours component: called in irrigation_form
**********************************************************/var propTypes={valves:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,handleValveHours:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};var ValveHours=function ValveHours(_ref){var valves=_ref.valves,handleValveHours=_ref.handleValveHours,edit=_ref.edit;function _onChange(hours){if(Number(hours.value)===0)hours.style.backgroundColor='#ffffff';if(Number(hours.value)>0){hours.style.backgroundColor='#bbdefb';hours.style.fontWeight='bold';hours.style.textAlign='center';hours.style.color='#424242';}return;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'utils-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card z-depth-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'card-title blue-text'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('u',null,'Valve Hours')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},valves.map(function(v){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:v.id,className:'col s6 m3 l3 xl3'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s4 m4 l4 xl4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'irr-meter-label z-depth-3'},v.valveNo)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col s8 m8 l8 xl8'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["g" /* NumberInput */],{id:'valve'+v.id+'-hours',name:'valve-'+v.id,min:0,max:100,onChange:function onChange(e){_onChange(document.getElementById('valve'+v.id+'-hours'));handleValveHours({v:{valveId:v.id,engineId:v.engineId,meterId:v.meterId,hours:e.target.value,totalGal:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__irrigation_utils__["h" /* calculateTotalGallons */])({hours:e.target.value,galPerMinute:v.galPerMinute})},edit:edit});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["h" /* HiddenInput */],{id:'valve'+v.id+'-engineId',value:v.engineId}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["h" /* HiddenInput */],{id:'valve'+v.id+'-meterId',value:v.meterId}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["h" /* HiddenInput */],{id:'valve'+v.id+'-valveId',value:v.id}));})))));};ValveHours.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ValveHours);/* END */

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Engine table component: called in irrigation_create
**********************************************************/var propTypes={meters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,meterLog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};var MeterTable=function MeterTable(_ref){var meters=_ref.meters,meterLog=_ref.meterLog;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'irr-log-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'responsive-table bordered highlight centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Meter'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Starting Gal'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Ending Gal'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Total Gal'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,meterLog.map(function(m){var meter=meters.find(function(_m){return _m.id===m.meterId;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:m.meterId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,meter===undefined?'':meter.meterNo),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,m.startGal),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,m.endGal),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,m.totalGal));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',{className:'hide-on-med-and-down'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,'Total')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,meterLog.length>0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__irrigation_utils__["g" /* sumProp */])('totalGal',meterLog):0)))))));};MeterTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (MeterTable);/* END */

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inputs__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/27/20
Irrigation Reporrt Form
**********************************************************/var propTypes={employees:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};var ReportForm=function(_Component){_inherits(ReportForm,_Component);function ReportForm(props){_classCallCheck(this,ReportForm);var _this=_possibleConstructorReturn(this,(ReportForm.__proto__||Object.getPrototypeOf(ReportForm)).call(this,props));_this.handleSubmit=_this.handleSubmit.bind(_this);return _this;}_createClass(ReportForm,[{key:'handleSubmit',value:function handleSubmit(_ref){var startDate=_ref.startDate,endDate=_ref.endDate;if(!(startDate&&endDate))return this.props.error('Please select a start date and end date');if(new Date(startDate)>new Date(endDate))return this.props.error('Start date must precede the end date');return this.props.fetchIrrigationReport({startDate:__WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_3_moment___default()(endDate).format('YYYY-MM-DD'),email:this.props.user.email});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'irrigation-report-form',onSubmit:function onSubmit(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["d" /* DatePicker2 */],{id:'irrigation-startDate',label:'Start Date'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__components_inputs__["d" /* DatePicker2 */],{id:'irrigation-endDate',label:'End Date'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-large waves-effect',onClick:function onClick(){return _this2.handleSubmit({startDate:document.getElementById('irrigation-startDate').value,endDate:document.getElementById('irrigation-endDate').value});}},'Run Report')))));}}]);return ReportForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ReportForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ReportForm);/* END */

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Valve table component: called in irrigation_create
**********************************************************/var propTypes={valves:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,valveLog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};var ValveTable=function ValveTable(_ref){var valves=_ref.valves,valveLog=_ref.valveLog;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'irr-log-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'responsive-table bordered highlight centered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Valve'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Gal/min'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Hours'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Gallons'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,valveLog.map(function(v){var valve=valves.find(function(_v){return _v.id===v.valveId;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:v.valveId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,valve===undefined?'':valve.valveNo),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,valve===undefined?'':valve.galPerMinute),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,v.hours),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,v.totalGal));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tfoot',{className:'hide-on-med-and-down'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,'Totals')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,valveLog.length>0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__irrigation_utils__["g" /* sumProp */])('hours',valveLog):0))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,valveLog.length>0?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__irrigation_utils__["g" /* sumProp */])('totalGal',valveLog):0)))))));};ValveTable.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ValveTable);/* END */

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabs__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__irrigation_css__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__irrigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__irrigation_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Alexander Self
8/22/17
Irrigation container
**********************************************************/var IrrigationContainer=function(_Component){_inherits(IrrigationContainer,_Component);function IrrigationContainer(){_classCallCheck(this,IrrigationContainer);return _possibleConstructorReturn(this,(IrrigationContainer.__proto__||Object.getPrototypeOf(IrrigationContainer)).apply(this,arguments));}_createClass(IrrigationContainer,[{key:'componentDidMount',value:function componentDidMount(){document.title='Irrigation';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Irrigation ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flow-text right'},__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd, MMMM Do YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_tabs__["a" /* default */],{id:"irrigation",tabs:__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* IRRIGATION_URLS */],level:this.props.user.level})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children));}}]);return IrrigationContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IrrigationContainer));/* END */

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__irrigation_actions__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_irrigation_form__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_footer_modal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_irrigation_display__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Create
**********************************************************/var propTypes={employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleEngineHours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleValveHours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleMeterGallons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,createIrrigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,preloadMeterForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,prepareData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var IrrigationCreate=function(_Component){_inherits(IrrigationCreate,_Component);function IrrigationCreate(){_classCallCheck(this,IrrigationCreate);return _possibleConstructorReturn(this,(IrrigationCreate.__proto__||Object.getPrototypeOf(IrrigationCreate)).apply(this,arguments));}_createClass(IrrigationCreate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.meters.length>0)this.props.preloadMeterForm({prevMeters:this.props.prevMeters,formId:'meter-form'});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_irrigation_form__["a" /* default */],{formId:'irrigation-form',employees:this.props.employees,engines:this.props.engines,meters:this.props.meters,valves:this.props.valves,handleEngineHours:this.props.handleEngineHours,handleMeterGallons:this.props.handleMeterGallons,handleValveHours:this.props.handleValveHours})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#irrigation-log-prepare',onClick:function onClick(){return _this2.props.prepareData({user:_this2.props.user,engineLog:_this2.props.app.engineLog,meterLog:_this2.props.app.meterLog,valveLog:_this2.props.app.valveLog,formData:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__irrigation_utils__["d" /* packageForm */])('irrigation-form')});}},'Prepare')),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_footer_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__components_irrigation_display__["a" /* default */])// eslint-disable-next-line
({id:'irrigation-log-prepare',employees:this.props.employees,engines:this.props.engines,meters:this.props.meters,valves:this.props.valves,app:this.props.app,view:false,footer:true,onClick:function onClick(){return _this2.props.createIrrigation({app:_this2.props.app,employees:_this2.props.employees,formId:'irrigation-form'});}})));}}]);return IrrigationCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{app:state.irrigation.create.app,employees:state.irrigation.utils.employees,engines:state.irrigation.utils.engines,meters:state.irrigation.utils.meters,prevMeters:state.irrigation.create.prevMeters,user:state.auth.user,valves:state.irrigation.utils.valves};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({createIrrigation:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["h" /* createIrrigation */],handleEngineHours:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["c" /* handleEngineHours */],handleMeterGallons:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["d" /* handleMeterGallons */],handleValveHours:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["e" /* handleValveHours */],preloadMeterForm:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["i" /* preloadMeterForm */],prepareData:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["j" /* prepareData */]},dispatch);}IrrigationCreate.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IrrigationCreate));/* END */

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_chartjs_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__harvest_utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_irrigation_intro_summary__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_meter_summary__ = __webpack_require__(419);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation view
**********************************************************/var propTypes={dashboardData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var IrrigationDashboard=function(_Component){_inherits(IrrigationDashboard,_Component);function IrrigationDashboard(){_classCallCheck(this,IrrigationDashboard);return _possibleConstructorReturn(this,(IrrigationDashboard.__proto__||Object.getPrototypeOf(IrrigationDashboard)).apply(this,arguments));}_createClass(IrrigationDashboard,[{key:'render',value:function render(){var _props$dashboardData=this.props.dashboardData,engineTotals=_props$dashboardData.engineTotals,meterTotals=_props$dashboardData.meterTotals,valveTotals=_props$dashboardData.valveTotals,fieldTotals=_props$dashboardData.fieldTotals,blockTotals=_props$dashboardData.blockTotals;/* Line Chart: By Engine */var line_2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* generateGraphDataAndLabels */])('totalFuelCost','key',engineTotals);var line_3=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* generateGraphDataAndLabels */])('totalGal','key',fieldTotals);/* Bar Chart: Gal by valve */var bar_1=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* generateGraphDataAndLabels */])('totalGal','key',valveTotals);var bar_2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* generateGraphDataAndLabels */])('totalGal','key',blockTotals);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,engineTotals.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_dashboard_irrigation_intro_summary__["a" /* default */],{engineTotals:engineTotals,meterTotals:meterTotals,valveTotals:valveTotals}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Gallons by Valve'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__["Bar"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["a" /* initBarChart */])({label:'Total Gallons by Valve',labels:bar_1.labels,data:bar_1.data,backgroundColor:'#42a5f5',borderColor:'#1565c0 ',borderWidth:1,hoverBackgroundColor:'#e3f2fd',hoverBorderColor:'#90caf9'}),height:300,options:{maintainAspectRatio:false}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Fuel Cost by Engine'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__["Line"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["b" /* initLineChart */])({label:'Total Cost by Engine',labels:line_2.labels,data:line_2.data,backgroundColor:'#00897b'}),height:300,options:{maintainAspectRatio:false}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Gallons by Field'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__["Line"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["b" /* initLineChart */])({label:'Total Gallons by Field',labels:line_3.labels,data:line_3.data,backgroundColor:'#9c27b0'}),height:300,options:{maintainAspectRatio:false,fill:true}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title grey-text text-darken-4'},'Gallons by Block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__["Bar"],{data:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__harvest_utils__["a" /* initBarChart */])({label:'Total Gallons by Block',labels:bar_2.labels,data:bar_2.data,backgroundColor:'#8bc34a',borderColor:'#33691e ',borderWidth:1,hoverBackgroundColor:'#aed581',hoverBorderColor:'#dcedc8vv'}),height:300,options:{maintainAspectRatio:false}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_dashboard_meter_summary__["a" /* default */],{meterTotals:meterTotals}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'No irrigation data exists for the date range.')));}}]);return IrrigationDashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IrrigationDashboard.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (IrrigationDashboard);/* END */

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__irrigation_actions__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__irrigation_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_irrigation_form__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_footer_modal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_irrigation_display__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Manage
**********************************************************/var propTypes={employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleEngineHours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleValveHours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleMeterGallons:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,deleteIrrigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var SpanList=function SpanList(_ref){var list=_ref.list,log=_ref.log,id=_ref.id,prop=_ref.prop,_class=_ref._class;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_class},log.map(function(m,ind){var _m=list.find(function(l){return l.id===m[id];});if(ind===log.length-1)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:m.id},_m[prop]);else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:m.id},_m[prop],', ');}));};var IrrigationManage=function(_Component){_inherits(IrrigationManage,_Component);function IrrigationManage(){_classCallCheck(this,IrrigationManage);return _possibleConstructorReturn(this,(IrrigationManage.__proto__||Object.getPrototypeOf(IrrigationManage)).apply(this,arguments));}_createClass(IrrigationManage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.app.engineLog.length>0&&this.props.employees.length>0){var name='N/A';var emp=this.props.employees.find(function(e){return Number(e.id)===Number(_this2.props.app.data.employee);});if(emp)name=emp.firstName+' '+emp.lastName;document.getElementById('irrigation-date').value=__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.app.data.date).format('YYYY-MM-DD');document.getElementById('irrigation-notes').value=this.props.app.data.notes;document.getElementById('irrigation-employee').value=name;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__irrigation_utils__["a" /* preFillForm */])({data:this.props.app.engineLog.map(function(e){return Object.assign({},e,{id:e.engineId});}),formId:'engine-form',prop:'hours'});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__irrigation_utils__["a" /* preFillForm */])({data:this.props.app.valveLog.map(function(e){return Object.assign({},e,{id:e.valveId});}),formId:'valve-form',prop:'hours',style:true});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__irrigation_utils__["b" /* preFillMeterForm */])({data:this.props.app.meterLog,formId:'meter-form'});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m2 l2 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'irrigation-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},this.props.irrigationLogs.filter(__WEBPACK_IMPORTED_MODULE_6__irrigation_utils__["c" /* filterOldRecords */]).map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:c.id,className:'collection-item chem-list-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(c.date).format('MM/DD/YYYY'),', Meter(s):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpanList,{log:c.meterLog,list:_this3.props.meters,id:'meterId',prop:'meterNo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meter-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-small blue irr-manage-btn waves-effect',onClick:function onClick(){return _this3.props.selectIrrigationLogToEdit({i:c,employees:_this3.props.employees});}},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn btn-small irr-manage-btn red modal-trigger',href:'#irrigation-delete-'+c.id},'Delete')),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_footer_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__components_irrigation_display__["a" /* default */])// eslint-disable-next-line
({id:'irrigation-delete-'+c.id,employees:_this3.props.employees,engines:_this3.props.engines,meters:_this3.props.meters,valves:_this3.props.valves,app:{data:Object.assign({},c),engineLog:c.engineLog,meterLog:c.meterLog,valveLog:c.valveLog},view:false,footer:true,toDelete:true,onClick:function onClick(){return _this3.props.deleteIrrigation(c.irrigationId);}}));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m10 l10 xl10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_irrigation_form__["a" /* default */],{formId:'irrigation-edit-form',employees:this.props.employees,engines:this.props.engines,meters:this.props.meters,valves:this.props.valves,handleEngineHours:this.props.handleEngineHours,handleMeterGallons:this.props.handleMeterGallons,handleValveHours:this.props.handleValveHours,edit:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn modal-trigger',href:'#irrigation-edit-log-prepare',onClick:function onClick(){return _this3.props.prepareEditData({user:_this3.props.user,irrigationId:_this3.props.app.data.irrigationId,engineLog:_this3.props.app.engineLog,meterLog:_this3.props.app.meterLog,valveLog:_this3.props.app.valveLog,formData:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__irrigation_utils__["d" /* packageForm */])('irrigation-edit-form')});}},'Prepare')),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_footer_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__components_irrigation_display__["a" /* default */])// eslint-disable-next-line
({id:'irrigation-edit-log-prepare',employees:this.props.employees,engines:this.props.engines,meters:this.props.meters,valves:this.props.valves,app:this.props.app,view:false,footer:true,onClick:function onClick(){return _this3.props.editIrrigation({app:_this3.props.app,deleted:_this3.props.deleted,employees:_this3.props.employees,formId:'irrigation-edit-form'});}})))));}}]);return IrrigationManage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{app:state.irrigation.edit.app,deleted:state.irrigation.edit.deleted,employees:state.irrigation.utils.employees,engines:state.irrigation.utils.engines,irrigationLogs:state.irrigation.view.displaying,meters:state.irrigation.utils.meters,user:state.auth.user,valves:state.irrigation.utils.valves};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* bindActionCreators */])({deleteIrrigation:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["a" /* deleteIrrigation */],editIrrigation:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["b" /* editIrrigation */],handleEngineHours:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["c" /* handleEngineHours */],handleMeterGallons:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["d" /* handleMeterGallons */],handleValveHours:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["e" /* handleValveHours */],prepareEditData:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["f" /* prepareEditData */],selectIrrigationLogToEdit:__WEBPACK_IMPORTED_MODULE_5__irrigation_actions__["g" /* selectIrrigationLogToEdit */]},dispatch);}IrrigationManage.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IrrigationManage));/* END */

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__irrigation_actions__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_report_form__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_footer_modal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_irrigation_display__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__irrigation_dashboard__ = __webpack_require__(429);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation view
**********************************************************/var propTypes={employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,engines:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,meters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,valves:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fetchIrrigation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchEmployees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var TDList=function TDList(_ref){var list=_ref.list,log=_ref.log,id=_ref.id,prop=_ref.prop,_class=_ref._class;if(!log)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_class},log.map(function(m,ind){var _m=list.find(function(l){return l.id===m[id];});if(ind===log.length-1)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:m.id},_m[prop]);else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:m.id},_m[prop],', ');}));};var IrrigationView=function(_Component){_inherits(IrrigationView,_Component);function IrrigationView(props){_classCallCheck(this,IrrigationView);var _this=_possibleConstructorReturn(this,(IrrigationView.__proto__||Object.getPrototypeOf(IrrigationView)).call(this,props));_this.state={irrigation:_this.props.irrigationLogs,reverseSort:false};_this.sortBy=_this.sortBy.bind(_this);return _this;}_createClass(IrrigationView,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.engines.length===0)this.props.fetchIrrigation();if(this.props.employees.length===0)this.props.fetchEmployees();}},{key:'sortBy',value:function sortBy(id){var _this2=this;if(!id)return;var _id=id.split('-');if(this.state.reverseSort)this.setState({reverseSort:!this.state.reverseSort},function(){_this2.setState({irrigation:_this2.state.irrigation.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* dynamicReverseSort */])(_id[1]))});});this.setState({irrigation:this.state.irrigation.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* dynamicSort */])(_id[1])),reverseSort:!this.state.reverseSort});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.dashboard?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'left flow-text'},'Dates Selected: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.dashboardData.startDate,' -> ',this.props.dashboardData.endDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.props.resetDashboard();},className:'btn waves-effect'},'Fetch New Report'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__irrigation_dashboard__["a" /* default */],{dashboardData:this.props.dashboardData}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title report-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Irrigation Report'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_report_form__["a" /* default */],{fetchIrrigationReport:this.props.fetchIrrigationReport,user:this.props.user,error:this.props._error})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl10'},this.props.irrigationLogs.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'irrigation-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordered highlight responsive-table centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'i-date',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-engineLog',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Engine'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-meterLog',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Meter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-valveLog',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Valve'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-totalEngineHours',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Engine Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-totalMeterGal',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Meter Gallons (M)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{id:'h-totalValveHours',onClick:function onClick(e){return _this3.sortBy(e.target.id);}},'Valve Hours'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.irrigationLogs.map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default()(i.date).format('MM-DD-YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TDList,{log:i.engineLog,list:_this3.props.engines,id:'engineId',prop:'equipmentNo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TDList,{log:i.meterLog,list:_this3.props.meters,id:'meterId',prop:'meterNo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TDList,{log:i.valveLog,list:_this3.props.valves,id:'valveId',prop:'valveNo',_class:'valve-table-list'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.totalEngineHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.totalMeterGal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i.totalValveHours),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'waves-effect waves-light btn btn-small green modal-trigger',href:'#irrigation-log-'+i.id},'View'),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_footer_modal__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__components_irrigation_display__["a" /* default */])// eslint-disable-next-line
({id:'irrigation-log-'+i.id,employees:_this3.props.employees,engines:_this3.props.engines,meters:_this3.props.meters,valves:_this3.props.valves,app:{data:Object.assign({},i),engineLog:i.engineLog,meterLog:i.meterLog,valveLog:i.valveLog},view:true,toDelete:false,footer:true})));})))):'')));}}]);return IrrigationView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{dashboard:state.irrigation.view.dashboard,dashboardData:state.irrigation.view.dashboardData,employees:state.irrigation.utils.employees,engines:state.irrigation.utils.engines,irrigationLogs:state.irrigation.view.displaying,meters:state.irrigation.utils.meters,user:state.auth.user,valves:state.irrigation.utils.valves};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* bindActionCreators */])({_error:__WEBPACK_IMPORTED_MODULE_6__irrigation_actions__["k" /* _error */],fetchEmployees:__WEBPACK_IMPORTED_MODULE_6__irrigation_actions__["l" /* fetchEmployees */],fetchIrrigation:__WEBPACK_IMPORTED_MODULE_6__irrigation_actions__["m" /* fetchIrrigation */],fetchIrrigationReport:__WEBPACK_IMPORTED_MODULE_6__irrigation_actions__["n" /* fetchIrrigationReport */],resetDashboard:__WEBPACK_IMPORTED_MODULE_6__irrigation_actions__["o" /* resetDashboard */]},dispatch);}IrrigationView.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IrrigationView));/* END */

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IrrigationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__irrigation_utils__ = __webpack_require__(25);
/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Reducer: Handles all state changes with irrigation
**********************************************************/var initState={utils:{engines:[],meters:[],valves:[],employees:[]},view:{all:[],displaying:[],dashboard:false,dashboardData:{startDate:null,endDate:null}},create:{app:{data:{},engineLog:[],meterLog:[],valveLog:[]},prevMeters:[]},edit:{app:{data:{},engineLog:[],meterLog:[],valveLog:[]},deleted:{engineLog:[],meterLog:[],valveLog:[]}}};function IrrigationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* FETCH_IRRIGATION */]:return Object.assign({},state,{utils:Object.assign({},state.utils,{engines:action.payload.engines,meters:action.payload.meters,valves:action.payload.valves}),view:Object.assign({},state.view,{all:action.payload.irrigationLogs,displaying:action.payload.irrigationLogs.sort(sortByDateField)}),create:Object.assign({},state.create,{prevMeters:action.payload.prevMeters})});case __WEBPACK_IMPORTED_MODULE_1__types__["c" /* FETCH_IRRIGATION_EMPLOYEES */]:return Object.assign({},state,{utils:Object.assign({},state.utils,{employees:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__types__["l" /* HANDLE_ENGINE_HOURS */]:return Object.assign({},state,{create:Object.assign({},state.create,{app:Object.assign({},state.create.app,{engineLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.create.app.engineLog,prop:'hours',id:'engineId'})})})});case __WEBPACK_IMPORTED_MODULE_1__types__["k" /* HANDLE_EDIT_ENGINE_HOURS */]:var deleteEngineLog=false;var engLog={};if(Number(action.payload.hours)===0&&state.edit.app.engineLog.find(function(v){return Number(v.engineId)===Number(action.payload.engineId);})){deleteEngineLog=true;engLog=state.edit.app.engineLog.find(function(v){return Number(v.engineId)===Number(action.payload.engineId);});}return Object.assign({},state,{edit:Object.assign({},state.edit,{app:Object.assign({},state.edit.app,{engineLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.edit.app.engineLog,prop:'hours',id:'engineId'})}),deleted:Object.assign({},state.edit.deleted,{engineLog:deleteEngineLog?state.edit.deleted.engineLog.concat(engLog):state.edit.deleted.engineLog})})});case __WEBPACK_IMPORTED_MODULE_1__types__["n" /* HANDLE_METER_GALLONS */]:return Object.assign({},state,{create:Object.assign({},state.create,{app:Object.assign({},state.create.app,{meterLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.create.app.meterLog,prop:'totalGal',id:'meterId'})})})});case __WEBPACK_IMPORTED_MODULE_1__types__["m" /* HANDLE_EDIT_METER_GALLONS */]:var deleteMeterLog=false;var metLog={};if(Number(action.payload.totalGal)===0&&state.edit.app.meterLog.find(function(v){return Number(v.meterId)===Number(action.payload.meterId);})){deleteMeterLog=true;metLog=state.edit.app.meterLog.find(function(v){return Number(v.meterId)===Number(action.payload.meterId);});}return Object.assign({},state,{edit:Object.assign({},state.edit,{app:Object.assign({},state.edit.app,{meterLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.edit.app.meterLog,prop:'totalGal',id:'meterId'})}),deleted:Object.assign({},state.edit.deleted,{meterLog:deleteMeterLog?state.edit.deleted.meterLog.concat(metLog):state.edit.deleted.meterLog})})});case __WEBPACK_IMPORTED_MODULE_1__types__["j" /* HANDLE_VALVE_HOURS */]:return Object.assign({},state,{create:Object.assign({},state.create,{app:Object.assign({},state.create.app,{valveLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.create.app.valveLog,prop:'hours',id:'valveId'})})})});case __WEBPACK_IMPORTED_MODULE_1__types__["i" /* HANDLE_EDIT_VALVE_HOURS */]:var deleteValveLog=false;var _valveLog={};if(Number(action.payload.hours)===0&&state.edit.app.valveLog.find(function(v){return Number(v.valveId)===Number(action.payload.valveId);})){deleteValveLog=true;_valveLog=state.edit.app.valveLog.find(function(v){return Number(v.valveId)===Number(action.payload.valveId);});}return Object.assign({},state,{edit:Object.assign({},state.edit,{app:Object.assign({},state.edit.app,{valveLog:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__irrigation_utils__["k" /* handleLog */])({payload:action.payload,log:state.edit.app.valveLog,prop:'hours',id:'valveId'})}),deleted:Object.assign({},state.edit.deleted,{valveLog:deleteValveLog?state.edit.deleted.valveLog.concat(_valveLog):state.edit.deleted.valveLog})})});case __WEBPACK_IMPORTED_MODULE_1__types__["g" /* PREPARE_IRRIGATION_DATA */]:return Object.assign({},state,{create:Object.assign({},state.create,{app:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__types__["d" /* CREATE_IRRIGATION */]:return Object.assign({},state,{view:Object.assign({},state.view,{all:state.view.all.concat(action.payload.irrigationLog),displaying:state.view.displaying.concat(action.payload.irrigationLog).sort(sortByDateField)}),create:{app:initState.create.app,prevMeters:action.payload.prevMeters}});case __WEBPACK_IMPORTED_MODULE_1__types__["p" /* SELECT_IRRIGATION_LOG_TO_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{app:action.payload,deleted:initState.edit.deleted})});case __WEBPACK_IMPORTED_MODULE_1__types__["f" /* DELETE_IRRIGATION */]:return Object.assign({},state,{view:Object.assign({},state.view,{all:state.view.all.filter(function(i){return i.irrigationId!==action.payload;}),displaying:state.view.displaying.filter(function(i){return i.irrigationId!==action.payload;})}),create:Object.assign({},state.create,{prevMeters:action.prevMeters})});case __WEBPACK_IMPORTED_MODULE_1__types__["h" /* PREPARE_EDIT_IRRIGATION_DATA */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{app:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__types__["e" /* EDIT_IRRIGATION */]:return Object.assign({},state,{view:Object.assign({},state.view,{all:state.view.all.filter(function(i){return i.id!==action.payload.irrigationLog.id;}).concat(action.payload.irrigationLog),displaying:state.view.displaying.filter(function(i){return i.id!==action.payload.irrigationLog.id;}).concat(action.payload.irrigationLog).sort(sortByDateField)}),create:Object.assign({},state.create,{prevMeters:action.payload.prevMeters}),edit:initState.edit});case __WEBPACK_IMPORTED_MODULE_1__types__["b" /* FETCH_IRRIGATION_REPORT */]:return Object.assign({},state,{view:Object.assign({},state.view,{dashboard:true,dashboardData:Object.assign({},action.payload,{startDate:action.startDate,endDate:action.endDate})})});case __WEBPACK_IMPORTED_MODULE_1__types__["q" /* RESET_DASHBOARD */]:return Object.assign({},state,{view:Object.assign({},state.view,{dashboard:initState.view.dashboard,dashboardData:initState.view.dashboardData})});default:return state;}}function sortByDateField(a,b){if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')<__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD'))return 1;else if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')>__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD'))return-1;else if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(a.date).format('YYYY-MM-DD')===__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.date).format('YYYY-MM-DD')){if(a.id<b.id)return-1;else if(a.id>b.id)return 1;return 0;}return 0;}/* END */

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initState={location:"",gang:"",prefillMessage:"",optionalMessage:"",chips:[],gangOptions:[],locationOptions:[]};function formReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_21" /* UPDATE_SELECTED_LOCATION */]:return Object.assign({},state,{location:action.payload.location});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_28" /* UPDATE_PREFILL_MESSAGE */]:return Object.assign({},state,{prefillMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_29" /* UPDATE_OPTIONAL_MESSAGE */]:return Object.assign({},state,{optionalMessage:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_22" /* UPDATE_SELECTED_GANG */]:return Object.assign({},state,{gang:action.payload.gang});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_30" /* UPDATE_CHIPS */]:return Object.assign({},state,{chips:[].concat(_toConsumableArray(state.chips),[action.payload])});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_31" /* REMOVE_CHIP */]:var newChips=[].concat(_toConsumableArray(state.chips));var propToDelete=newChips.findIndex(function(chip){return chip.id===Number(action.payload);});newChips.splice(propToDelete,1);return Object.assign({},state,{chips:newChips});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_25" /* FETCH_GANGS_FOR_SMS */]:return Object.assign({},state,{gangOptions:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_26" /* FETCH_LOCATIONS */]:return Object.assign({},state,{locationOptions:action.payload});default:return state;}}/* END */

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
var initState={employees:[]};function listReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_21" /* UPDATE_SELECTED_LOCATION */]:return Object.assign({},state,{employees:action.payload.employees});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_22" /* UPDATE_SELECTED_GANG */]:return Object.assign({},state,{employees:action.payload.employees});default:return state;}}/* END */

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = messagesReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
var initState={messages:[],searchedMessages:[]};function messagesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_24" /* UPDATE_MESSAGE_LIST */]:return Object.assign({},state,{messages:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_27" /* SEARCH_MESSAGES_DATABASE */]:return Object.assign({},state,{searchedMessages:action.payload});default:return state;}}/* END */

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toastReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
var initState={messageAttempt:false,messageSuccess:false};function toastReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_32" /* TOAST_DISPLAYED */]:return Object.assign({},state,{messageAttempt:false,messageSuccess:false});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_23" /* NOTIFICATION_SENT */]:return Object.assign({},state,{messageAttempt:true,messageSuccess:action.payload});default:return state;}}

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
var initState={authenticated:false,error:'',user:{}};function authReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["O" /* AUTH_USER */]:return{authenticated:true,error:'',user:action.payload};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["x" /* FETCH_USER_PROFILE */]:return Object.assign({},state,{user:Object.assign({},state.user,action.payload)});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["N" /* UNAUTH_USER */]:return initState;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_12" /* AUTH_ERROR */]:return{authenticated:false,error:action.payload,user:{}};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_67" /* FETCH_MESSAGE */]:return Object.assign({},state,{message:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["k" /* ERROR */]:return Object.assign({},state,{error:action.err});default:return state;}}/* END */

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DashboardReducer;
/* unused harmony export sortByDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**************************************************************
8/14/17
Main dashboard for displaying all time management related data
Alexander Self

***************************************************************/var initState={employeeAttendance:{all:[],// Both locations to show initially
displaying:[]},fieldHours:{all:[],// Both locations to show initially
displaying:[]},bagDensities:{all:[],displaying:[]},leaderBoard:{/* Displays a leaderboard of bag counts + total lbs collected */all:[],displaying:[],totalLbs:0// Calculates total lbs of
},laborHours:{all:[],tHours:[],// To show time series in Sparkline
tReg:[],tOT:[],tDT:[],totalHours:0,totalRegtime:0,totalOvertime:0,totalDoubletime:0},equipmentHours:[],hoursByDepartment:[],headCount:[],empsWOTS:{data:[],date:'',total:0},headCountDate:'',graphSize:'6'};function DashboardReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_54" /* FETCH_DASHBOARD_DATA */]:var empsWOTS={data:action.payload.empsWOTS.data,date:action.payload.empsWOTS.date,total:action.payload.empsWOTS.total};if(__WEBPACK_IMPORTED_MODULE_1_moment___default()(action.payload.empsWOTS.date).day()===0||__WEBPACK_IMPORTED_MODULE_1_moment___default()(action.payload.empsWOTS.date).day()===6){empsWOTS={data:[],date:'',total:0};}return Object.assign({},state,{/*fieldHours: {
          all: action.payload.fieldHours,
          displaying: action.payload.fieldHours
        },
        bagDensities: {
          all: action.payload.bagDensities,
          displaying: action.payload.bagDensities
        },
        leaderBoard: {
          all: action.payload.leaderBoard,
          displaying: action.payload.leaderBoard,
          totalLbs: action.payload.leaderBoard.reduce((acc, val, i) => { return acc + val.totalLbs }, 0)
        },
        laborHours: {
          all: action.payload.totalLaborHourSums,
          tHours: action.payload.totalLaborHourSums.map((i) => i.totalHours),
          tReg: action.payload.totalLaborHourSums.map((i) => i.totalRegtime),
          tOT: action.payload.totalLaborHourSums.map((i) =>i.totalOvertime),
          tDT: action.payload.totalLaborHourSums.map((i) => i.totalDoubletime),
          totalHours: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalHours }, 0),
          totalRegtime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalRegtime }, 0),
          totalOvertime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalOvertime }, 0),
          totalDoubletime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalDoubletime }, 0)
        },
        hoursByDepartment: action.payload.hoursByDepartment,
        */equipmentHours:action.payload.equipmentHours,headCount:action.payload.headCount,headCountDate:action.payload.date,empsWOTS:empsWOTS});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_55" /* FETCH_HEADCOUNT */]:return Object.assign({},state,{headCount:action.payload,headCountDate:action.date});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_58" /* FETCH_INFO_BY_LOCATION */]:return handleLocationSwitch(state,action.payload);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_59" /* ENLARGE_GRAPHS */]:var graphSize=void 0;if(state.graphSize==='6')graphSize='12';else graphSize='6';return Object.assign({},state,{graphSize:graphSize});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_60" /* SORT_BY_OPERATION */]:switch(action.payload){case'dashboard-operating-equipment':return Object.assign({},state,{equipmentHours:[].concat(_toConsumableArray(state.equipmentHours.sort(function(a,b){return a.operatingHours>b.operatingHours?-1:1;})))});case'dashboard-garage-equipment':return Object.assign({},state,{equipmentHours:[].concat(_toConsumableArray(state.equipmentHours.sort(function(a,b){return a.garageHours>b.garageHours?-1:1;})))});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_57" /* FETCH_MISSING_TIMESHEETS */]:return Object.assign({},state,{empsWOTS:{data:action.payload.empsWOTS.data,date:action.payload.empsWOTS.date,total:action.payload.empsWOTS.total}/*case FETCH_HOURS_BY_FIELD:
      return { ...state,
        fieldHours: {
          all: action.payload,
          displaying: action.payload
        }
      };*/});default:return state;}}/* Employee attendance would autosort forwhatever reason on each re-render */function handleLocationSwitch(state,action){switch(action){case'field-both-loc':return Object.assign({},state,{fieldHours:Object.assign({},state.fieldHours,{displaying:state.fieldHours.all}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'field-kau-loc':return Object.assign({},state,{fieldHours:Object.assign({},state.fieldHours,{displaying:state.fieldHours.all.filter(function(f){return f.location==='71';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'field-keaau-loc':return Object.assign({},state,{fieldHours:Object.assign({},state.fieldHours,{displaying:state.fieldHours.all.filter(function(f){return f.location==='72';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'density-both-loc':return Object.assign({},state,{bagDensities:Object.assign({},state.bagDensities,{displaying:state.bagDensities.all}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'density-kau-loc':return Object.assign({},state,{bagDensities:Object.assign({},state.bagDensities,{displaying:state.bagDensities.all.filter(function(f){return f.location==='71';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'density-keaau-loc':return Object.assign({},state,{bagDensities:Object.assign({},state.bagDensities,{displaying:state.bagDensities.all.filter(function(f){return f.location==='72';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'leaderBoard-both-loc':return Object.assign({},state,{leaderBoard:Object.assign({},state.leaderBoard,{displaying:state.leaderBoard.all}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'leaderBoard-kau-loc':return Object.assign({},state,{leaderBoard:Object.assign({},state.leaderBoard,{displaying:state.leaderBoard.all.filter(function(f){return f.location==='71';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'leaderBoard-keaau-loc':return Object.assign({},state,{leaderBoard:Object.assign({},state.leaderBoard,{displaying:state.leaderBoard.all.filter(function(f){return f.location==='72';})}),employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.displaying.sort(sortByDate)})});case'attendance-both-loc':return Object.assign({},state,{employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.all.sort(sortByDate)})});case'attendance-kau-loc':return Object.assign({},state,{employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.all.filter(function(f){return f.location==='71';}).sort(sortByDate)})});case'attendance-keaau-loc':return Object.assign({},state,{employeeAttendance:Object.assign({},state.employeeAttendance,{displaying:state.employeeAttendance.all.filter(function(f){return f.location==='72';}).sort(sortByDate)})});default:return state;}}function sortByDate(a,b){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.workdate)-__WEBPACK_IMPORTED_MODULE_1_moment___default()(b.workdate);}/* END */

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EquipmentReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/***********************************************************
Alexander Self
8/22/17
Gang Reducer: Manages and creation and editing of gangs
***********************************************************/var initState={equipmentNo:[],equipmentTrailerNo:[],selectedEquipment:{},create:{},edit:{}};function EquipmentReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* FETCH_TIMESHEET_DATA */]:return Object.assign({},state,{equipmentNo:action.payload.equipmentNo,equipmentTrailerNo:action.payload.equipmentTrailerNo});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_65" /* FETCH_EQUIPMENT */]:return Object.assign({},state,{equipmentNo:action.payload.equipmentNo,equipmentTrailerNo:action.payload.equipmentTrailerNo});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_66" /* SELECT_EQUIPMENT */]:return Object.assign({},state,{selectEquipment:action.payload});default:return state;}}/* END */

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GangReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/***********************************************************
Alexander Self
8/22/17
Gang Reducer: Manages and creation and editing of gangs
***********************************************************/var Materialize=window.Materialize;var initState={gangs:[],employees:[],selectedGang:{emps:[]},create:{gangMembers:[],// All employees to be added to the gang
count:0},edit:{selectedGang:{emps:[],gangCount:0},addedMembers:[],removedMembers:[]}};function GangReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* FETCH_TIMESHEET_DATA */]://console.log(action.payload);
var _gangs=state.gangs;var _employees=action.payload.employees;/* If a employee already belongs to a gang; remove them from the employee list */var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=_gangs[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _gang=_step.value;var gangMembers=_gang.emps;var _loop=function _loop(member){_employees=_employees.filter(function(e){return e.eid!==member.eid;});};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=gangMembers[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var member=_step2.value;_loop(member);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return Object.assign({},state,{employees:_employees.sort(sortById)});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_46" /* ADD_GANG_MEMBER */]:/* Check if member exists in current build */if(state.create.gangMembers.find(function(e){return e.eid===action.payload.eid;}))return state;/* Check if member is duplcate and exists in any gang */var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=state.gangs[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var _ref=_step3.value;var _emps3=_ref.emps;if(_emps3.find(function(e){return e.eid===action.payload.eid;}))return state;}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return Object.assign({},state,{create:Object.assign({},state.create,{gangMembers:state.create.gangMembers.concat(action.payload),count:state.create.count+1})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_47" /* REMOVE_GANG_MEMBER */]:return Object.assign({},state,{create:Object.assign({},state.create,{gangMembers:state.create.gangMembers.filter(function(e){return e.eid!==action.payload.eid;}),count:state.create.count-1})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_48" /* GANG_AUTOCOMPLETE */]:// Make sure not in list
if(state.create.gangMembers.find(function(e){return e.eid===action.payload.eid;}))return state;return Object.assign({},state,{create:Object.assign({},state.create,{gangMembers:state.create.gangMembers.concat(action.payload),count:state.create.count+1})});//return state;
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_49" /* GANG_EDIT_AUTOCOMPLETE */]:/* Check if a gang has been selected: Don't do this in reducer again */if(!state.edit.selectedGang.id){Materialize.toast('Please select a gang before adding an employee',4000,'red rounded');return state;}if(state.edit.selectedGang.emps.find(function(e){return e.eid===action.payload.eid;}))return state;var _emps_=state.edit.selectedGang.emps.concat(action.payload);return Object.assign({},state,{edit:Object.assign({},state.eid,{selectedGang:Object.assign({},state.edit.selectedGang,{gangCount:state.edit.selectedGang.gangCount+1,emps:_emps_}),// Clean up lists after adding members
addedMembers:state.edit.addedMembers.concat(action.payload),removedMembers:state.edit.removedMembers.filter(function(e){return e.eid!==action.payload.eid;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_42" /* CREATE_GANG */]:var newEmployeeList=void 0;newEmployeeList=state.employees.map(function(emp){if(action.selectedEmps.find(function(e){return e.eid===emp.eid;}))return 1;else return emp;});return Object.assign({},state,{gangs:action.payload,employees:newEmployeeList.filter(function(e){return e!==1;}).sort(sortById),create:{gangMembers:[]}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_43" /* FETCH_GANGS */]:var gangs=action.payload;var employees=state.employees;/* If a employee already belongs to a gang; remove them from the employee list */var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=gangs[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _gang2=_step4.value;var _gangMembers=_gang2.emps;var _loop2=function _loop2(_member){employees=employees.filter(function(e){return e.eid!==_member.eid;});};var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=_gangMembers[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var _member=_step5.value;_loop2(_member);}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}return Object.assign({},state,{employees:employees,gangs:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_50" /* SELECT_GANG */]:var gang=state.gangs.find(function(g){return g.gangId===action.payload;});return Object.assign({},state,{selectedGang:gang});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_51" /* SELECT_GANG_TO_EDIT */]:var gangToEdit=state.gangs.find(function(g){return g.gangId===action.payload;});var __gangs=state.gangs;var __employees=state.employees;/* If a employee already belongs to a gang; remove them from the employee list */var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=__gangs[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var _gang3=_step6.value;var _gangMembers2=_gang3.emps;var _loop3=function _loop3(_member2){__employees=__employees.filter(function(e){return e.eid!==_member2.eid;});};var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=_gangMembers2[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var _member2=_step7.value;_loop3(_member2);}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}return Object.assign({},state,{employees:__employees,edit:Object.assign({},state.edit,{selectedGang:gangToEdit})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_52" /* REMOVE_GANG_MEMBER_FROM_EDIT */]:/* Maintain a list of employees who were removed and added during edit;
        also if removed, repopulate that employee into main employees list
       */var _emps=state.edit.selectedGang.emps.filter(function(e){return e.eid!==action.payload.eid;});return Object.assign({},state,{employees:state.employees.concat(action.payload).sort(sortById),edit:Object.assign({},state.edit,{selectedGang:Object.assign({},state.edit.selectedGang,{gangCount:state.edit.selectedGang.gangCount-1,emps:_emps}),removedMembers:state.edit.removedMembers.concat(action.payload),addedMembers:state.edit.addedMembers.filter(function(e){return e.eid!==action.payload.eid;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_53" /* ADD_GANG_MEMBER_TO_EDIT */]:if(state.edit.selectedGang.emps.find(function(e){return e.eid===action.payload.eid;}))return state;var emps=state.edit.selectedGang.emps.concat(action.payload);return Object.assign({},state,{employees:state.employees.filter(function(e){return e.eid!==action.payload.eid;}),edit:Object.assign({},state.edit,{selectedGang:Object.assign({},state.edit.selectedGang,{gangCount:state.edit.selectedGang.gangCount+1,emps:emps}),// Clean up lists after adding members
addedMembers:state.edit.addedMembers.concat(action.payload),removedMembers:state.edit.removedMembers.filter(function(e){return e.eid!==action.payload.eid;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_44" /* EDIT_GANG */]:return Object.assign({},state,{gangs:action.payload,edit:{selectedGang:{emps:[]},addedMembers:[],removedMembers:[]}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_45" /* DELETE_GANG */]:var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=action.oldGang.emps[Symbol.iterator](),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var e=_step8.value;state.employees.push(e);}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}return{gangs:action.payload,employees:state.employees.sort(sortById),selectedGang:{emps:[]},create:{gangMembers:[],// All employees to be added to the gang
count:0},edit:{selectedGang:{emps:[],gangCount:0},addedMembers:[],removedMembers:[]}};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["B" /* SUBMIT_GANG_TIMESHEET */]:return Object.assign({},state,{gangs:action.gangs});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["A" /* SUBMIT_REG_TIMESHEET */]:return Object.assign({},state,{gangs:action.gangs});default:return state;}}function sortById(a,b){return a.id-b.id;}/* END */

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HarvestReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/***************************************************
Alexander Self
12/01/18
MechanicalHarvestReducer: Handles harvest related actions
****************************************************/var initState={harvest:{mech:{all:[],displaying:[]},hand:{all:[],displaying:[]}},create:{selectedField:{},harvest:{},previousHarvest:[],harvestRecords:[],harvestToEdit:{},toEdit:false},manage:{editedHarvest:{},// New harvest which was edited
selectedField:{},selectedHarvest:{},previousHarvest:[],myHarvest:[],// Initial pull is for all harvest records that were submitted by a user
isEditOrDelete:false// Determines if the edit and delete options will be present
},report:{disabled:'',// Disables form options for report: Limits query
options:{},reportOpts:{reportRunning:false,// Switches UI for larger screen on report
employee:false,// Determines if an employee was queried
equipment:false,// Determines if an equipment was queried
field:false},query:{data:[],summary:{},type:''}},equipmentNo:[],// Equipment no's with descriptions
seasons:[],// current farming seaons
employees:{displaying:[],all:[]},// List of current employees
fields:[],blocks:[]};function HarvestReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* FETCH_MECH_HARVEST */]:return Object.assign({},state,{harvest:Object.assign({},state.harvest,{mech:{all:action.mechHarvest,displaying:action.mechHarvest.sort(sortByDate)}}),equipmentNo:action.equipmentNo,seasons:action.seasons,fields:action.fields,employees:{all:action.employees,displaying:action.employees.filter(function(e){return e.employeeStatus==='Active';})}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* CREATE_MECH_HARVEST */]:return Object.assign({},state,{create:initState.create});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["L" /* FETCH_FIELDS_BY_LOC */]:return Object.assign({},state,{fields:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["M" /* FETCH_BLOCKS_BY_FIELD */]:return Object.assign({},state,{blocks:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["n" /* SELECT_FIELD */]:return Object.assign({},state,{create:Object.assign({},state.create,{selectedField:state.fields.find(function(f){return f.field===action.payload;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* PREPARE_MECH_HARVEST_TO_CREATE */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvest:action.payload,selectedField:action.selectedField,previousHarvest:action.previousHarvest})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["e" /* PREPARE_MECH_HARVEST_TO_CREATE_2 */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvestRecords:action.payload,previousHarvest:action.previousHarvest})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* PREPARE_MECH_HARVEST_TO_EDIT */]:return Object.assign({},state,{manage:Object.assign({},state.manage,{editedHarvest:action.payload,selectedField:action.selectedField,previousHarvest:action.previousHarvest})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["o" /* SELECT_REPORT_TYPE */]:return Object.assign({},state,{report:Object.assign({},state.report,{disabled:action.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["i" /* SET_REPORT_OPTS */]:var employee=state.report.reportOpts.employee;var equipment=state.report.reportOpts.equipment;var field=state.report.reportOpts.field;if(action.payload.eid)employee=!state.report.reportOpts.employee;if(action.payload.equipmentNo)equipment=!state.report.reportOpts.equipment;if(action.payload.field)field=!state.report.reportOpts.field;return Object.assign({},state,{report:Object.assign({},state.report,{reportOpts:Object.assign({},state.report.reportOpts,{reportRunning:!state.report.reportOpts.reportRunning,employee:employee,equipment:equipment,field:field})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* SELECT_NEW_REPORT */]:return Object.assign({},state,{report:{disabled:'',options:{},reportOpts:{reportRunning:false,employee:false,equipment:false,field:false},query:{data:[],summary:{},type:''}}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* FETCH_REPORT */]:return Object.assign({},state,{report:Object.assign({},state.report,{options:action.options,query:action.payload})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* FETCH_MY_MECH_HARVEST */]:return Object.assign({},state,{manage:Object.assign({},state.manage,{myHarvest:state.harvest.mech.all.filter(function(h){return h.submitter===action.payload;}).sort(sortByDate)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["l" /* SELECT_HARVEST_TO_MANAGE */]:return Object.assign({},state,{manage:Object.assign({},state.manage,{editedHarvest:{},selectedHarvest:action.payload,selectedField:action.selectedField,isEditOrDelete:true}),blocks:action.blocks});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["r" /* RESET_MANAGE_HARVEST */]:return Object.assign({},state,{manage:Object.assign({},state.manage,{editedHarvest:{},selectedField:{},selectedHarvest:{},previousHarvest:[],isEditOrDelete:!state.manage.isEditOrDelete})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["m" /* FETCH_HARVEST_BY_DATE */]:var _harvest=action.payload;if(_harvest.length>0)_harvest=_harvest.sort(sortByDate);return Object.assign({},state,{manage:Object.assign({},state.manage,{myHarvest:_harvest})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["g" /* EDIT_MECH_HARVEST */]:return Object.assign({},state,{harvest:Object.assign({},state.harvest,{mech:Object.assign({},state.harvest.mech,{all:state.harvest.mech.all.filter(function(h){return h.id!==action.payload.id;}).concat(action.payload).sort(sortByDate),displaying:state.harvest.mech.displaying.filter(function(h){return h.id!==action.payload.id;}).concat(action.payload).sort(sortByDate)})}),manage:{myHarvest:state.manage.myHarvest.filter(function(h){return h.id!==action.payload.id;}).concat(action.payload).filter(function(h){return h.submitter===action.submitter;}).sort(sortByDate),editedHarvest:{},selectedField:{},selectedHarvest:{},previousHarvest:[],isEditOrDelete:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["h" /* DELETE_MECH_HARVEST */]:return Object.assign({},state,{harvest:Object.assign({},state.harvest,{mech:Object.assign({},state.harvest.mech,{all:state.harvest.mech.all.filter(function(h){return h.id!==action.payload;}).sort(sortByDate),displaying:state.harvest.mech.displaying.filter(function(h){return h.id!==action.payload;}).sort(sortByDate)})}),manage:{myHarvest:state.manage.myHarvest.filter(function(h){return h.id!==action.payload;}).filter(function(h){return h.submitter===action.submitter;}).sort(sortByDate),editedHarvest:{},selectedField:{},selectedHarvest:{},previousHarvest:[],isEditOrDelete:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["k" /* ERROR */]:return Object.assign({},state,{report:{disabled:'',reportOpts:{reportRunning:false,employee:false,equipment:false,field:false},query:{data:[],summary:{},type:''}}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["s" /* ADD_HARVEST_RECORD */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvestRecords:state.create.harvestRecords.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["t" /* SET_MECH_HARVEST_TO_EDIT */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvestToEdit:action.payload,toEdit:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["u" /* EDIT_MECH_HARVEST_RECORD */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvestToEdit:initState.create.harvestToEdit,toEdit:false,harvestRecords:state.create.harvestRecords.filter(function(h){return h.guid!==state.create.harvestToEdit.guid;}).concat(Object.assign({},action.payload,{guid:state.create.harvestToEdit.guid}))})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["v" /* DELETE_MECH_HARVEST_RECORD */]:return Object.assign({},state,{create:Object.assign({},state.create,{harvestRecords:state.create.harvestRecords.filter(function(h){return h.guid!==action.payload;})})});default:return state;}}function sortByDate(a,b){if(new Date(a.date)<new Date(b.date))return 1;else if(new Date(a.date)>new Date(b.date))return-1;return 0;}/* END */

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_reducer__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timesheet_reducer__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_reducer__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_reducer__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_reducer__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gang_reducer__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__equipment_reducer__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__harvest_reducer__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__alerts_form_reducer__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alerts_list_reducer__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__alerts_toast_reducer__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alerts_messages_reducer__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cultivation_reducers__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__weather_reducer__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__irrigation_reducer__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__interval_interval_reducer__ = __webpack_require__(415);
/***************************************************
Alexander Self
7/29/17
Root reducer: Combines all reducers
****************************************************//* SMS Alerts *//* Cultivation *//* Weather *//* Irrigation *//* Intervals */var rootReducer=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({intervals:__WEBPACK_IMPORTED_MODULE_16__interval_interval_reducer__["a" /* default */],irrigation:__WEBPACK_IMPORTED_MODULE_15__irrigation_reducer__["a" /* default */],weather:__WEBPACK_IMPORTED_MODULE_14__weather_reducer__["a" /* default */],cultivation:__WEBPACK_IMPORTED_MODULE_13__cultivation_reducers__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_1__auth_reducer__["a" /* default */],dashboard:__WEBPACK_IMPORTED_MODULE_5__dashboard_reducer__["a" /* default */],timesheet:__WEBPACK_IMPORTED_MODULE_2__timesheet_reducer__["a" /* default */],misc:__WEBPACK_IMPORTED_MODULE_3__misc_reducer__["a" /* default */],profile:__WEBPACK_IMPORTED_MODULE_4__profile_reducer__["a" /* default */],gang:__WEBPACK_IMPORTED_MODULE_6__gang_reducer__["a" /* default */],equipment:__WEBPACK_IMPORTED_MODULE_7__equipment_reducer__["a" /* default */],harvest:__WEBPACK_IMPORTED_MODULE_8__harvest_reducer__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_9__alerts_form_reducer__["a" /* default */],list:__WEBPACK_IMPORTED_MODULE_10__alerts_list_reducer__["a" /* default */],toast:__WEBPACK_IMPORTED_MODULE_11__alerts_toast_reducer__["a" /* default */],messages:__WEBPACK_IMPORTED_MODULE_12__alerts_messages_reducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MiscReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/***************************************************
Alexander Self
6/27/17
Misc reducer: Handles data used by multiple modules
Map reducer: Handles all map interactions
****************************************************/var initState={payPeriod:{},prevPP:{},season:{},positionTypes:[],mapView:false,location:'kau',field:null,fieldInfo:{basicInfo:{},blocks:[],harvest:{},work:{},lastVisited:{}}};function MiscReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["w" /* FETCH_PAY_PERIOD */]:return Object.assign({},state,{payPeriod:{startDate:action.payload.startDate,endDate:action.payload.endDate},prevPP:{startDate:action.prevPP.startDate,endDate:action.prevPP.endDate}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_61" /* FETCH_FIELD_INFORMATION */]:return Object.assign({},state,{fieldInfo:{basicInfo:action.payload.fieldInfo,blocks:action.payload.blocks,harvest:action.payload.harvestObj,work:action.payload.workObj,lastVisited:action.payload.lastVisited}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_62" /* SET_MAP_VIEW */]:var field=void 0;field=state.field;/* Make sure field is not displaying when on Dashboard */if(state.mapView===true){field=null;}return Object.assign({},state,{field:field,mapView:!state.mapView});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_63" /* SET_FIELD_VIEW */]:return Object.assign({},state,{field:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_64" /* SET_MAP_LOCATION */]:return Object.assign({},state,{location:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_39" /* FETCH_POSITION_TYPE */]:return Object.assign({},state,{positionTypes:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["N" /* UNAUTH_USER */]:return initState;default:return state;}}/* END */

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProfileReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(14);
/***************************************************
Alexander Self
7/29/17
Profile reducer: Handles all viewing, creating and editing of employees
****************************************************/var initState={employees:[],view:{selectedEmployee:{manager:{},managedEmployees:[],stats:{harvest:{harvestHours:[],harvestHourTotal:0},equipment:{equipmentHours:[],equipmentHourTotal:0},costCenter:{costCenterHours:[],costCenterHourTotal:0}}},schedule:[],timesheets:[]},create:{},edit:{employee:{}}};function ProfileReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_33" /* FETCH_LEVEL_EMPLOYEES */]:return Object.assign({},state,{employees:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_41" /* FETCH_EMPLOYEE_TO_EDIT */]:return Object.assign({},state,{edit:{employee:action.payload}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_36" /* SUBMIT_EDIT_PROFILE */]:return Object.assign({},state,{employees:action.payload,edit:{employee:{}}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_34" /* CREATE_EMPLOYEE_PROFILE */]:return Object.assign({},state,{employees:action.payload});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_38" /* FETCH_EMPLOYEE_PROFILE */]:return Object.assign({},state,{view:{selectedEmployee:Object.assign({},action.payload.employee,{manager:action.payload.manager,managedEmployees:action.payload.managedEmployees,stats:action.payload.stats})}});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_35" /* CREATE_LOGIN_PROFILE */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_37" /* SUBMIT_EDIT_LOGIN */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["N" /* UNAUTH_USER */]:return initState;default:return state;}}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TimesheetReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types__ = __webpack_require__(14);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/***************************************************************
5/22/2017
Alexander Self
Timesheet Reducer
- Takes timesheet actions and returns a new timesheet state
***************************************************************/var initState={employees:[],// constants pulled from db
myEmployees:[],// Specific employees that are managed by a given user
fields:[],// constants pulled from db
blocks:[],// constants pulled from db
costCenters:{all:[],displaying:[]},// constants pulled from db
details:{all:[],displaying:[]},paycodes:[],subAccounts:[],// constants pulled from db
addedEmployees:[],// Any employees added to a timesheet
employeeTS:{// Full employee TS with secondary TS's; to be applied to all employees added to list
indMacField:[],secondaryTS:{workPerformed:[],editWork:{}}},gangTS:{// For gang timesheets
timesheet:{emps:[]},addedGangEmployees:[],addedGangInfoRow:[],// Contains objects with eids as keys, count of rows per employee
gangWorkPerformed:[],editWork:{}},timesheets:[],// All timesheets fetched to view; fetched based on date
myTimesheets:{date:__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),timesheets:[]},employeeTimesheets:{employee:{},timesheets:[]},edit:{employee:{},ts:{timesheet:{},subTimesheets:[],removedWork:[],harvestTimesheet:[],removedHarvest:[],editWork:{},editHarvest:{}},// All timesheet information for a particular date
timesheetDates:[]// All timesheets submitted
},delete:{employee:{},timesheets:[]},download:''};function TimesheetReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_types__["y" /* FETCH_TIMESHEET_DATA */]:return Object.assign({},state,{employees:action.payload.employees,myEmployees:action.payload.myEmployees,costCenters:{all:action.payload.costCenters,displaying:action.payload.costCenters},details:{all:action.payload.details,displaying:action.payload.details},paycodes:action.payload.paycodes});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["P" /* ADD_EMPLOYEE_TO_TIMESHEET */]:// Make sure users cannot add duplicates
if(state.addedEmployees.find(function(item){return item.eid===action.payload.eid;}))return state;return Object.assign({},state,{addedEmployees:state.addedEmployees.concat(action.payload)});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_9" /* EMPLOYEE_AUTOCOMPLETE */]:// Make sure not in list
if(state.addedEmployees.find(function(item){return item.eid===action.payload.eid;}))return state;if(state.gangTS.addedGangEmployees.find(function(item){return item.eid===action.payload.eid;}))return state;/* Employee timesheet has already been submitted, return original state *///if (action.payload.status) return state;
return handleAutocomplete(action.id,action.payload,state);case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Z" /* REMOVE_EMPLOYEE_FROM_TIMESHEET */]:return Object.assign({},state,{addedEmployees:state.addedEmployees.filter(function(item){return item.eid!==action.payload.eid;})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Q" /* ADD_WORK_TO_TIMESHEET */]:return Object.assign({},state,{employeeTS:Object.assign({},state.employeeTS,{secondaryTS:{workPerformed:state.employeeTS.secondaryTS.workPerformed.concat(action.payload)}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_0" /* REMOVE_WORK_FROM_TIMESHEET */]:return Object.assign({},state,{employeeTS:Object.assign({},state.employeeTS,{secondaryTS:{workPerformed:state.employeeTS.secondaryTS.workPerformed.filter(function(w){return w.workId!==action.payload;})}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_1" /* ADD_EMPLOYEE_TO_GANG_TIMESHEET */]:if(state.gangTS.addedGangEmployees.find(function(item){return item.eid===action.payload.eid;}))return Object.assign({},state);return Object.assign({},state,{gangTS:{timesheet:state.gangTS.timesheet,addedGangEmployees:state.gangTS.addedGangEmployees.concat(action.payload)}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_2" /* REMOVE_EMPLOYEE_FROM_GANG_TIMESHEET */]:return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{timesheet:state.gangTS.timesheet,addedGangEmployees:state.gangTS.addedGangEmployees.filter(function(e){return e.eid!==action.payload;}),addedGangInfoRow:state.gangTS.addedGangInfoRow.filter(function(e){return e.eid!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_4" /* PREPARE_REG_TIMESHEET */]:return Object.assign({},state,{employeeTS:action.payload});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["A" /* SUBMIT_REG_TIMESHEET */]:if(!action.payload)return state;return Object.assign({},state,{addedEmployees:[],employeeTS:{indMacField:[],secondaryTS:{workPerformed:[]}}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_3" /* PREPARE_GANG_TIMESHEET */]:var _emps=action.payload.emps;// Add actual grades to submit
var _loop=function _loop(e){_emps.map(function(emp){if(emp.eid===e.eid){emp.grade=e.grade;//if (Number(emp.grade) > 2) emp.grade = 2; // Removed 4.14.22
emp.firstName=e.firstName;emp.lastName=e.lastName;}return emp;});};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=state.gangTS.addedGangEmployees[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var e=_step.value;_loop(e);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{timesheet:{timesheetID:action.payload.timesheetID,submitter:action.payload.submitter,location:action.payload.location,date:action.payload.date,round:action.payload.round,emps:_emps}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["B" /* SUBMIT_GANG_TIMESHEET */]:return Object.assign({},state,{employees:action.payload,gangTS:{timesheet:{emps:[]},addedGangEmployees:[],addedGangInfoRow:[],gangWorkPerformed:[],editWork:{}}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["C" /* FETCH_TIMESHEETS */]:return Object.assign({},state,{timesheets:action.payload,employeeTimesheets:{employee:{},timesheets:[]}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["D" /* FETCH_EMPLOYEE_TIMESHEETS */]:return Object.assign({},state,{employeeTimesheets:{employee:action.payload.employee[0],timesheets:action.payload.timesheets},timesheets:[]});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["F" /* GET_TIMESHEET_DATES_TO_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{employee:action.employee,timesheetDates:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_5" /* FETCH_TIMESHEET_TO_EDIT */]:return Object.assign({},state,{costCenters:Object.assign({},state.costCenters,{displaying:state.costCenters.all.filter(function(cc){return cc.location===action.payload.timesheet.location;})}),fields:action.fields,subAccounts:action.payload.subAccounts,edit:Object.assign({},state.edit,{ts:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_7" /* REMOVE_WORK_FROM_EDIT_TIMESHEET */]:var droppedWork=state.edit.ts.subTimesheets.find(function(item){return item.id===action.payload;});return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{subTimesheets:state.edit.ts.subTimesheets.filter(function(item){return item.id!==action.payload;}),removedWork:state.edit.ts.removedWork.concat(droppedWork)})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_6" /* ADD_WORK_TO_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{subTimesheets:state.edit.ts.subTimesheets.concat(action.payload)})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_8" /* PREPARE_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["G" /* SUBMIT_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:{timesheet:{},subTimesheets:[],removedWork:[],harvestTimesheet:[],removedHarvest:[]}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["H" /* FETCH_TIMESHEETS_TO_DELETE */]:return Object.assign({},state,{delete:{employee:action.employee,timesheets:action.payload}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["I" /* DELETE_TIMESHEET */]:return Object.assign({},state,{delete:{employee:{},timesheets:[]}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["J" /* DOWNLOAD_TIMESHEET */]:return Object.assign({},state);case __WEBPACK_IMPORTED_MODULE_1__actions_types__["K" /* FETCH_SUBACCOUNTS */]:return Object.assign({},state,{subAccounts:action.payload.subAccounts});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["L" /* FETCH_FIELDS_BY_LOC */]:return Object.assign({},state,{fields:action.payload});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["M" /* FETCH_BLOCKS_BY_FIELD */]:var _loop2=function _loop2(block){if(action.payload.find(function(b){return b.block===block.block;}))return{v:state};};/* Check for possible duplicates */var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=state.blocks[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var block=_step2.value;var _ret2=_loop2(block);if((typeof _ret2==='undefined'?'undefined':_typeof(_ret2))==="object")return _ret2.v;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return Object.assign({},state,{blocks:state.blocks.concat(action.payload)});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_10" /* SELECT_GANG_FOR_TIMESHEET */]:// TODO: Make sure you cant add duplicates
return Object.assign({},state,{addedEmployees:action.payload.emps//state.addedEmployees.concat(action.payload.emps)
});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_11" /* SELECT_GANG_FOR_GANG_TIMESHEET */]:// TODO: Make sure you cant add duplicates
return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{addedGangEmployees:action.payload.emps//state.gangTS.addedGangEmployees.concat(action.payload.emps)
})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_13" /* FETCH_MY_EMPLOYEES_TIMESHEET */]:return Object.assign({},state,{myEmployees:state.employees.filter(function(e){return e.managerId===action.payload;})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_14" /* ADD_NEW_GANG_INFO_ROW */]:// Check if employee has a form row added
var emp=state.gangTS.addedGangInfoRow.find(function(e){if(action.payload===e.eid)return e;else return!e;});// If an employee exists in addedGangInfoRow, update the count of forms and return new state
if(emp){var addedGangInfoRow=state.gangTS.addedGangInfoRow.map(function(e){if(e.eid===emp.eid){e.count.push(1);}return e;});return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{addedGangInfoRow:addedGangInfoRow})});}return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{addedGangInfoRow:state.gangTS.addedGangInfoRow.concat({eid:action.payload,count:[1]})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_15" /* REMOVE_HARVEST_FROM_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{harvestTimesheet:state.edit.ts.harvestTimesheet.filter(function(h){return h.id!==action.payload;}),removedHarvest:state.edit.ts.removedHarvest.concat({id:action.payload})})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_16" /* ADD_HARVEST_TO_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{harvestTimesheet:state.edit.ts.harvestTimesheet.concat(action.payload)})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_19" /* SELECT_COST_CENTER_BY_LOCATION */]:return Object.assign({},state,{costCenters:Object.assign({},state.costCenters,{displaying:action.payload==='71'?state.costCenters.all.filter(function(cc){return cc.location===action.payload;}):action.payload==='72'?state.costCenters.all.filter(function(cc){return cc.location===action.payload;}):state.costCenters.all.filter(function(cc){return cc.location==='71';})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["S" /* EDIT_WORK_IN_TIMESHEET */]:return Object.assign({},state,{employeeTS:Object.assign({},state.employeeTS.indMacField,{secondaryTS:{workPerformed:[].concat(_toConsumableArray(state.employeeTS.secondaryTS.workPerformed)),editWork:action.payload}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["T" /* EDIT_WORK_RECORD */]:var workId=state.employeeTS.secondaryTS.editWork.workId;return Object.assign({},state,{employeeTS:Object.assign({},state.employeeTS.indMacField,{secondaryTS:{workPerformed:state.employeeTS.secondaryTS.workPerformed.filter(function(w){return w.workId!==workId;}).concat(action.payload),editWork:{}}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["W" /* EDIT_WORK_IN_EDIT_TIMESHEET */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{editWork:action.payload})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["X" /* EDIT_WORK_RECORD_EDIT_TS */]:var id=state.edit.ts.editWork.id;action.payload.id=id;return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{subTimesheets:state.edit.ts.subTimesheets.filter(function(w){return w.id!==id;}).concat(action.payload),editWork:{}})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["R" /* ADD_WORK_TO_GANG_TIMESHEET */]:return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{gangWorkPerformed:state.gangTS.gangWorkPerformed.concat(action.payload)})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["V" /* EDIT_WORK_IN_GANG_TIMESHEET */]:return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{editWork:action.payload})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["U" /* EDIT_GANG_WORK_RECORD */]:return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{gangWorkPerformed:state.gangTS.gangWorkPerformed.filter(function(w){return w.workId!==state.gangTS.editWork.workId;}).concat(action.payload),editWork:{}})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_17" /* SELECT_HARVEST_TO_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{editHarvest:action.payload})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["_18" /* EDIT_HARVEST */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{ts:Object.assign({},state.edit.ts,{harvestTimesheet:state.edit.ts.harvestTimesheet.filter(function(w){return w.id!==action.payload.id;}).concat(action.payload),editHarvest:{}})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["Y" /* DELETE_WORK_IN_GANG_TIMESHEET */]:return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{gangWorkPerformed:state.gangTS.gangWorkPerformed.filter(function(w){return w.workId!==action.payload;})})});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["E" /* FETCH_MY_TIMESHEETS */]:return Object.assign({},state,{myTimesheets:{timesheets:action.payload,date:action.date}});case __WEBPACK_IMPORTED_MODULE_1__actions_types__["N" /* UNAUTH_USER */]:return initState;default:return state;}}function handleAutocomplete(id,emp,state){switch(id){case'employee-reg-ts-list':return Object.assign({},state,{addedEmployees:state.addedEmployees.concat(emp)});case'employee-gang-ts-list':return Object.assign({},state,{gangTS:Object.assign({},state.gangTS,{addedGangEmployees:state.gangTS.addedGangEmployees.concat(emp)})});default:return state;}}/* END */

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_auth_app__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_auth_signin__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_auth_signout__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_auth_require_auth__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_main__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_dashboard__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_timesheet__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_timesheets_view_timesheet_view__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_timesheets_create_timesheet_create__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_timesheets_edit_timesheet_edit__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_timesheets_delete_timesheet_delete__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_team_builder__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_teams_view_team_view__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_teams_create_team_create__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_teams_edit_team_edit__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_teams_delete_team_delete__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_profile__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_profiles_view_profile_view__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_profiles_create_profile_create__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_profiles_edit_profile_edit__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_alert__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__containers_harvest__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_harvest_view_harvest_view__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_harvest_create_mechHarvest_create__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_harvest_manage_mechHarvest_manage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cultivation__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cultivation_components_documentation_introduction__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cultivation_components_reports_reports__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cultivation_components_chemical_chemical_container__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cultivation_components_chemical_chemical_view__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cultivation_components_chem_app_chem_app_container__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__cultivation_components_chem_app_chem_app_view__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cultivation_components_chem_app_chem_app_create__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__cultivation_components_fertilizer_fertilizer_container__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__cultivation_components_fertilizer_fertilizer_create__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__cultivation_components_fertilizer_fertilizer_view__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__cultivation_components_mowing_mowing_container__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__cultivation_components_mowing_mowing_create__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__cultivation_components_mowing_mowing_view__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__cultivation_components_tree_replant_tree_replant_container__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__cultivation_components_tree_replant_tree_inventory__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__cultivation_components_tree_replant_tree_replant__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__weather_weather__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__irrigation_irrigation_container__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__irrigation_irrigation_view__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__irrigation_irrigation_create__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__irrigation_irrigation_manage__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__interval_interval_container__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__interval_interval_view__ = __webpack_require__(416);
/*
  Hawaiian Macadamia Nut Services
  Alexander Self
  routes.js: Main client-side routing used throughout the application
  For authorization over a nested route, use RequireAuth in the parent route
*//* Timesheet Components *//* Team Builder Components *//* Profile Components *//* Alert Component *//* Mechanical Harvest Components *//* Cultivation Components *//* Weather Component *//* Irrigation Components *//* Interval Components *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_2__containers_auth_app__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_3__containers_auth_signin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/signout',component:__WEBPACK_IMPORTED_MODULE_4__containers_auth_signout__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/dashboard',component:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__containers_auth_require_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__containers_main__["a" /* default */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_7__containers_dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/timesheet',component:__WEBPACK_IMPORTED_MODULE_8__containers_timesheet__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_9__components_timesheets_view_timesheet_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/timesheet/create',component:__WEBPACK_IMPORTED_MODULE_10__components_timesheets_create_timesheet_create__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/timesheet/edit',component:__WEBPACK_IMPORTED_MODULE_11__components_timesheets_edit_timesheet_edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/timesheet/delete',component:__WEBPACK_IMPORTED_MODULE_12__components_timesheets_delete_timesheet_delete__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/teambuilder',component:__WEBPACK_IMPORTED_MODULE_13__containers_team_builder__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_14__components_teams_view_team_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/teambuilder/create',component:__WEBPACK_IMPORTED_MODULE_15__components_teams_create_team_create__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/teambuilder/edit',component:__WEBPACK_IMPORTED_MODULE_16__components_teams_edit_team_edit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/teambuilder/delete',component:__WEBPACK_IMPORTED_MODULE_17__components_teams_delete_team_delete__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/profile',component:__WEBPACK_IMPORTED_MODULE_18__containers_profile__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_19__components_profiles_view_profile_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/profile/create',component:__WEBPACK_IMPORTED_MODULE_20__components_profiles_create_profile_create__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/profile/edit',component:__WEBPACK_IMPORTED_MODULE_21__components_profiles_edit_profile_edit__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/alert',component:__WEBPACK_IMPORTED_MODULE_22__containers_alert__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_22__containers_alert__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/harvest',component:__WEBPACK_IMPORTED_MODULE_23__containers_harvest__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_24__components_harvest_view_harvest_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/harvest/create',component:__WEBPACK_IMPORTED_MODULE_25__components_harvest_create_mechHarvest_create__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/harvest/manage',component:__WEBPACK_IMPORTED_MODULE_26__components_harvest_manage_mechHarvest_manage__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation',component:__WEBPACK_IMPORTED_MODULE_27__cultivation__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_28__cultivation_components_documentation_introduction__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation',component:__WEBPACK_IMPORTED_MODULE_30__cultivation_components_chemical_chemical_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/products',component:__WEBPACK_IMPORTED_MODULE_31__cultivation_components_chemical_chemical_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/reports',component:__WEBPACK_IMPORTED_MODULE_29__cultivation_components_reports_reports__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/chemicalApplication',component:__WEBPACK_IMPORTED_MODULE_32__cultivation_components_chem_app_chem_app_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_33__cultivation_components_chem_app_chem_app_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/chemicalApplication/create',component:__WEBPACK_IMPORTED_MODULE_34__cultivation_components_chem_app_chem_app_create__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/fertilizer',component:__WEBPACK_IMPORTED_MODULE_35__cultivation_components_fertilizer_fertilizer_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_37__cultivation_components_fertilizer_fertilizer_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/fertilizer/create',component:__WEBPACK_IMPORTED_MODULE_36__cultivation_components_fertilizer_fertilizer_create__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/mowing',component:__WEBPACK_IMPORTED_MODULE_38__cultivation_components_mowing_mowing_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_40__cultivation_components_mowing_mowing_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/mowing/create',component:__WEBPACK_IMPORTED_MODULE_39__cultivation_components_mowing_mowing_create__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation',component:__WEBPACK_IMPORTED_MODULE_41__cultivation_components_tree_replant_tree_replant_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/trees',component:__WEBPACK_IMPORTED_MODULE_42__cultivation_components_tree_replant_tree_inventory__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/cultivation/replants',component:__WEBPACK_IMPORTED_MODULE_43__cultivation_components_tree_replant_tree_replant__["a" /* default */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/irrigation',component:__WEBPACK_IMPORTED_MODULE_45__irrigation_irrigation_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_46__irrigation_irrigation_view__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/irrigation/create',component:__WEBPACK_IMPORTED_MODULE_47__irrigation_irrigation_create__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/irrigation/manage',component:__WEBPACK_IMPORTED_MODULE_48__irrigation_irrigation_manage__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/weather',component:__WEBPACK_IMPORTED_MODULE_44__weather_weather__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/interval',component:__WEBPACK_IMPORTED_MODULE_49__interval_interval_container__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_50__interval_interval_view__["a" /* default */]})))));/* END */

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchWeather;
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadWeather;
/* harmony export (immutable) */ __webpack_exports__["e"] = setWeatherTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = setLocalWeatherSite;
/* harmony export (immutable) */ __webpack_exports__["c"] = setWeatherLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(7);
/*******************************************************************************
Weather Actions
Hawaiian Macadamia Nut Services
Alexander Self
Weather data derived from: https://developer.climacell.co/; saved in AWS db
06.18.20
*******************************************************************************/var $=window.$;var Materialize=window.Materialize;/**
* fetchWeather(): Fetches weather and air quality records by location
* @param {String} date: date to fetch
* @returns {Object} locations: array of locations with weather and aq data
* @called-in: ['weather.js']
**/function fetchWeather(date){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/weather',{headers:{authorization:localStorage.getItem('token')},params:{date:date}}).then(function(res){var locations=res.data.locations;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_WEATHER */],payload:locations,date:date});}).catch(function(err){console.error(err);});};}/**
* downloadWeather(): Fetches weather and air quality records and emails them out
* @param {String} date1: Start date
* @param {String} date2: End date
* @param {String} email: email to send file to
* @returns
* @called-in: ['weather.js']
**/function downloadWeather(date1,date2,email){$('#preloader').css('display','block');return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ROOT_URL */]+'/downloadWeather',{headers:{authorization:localStorage.getItem('token')},params:{date1:date1,date2:date2,email:email}}).then(function(res){$('#preloader').css('display','none');success('Success fetching weather data');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["b" /* DOWNLOAD_DATA */]});}).catch(function(err){$('#preloader').css('display','none');error('There was an error fetching weather data');});};}/**
* setWeatherTime(): Sets the time of the data set and fetches the data object for display
* @param {String} val: The value from the time slider(1-18); used to map to actual Time
* @param {Array} locations: All weather locations with data sets
* @param {Number} loc: The id of the location(site)
* @returns {Object}
* @called-in: ['weather.js']
**/function setWeatherTime(val,locations,loc){var _loc=locations.find(function(l){return Number(l.id)===Number(loc);});if(_loc===undefined)return{type:__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_WEATHER_TIME */],payload:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* TIME */][val]};var airQuality=_loc.airQuality.find(function(a){var re=new RegExp(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* TIME */][val],"g");var time=a.observation_time.split(' ')[1];var hour=time.split(':')[0];return hour.match(re);});var weather=_loc.weather.find(function(a){var re=new RegExp(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* TIME */][val],"g");var time=a.observation_time.split(' ')[1];var hour=time.split(':')[0];return hour.match(re);});return{type:__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_WEATHER_TIME */],payload:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* TIME */][val],loc:Object.assign({},_loc,{airQuality:airQuality,weather:weather}),dataset:{airQuality:_loc.airQuality,weather:_loc.weather}};}/**
* setLocalWeatherSite(): Sets the site of the data set and fetches the data object for display
* @param {String} val: The value from the location slider(dynamic ids of the locations)
* @param {Array} locations: All weather locations with data sets
* @param {Number} _time: The current time value saved in state
* @returns {Object}
* @called-in: ['weather.js']
**/function setLocalWeatherSite(val,locations,_time){var _loc=locations.find(function(l){return Number(l.id)===Number(val);});if(_loc===undefined)return{type:__WEBPACK_IMPORTED_MODULE_0__types__["d" /* SET_LOCAL_WEATHER_SITE */],payload:_loc};var airQuality=_loc.airQuality.find(function(a){var re=new RegExp(_time,"g");var time=a.observation_time.split(' ')[1];var hour=time.split(':')[0];return hour.match(re);});var weather=_loc.weather.find(function(a){var re=new RegExp(_time,"g");var time=a.observation_time.split(' ')[1];var hour=time.split(':')[0];return hour.match(re);});return{type:__WEBPACK_IMPORTED_MODULE_0__types__["d" /* SET_LOCAL_WEATHER_SITE */],payload:Object.assign({},_loc,{airQuality:airQuality,weather:weather}),dataset:{airQuality:_loc.airQuality,weather:_loc.weather}};}/**
* setWeatherLocation): Sets the location of the data: 71, 72, 75
* @param {Number} loc: The value of the location
* @returns {Object}
* @called-in: ['weather.js']
**/function setWeatherLocation(loc){return{type:__WEBPACK_IMPORTED_MODULE_0__types__["e" /* SET_WEATHER_LOCATION */],payload:loc};}function error(err){Materialize.toast(err,4000,'rounded red');return{type:'ERROR',err:err};}function success(msg){Materialize.toast(msg,4000,'rounded green');return{type:'SUCCESS'};}/* END */

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
var propTypes={airQuality:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var AirQualityDisplay=function AirQualityDisplay(_ref){var airQuality=_ref.airQuality;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex','flexDirection':'row','justifyContent':'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10 pr-10'},airQuality?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'intro-title'},airQuality.epa_health_concern,' Air Quality'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].epa_aqi,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'EPA Air Quality Index'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:airQuality.epa_aqi<=50?'green-text':airQuality.epa_aqi>50&&airQuality.epa_aqi<=100?'yellow-text':airQuality.epa_aqi>100&&airQuality.epa_aqi<=150?'orange-text':airQuality.epa_aqi>150&&airQuality.epa_aqi<=200?'red-text':airQuality.epa_aqi>200&&airQuality.epa_aqi<=300?'purple-text':airQuality.epa_aqi>300?'brown-text':''},airQuality.epa_aqi,' ',airQuality.epa_health_concern):'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].pm25,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Particulate Matter < 2.5',' ','\xB5','m'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.pm25:'N/A',' ','\xB5','g/ft','\xB3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].pm10,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Particulate Matter < 10',' ','\xB5','m'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.pm10:'N/A',' ','\xB5','g/ft','\xB3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].o3,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Ozone (o3)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.o3:'N/A',' ppb')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].no2,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Nitrogen Dioxide (no2)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.no2:'N/A',' ppb')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].co,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Carbon Monoxide (co)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.co:'N/A',' ppb')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].so2,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Sulfur Dioxide (so2)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.so2:'N/A',' ppb')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-smog small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Primary Pollutant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},airQuality?airQuality.epa_primary_pollutant:'N/A'))))));};AirQualityDisplay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (AirQualityDisplay);/* END */

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StackedBarChartWithLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = LineChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/*
export function TimeSeries({ctx, labels, data1, data2, opts, label1, label2}) {
	return new Chart(ctx, {
		type: 'line',
		data: {
			labels,
			datasets: [{
				label: label1,
				backgroundColor: 'rgba(255, 99, 132, 0.2)',
				borderColor: 'rgba(255,99,132,1)',
				fill: false,
				data: data1,
			}, {
				label: label2,
				backgroundColor: 'rgba(137, 196, 244, 1)',
				borderColor: 'rgba(44, 130, 201, 1)',
				fill: false,
				data: data2,
			},
		},
		options: {
			title: {
				text: 'Chart.js Time Scale'
			},
			scales: {
				xAxes: [{
					type: 'time',
					time: {
						parser: timeFormat,
						tooltipFormat: 'll HH:mm'
					},
					scaleLabel: {
						display: true,
						labelString: 'Date'
					}
				}],
				yAxes: [{
					scaleLabel: {
						display: true,
						labelString: 'value'
					}
				}]
			},
		}
	});
}
*/function StackedBarChartWithLine(_ref){var ctx=_ref.ctx,labels=_ref.labels,data1=_ref.data1,data2=_ref.data2,data3=_ref.data3,label1=_ref.label1,label2=_ref.label2,label3=_ref.label3;return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{labels:labels,datasets:[{type:'line',label:label1,backgroundColor:'rgba(54, 162, 235, 1)',borderColor:'rgba(54, 162, 235, 1)',borderWidth:2,fill:false,data:data1,yAxisID:"y-axis-2"},{type:'bar',label:label2,backgroundColor:'rgba(75, 192, 192, 1)',borderColor:'rgba(75, 192, 192, 1)',borderWidth:2,data:data2},{type:'bar',label:label3,backgroundColor:'rgba(255, 206, 86, 1)',borderColor:'rgba(255, 206, 86, 1)',borderWidth:2,data:data3,yAxisID:"y-axis-1"}]},options:{responsive:true,title:{text:''},tooltips:{mode:'index'},hover:{mode:'index'},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Time'}}],yAxes:[{stacked:false,position:"left",scaleLabel:{display:true,labelString:''},id:"y-axis-1",ticks:{beginAtZero:true}},{stacked:false,position:"left",scaleLabel:{display:true,labelString:'Temperature & Humidity'},id:"y-axis-1"},{type:"linear",display:true,position:"right",scaleLabel:{display:true,labelString:'Precipitation (mm)'},gridLines:{color:"rgba(0, 0, 0, 0)"},ticks:{beginAtZero:true},id:"y-axis-2"}]}}});}function LineChart(_ref2){var ctx=_ref2.ctx,labels=_ref2.labels,data=_ref2.data,label=_ref2.label;return new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'line',data:{labels:labels,datasets:[{type:'line',label:label,backgroundColor:'rgba(1, 152, 117, 1)',borderColor:'rgba(162, 222, 208, 1)',borderWidth:2,fill:true,data:data,yAxisID:"y-axis-3"}]},options:{responsive:true,title:{text:''},tooltips:{mode:'index'},hover:{mode:'index'},scales:{xAxes:[{scaleLabel:{display:true,labelString:'Time'}}],yAxes:[{type:"linear",display:true,position:"left",scaleLabel:{display:false,labelString:'Air Quality'},gridLines:{color:"rgba(0, 0, 0, 0)"},ticks:{beginAtZero:true},id:"y-axis-3"}]}}});}/* END */

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/***************************************************************
10/5/2017
Alexander Self
Dashboard Chart Card
***************************************************************/var propTypes={canvasId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var DashboardCard=function DashboardCard(_ref){var canvasId=_ref.canvasId,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'weather-card-title grey-text text-darken-4'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:canvasId,className:'weather-chart'})));};DashboardCard.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (DashboardCard);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HorizontalSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VerticalSlider; });
/* harmony export (immutable) */ __webpack_exports__["b"] = DatePicker;
/* harmony export (immutable) */ __webpack_exports__["a"] = RadioButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function HorizontalSlider(_ref){var id=_ref.id,outputId=_ref.outputId,outputVal=_ref.outputVal,label=_ref.label,_class=_ref._class,min=_ref.min,max=_ref.max,_onChange=_ref.onChange,defaultValue=_ref.defaultValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"slider-label",htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"range",id:id,min:min,max:max,className:_class,onChange:function onChange(e){return _onChange(e.target.value);},defaultValue:defaultValue}));}function VerticalSlider(_ref2){var id=_ref2.id,label=_ref2.label,min=_ref2.min,max=_ref2.max,_class=_ref2._class,_onChange2=_ref2.onChange,defaultValue=_ref2.defaultValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"slider-label",htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"range",className:_class+" vertical",orient:"vertical",id:id,min:min,max:max,defaultValue:defaultValue,onChange:function onChange(e){return _onChange2(e.target.value);}}));}function DatePicker(_ref3){var id=_ref3.id,label=_ref3.label,min=_ref3.min,max=_ref3.max,_class=_ref3._class;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date",className:_class,id:id}));}function RadioButton(_ref4){var id=_ref4.id,name=_ref4.name,label=_ref4.label,value=_ref4.value,_class=_ref4._class,disabled=_ref4.disabled,onClick=_ref4.onClick,checked=_ref4.checked;if(checked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radio-button "+_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"radio",disabled:disabled,onClick:onClick,value:value,defaultChecked:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radio-button "+_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:id,name:name,type:"radio",disabled:disabled,onClick:onClick,value:value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:id},label));}/* END */

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(169);
var propTypes={weather:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var WeatherDislay=function WeatherDislay(_ref){var weather=_ref.weather;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex','flexDirection':'row','justifyContent':'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10'},weather?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi '+__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* WEATHER_CODES */][weather.weather_code]+' medium intro-title'}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'intro-title'},weather?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* capitalizeWeatherCode */])(weather.weather_code):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-thermometer small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Temperature'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.temp:'N/A',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-fahrenheit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-humidity small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Humidity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.humidity:'N/A','%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-raindrops small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Precipitation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.precipitation:'N/A',' in/hr')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-windy small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Wind Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.wind_speed:'N/A',' mph')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m6 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-barometer small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Barometric Pressure'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?(Number(weather.baro_pressure)*__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PASCAL */]).toFixed(2):'N/A',' hPA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-cloudy small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Cloud Cover'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.cloud_cover:'N/A','%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:"40px",width:"40px",src:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SVG */].surface_shortwave_radiation,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Surface Shortwave Radiation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.surface_shortwave_radiation:'N/A',' Btu/ft','\xB2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'collection-item avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'wi wi-strong-wind small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label2'},'Wind Gust'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title2'},weather?weather.wind_gust:'N/A',' mph'))))));};WeatherDislay.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (WeatherDislay);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WeatherReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(169);
/***************************************************
Root Reducer
****************************************************/var initState={locations:{all:[],displaying:[]},view:{lastUpdated:'',date:'',time:'06',loc:1,location:71,name:'Husking',datapoint:{airQuality:{},weather:{}},dataset:{airQuality:[],weather:[]}}};function WeatherReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_WEATHER */]:if(action.payload.length===0)return state;var loc=action.payload.find(function(l){return l.name===initState.view.name;});if(loc.airQuality.length===0&&loc.weather.length===0)return state;var hour=loc.airQuality[loc.airQuality.length-1].observation_time.split(' ')[1].split(':')[0]||'N/A';if(document.getElementById('weather-time'))document.getElementById('weather-time').value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* swapKeyWithValue */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* TIME */])[hour];var lastUpdated=state.view.lastUpdated;if(lastUpdated==='')lastUpdated=loc.airQuality[loc.airQuality.length-1].observation_time;return Object.assign({},state,{locations:Object.assign({},state.locations,{all:action.payload,displaying:action.payload.filter(function(l){return l.loc===state.view.location;})}),view:Object.assign({},state.view,{date:action.date,lastUpdated:lastUpdated,time:hour,datapoint:Object.assign({},loc,{airQuality:loc.airQuality[loc.airQuality.length-1]||{},weather:loc.weather[loc.weather.length-1]||{}}),dataset:{airQuality:loc.airQuality,weather:loc.weather}})});case __WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_WEATHER_TIME */]:return Object.assign({},state,{view:Object.assign({},state.view,{time:action.payload,datapoint:action.loc,name:action.loc.name,dataset:action.dataset})});case __WEBPACK_IMPORTED_MODULE_0__types__["d" /* SET_LOCAL_WEATHER_SITE */]:return Object.assign({},state,{view:Object.assign({},state.view,{datapoint:action.payload,name:action.payload.name,loc:action.payload.id,dataset:action.dataset})});case __WEBPACK_IMPORTED_MODULE_0__types__["e" /* SET_WEATHER_LOCATION */]:var locs=state.locations.all.filter(function(l){return l.loc===Number(action.payload);});var record=locs[0];var _hour=record.airQuality[record.airQuality.length-1].observation_time.split(' ')[1].split(':')[0]||'N/A';document.getElementById('weather-time').value=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* swapKeyWithValue */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* TIME */])[_hour];document.getElementById('weather-location').value=record.id;return Object.assign({},state,{locations:Object.assign({},state.locations,{displaying:locs}),view:Object.assign({},state.view,{time:_hour,loc:record.id,location:Number(action.payload),name:record.name,datapoint:Object.assign({},record,{airQuality:record.airQuality[record.airQuality.length-1],weather:record.weather[record.weather.length-1]}),dataset:{airQuality:record.airQuality,weather:record.weather}})});default:return state;}}/* END */

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_convert_units__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_convert_units___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_convert_units__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__weather_css__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__weather_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__weather_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_weather_display__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_airQuality_display__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inputs__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_charts_misc_chart__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dashboard_card__ = __webpack_require__(451);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={allLocations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,displaying:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,view:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,weather:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,airQuality:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,downloadWeather:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchWeather:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setWeatherLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setLocalWeatherSite:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setWeatherTime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var Weather=function(_Component){_inherits(Weather,_Component);function Weather(props){_classCallCheck(this,Weather);var _this=_possibleConstructorReturn(this,(Weather.__proto__||Object.getPrototypeOf(Weather)).call(this,props));_this.state={barLineChart:null,lineChart:null};_this._fetchWeather=_this._fetchWeather.bind(_this);_this._downloadWeather=_this._downloadWeather.bind(_this);_this.drawWeatherChart=_this.drawWeatherChart.bind(_this);_this.drawAirQualityChart=_this.drawAirQualityChart.bind(_this);return _this;}_createClass(Weather,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchWeather(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'));document.title='Weather';}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){this.drawWeatherChart(newProps.view.dataset.weather);this.drawAirQualityChart(newProps.view.dataset.airQuality);}},{key:'_fetchWeather',value:function _fetchWeather(date){if(date==='')return;return this.props.fetchWeather(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD'));}},{key:'_downloadWeather',value:function _downloadWeather(date1,date2){if(date1===''&&date2==='')return;return this.props.downloadWeather(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date1).format('YYYY-MM-DD'),__WEBPACK_IMPORTED_MODULE_2_moment___default()(date2).format('YYYY-MM-DD'),this.props.user.email);}},{key:'drawWeatherChart',value:function drawWeatherChart(props){if(!props)return;if(this.state.barLineChart)this.state.barLineChart.destroy();var ctx=document.getElementById("weather-chart").getContext("2d");var labels=props.map(function(val){var time=val.observation_time.split(' ')[1];return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time,'HH').format("h:mm:ss A");});var temp=props.map(function(val){return val.temp;});var humidity=props.map(function(val){return val.humidity;});var precipitation=props.map(function(val){return __WEBPACK_IMPORTED_MODULE_3_convert_units___default()(val.precipitation).from('in').to('mm');});// Params: ctx, labels, data1, data2, data3, label1, label2, label3
var barLineChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_charts_misc_chart__["a" /* StackedBarChartWithLine */])({ctx:ctx,labels:labels,data1:precipitation,data2:humidity,data3:temp,label1:'Precipitation (mm)',label2:'Humidity %',label3:'Temperature'});this.setState({barLineChart:barLineChart});}},{key:'drawAirQualityChart',value:function drawAirQualityChart(props){if(!props)return;if(this.state.lineChart)this.state.lineChart.destroy();var ctx=document.getElementById("airQuality-chart").getContext("2d");var labels=props.map(function(val){var time=val.observation_time.split(' ')[1];return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time,'HH').format("h:mm:ss A");});var aq=props.map(function(val){return val.epa_aqi;});// Params: ctx, labels, data, label
var lineChart=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_charts_misc_chart__["b" /* LineChart */])({ctx:ctx,labels:labels,data:aq,label:'EPA Air Quality Index'});this.setState({lineChart:lineChart});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card z-depth-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-title'},'Location: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.view.location===71?'Pahala':this.props.view.location===72?'Kea\'au':this.props.view.location===75?'Na\'alehu':'N/A'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Site: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.view.name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Date: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.view.date),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Time: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.view.time+':00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Last Updated: ',this.props.view.lastUpdated),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["a" /* RadioButton */],{id:'weather-pahala',name:'weather-loc',label:'Pahala',value:71,onClick:function onClick(e){return _this2.props.setWeatherLocation(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["a" /* RadioButton */],{id:'weather-keaau',name:'weather-loc',label:'Kea\'au',value:72,onClick:function onClick(e){return _this2.props.setWeatherLocation(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["a" /* RadioButton */],{id:'weather-naalehu',name:'weather-loc',label:'Na\'alehu',value:75,onClick:function onClick(e){return _this2.props.setWeatherLocation(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-fetch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["b" /* DatePicker */],{id:'weather-fetch',label:'Select a Date',_class:'w-date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect',onClick:function onClick(){return _this2._fetchWeather(document.getElementById('weather-fetch').value);}},'Fetch'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl5 hide-on-small-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_dashboard_card__["a" /* default */],{canvasId:'weather-chart',label:'Weather'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl5 hide-on-small-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_dashboard_card__["a" /* default */],{canvasId:'airQuality-chart',label:'Air Quality'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["c" /* HorizontalSlider */],{id:'weather-time',_class:'sl',label:'Time',min:"1",max:"19",defaultValue:"1",onChange:function onChange(val){return _this2.props.setWeatherTime(val,_this2.props.allLocations,_this2.props.view.loc);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s1 m1 l1 xl1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["d" /* VerticalSlider */],{id:'weather-location',label:'Site',_class:'sl slider',min:Math.min.apply(Math,_toConsumableArray(this.props.displaying.map(function(d){return d.id;}))),defaultValue:''+this.props.view.loc,max:Math.max.apply(Math,_toConsumableArray(this.props.displaying.map(function(d){return d.id;}))),onChange:function onChange(val){return _this2.props.setLocalWeatherSite(val,_this2.props.allLocations,_this2.props.view.time);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s11 m11 l11 xl11 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_weather_display__["a" /* default */],{weather:this.props.weather})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l6 xl6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_airQuality_display__["a" /* default */],{airQuality:this.props.airQuality}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.view.location===71?'Pahala':this.props.view.location===72?'Kea\'au':this.props.view.location===75?'Na\'alehu':'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.view.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.view.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s6 m3 l3 xl3 b-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.view.time+':00')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col s12 m12 l12 xl12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Email Weather & Air Quality Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pr-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["b" /* DatePicker */],{id:'weather-date1',label:'From',_class:'w-date'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pr-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_inputs__["b" /* DatePicker */],{id:'weather-date2',label:'To',_class:'w-date'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'center-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn waves-effect',onClick:function onClick(){return _this2._downloadWeather(document.getElementById('weather-date1').value,document.getElementById('weather-date2').value);}},'Email'))))))));}}]);return Weather;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.auth.user,allLocations:state.weather.locations.all,displaying:state.weather.locations.displaying,view:state.weather.view,weather:state.weather.view.datapoint.weather,airQuality:state.weather.view.datapoint.airQuality};}function mapDispatchToProps(dispatch){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["c" /* bindActionCreators */])({downloadWeather:__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* downloadWeather */],fetchWeather:__WEBPACK_IMPORTED_MODULE_6__actions__["b" /* fetchWeather */],setWeatherLocation:__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* setWeatherLocation */],setLocalWeatherSite:__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* setLocalWeatherSite */],setWeatherTime:__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* setWeatherTime */]},dispatch);}Weather.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Weather));

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(456)
var ieee754 = __webpack_require__(520)
var isArray = __webpack_require__(524)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
'use strict';

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/
function clone(parent, circular, depth, prototype) {
  var filter;
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    filter = circular.filter;
    circular = circular.circular
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
};
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
};
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
};
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
};
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
};
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457).Buffer))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(170);
var route = __webpack_require__(461);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(170);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(462);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/,
       hex =  /^#([a-fA-F0-9]{6})$/,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       keyword = /(\D+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var clone = __webpack_require__(458);
var convert = __webpack_require__(459);
var string = __webpack_require__(463);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		} else {
			throw new Error('Unable to parse color from string "' + obj + '"');
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		} else {
			throw new Error('Unable to parse color from object ' + JSON.stringify(obj));
		}
	}
};

Color.prototype = {
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		if (this.values.alpha !== 1) {
			return this.values.hwb.concat([this.values.alpha]);
		}
		return this.values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var rgb = this.values.rgb;
		return rgb.concat([this.values.alpha]);
	},
	rgbaArrayNormalized: function () {
		var rgb = this.values.rgb;
		var glRgba = [];
		for (var i = 0; i < 3; i++) {
			glRgba[i] = rgb[i] / 255;
		}
		glRgba.push(this.values.alpha);
		return glRgba;
	},
	hslaArray: function () {
		var hsl = this.values.hsl;
		return hsl.concat([this.values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		this.values.hsl[2] += this.values.hsl[2] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	darken: function (ratio) {
		this.values.hsl[2] -= this.values.hsl[2] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	saturate: function (ratio) {
		this.values.hsl[1] += this.values.hsl[1] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	desaturate: function (ratio) {
		this.values.hsl[1] -= this.values.hsl[1] * ratio;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	whiten: function (ratio) {
		this.values.hwb[1] += this.values.hwb[1] * ratio;
		this.setValues('hwb', this.values.hwb);
		return this;
	},

	blacken: function (ratio) {
		this.values.hwb[2] += this.values.hwb[2] * ratio;
		this.setValues('hwb', this.values.hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		this.setValues('alpha', this.values.alpha - (this.values.alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		this.setValues('alpha', this.values.alpha + (this.values.alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hue = this.values.hsl[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		this.values.hsl[0] = hue;
		this.setValues('hsl', this.values.hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		var col = new Color();
		col.values = clone(this.values);
		return col;
	}
};

Color.prototype.getValues = function (space) {
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = this.values[space][i];
	}

	if (this.values.alpha !== 1) {
		vals.a = this.values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};

	var maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};

	var i;
	var alpha = 1;
	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		this.values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			this.values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			this.values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	this.values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? this.values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
		this.values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			this.values[sname] = convert[space][sname](this.values[space]);
		}

		// cap values
		for (i = 0; i < sname.length; i++) {
			capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
			this.values[sname][i] = Math.round(capped);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	if (val === undefined) {
		// color.red()
		return this.values[space][index];
	} else if (val === this.values[space][index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	this.values[space][index] = val;
	this.setValues(space, this.values[space]);

	return this;
};

module.exports = Color;


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Adds comma's to a number
 *
 * @export
 * @param {(string|number)} num the number to commafy
 * @param {object} [{ stripDecimals = false, spacedDecimals = false }={}] the options
 * @returns {string} eg. '1,000,000'
 */
function commafy(num, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.stripDecimals, stripDecimals = _c === void 0 ? false : _c, _d = _b.spacedDecimals, spacedDecimals = _d === void 0 ? false : _d, _e = _b.thousands, thousands = _e === void 0 ? false : _e;
    var str = num.toString().split('.');
    var minLength = thousands ? 4 : 5;
    if (str[0].length >= minLength) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (stripDecimals)
        return str[0];
    if (spacedDecimals && str[1] && str[1].length >= minLength) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ').trim();
    }
    return str.join('.');
}

/* harmony default export */ __webpack_exports__["a"] = (commafy);


/***/ }),
/* 466 */
/***/ (function(module, exports) {

var angle;

angle = {
  rad: {
    name: {
      singular: 'radian'
    , plural: 'radians'
    }
  , to_anchor: 180/Math.PI
  }
, deg: {
    name: {
      singular: 'degree'
    , plural: 'degrees'
    }
  , to_anchor: 1
  }
, grad: {
    name: {
      singular: 'gradian'
    , plural: 'gradians'
    }
  , to_anchor: 9/10
  }
, arcmin: {
    name: {
      singular: 'arcminute'
    , plural: 'arcminutes'
    }
  , to_anchor: 1/60
  }
, arcsec: {
    name: {
      singular: 'arcsecond'
    , plural: 'arcseconds'
    }
  , to_anchor: 1/3600
  }
};

module.exports = {
  metric: angle
, _anchors: {
    metric: {
      unit: 'deg'
    , ratio: 1
    }
  }
};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

var apparentPower;

apparentPower = {
  VA: {
    name: {
      singular: 'Volt-Ampere'
    , plural: 'Volt-Amperes'
    }
  , to_anchor: 1
  }
, mVA: {
    name: {
      singular: 'Millivolt-Ampere'
      , plural: 'Millivolt-Amperes'
    }
    , to_anchor: .001
  }
, kVA: {
    name: {
      singular: 'Kilovolt-Ampere'
    , plural: 'Kilovolt-Amperes'
    }
  , to_anchor: 1000
  }
, MVA: {
    name: {
      singular: 'Megavolt-Ampere'
    , plural: 'Megavolt-Amperes'
    }
  , to_anchor: 1000000
  }
, GVA: {
    name: {
      singular: 'Gigavolt-Ampere'
    , plural: 'Gigavolt-Amperes'
    }
  , to_anchor: 1000000000
  }
};

module.exports = {
  metric: apparentPower
, _anchors: {
    metric: {
      unit: 'VA'
    , ratio: 1
    }
  }
};


/***/ }),
/* 468 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  mm2: {
    name: {
      singular: 'Square Millimeter'
    , plural: 'Square Millimeters'
    }
  , to_anchor: 1/1000000
  }
, cm2: {
    name: {
      singular: 'Centimeter'
    , plural: 'Centimeters'
    }
  , to_anchor: 1/10000
  }
, m2: {
    name: {
      singular: 'Square Meter'
    , plural: 'Square Meters'
    }
  , to_anchor: 1
  }
, ha: {
    name: {
      singular: 'Hectare'
    , plural: 'Hectares'
    }
  , to_anchor: 10000
  }
, km2: {
    name: {
      singular: 'Square Kilometer'
    , plural: 'Square Kilometers'
    }
  , to_anchor: 1000000
  }
};

imperial = {
  'in2': {
    name: {
      singular: 'Square Inch'
    , plural: 'Square Inches'
    }
  , to_anchor: 1/144
  }
, yd2: {
    name: {
      singular: 'Square Yard'
    , plural: 'Square Yards'  
    }
  , to_anchor: 9
  }
, ft2: {
    name: {
      singular: 'Square Foot'
    , plural: 'Square Feet'
    }
  , to_anchor: 1
  }
, ac: {
    name: {
      singular: 'Acre'
    , plural: 'Acres'
    }
  , to_anchor: 43560
  }
, mi2: {
    name: {
      singular: 'Square Mile'
    , plural: 'Square Miles'
    }
  , to_anchor: 27878400
  }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'm2'
    , ratio: 10.7639
    }
  , imperial: {
      unit: 'ft2'
    , ratio: 1/10.7639
    }
  }
};


/***/ }),
/* 469 */
/***/ (function(module, exports) {

var current;

current = {
  A: {
    name: {
      singular: 'Ampere'
    , plural: 'Amperes'
    }
  , to_anchor: 1
  }
, mA: {
    name: {
      singular: 'Milliampere'
      , plural: 'Milliamperes'
    }
    , to_anchor: .001
  }
, kA: {
    name: {
      singular: 'Kiloampere'
    , plural: 'Kiloamperes'
    }
  , to_anchor: 1000
  }
};

module.exports = {
  metric: current
, _anchors: {
    metric: {
      unit: 'A'
    , ratio: 1
    }
  }
};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

var bits
  , bytes;

bits = {
  b: {
    name: {
      singular: 'Bit'
    , plural: 'Bits'
    }
  , to_anchor: 1
  }
, Kb: {
    name: {
      singular: 'Kilobit'
    , plural: 'Kilobits'
    }
  , to_anchor: 1024
  }
, Mb: {
    name: {
      singular: 'Megabit'
    , plural: 'Megabits'
    }
  , to_anchor: 1048576
  }
, Gb: {
    name: {
      singular: 'Gigabit'
    , plural: 'Gigabits'
    }
  , to_anchor: 1073741824
  }
, Tb: {
    name: {
      singular: 'Terabit'
    , plural: 'Terabits'
    }
  , to_anchor: 1099511627776
  }
};

bytes = {
  B: {
    name: {
      singular: 'Byte'
    , plural: 'Bytes'
    }
  , to_anchor: 1
  }
, KB: {
    name: {
      singular: 'Kilobyte'
    , plural: 'Kilobytes'
    }
  , to_anchor: 1024
  }
, MB: {
    name: {
      singular: 'Megabyte'
    , plural: 'Megabytes'
    }
  , to_anchor: 1048576
  }
, GB: {
    name: {
      singular: 'Gigabyte'
    , plural: 'Gigabytes'
    }
  , to_anchor: 1073741824
  }
, TB: {
    name: {
      singular: 'Terabyte'
    , plural: 'Terabytes'
    }
  , to_anchor: 1099511627776
  }
};

module.exports = {
  bits: bits
, bytes: bytes
, _anchors: {
    bits: {
      unit: 'b'
    , ratio: 1/8
    }
  , bytes: {
      unit: 'B'
    , ratio: 8
    }
  }
};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  ea: {
    name: {
      singular: 'Each'
    , plural: 'Each'
    }
  , to_anchor: 1
  },
  dz: {
    name: {
      singular: 'Dozen'
    , plural: 'Dozens'
    }
  , to_anchor: 12
  }
};

module.exports = {
  metric: metric
, imperial: {}
, _anchors: {
    metric: {
      unit: 'ea'
    , ratio: 1
    }
  }
};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

var energy;

energy = {
  Wh: {
    name: {
      singular: 'Watt-hour'
    , plural: 'Watt-hours'
    }
  , to_anchor: 3600
  }
, mWh: {
    name: {
      singular: 'Milliwatt-hour'
      , plural: 'Milliwatt-hours'
    }
    , to_anchor: 3.6
  }
, kWh: {
    name: {
      singular: 'Kilowatt-hour'
    , plural: 'Kilowatt-hours'
    }
  , to_anchor: 3600000
  }
, MWh: {
    name: {
      singular: 'Megawatt-hour'
    , plural: 'Megawatt-hours'
    }
  , to_anchor: 3600000000
  }
, GWh: {
    name: {
      singular: 'Gigawatt-hour'
    , plural: 'Gigawatt-hours'
    }
  , to_anchor: 3600000000000
  }
, J: {
    name: {
      singular: 'Joule'
    , plural: 'Joules'
    }
  , to_anchor: 1
  }
, kJ: {
    name: {
      singular: 'Kilojoule'
    , plural: 'Kilojoules'
    }
  , to_anchor: 1000
  }
};

module.exports = {
  metric: energy
, _anchors: {
    metric: {
      unit: 'J'
    , ratio: 1
    }
  }
};


/***/ }),
/* 473 */
/***/ (function(module, exports) {

var frequency;

frequency = {
  mHz: {
    name: {
      singular: 'millihertz'
    , plural: 'millihertz'
    }
  , to_anchor: 1/1000
  }
, Hz: {
    name: {
      singular: 'hertz'
    , plural: 'hertz'
    }
  , to_anchor: 1
  }
, kHz: {
    name: {
      singular: 'kilohertz'
    , plural: 'kilohertz'
    }
  , to_anchor: 1000
  }
, MHz: {
    name: {
      singular: 'megahertz'
    , plural: 'megahertz'
    }
  , to_anchor: 1000 * 1000
  }
, GHz: {
    name: {
      singular: 'gigahertz'
    , plural: 'gigahertz'
    }
  , to_anchor: 1000 * 1000 * 1000
  }
, THz: {
    name: {
      singular: 'terahertz'
    , plural: 'terahertz'
    }
  , to_anchor: 1000 * 1000 * 1000 * 1000
  }
, rpm: {
    name: {
      singular: 'rotation per minute'
    , plural: 'rotations per minute'
    }
  , to_anchor: 1/60
  }
, "deg/s": {
    name: {
      singular: 'degree per second'
    , plural: 'degrees per second'
    }
  , to_anchor: 1/360
  }
, "rad/s": {
    name: {
      singular: 'radian per second'
    , plural: 'radians per second'
    }
  , to_anchor: 1/(Math.PI * 2)
  }
};


module.exports = {
  metric: frequency
, _anchors: {
    frequency: {
      unit: 'hz'
    , ratio: 1
    }
  }
};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

var metric,
imperial;

metric = {
  'lx': {
    name: {
      singular: 'Lux',
      plural: 'Lux'
    },
    to_anchor: 1
  }
};

imperial = {
  'ft-cd': {
    name: {
      singular: 'Foot-candle',
      plural: 'Foot-candles'
    },
    to_anchor: 1
  }
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'lx',
      ratio: 1/10.76391
    },
    imperial: {
      unit: 'ft-cd',      
	  ratio: 10.76391
    }
  }
};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

var metric,
imperial;

metric = {
  mm: {
    name: {
      singular: 'Millimeter',
      plural: 'Millimeters'
    },
    to_anchor: 1/1000
  },
  cm: {
    name: {
      singular: 'Centimeter',
      plural: 'Centimeters'
    },
    to_anchor: 1/100
  },
  m: {
    name: {
      singular: 'Meter',
      plural: 'Meters'
    },
    to_anchor: 1
  },
  km: {
    name: {
      singular: 'Kilometer',
      plural: 'Kilometers'
    },
    to_anchor: 1000
  }
};

imperial = {
  'in': {
    name: {
      singular: 'Inch',
      plural: 'Inches'
    },
    to_anchor: 1/12
  },
  yd: {
    name: {
      singular: 'Yard',
      plural: 'Yards'
    },
    to_anchor: 3
  },
  'ft-us': {
    name: {
      singular: 'US Survey Foot',
      plural: 'US Survey Feet'
    },
    to_anchor: 1.000002
  },
  ft: {
    name: {
      singular: 'Foot',
      plural: 'Feet'
    },
    to_anchor: 1
  },
  mi: {
    name: {
      singular: 'Mile',
      plural: 'Miles'
    },
    to_anchor: 5280
  }
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'm',
      ratio: 3.28084
    },
    imperial: {
      unit: 'ft',
      ratio: 1/3.28084
    }
  }
};


/***/ }),
/* 476 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  mcg: {
    name: {
      singular: 'Microgram'
    , plural: 'Micrograms'
    }
  , to_anchor: 1/1000000
  }
, mg: {
    name: {
      singular: 'Milligram'
    , plural: 'Milligrams'
    }
  , to_anchor: 1/1000
  }
, g: {
    name: {
      singular: 'Gram'
    , plural: 'Grams'
    }
  , to_anchor: 1
  }
, kg: {
    name: {
      singular: 'Kilogram'
    , plural: 'Kilograms'
    }
  , to_anchor: 1000
}
, mt: {
    name: {
      singular: 'Metric Tonne'
    , plural: 'Metric Tonnes'
    }
  , to_anchor: 1000000
  }
};

imperial = {
  oz: {
    name: {
      singular: 'Ounce'
    , plural: 'Ounces'
    }
  , to_anchor: 1/16
  }
, lb: {
    name: {
      singular: 'Pound'
    , plural: 'Pounds'
    }
  , to_anchor: 1
}, t: {
  name: {
    singular: 'Ton',
    plural: 'Tons',
  },
    to_anchor: 2000,
  },
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'g'
    , ratio: 1/453.592
    }
  , imperial: {
      unit: 'lb'
    , ratio: 453.592
    }
  }
};


/***/ }),
/* 477 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  'min/km': {
    name: {
      singular: 'Minute per kilometre'
    , plural: 'Minutes per kilometre'
    }
  , to_anchor: 0.06
  }
  ,'s/m': {
    name: {
      singular: 'Second per metre'
    , plural: 'Seconds per metre'
    }
  , to_anchor: 1
  }
}

imperial = {
    'min/mi': {
      name: {
        singular: 'Minute per mile'
      , plural: 'Minutes per mile'
      }
    , to_anchor: 0.0113636
   }
   , 's/ft': {
      name: {
        singular: 'Second per foot'
      , plural: 'Seconds per foot'
      }
    , to_anchor: 1
   }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 's/m'
    , ratio: 0.3048
    }
  , imperial: {
      unit: 's/ft'
    , ratio: 1/0.3048
    }
  }
};


/***/ }),
/* 478 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  ppm: {
    name: {
      singular: 'Part-per Million'
      , plural: 'Parts-per Million'
    }
    , to_anchor: 1
  }
  , ppb: {
    name: {
      singular: 'Part-per Billion'
      , plural: 'Parts-per Billion'
    }
    , to_anchor: .001
  }
  , ppt: {
    name: {
      singular: 'Part-per Trillion'
      , plural: 'Parts-per Trillion'
    }
    , to_anchor: .000001
  }
  , ppq: {
    name: {
      singular: 'Part-per Quadrillion'
      , plural: 'Parts-per Quadrillion'
    }
    , to_anchor: .000000001
  }
};

module.exports = {
  metric: metric
  , imperial: {}
  , _anchors: {
    metric: {
      unit: 'ppm'
      , ratio: .000001
    }
  }
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

var power;

power = {
  W: {
    name: {
      singular: 'Watt'
    , plural: 'Watts'
    }
  , to_anchor: 1
  }
, mW: {
    name: {
      singular: 'Milliwatt'
      , plural: 'Milliwatts'
    }
    , to_anchor: .001
  }
, kW: {
    name: {
      singular: 'Kilowatt'
    , plural: 'Kilowatts'
    }
  , to_anchor: 1000
  }
, MW: {
    name: {
      singular: 'Megawatt'
    , plural: 'Megawatts'
    }
  , to_anchor: 1000000
  }
, GW: {
    name: {
      singular: 'Gigawatt'
    , plural: 'Gigawatts'
    }
  , to_anchor: 1000000000
  }
};

module.exports = {
  metric: power
, _anchors: {
    metric: {
      unit: 'W'
    , ratio: 1
    }
  }
};


/***/ }),
/* 480 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  Pa: {
    name: {
      singular: 'pascal'
    , plural: 'pascals'
    }
  , to_anchor: 1/1000
  }
, kPa: {
    name: {
      singular: 'kilopascal'
    , plural: 'kilopascals'
    }
  , to_anchor: 1
  }
, MPa: {
    name: {
      singular: 'megapascal'
    , plural: 'megapascals'
    }
  , to_anchor: 1000
  }
, hPa: {
    name: {
      singular: 'hectopascal'
    , plural: 'hectopascals'
    }
  , to_anchor: 1/10
  }
, bar: {
    name: {
      singular: 'bar'
    , plural: 'bar'
    }
  , to_anchor: 100
  }
, torr: {
    name: {
      singular: 'torr'
    , plural: 'torr'
    }
  , to_anchor: 101325/760000
  }
};

imperial = {
  psi: {
    name: {
      singular: 'pound per square inch'
    , plural: 'pounds per square inch'
    }
  , to_anchor: 1/1000
  }
, ksi: {
    name: {
      singular: 'kilopound per square inch'
    , plural: 'kilopound per square inch'
    }
  , to_anchor: 1
  }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'kPa'
    , ratio: 0.00014503768078
    }
  , imperial: {
      unit: 'psi'
    , ratio: 1/0.00014503768078
    }
  }
};


/***/ }),
/* 481 */
/***/ (function(module, exports) {

var reactiveEnergy;

reactiveEnergy = {
  VARh: {
    name: {
      singular: 'Volt-Ampere Reactive Hour'
    , plural: 'Volt-Amperes Reactive Hour'
    }
  , to_anchor: 1
  }
, mVARh: {
    name: {
      singular: 'Millivolt-Ampere Reactive Hour'
      , plural: 'Millivolt-Amperes Reactive Hour'
    }
    , to_anchor: .001
  }
, kVARh: {
    name: {
      singular: 'Kilovolt-Ampere Reactive Hour'
    , plural: 'Kilovolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000
  }
, MVARh: {
    name: {
      singular: 'Megavolt-Ampere Reactive Hour'
    , plural: 'Megavolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000000
  }
, GVARh: {
    name: {
      singular: 'Gigavolt-Ampere Reactive Hour'
    , plural: 'Gigavolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000000000
  }
};

module.exports = {
  metric: reactiveEnergy
, _anchors: {
    metric: {
      unit: 'VARh'
    , ratio: 1
    }
  }
};


/***/ }),
/* 482 */
/***/ (function(module, exports) {

var reactivePower;

reactivePower = {
  VAR: {
    name: {
      singular: 'Volt-Ampere Reactive'
    , plural: 'Volt-Amperes Reactive'
    }
  , to_anchor: 1
  }
, mVAR: {
    name: {
      singular: 'Millivolt-Ampere Reactive'
      , plural: 'Millivolt-Amperes Reactive'
    }
    , to_anchor: .001
  }
, kVAR: {
    name: {
      singular: 'Kilovolt-Ampere Reactive'
    , plural: 'Kilovolt-Amperes Reactive'
    }
  , to_anchor: 1000
  }
, MVAR: {
    name: {
      singular: 'Megavolt-Ampere Reactive'
    , plural: 'Megavolt-Amperes Reactive'
    }
  , to_anchor: 1000000
  }
, GVAR: {
    name: {
      singular: 'Gigavolt-Ampere Reactive'
    , plural: 'Gigavolt-Amperes Reactive'
    }
  , to_anchor: 1000000000
  }
};

module.exports = {
  metric: reactivePower
, _anchors: {
    metric: {
      unit: 'VAR'
    , ratio: 1
    }
  }
};


/***/ }),
/* 483 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  'm/s': {
    name: {
      singular: 'Metre per second'
    , plural: 'Metres per second'
    }
  , to_anchor: 3.6
  }
, 'km/h': {
    name: {
      singular: 'Kilometre per hour'
    , plural: 'Kilometres per hour'
    }
  , to_anchor: 1
  }
}

  imperial = {
    'm/h': {
      name: {
        singular: 'Mile per hour'
      , plural: 'Miles per hour'
      }
    , to_anchor: 1
    }
  , knot: {
      name: {
        singular: 'Knot'
      , plural: 'Knots'
      }
    , to_anchor: 1.150779
    }
  , 'ft/s': {
      name: {
        singular: 'Foot per second'
      , plural: 'Feet per second'
      }
    , to_anchor: 0.681818
      }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'km/h'
    , ratio: 1/1.609344
    }
  , imperial: {
      unit: 'm/h'
    , ratio: 1.609344
    }
  }
};


/***/ }),
/* 484 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  C: {
    name: {
      singular: 'degree Celsius'
    , plural: 'degrees Celsius'
    }
  , to_anchor: 1
  , anchor_shift: 0
  },
  K: {
    name: {
      singular: 'degree Kelvin'
    , plural: 'degrees Kelvin'
    }
  , to_anchor: 1
  , anchor_shift: 273.15
  }
};

imperial = {
  F: {
    name: {
      singular: 'degree Fahrenheit'
    , plural: 'degrees Fahrenheit'
    }
  , to_anchor: 1
  },
  R: {
    name: {
      singular: 'degree Rankine'
    , plural: 'degrees Rankine'
    }
  , to_anchor: 1
  , anchor_shift: 459.67
  }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'C'
    , transform: function (C) { return C / (5/9) + 32 }
    }
  , imperial: {
      unit: 'F'
    , transform: function (F) { return (F - 32) * (5/9) }
    }
  }
};



/***/ }),
/* 485 */
/***/ (function(module, exports) {

var time;
var daysInYear = 365.25;

time = {
  ns: {
    name: {
      singular: 'Nanosecond'
    , plural: 'Nanoseconds'
    }
  , to_anchor: 1/1000000000
  }
, mu: {
    name: {
      singular: 'Microsecond'
    , plural: 'Microseconds'
    }
  , to_anchor: 1/1000000
  }
, ms: {
    name: {
      singular: 'Millisecond'
    , plural: 'Milliseconds'
    }
  , to_anchor: 1/1000
  }
, s: {
    name: {
      singular: 'Second'
    , plural: 'Seconds'
    }
  , to_anchor: 1
  }
, min: {
    name: {
      singular: 'Minute'
    , plural: 'Minutes'
    }
  , to_anchor: 60
  }
, h: {
    name: {
      singular: 'Hour'
    , plural: 'Hours'
    }
  , to_anchor: 60 * 60 
  }
, d: {
    name: {
      singular: 'Day'
    , plural: 'Days'
    }
  , to_anchor: 60 * 60 * 24
  }
, week: {
    name: {
      singular: 'Week'
    , plural: 'Weeks'
    }
  , to_anchor: 60 * 60 * 24 * 7
  }
, month: {
    name: {
      singular: 'Month'
    , plural: 'Months'
    }
  , to_anchor: 60 * 60 * 24 * daysInYear / 12
  }
, year: {
    name: {
      singular: 'Year'
    , plural: 'Years'
    }
  , to_anchor: 60 * 60 * 24 * daysInYear
  }
};


module.exports = {
  metric: time 
, _anchors: {
    metric: {
      unit: 's'
    , ratio: 1
    }
  }
};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

var voltage;

voltage = {
  V: {
    name: {
      singular: 'Volt'
    , plural: 'Volts'
    }
  , to_anchor: 1
  }
, mV: {
    name: {
      singular: 'Millivolt'
      , plural: 'Millivolts'
    }
    , to_anchor: .001
  }
, kV: {
    name: {
      singular: 'Kilovolt'
    , plural: 'Kilovolts'
    }
  , to_anchor: 1000
  }
};

module.exports = {
  metric: voltage
, _anchors: {
    metric: {
      unit: 'V'
    , ratio: 1
    }
  }
};


/***/ }),
/* 487 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  mm3: {
      name: {
        singular: 'Cubic Millimeter'
      , plural: 'Cubic Millimeters'
      }
    , to_anchor: 1/1000000
  }
, cm3: {
    name: {
      singular: 'Cubic Centimeter'
    , plural: 'Cubic Centimeters'
    }
  , to_anchor: 1/1000
  }
, ml: {
    name: {
      singular: 'Millilitre'
    , plural: 'Millilitres'
    }
  , to_anchor: 1/1000
  }
, cl: {
    name: {
      singular: 'Centilitre'
    , plural: 'Centilitres'
    }
  , to_anchor: 1/100
  }
, dl: {
    name: {
      singular: 'Decilitre'
    , plural: 'Decilitres'
    }
  , to_anchor: 1/10
  }
, l: {
    name: {
      singular: 'Litre'
    , plural: 'Litres'
    }
  , to_anchor: 1
  }
, kl: {
    name: {
      singular: 'Kilolitre'
    , plural: 'Kilolitres'
    }
  , to_anchor: 1000
  }
, m3: {
    name: {
      singular: 'Cubic meter'
    , plural: 'Cubic meters'
    }
  , to_anchor: 1000
  }
, km3: {
    name: {
      singular: 'Cubic kilometer'
    , plural: 'Cubic kilometers'
    }
  , to_anchor: 1000000000000
  }

// Swedish units
, krm: {
  name: {
    singular: 'Matsked'
    , plural: 'Matskedar'
  }
  , to_anchor: 1/1000
}
, tsk: {
    name: {
      singular: 'Tesked'
    , plural: 'Teskedar'
    }
  , to_anchor: 5/1000
  }
, msk: {
    name: {
      singular: 'Matsked'
      , plural: 'Matskedar'
    }
    , to_anchor: 15/1000
  }
, kkp: {
    name: {
      singular: 'Kaffekopp'
      , plural: 'Kaffekoppar'
    }
    , to_anchor: 150/1000
  }
, glas: {
    name: {
      singular: 'Glas'
      , plural: 'Glas'
    }
    , to_anchor: 200/1000
  }
, kanna: {
    name: {
      singular: 'Kanna'
    , plural: 'Kannor'
    }
  , to_anchor: 2.617
  }
};

imperial = {
  tsp: {
    name: {
      singular: 'Teaspoon'
    , plural: 'Teaspoons'
    }
  , to_anchor: 1/6
  }
, Tbs: {
    name: {
      singular: 'Tablespoon'
    , plural: 'Tablespoons'
    }
  , to_anchor: 1/2
  }
, in3: {
    name: {
      singular: 'Cubic inch'
    , plural: 'Cubic inches'
    }
  , to_anchor: 0.55411
  }
, 'fl-oz': {
    name: {
      singular: 'Fluid Ounce'
    , plural: 'Fluid Ounces'
    }
  , to_anchor: 1
  }
, cup: {
    name: {
      singular: 'Cup'
    , plural: 'Cups'
    }
  , to_anchor: 8
  }
, pnt: {
    name: {
      singular: 'Pint'
    , plural: 'Pints'
    }
  , to_anchor: 16
  }
, qt: {
    name: {
      singular: 'Quart'
    , plural: 'Quarts'
    }
  , to_anchor: 32
  }
, gal: {
    name: {
      singular: 'Gallon'
    , plural: 'Gallons'
    }
  , to_anchor: 128
  }
, ft3: {
    name: {
      singular: 'Cubic foot'
    , plural: 'Cubic feet'
    }
  , to_anchor: 957.506
  }
, yd3: {
    name: {
      singular: 'Cubic yard'
    , plural: 'Cubic yards'
    }
  , to_anchor: 25852.7
  }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'l'
    , ratio: 33.8140226
    }
  , imperial: {
      unit: 'fl-oz'
    , ratio: 1/33.8140226
    }
  }
};


/***/ }),
/* 488 */
/***/ (function(module, exports) {

var metric
  , imperial;

metric = {
  'mm3/s': {
      name: {
        singular: 'Cubic Millimeter per second'
      , plural: 'Cubic Millimeters per second'
      }
    , to_anchor: 1/1000000
  }
, 'cm3/s': {
    name: {
      singular: 'Cubic Centimeter per second'
    , plural: 'Cubic Centimeters per second'
    }
  , to_anchor: 1/1000
  }
, 'ml/s': {
    name: {
      singular: 'Millilitre per second'
    , plural: 'Millilitres per second'
    }
  , to_anchor: 1/1000
  }
, 'cl/s': {
    name: {
      singular: 'Centilitre per second'
    , plural: 'Centilitres per second'
    }
  , to_anchor: 1/100
  }
, 'dl/s': {
    name: {
      singular: 'Decilitre per second'
    , plural: 'Decilitres per second'
    }
  , to_anchor: 1/10
  }
, 'l/s': {
    name: {
      singular: 'Litre per second'
    , plural: 'Litres per second'
    }
  , to_anchor: 1
  }
, 'l/min': {
    name: {
      singular: 'Litre per minute'
    , plural: 'Litres per minute'
    }
  , to_anchor: 1/60
  }
, 'l/h': {
    name: {
      singular: 'Litre per hour'
    , plural: 'Litres per hour'
    }
  , to_anchor: 1/3600
  }
, 'kl/s': {
    name: {
      singular: 'Kilolitre per second'
    , plural: 'Kilolitres per second'
    }
  , to_anchor: 1000
  }
, 'kl/min': {
    name: {
      singular: 'Kilolitre per minute'
    , plural: 'Kilolitres per minute'
    }
  , to_anchor: 50/3
  }
, 'kl/h': {
    name: {
      singular: 'Kilolitre per hour'
    , plural: 'Kilolitres per hour'
    }
  , to_anchor: 5/18
  }
, 'm3/s': {
    name: {
      singular: 'Cubic meter per second'
    , plural: 'Cubic meters per second'
    }
  , to_anchor: 1000
  }
, 'm3/min': {
    name: {
      singular: 'Cubic meter per minute'
    , plural: 'Cubic meters per minute'
    }
  , to_anchor: 50/3
  }
, 'm3/h': {
    name: {
      singular: 'Cubic meter per hour'
    , plural: 'Cubic meters per hour'
    }
  , to_anchor: 5/18
  }
, 'km3/s': {
    name: {
      singular: 'Cubic kilometer per second'
    , plural: 'Cubic kilometers per second'
    }
  , to_anchor: 1000000000000
  }
};

imperial = {
  'tsp/s': {
    name: {
      singular: 'Teaspoon per second'
    , plural: 'Teaspoons per second'
    }
  , to_anchor: 1/6
  }
, 'Tbs/s': {
    name: {
      singular: 'Tablespoon per second'
    , plural: 'Tablespoons per second'
    }
  , to_anchor: 1/2
  }
, 'in3/s': {
    name: {
      singular: 'Cubic inch per second'
    , plural: 'Cubic inches per second'
    }
  , to_anchor: 0.55411
  }
, 'in3/min': {
    name: {
      singular: 'Cubic inch per minute'
    , plural: 'Cubic inches per minute'
    }
  , to_anchor: 0.55411/60
  }
, 'in3/h': {
    name: {
      singular: 'Cubic inch per hour'
    , plural: 'Cubic inches per hour'
    }
  , to_anchor: 0.55411/3600
  }
, 'fl-oz/s': {
    name: {
      singular: 'Fluid Ounce per second'
    , plural: 'Fluid Ounces per second'
    }
  , to_anchor: 1
  }
, 'fl-oz/min': {
    name: {
      singular: 'Fluid Ounce per minute'
    , plural: 'Fluid Ounces per minute'
    }
  , to_anchor: 1/60
  }
, 'fl-oz/h': {
    name: {
      singular: 'Fluid Ounce per hour'
    , plural: 'Fluid Ounces per hour'
    }
  , to_anchor: 1/3600
  }
, 'cup/s': {
    name: {
      singular: 'Cup per second'
    , plural: 'Cups per second'
    }
  , to_anchor: 8
  }
, 'pnt/s': {
    name: {
      singular: 'Pint per second'
    , plural: 'Pints per second'
    }
  , to_anchor: 16
  }
, 'pnt/min': {
    name: {
      singular: 'Pint per minute'
    , plural: 'Pints per minute'
    }
  , to_anchor: 4/15
  }
, 'pnt/h': {
    name: {
      singular: 'Pint per hour'
    , plural: 'Pints per hour'
    }
  , to_anchor: 1/225
  }
, 'qt/s': {
    name: {
      singular: 'Quart per second'
    , plural: 'Quarts per second'
    }
  , to_anchor: 32
  }
, 'gal/s': {
    name: {
      singular: 'Gallon per second'
    , plural: 'Gallons per second'
    }
  , to_anchor: 128
  }
, 'gal/min': {
    name: {
      singular: 'Gallon per minute'
    , plural: 'Gallons per minute'
    }
  , to_anchor: 32/15
  }
, 'gal/h': {
    name: {
      singular: 'Gallon per hour'
    , plural: 'Gallons per hour'
    }
  , to_anchor: 8/225
  }
, 'ft3/s': {
    name: {
      singular: 'Cubic foot per second'
    , plural: 'Cubic feet per second'
    }
  , to_anchor: 957.506
  }
, 'ft3/min': {
    name: {
      singular: 'Cubic foot per minute'
    , plural: 'Cubic feet per minute'
    }
  , to_anchor: 957.506/60
  }
, 'ft3/h': {
    name: {
      singular: 'Cubic foot per hour'
    , plural: 'Cubic feet per hour'
    }
  , to_anchor: 957.506/3600
  }
, 'yd3/s': {
    name: {
      singular: 'Cubic yard per second'
    , plural: 'Cubic yards per second'
    }
  , to_anchor: 25852.7
  }
, 'yd3/min': {
    name: {
      singular: 'Cubic yard per minute'
    , plural: 'Cubic yards per minute'
    }
  , to_anchor: 25852.7/60
  }
, 'yd3/h': {
    name: {
      singular: 'Cubic yard per hour'
    , plural: 'Cubic yards per hour'
    }
  , to_anchor: 25852.7/3600
  }
};

module.exports = {
  metric: metric
, imperial: imperial
, _anchors: {
    metric: {
      unit: 'l/s'
    , ratio: 33.8140227
    }
  , imperial: {
      unit: 'fl-oz/s'
    , ratio: 1/33.8140227
    }
  }
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var emptyObject = __webpack_require__(70);
var _invariant = __webpack_require__(6);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(208);
var isArguments = __webpack_require__(521);
var is = __webpack_require__(635);
var isRegex = __webpack_require__(523);
var flags = __webpack_require__(759);
var isDate = __webpack_require__(522);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(178)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(177);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(496);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(506);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(6);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(22);

var createArrayFromMixed = __webpack_require__(499);
var getMarkupWrap = __webpack_require__(501);
var invariant = __webpack_require__(6);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(22);

var invariant = __webpack_require__(6);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(503);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(505);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/airQualityIndex.f8a0188f.svg";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ozone.5f25bdd1.svg";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pm10_v2.c2bdc9be.svg";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pm2.5_v2.693c4662.svg";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/radiation.702c3a9b.svg";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(47);

var _PathUtils = __webpack_require__(42);

var _ExecutionEnvironment = __webpack_require__(71);

var _DOMUtils = __webpack_require__(100);

var _DOMStateStorage = __webpack_require__(179);

var _createDOMHistory = __webpack_require__(180);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(47);

var _PathUtils = __webpack_require__(42);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(30);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(42);

var _Actions = __webpack_require__(47);

var _createHistory = __webpack_require__(182);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(129);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(178)();
var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
var hasOwnProperty;
var regexExec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	regexExec = Function.call.bind(RegExp.prototype.exec);
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var toStr = Object.prototype.toString;
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			regexExec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return toStr.call(value) === regexClass;
	};


/***/ }),
/* 524 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(529);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41)))

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(530);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(184);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(526);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreate = __webpack_require__(186),
    isObject = __webpack_require__(73),
    setBindData = __webpack_require__(104);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * The base implementation of `_.bind` that creates the bound function and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new bound function.
 */
function baseBind(bindData) {
  var func = bindData[0],
      partialArgs = bindData[2],
      thisArg = bindData[4];

  function bound() {
    // `Function#bind` spec
    // http://es5.github.io/#x15.3.4.5
    if (partialArgs) {
      var args = partialArgs.slice();
      push.apply(args, arguments);
    }
    // mimic the constructor's `return` behavior
    // http://es5.github.io/#x13.2.2
    if (this instanceof bound) {
      // ensure `new bound` is an instance of `func`
      var thisBinding = baseCreate(func.prototype),
          result = func.apply(thisBinding, args || arguments);
      return isObject(result) ? result : thisBinding;
    }
    return func.apply(thisArg, args || arguments);
  }
  setBindData(bound, bindData);
  return bound;
}

module.exports = baseBind;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreate = __webpack_require__(186),
    isObject = __webpack_require__(73),
    setBindData = __webpack_require__(104),
    slice = __webpack_require__(188);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * The base implementation of `createWrapper` that creates the wrapper and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new function.
 */
function baseCreateWrapper(bindData) {
  var func = bindData[0],
      bitmask = bindData[1],
      partialArgs = bindData[2],
      partialRightArgs = bindData[3],
      thisArg = bindData[4],
      arity = bindData[5];

  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isCurryBound = bitmask & 8,
      key = func;

  function bound() {
    var thisBinding = isBind ? thisArg : this;
    if (partialArgs) {
      var args = partialArgs.slice();
      push.apply(args, arguments);
    }
    if (partialRightArgs || isCurry) {
      args || (args = slice(arguments));
      if (partialRightArgs) {
        push.apply(args, partialRightArgs);
      }
      if (isCurry && args.length < arity) {
        bitmask |= 16 & ~32;
        return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
      }
    }
    args || (args = arguments);
    if (isBindKey) {
      func = thisBinding[key];
    }
    if (this instanceof bound) {
      thisBinding = baseCreate(func.prototype);
      var result = func.apply(thisBinding, args);
      return isObject(result) ? result : thisBinding;
    }
    return func.apply(thisBinding, args);
  }
  setBindData(bound, bindData);
  return bound;
}

module.exports = baseCreateWrapper;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseBind = __webpack_require__(533),
    baseCreateWrapper = __webpack_require__(534),
    isFunction = __webpack_require__(541);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * Creates a function that, when called, either curries or invokes `func`
 * with an optional `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of method flags to compose.
 *  The bitmask may be composed of the following flags:
 *  1 - `_.bind`
 *  2 - `_.bindKey`
 *  4 - `_.curry`
 *  8 - `_.curry` (bound)
 *  16 - `_.partial`
 *  32 - `_.partialRight`
 * @param {Array} [partialArgs] An array of arguments to prepend to those
 *  provided to the new function.
 * @param {Array} [partialRightArgs] An array of arguments to append to those
 *  provided to the new function.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new function.
 */
function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isCurryBound = bitmask & 8,
      isPartial = bitmask & 16,
      isPartialRight = bitmask & 32;

  if (!isBindKey && !isFunction(func)) {
    throw new TypeError;
  }
  if (isPartial && !partialArgs.length) {
    bitmask &= ~16;
    isPartial = partialArgs = false;
  }
  if (isPartialRight && !partialRightArgs.length) {
    bitmask &= ~32;
    isPartialRight = partialRightArgs = false;
  }
  var bindData = func && func.__bindData__;
  if (bindData && bindData !== true) {
    bindData = bindData.slice();

    // set `thisBinding` is not previously bound
    if (isBind && !(bindData[1] & 1)) {
      bindData[4] = thisArg;
    }
    // set if previously bound but not currently (subsequent curried functions)
    if (!isBind && bindData[1] & 1) {
      bitmask |= 8;
    }
    // set curried arity if not yet set
    if (isCurry && !(bindData[1] & 4)) {
      bindData[5] = arity;
    }
    // append partial left arguments
    if (isPartial) {
      push.apply(bindData[2] || (bindData[2] = []), partialArgs);
    }
    // append partial right arguments
    if (isPartialRight) {
      push.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
    }
    // merge flags
    bindData[1] |= bitmask;
    return createWrapper.apply(null, bindData);
  }
  // fast path for `_.bind`
  var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
  return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
}

module.exports = createWrapper;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(103);

/** Used for native method references */
var objectProto = Object.prototype;

/** Native method shortcuts */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which produces an array of the
 * given object's own enumerable property names.
 *
 * @private
 * @type Function
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 */
var shimKeys = function(object) {
  var index, iterable = object, result = [];
  if (!iterable) return result;
  if (!(objectTypes[typeof object])) return result;
    for (index in iterable) {
      if (hasOwnProperty.call(iterable, index)) {
        result.push(index);
      }
    }
  return result
};

module.exports = shimKeys;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var createWrapper = __webpack_require__(535),
    reNative = __webpack_require__(58),
    slice = __webpack_require__(188);

/**
 * Creates a function that, when called, invokes `func` with the `this`
 * binding of `thisArg` and prepends any additional `bind` arguments to those
 * provided to the bound function.
 *
 * @static
 * @memberOf _
 * @category Functions
 * @param {Function} func The function to bind.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {...*} [arg] Arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var func = function(greeting) {
 *   return greeting + ' ' + this.name;
 * };
 *
 * func = _.bind(func, { 'name': 'fred' }, 'hi');
 * func();
 * // => 'hi fred'
 */
function bind(func, thisArg) {
  return arguments.length > 2
    ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
    : createWrapper(func, 1, null, null, thisArg);
}

module.exports = bind;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreateCallback = __webpack_require__(187),
    forOwn = __webpack_require__(539);

/**
 * Iterates over elements of a collection, executing the callback for each
 * element. The callback is bound to `thisArg` and invoked with three arguments;
 * (value, index|key, collection). Callbacks may exit iteration early by
 * explicitly returning `false`.
 *
 * Note: As with other "Collections" methods, objects with a `length` property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collections
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [callback=identity] The function called per iteration.
 * @param {*} [thisArg] The `this` binding of `callback`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
 * // => logs each number and returns '1,2,3'
 *
 * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
 * // => logs each number and returns the object (property order is not guaranteed across environments)
 */
function forEach(collection, callback, thisArg) {
  var index = -1,
      length = collection ? collection.length : 0;

  callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
  if (typeof length == 'number') {
    while (++index < length) {
      if (callback(collection[index], index, collection) === false) {
        break;
      }
    }
  } else {
    forOwn(collection, callback);
  }
  return collection;
}

module.exports = forEach;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreateCallback = __webpack_require__(187),
    keys = __webpack_require__(189),
    objectTypes = __webpack_require__(103);

/**
 * Iterates over own enumerable properties of an object, executing the callback
 * for each property. The callback is bound to `thisArg` and invoked with three
 * arguments; (value, key, object). Callbacks may exit iteration early by
 * explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Objects
 * @param {Object} object The object to iterate over.
 * @param {Function} [callback=identity] The function called per iteration.
 * @param {*} [thisArg] The `this` binding of `callback`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
 *   console.log(key);
 * });
 * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
 */
var forOwn = function(collection, callback, thisArg) {
  var index, iterable = collection, result = iterable;
  if (!iterable) return result;
  if (!objectTypes[typeof iterable]) return result;
  callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
    var ownIndex = -1,
        ownProps = objectTypes[typeof iterable] && keys(iterable),
        length = ownProps ? ownProps.length : 0;

    while (++ownIndex < length) {
      index = ownProps[ownIndex];
      if (callback(iterable[index], index, collection) === false) return result;
    }
  return result
};

module.exports = forOwn;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Checks if `value` is a function.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 */
function isFunction(value) {
  return typeof value == 'function';
}

module.exports = isFunction;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var reNative = __webpack_require__(58);

/** Used to detect functions containing a `this` reference */
var reThis = /\bthis\b/;

/**
 * An object used to flag environments features.
 *
 * @static
 * @memberOf _
 * @type Object
 */
var support = {};

/**
 * Detect if functions can be decompiled by `Function#toString`
 * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
 *
 * @memberOf _.support
 * @type boolean
 */
support.funcDecomp = !reNative.test(global.WinRTError) && reThis.test(function() { return this; });

/**
 * Detect if `Function#name` is supported (all but IE).
 *
 * @memberOf _.support
 * @type boolean
 */
support.funcNames = typeof Function.name == 'string';

module.exports = support;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(35);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(592),
    hashDelete = __webpack_require__(593),
    hashGet = __webpack_require__(594),
    hashHas = __webpack_require__(595),
    hashSet = __webpack_require__(596);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(35);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(35);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(106),
    setCacheAdd = __webpack_require__(616),
    setCacheHas = __webpack_require__(617);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(35);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(35);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(574),
    isArguments = __webpack_require__(201),
    isArray = __webpack_require__(36),
    isBuffer = __webpack_require__(203),
    isIndex = __webpack_require__(196),
    isTypedArray = __webpack_require__(205);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(558);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(582);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(560),
    createBaseEach = __webpack_require__(580);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(581);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(559),
    keys = __webpack_require__(112);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(554),
    isArray = __webpack_require__(36);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(191),
    equalArrays = __webpack_require__(194),
    equalByTag = __webpack_require__(583),
    equalObjects = __webpack_require__(584),
    getTag = __webpack_require__(589),
    isArray = __webpack_require__(36),
    isBuffer = __webpack_require__(203),
    isTypedArray = __webpack_require__(205);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(191),
    baseIsEqual = __webpack_require__(107);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(204),
    isMasked = __webpack_require__(598),
    isObject = __webpack_require__(110),
    toSource = __webpack_require__(199);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isLength = __webpack_require__(109),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(570),
    baseMatchesProperty = __webpack_require__(571),
    identity = __webpack_require__(627),
    isArray = __webpack_require__(36),
    property = __webpack_require__(631);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(599),
    nativeKeys = __webpack_require__(612);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(565),
    getMatchData = __webpack_require__(586),
    matchesStrictComparable = __webpack_require__(198);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(107),
    get = __webpack_require__(625),
    hasIn = __webpack_require__(626),
    isKey = __webpack_require__(108),
    isStrictComparable = __webpack_require__(197),
    matchesStrictComparable = __webpack_require__(198),
    toKey = __webpack_require__(79);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(192);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(75),
    arrayMap = __webpack_require__(553),
    isArray = __webpack_require__(36),
    isSymbol = __webpack_require__(111);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(35);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(550),
    baseAggregator = __webpack_require__(556),
    baseIteratee = __webpack_require__(568),
    isArray = __webpack_require__(36);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(202);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(75),
    Uint8Array = __webpack_require__(548),
    eq = __webpack_require__(200),
    equalArrays = __webpack_require__(194),
    mapToArray = __webpack_require__(610),
    setToArray = __webpack_require__(618);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(585);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(561),
    getSymbols = __webpack_require__(588),
    keys = __webpack_require__(112);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(197),
    keys = __webpack_require__(112);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(75);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(551),
    stubArray = __webpack_require__(632);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(543),
    Map = __webpack_require__(105),
    Promise = __webpack_require__(545),
    Set = __webpack_require__(546),
    WeakMap = __webpack_require__(549),
    baseGetTag = __webpack_require__(59),
    toSource = __webpack_require__(199);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 590 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(193),
    isArguments = __webpack_require__(201),
    isArray = __webpack_require__(36),
    isIndex = __webpack_require__(196),
    isLength = __webpack_require__(109),
    toKey = __webpack_require__(79);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 597 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(578);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(76);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(76);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(76);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(76);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(544),
    ListCache = __webpack_require__(74),
    Map = __webpack_require__(105);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 610 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(630);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(615);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(195);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)(module)))

/***/ }),
/* 614 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 615 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 616 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(74);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(74),
    Map = __webpack_require__(105),
    MapCache = __webpack_require__(106);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(611);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(192);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(562),
    hasPath = __webpack_require__(591);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 627 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(107);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(557),
    createAggregator = __webpack_require__(579);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(106);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(572),
    basePropertyDeep = __webpack_require__(573),
    isKey = __webpack_require__(108),
    toKey = __webpack_require__(79);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(575);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(57);
var callBind = __webpack_require__(172);

var implementation = __webpack_require__(206);
var getPolyfill = __webpack_require__(207);
var shim = __webpack_require__(636);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(207);
var define = __webpack_require__(57);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(209); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(211);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(129);
var assign = __webpack_require__(12);

var ReactPropTypesSecret = __webpack_require__(211);
var checkPropTypes = __webpack_require__(638);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(761);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(464);

var ratio = 0.618033988749895;
var hue   = Math.random();

module.exports = function (saturation, value) {

  hue += ratio;
  hue %= 1;

  if (typeof saturation !== 'number') {
    saturation = 0.5;
  }

  if (typeof value !== 'number') {
    value = 0.95;
  }

  return color({
    h: hue * 360,
    s: saturation * 100,
    v: value * 100
  });
};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(657);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(13);

var focusNode = __webpack_require__(174);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(22);
var FallbackCompositionState = __webpack_require__(652);
var SyntheticCompositionEvent = __webpack_require__(689);
var SyntheticInputEvent = __webpack_require__(692);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(213);
var ExecutionEnvironment = __webpack_require__(22);
var ReactInstrumentation = __webpack_require__(26);

var camelizeStyleName = __webpack_require__(497);
var dangerousStyleValue = __webpack_require__(698);
var hyphenateStyleName = __webpack_require__(504);
var memoizeStringOnly = __webpack_require__(507);
var warning = __webpack_require__(10);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(61);
var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(31);
var SyntheticEvent = __webpack_require__(37);

var inputValueTracking = __webpack_require__(229);
var getEventTarget = __webpack_require__(125);
var isEventSupported = __webpack_require__(126);
var isTextInputElement = __webpack_require__(231);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(48);
var ExecutionEnvironment = __webpack_require__(22);

var createNodesFromMarkup = __webpack_require__(500);
var emptyFunction = __webpack_require__(29);
var invariant = __webpack_require__(6);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(13);
var SyntheticMouseEvent = __webpack_require__(82);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(44);

var getTextContentAccessor = __webpack_require__(228);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(49);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(50);

var instantiateReactComponent = __webpack_require__(230);
var KeyEscapeUtils = __webpack_require__(117);
var shouldUpdateReactComponent = __webpack_require__(127);
var traverseAllChildren = __webpack_require__(233);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(247);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(113);
var ReactDOMIDOperations = __webpack_require__(662);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var React = __webpack_require__(52);
var ReactComponentEnvironment = __webpack_require__(119);
var ReactCurrentOwner = __webpack_require__(38);
var ReactErrorUtils = __webpack_require__(120);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(26);
var ReactNodeTypes = __webpack_require__(223);
var ReactReconciler = __webpack_require__(50);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(6);
var shallowEqual = __webpack_require__(99);
var shouldUpdateReactComponent = __webpack_require__(127);
var warning = __webpack_require__(10);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(13);
var ReactDefaultInjection = __webpack_require__(670);
var ReactMount = __webpack_require__(222);
var ReactReconciler = __webpack_require__(50);
var ReactUpdates = __webpack_require__(31);
var ReactVersion = __webpack_require__(683);

var findDOMNode = __webpack_require__(699);
var getHostComponentFromComposite = __webpack_require__(227);
var renderSubtreeIntoContainer = __webpack_require__(706);
var warning = __webpack_require__(10);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var AutoFocusUtils = __webpack_require__(645);
var CSSPropertyOperations = __webpack_require__(647);
var DOMLazyTree = __webpack_require__(48);
var DOMNamespaces = __webpack_require__(114);
var DOMProperty = __webpack_require__(49);
var DOMPropertyOperations = __webpack_require__(215);
var EventPluginHub = __webpack_require__(61);
var EventPluginRegistry = __webpack_require__(115);
var ReactBrowserEventEmitter = __webpack_require__(81);
var ReactDOMComponentFlags = __webpack_require__(216);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMInput = __webpack_require__(663);
var ReactDOMOption = __webpack_require__(664);
var ReactDOMSelect = __webpack_require__(217);
var ReactDOMTextarea = __webpack_require__(667);
var ReactInstrumentation = __webpack_require__(26);
var ReactMultiChild = __webpack_require__(676);
var ReactServerRenderingTransaction = __webpack_require__(681);

var emptyFunction = __webpack_require__(29);
var escapeTextContentForBrowser = __webpack_require__(84);
var invariant = __webpack_require__(6);
var isEventSupported = __webpack_require__(126);
var shallowEqual = __webpack_require__(99);
var inputValueTracking = __webpack_require__(229);
var validateDOMNesting = __webpack_require__(128);
var warning = __webpack_require__(10);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(128);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var DOMLazyTree = __webpack_require__(48);
var ReactDOMComponentTree = __webpack_require__(13);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(113);
var ReactDOMComponentTree = __webpack_require__(13);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var DOMPropertyOperations = __webpack_require__(215);
var LinkedValueUtils = __webpack_require__(118);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(31);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var React = __webpack_require__(52);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMSelect = __webpack_require__(217);

var warning = __webpack_require__(10);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var getNodeForCharacterOffset = __webpack_require__(703);
var getTextContentAccessor = __webpack_require__(228);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var DOMChildrenOperations = __webpack_require__(113);
var DOMLazyTree = __webpack_require__(48);
var ReactDOMComponentTree = __webpack_require__(13);

var escapeTextContentForBrowser = __webpack_require__(84);
var invariant = __webpack_require__(6);
var validateDOMNesting = __webpack_require__(128);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(12);

var LinkedValueUtils = __webpack_require__(118);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(31);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var ReactUpdates = __webpack_require__(31);
var Transaction = __webpack_require__(83);

var emptyFunction = __webpack_require__(29);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(644);
var BeforeInputEventPlugin = __webpack_require__(646);
var ChangeEventPlugin = __webpack_require__(648);
var DefaultEventPluginOrder = __webpack_require__(650);
var EnterLeaveEventPlugin = __webpack_require__(651);
var HTMLDOMPropertyConfig = __webpack_require__(653);
var ReactComponentBrowserEnvironment = __webpack_require__(655);
var ReactDOMComponent = __webpack_require__(658);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMEmptyComponent = __webpack_require__(660);
var ReactDOMTreeTraversal = __webpack_require__(668);
var ReactDOMTextComponent = __webpack_require__(666);
var ReactDefaultBatchingStrategy = __webpack_require__(669);
var ReactEventListener = __webpack_require__(673);
var ReactInjection = __webpack_require__(674);
var ReactReconcileTransaction = __webpack_require__(679);
var SVGDOMPropertyConfig = __webpack_require__(684);
var SelectEventPlugin = __webpack_require__(685);
var SimpleEventPlugin = __webpack_require__(686);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(61);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var EventListener = __webpack_require__(173);
var ExecutionEnvironment = __webpack_require__(22);
var PooledClass = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(31);

var getEventTarget = __webpack_require__(125);
var getUnboundedScrollPosition = __webpack_require__(502);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(49);
var EventPluginHub = __webpack_require__(61);
var EventPluginUtils = __webpack_require__(116);
var ReactComponentEnvironment = __webpack_require__(119);
var ReactEmptyComponent = __webpack_require__(218);
var ReactBrowserEventEmitter = __webpack_require__(81);
var ReactHostComponent = __webpack_require__(220);
var ReactUpdates = __webpack_require__(31);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(697);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactComponentEnvironment = __webpack_require__(119);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(26);

var ReactCurrentOwner = __webpack_require__(38);
var ReactReconciler = __webpack_require__(50);
var ReactChildReconciler = __webpack_require__(654);

var emptyFunction = __webpack_require__(29);
var flattenChildren = __webpack_require__(700);
var invariant = __webpack_require__(6);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(6);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var CallbackQueue = __webpack_require__(214);
var PooledClass = __webpack_require__(44);
var ReactBrowserEventEmitter = __webpack_require__(81);
var ReactInputSelection = __webpack_require__(221);
var ReactInstrumentation = __webpack_require__(26);
var Transaction = __webpack_require__(83);
var ReactUpdateQueue = __webpack_require__(121);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(677);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(44);
var Transaction = __webpack_require__(83);
var ReactInstrumentation = __webpack_require__(26);
var ReactServerUpdateQueue = __webpack_require__(682);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(121);

var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInputSelection = __webpack_require__(221);
var SyntheticEvent = __webpack_require__(37);

var getActiveElement = __webpack_require__(175);
var isTextInputElement = __webpack_require__(231);
var shallowEqual = __webpack_require__(99);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var EventListener = __webpack_require__(173);
var EventPropagators = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(13);
var SyntheticAnimationEvent = __webpack_require__(687);
var SyntheticClipboardEvent = __webpack_require__(688);
var SyntheticEvent = __webpack_require__(37);
var SyntheticFocusEvent = __webpack_require__(691);
var SyntheticKeyboardEvent = __webpack_require__(693);
var SyntheticMouseEvent = __webpack_require__(82);
var SyntheticDragEvent = __webpack_require__(690);
var SyntheticTouchEvent = __webpack_require__(694);
var SyntheticTransitionEvent = __webpack_require__(695);
var SyntheticUIEvent = __webpack_require__(64);
var SyntheticWheelEvent = __webpack_require__(696);

var emptyFunction = __webpack_require__(29);
var getEventCharCode = __webpack_require__(123);
var invariant = __webpack_require__(6);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(82);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventCharCode = __webpack_require__(123);
var getEventKey = __webpack_require__(701);
var getEventModifierState = __webpack_require__(124);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventModifierState = __webpack_require__(124);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(37);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(82);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(213);
var warning = __webpack_require__(10);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstanceMap = __webpack_require__(63);

var getHostComponentFromComposite = __webpack_require__(227);
var invariant = __webpack_require__(6);
var warning = __webpack_require__(10);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(117);
var traverseAllChildren = __webpack_require__(233);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(247);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(123);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(84);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(222);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(130);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(713);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(235);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(235);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(237);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(714);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(130);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _InternalPropTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: _InternalPropTypes.history
  },

  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

exports.default = History;
module.exports = exports['default'];

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(238);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = _react2.default.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(239);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = _react2.default.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(40);

var _InternalPropTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react2.default.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = _react2.default.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: _InternalPropTypes.falsy,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

exports.default = Lifecycle;
module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(40);

var _InternalPropTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

exports.default = RouteContext;
module.exports = exports['default'];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHashHistory = __webpack_require__(181);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _useQueries = __webpack_require__(72);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _InternalPropTypes = __webpack_require__(45);

var _RouterContext = __webpack_require__(86);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(40);

var _RouterUtils = __webpack_require__(240);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var _React$PropTypes = _react2.default.PropTypes;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // Deprecated:
    parseQueryString: func,
    stringifyQuery: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _props = this.props;
    var parseQueryString = _props.parseQueryString;
    var stringifyQuery = _props.stringifyQuery;

     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects();

    var history = _createRouterObjects.history;
    var transitionManager = _createRouterObjects.transitionManager;
    var router = _createRouterObjects.router;


    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        _this.setState(state, _this.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  },
  createRouterObjects: function createRouterObjects() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext;
    }

    var history = this.props.history;
    var _props2 = this.props;
    var routes = _props2.routes;
    var children = _props2.children;


    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;

    if (isDeprecatedHistory(history)) {
      history = this.wrapDeprecatedHistory(history);
    }

    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

    return { history: routingHistory, transitionManager: transitionManager, router: router };
  },
  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
    var _props3 = this.props;
    var parseQueryString = _props3.parseQueryString;
    var stringifyQuery = _props3.stringifyQuery;


    var createHistory = void 0;
    if (history) {
       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
      createHistory = function createHistory() {
        return history;
      };
    } else {
       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
      createHistory = _createHashHistory2.default;
    }

    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state;
    var location = _state.location;
    var routes = _state.routes;
    var params = _state.params;
    var components = _state.components;
    var _props4 = this.props;
    var createElement = _props4.createElement;
    var render = _props4.render;

    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(86);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutingContext = _react2.default.createClass({
  displayName: 'RoutingContext',
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  },
  render: function render() {
    return _react2.default.createElement(_RouterContext2.default, this.props);
  }
});

exports.default = RoutingContext;
module.exports = exports['default'];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(131);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(86);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  var withContext = middlewares.map(function (m) {
    return m.renderRouterContext;
  }).filter(function (f) {
    return f;
  });
  var withComponent = middlewares.map(function (m) {
    return m.renderRouteComponent;
  }).filter(function (f) {
    return f;
  });
  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(516);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(242);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(51);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(131);

var _makeStateWithLocation = __webpack_require__(243);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(51);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(181);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(242);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(51);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname;
  var query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(241);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(40);

var _RouterUtils = __webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history;
  var routes = _ref.routes;
  var location = _ref.location;

  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation, nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(131);

var _makeStateWithLocation = __webpack_require__(243);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

var _PatternUtils = __webpack_require__(51);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useQueries = __webpack_require__(72);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _routerWarning = __webpack_require__(18);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var routes = _ref.routes;

    var options = _objectWithoutProperties(_ref, ['routes']);

    var history = (0, _useQueries2.default)(createHistory)(options);
    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
    return _extends({}, history, transitionManager);
  };
}

exports.default = useRoutes;
module.exports = exports['default'];

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(739);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent) {
  var WithRouter = _react2.default.createClass({
    displayName: 'WithRouter',

    contextTypes: { router: _PropTypes.routerShape },
    render: function render() {
      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { router: this.context.router }));
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(245);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(245);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(65);

var invariant = __webpack_require__(6);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(744);
var ReactElement = __webpack_require__(53);

var emptyFunction = __webpack_require__(29);
var traverseAllChildren = __webpack_require__(754);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(53);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(53),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(210);

module.exports = factory(isValidElement);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(246),
    Component = _require.Component;

var _require2 = __webpack_require__(53),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(249);
var factory = __webpack_require__(489);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(65);

var ReactElement = __webpack_require__(53);

var invariant = __webpack_require__(6);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(65);

var ReactCurrentOwner = __webpack_require__(38);
var REACT_ELEMENT_TYPE = __webpack_require__(248);

var getIteratorFn = __webpack_require__(750);
var invariant = __webpack_require__(6);
var KeyEscapeUtils = __webpack_require__(743);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(251);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(253);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(57);
var callBind = __webpack_require__(172);

var implementation = __webpack_require__(254);
var getPolyfill = __webpack_require__(255);
var shim = __webpack_require__(760);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(57).supportsDescriptors;
var getPolyfill = __webpack_require__(255);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(763);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41), __webpack_require__(778)(module)))

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kauSatelliteMap_final.aef2c7c7.jpg";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/keaauMap_final.db23daad.jpg";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/macOrchard.32e2f209.jpg";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACWCAYAAACb3McZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2lpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo1MjhjYzdhOC02ZWIwLTQ1NGEtOThiZi0zOWYxM2IxOTcyNTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjNEMkI5MzhGNzg3MTFFNUFENzA4OTA2RjIwMzQ1NEIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjNEMkI5MzdGNzg3MTFFNUFENzA4OTA2RjIwMzQ1NEIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjcxRDVDNjRBRjc3NDExRTVCMTgyQkE2QkFBQ0E4Q0Q4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjcxRDVDNjRCRjc3NDExRTVCMTgyQkE2QkFBQ0E4Q0Q4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+KoHojAAAGgtJREFUeNrsXQe4VcW1XlcQuSAgKgKSRxFEVIyUo4LoCyi2JA8LEokxKIkglmdiQcyLJvj8YuzRWF+MPQLPWFA0NkKuDVBvKDaaXECawJMmRerN/Ox13j0czp7Ze8/semZ93/oO3H3O3rNn5p9ZfSpqa2vJkiVLpanCAsSSJQsQS5YsQCxZsgCxZMkCxJKlDAEkl8uZblel4JaCDxR8gOD9BDcT3FRwC/5sJHhf/mwgeB/BewveS3B9/iymHYJ3Ct4meKvg7YK/FbyJP8GbBa8T/DX//Rtm/G11wecmO32yQdXV1a7X6sfUJkzegwV3FHyI4PaC2wpuI7gV8/6C6yWwP7cVAOhrBgs+VwpeJniF4K8EL+d/r7FTML0UFUAAgH6CjxR8GH9+h1f8tNHevLMd6OG73zBQwEuYFwn+suBzfcTt78aL0wwGtKWYATJS8O8TuhuETU2YO7tcx060kLlG8DzmuQwekzRI8FWCe/P/IUreJvgmC4P4AHKW4NttN7sS9KqjmQsJutFUwdcK/kDzGdDNxvFYFOt5owWvEvygHQp3XSBMusZ2ceCF6wTBUwR30TR2TCkBjkL6leCGtsvjAchBtou1qELwjRq/nyC4u+I7sBY2tV0dD0A+sl2sTX0C/u4KwSd7+B50n9W2m+MByK/JseRYCk7tBHfy+Zt9WQH3QjewzmMpBoDAlHmc4PEMlAWCJ5LjkLPknXr5/P5QchyoMvpc8HmCn7PdGx9AQLMEny3433glHE7lafLVoeN8fn+w4vpd5PiinrVdK6coPenrCmRqmYNwK3OYINrKYojbMxCOson7pyKCvsGO2szQDgLDyDGS6++SYz62lDCA5Kmb5NpiwSeS411uEGIbNgh+WPAFLtcnCf4ROT6EsHfZWn5f6AyXu3wHfhJ47v/Pw/2OUixAd9tpn2yAdJZc+4L1lihorQJAUcdQvSwBCCY8POATPNynpeQalPEP7bRPlg5S/LwjJNdnR9gWmXOsQQxjMYPk1iSvYta+kmurKPrYLwsQH9SWOQkASRohGnimAUW9QrGDWEowQA5RyMezynw8pkquIemm0qNOIxvvCjvtkwuQwyXXkGcxxwLElZoxSCxlGCAy/QNOxGUWIFLqZadstgFymORajZWRd1nxvjCgh1hKIUBgUpaFbn9uh2MXfaAAiNUhMgoQ5J+3llyfbYdDCRCkKXe1XZRdgMieN8sOhxIgVg/JMEBkCjo81/PscOyi6SQPKeltuyibAJGZeGHBWmmHYxfB3C2zZh1juyibAJFZsGC5sSUe60gGkHzJJEsZAkhjkluwPrND4VkPqbB6SPYAAgX9AMn1OXYodiPk8n9r9ZDyAcihiuvWgrU7Ibnsn5Lr1mGYMYDILFirSe49LleaIrnWk5yC3pYyAhCZ/lFDdem4lrzpIchlsdasMgHIXDsMvgFi9ZAMAaS5QgexFqzStFjRN1YPyQhAUOqnid1BApEqgaq+7aL0A0RlwbJRvMEUdZT36WG7KP0AOVJyDQfLLLDD4EqqCiRWD8kAQGRlfmDB2myHwZU+JedUKjeyHvUMAETmA7EedDnVKnYRm6OecoAgQaqj1T9C00M6edDxLCUYIBjAfewOokWqQg5WD0kxQGQh7igQbWOw1ISYrPVWD8kmQGT501+S+ZNcs0ibFXrIsbaL0guQDpJrk8nJnrOkJlnYyXeLxnGt4l47bXd6J5Oe2BbklOlH7V2cboTEHlk4RCvBl1I43mBMmC3kFKLL15ramlFFHaVcRwuuIqci/VGS76Lu2EY77SMESC6XO4kn+g/IW+3YPJ3EHAUt41UYCi/O/qj2sNImiZBAtYPcD/y5kbydhotF7CFynLMoDLGigL+yO/qeVFFbW6sDjjsonacVfcS7nJuX/28M+KS1OSy/x3YGyXJeTOCcXMRAwudivpZJqq6uNr+DCHBgJRqR0j5JYy7FuyECBPOgDXMp2spAqWHQzGGxdT5/ZnbnqR8QHP1TDA4vlMSjq5fG+GwcKHQolXZKol2IyIbJ/jNm/Htl2QKEnPPPs0w5NjB8kKA2NUhoX+V3nn4Ff4NpGqVkpwn+hD8/phRmjvoGiNg9YLrtG5IcvIDqzilcwoojOhWWF1T52MkTBZYblBLCmRmwhuGI6ba8wrUn/RNyO7JC/xQvBkuSoC+maF7BWNOdOU8YR5yg9U/Wp96nFPjBguwgFxt69kaWq+EPmc6dt9jAJAJYuvHgnEBOKEbjgPcbIvgscixEfyRLOoTF7N+ZQbDKIRbvHXIcoVVJBIwvK5bYPfZiK0fLgM+DXIrTXN8kx9z6dQTviOOTTxZ8muAfkmPqDKok/4LBHAf9l+DfZRhAO3h3qeK58Q5FlAohs2L5BcjZ4uOFAG14XfAz/NtNMQ4CdpJzyDkf/dSA97hS8H0WIKETFtOJgv8u+I0wjRQygPgNNbnCx3ehLzzKCu8Zgv8SMzjyYt3TvJvA1Ps4+a8JDFHrJZIft2xJn5BSfD7PoQW8yF7OInRk5BkgYvfACbVePd9/IqfUz8UkrxAYJ2HZ+Bk5Vecf8fnbAaxoftfO40hob17U7ifHF/MiSwGJUtK9KOfjyYkLmqm5cnTglaIF6zv7k2O9qseyKhxXq8gJl4ClawnVhU/4JTi9hgt+QPBNgs/0+LsuDJJBrFdZqqNtJD/uG7SdghmJ6rPh5Cwet5MpREelJx1E7B4VPBEPcvkKDr+5WvArAdqAcI++5JTTRJUO5LBXBrjPRp7s03nivk3BjnXD7nA3yTMhSy0ej1od5P/b+SSL1diZi83TWMQuIscvMpp3cR26U/DIWJV0AZDLeIUtRQ8Lvork1ciL6XjBA1lRDvPMvRms4GFL9uP0Q5zWPYKH+fjNLwXfW+YAeavI+PGY4KGKfoLPq63GM6Hr4uSAtWEAxKsOUiqtE6HVA8TNL/UIjv1Yyc87ia6m8A+khD9kFDlOv8k84b34RDbx9j3AR8cDUL8oc9GqYdH/H/TwnScM6NHnxa2kD2OLwgz+P8SYnADHBA+/PVjwbeR4yGEejasSR282HsxjXcOLP2QCt3eqD5D8vIwBcmLRYlpNe/qNinOAABDd08VOixUgAgjfCh4rGN5p+EL6iH/XKH5WyTIm9ILrSH6ATpSESiu/Yf1klAdFcT4P+tMe7/9nlr/LlYoXiGILYTvaPZVgAYvBuovf3rEBpAgs4wWrPJyw7KDo2W8puf4CWMZuZWVxgIfvI+zkDo/3hlWrQ5kCBOJOs4L/j6M9/V+XKEDkl1qFJa6bzklHQ+FEe1bwISkZ0MML2txc8d3rGPQqwq40KaxVLeGEBXFwka761xIiUbuiBWWZ5nOPSDpA/oPlzQEpHdhB3H6VPPvfgm/wcL/2PsSyrNHFih0C8+6igv/DJ/KUgYUusQC5kVeBVikfWKxqCGlQ2dVhbr3Zo7jxkwjaDR/VkyzWJuE4bRg2CivPv1/C0AGAVBTpbjoFJTokEiC5XO4vvKpmiW4nx4YvIyj6D3m416MeRDddWs4TDhVNOrOiDP9UnGc/Fu8ib5XYYU8uMobM13he2zBeInDRBgGMhvzSJ2RYVEBY/vfJCW9xI/RBfw9K+5mabZE5CmEpLHXMXQWv5Kfye0Q5VkhbRnQEzOrwgb1HexbJwK6SNwv3536qDPi8heSUut3h94fGwt0LwFHJL1wOB7jgPfuxnFyKGvFK3Vpxn++Rk+MQBkA+J/k5LHnqwkA9l6LxR6FkKnxJfXjHKEUzGOA/Ir2sSYhnCA9aEStABDgQMIhCZuV0ymoV7Z5zXUxHU50TlTQncRCAwOz+DK/ISOzycqwdcu4vZLC0yMAYYSJ3pQAnBpjMBwG9QuV3BHFfkieKIXr5GsU9YIY8J6T2VbLM/2dejaGsw6uPiNemLr9BbNplvOrCuz0t5WNUEYau5wsgYvdAqMjpVJ6ECILbJNcRATxZcY9bImordirEhSFIE8GAY8kJFdrXRVd4mPUFAGpSiseoWWwAEeCAZeQKKm+Co/DHkusqk+5hFDzVN6h8DgV5MItgCOv4H9rdelRIL/G101MKlCbGtyWP4e6Hkj2uOU8Ir4bN3a0CB0zesjq5yLM+JcBzIUI9YvA9EFUNE/QYci+UB6fvDRGJ1OjXlcwoEYTi4zt4EW/E4hOS52QxfcOD9JGJfBAoPodHPBGXsiy9kJwwhNVUl4WGTkKxMjj2YPtvHXHb4HHvIVnp0V6Z0xSy/xrynlG3lSdrGE5HTMjHWcxaKJl4N5FZRzAW3Cncl6jGiODXJSSvwo9Uhe+QU/8M8xGWOJiJ83nqgZKntAAiwDGavMUfmSAojs+Tkw2IjvOSStmAOwr1lgZSdOH0iAS+3eXa+SzSpIm2sJJ/F5U+mvsA1qGGazxjMhs7JpJeWnYhYZHBKVtD2EBxV2QA4SqKNREMztO8gk02cK++5ESLDo6g3W3IPcgODrJOKRQhAZT72CBRKsf/JF6pu3u83wZeLBCZ8GESX1jHzPtIyG17mUWVIYbAAapiRRqryhsht/9BybXfpFTHwqGr17LYc2mJ65N4zO5W3Ad6DeLVEPoyIqngCKyki90D3s/3QnruOlY6n4vgHYfw7lQZ0v0h0rmVNlrMMnOaCcr8r8gp4FZMiHxGlmZxHNSf2FixNA0vGHQHuSuk9kAx6xkROEBP8fPCqs91p+TaA5R+OoZ1Bkz6YjPqG7yb5AMRp7EueElawBFoBxG7R2+DIk8hARSDYnpXhMggLiiMdNieVNoTfRDrKPUoGwTlHRa410tcw7jCj+L3LEhYIFFcA1Yp+IlQwwDZno2org4a9JjVVHcWyWe84K0OewdxAwjCSUwfQYaMvSDVJ9BRMOe2YvkYFVQQkLaQghU3Bkh+GCHwMWkGULYI5Vd1Krh05T6BPwgloIKcfbKRpZGJ3MezIwGIAAfkyUWGOxRm274+vg87N+KW+vEWXiqYDiCpZtl4PJU2TbrRh2Te+YWV8KsSf8eiMI6yR+hvmLOn+vgNLIuokBPG4a2vkmMpe8EkQErpIBcabvgqH7sRttoxvI3eykqgW6RpS74vrCnzWNfw6sw83dT2XEAXSAZucwYB0oi8517AwYniGGMpvJONMRee58VvoKmblgLIjw03/CzylkqJkIbpAZ8PWfWn5Bz3dY2H768m836S813+voHFgCzRNBZ7P1J8Dwo7cmCQdXpUhEYFiLxvkoF8pb2KxKuuZDak5CEPyn4jFpNuNvA8AOVOlklVFUVgeTFZVKE7lT7kkmjPdNM0Uw1P/C2K793CovWJMbXzFFbkRxoDiGHlFdlkVyu+04QVLdPbLhRAJA41VHzvP8nsmSXfd/n7uxkBxzoGh0wigDHlH+T4TpJACAfCufdNTQDkewYbhhVEVbMXdvSwzthAxtwEDwNu0t/jlnUI+XtZBgCChUfm3+jBYlffhLUbpn3E+bUPDBAuwtDLUIOwwqiOKYMTrXfIHdOflX0Z3Uv+KtPLqJeLaIdQ7pkpB8e1JM+pP57F6aRGDiAff6pEDFbuIFjJ9zPUmDEK0QVhLJdF1DGIuu0puY6DRF8w9CxY1tzyzj9LMTiqFDttT/7OPgl/j5YM4nZBAHKkwYaMUVy/P+KOuVezvX7IrQTm5ykFB3JwhkiuI6I5TWVWD2SdsElcAPlKoZRCTu8Wcaf0YZ3EjWBtMeUXcbMCfplSgIwm9/PrMX/eDKoAx0hIsHrVL0DaGXo4tjCZA2lYTJ0iO2NxA/k7gUpG7SULR9pomUKHe4RCKhodAcH8fLMfgJhKW5WVj4HP47SYOgTPlcX8TDf0nNaSybYhZZPo15LFDibtn1G6Cc7p7l4BYuqAm3mSayiwtn+M22qXgO32Q27v9w2ZD28JkyASPuFyDcr4o5QNGuMVII0NPVAmShwWc2fIogSWG3oG5PEKF2U3TTvIPZJrcAKGVckfvil4wBFR/hx/omrlxpCe1yWXyw3zApCGBl9QtorHSW0CttsPNWFRshRtSQk4Nkt2D7gCRhl+3ibekc5kXRhZmjhvZhB/dmfdDmVSn6IABaoVdAuX1JUCxNRZIbKEmYYxD7zs+aachaiy4WbyrE0JQFArYI3LtV8aHsc/smRxMT/XbaFCAQlE617I33/cYBtg+h2qAoipwZNlz22PeeC3Kya2CdrJrOrvJNOzLn+HkWOEoWegIj5Cm5B4tcTnb+ezgeAUKl15JQiNVA3YVkMPkh3auTLmgV+p0B1M0EaJvJwGZxqMCX93uYaci5YGnoGwm2NJ7zgI0ES+j4kEv86cau4KEFNRrbJS+nGXL50XsN1+aL2LjFxPopskid6TiDkmcoUwmU+QiHB+CZmNiAP72sC9zpcBxFSDZWfFfRyjorqW5PFQHQw+x21nbZ4CgEyWtL+fAfET/ijT1rxlrMzr0hkygKww1NijJdfwjPdjXBnXSq6bCrt360dUONkvBQBxK490HCuzOoRaWXNCajfyih7UvEdHIWYd4QaQJYYaerzielxHIz8puYZ+MBXq7xZz1ToF4IARwy2o8ljNe8M/9ruQ23+9AVWhlxtAZhlqJLzVMofcWIOWB68E8I+XXO9hUMRyWyHbpgAgALebw1Q3mPVhCt+K+Y1iIfQtARUCZLbBhp4ruQYdJOp0zFGKwRlo8FmzJAtH0gmrvJs1UycKArrHXyN6h7Gav+/kBpBpBhE+VHEdZfY/iKjDYLIcoxCvfmroWdjeP3G51jUFAHEz1MD6phNaMo+iy4dB1uAqjd8fXBIg1dXVEHtMRbRCXFFVEzybwo9NwoCrqjmi/E8bgwru2gDGi6SQm+jbnPRM1B9H+A7bJIuUF2rutoOA3jHYUNWBlZB1Tw25o3Denso+fpPBZ77t8nccAdA+BQBZK9lBdKrjR13IWschXSkDyOsGG3mkB1ELpjkkrpgOA4eptY+HHfFKMnvIjdt5JOdQOsgt5QFhODoFuKOuLKkTFVKv+MULqYpXXFO5Iahs8iLJ/Q/wTyB68wlyai7pEoq0IU5HZbaGTH2bwUGBs2qy5FmIPdqYYHA0JncLFnRTnQjayojfpYHGb3e6AkToIdtzuRwiJocb7HTE9PdXfA/hAghcw7kS1wcUR+ayWOfVzIdKJiajUp8j9yBFlMy5ipIdzVshaR+MD99qTPSofUA6Ds3NMhEL9JjhxkIPuNXjd3GGdz70+S1SH+KJrRRV8y4ix/fiFRzY2UzX5JKFX2+n5Ie61yp0Ex0H3FERvkd9zeftJu67nQ/yKZktA0S8gt7j8zcwuSFZpiP/uxEP1FIWWWaS/4qF1xkWrXZtvhTNWeJxEix0QYtB7+D5NCeCdiKSQyec6W9CkvqBmw6Sp9tJ3yNZTH/gTz8gWUZmS3aO8rGb+aE7KPs0RwMgUHwHktqyaYLO0/x9jUrEAqFc/YoQGv+HGCfT/SGBA+Hbz5YBQHQrQ46g0rn6Jgk60lDNe8xUAkRsMVA2fxvSS1zLekOHiAYWOg0Say4P6f43UHnQR5q/Rz2CkSG3EcGQTTTvMVWpgxToIl9SeIUW1jNYwjyLHfnTv6fwcuHnUvyVWqIiZFzC2qhTtglGFzhNF4bQvh6kf5LxIrE5tPciYuXpkpA7HEcL48gsk6c95U+bmsEiXZiFIkZQ+RAWtH9o3gMpx3Cmmi5yDbPuqwbu81rxH6QAEWh6rdSPDBOsP4jARDQxSkH2DCCr4j2OYx0jf15h2LFPzxuYMGmj/zVwj87cb6bSjxFHBwetiTpdewS1SkUsFrOwpcLD2iDCgYAJFx52BJ2hggXCsBHrv51XIew+KB6AMBFkAiKs5JAI24cgS5yDsa7MAILdGBEKJiItPmWFulrjHshtH0dmgk1rxIbQ0TdAGCSDST/OPkuEg0lfKtN3h053vcH7IQ33bp+LDXxiMNlfabAdVwiAPBAIIAySx0jfhJYFQt7z5WX8/tg9lhmWKFbyAoxFB06+UsGGjVhSQJoEzitpbPD5SItoJQCyNTBAGCQzKbwzBdNAiD4+3q4Ruxx+YWWFLmd9FGL1FhbrIEIdTvpFI9zoMgGOh0pd8AuQFiw7HlSGkwKyN2J81lp87HLILSZzUd9x0nwBDteUB1+lMMWNkMqI/I2NZTYh1rFCaMHhECJeh2XkXS6QXfRdK1aAZC5Pli1lMhk2sOy7yOJiN0KezzMpfwcYB6bKvuBLxCoSt+C5hD27aYYnAeLR+rNYaWlPgskdxRg6pbDtKBrSixd9cztIwU6CKihwzi3M6ODP4Q604HCnbbyAbEpZu7HwneHli1rl+AVIYG1Axb0pGRv4tzMOfpME0RP1dtNy9sl61qPXhA6QAsUdps97MzLgSKbqS+XnJdchRD2gQs3OhLdzDc9Vz+dRmjzQBZGzSIpZntJBxkqICuHX2/keiJBSAONNUg8qXcAis6+8FtMnHqEQAoIEx6RscB/jdr9i57kWQdRG8OnUhLVrEqsCvs+nCeNIMIhcPyHneKz3Ez6gVeScefFzK1IZI6SsoiDGfQlpz2hyCocEKpge5pl5+S0XpxJVJ2wQsdKdy+CosnM6FLqSF8m4xv5dcvxXWpUzozhUchxvuwgyey3mQXuZ9Qwoas/bORyJXoKxR2LZFxE9EzoGghlRhHCy7s0COwoLKZfL+fk6qpzj/OtzKJqK59MZDODZds7GRvV44l5K4ZRIgmkeZ637PqBJ5iiMAyCF1I0c8yBkVvgdTFTgW8oi1GRewT6xczNx1IslCugG3QNKMtt48UMK74ukcTJBkgFSSMgvQEgzCozlq6EjjRIRo/mSl2hsPh0XAZOoIwyzMky0c3h7nUPqioyWkkMdeEeBNIGMPoS278+gqeXP7TzWiKiez4veh2To2MDQAWLJUlbJAsSSJQsQS5YsQCxZsgCxZMkCxJKlhNC/BBgArvzp6hOMDJoAAAAASUVORK5CYII="

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/user-profile-bg.977c2e8c.jpg";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/co.e7064ce5.jpg";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/so2.069721b2.jpg";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(258);
module.exports = __webpack_require__(257);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e1e4cba3.js